// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"i4Eus":[function(require,module,exports) {
require("3146b8f41ba359d3").register(require("839d73ee6a6a935a").getBundleURL("5TG9K"), JSON.parse('["5TG9K","App.js","b5bbt","cadastro_fisico.fc612a8e.js","eVZew","minha_conta.baf1e7ab.js","cXwOr","cadastro_juridico.2cfc87d1.js","l7T2x","lote.1d5170bc.js","1RNcA","lote.e03d780f.js","j5lEo","lote.e3f485a7.js","eIzfm","leilao.7337ac6d.js","80HCa","compra_parcelada.ffbcc86e.js"]'));

},{"3146b8f41ba359d3":"fr4hE","839d73ee6a6a935a":"hckkS"}],"fr4hE":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"hckkS":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"cXALw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotifyAlert", ()=>NotifyAlert);
var _vue = require("vue");
var _quasar = require("quasar");
var _ptBR = require("quasar/lang/pt-BR");
var _ptBRDefault = parcelHelpers.interopDefault(_ptBR);
var _autoAnimateVuePluginJs = require("./vendor/autoAnimateVuePlugin.js");
var _vue1 = require("@sentry/vue");
const page = async ()=>{
    const attr = document.body.getAttribute("js-page");
    const pages = {
        cadastro_fisico: ()=>require("17e712543bea3761"),
        minha_conta: ()=>require("b5ec18d591a476b9"),
        habilitar_se: ()=>require("b5ec18d591a476b9"),
        cadastro_juridico: ()=>require("d3a9e7b637df371b"),
        lote: ()=>require("ca5e4b6b4ec0cf0f"),
        leilao: ()=>require("2003e455d9902e10"),
        compra_parcelada: ()=>require("3bab3f0619f88cdf")
    };
    return pages[attr] ? await pages[attr]() : null;
};
console.log("App.js carregado - js-page:", document.body.getAttribute("js-page"));
(async ()=>{
    const attr = document.body.getAttribute("js-page");
    if (!attr) return;
    const resolvedPage = await page();
    if (resolvedPage) {
        const app = (0, _vue.createApp)(resolvedPage.default);
        if (window.GLITCHTIP_CONFIG?.dsn && !app.__glitchTipVueAttached) {
            (0, _vue1.attachErrorHandler)(app, {
                attachProps: false
            });
            app.__glitchTipVueAttached = true;
        }
        app.use((0, _quasar.Quasar), {
            plugins: {
                Notify: (0, _quasar.Notify)
            },
            lang: (0, _ptBRDefault.default),
            components: {
                QDialog: (0, _quasar.QDialog),
                QCard: (0, _quasar.QCard),
                QBtn: (0, _quasar.QBtn),
                QBtnGroup: (0, _quasar.QBtnGroup),
                QSpinnerDots: (0, _quasar.QSpinnerDots),
                QForm: (0, _quasar.QForm),
                QInput: (0, _quasar.QInput),
                QMenu: (0, _quasar.QMenu),
                QList: (0, _quasar.QList),
                QItem: (0, _quasar.QItem),
                QVirtualScroll: (0, _quasar.QVirtualScroll),
                QIcon: (0, _quasar.QIcon),
                QSeparator: (0, _quasar.QSeparator)
            },
            directives: {
                ClosePopup: (0, _quasar.ClosePopup)
            },
            config: {
                notify: {}
            }
        });
        app.use((0, _autoAnimateVuePluginJs.autoAnimatePlugin));
        app.mount("#app");
        (0, _quasar.Notify).registerType("alert", {
            progress: true,
            classes: "notify-alert",
            timeout: 3000,
            position: "top"
        });
    }
})();
const NotifyAlert = (text, opts)=>{
    (0, _quasar.Notify).create({
        type: "alert",
        message: text,
        ...opts
    });
};

},{"vue":"fypEC","quasar":"jiQes","quasar/lang/pt-BR":"jVJP6","./vendor/autoAnimateVuePlugin.js":"75Ynz","@sentry/vue":"2cQfL","17e712543bea3761":"bbXYh","b5ec18d591a476b9":"jYDaW","d3a9e7b637df371b":"atGDB","ca5e4b6b4ec0cf0f":"cuo2U","2003e455d9902e10":"7lE8D","3bab3f0619f88cdf":"bhStf","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fypEC":[function(require,module,exports) {
/**
* vue v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compile", ()=>compileToFunction);
var _runtimeDom = require("@vue/runtime-dom");
parcelHelpers.exportAll(_runtimeDom, exports);
var _compilerDom = require("@vue/compiler-dom");
var _shared = require("@vue/shared");
function initDev() {
    (0, _runtimeDom.initCustomFormatter)();
}
const compileCache = /* @__PURE__ */ Object.create(null);
function compileToFunction(template, options) {
    if (!(0, _shared.isString)(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return 0, _shared.NOOP;
    }
    const key = (0, _shared.genCacheKey)(template, options);
    const cached = compileCache[key];
    if (cached) return cached;
    if (template[0] === "#") {
        const el = document.querySelector(template);
        template = el ? el.innerHTML : ``;
    }
    const opts = (0, _shared.extend)({
        hoistStatic: true,
        onError: void 0,
        onWarn: (0, _shared.NOOP)
    }, options);
    if (!opts.isCustomElement && typeof customElements !== "undefined") opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code } = (0, _compilerDom.compile)(template, opts);
    function onError(err, asWarning = false) {
        const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc && (0, _shared.generateCodeFrame)(template, err.loc.start.offset, err.loc.end.offset);
        (0, _runtimeDom.warn)(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render = new Function("Vue", code)(_runtimeDom);
    render._rc = true;
    return compileCache[key] = render;
}
(0, _runtimeDom.registerRuntimeCompiler)(compileToFunction);

},{"@vue/runtime-dom":"cEl5N","@vue/compiler-dom":"ePJTz","@vue/shared":"jjpTC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"cEl5N":[function(require,module,exports) {
/**
* @vue/runtime-dom v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "TransitionGroup", ()=>TransitionGroup);
parcelHelpers.export(exports, "VueElement", ()=>VueElement);
parcelHelpers.export(exports, "createApp", ()=>createApp);
parcelHelpers.export(exports, "createSSRApp", ()=>createSSRApp);
parcelHelpers.export(exports, "defineCustomElement", ()=>defineCustomElement);
parcelHelpers.export(exports, "defineSSRCustomElement", ()=>defineSSRCustomElement);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "initDirectivesForSSR", ()=>initDirectivesForSSR);
parcelHelpers.export(exports, "nodeOps", ()=>nodeOps);
parcelHelpers.export(exports, "patchProp", ()=>patchProp);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "useCssModule", ()=>useCssModule);
parcelHelpers.export(exports, "useCssVars", ()=>useCssVars);
parcelHelpers.export(exports, "useHost", ()=>useHost);
parcelHelpers.export(exports, "useShadowRoot", ()=>useShadowRoot);
parcelHelpers.export(exports, "vModelCheckbox", ()=>vModelCheckbox);
parcelHelpers.export(exports, "vModelDynamic", ()=>vModelDynamic);
parcelHelpers.export(exports, "vModelRadio", ()=>vModelRadio);
parcelHelpers.export(exports, "vModelSelect", ()=>vModelSelect);
parcelHelpers.export(exports, "vModelText", ()=>vModelText);
parcelHelpers.export(exports, "vShow", ()=>vShow);
parcelHelpers.export(exports, "withKeys", ()=>withKeys);
parcelHelpers.export(exports, "withModifiers", ()=>withModifiers);
var _runtimeCore = require("@vue/runtime-core");
parcelHelpers.exportAll(_runtimeCore, exports);
var _shared = require("@vue/shared");
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const unsafeToTrustedHTML = policy ? (val)=>policy.createHTML(val) : (val)=>val;
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, {
            is
        }) : doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>doc.createTextNode(text),
    createComment: (text)=>doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            templateContainer.innerHTML = unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const TRANSITION = "transition";
const ANIMATION = "animation";
const vtcKey = /* @__PURE__ */ Symbol("_vtc");
const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const TransitionPropsValidators = /* @__PURE__ */ (0, _shared.extend)({}, (0, _runtimeCore.BaseTransitionPropsValidators), DOMTransitionPropsValidators);
const decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = TransitionPropsValidators;
    return t;
};
const Transition = /* @__PURE__ */ decorate$1((props, { slots })=>(0, _runtimeCore.h)((0, _runtimeCore.BaseTransition), resolveTransitionProps(props), slots));
const callHook = (hook, args = [])=>{
    if ((0, _shared.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const hasExplicitCallback = (hook)=>{
    return hook ? (0, _shared.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name = "v", type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        removeTransitionClass(el, leaveFromClass);
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            callHook(hook, [
                el,
                resolve
            ]);
            nextFrame(()=>{
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, _shared.extend)(baseProps, {
        onBeforeEnter (el) {
            callHook(onBeforeEnter, [
                el
            ]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            callHook(onBeforeAppear, [
                el
            ]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                forceReflow(el);
                addTransitionClass(el, leaveActiveClass);
            } else {
                addTransitionClass(el, leaveActiveClass);
                forceReflow(el);
            }
            nextFrame(()=>{
                if (!el._isLeaving) return;
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, _shared.isObject)(duration)) return [
        NumberOf(duration.enter),
        NumberOf(duration.leave)
    ];
    else {
        const n = NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function NumberOf(val) {
    const res = (0, _shared.toNumber)(val);
    return res;
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[vtcKey] = void 0;
    }
}
function nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${TRANSITION}Property`).toString());
    return {
        type,
        timeout,
        propCount,
        hasTransform
    };
}
function getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>toMs(d) + toMs(delays[i])));
}
function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const vShow = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value }, { transition }) {
        el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else setDisplay(el, value);
    },
    mounted (el, { value }, { transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value, oldValue }, { transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                setDisplay(el, false);
            });
        } else setDisplay(el, value);
    },
    beforeUnmount (el, { value }) {
        setDisplay(el, value);
    }
};
function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
}
function initVShowForSSR() {
    vShow.getSSRProps = ({ value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function useCssVars(getter) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) setVarsOnNode(instance.ce, vars);
        else setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, _runtimeCore.onBeforeUpdate)(()=>{
        (0, _runtimeCore.queuePostFlushCb)(setVars);
    });
    (0, _runtimeCore.onMounted)(()=>{
        (0, _runtimeCore.watch)(setVars, (0, _shared.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, _runtimeCore.onUnmounted)(()=>ob.disconnect());
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, _runtimeCore.Fragment)) vnode.children.forEach((c)=>setVarsOnVNode(c, vars));
    else if (vnode.type === (0, _runtimeCore.Static)) {
        let { el, anchor } = vnode;
        while(el){
            setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, _shared.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[CSS_VAR_TEXT] = cssText;
    }
}
const displayRE = /(?:^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, _shared.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, _shared.isString)(prev)) {
                for(const key in prev)if (next[key] == null) setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!shouldPreserveTextareaResizeStyle(el, key, !(0, _shared.isString)(prev) && prev ? prev[key] : void 0, value)) setStyle(style, key, value);
            } else setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if (vShowOriginalDisplay in el) {
        el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[vShowHidden]) style.display = "none";
    }
}
const semicolonRE = /[^\\];\s*$/;
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if ((0, _shared.isArray)(val)) val.forEach((v)=>setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) style.setProperty((0, _shared.hyphenate)(prefixed), val.replace(importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const prefixCache = {};
function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) return cached;
    let name = (0, _runtimeCore.camelize)(rawName);
    if (name !== "filter" && name in style) return prefixCache[rawName] = name;
    name = (0, _shared.capitalize)(name);
    for(let i = 0; i < prefixes.length; i++){
        const prefixed = prefixes[i] + name;
        if (prefixed in style) return prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, _shared.isString)(next) && prev === next;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = (0, _shared.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS(xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, _shared.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, _shared.isSymbol)(value) ? String(value) : value);
}
function patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, _shared.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const veiKey = /* @__PURE__ */ Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = createInvoker(nextValue, instance);
            addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match(optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, _shared.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = ()=>cachedNow || (p.then(()=>cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, _runtimeCore.callWithAsyncErrorHandling)(patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function sanitizeEventValue(value, propName) {
    if ((0, _shared.isFunction)(value) || (0, _shared.isArray)(value)) return value;
    (0, _runtimeCore.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, _shared.NOOP;
}
function patchStopImmediatePropagation(e, value) {
    if ((0, _shared.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") patchClass(el, nextValue, isSVG);
    else if (key === "style") patchStyle(el, prevValue, nextValue);
    else if ((0, _shared.isOn)(key)) {
        if (!(0, _shared.isModelListener)(key)) patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    (shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, _shared.isString)(nextValue)))) patchDOMProp(el, (0, _shared.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && isNativeOn(key) && (0, _shared.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if (isNativeOn(key) && (0, _shared.isString)(value)) return false;
    return key in el;
}
function shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, _shared.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, _shared.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, _shared.camelize)(prop) === camelKey);
}
const REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function defineCustomElement(options, extraOptions, _createApp) {
    let Comp = (0, _runtimeCore.defineComponent)(options, extraOptions);
    if ((0, _shared.isPlainObject)(Comp)) Comp = (0, _shared.extend)({}, Comp, extraOptions);
    class VueCustomElement extends VueElement {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ defineCustomElement(options, extraOptions, createSSRApp);
};
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
    constructor(_def, _props = {}, _createApp = createApp){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== createApp) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, _shared.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof VueElement) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, _runtimeCore.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props, styles } = def;
            let numberProps;
            if (props && !(0, _shared.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, _shared.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, _shared.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, _shared.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, _runtimeCore.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props } = def;
        const declaredPropKeys = (0, _shared.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, _shared.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : REMOVAL;
        const camelKey = (0, _shared.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, _shared.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, _shared.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, _shared.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, _shared.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        render(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, _runtimeCore.createVNode)(this._def, (0, _shared.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, _shared.isPlainObject)(args[0]) ? (0, _shared.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, _shared.hyphenate)(event) !== event) dispatch((0, _shared.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function useHost(caller) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, _runtimeCore.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, _runtimeCore.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function useShadowRoot() {
    const el = useHost();
    return el && el.shadowRoot;
}
function useCssModule(name = "$style") {
    {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        if (!instance) return 0, _shared.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, _shared.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, _shared.EMPTY_OBJ;
        return mod;
    }
}
const positionMap = /* @__PURE__ */ new WeakMap();
const newPositionMap = /* @__PURE__ */ new WeakMap();
const moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const TransitionGroupImpl = /* @__PURE__ */ decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, _shared.extend)({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots }) {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        const state = (0, _runtimeCore.useTransitionState)();
        let prevChildren;
        let children;
        (0, _runtimeCore.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[moveCbKey] = null;
                        removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, _runtimeCore.toRaw)(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, _runtimeCore.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    positionMap.set(child, getPosition(child.el));
                }
            }
            children = slots.default ? (0, _runtimeCore.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, _runtimeCore.createVNode)(tag, null, children);
        };
    }
});
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) el[moveCbKey]();
    if (el[enterCbKey]) el[enterCbKey]();
}
function recordPosition(c) {
    newPositionMap.set(c, getPosition(c.el));
}
function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, _shared.isArray)(fn) ? (value)=>(0, _shared.invokeArrayFns)(fn, value) : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const assignKey = /* @__PURE__ */ Symbol("_assign");
function castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, _shared.looseToNumber)(value);
    return value;
}
const vModelText = {
    created (el, { modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[assignKey](castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) addEventListener(el, "change", ()=>{
            el.value = castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            addEventListener(el, "compositionstart", onCompositionStart);
            addEventListener(el, "compositionend", onCompositionEnd);
            addEventListener(el, "change", onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, _shared.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el[assignKey];
            if ((0, _shared.isArray)(modelValue)) {
                const index = (0, _shared.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, _shared.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign(getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate (el, binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, _shared.isArray)(value)) checked = (0, _shared.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, _shared.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, _shared.looseEqual)(value, getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const vModelRadio = {
    created (el, { value }, vnode) {
        el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            el[assignKey](getValue(el));
        });
    },
    beforeUpdate (el, { value, oldValue }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
    }
};
const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value, modifiers: { number } }, vnode) {
        const isSetModel = (0, _shared.isSet)(value);
        addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, _shared.looseToNumber)(getValue(o)) : getValue(o));
            el[assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, _runtimeCore.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value }) {
        setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
    },
    updated (el, { value }) {
        if (!el._assigning) setSelected(el, value);
    }
};
function setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, _shared.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, _shared.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, _shared.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, _shared.looseEqual)(getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const vModelDynamic = {
    created (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return vModelSelect;
        case "TEXTAREA":
            return vModelText;
        default:
            switch(type){
                case "checkbox":
                    return vModelCheckbox;
                case "radio":
                    return vModelRadio;
                default:
                    return vModelText;
            }
    }
}
function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function initVModelForSSR() {
    vModelText.getSSRProps = ({ value })=>({
            value
        });
    vModelRadio.getSSRProps = ({ value }, vnode)=>{
        if (vnode.props && (0, _shared.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode)=>{
        if ((0, _shared.isArray)(value)) {
            if (vnode.props && (0, _shared.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, _shared.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    vModelDynamic.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const withKeys = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, _shared.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || keyNames[k] === eventKey)) return fn(event);
    });
};
const rendererOptions = /* @__PURE__ */ (0, _shared.extend)({
    patchProp
}, nodeOps);
let renderer;
let enabledHydration = false;
function ensureRenderer() {
    return renderer || (renderer = (0, _runtimeCore.createRenderer)(rendererOptions));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : (0, _runtimeCore.createHydrationRenderer)(rendererOptions);
    enabledHydration = true;
    return renderer;
}
const render = (...args)=>{
    ensureRenderer().render(...args);
};
const hydrate = (...args)=>{
    ensureHydrationRenderer().hydrate(...args);
};
const createApp = (...args)=>{
    const app = ensureRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, _shared.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const createSSRApp = (...args)=>{
    const app = ensureHydrationRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, resolveRootNamespace(container));
    };
    return app;
};
function resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
        writable: false
    });
}
function injectCompilerOptionsCheck(app) {
    if ((0, _runtimeCore.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, _runtimeCore.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, _runtimeCore.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, _runtimeCore.warn)(msg);
            }
        });
    }
}
function normalizeContainer(container) {
    if ((0, _shared.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let ssrDirectiveInitialized = false;
const initDirectivesForSSR = ()=>{
    if (!ssrDirectiveInitialized) {
        ssrDirectiveInitialized = true;
        initVModelForSSR();
        initVShowForSSR();
    }
};

},{"@vue/runtime-core":"86KwH","@vue/shared":"jjpTC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"86KwH":[function(require,module,exports) {
/**
* @vue/runtime-core v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EffectScope", ()=>(0, _reactivity.EffectScope));
parcelHelpers.export(exports, "ReactiveEffect", ()=>(0, _reactivity.ReactiveEffect));
parcelHelpers.export(exports, "TrackOpTypes", ()=>(0, _reactivity.TrackOpTypes));
parcelHelpers.export(exports, "TriggerOpTypes", ()=>(0, _reactivity.TriggerOpTypes));
parcelHelpers.export(exports, "customRef", ()=>(0, _reactivity.customRef));
parcelHelpers.export(exports, "effect", ()=>(0, _reactivity.effect));
parcelHelpers.export(exports, "effectScope", ()=>(0, _reactivity.effectScope));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _reactivity.getCurrentScope));
parcelHelpers.export(exports, "getCurrentWatcher", ()=>(0, _reactivity.getCurrentWatcher));
parcelHelpers.export(exports, "isProxy", ()=>(0, _reactivity.isProxy));
parcelHelpers.export(exports, "isReactive", ()=>(0, _reactivity.isReactive));
parcelHelpers.export(exports, "isReadonly", ()=>(0, _reactivity.isReadonly));
parcelHelpers.export(exports, "isRef", ()=>(0, _reactivity.isRef));
parcelHelpers.export(exports, "isShallow", ()=>(0, _reactivity.isShallow));
parcelHelpers.export(exports, "markRaw", ()=>(0, _reactivity.markRaw));
parcelHelpers.export(exports, "onScopeDispose", ()=>(0, _reactivity.onScopeDispose));
parcelHelpers.export(exports, "onWatcherCleanup", ()=>(0, _reactivity.onWatcherCleanup));
parcelHelpers.export(exports, "proxyRefs", ()=>(0, _reactivity.proxyRefs));
parcelHelpers.export(exports, "reactive", ()=>(0, _reactivity.reactive));
parcelHelpers.export(exports, "readonly", ()=>(0, _reactivity.readonly));
parcelHelpers.export(exports, "ref", ()=>(0, _reactivity.ref));
parcelHelpers.export(exports, "shallowReactive", ()=>(0, _reactivity.shallowReactive));
parcelHelpers.export(exports, "shallowReadonly", ()=>(0, _reactivity.shallowReadonly));
parcelHelpers.export(exports, "shallowRef", ()=>(0, _reactivity.shallowRef));
parcelHelpers.export(exports, "stop", ()=>(0, _reactivity.stop));
parcelHelpers.export(exports, "toRaw", ()=>(0, _reactivity.toRaw));
parcelHelpers.export(exports, "toRef", ()=>(0, _reactivity.toRef));
parcelHelpers.export(exports, "toRefs", ()=>(0, _reactivity.toRefs));
parcelHelpers.export(exports, "toValue", ()=>(0, _reactivity.toValue));
parcelHelpers.export(exports, "triggerRef", ()=>(0, _reactivity.triggerRef));
parcelHelpers.export(exports, "unref", ()=>(0, _reactivity.unref));
parcelHelpers.export(exports, "camelize", ()=>(0, _shared.camelize));
parcelHelpers.export(exports, "capitalize", ()=>(0, _shared.capitalize));
parcelHelpers.export(exports, "normalizeClass", ()=>(0, _shared.normalizeClass));
parcelHelpers.export(exports, "normalizeProps", ()=>(0, _shared.normalizeProps));
parcelHelpers.export(exports, "normalizeStyle", ()=>(0, _shared.normalizeStyle));
parcelHelpers.export(exports, "toDisplayString", ()=>(0, _shared.toDisplayString));
parcelHelpers.export(exports, "toHandlerKey", ()=>(0, _shared.toHandlerKey));
parcelHelpers.export(exports, "BaseTransition", ()=>BaseTransition);
parcelHelpers.export(exports, "BaseTransitionPropsValidators", ()=>BaseTransitionPropsValidators);
parcelHelpers.export(exports, "Comment", ()=>Comment);
parcelHelpers.export(exports, "DeprecationTypes", ()=>DeprecationTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "ErrorTypeStrings", ()=>ErrorTypeStrings);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "KeepAlive", ()=>KeepAlive);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "Suspense", ()=>Suspense);
parcelHelpers.export(exports, "Teleport", ()=>Teleport);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "assertNumber", ()=>assertNumber);
parcelHelpers.export(exports, "callWithAsyncErrorHandling", ()=>callWithAsyncErrorHandling);
parcelHelpers.export(exports, "callWithErrorHandling", ()=>callWithErrorHandling);
parcelHelpers.export(exports, "cloneVNode", ()=>cloneVNode);
parcelHelpers.export(exports, "compatUtils", ()=>compatUtils);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "createBlock", ()=>createBlock);
parcelHelpers.export(exports, "createCommentVNode", ()=>createCommentVNode);
parcelHelpers.export(exports, "createElementBlock", ()=>createElementBlock);
parcelHelpers.export(exports, "createElementVNode", ()=>createBaseVNode);
parcelHelpers.export(exports, "createHydrationRenderer", ()=>createHydrationRenderer);
parcelHelpers.export(exports, "createPropsRestProxy", ()=>createPropsRestProxy);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "createSlots", ()=>createSlots);
parcelHelpers.export(exports, "createStaticVNode", ()=>createStaticVNode);
parcelHelpers.export(exports, "createTextVNode", ()=>createTextVNode);
parcelHelpers.export(exports, "createVNode", ()=>createVNode);
parcelHelpers.export(exports, "defineAsyncComponent", ()=>defineAsyncComponent);
parcelHelpers.export(exports, "defineComponent", ()=>defineComponent);
parcelHelpers.export(exports, "defineEmits", ()=>defineEmits);
parcelHelpers.export(exports, "defineExpose", ()=>defineExpose);
parcelHelpers.export(exports, "defineModel", ()=>defineModel);
parcelHelpers.export(exports, "defineOptions", ()=>defineOptions);
parcelHelpers.export(exports, "defineProps", ()=>defineProps);
parcelHelpers.export(exports, "defineSlots", ()=>defineSlots);
parcelHelpers.export(exports, "devtools", ()=>devtools);
parcelHelpers.export(exports, "getCurrentInstance", ()=>getCurrentInstance);
parcelHelpers.export(exports, "getTransitionRawChildren", ()=>getTransitionRawChildren);
parcelHelpers.export(exports, "guardReactiveProps", ()=>guardReactiveProps);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "hasInjectionContext", ()=>hasInjectionContext);
parcelHelpers.export(exports, "hydrateOnIdle", ()=>hydrateOnIdle);
parcelHelpers.export(exports, "hydrateOnInteraction", ()=>hydrateOnInteraction);
parcelHelpers.export(exports, "hydrateOnMediaQuery", ()=>hydrateOnMediaQuery);
parcelHelpers.export(exports, "hydrateOnVisible", ()=>hydrateOnVisible);
parcelHelpers.export(exports, "initCustomFormatter", ()=>initCustomFormatter);
parcelHelpers.export(exports, "inject", ()=>inject);
parcelHelpers.export(exports, "isMemoSame", ()=>isMemoSame);
parcelHelpers.export(exports, "isRuntimeOnly", ()=>isRuntimeOnly);
parcelHelpers.export(exports, "isVNode", ()=>isVNode);
parcelHelpers.export(exports, "mergeDefaults", ()=>mergeDefaults);
parcelHelpers.export(exports, "mergeModels", ()=>mergeModels);
parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "onActivated", ()=>onActivated);
parcelHelpers.export(exports, "onBeforeMount", ()=>onBeforeMount);
parcelHelpers.export(exports, "onBeforeUnmount", ()=>onBeforeUnmount);
parcelHelpers.export(exports, "onBeforeUpdate", ()=>onBeforeUpdate);
parcelHelpers.export(exports, "onDeactivated", ()=>onDeactivated);
parcelHelpers.export(exports, "onErrorCaptured", ()=>onErrorCaptured);
parcelHelpers.export(exports, "onMounted", ()=>onMounted);
parcelHelpers.export(exports, "onRenderTracked", ()=>onRenderTracked);
parcelHelpers.export(exports, "onRenderTriggered", ()=>onRenderTriggered);
parcelHelpers.export(exports, "onServerPrefetch", ()=>onServerPrefetch);
parcelHelpers.export(exports, "onUnmounted", ()=>onUnmounted);
parcelHelpers.export(exports, "onUpdated", ()=>onUpdated);
parcelHelpers.export(exports, "openBlock", ()=>openBlock);
parcelHelpers.export(exports, "popScopeId", ()=>popScopeId);
parcelHelpers.export(exports, "provide", ()=>provide);
parcelHelpers.export(exports, "pushScopeId", ()=>pushScopeId);
parcelHelpers.export(exports, "queuePostFlushCb", ()=>queuePostFlushCb);
parcelHelpers.export(exports, "registerRuntimeCompiler", ()=>registerRuntimeCompiler);
parcelHelpers.export(exports, "renderList", ()=>renderList);
parcelHelpers.export(exports, "renderSlot", ()=>renderSlot);
parcelHelpers.export(exports, "resolveComponent", ()=>resolveComponent);
parcelHelpers.export(exports, "resolveDirective", ()=>resolveDirective);
parcelHelpers.export(exports, "resolveDynamicComponent", ()=>resolveDynamicComponent);
parcelHelpers.export(exports, "resolveFilter", ()=>resolveFilter);
parcelHelpers.export(exports, "resolveTransitionHooks", ()=>resolveTransitionHooks);
parcelHelpers.export(exports, "setBlockTracking", ()=>setBlockTracking);
parcelHelpers.export(exports, "setDevtoolsHook", ()=>setDevtoolsHook);
parcelHelpers.export(exports, "setTransitionHooks", ()=>setTransitionHooks);
parcelHelpers.export(exports, "ssrContextKey", ()=>ssrContextKey);
parcelHelpers.export(exports, "ssrUtils", ()=>ssrUtils);
parcelHelpers.export(exports, "toHandlers", ()=>toHandlers);
parcelHelpers.export(exports, "transformVNodeArgs", ()=>transformVNodeArgs);
parcelHelpers.export(exports, "useAttrs", ()=>useAttrs);
parcelHelpers.export(exports, "useId", ()=>useId);
parcelHelpers.export(exports, "useModel", ()=>useModel);
parcelHelpers.export(exports, "useSSRContext", ()=>useSSRContext);
parcelHelpers.export(exports, "useSlots", ()=>useSlots);
parcelHelpers.export(exports, "useTemplateRef", ()=>useTemplateRef);
parcelHelpers.export(exports, "useTransitionState", ()=>useTransitionState);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "watch", ()=>watch);
parcelHelpers.export(exports, "watchEffect", ()=>watchEffect);
parcelHelpers.export(exports, "watchPostEffect", ()=>watchPostEffect);
parcelHelpers.export(exports, "watchSyncEffect", ()=>watchSyncEffect);
parcelHelpers.export(exports, "withAsyncContext", ()=>withAsyncContext);
parcelHelpers.export(exports, "withCtx", ()=>withCtx);
parcelHelpers.export(exports, "withDefaults", ()=>withDefaults);
parcelHelpers.export(exports, "withDirectives", ()=>withDirectives);
parcelHelpers.export(exports, "withMemo", ()=>withMemo);
parcelHelpers.export(exports, "withScopeId", ()=>withScopeId);
var _reactivity = require("@vue/reactivity");
var _shared = require("@vue/shared");
const stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
let isWarning = false;
function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    (0, _reactivity.pauseTracking)();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) callWithErrorHandling(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode })=>`at <${formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, _reactivity.resetTracking)();
    isWarning = false;
}
function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...formatTraceEntry(entry));
    });
    return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function formatProp(key, value, raw) {
    if ((0, _shared.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, _reactivity.isRef)(value)) {
        value = formatProp(key, (0, _reactivity.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, _shared.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, _reactivity.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function assertNumber(val, type) {
    return;
}
const ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function callWithErrorHandling(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        handleError(err, instance, type);
    }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if ((0, _shared.isFunction)(fn)) {
        const res = callWithErrorHandling(fn, instance, type, args);
        if (res && (0, _shared.isPromise)(res)) res.catch((err)=>{
            handleError(err, instance, type);
        });
        return res;
    }
    if ((0, _shared.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
        return values;
    }
}
function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, _shared.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, _reactivity.pauseTracking)();
            callWithErrorHandling(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, _reactivity.resetTracking)();
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
    const p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = queue[middle];
        const middleJobId = getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = getId(job);
        const lastJob = queue[queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= getId(lastJob)) queue.push(job);
        else queue.splice(findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        queueFlush();
    }
}
function queueFlush() {
    if (!currentFlushPromise) currentFlushPromise = resolvedPromise.then(flushJobs);
}
function queuePostFlushCb(cb) {
    if (!(0, _shared.isArray)(cb)) {
        if (activePostFlushCbs && cb.id === -1) activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else pendingPostFlushCbs.push(...cb);
    queueFlush();
}
function flushPreFlushCbs(instance, seen, i = flushIndex + 1) {
    for(; i < queue.length; i++){
        const cb = queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set(pendingPostFlushCbs)
        ].sort((a, b)=>getId(a) - getId(b));
        pendingPostFlushCbs.length = 0;
        if (activePostFlushCbs) {
            activePostFlushCbs.push(...deduped);
            return;
        }
        activePostFlushCbs = deduped;
        for(postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++){
            const cb = activePostFlushCbs[postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
const getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
    const check = (0, _shared.NOOP);
    try {
        for(flushIndex = 0; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                callWithErrorHandling(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job) job.flags &= -2;
        }
        flushIndex = -1;
        queue.length = 0;
        flushPostFlushCbs(seen);
        currentFlushPromise = null;
        if (queue.length || pendingPostFlushCbs.length) flushJobs(seen);
    }
}
function checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && getComponentName(instance.type);
        handleError(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let isHmrUpdating = false;
const setHmrUpdating = (v1)=>{
    try {
        return isHmrUpdating;
    } finally{
        isHmrUpdating = v1;
    }
};
const hmrDirtyComponents = /* @__PURE__ */ new Map();
const map = /* @__PURE__ */ new Map();
function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) return false;
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = normalizeClassComponent(instance.type);
        let dirtyInstances = hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) updateComponentDef(oldComp, newComp);
            hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                isHmrUpdating = true;
                instance.parent.update();
                isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    queuePostFlushCb(()=>{
        hmrDirtyComponents.clear();
    });
}
function updateComponentDef(oldComp, newComp) {
    (0, _shared.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let devtools$1;
let buffer = [];
let devtoolsNotInstalled = false;
function emit$1(event, ...args) {
    if (devtools$1) devtools$1.emit(event, ...args);
    else if (!devtoolsNotInstalled) buffer.push({
        event,
        args
    });
}
function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
        devtools$1.enabled = true;
        buffer.forEach(({ event, args })=>devtools$1.emit(event, ...args));
        buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3e3);
    } else {
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment,
        Text,
        Comment,
        Static
    });
}
function devtoolsUnmountApp(app) {
    emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const devtoolsComponentRemoved = (component)=>{
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !devtools$1.cleanupBuffer(component)) _devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
    return (component)=>{
        emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function pushScopeId(id) {
    currentScopeId = id;
}
function popScopeId() {
    currentScopeId = null;
}
const withScopeId = (_id)=>withCtx;
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) setBlockTracking(-1);
        const prevInstance = setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) setBlockTracking(1);
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function validateDirectiveName(name) {
    if ((0, _shared.isBuiltInDirective)(name)) warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) return vnode;
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, _shared.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, _shared.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, _reactivity.traverse)(value);
            bindings.push({
                dir,
                instance,
                value,
                oldValue: void 0,
                arg,
                modifiers
            });
        }
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, _reactivity.pauseTracking)();
            callWithAsyncErrorHandling(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, _reactivity.resetTracking)();
        }
    }
}
function provide(key, value) {
    if (currentInstance) {
        let provides = currentInstance.provides;
        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) provides = currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = getCurrentInstance();
    if (instance || currentApp) {
        let provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, _shared.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function hasInjectionContext() {
    return !!(getCurrentInstance() || currentApp);
}
const ssrContextKey = /* @__PURE__ */ Symbol.for("v-scx");
const useSSRContext = ()=>{
    {
        const ctx = inject(ssrContextKey);
        ctx;
        return ctx;
    }
};
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "post"
    });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "sync"
    });
}
function watch(source, cb, options) {
    return doWatch(source, cb, options);
}
function doWatch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, flush, once } = options;
    const baseWatchOptions = (0, _shared.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if (isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = useSSRContext();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, _shared.NOOP);
            watchStopHandle.resume = (0, _shared.NOOP);
            watchStopHandle.pause = (0, _shared.NOOP);
            return watchStopHandle;
        }
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args)=>callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, _reactivity.watch)(source, cb, baseWatchOptions);
    if (isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, _shared.isString)(source) ? source.includes(".") ? createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, _shared.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const pendingMounts = /* @__PURE__ */ new WeakMap();
const TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const isTeleport = (type)=>type.__isTeleport;
const isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, _shared.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment, parentNode } } = internals;
        const disabled = isTeleportDisabled(n2.props);
        let { dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = isTeleportDisabled(vnode.props);
            const target = vnode.target = resolveTarget(vnode.props, querySelector);
            const targetAnchor = prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if (pendingMounts.get(vnode) !== mountJob) return;
                pendingMounts.delete(vnode);
                if (isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            pendingMounts.set(vnode, mountJob);
            queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if (isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
                    if (nextTarget) moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag, children, anchor, targetStart, targetAnchor, target, props } = vnode;
        let shouldRemove = doRemove || !isTeleportDisabled(props);
        const pendingMount = pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            pendingMounts.delete(vnode);
            shouldRemove = false;
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!pendingMounts.has(vnode) && (!isReorder || isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector, insert, createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = resolveTarget(vnode.props, querySelector);
    const disabled = isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function useTransitionState() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(()=>{
        state.isMounted = true;
    });
    onBeforeUnmount(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const TransitionHookValidator = [
    Function,
    Array
];
const BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
};
const recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
};
const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        return ()=>{
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            const child = children && children.length ? findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? createCommentVNode() : void 0;
            if (!child) return;
            const rawProps = (0, _reactivity.toRaw)(props);
            const { mode } = rawProps;
            if (state.isLeaving) return emptyPlaceholder(child);
            const innerChild = getInnerChild$1(child);
            if (!innerChild) return emptyPlaceholder(child);
            let enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== Comment) setTransitionHooks(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(oldInnerChild, innerChild) && recursiveGetSubtree(instance).type !== Comment) {
                let leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                setTransitionHooks(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== Comment) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== Comment) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[leaveCbKey] = ()=>{
                        earlyRemove();
                        el[leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== Comment) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, _shared.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode,
        persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[leaveCbKey]) el[leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) leavingVNode.el[leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[enterCbKey] = void 0;
            };
            const done = el[enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[enterCbKey]) el[enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = resolveTransitionHooks(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
        if (isTeleport(vnode.type) && vnode.children) return findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag, children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, _shared.isFunction)(children.default)) return children.default();
    }
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        setTransitionHooks(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === Fragment) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
        } else if (keepComment || child.type !== Comment) ret.push(key != null ? cloneVNode(child, {
            key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
    return (0, _shared.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, _shared.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function useId() {
    const i = getCurrentInstance();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function useTemplateRef(key) {
    const i = getCurrentInstance();
    const r = (0, _reactivity.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, _shared.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, _shared.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>setRef(r, oldRawRef && ((0, _shared.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, _shared.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, _reactivity.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, _shared.EMPTY_OBJ) ? (0, _shared.NO) : (key)=>{
        if (isTemplateRefKey(refs, key)) return false;
        return (0, _shared.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        invalidatePendingSetRef(oldRawRef);
        if ((0, _shared.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, _reactivity.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, _shared.isFunction)(ref)) callWithErrorHandling(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, _shared.isString)(ref);
        const _isRef = (0, _reactivity.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, _shared.isArray)(existing) && (0, _shared.remove)(existing, refValue);
                    else {
                        if (!(0, _shared.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                pendingSetRefMap.set(rawRef, job);
                queuePostRenderEffect(job, parentSuspense);
            } else {
                invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function invalidatePendingSetRef(rawRef) {
    const pendingSetRef = pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        pendingSetRefMap.delete(rawRef);
    }
}
let hasLoggedMismatchError = false;
const logMismatchError = ()=>{
    if (hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    hasLoggedMismatchError = true;
};
const isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if (isSVGContainer(container)) return "svg";
    if (isMathMLContainer(container)) return "mathml";
    return void 0;
};
const isComment = (node)=>node.nodeType === 8;
function createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp, createText, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type, ref, shapeFlag, patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(node, "__vnode", vnode, true);
            (0, _shared.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case Text:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case Static:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case Fragment:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if (isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, getContainerType(container), optimized);
                    if (isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type, props, patchFlag, shapeFlag, dirs, transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, _shared.isOn)(key) && !(0, _shared.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, _shared.isReservedProp)(key)) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, _reactivity.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) queueEffectWithSuspense(()=>{
                vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
            const isText = vnode.type === Text;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && normalizeVNode(children[i + 1]).type === Text) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, _shared.normalizeClass)(clientValue);
        if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, _shared.isString)(clientValue) ? clientValue : (0, _shared.stringifyStyle)((0, _shared.normalizeStyle)(clientValue));
        const actualMap = toStyleMap(actual);
        const expectedMap = toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir, value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) resolveCssVars(instance, vnode, expectedMap);
        if (!isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, _shared.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, _shared.isBooleanAttr)(key) || (0, _shared.isKnownHtmlAttr)(key))) {
        if ((0, _shared.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, _shared.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, _shared.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === Fragment && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, _shared.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, _shared.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const allowMismatchAttr = "data-allow-mismatch";
const MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute(allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute(allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes(MismatchTypeString[allowedType]);
    }
}
const requestIdleCallback = (0, _shared.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const cancelIdleCallback = (0, _shared.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const hydrateOnIdle = (timeout = 1e4)=>(hydrate)=>{
        const id = requestIdleCallback(hydrate, {
            timeout
        });
        return ()=>cancelIdleCallback(id);
    };
function elementIsVisibleInViewport(el) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const hydrateOnVisible = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if (elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const hydrateOnMediaQuery = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const hydrateOnInteraction = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, _shared.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function forEachElement(node, cb) {
    if (isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if (isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function defineAsyncComponent(source) {
    if ((0, _shared.isFunction)(source)) source = {
        loader: source
    };
    const { loader, loadingComponent, errorComponent, delay = 200, hydrate: hydrateStrategy, timeout, // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return defineComponent({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = currentInstance;
            markAsyncBoundary(instance);
            if (resolvedComp) return ()=>createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                handleError(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? createVNode(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, _reactivity.ref)(false);
            const error = (0, _reactivity.ref)();
            const delayed = (0, _reactivity.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return createVNode(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function createInnerComp(comp, parent) {
    const { ref: ref2, props, children, ce } = parent.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, _shared.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            invalidateMount(instance2.m);
            invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(()=>{
                if (instance2.da) (0, _shared.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !isSameVNodeType(cached, current))) unmount(cached);
            else if (current) resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        watch(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>matches(include, name));
            exclude && pruneCache((name)=>!matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if (isSuspense(instance.subTree.type)) queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(()=>{
            cache.forEach((cached)=>{
                const { subTree, suspense } = instance;
                const vnode = getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            if (vnode.type === Comment) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include, exclude, max } = props;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) setTransitionHooks(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if ((0, _shared.isArray)(pattern)) return pattern.some((p)=>matches(p, name));
    else if ((0, _shared.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, _shared.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if (isKeepAlive(current.parent.vnode)) injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(type, hook, keepAliveRoot, true);
    onUnmounted(()=>{
        (0, _shared.remove)(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, _reactivity.pauseTracking)();
            const reset = setCurrentInstance(target);
            const res = callWithAsyncErrorHandling(hook, target, type, args);
            reset();
            (0, _reactivity.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const createHook = (lifecycle)=>(hook, target = currentInstance)=>{
        if (!isInSSRComponentSetup || lifecycle === "sp") injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
}
const COMPONENTS = "components";
const DIRECTIVES = "directives";
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
    if ((0, _shared.isString)(component)) return resolveAsset(COMPONENTS, component, false) || component;
    else return component || NULL_DYNAMIC_COMPONENT;
}
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === COMPONENTS) {
            const selfName = getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, _shared.camelize)(name) || selfName === (0, _shared.capitalize)((0, _shared.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function resolve(registry, name) {
    return registry && (registry[name] || registry[(0, _shared.camelize)(name)] || registry[(0, _shared.capitalize)((0, _shared.camelize)(name))]);
}
function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, _shared.isArray)(source);
    if (sourceIsArray || (0, _shared.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, _reactivity.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, _reactivity.isShallow)(source);
            isReadonlySource = (0, _reactivity.isReadonly)(source);
            source = (0, _reactivity.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, _reactivity.toReadonly)((0, _reactivity.toReactive)(source[i])) : (0, _reactivity.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, _shared.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function createSlots(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, _shared.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
        const hasProps = Object.keys(props).length > 0;
        if (name !== "default") props.name = name;
        return openBlock(), createBlock(Fragment, null, [
            createVNode("slot", props, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = createBlock(Fragment, {
        key: (slotKey && !(0, _shared.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!isVNode(child)) return true;
        if (child.type === Comment) return false;
        if (child.type === Fragment && !ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, _shared.toHandlerKey)(key)] = obj[key];
    return ret;
}
const getPublicInstance = (i)=>{
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
};
const publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, _shared.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>getPublicInstance(i.parent),
    $root: (i)=>getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? instanceWatch.bind(i) : (0, _shared.NOOP)
});
const isReservedPrefix = (key)=>key === "_" || key === "$";
const hasSetupBinding = (state, key)=>state !== (0, _shared.EMPTY_OBJ) && !state.__isScriptSetup && (0, _shared.hasOwn)(state, key);
const PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, _shared.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, _reactivity.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, _shared.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data, setupState, ctx } = instance;
        if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, _shared.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data, setupState, accessCache, ctx, appContext, props, type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, _shared.EMPTY_OBJ) && key[0] !== "$" && (0, _shared.hasOwn)(data, key) || hasSetupBinding(setupState, key) || (0, _shared.hasOwn)(props, key) || (0, _shared.hasOwn)(ctx, key) || (0, _shared.hasOwn)(publicPropertiesMap, key) || (0, _shared.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, _shared.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var target;
const RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, _shared.extend)({}, PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, _shared.isGloballyAllowed)(key);
        return has;
    }
});
function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys(publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, _shared.NOOP)
        });
    });
    return target;
}
function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, _shared.NOOP)
        });
    });
}
function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys((0, _reactivity.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if (isReservedPrefix(key[0])) {
                warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, _shared.NOOP)
            });
        }
    });
}
const warnRuntimeUsage = (method)=>warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function defineProps() {
    return null;
}
function defineEmits() {
    return null;
}
function defineExpose(exposed) {}
function defineOptions(options) {}
function defineSlots() {
    return null;
}
function defineModel() {}
function withDefaults(props, defaults) {
    return null;
}
function useSlots() {
    return getContext("useSlots").slots;
}
function useAttrs() {
    return getContext("useAttrs").attrs;
}
function getContext(calledFunctionName) {
    const i = getCurrentInstance();
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
    return (0, _shared.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function mergeDefaults(raw, defaults) {
    const props = normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function mergeModels(a, b) {
    if (!a || !b) return a || b;
    if ((0, _shared.isArray)(a) && (0, _shared.isArray)(b)) return a.concat(b);
    return (0, _shared.extend)({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
}
function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    const inSSRSetup = isInSSRComponentSetup;
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if (inSSRSetup) setInSSRSetupState(false);
    const restore = ()=>{
        setCurrentInstance(ctx);
        if (inSSRSetup) setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if (getCurrentInstance() !== ctx) ctx.scope.off();
        unsetCurrentInstance();
        if (inSSRSetup) setInSSRSetupState(false);
    };
    if ((0, _shared.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let shouldCacheAccess = true;
function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, // lifecycle
    created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, // public API
    expose, inheritAttrs, // assets
    components, directives, filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, _shared.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, _shared.isObject)(data)) ;
        else instance.data = (0, _reactivity.reactive)(data);
    }
    shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, _shared.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, _shared.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, _shared.NOOP);
        const set = !(0, _shared.isFunction)(opt) && (0, _shared.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, _shared.NOOP);
        const c = computed({
            get,
            set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, _shared.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            provide(key, provides[key]);
        });
    }
    if (created) callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, _shared.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if ((0, _shared.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, _shared.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) markAsyncBoundary(instance);
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, _shared.NOOP)) {
    if ((0, _shared.isArray)(injectOptions)) injectOptions = normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, _shared.isObject)(opt)) {
            if ("default" in opt) injected = inject(opt.from || key, opt.default, true);
            else injected = inject(opt.from || key);
        } else injected = inject(opt);
        if ((0, _reactivity.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling((0, _shared.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, _shared.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, _shared.isFunction)(handler)) watch(getter, handler);
    } else if ((0, _shared.isFunction)(raw)) watch(getter, raw.bind(publicThis));
    else if ((0, _shared.isObject)(raw)) {
        if ((0, _shared.isArray)(raw)) raw.forEach((r)=>createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, _shared.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, _shared.isFunction)(handler)) watch(getter, handler, raw);
        }
    } else ;
}
function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>mergeOptions(resolved, m, optionMergeStrategies, true));
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, _shared.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, _shared.extend)((0, _shared.isFunction)(to) ? to.call(this, this) : to, (0, _shared.isFunction)(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if ((0, _shared.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function mergeObjectOptions(to, from) {
    return to ? (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, _shared.isArray)(to) && (0, _shared.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, _shared.extend)(/* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = mergeAsArray(to[key], from[key]);
    return merged;
}
function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, _shared.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, _shared.isFunction)(rootComponent)) rootComponent = (0, _shared.extend)({}, rootComponent);
        if (rootProps != null && !(0, _shared.isObject)(rootProps)) rootProps = null;
        const context = createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, _shared.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, _shared.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        devtoolsInitApp(app, version);
                    }
                    return getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    callWithAsyncErrorHandling(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = currentApp;
                currentApp = app;
                try {
                    return fn();
                } finally{
                    currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let currentApp = null;
function useModel(props, name, options = (0, _shared.EMPTY_OBJ)) {
    const i = getCurrentInstance();
    const camelizedName = (0, _shared.camelize)(name);
    const hyphenatedName = (0, _shared.hyphenate)(name);
    const modifiers = getModelModifiers(props, camelizedName);
    const res = (0, _reactivity.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, _shared.EMPTY_OBJ);
        let prevEmittedValue;
        watchSyncEffect(()=>{
            const propValue = props[camelizedName];
            if ((0, _shared.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, _shared.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, _shared.hasChanged)(value, emittedValue) && (0, _shared.hasChanged)(value, prevSetValue) && !(0, _shared.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, _shared.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, _shared.camelize)(modelName)}Modifiers`] || props[`${(0, _shared.hyphenate)(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, _shared.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, _shared.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, _shared.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, _shared.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, _shared.toHandlerKey)((0, _shared.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, _shared.toHandlerKey)((0, _shared.hyphenate)(event))];
    if (handler) callWithAsyncErrorHandling(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
}
const mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, _shared.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, _shared.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, _shared.extend)(normalized, raw);
    if ((0, _shared.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function isEmitListener(options, key) {
    if (!options || !(0, _shared.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, _shared.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, _shared.hasOwn)(options, (0, _shared.hyphenate)(key)) || (0, _shared.hasOwn)(options, key);
}
let accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, props, data, setupState, ctx, inheritAttrs } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = normalizeVNode(render2.length > 1 ? render2(props, {
                attrs,
                slots,
                emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1);
        result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, _shared.isModelListener))) fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                root = cloneVNode(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = cloneVNode(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) setTransitionHooks(root, vnode.transition);
    result = root;
    setCurrentRenderingInstance(prev);
    return result;
}
const getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        normalizeVNode(childRoot),
        setRoot
    ];
};
function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (isVNode(child)) {
            if (child.type !== Comment || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, _shared.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, _shared.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, _shared.isObject)(nextProp) && (0, _shared.isObject)(prevProp)) return !(0, _shared.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function updateHOCHostEl({ vnode, parent, suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const internalObjectProto = {};
const createInternalObject = ()=>Object.create(internalObjectProto);
const isInternalObject = (obj)=>Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, _reactivity.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = (0, _reactivity.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if (isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, _shared.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, _shared.camelize)(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if (setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, _shared.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, _shared.hyphenate)(key)) === key || !(0, _shared.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, _shared.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, _reactivity.trigger)(instance.attrs, "set", "");
}
function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, _shared.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, _shared.hasOwn)(options, camelKey = (0, _shared.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, _reactivity.toRaw)(props);
        const castValues = rawCastValues || (0, _shared.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, _shared.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, _shared.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, _shared.isFunction)(defaultValue)) {
                const { propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, _shared.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = normalizePropsOptions(raw2, appContext, true);
            (0, _shared.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, (0, _shared.EMPTY_ARR));
        return 0, _shared.EMPTY_ARR;
    }
    if ((0, _shared.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, _shared.camelize)(raw[i]);
        if (validatePropName(normalizedKey)) normalized[normalizedKey] = (0, _shared.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, _shared.camelize)(key);
        if (validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt) ? {
                type: opt
            } : (0, _shared.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, _shared.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, _shared.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, _shared.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, _shared.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, _shared.isObject)(comp)) cache.set(comp, res);
    return res;
}
function validatePropName(key) {
    if (key[0] !== "$" && !(0, _shared.isReservedProp)(key)) return true;
    return false;
}
function getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function validateProps(rawProps, props, instance) {
    const resolvedValues = (0, _reactivity.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, _shared.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function validateProp(name, value, prop, props, isAbsent) {
    const { type, required, validator, skipCheck } = prop;
    if (required && isAbsent) {
        warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, _shared.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid, expectedType } = assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            warn$1(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const isSimpleType = /* @__PURE__ */ (0, _shared.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (expectedType === "null") valid = value === null;
    else if (isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, _shared.isObject)(value);
    else if (expectedType === "Array") valid = (0, _shared.isArray)(value);
    else valid = value instanceof type;
    return {
        valid,
        expectedType
    };
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, _shared.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, _shared.toRawType)(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function styleValue(value, type) {
    if ((0, _shared.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const normalizeSlotValue = (value)=>(0, _shared.isArray)(value) ? value.map(normalizeVNode) : [
        normalizeVNode(value)
    ];
const normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = withCtx((...args)=>{
        return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if (isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, _shared.isFunction)(value)) slots[key] = normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const normalizeVNodeSlots = (instance, children)=>{
    const normalized = normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !isInternalKey(key)) slots[key] = children[key];
};
const initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            assignSlots(slots, children, optimized);
            if (optimized) (0, _shared.def)(slots, "_", type, true);
        } else normalizeObjectSlots(children, slots);
    } else if (children) normalizeVNodeSlots(instance, children);
};
const updateSlots = (instance, children, optimized)=>{
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, _shared.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let supported;
let perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${formatComponentName(instance, instance.type)}> ${type}`;
        perf.mark(endTag);
        perf.measure(measureName, startTag, endTag);
        perf.clearMeasures(measureName);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
}
function isSupported() {
    if (supported !== void 0) return supported;
    if (typeof window !== "undefined" && window.performance) {
        supported = true;
        perf = window.performance;
    } else supported = false;
    return supported;
}
function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
    return baseCreateRenderer(options);
}
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
function baseCreateRenderer(options, createHydrationFns) {
    initFeatureFlags();
    const target = (0, _shared.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, _shared.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type, ref, shapeFlag } = n2;
        switch(type){
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props, shapeFlag, transition, dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, _shared.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(el, "__vnode", vnode, true);
            (0, _shared.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag, dynamicChildren, dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, _shared.EMPTY_OBJ);
        const newProps = n2.props || (0, _shared.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, _shared.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, _shared.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, _shared.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = createVNode(Comment);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el, props } = initialVNode;
                const { bm, m, parent, root, type } = instance;
                const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                if (bm) (0, _shared.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) invokeVNodeHook(vnodeHook, parent, initialVNode);
                toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next, bu, u, parent, vnode } = instance;
                {
                    const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, _shared.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parent, next, vnode);
                toggleRecurse(instance, true);
                const nextTree = renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) updateHOCHostEl(instance, nextTree.el);
                if (u) queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, _reactivity.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>queueJob(job);
        toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        (0, _reactivity.pauseTracking)();
        flushPreFlushCbs(instance);
        (0, _reactivity.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag, shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, _shared.EMPTY_ARR);
        c2 = c2 || (0, _shared.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : (0, _shared.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el, type, transition, children, shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave, delayLeave, afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    if (el._isLeaving) el[leaveCbKey](true);
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs, cacheIndex, memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, _reactivity.pauseTracking)();
            setRef(ref, null, parentSuspense, vnode, true);
            (0, _reactivity.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== Fragment || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === Fragment && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type, el, anchor, transition } = vnode;
        if (type === Fragment) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave, delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum, scope, job, subTree, um, m, a } = instance;
        invalidateMount(m);
        invalidateMount(a);
        if (bum) (0, _shared.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) queuePostRenderEffect(um, parentSuspense);
        queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            flushPreFlushCbs(instance);
            flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render,
        hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect, job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, _shared.isArray)(ch1) && (0, _shared.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) {
            if (c2.patchFlag === -1) c2 = ch2[i] = cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === Comment && !c2.el) c2.el = c1.el;
    }
}
function getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return locateNonHydratedAsyncRoot(subComponent);
    }
}
function invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const isSuspense = (type)=>type.__isSuspense;
let suspenseId = 0;
const SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    normalize: normalizeSuspenseChildren
};
const Suspense = SuspenseImpl;
function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, _shared.isFunction)(eventListener)) eventListener();
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        triggerEvent(vnode, "onPending");
        triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        setActiveBranch(suspense, newBranch);
    } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout, pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let hasWarned = false;
function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, _shared.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode,
        parent: parentSuspense,
        parentComponent,
        namespace,
        container,
        hiddenContainer,
        deps: 0,
        pendingId: suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch, pendingBranch, pendingId, effects, parentComponent: parentComponent2, container: container2, isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        queuePostFlushCb(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) queuePostFlushCb(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                handleError(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    let block;
    if ((0, _shared.isFunction)(s)) {
        const trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if ((0, _shared.isArray)(s)) {
        const singleChild = filterSingleRoot(s);
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, _shared.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else queuePostFlushCb(fn);
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}
function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const Fragment = /* @__PURE__ */ Symbol.for("v-fgt");
const Text = /* @__PURE__ */ Symbol.for("v-txt");
const Comment = /* @__PURE__ */ Symbol.for("v-cmt");
const Static = /* @__PURE__ */ Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value, inVOnce = false) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock && inVOnce) currentBlock.hasOnce = true;
}
function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || (0, _shared.EMPTY_ARR) : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(vnode);
    return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let vnodeArgsTransformer;
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
const createVNodeWithArgsTransform = (...args)=>{
    return _createVNode(...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args);
};
const normalizeKey = ({ key })=>key != null ? key : null;
const normalizeRef = ({ ref, ref_key, ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, _shared.isString)(ref) || (0, _reactivity.isRef)(ref) || (0, _shared.isFunction)(ref) ? {
        i: currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type,
        props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag,
        patchFlag,
        dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, _shared.isString)(children) ? 8 : 16;
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) currentBlock.push(vnode);
    return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) type = Comment;
    if (isVNode(type)) {
        const cloned = cloneVNode(type, props, true);
        if (children) normalizeChildren(cloned, children);
        if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
            if (cloned.shapeFlag & 6) currentBlock[currentBlock.indexOf(type)] = cloned;
            else currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if (isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = guardReactiveProps(props);
        let { class: klass, style } = props;
        if (klass && !(0, _shared.isString)(klass)) props.class = (0, _shared.normalizeClass)(klass);
        if ((0, _shared.isObject)(style)) {
            if ((0, _reactivity.isProxy)(style) && !(0, _shared.isArray)(style)) style = (0, _shared.extend)({}, style);
            props.style = (0, _shared.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, _shared.isString)(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : (0, _shared.isObject)(type) ? 4 : (0, _shared.isFunction)(type) ? 2 : 0;
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props) return null;
    return (0, _reactivity.isProxy)(props) || isInternalObject(props) ? (0, _shared.extend)({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, _shared.isArray)(ref) ? ref.concat(normalizeRef(extraProps)) : [
            ref,
            normalizeRef(extraProps)
        ] : normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) setTransitionHooks(cloned, transition.clone(cloned));
    return cloned;
}
function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if ((0, _shared.isArray)(vnode.children)) cloned.children = vnode.children.map(deepCloneVNode);
    return cloned;
}
function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return createVNode(Comment);
    else if ((0, _shared.isArray)(child)) return createVNode(Fragment, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (isVNode(child)) return cloneIfMounted(child);
    else return createVNode(Text, null, String(child));
}
function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, _shared.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !isInternalObject(children)) children._ctx = currentRenderingInstance;
            else if (slotFlag === 3 && currentRenderingInstance) {
                if (currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, _shared.isFunction)(children)) {
        children = {
            default: children,
            _ctx: currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                createTextVNode(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, _shared.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, _shared.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, _shared.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, _shared.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, _shared.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
        uid: uid++,
        vnode,
        type,
        parent,
        appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, _reactivity.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, _shared.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, _shared.EMPTY_OBJ),
        data: (0, _shared.EMPTY_OBJ),
        props: (0, _shared.EMPTY_OBJ),
        attrs: (0, _shared.EMPTY_OBJ),
        slots: (0, _shared.EMPTY_OBJ),
        refs: (0, _shared.EMPTY_OBJ),
        setupState: (0, _shared.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let currentInstance = null;
const getCurrentInstance = ()=>currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
    const g = (0, _shared.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>currentInstance = v1);
    setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>isInSSRComponentSetup = v1);
}const setCurrentInstance = (instance)=>{
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        internalSetCurrentInstance(prev);
    };
};
const unsetCurrentInstance = ()=>{
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
};
const isBuiltInTag = /* @__PURE__ */ (0, _shared.makeMap)("slot,component");
function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    const { setup } = Component;
    if (setup) {
        (0, _reactivity.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
        const reset = setCurrentInstance(instance);
        const setupResult = callWithErrorHandling(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, _shared.isPromise)(setupResult);
        (0, _reactivity.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                handleError(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else handleSetupResult(instance, setupResult, isSSR);
    } else finishComponentSetup(instance, isSSR);
}
function handleSetupResult(instance, setupResult, isSSR) {
    if ((0, _shared.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, _shared.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, _reactivity.proxyRefs)(setupResult);
    }
    finishComponentSetup(instance, isSSR);
}
let compile;
let installWithProxy;
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const isRuntimeOnly = ()=>!compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement, compilerOptions } = instance.appContext.config;
                const { delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, _shared.extend)((0, _shared.extend)({
                    isCustomElement,
                    delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, _shared.NOOP);
        if (installWithProxy) installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        try {
            applyOptions(instance);
        } finally{
            (0, _reactivity.resetTracking)();
            reset();
        }
    }
}
const attrsProxyHandlers = {
    get (target, key) {
        (0, _reactivity.track)(target, "get", "");
        return target[key];
    }
};
function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, _reactivity.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
    };
}
function getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, _reactivity.proxyRefs)((0, _reactivity.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const classifyRE = /(?:^|[-_])\w/g;
const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
    return (0, _shared.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
    return (0, _shared.isFunction)(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions)=>{
    const c = (0, _reactivity.computed)(getterOrOptions, debugOptions, isInSSRComponentSetup);
    return c;
};
function h(type, propsOrChildren, children) {
    try {
        setBlockTracking(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, _shared.isObject)(propsOrChildren) && !(0, _shared.isArray)(propsOrChildren)) {
                if (isVNode(propsOrChildren)) return createVNode(type, null, [
                    propsOrChildren
                ]);
                return createVNode(type, propsOrChildren);
            } else return createVNode(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && isVNode(children)) children = [
                children
            ];
            return createVNode(type, propsOrChildren, children);
        }
    } finally{
        setBlockTracking(1);
    }
}
function initCustomFormatter() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, _reactivity.toRaw)(instance.props)));
        if (instance.setupState !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, _reactivity.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, _shared.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, _shared.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, _reactivity.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, _shared.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, _shared.isArray)(opts) && opts.includes(key) || (0, _shared.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, _reactivity.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function withMemo(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, _shared.hasChanged)(prev[i], memo[i])) return false;
    }
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(cached);
    return true;
}
const version = "3.5.34";
const warn = (0, _shared.NOOP);
const ErrorTypeStrings = ErrorTypeStrings$1;
const devtools = devtools$1;
const setDevtoolsHook = setDevtoolsHook$1;
const _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode: isVNode,
    normalizeVNode,
    getComponentPublicInstance,
    ensureValidVNode,
    pushWarningContext,
    popWarningContext
};
const ssrUtils = _ssrUtils;
const resolveFilter = null;
const compatUtils = null;
const DeprecationTypes = null;

},{"@vue/reactivity":"ebwJT","@vue/shared":"jjpTC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"ebwJT":[function(require,module,exports) {
/**
* @vue/reactivity v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_ITERATE_KEY", ()=>ARRAY_ITERATE_KEY);
parcelHelpers.export(exports, "EffectFlags", ()=>EffectFlags);
parcelHelpers.export(exports, "EffectScope", ()=>EffectScope);
parcelHelpers.export(exports, "ITERATE_KEY", ()=>ITERATE_KEY);
parcelHelpers.export(exports, "MAP_KEY_ITERATE_KEY", ()=>MAP_KEY_ITERATE_KEY);
parcelHelpers.export(exports, "ReactiveEffect", ()=>ReactiveEffect);
parcelHelpers.export(exports, "ReactiveFlags", ()=>ReactiveFlags);
parcelHelpers.export(exports, "TrackOpTypes", ()=>TrackOpTypes);
parcelHelpers.export(exports, "TriggerOpTypes", ()=>TriggerOpTypes);
parcelHelpers.export(exports, "WatchErrorCodes", ()=>WatchErrorCodes);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "customRef", ()=>customRef);
parcelHelpers.export(exports, "effect", ()=>effect);
parcelHelpers.export(exports, "effectScope", ()=>effectScope);
parcelHelpers.export(exports, "enableTracking", ()=>enableTracking);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "getCurrentWatcher", ()=>getCurrentWatcher);
parcelHelpers.export(exports, "isProxy", ()=>isProxy);
parcelHelpers.export(exports, "isReactive", ()=>isReactive);
parcelHelpers.export(exports, "isReadonly", ()=>isReadonly);
parcelHelpers.export(exports, "isRef", ()=>isRef);
parcelHelpers.export(exports, "isShallow", ()=>isShallow);
parcelHelpers.export(exports, "markRaw", ()=>markRaw);
parcelHelpers.export(exports, "onEffectCleanup", ()=>onEffectCleanup);
parcelHelpers.export(exports, "onScopeDispose", ()=>onScopeDispose);
parcelHelpers.export(exports, "onWatcherCleanup", ()=>onWatcherCleanup);
parcelHelpers.export(exports, "pauseTracking", ()=>pauseTracking);
parcelHelpers.export(exports, "proxyRefs", ()=>proxyRefs);
parcelHelpers.export(exports, "reactive", ()=>reactive);
parcelHelpers.export(exports, "reactiveReadArray", ()=>reactiveReadArray);
parcelHelpers.export(exports, "readonly", ()=>readonly);
parcelHelpers.export(exports, "ref", ()=>ref);
parcelHelpers.export(exports, "resetTracking", ()=>resetTracking);
parcelHelpers.export(exports, "shallowReactive", ()=>shallowReactive);
parcelHelpers.export(exports, "shallowReadArray", ()=>shallowReadArray);
parcelHelpers.export(exports, "shallowReadonly", ()=>shallowReadonly);
parcelHelpers.export(exports, "shallowRef", ()=>shallowRef);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "toRaw", ()=>toRaw);
parcelHelpers.export(exports, "toReactive", ()=>toReactive);
parcelHelpers.export(exports, "toReadonly", ()=>toReadonly);
parcelHelpers.export(exports, "toRef", ()=>toRef);
parcelHelpers.export(exports, "toRefs", ()=>toRefs);
parcelHelpers.export(exports, "toValue", ()=>toValue);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "traverse", ()=>traverse);
parcelHelpers.export(exports, "trigger", ()=>trigger);
parcelHelpers.export(exports, "triggerRef", ()=>triggerRef);
parcelHelpers.export(exports, "unref", ()=>unref);
parcelHelpers.export(exports, "watch", ()=>watch);
var _shared = require("@vue/shared");
function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && activeEffectScope) {
            if (activeEffectScope.active) {
                this.parent = activeEffectScope;
                this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally{
                activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = activeEffectScope;
            activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if (activeEffectScope === this) activeEffectScope = this.prevScope;
            else {
                let current = activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
let activeSub;
const EffectFlags = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if (activeEffectScope) {
            if (activeEffectScope.active) activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if (pausedQueueEffects.has(this)) {
                pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        cleanupEffect(this);
        prepareDeps(this);
        const prevEffect = activeSub;
        const prevShouldTrack = shouldTrack;
        activeSub = this;
        shouldTrack = true;
        try {
            return this.fn();
        } finally{
            cleanupDeps(this);
            activeSub = prevEffect;
            shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)removeSub(link);
            this.deps = this.depsTail = void 0;
            cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if (isDirty(this)) this.run();
    }
    get dirty() {
        return isDirty(this);
    }
}
let batchDepth = 0;
let batchedSub;
let batchedComputed;
function batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = batchedComputed;
        batchedComputed = sub;
        return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
}
function startBatch() {
    batchDepth++;
}
function endBatch() {
    if (--batchDepth > 0) return;
    if (batchedComputed) {
        let e = batchedComputed;
        batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while(batchedSub){
        let e = batchedSub;
        batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            removeSub(link);
            removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === globalVersion) return;
    computed.globalVersion = globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed;
    shouldTrack = true;
    try {
        prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, _shared.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        activeSub = prevSub;
        shouldTrack = prevShouldTrack;
        cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function removeSub(link, soft = false) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    const e = new ReactiveEffect(fn);
    if (options) (0, _shared.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function onEffectCleanup(fn, failSilently = false) {
    if (activeSub instanceof ReactiveEffect) activeSub.cleanup = fn;
}
function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = activeSub;
        activeSub = void 0;
        try {
            cleanup();
        } finally{
            activeSub = prevSub;
        }
    }
}
let globalVersion = 0;
class Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!activeSub || !shouldTrack || activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== activeSub) {
            link = this.activeLink = new Link(activeSub, this);
            if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
            else {
                link.prevDep = activeSub.depsTail;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
            }
            addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = activeSub.depsTail;
                link.nextDep = void 0;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
                if (activeSub.deps === link) activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            endBatch();
        }
    }
}
function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = /* @__PURE__ */ Symbol("");
const MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol("");
const ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeSub) {
        let depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
        globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, _shared.isArray)(target);
        const isArrayIndex = targetIsArray && (0, _shared.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !(0, _shared.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ((0, _shared.isMap)(target)) run(depsMap.get(ITERATE_KEY));
                    break;
            }
        }
    }
    endBatch();
}
function getDepFromReactive(object, key) {
    const depMap = targetMap.get(object);
    return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
    const raw = toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
}
function toWrapped(target, item) {
    if (isReadonly(target)) return isReactive(target) ? toReadonly(toReactive(item)) : toReadonly(item);
    return toReactive(item);
}
const arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return iterator(this, Symbol.iterator, (item)=>toWrapped(this, item));
    },
    concat (...args) {
        return reactiveReadArray(this).concat(...args.map((x)=>(0, _shared.isArray)(x) ? reactiveReadArray(x) : x));
    },
    entries () {
        return iterator(this, "entries", (value)=>{
            value[1] = toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return apply(this, "find", fn, thisArg, (item)=>toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return apply(this, "findLast", fn, thisArg, (item)=>toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return noTracking(this, "pop");
    },
    push (...args) {
        return noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return noTracking(this, "splice", args);
    },
    toReversed () {
        return reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return noTracking(this, "unshift", args);
    },
    values () {
        return iterator(this, "values", (item)=>toWrapped(this, item));
    }
};
function iterator(self, method, wrapValue) {
    const arr = shallowReadArray(self);
    const iter = arr[method]();
    if (arr !== self && !isShallow(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self);
    const needsWrap = arr !== self && !isShallow(self);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
    const arr = shallowReadArray(self);
    const needsWrap = arr !== self && !isShallow(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = toWrapped(self, acc);
                }
                return fn.call(this, acc, toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? toWrapped(self, result) : result;
}
function searchProxy(self, method, args) {
    const arr = toRaw(self);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && isProxy(args[0])) {
        args[0] = toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function noTracking(self, method, args = []) {
    pauseTracking();
    startBatch();
    const res = toRaw(self)[method].apply(self, args);
    endBatch();
    resetTracking();
    return res;
}
const isNonTrackableKeys = /* @__PURE__ */ (0, _shared.makeMap)(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, _shared.isSymbol)));
function hasOwnProperty(key) {
    if (!(0, _shared.isSymbol)(key)) key = String(key);
    const obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, _shared.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        isRef(target) ? target : receiver);
        if ((0, _shared.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
        if (!isReadonly2) track(target, "get", key);
        if (isShallow2) return res;
        if (isRef(res)) {
            const value = targetIsArray && (0, _shared.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, _shared.isObject)(value) ? readonly(value) : value;
        }
        if ((0, _shared.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
        return res;
    }
}
class MutableReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, _shared.isArray)(target) && (0, _shared.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = isReadonly(oldValue);
            if (!isShallow(value) && !isReadonly(value)) {
                oldValue = toRaw(oldValue);
                value = toRaw(value);
            }
            if (!isArrayWithIntegerKey && isRef(oldValue) && !isRef(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, _shared.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, isRef(target) ? target : receiver);
        if (target === toRaw(receiver)) {
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, _shared.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, _shared.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        track(target, "iterate", (0, _shared.isArray)(target) ? "length" : ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value)=>value;
const getProto = (v)=>Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = toRaw(target);
        const targetIsMap = (0, _shared.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return (0, _shared.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value, done } = innerIterator.next();
                return done ? {
                    value,
                    done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done
                };
            }
        });
    };
}
function createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const rawKey = toRaw(key);
            if (!readonly) {
                if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
                track(rawTarget, "get", rawKey);
            }
            const { has } = getProto(rawTarget);
            const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && track(toRaw(target), "iterate", ITERATE_KEY);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const rawKey = toRaw(key);
            if (!readonly) {
                if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
                track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = toRaw(target);
            const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            !readonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, _shared.extend)(instrumentations, readonly ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = toRaw(this);
            const proto = getProto(target);
            const rawValue = toRaw(value);
            const valueToAdd = !shallow && !isShallow(value) && !isReadonly(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, _shared.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, _shared.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                trigger(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            const target = toRaw(this);
            const { has, get } = getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = toRaw(this);
            const { has, get } = getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, _shared.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, _shared.toRawType)(target);
        warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, _shared.toRawType)(value));
}
// @__NO_SIDE_EFFECTS__
function reactive(target) {
    if (/* @__PURE__ */ isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, _shared.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function isReactive(value) {
    if (/* @__PURE__ */ isReadonly(value)) return /* @__PURE__ */ isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ toRaw(raw) : observed;
}
function markRaw(value) {
    if (!(0, _shared.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, _shared.def)(value, "__v_skip", true);
    return value;
}
const toReactive = (value)=>(0, _shared.isObject)(value) ? /* @__PURE__ */ reactive(value) : value;
const toReadonly = (value)=>(0, _shared.isObject)(value) ? /* @__PURE__ */ readonly(value) : value;
// @__NO_SIDE_EFFECTS__
function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function ref(value) {
    return createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (/* @__PURE__ */ isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
class RefImpl {
    constructor(value, isShallow2){
        this.dep = new Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : toRaw(value);
        this._value = isShallow2 ? value : toReactive(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
        newValue = useDirectValue ? newValue : toRaw(newValue);
        if ((0, _shared.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : toReactive(newValue);
            this.dep.trigger();
        }
    }
}
function triggerRef(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function unref(ref2) {
    return /* @__PURE__ */ isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, _shared.isFunction)(source) ? source() : unref(source);
}
const shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new Dep();
        const { get, set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function customRef(factory) {
    return new CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function toRefs(object) {
    const ret = (0, _shared.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
class ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, _shared.isSymbol)(key) ? key : String(key);
        this._raw = toRaw(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, _shared.isArray)(_object) || (0, _shared.isSymbol)(this._key) || !(0, _shared.isIntegerKey)(this._key)) do shallow = !isProxy(obj) || isShallow(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = unref(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ isRef(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ isRef(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return getDepFromReactive(this._raw, this._key);
    }
}
class GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function toRef(source, key, defaultValue) {
    if (/* @__PURE__ */ isRef(source)) return source;
    else if ((0, _shared.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, _shared.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ ref(source);
}
function propertyToRef(source, key, defaultValue) {
    return new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        activeSub !== this) {
            batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, _shared.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const ReactiveFlags = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const WatchErrorCodes = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function getCurrentWatcher() {
    return activeWatcher;
}
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
        let cleanups = cleanupMap.get(owner);
        if (!cleanups) cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function watch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if (isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
        return traverse(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef(source)) {
        getter = ()=>source.value;
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, _shared.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>isReactive(s) || isShallow(s));
        getter = ()=>source.map((s)=>{
                if (isRef(s)) return s.value;
                else if (isReactive(s)) return reactiveGetter(s);
                else if ((0, _shared.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, _shared.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                pauseTracking();
                try {
                    cleanup();
                } finally{
                    resetTracking();
                }
            }
            const currentEffect = activeWatcher;
            activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                activeWatcher = currentEffect;
            }
        };
    } else getter = (0, _shared.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, _shared.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, _shared.hasChanged)(v, oldValue[i])) : (0, _shared.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = activeWatcher;
                activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new ReactiveEffect(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>onWatcherCleanup(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, _shared.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if (isRef(value)) traverse(value.value, depth, seen);
    else if ((0, _shared.isArray)(value)) for(let i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, _shared.isSet)(value) || (0, _shared.isMap)(value)) value.forEach((v)=>{
        traverse(v, depth, seen);
    });
    else if ((0, _shared.isPlainObject)(value)) {
        for(const key in value)traverse(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) traverse(value[key], depth, seen);
    }
    return value;
}

},{"@vue/shared":"jjpTC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"jjpTC":[function(require,module,exports) {
/**
* @vue/shared v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_ARR", ()=>EMPTY_ARR);
parcelHelpers.export(exports, "EMPTY_OBJ", ()=>EMPTY_OBJ);
parcelHelpers.export(exports, "NO", ()=>NO);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
parcelHelpers.export(exports, "PatchFlagNames", ()=>PatchFlagNames);
parcelHelpers.export(exports, "PatchFlags", ()=>PatchFlags);
parcelHelpers.export(exports, "ShapeFlags", ()=>ShapeFlags);
parcelHelpers.export(exports, "SlotFlags", ()=>SlotFlags);
parcelHelpers.export(exports, "camelize", ()=>camelize);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "cssVarNameEscapeSymbolsRE", ()=>cssVarNameEscapeSymbolsRE);
parcelHelpers.export(exports, "def", ()=>def);
parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
parcelHelpers.export(exports, "escapeHtmlComment", ()=>escapeHtmlComment);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "genCacheKey", ()=>genCacheKey);
parcelHelpers.export(exports, "genPropsAccessExp", ()=>genPropsAccessExp);
parcelHelpers.export(exports, "generateCodeFrame", ()=>generateCodeFrame);
parcelHelpers.export(exports, "getEscapedCssVarName", ()=>getEscapedCssVarName);
parcelHelpers.export(exports, "getGlobalThis", ()=>getGlobalThis);
parcelHelpers.export(exports, "hasChanged", ()=>hasChanged);
parcelHelpers.export(exports, "hasOwn", ()=>hasOwn);
parcelHelpers.export(exports, "hyphenate", ()=>hyphenate);
parcelHelpers.export(exports, "includeBooleanAttr", ()=>includeBooleanAttr);
parcelHelpers.export(exports, "invokeArrayFns", ()=>invokeArrayFns);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBooleanAttr", ()=>isBooleanAttr);
parcelHelpers.export(exports, "isBuiltInDirective", ()=>isBuiltInDirective);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isGloballyAllowed", ()=>isGloballyAllowed);
parcelHelpers.export(exports, "isGloballyWhitelisted", ()=>isGloballyWhitelisted);
parcelHelpers.export(exports, "isHTMLTag", ()=>isHTMLTag);
parcelHelpers.export(exports, "isIntegerKey", ()=>isIntegerKey);
parcelHelpers.export(exports, "isKnownHtmlAttr", ()=>isKnownHtmlAttr);
parcelHelpers.export(exports, "isKnownMathMLAttr", ()=>isKnownMathMLAttr);
parcelHelpers.export(exports, "isKnownSvgAttr", ()=>isKnownSvgAttr);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isMathMLTag", ()=>isMathMLTag);
parcelHelpers.export(exports, "isModelListener", ()=>isModelListener);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isOn", ()=>isOn);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isRenderableAttrValue", ()=>isRenderableAttrValue);
parcelHelpers.export(exports, "isReservedProp", ()=>isReservedProp);
parcelHelpers.export(exports, "isSSRSafeAttrName", ()=>isSSRSafeAttrName);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isSpecialBooleanAttr", ()=>isSpecialBooleanAttr);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isVoidTag", ()=>isVoidTag);
parcelHelpers.export(exports, "looseEqual", ()=>looseEqual);
parcelHelpers.export(exports, "looseIndexOf", ()=>looseIndexOf);
parcelHelpers.export(exports, "looseToNumber", ()=>looseToNumber);
parcelHelpers.export(exports, "makeMap", ()=>makeMap);
parcelHelpers.export(exports, "normalizeClass", ()=>normalizeClass);
parcelHelpers.export(exports, "normalizeCssVarValue", ()=>normalizeCssVarValue);
parcelHelpers.export(exports, "normalizeProps", ()=>normalizeProps);
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
parcelHelpers.export(exports, "objectToString", ()=>objectToString);
parcelHelpers.export(exports, "parseStringStyle", ()=>parseStringStyle);
parcelHelpers.export(exports, "propsToAttrMap", ()=>propsToAttrMap);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "slotFlagsText", ()=>slotFlagsText);
parcelHelpers.export(exports, "stringifyStyle", ()=>stringifyStyle);
parcelHelpers.export(exports, "toDisplayString", ()=>toDisplayString);
parcelHelpers.export(exports, "toHandlerKey", ()=>toHandlerKey);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toRawType", ()=>toRawType);
parcelHelpers.export(exports, "toTypeString", ()=>toTypeString);
var global = arguments[3];
function makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = ()=>{};
const NO = ()=>false;
const isOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key)=>key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (val, key)=>hasOwnProperty.call(val, key);
const isArray = Array.isArray;
const isMap = (val)=>toTypeString(val) === "[object Map]";
const isSet = (val)=>toTypeString(val) === "[object Set]";
const isDate = (val)=>toTypeString(val) === "[object Date]";
const isRegExp = (val)=>toTypeString(val) === "[object RegExp]";
const isFunction = (val)=>typeof val === "function";
const isString = (val)=>typeof val === "string";
const isSymbol = (val)=>typeof val === "symbol";
const isObject = (val)=>val !== null && typeof val === "object";
const isPromise = (val)=>{
    return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value)=>objectToString.call(value);
const toRawType = (value)=>{
    return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val)=>toTypeString(val) === "[object Object]";
const isIntegerKey = (key)=>isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const isBuiltInDirective = /* @__PURE__ */ makeMap("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const camelizeRE = /-\w/g;
const camelize = cacheStringFunction((str)=>{
    return str.replace(camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str)=>str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction((str)=>{
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
});
const hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const def = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable,
        value
    });
};
const looseToNumber = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const toNumber = (val)=>{
    const n = isString(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = ()=>{
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
const identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function genPropsAccessExp(name) {
    return identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function genCacheKey(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const PatchFlags = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const ShapeFlags = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const SlotFlags = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
const isGloballyWhitelisted = isGloballyAllowed;
const range = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - range; j <= i + range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function normalizeStyle(value) {
    if (isArray(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if (isString(value) || isObject(value)) return value;
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split(propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function stringifyStyle(styles) {
    if (!styles) return "";
    if (isString(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if (isString(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function normalizeClass(value) {
    let res = "";
    if (isString(value)) res = value;
    else if (isArray(value)) for(let i = 0; i < value.length; i++){
        const normalized = normalizeClass(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if (isObject(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) props.class = normalizeClass(klass);
    if (style) props.style = normalizeStyle(style);
    return props;
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
const isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
const isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
const isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
const isBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function includeBooleanAttr(value) {
    return !!value || value === "";
}
const unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const attrValidationCache = {};
function isSSRSafeAttrName(name) {
    if (attrValidationCache.hasOwnProperty(name)) return attrValidationCache[name];
    const isUnsafe = unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return attrValidationCache[name] = !isUnsafe;
}
const propsToAttrMap = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const isKnownHtmlAttr = /* @__PURE__ */ makeMap(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const isKnownSvgAttr = /* @__PURE__ */ makeMap(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const isKnownMathMLAttr = /* @__PURE__ */ makeMap(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function isRenderableAttrValue(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const escapeRE = /["'&<>]/;
function escapeHtml(string) {
    const str = "" + string;
    const match = escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function escapeHtmlComment(src) {
    return src.replace(commentStripRE, "");
}
const cssVarNameEscapeSymbolsRE = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function getEscapedCssVarName(key, doubleEscape) {
    return key.replace(cssVarNameEscapeSymbolsRE, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = looseEqual(a[i], b[i]);
    return equal;
}
function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) return a === b;
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function looseIndexOf(arr, val) {
    return arr.findIndex((item)=>looseEqual(item, val));
}
const isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val)=>{
    return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val)=>{
    if (isRef(val)) return replacer(_key, val.value);
    else if (isMap(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if (isSet(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>stringifySymbol(v))
    };
    else if (isSymbol(val)) return stringifySymbol(val);
    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) return String(val);
    return val;
};
const stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function normalizeCssVarValue(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"b6aao":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"ePJTz":[function(require,module,exports) {
/**
* @vue/compiler-dom v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMDirectiveTransforms", ()=>DOMDirectiveTransforms);
parcelHelpers.export(exports, "DOMErrorCodes", ()=>DOMErrorCodes);
parcelHelpers.export(exports, "DOMErrorMessages", ()=>DOMErrorMessages);
parcelHelpers.export(exports, "DOMNodeTransforms", ()=>DOMNodeTransforms);
parcelHelpers.export(exports, "TRANSITION", ()=>TRANSITION);
parcelHelpers.export(exports, "TRANSITION_GROUP", ()=>TRANSITION_GROUP);
parcelHelpers.export(exports, "V_MODEL_CHECKBOX", ()=>V_MODEL_CHECKBOX);
parcelHelpers.export(exports, "V_MODEL_DYNAMIC", ()=>V_MODEL_DYNAMIC);
parcelHelpers.export(exports, "V_MODEL_RADIO", ()=>V_MODEL_RADIO);
parcelHelpers.export(exports, "V_MODEL_SELECT", ()=>V_MODEL_SELECT);
parcelHelpers.export(exports, "V_MODEL_TEXT", ()=>V_MODEL_TEXT);
parcelHelpers.export(exports, "V_ON_WITH_KEYS", ()=>V_ON_WITH_KEYS);
parcelHelpers.export(exports, "V_ON_WITH_MODIFIERS", ()=>V_ON_WITH_MODIFIERS);
parcelHelpers.export(exports, "V_SHOW", ()=>V_SHOW);
parcelHelpers.export(exports, "compile", ()=>compile);
parcelHelpers.export(exports, "createDOMCompilerError", ()=>createDOMCompilerError);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parserOptions", ()=>parserOptions);
parcelHelpers.export(exports, "transformStyle", ()=>transformStyle);
var _compilerCore = require("@vue/compiler-core");
parcelHelpers.exportAll(_compilerCore, exports);
var _shared = require("@vue/shared");
const V_MODEL_RADIO = /* @__PURE__ */ Symbol(``);
const V_MODEL_CHECKBOX = /* @__PURE__ */ Symbol(``);
const V_MODEL_TEXT = /* @__PURE__ */ Symbol(``);
const V_MODEL_SELECT = /* @__PURE__ */ Symbol(``);
const V_MODEL_DYNAMIC = /* @__PURE__ */ Symbol(``);
const V_ON_WITH_MODIFIERS = /* @__PURE__ */ Symbol(``);
const V_ON_WITH_KEYS = /* @__PURE__ */ Symbol(``);
const V_SHOW = /* @__PURE__ */ Symbol(``);
const TRANSITION = /* @__PURE__ */ Symbol(``);
const TRANSITION_GROUP = /* @__PURE__ */ Symbol(``);
(0, _compilerCore.registerRuntimeHelpers)({
    [V_MODEL_RADIO]: `vModelRadio`,
    [V_MODEL_CHECKBOX]: `vModelCheckbox`,
    [V_MODEL_TEXT]: `vModelText`,
    [V_MODEL_SELECT]: `vModelSelect`,
    [V_MODEL_DYNAMIC]: `vModelDynamic`,
    [V_ON_WITH_MODIFIERS]: `withModifiers`,
    [V_ON_WITH_KEYS]: `withKeys`,
    [V_SHOW]: `vShow`,
    [TRANSITION]: `Transition`,
    [TRANSITION_GROUP]: `TransitionGroup`
});
let decoder;
function decodeHtmlBrowser(raw, asAttr = false) {
    if (!decoder) decoder = document.createElement("div");
    if (asAttr) {
        decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
        return decoder.children[0].getAttribute("foo");
    } else {
        decoder.innerHTML = raw;
        return decoder.textContent;
    }
}
const parserOptions = {
    parseMode: "html",
    isVoidTag: (0, _shared.isVoidTag),
    isNativeTag: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
    isPreTag: (tag)=>tag === "pre",
    isIgnoreNewlineTag: (tag)=>tag === "pre" || tag === "textarea",
    decodeEntities: decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if (tag === "Transition" || tag === "transition") return TRANSITION;
        else if (tag === "TransitionGroup" || tag === "transition-group") return TRANSITION_GROUP;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent, rootNamespace) {
        let ns = parent ? parent.ns : rootNamespace;
        if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
                if (tag === "svg") return 1;
                if (parent.props.some((a)=>a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml"))) ns = 0;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") ns = 0;
        } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") ns = 0;
        }
        if (ns === 0) {
            if (tag === "svg") return 1;
            if (tag === "math") return 2;
        }
        return ns;
    }
};
const transformStyle = (node)=>{
    if (node.type === 1) node.props.forEach((p, i)=>{
        if (p.type === 6 && p.name === "style" && p.value) node.props[i] = {
            type: 7,
            name: `bind`,
            arg: (0, _compilerCore.createSimpleExpression)(`style`, true, p.loc),
            exp: parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, _shared.parseStringStyle)(cssText);
    return (0, _compilerCore.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3);
};
function createDOMCompilerError(code, loc) {
    return (0, _compilerCore.createCompilerError)(code, loc, void 0);
}
const DOMErrorCodes = {
    "X_V_HTML_NO_EXPRESSION": 54,
    "54": "X_V_HTML_NO_EXPRESSION",
    "X_V_HTML_WITH_CHILDREN": 55,
    "55": "X_V_HTML_WITH_CHILDREN",
    "X_V_TEXT_NO_EXPRESSION": 56,
    "56": "X_V_TEXT_NO_EXPRESSION",
    "X_V_TEXT_WITH_CHILDREN": 57,
    "57": "X_V_TEXT_WITH_CHILDREN",
    "X_V_MODEL_ON_INVALID_ELEMENT": 58,
    "58": "X_V_MODEL_ON_INVALID_ELEMENT",
    "X_V_MODEL_ARG_ON_ELEMENT": 59,
    "59": "X_V_MODEL_ARG_ON_ELEMENT",
    "X_V_MODEL_ON_FILE_INPUT_ELEMENT": 60,
    "60": "X_V_MODEL_ON_FILE_INPUT_ELEMENT",
    "X_V_MODEL_UNNECESSARY_VALUE": 61,
    "61": "X_V_MODEL_UNNECESSARY_VALUE",
    "X_V_SHOW_NO_EXPRESSION": 62,
    "62": "X_V_SHOW_NO_EXPRESSION",
    "X_TRANSITION_INVALID_CHILDREN": 63,
    "63": "X_TRANSITION_INVALID_CHILDREN",
    "X_IGNORED_SIDE_EFFECT_TAG": 64,
    "64": "X_IGNORED_SIDE_EFFECT_TAG",
    "__EXTEND_POINT__": 65,
    "65": "__EXTEND_POINT__"
};
const DOMErrorMessages = {
    [54]: `v-html is missing expression.`,
    [55]: `v-html will override element children.`,
    [56]: `v-text is missing expression.`,
    [57]: `v-text will override element children.`,
    [58]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [59]: `v-model argument is not supported on plain elements.`,
    [60]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [61]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [62]: `v-show is missing expression.`,
    [63]: `<Transition> expects exactly one child element or component.`,
    [64]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const transformVHtml = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(54, loc));
    if (node.children.length) {
        context.onError(createDOMCompilerError(55, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, _compilerCore.createObjectProperty)((0, _compilerCore.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, _compilerCore.createSimpleExpression)("", true))
        ]
    };
};
const transformVText = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(56, loc));
    if (node.children.length) {
        context.onError(createDOMCompilerError(57, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, _compilerCore.createObjectProperty)((0, _compilerCore.createSimpleExpression)(`textContent`, true), exp ? (0, _compilerCore.getConstantType)(exp, context) > 0 ? exp : (0, _compilerCore.createCallExpression)(context.helperString((0, _compilerCore.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, _compilerCore.createSimpleExpression)("", true))
        ]
    };
};
const transformModel = (dir, node, context)=>{
    const baseResult = (0, _compilerCore.transformModel)(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) return baseResult;
    if (dir.arg) context.onError(createDOMCompilerError(59, dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, _compilerCore.findDir)(node, "bind");
        if (value && (0, _compilerCore.isStaticArgOf)(value.arg, "value")) context.onError(createDOMCompilerError(61, value.loc));
    }
    const { tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
        let directiveToUse = V_MODEL_TEXT;
        let isInvalidType = false;
        if (tag === "input" || isCustomElement) {
            const type = (0, _compilerCore.findProp)(node, `type`);
            if (type) {
                if (type.type === 7) directiveToUse = V_MODEL_DYNAMIC;
                else if (type.value) switch(type.value.content){
                    case "radio":
                        directiveToUse = V_MODEL_RADIO;
                        break;
                    case "checkbox":
                        directiveToUse = V_MODEL_CHECKBOX;
                        break;
                    case "file":
                        isInvalidType = true;
                        context.onError(createDOMCompilerError(60, dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, _compilerCore.hasDynamicKeyVBind)(node)) directiveToUse = V_MODEL_DYNAMIC;
        } else if (tag === "select") directiveToUse = V_MODEL_SELECT;
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError(createDOMCompilerError(58, dir.loc));
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 && p.key.content === "modelValue"));
    return baseResult;
};
const isEventOptionModifier = /* @__PURE__ */ (0, _shared.makeMap)(`passive,once,capture`);
const isNonKeyModifier = /* @__PURE__ */ (0, _shared.makeMap)(// event propagation management
`stop,prevent,self,ctrl,shift,alt,meta,exact,middle`);
const maybeKeyModifier = /* @__PURE__ */ (0, _shared.makeMap)("left,right");
const isKeyboardEvent = /* @__PURE__ */ (0, _shared.makeMap)(`onkeyup,onkeydown,onkeypress`);
const resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i].content;
        if (modifier === "native" && (0, _compilerCore.checkCompatEnabled)("COMPILER_V_ON_NATIVE", context, loc)) eventOptionModifiers.push(modifier);
        else if (isEventOptionModifier(modifier)) eventOptionModifiers.push(modifier);
        else {
            if (maybeKeyModifier(modifier)) {
                if ((0, _compilerCore.isStaticExp)(key)) {
                    if (isKeyboardEvent(key.content.toLowerCase())) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if (isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers,
        nonKeyModifiers,
        eventOptionModifiers
    };
};
const transformClick = (key, event)=>{
    const isStaticClick = (0, _compilerCore.isStaticExp)(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? (0, _compilerCore.createSimpleExpression)(event, true) : key.type !== 4 ? (0, _compilerCore.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const transformOn = (dir, node, context)=>{
    return (0, _compilerCore.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers, context, dir.loc);
        if (nonKeyModifiers.includes("right")) key = transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes("middle")) key = transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, _compilerCore.createCallExpression)(context.helper(V_ON_WITH_MODIFIERS), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, _compilerCore.isStaticExp)(key) || isKeyboardEvent(key.content.toLowerCase()))) handlerExp = (0, _compilerCore.createCallExpression)(context.helper(V_ON_WITH_KEYS), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, _shared.capitalize)).join("");
            key = (0, _compilerCore.isStaticExp)(key) ? (0, _compilerCore.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, _compilerCore.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, _compilerCore.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const transformShow = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(62, loc));
    return {
        props: [],
        needRuntime: context.helper(V_SHOW)
    };
};
const transformTransition = (node, context)=>{
    if (node.type === 1 && node.tagType === 1) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === TRANSITION) return ()=>{
            if (!node.children.length) return;
            if (hasMultipleChildren(node)) context.onError(createDOMCompilerError(63, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
            }));
            const child = node.children[0];
            if (child.type === 1) {
                for (const p of child.props)if (p.type === 7 && p.name === "show") node.props.push({
                    type: 6,
                    name: "persisted",
                    nameLoc: node.loc,
                    value: void 0,
                    loc: node.loc
                });
            }
        };
    }
};
function hasMultipleChildren(node) {
    const children = node.children = node.children.filter((c)=>!(0, _compilerCore.isCommentOrWhitespace)(c));
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some(hasMultipleChildren);
}
const ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) context.removeNode();
};
function isValidHTMLNesting(parent, child) {
    if (parent === "template") return true;
    if (parent in onlyValidChildren) return onlyValidChildren[parent].has(child);
    if (child in onlyValidParents) return onlyValidParents[child].has(parent);
    if (parent in knownInvalidChildren) {
        if (knownInvalidChildren[parent].has(child)) return false;
    }
    if (child in knownInvalidParents) {
        if (knownInvalidParents[child].has(parent)) return false;
    }
    return true;
}
const headings = /* @__PURE__ */ new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
const emptySet = /* @__PURE__ */ new Set([]);
const onlyValidChildren = {
    head: /* @__PURE__ */ new Set([
        "base",
        "basefront",
        "bgsound",
        "link",
        "meta",
        "title",
        "noscript",
        "noframes",
        "style",
        "script",
        "template"
    ]),
    optgroup: /* @__PURE__ */ new Set([
        "option"
    ]),
    select: /* @__PURE__ */ new Set([
        "optgroup",
        "option",
        "hr"
    ]),
    // table
    table: /* @__PURE__ */ new Set([
        "caption",
        "colgroup",
        "tbody",
        "tfoot",
        "thead"
    ]),
    tr: /* @__PURE__ */ new Set([
        "td",
        "th"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "col"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "tr"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "tr"
    ]),
    // these elements can not have any children elements
    script: emptySet,
    iframe: emptySet,
    option: emptySet,
    textarea: emptySet,
    style: emptySet,
    title: emptySet
};
const onlyValidParents = {
    // sections
    html: emptySet,
    body: /* @__PURE__ */ new Set([
        "html"
    ]),
    head: /* @__PURE__ */ new Set([
        "html"
    ]),
    // table
    td: /* @__PURE__ */ new Set([
        "tr"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "table"
    ]),
    caption: /* @__PURE__ */ new Set([
        "table"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "table"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "table"
    ]),
    col: /* @__PURE__ */ new Set([
        "colgroup"
    ]),
    th: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "table"
    ]),
    tr: /* @__PURE__ */ new Set([
        "tbody",
        "thead",
        "tfoot"
    ]),
    // data list
    dd: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    // other
    figcaption: /* @__PURE__ */ new Set([
        "figure"
    ]),
    // li: new Set(["ul", "ol"]),
    summary: /* @__PURE__ */ new Set([
        "details"
    ]),
    area: /* @__PURE__ */ new Set([
        "map"
    ])
};
const knownInvalidChildren = {
    p: /* @__PURE__ */ new Set([
        "address",
        "article",
        "aside",
        "blockquote",
        "center",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "fieldset",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "menu",
        "ol",
        "p",
        "pre",
        "section",
        "table",
        "ul"
    ]),
    svg: /* @__PURE__ */ new Set([
        "b",
        "blockquote",
        "br",
        "code",
        "dd",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        "li",
        "menu",
        "meta",
        "ol",
        "p",
        "pre",
        "ruby",
        "s",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "table",
        "u",
        "ul",
        "var"
    ])
};
const knownInvalidParents = {
    a: /* @__PURE__ */ new Set([
        "a"
    ]),
    button: /* @__PURE__ */ new Set([
        "button"
    ]),
    dd: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    form: /* @__PURE__ */ new Set([
        "form"
    ]),
    li: /* @__PURE__ */ new Set([
        "li"
    ]),
    h1: headings,
    h2: headings,
    h3: headings,
    h4: headings,
    h5: headings,
    h6: headings
};
const validateHtmlNesting = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !isValidHTMLNesting(context.parent.tag, node.tag)) {
        const error = new SyntaxError(`<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`);
        error.loc = node.loc;
        context.onWarn(error);
    }
};
const DOMNodeTransforms = [
    transformStyle
];
const DOMDirectiveTransforms = {
    cloak: (0, _compilerCore.noopDirectiveTransform),
    html: transformVHtml,
    text: transformVText,
    model: transformModel,
    // override compiler-core
    on: transformOn,
    // override compiler-core
    show: transformShow
};
function compile(src, options = {}) {
    return (0, _compilerCore.baseCompile)(src, (0, _shared.extend)({}, parserOptions, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            ignoreSideEffectTags,
            ...DOMNodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, _shared.extend)({}, DOMDirectiveTransforms, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function parse(template, options = {}) {
    return (0, _compilerCore.baseParse)(template, (0, _shared.extend)({}, parserOptions, options));
}

},{"@vue/compiler-core":"5HVqU","@vue/shared":"jjpTC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"5HVqU":[function(require,module,exports) {
/**
* @vue/compiler-core v3.5.34
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCodeFrame", ()=>(0, _shared.generateCodeFrame));
parcelHelpers.export(exports, "BASE_TRANSITION", ()=>BASE_TRANSITION);
parcelHelpers.export(exports, "BindingTypes", ()=>BindingTypes);
parcelHelpers.export(exports, "CAMELIZE", ()=>CAMELIZE);
parcelHelpers.export(exports, "CAPITALIZE", ()=>CAPITALIZE);
parcelHelpers.export(exports, "CREATE_BLOCK", ()=>CREATE_BLOCK);
parcelHelpers.export(exports, "CREATE_COMMENT", ()=>CREATE_COMMENT);
parcelHelpers.export(exports, "CREATE_ELEMENT_BLOCK", ()=>CREATE_ELEMENT_BLOCK);
parcelHelpers.export(exports, "CREATE_ELEMENT_VNODE", ()=>CREATE_ELEMENT_VNODE);
parcelHelpers.export(exports, "CREATE_SLOTS", ()=>CREATE_SLOTS);
parcelHelpers.export(exports, "CREATE_STATIC", ()=>CREATE_STATIC);
parcelHelpers.export(exports, "CREATE_TEXT", ()=>CREATE_TEXT);
parcelHelpers.export(exports, "CREATE_VNODE", ()=>CREATE_VNODE);
parcelHelpers.export(exports, "CompilerDeprecationTypes", ()=>CompilerDeprecationTypes);
parcelHelpers.export(exports, "ConstantTypes", ()=>ConstantTypes);
parcelHelpers.export(exports, "ElementTypes", ()=>ElementTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "FRAGMENT", ()=>FRAGMENT);
parcelHelpers.export(exports, "GUARD_REACTIVE_PROPS", ()=>GUARD_REACTIVE_PROPS);
parcelHelpers.export(exports, "IS_MEMO_SAME", ()=>IS_MEMO_SAME);
parcelHelpers.export(exports, "IS_REF", ()=>IS_REF);
parcelHelpers.export(exports, "KEEP_ALIVE", ()=>KEEP_ALIVE);
parcelHelpers.export(exports, "MERGE_PROPS", ()=>MERGE_PROPS);
parcelHelpers.export(exports, "NORMALIZE_CLASS", ()=>NORMALIZE_CLASS);
parcelHelpers.export(exports, "NORMALIZE_PROPS", ()=>NORMALIZE_PROPS);
parcelHelpers.export(exports, "NORMALIZE_STYLE", ()=>NORMALIZE_STYLE);
parcelHelpers.export(exports, "Namespaces", ()=>Namespaces);
parcelHelpers.export(exports, "NodeTypes", ()=>NodeTypes);
parcelHelpers.export(exports, "OPEN_BLOCK", ()=>OPEN_BLOCK);
parcelHelpers.export(exports, "POP_SCOPE_ID", ()=>POP_SCOPE_ID);
parcelHelpers.export(exports, "PUSH_SCOPE_ID", ()=>PUSH_SCOPE_ID);
parcelHelpers.export(exports, "RENDER_LIST", ()=>RENDER_LIST);
parcelHelpers.export(exports, "RENDER_SLOT", ()=>RENDER_SLOT);
parcelHelpers.export(exports, "RESOLVE_COMPONENT", ()=>RESOLVE_COMPONENT);
parcelHelpers.export(exports, "RESOLVE_DIRECTIVE", ()=>RESOLVE_DIRECTIVE);
parcelHelpers.export(exports, "RESOLVE_DYNAMIC_COMPONENT", ()=>RESOLVE_DYNAMIC_COMPONENT);
parcelHelpers.export(exports, "RESOLVE_FILTER", ()=>RESOLVE_FILTER);
parcelHelpers.export(exports, "SET_BLOCK_TRACKING", ()=>SET_BLOCK_TRACKING);
parcelHelpers.export(exports, "SUSPENSE", ()=>SUSPENSE);
parcelHelpers.export(exports, "TELEPORT", ()=>TELEPORT);
parcelHelpers.export(exports, "TO_DISPLAY_STRING", ()=>TO_DISPLAY_STRING);
parcelHelpers.export(exports, "TO_HANDLERS", ()=>TO_HANDLERS);
parcelHelpers.export(exports, "TO_HANDLER_KEY", ()=>TO_HANDLER_KEY);
parcelHelpers.export(exports, "TS_NODE_TYPES", ()=>TS_NODE_TYPES);
parcelHelpers.export(exports, "UNREF", ()=>UNREF);
parcelHelpers.export(exports, "WITH_CTX", ()=>WITH_CTX);
parcelHelpers.export(exports, "WITH_DIRECTIVES", ()=>WITH_DIRECTIVES);
parcelHelpers.export(exports, "WITH_MEMO", ()=>WITH_MEMO);
parcelHelpers.export(exports, "advancePositionWithClone", ()=>advancePositionWithClone);
parcelHelpers.export(exports, "advancePositionWithMutation", ()=>advancePositionWithMutation);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "baseCompile", ()=>baseCompile);
parcelHelpers.export(exports, "baseParse", ()=>baseParse);
parcelHelpers.export(exports, "buildDirectiveArgs", ()=>buildDirectiveArgs);
parcelHelpers.export(exports, "buildProps", ()=>buildProps);
parcelHelpers.export(exports, "buildSlots", ()=>buildSlots);
parcelHelpers.export(exports, "checkCompatEnabled", ()=>checkCompatEnabled);
parcelHelpers.export(exports, "convertToBlock", ()=>convertToBlock);
parcelHelpers.export(exports, "createArrayExpression", ()=>createArrayExpression);
parcelHelpers.export(exports, "createAssignmentExpression", ()=>createAssignmentExpression);
parcelHelpers.export(exports, "createBlockStatement", ()=>createBlockStatement);
parcelHelpers.export(exports, "createCacheExpression", ()=>createCacheExpression);
parcelHelpers.export(exports, "createCallExpression", ()=>createCallExpression);
parcelHelpers.export(exports, "createCompilerError", ()=>createCompilerError);
parcelHelpers.export(exports, "createCompoundExpression", ()=>createCompoundExpression);
parcelHelpers.export(exports, "createConditionalExpression", ()=>createConditionalExpression);
parcelHelpers.export(exports, "createForLoopParams", ()=>createForLoopParams);
parcelHelpers.export(exports, "createFunctionExpression", ()=>createFunctionExpression);
parcelHelpers.export(exports, "createIfStatement", ()=>createIfStatement);
parcelHelpers.export(exports, "createInterpolation", ()=>createInterpolation);
parcelHelpers.export(exports, "createObjectExpression", ()=>createObjectExpression);
parcelHelpers.export(exports, "createObjectProperty", ()=>createObjectProperty);
parcelHelpers.export(exports, "createReturnStatement", ()=>createReturnStatement);
parcelHelpers.export(exports, "createRoot", ()=>createRoot);
parcelHelpers.export(exports, "createSequenceExpression", ()=>createSequenceExpression);
parcelHelpers.export(exports, "createSimpleExpression", ()=>createSimpleExpression);
parcelHelpers.export(exports, "createStructuralDirectiveTransform", ()=>createStructuralDirectiveTransform);
parcelHelpers.export(exports, "createTemplateLiteral", ()=>createTemplateLiteral);
parcelHelpers.export(exports, "createTransformContext", ()=>createTransformContext);
parcelHelpers.export(exports, "createVNodeCall", ()=>createVNodeCall);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
parcelHelpers.export(exports, "extractIdentifiers", ()=>extractIdentifiers);
parcelHelpers.export(exports, "findDir", ()=>findDir);
parcelHelpers.export(exports, "findProp", ()=>findProp);
parcelHelpers.export(exports, "forAliasRE", ()=>forAliasRE);
parcelHelpers.export(exports, "generate", ()=>generate);
parcelHelpers.export(exports, "getBaseTransformPreset", ()=>getBaseTransformPreset);
parcelHelpers.export(exports, "getConstantType", ()=>getConstantType);
parcelHelpers.export(exports, "getMemoedVNodeCall", ()=>getMemoedVNodeCall);
parcelHelpers.export(exports, "getVNodeBlockHelper", ()=>getVNodeBlockHelper);
parcelHelpers.export(exports, "getVNodeHelper", ()=>getVNodeHelper);
parcelHelpers.export(exports, "hasDynamicKeyVBind", ()=>hasDynamicKeyVBind);
parcelHelpers.export(exports, "hasScopeRef", ()=>hasScopeRef);
parcelHelpers.export(exports, "helperNameMap", ()=>helperNameMap);
parcelHelpers.export(exports, "injectProp", ()=>injectProp);
parcelHelpers.export(exports, "isAllWhitespace", ()=>isAllWhitespace);
parcelHelpers.export(exports, "isCommentOrWhitespace", ()=>isCommentOrWhitespace);
parcelHelpers.export(exports, "isCoreComponent", ()=>isCoreComponent);
parcelHelpers.export(exports, "isFnExpression", ()=>isFnExpression);
parcelHelpers.export(exports, "isFnExpressionBrowser", ()=>isFnExpressionBrowser);
parcelHelpers.export(exports, "isFnExpressionNode", ()=>isFnExpressionNode);
parcelHelpers.export(exports, "isFunctionType", ()=>isFunctionType);
parcelHelpers.export(exports, "isInDestructureAssignment", ()=>isInDestructureAssignment);
parcelHelpers.export(exports, "isInNewExpression", ()=>isInNewExpression);
parcelHelpers.export(exports, "isMemberExpression", ()=>isMemberExpression);
parcelHelpers.export(exports, "isMemberExpressionBrowser", ()=>isMemberExpressionBrowser);
parcelHelpers.export(exports, "isMemberExpressionNode", ()=>isMemberExpressionNode);
parcelHelpers.export(exports, "isReferencedIdentifier", ()=>isReferencedIdentifier);
parcelHelpers.export(exports, "isSimpleIdentifier", ()=>isSimpleIdentifier);
parcelHelpers.export(exports, "isSlotOutlet", ()=>isSlotOutlet);
parcelHelpers.export(exports, "isStaticArgOf", ()=>isStaticArgOf);
parcelHelpers.export(exports, "isStaticExp", ()=>isStaticExp);
parcelHelpers.export(exports, "isStaticProperty", ()=>isStaticProperty);
parcelHelpers.export(exports, "isStaticPropertyKey", ()=>isStaticPropertyKey);
parcelHelpers.export(exports, "isTemplateNode", ()=>isTemplateNode);
parcelHelpers.export(exports, "isText", ()=>isText$1);
parcelHelpers.export(exports, "isVPre", ()=>isVPre);
parcelHelpers.export(exports, "isVSlot", ()=>isVSlot);
parcelHelpers.export(exports, "isWhitespaceText", ()=>isWhitespaceText);
parcelHelpers.export(exports, "locStub", ()=>locStub);
parcelHelpers.export(exports, "noopDirectiveTransform", ()=>noopDirectiveTransform);
parcelHelpers.export(exports, "processExpression", ()=>processExpression);
parcelHelpers.export(exports, "processFor", ()=>processFor);
parcelHelpers.export(exports, "processIf", ()=>processIf);
parcelHelpers.export(exports, "processSlotOutlet", ()=>processSlotOutlet);
parcelHelpers.export(exports, "registerRuntimeHelpers", ()=>registerRuntimeHelpers);
parcelHelpers.export(exports, "resolveComponentType", ()=>resolveComponentType);
parcelHelpers.export(exports, "stringifyExpression", ()=>stringifyExpression);
parcelHelpers.export(exports, "toValidAssetId", ()=>toValidAssetId);
parcelHelpers.export(exports, "trackSlotScopes", ()=>trackSlotScopes);
parcelHelpers.export(exports, "trackVForSlotScopes", ()=>trackVForSlotScopes);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "transformBind", ()=>transformBind);
parcelHelpers.export(exports, "transformElement", ()=>transformElement);
parcelHelpers.export(exports, "transformExpression", ()=>transformExpression);
parcelHelpers.export(exports, "transformModel", ()=>transformModel);
parcelHelpers.export(exports, "transformOn", ()=>transformOn);
parcelHelpers.export(exports, "transformVBindShorthand", ()=>transformVBindShorthand);
parcelHelpers.export(exports, "traverseNode", ()=>traverseNode);
parcelHelpers.export(exports, "unwrapTSNode", ()=>unwrapTSNode);
parcelHelpers.export(exports, "validFirstIdentCharRE", ()=>validFirstIdentCharRE);
parcelHelpers.export(exports, "walkBlockDeclarations", ()=>walkBlockDeclarations);
parcelHelpers.export(exports, "walkFunctionParams", ()=>walkFunctionParams);
parcelHelpers.export(exports, "walkIdentifiers", ()=>walkIdentifiers);
parcelHelpers.export(exports, "warnDeprecation", ()=>warnDeprecation);
var _shared = require("@vue/shared");
const FRAGMENT = /* @__PURE__ */ Symbol(``);
const TELEPORT = /* @__PURE__ */ Symbol(``);
const SUSPENSE = /* @__PURE__ */ Symbol(``);
const KEEP_ALIVE = /* @__PURE__ */ Symbol(``);
const BASE_TRANSITION = /* @__PURE__ */ Symbol(``);
const OPEN_BLOCK = /* @__PURE__ */ Symbol(``);
const CREATE_BLOCK = /* @__PURE__ */ Symbol(``);
const CREATE_ELEMENT_BLOCK = /* @__PURE__ */ Symbol(``);
const CREATE_VNODE = /* @__PURE__ */ Symbol(``);
const CREATE_ELEMENT_VNODE = /* @__PURE__ */ Symbol(``);
const CREATE_COMMENT = /* @__PURE__ */ Symbol(``);
const CREATE_TEXT = /* @__PURE__ */ Symbol(``);
const CREATE_STATIC = /* @__PURE__ */ Symbol(``);
const RESOLVE_COMPONENT = /* @__PURE__ */ Symbol(``);
const RESOLVE_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol(``);
const RESOLVE_DIRECTIVE = /* @__PURE__ */ Symbol(``);
const RESOLVE_FILTER = /* @__PURE__ */ Symbol(``);
const WITH_DIRECTIVES = /* @__PURE__ */ Symbol(``);
const RENDER_LIST = /* @__PURE__ */ Symbol(``);
const RENDER_SLOT = /* @__PURE__ */ Symbol(``);
const CREATE_SLOTS = /* @__PURE__ */ Symbol(``);
const TO_DISPLAY_STRING = /* @__PURE__ */ Symbol(``);
const MERGE_PROPS = /* @__PURE__ */ Symbol(``);
const NORMALIZE_CLASS = /* @__PURE__ */ Symbol(``);
const NORMALIZE_STYLE = /* @__PURE__ */ Symbol(``);
const NORMALIZE_PROPS = /* @__PURE__ */ Symbol(``);
const GUARD_REACTIVE_PROPS = /* @__PURE__ */ Symbol(``);
const TO_HANDLERS = /* @__PURE__ */ Symbol(``);
const CAMELIZE = /* @__PURE__ */ Symbol(``);
const CAPITALIZE = /* @__PURE__ */ Symbol(``);
const TO_HANDLER_KEY = /* @__PURE__ */ Symbol(``);
const SET_BLOCK_TRACKING = /* @__PURE__ */ Symbol(``);
const PUSH_SCOPE_ID = /* @__PURE__ */ Symbol(``);
const POP_SCOPE_ID = /* @__PURE__ */ Symbol(``);
const WITH_CTX = /* @__PURE__ */ Symbol(``);
const UNREF = /* @__PURE__ */ Symbol(``);
const IS_REF = /* @__PURE__ */ Symbol(``);
const WITH_MEMO = /* @__PURE__ */ Symbol(``);
const IS_MEMO_SAME = /* @__PURE__ */ Symbol(``);
const helperNameMap = {
    [FRAGMENT]: `Fragment`,
    [TELEPORT]: `Teleport`,
    [SUSPENSE]: `Suspense`,
    [KEEP_ALIVE]: `KeepAlive`,
    [BASE_TRANSITION]: `BaseTransition`,
    [OPEN_BLOCK]: `openBlock`,
    [CREATE_BLOCK]: `createBlock`,
    [CREATE_ELEMENT_BLOCK]: `createElementBlock`,
    [CREATE_VNODE]: `createVNode`,
    [CREATE_ELEMENT_VNODE]: `createElementVNode`,
    [CREATE_COMMENT]: `createCommentVNode`,
    [CREATE_TEXT]: `createTextVNode`,
    [CREATE_STATIC]: `createStaticVNode`,
    [RESOLVE_COMPONENT]: `resolveComponent`,
    [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
    [RESOLVE_DIRECTIVE]: `resolveDirective`,
    [RESOLVE_FILTER]: `resolveFilter`,
    [WITH_DIRECTIVES]: `withDirectives`,
    [RENDER_LIST]: `renderList`,
    [RENDER_SLOT]: `renderSlot`,
    [CREATE_SLOTS]: `createSlots`,
    [TO_DISPLAY_STRING]: `toDisplayString`,
    [MERGE_PROPS]: `mergeProps`,
    [NORMALIZE_CLASS]: `normalizeClass`,
    [NORMALIZE_STYLE]: `normalizeStyle`,
    [NORMALIZE_PROPS]: `normalizeProps`,
    [GUARD_REACTIVE_PROPS]: `guardReactiveProps`,
    [TO_HANDLERS]: `toHandlers`,
    [CAMELIZE]: `camelize`,
    [CAPITALIZE]: `capitalize`,
    [TO_HANDLER_KEY]: `toHandlerKey`,
    [SET_BLOCK_TRACKING]: `setBlockTracking`,
    [PUSH_SCOPE_ID]: `pushScopeId`,
    [POP_SCOPE_ID]: `popScopeId`,
    [WITH_CTX]: `withCtx`,
    [UNREF]: `unref`,
    [IS_REF]: `isRef`,
    [WITH_MEMO]: `withMemo`,
    [IS_MEMO_SAME]: `isMemoSame`
};
function registerRuntimeHelpers(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        helperNameMap[s] = helpers[s];
    });
}
const Namespaces = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
const NodeTypes = {
    "ROOT": 0,
    "0": "ROOT",
    "ELEMENT": 1,
    "1": "ELEMENT",
    "TEXT": 2,
    "2": "TEXT",
    "COMMENT": 3,
    "3": "COMMENT",
    "SIMPLE_EXPRESSION": 4,
    "4": "SIMPLE_EXPRESSION",
    "INTERPOLATION": 5,
    "5": "INTERPOLATION",
    "ATTRIBUTE": 6,
    "6": "ATTRIBUTE",
    "DIRECTIVE": 7,
    "7": "DIRECTIVE",
    "COMPOUND_EXPRESSION": 8,
    "8": "COMPOUND_EXPRESSION",
    "IF": 9,
    "9": "IF",
    "IF_BRANCH": 10,
    "10": "IF_BRANCH",
    "FOR": 11,
    "11": "FOR",
    "TEXT_CALL": 12,
    "12": "TEXT_CALL",
    "VNODE_CALL": 13,
    "13": "VNODE_CALL",
    "JS_CALL_EXPRESSION": 14,
    "14": "JS_CALL_EXPRESSION",
    "JS_OBJECT_EXPRESSION": 15,
    "15": "JS_OBJECT_EXPRESSION",
    "JS_PROPERTY": 16,
    "16": "JS_PROPERTY",
    "JS_ARRAY_EXPRESSION": 17,
    "17": "JS_ARRAY_EXPRESSION",
    "JS_FUNCTION_EXPRESSION": 18,
    "18": "JS_FUNCTION_EXPRESSION",
    "JS_CONDITIONAL_EXPRESSION": 19,
    "19": "JS_CONDITIONAL_EXPRESSION",
    "JS_CACHE_EXPRESSION": 20,
    "20": "JS_CACHE_EXPRESSION",
    "JS_BLOCK_STATEMENT": 21,
    "21": "JS_BLOCK_STATEMENT",
    "JS_TEMPLATE_LITERAL": 22,
    "22": "JS_TEMPLATE_LITERAL",
    "JS_IF_STATEMENT": 23,
    "23": "JS_IF_STATEMENT",
    "JS_ASSIGNMENT_EXPRESSION": 24,
    "24": "JS_ASSIGNMENT_EXPRESSION",
    "JS_SEQUENCE_EXPRESSION": 25,
    "25": "JS_SEQUENCE_EXPRESSION",
    "JS_RETURN_STATEMENT": 26,
    "26": "JS_RETURN_STATEMENT"
};
const ElementTypes = {
    "ELEMENT": 0,
    "0": "ELEMENT",
    "COMPONENT": 1,
    "1": "COMPONENT",
    "SLOT": 2,
    "2": "SLOT",
    "TEMPLATE": 3,
    "3": "TEMPLATE"
};
const ConstantTypes = {
    "NOT_CONSTANT": 0,
    "0": "NOT_CONSTANT",
    "CAN_SKIP_PATCH": 1,
    "1": "CAN_SKIP_PATCH",
    "CAN_CACHE": 2,
    "2": "CAN_CACHE",
    "CAN_STRINGIFY": 3,
    "3": "CAN_STRINGIFY"
};
const locStub = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function createRoot(children, source = "") {
    return {
        type: 0,
        source,
        children,
        helpers: /* @__PURE__ */ new Set(),
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: [],
        temps: 0,
        codegenNode: void 0,
        loc: locStub
    };
}
function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = locStub) {
    if (context) {
        if (isBlock) {
            context.helper(OPEN_BLOCK);
            context.helper(getVNodeBlockHelper(context.inSSR, isComponent));
        } else context.helper(getVNodeHelper(context.inSSR, isComponent));
        if (directives) context.helper(WITH_DIRECTIVES);
    }
    return {
        type: 13,
        tag,
        props,
        children,
        patchFlag,
        dynamicProps,
        directives,
        isBlock,
        disableTracking,
        isComponent,
        loc
    };
}
function createArrayExpression(elements, loc = locStub) {
    return {
        type: 17,
        loc,
        elements
    };
}
function createObjectExpression(properties, loc = locStub) {
    return {
        type: 15,
        loc,
        properties
    };
}
function createObjectProperty(key, value) {
    return {
        type: 16,
        loc: locStub,
        key: (0, _shared.isString)(key) ? createSimpleExpression(key, true) : key,
        value
    };
}
function createSimpleExpression(content, isStatic = false, loc = locStub, constType = 0) {
    return {
        type: 4,
        loc,
        content,
        isStatic,
        constType: isStatic ? 3 : constType
    };
}
function createInterpolation(content, loc) {
    return {
        type: 5,
        loc,
        content: (0, _shared.isString)(content) ? createSimpleExpression(content, false, loc) : content
    };
}
function createCompoundExpression(children, loc = locStub) {
    return {
        type: 8,
        loc,
        children
    };
}
function createCallExpression(callee, args = [], loc = locStub) {
    return {
        type: 14,
        loc,
        callee,
        arguments: args
    };
}
function createFunctionExpression(params, returns, newline = false, isSlot = false, loc = locStub) {
    return {
        type: 18,
        params,
        returns,
        newline,
        isSlot,
        loc
    };
}
function createConditionalExpression(test, consequent, alternate, newline = true) {
    return {
        type: 19,
        test,
        consequent,
        alternate,
        newline,
        loc: locStub
    };
}
function createCacheExpression(index, value, needPauseTracking = false, inVOnce = false) {
    return {
        type: 20,
        index,
        value,
        needPauseTracking,
        inVOnce,
        needArraySpread: false,
        loc: locStub
    };
}
function createBlockStatement(body) {
    return {
        type: 21,
        body,
        loc: locStub
    };
}
function createTemplateLiteral(elements) {
    return {
        type: 22,
        elements,
        loc: locStub
    };
}
function createIfStatement(test, consequent, alternate) {
    return {
        type: 23,
        test,
        consequent,
        alternate,
        loc: locStub
    };
}
function createAssignmentExpression(left, right) {
    return {
        type: 24,
        left,
        right,
        loc: locStub
    };
}
function createSequenceExpression(expressions) {
    return {
        type: 25,
        expressions,
        loc: locStub
    };
}
function createReturnStatement(returns) {
    return {
        type: 26,
        returns,
        loc: locStub
    };
}
function getVNodeHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_VNODE : CREATE_ELEMENT_VNODE;
}
function getVNodeBlockHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_BLOCK : CREATE_ELEMENT_BLOCK;
}
function convertToBlock(node, { helper, removeHelper, inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper(getVNodeHelper(inSSR, node.isComponent));
        helper(OPEN_BLOCK);
        helper(getVNodeBlockHelper(inSSR, node.isComponent));
    }
}
const defaultDelimitersOpen = new Uint8Array([
    123,
    123
]);
const defaultDelimitersClose = new Uint8Array([
    125,
    125
]);
function isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
}
function isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
}
function isEndOfTagSection(c) {
    return c === 47 || c === 62 || isWhitespace(c);
}
function toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)ret[i] = str.charCodeAt(i);
    return ret;
}
const Sequences = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    // CDATA[
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    // ]]>
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    // `-->`
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    // `<\/script`
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    // `</style`
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    // `</title`
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
class Tokenizer {
    constructor(stack, cbs){
        this.stack = stack;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = 1;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1;
        /** For special parsing behavior inside of script and style tags. */ this.inRCDATA = false;
        /** For disabling RCDATA tags handling */ this.inXML = false;
        /** For disabling interpolation parsing in v-pre */ this.inVPre = false;
        /** Record newline positions for fast line / column calculation */ this.newlines = [];
        this.mode = 0;
        this.delimiterOpen = defaultDelimitersOpen;
        this.delimiterClose = defaultDelimitersClose;
        this.delimiterIndex = -1;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
        this.state = 1;
        this.mode = 0;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = 1;
        this.inRCDATA = false;
        this.currentSequence = void 0;
        this.newlines.length = 0;
        this.delimiterOpen = defaultDelimitersOpen;
        this.delimiterClose = defaultDelimitersClose;
    }
    /**
   * Generate Position object with line / column information using recorded
   * newline positions. We know the index is always going to be an already
   * processed index, so all the newlines up to this index should have been
   * recorded.
   */ getPos(index) {
        let line = 1;
        let column = index + 1;
        const length = this.newlines.length;
        let j = -1;
        if (length > 100) {
            let l = -1;
            let r = length;
            while(l + 1 < r){
                const m = l + r >>> 1;
                this.newlines[m] < index ? l = m : r = m;
            }
            j = l;
        } else {
            for(let i = length - 1; i >= 0; i--)if (index > this.newlines[i]) {
                j = i;
                break;
            }
        }
        if (j >= 0) {
            line = j + 2;
            column = index - this.newlines[j];
        }
        return {
            column,
            line,
            offset: index
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
        if (c === 60) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
        }
    }
    stateInterpolationOpen(c) {
        if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                const start = this.index + 1 - this.delimiterOpen.length;
                if (start > this.sectionStart) this.cbs.ontext(this.sectionStart, start);
                this.state = 3;
                this.sectionStart = start;
            } else this.delimiterIndex++;
        } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
        } else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInterpolation(c) {
        if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
        }
    }
    stateInterpolationClose(c) {
        if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
                this.cbs.oninterpolation(this.sectionStart, this.index + 1);
                if (this.inRCDATA) this.state = 32;
                else this.state = 1;
                this.sectionStart = this.index + 1;
            } else this.delimiterIndex++;
        } else {
            this.state = 3;
            this.stateInterpolation(c);
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
        isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.inRCDATA = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = 6;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */ stateInRCDATA(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                this.inRCDATA = false;
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd || this.currentSequence === Sequences.TextareaEnd && !this.inSFCRoot) {
                if (!this.inVPre && c === this.delimiterOpen[0]) {
                    this.state = 2;
                    this.delimiterIndex = 0;
                    this.stateInterpolationOpen(c);
                }
            } else if (this.fastForwardTo(60)) this.sequenceIndex = 1;
        } else this.sequenceIndex = Number(c === 60);
    }
    stateCDATASequence(c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this.state = 28;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
        }
    }
    /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */ fastForwardTo(c) {
        while(++this.index < this.buffer.length){
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) this.newlines.push(this.index);
            if (cc === c) return true;
        }
        this.index = this.buffer.length - 1;
        return false;
    }
    /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index - 2);
                else this.cbs.oncomment(this.sectionStart, this.index - 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = 1;
            }
        } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) this.sequenceIndex = 0;
    }
    startSpecial(sequence, offset) {
        this.enterRCDATA(sequence, offset);
        this.state = 31;
    }
    enterRCDATA(sequence, offset) {
        this.inRCDATA = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
        if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
        } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
        } else if (isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) this.state = 6;
            else if (this.inSFCRoot) this.state = 34;
            else if (!this.inXML) {
                if (c === 116) this.state = 30;
                else this.state = c === 115 ? 29 : 6;
            } else this.state = 6;
        } else if (c === 47) this.state = 8;
        else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if (isEndOfTagSection(c)) this.handleTagName(c);
    }
    stateInSFCRootTagName(c) {
        if (isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") this.enterRCDATA(toCharCodes(`</` + tag), 0);
            this.handleTagName(c);
        }
    }
    handleTagName(c) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
        if (isWhitespace(c)) ;
        else if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        } else {
            this.state = isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === 62 || isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttrName(c) {
        if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) this.state = 32;
            else this.state = 1;
            this.sectionStart = this.index + 1;
        } else if (c === 47) this.state = 7;
        else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!isWhitespace(c)) this.handleAttrStart(c);
    }
    handleAttrStart(c) {
        if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
        } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else {
            this.state = 12;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
        } else if (!isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
        }
    }
    stateInAttrName(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirName(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDirArg(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 91) this.state = 15;
        else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDynamicDirArg(c) {
        if (c === 93) this.state = 14;
        else if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirModifier(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
        }
    }
    handleAttrNameEnd(c) {
        this.sectionStart = this.index;
        this.state = 17;
        this.cbs.onattribnameend(this.index);
        this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
        if (c === 61) this.state = 18;
        else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (!isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
        }
    }
    stateBeforeAttrValue(c) {
        if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
        } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
        } else if (!isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
        }
    }
    handleInAttrValue(c, quote) {
        if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === 34 ? 3 : 2, this.index + 1);
            this.state = 11;
        }
    }
    stateInAttrValueDoubleQuotes(c) {
        this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
        this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
        if (isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (c === 39 || c === 60 || c === 61 || c === 96) this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(c) {
        if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
        } else this.state = c === 45 ? 25 : 23;
    }
    stateInDeclaration(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === 45) {
            this.state = 28;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = 23;
    }
    stateInSpecialComment(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        if (c === Sequences.ScriptEnd[3]) this.startSpecial(Sequences.ScriptEnd, 4);
        else if (c === Sequences.StyleEnd[3]) this.startSpecial(Sequences.StyleEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    stateBeforeSpecialT(c) {
        if (c === Sequences.TitleEnd[3]) this.startSpecial(Sequences.TitleEnd, 4);
        else if (c === Sequences.TextareaEnd[3]) this.startSpecial(Sequences.TextareaEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    startEntity() {}
    stateInEntity() {}
    /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */ parse(input) {
        this.buffer = input;
        while(this.index < this.buffer.length){
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10 && this.state !== 33) this.newlines.push(this.index);
            switch(this.state){
                case 1:
                    this.stateText(c);
                    break;
                case 2:
                    this.stateInterpolationOpen(c);
                    break;
                case 3:
                    this.stateInterpolation(c);
                    break;
                case 4:
                    this.stateInterpolationClose(c);
                    break;
                case 31:
                    this.stateSpecialStartSequence(c);
                    break;
                case 32:
                    this.stateInRCDATA(c);
                    break;
                case 26:
                    this.stateCDATASequence(c);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(c);
                    break;
                case 12:
                    this.stateInAttrName(c);
                    break;
                case 13:
                    this.stateInDirName(c);
                    break;
                case 14:
                    this.stateInDirArg(c);
                    break;
                case 15:
                    this.stateInDynamicDirArg(c);
                    break;
                case 16:
                    this.stateInDirModifier(c);
                    break;
                case 28:
                    this.stateInCommentLike(c);
                    break;
                case 27:
                    this.stateInSpecialComment(c);
                    break;
                case 11:
                    this.stateBeforeAttrName(c);
                    break;
                case 6:
                    this.stateInTagName(c);
                    break;
                case 34:
                    this.stateInSFCRootTagName(c);
                    break;
                case 9:
                    this.stateInClosingTagName(c);
                    break;
                case 5:
                    this.stateBeforeTagName(c);
                    break;
                case 17:
                    this.stateAfterAttrName(c);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(c);
                    break;
                case 18:
                    this.stateBeforeAttrValue(c);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(c);
                    break;
                case 10:
                    this.stateAfterClosingTagName(c);
                    break;
                case 29:
                    this.stateBeforeSpecialS(c);
                    break;
                case 30:
                    this.stateBeforeSpecialT(c);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(c);
                    break;
                case 7:
                    this.stateInSelfClosingTag(c);
                    break;
                case 23:
                    this.stateInDeclaration(c);
                    break;
                case 22:
                    this.stateBeforeDeclaration(c);
                    break;
                case 25:
                    this.stateBeforeComment(c);
                    break;
                case 24:
                    this.stateInProcessingInstruction(c);
                    break;
                case 33:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
        this.finish();
    }
    /**
   * Remove data that has already been consumed from the buffer.
   */ cleanup() {
        if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    finish() {
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length;
        if (this.sectionStart >= endIndex) return;
        if (this.state === 28) {
            if (this.currentSequence === Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex);
            else this.cbs.oncomment(this.sectionStart, endIndex);
        } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {}
}
const CompilerDeprecationTypes = {
    "COMPILER_IS_ON_ELEMENT": "COMPILER_IS_ON_ELEMENT",
    "COMPILER_V_BIND_SYNC": "COMPILER_V_BIND_SYNC",
    "COMPILER_V_BIND_OBJECT_ORDER": "COMPILER_V_BIND_OBJECT_ORDER",
    "COMPILER_V_ON_NATIVE": "COMPILER_V_ON_NATIVE",
    "COMPILER_V_IF_V_FOR_PRECEDENCE": "COMPILER_V_IF_V_FOR_PRECEDENCE",
    "COMPILER_NATIVE_TEMPLATE": "COMPILER_NATIVE_TEMPLATE",
    "COMPILER_INLINE_TEMPLATE": "COMPILER_INLINE_TEMPLATE",
    "COMPILER_FILTERS": "COMPILER_FILTERS"
};
const deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
        message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
        message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
        message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
        message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function getCompatValue(key, { compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") return value || 3;
    else return value;
}
function isCompatEnabled(key, context) {
    const mode = getCompatValue("MODE", context);
    const value = getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
}
function checkCompatEnabled(key, context, loc, ...args) {
    const enabled = isCompatEnabled(key, context);
    return enabled;
}
function warnDeprecation(key, context, loc, ...args) {
    const val = getCompatValue(key, context);
    if (val === "suppress-warning") return;
    const { message, link } = deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
function defaultOnError(error) {
    throw error;
}
function defaultOnWarn(msg) {}
function createCompilerError(code, loc, messages, additionalMessage) {
    const msg = `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const ErrorCodes = {
    "ABRUPT_CLOSING_OF_EMPTY_COMMENT": 0,
    "0": "ABRUPT_CLOSING_OF_EMPTY_COMMENT",
    "CDATA_IN_HTML_CONTENT": 1,
    "1": "CDATA_IN_HTML_CONTENT",
    "DUPLICATE_ATTRIBUTE": 2,
    "2": "DUPLICATE_ATTRIBUTE",
    "END_TAG_WITH_ATTRIBUTES": 3,
    "3": "END_TAG_WITH_ATTRIBUTES",
    "END_TAG_WITH_TRAILING_SOLIDUS": 4,
    "4": "END_TAG_WITH_TRAILING_SOLIDUS",
    "EOF_BEFORE_TAG_NAME": 5,
    "5": "EOF_BEFORE_TAG_NAME",
    "EOF_IN_CDATA": 6,
    "6": "EOF_IN_CDATA",
    "EOF_IN_COMMENT": 7,
    "7": "EOF_IN_COMMENT",
    "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT": 8,
    "8": "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT",
    "EOF_IN_TAG": 9,
    "9": "EOF_IN_TAG",
    "INCORRECTLY_CLOSED_COMMENT": 10,
    "10": "INCORRECTLY_CLOSED_COMMENT",
    "INCORRECTLY_OPENED_COMMENT": 11,
    "11": "INCORRECTLY_OPENED_COMMENT",
    "INVALID_FIRST_CHARACTER_OF_TAG_NAME": 12,
    "12": "INVALID_FIRST_CHARACTER_OF_TAG_NAME",
    "MISSING_ATTRIBUTE_VALUE": 13,
    "13": "MISSING_ATTRIBUTE_VALUE",
    "MISSING_END_TAG_NAME": 14,
    "14": "MISSING_END_TAG_NAME",
    "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES": 15,
    "15": "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES",
    "NESTED_COMMENT": 16,
    "16": "NESTED_COMMENT",
    "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME": 17,
    "17": "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME",
    "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE": 18,
    "18": "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE",
    "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME": 19,
    "19": "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME",
    "UNEXPECTED_NULL_CHARACTER": 20,
    "20": "UNEXPECTED_NULL_CHARACTER",
    "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME": 21,
    "21": "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME",
    "UNEXPECTED_SOLIDUS_IN_TAG": 22,
    "22": "UNEXPECTED_SOLIDUS_IN_TAG",
    "X_INVALID_END_TAG": 23,
    "23": "X_INVALID_END_TAG",
    "X_MISSING_END_TAG": 24,
    "24": "X_MISSING_END_TAG",
    "X_MISSING_INTERPOLATION_END": 25,
    "25": "X_MISSING_INTERPOLATION_END",
    "X_MISSING_DIRECTIVE_NAME": 26,
    "26": "X_MISSING_DIRECTIVE_NAME",
    "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END": 27,
    "27": "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END",
    "X_V_IF_NO_EXPRESSION": 28,
    "28": "X_V_IF_NO_EXPRESSION",
    "X_V_IF_SAME_KEY": 29,
    "29": "X_V_IF_SAME_KEY",
    "X_V_ELSE_NO_ADJACENT_IF": 30,
    "30": "X_V_ELSE_NO_ADJACENT_IF",
    "X_V_FOR_NO_EXPRESSION": 31,
    "31": "X_V_FOR_NO_EXPRESSION",
    "X_V_FOR_MALFORMED_EXPRESSION": 32,
    "32": "X_V_FOR_MALFORMED_EXPRESSION",
    "X_V_FOR_TEMPLATE_KEY_PLACEMENT": 33,
    "33": "X_V_FOR_TEMPLATE_KEY_PLACEMENT",
    "X_V_BIND_NO_EXPRESSION": 34,
    "34": "X_V_BIND_NO_EXPRESSION",
    "X_V_ON_NO_EXPRESSION": 35,
    "35": "X_V_ON_NO_EXPRESSION",
    "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET": 36,
    "36": "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET",
    "X_V_SLOT_MIXED_SLOT_USAGE": 37,
    "37": "X_V_SLOT_MIXED_SLOT_USAGE",
    "X_V_SLOT_DUPLICATE_SLOT_NAMES": 38,
    "38": "X_V_SLOT_DUPLICATE_SLOT_NAMES",
    "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN": 39,
    "39": "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN",
    "X_V_SLOT_MISPLACED": 40,
    "40": "X_V_SLOT_MISPLACED",
    "X_V_MODEL_NO_EXPRESSION": 41,
    "41": "X_V_MODEL_NO_EXPRESSION",
    "X_V_MODEL_MALFORMED_EXPRESSION": 42,
    "42": "X_V_MODEL_MALFORMED_EXPRESSION",
    "X_V_MODEL_ON_SCOPE_VARIABLE": 43,
    "43": "X_V_MODEL_ON_SCOPE_VARIABLE",
    "X_V_MODEL_ON_PROPS": 44,
    "44": "X_V_MODEL_ON_PROPS",
    "X_V_MODEL_ON_CONST": 45,
    "45": "X_V_MODEL_ON_CONST",
    "X_INVALID_EXPRESSION": 46,
    "46": "X_INVALID_EXPRESSION",
    "X_KEEP_ALIVE_INVALID_CHILDREN": 47,
    "47": "X_KEEP_ALIVE_INVALID_CHILDREN",
    "X_PREFIX_ID_NOT_SUPPORTED": 48,
    "48": "X_PREFIX_ID_NOT_SUPPORTED",
    "X_MODULE_MODE_NOT_SUPPORTED": 49,
    "49": "X_MODULE_MODE_NOT_SUPPORTED",
    "X_CACHE_HANDLER_NOT_SUPPORTED": 50,
    "50": "X_CACHE_HANDLER_NOT_SUPPORTED",
    "X_SCOPE_ID_NOT_SUPPORTED": 51,
    "51": "X_SCOPE_ID_NOT_SUPPORTED",
    "X_VNODE_HOOKS": 52,
    "52": "X_VNODE_HOOKS",
    "X_V_BIND_INVALID_SAME_NAME_ARGUMENT": 53,
    "53": "X_V_BIND_INVALID_SAME_NAME_ARGUMENT",
    "__EXTEND_POINT__": 54,
    "54": "__EXTEND_POINT__"
};
const errorMessages = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [53]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `v-model cannot be used on a const binding because it is not writable.`,
    [46]: `Error parsing JavaScript expression: `,
    [47]: `<KeepAlive> expects exactly one child component.`,
    [52]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [48]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [49]: `ES module mode is not supported in this build of compiler.`,
    [50]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [51]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [54]: ``
};
function walkIdentifiers(root, onIdentifier, includeAll = false, parentStack = [], knownIds = /* @__PURE__ */ Object.create(null)) {
    return;
}
function isReferencedIdentifier(id, parent, parentStack) {
    return false;
}
function isInDestructureAssignment(parent, parentStack) {
    if (parent && (parent.type === "ObjectProperty" || parent.type === "ArrayPattern")) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === "AssignmentExpression") return true;
            else if (p.type !== "ObjectProperty" && !p.type.endsWith("Pattern")) break;
        }
    }
    return false;
}
function isInNewExpression(parentStack) {
    let i = parentStack.length;
    while(i--){
        const p = parentStack[i];
        if (p.type === "NewExpression") return true;
        else if (p.type !== "MemberExpression") break;
    }
    return false;
}
function walkFunctionParams(node, onIdent) {
    for (const p of node.params)for (const id of extractIdentifiers(p))onIdent(id);
}
function walkBlockDeclarations(block, onIdent) {
    const body = block.type === "SwitchCase" ? block.consequent : block.body;
    for (const stmt of body){
        if (stmt.type === "VariableDeclaration") {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
        } else if (stmt.type === "FunctionDeclaration" || stmt.type === "ClassDeclaration") {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        } else if (isForStatement(stmt)) walkForStatement(stmt, true, onIdent);
        else if (stmt.type === "SwitchStatement") walkSwitchStatement(stmt, true, onIdent);
    }
}
function isForStatement(stmt) {
    return stmt.type === "ForOfStatement" || stmt.type === "ForInStatement" || stmt.type === "ForStatement";
}
function walkForStatement(stmt, isVar, onIdent) {
    const variable = stmt.type === "ForStatement" ? stmt.init : stmt.left;
    if (variable && variable.type === "VariableDeclaration" && (variable.kind === "var" ? isVar : !isVar)) {
        for (const decl of variable.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
    }
}
function walkSwitchStatement(stmt, isVar, onIdent) {
    for (const cs of stmt.cases){
        for (const stmt2 of cs.consequent)if (stmt2.type === "VariableDeclaration" && (stmt2.kind === "var" ? isVar : !isVar)) {
            for (const decl of stmt2.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
        }
        walkBlockDeclarations(cs, onIdent);
    }
}
function extractIdentifiers(param, nodes = []) {
    switch(param.type){
        case "Identifier":
            nodes.push(param);
            break;
        case "MemberExpression":
            let object = param;
            while(object.type === "MemberExpression")object = object.object;
            nodes.push(object);
            break;
        case "ObjectPattern":
            for (const prop of param.properties)if (prop.type === "RestElement") extractIdentifiers(prop.argument, nodes);
            else extractIdentifiers(prop.value, nodes);
            break;
        case "ArrayPattern":
            param.elements.forEach((element)=>{
                if (element) extractIdentifiers(element, nodes);
            });
            break;
        case "RestElement":
            extractIdentifiers(param.argument, nodes);
            break;
        case "AssignmentPattern":
            extractIdentifiers(param.left, nodes);
            break;
    }
    return nodes;
}
const isFunctionType = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const isStaticProperty = (node)=>node && (node.type === "ObjectProperty" || node.type === "ObjectMethod") && !node.computed;
const isStaticPropertyKey = (node, parent)=>isStaticProperty(parent) && parent.key === node;
const TS_NODE_TYPES = [
    "TSAsExpression",
    // foo as number
    "TSTypeAssertion",
    // (<number>foo)
    "TSNonNullExpression",
    // foo!
    "TSInstantiationExpression",
    // foo<string>
    "TSSatisfiesExpression"
];
function unwrapTSNode(node) {
    if (TS_NODE_TYPES.includes(node.type)) return unwrapTSNode(node.expression);
    else return node;
}
const isStaticExp = (p)=>p.type === 4 && p.isStatic;
function isCoreComponent(tag) {
    switch(tag){
        case "Teleport":
        case "teleport":
            return TELEPORT;
        case "Suspense":
        case "suspense":
            return SUSPENSE;
        case "KeepAlive":
        case "keep-alive":
            return KEEP_ALIVE;
        case "BaseTransition":
        case "base-transition":
            return BASE_TRANSITION;
    }
}
const nonIdentifierRE = /^$|^\d|[^\$\w\xA0-\uFFFF]/;
const isSimpleIdentifier = (name)=>!nonIdentifierRE.test(name);
const validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
const validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
const getExpSource = (exp)=>exp.type === 4 ? exp.content : exp.loc.source;
const isMemberExpressionBrowser = (exp)=>{
    const path = getExpSource(exp).trim().replace(whitespaceRE, (s)=>s.trim());
    let state = 0 /* inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* inMemberExp */ :
                if (char === "[") {
                    stateStack.push(state);
                    state = 1 /* inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === "(") {
                    stateStack.push(state);
                    state = 2 /* inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? validFirstIdentCharRE : validIdentCharRE).test(char)) return false;
                break;
            case 1 /* inBrackets */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* inParens */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const isMemberExpressionNode = (0, _shared.NOOP);
const isMemberExpression = isMemberExpressionBrowser;
const fnExpRE = /^\s*(?:async\s*)?(?:\([^)]*?\)|[\w$_]+)\s*(?::[^=]+)?=>|^\s*(?:async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const isFnExpressionBrowser = (exp)=>fnExpRE.test(getExpSource(exp));
const isFnExpressionNode = (0, _shared.NOOP);
const isFnExpression = isFnExpressionBrowser;
function advancePositionWithClone(pos, source, numberOfCharacters = source.length) {
    return advancePositionWithMutation({
        offset: pos.offset,
        line: pos.line,
        column: pos.column
    }, source, numberOfCharacters);
}
function advancePositionWithMutation(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function assert(condition, msg) {
    if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function findDir(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 && (allowEmpty || p.exp) && ((0, _shared.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === "bind" && (p.exp || allowEmpty) && isStaticArgOf(p.arg, name)) return p;
    }
}
function isStaticArgOf(arg, name) {
    return !!(arg && isStaticExp(arg) && arg.content === name);
}
function hasDynamicKeyVBind(node) {
    return node.props.some((p)=>p.type === 7 && p.name === "bind" && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 || // v-bind:[_ctx.foo]
        !p.arg.isStatic));
}
function isText$1(node) {
    return node.type === 5 || node.type === 2;
}
function isVPre(p) {
    return p.type === 7 && p.name === "pre";
}
function isVSlot(p) {
    return p.type === 7 && p.name === "slot";
}
function isTemplateNode(node) {
    return node.type === 1 && node.tagType === 3;
}
function isSlotOutlet(node) {
    return node.type === 1 && node.tagType === 2;
}
const propsHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, _shared.isString)(props) && props.type === 14) {
        const callee = props.callee;
        if (!(0, _shared.isString)(callee) && propsHelperSet.has(callee)) return getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function injectProp(node, prop, context) {
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, _shared.isString)(props) && props.type === 14) {
        const ret = getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, _shared.isString)(props)) propsWithInjection = createObjectExpression([
        prop
    ]);
    else if (props.type === 14) {
        const first = props.arguments[0];
        if (!(0, _shared.isString)(first) && first.type === 15) {
            if (!hasProp(prop, first)) first.properties.unshift(prop);
        } else if (props.callee === TO_HANDLERS) propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift(createObjectExpression([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
        if (!hasProp(prop, props)) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([
                prop
            ]),
            props
        ]);
        if (parentCall && parentCall.callee === GUARD_REACTIVE_PROPS) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
        const propKeyName = prop.key.content;
        result = props.properties.some((p)=>p.key.type === 4 && p.key.content === propKeyName);
    }
    return result;
}
function toValidAssetId(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
}
function hasScopeRef(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1:
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 && (hasScopeRef(p.arg, ids) || hasScopeRef(p.exp, ids))) return true;
            }
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 11:
            if (hasScopeRef(node.source, ids)) return true;
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 9:
            return node.branches.some((b)=>hasScopeRef(b, ids));
        case 10:
            if (hasScopeRef(node.condition, ids)) return true;
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 4:
            return !node.isStatic && isSimpleIdentifier(node.content) && !!ids[node.content];
        case 8:
            return node.children.some((c)=>(0, _shared.isObject)(c) && hasScopeRef(c, ids));
        case 5:
        case 12:
            return hasScopeRef(node.content, ids);
        case 2:
        case 3:
        case 20:
            return false;
        default:
            return false;
    }
}
function getMemoedVNodeCall(node) {
    if (node.type === 14 && node.callee === WITH_MEMO) return node.arguments[1].returns;
    else return node;
}
const forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
function isAllWhitespace(str) {
    for(let i = 0; i < str.length; i++){
        if (!isWhitespace(str.charCodeAt(i))) return false;
    }
    return true;
}
function isWhitespaceText(node) {
    return node.type === 2 && isAllWhitespace(node.content) || node.type === 12 && isWhitespaceText(node.content);
}
function isCommentOrWhitespace(node) {
    return node.type === 3 || isWhitespaceText(node);
}
const defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0,
    isVoidTag: (0, _shared.NO),
    isPreTag: (0, _shared.NO),
    isIgnoreNewlineTag: (0, _shared.NO),
    isCustomElement: (0, _shared.NO),
    onError: defaultOnError,
    onWarn: defaultOnWarn,
    comments: false,
    prefixIdentifiers: false
};
let currentOptions = defaultParserOptions;
let currentRoot = null;
let currentInput = "";
let currentOpenTag = null;
let currentProp = null;
let currentAttrValue = "";
let currentAttrStartIndex = -1;
let currentAttrEndIndex = -1;
let inPre = 0;
let inVPre = false;
let currentVPreBoundary = null;
const stack = [];
const tokenizer = new Tokenizer(stack, {
    onerr: emitError,
    ontext (start, end) {
        onText(getSlice(start, end), start, end);
    },
    ontextentity (char, start, end) {
        onText(char, start, end);
    },
    oninterpolation (start, end) {
        if (inVPre) return onText(getSlice(start, end), start, end);
        let innerStart = start + tokenizer.delimiterOpen.length;
        let innerEnd = end - tokenizer.delimiterClose.length;
        while(isWhitespace(currentInput.charCodeAt(innerStart)))innerStart++;
        while(isWhitespace(currentInput.charCodeAt(innerEnd - 1)))innerEnd--;
        let exp = getSlice(innerStart, innerEnd);
        if (exp.includes("&")) exp = currentOptions.decodeEntities(exp, false);
        addNode({
            type: 5,
            content: createExp(exp, false, getLoc(innerStart, innerEnd)),
            loc: getLoc(start, end)
        });
    },
    onopentagname (start, end) {
        const name = getSlice(start, end);
        currentOpenTag = {
            type: 1,
            tag: name,
            ns: currentOptions.getNamespace(name, stack[0], currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: getLoc(start - 1, end),
            codegenNode: void 0
        };
    },
    onopentagend (end) {
        endOpenTag(end);
    },
    onclosetag (start, end) {
        const name = getSlice(start, end);
        if (!currentOptions.isVoidTag(name)) {
            let found = false;
            for(let i = 0; i < stack.length; i++){
                const e = stack[i];
                if (e.tag.toLowerCase() === name.toLowerCase()) {
                    found = true;
                    if (i > 0) emitError(24, stack[0].loc.start.offset);
                    for(let j = 0; j <= i; j++){
                        const el = stack.shift();
                        onCloseTag(el, end, j < i);
                    }
                    break;
                }
            }
            if (!found) emitError(23, backTrack(start, 60));
        }
    },
    onselfclosingtag (end) {
        const name = currentOpenTag.tag;
        currentOpenTag.isSelfClosing = true;
        endOpenTag(end);
        if (stack[0] && stack[0].tag === name) onCloseTag(stack.shift(), end);
    },
    onattribname (start, end) {
        currentProp = {
            type: 6,
            name: getSlice(start, end),
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
        };
    },
    ondirname (start, end) {
        const raw = getSlice(start, end);
        const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
        if (!inVPre && name === "") emitError(26, start);
        if (inVPre || name === "") currentProp = {
            type: 6,
            name: raw,
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
        };
        else {
            currentProp = {
                type: 7,
                name,
                rawName: raw,
                exp: void 0,
                arg: void 0,
                modifiers: raw === "." ? [
                    createSimpleExpression("prop")
                ] : [],
                loc: getLoc(start)
            };
            if (name === "pre") {
                inVPre = tokenizer.inVPre = true;
                currentVPreBoundary = currentOpenTag;
                const props = currentOpenTag.props;
                for(let i = 0; i < props.length; i++)if (props[i].type === 7) props[i] = dirToAttr(props[i]);
            }
        }
    },
    ondirarg (start, end) {
        if (start === end) return;
        const arg = getSlice(start, end);
        if (inVPre && !isVPre(currentProp)) {
            currentProp.name += arg;
            setLocEnd(currentProp.nameLoc, end);
        } else {
            const isStatic = arg[0] !== `[`;
            currentProp.arg = createExp(isStatic ? arg : arg.slice(1, -1), isStatic, getLoc(start, end), isStatic ? 3 : 0);
        }
    },
    ondirmodifier (start, end) {
        const mod = getSlice(start, end);
        if (inVPre && !isVPre(currentProp)) {
            currentProp.name += "." + mod;
            setLocEnd(currentProp.nameLoc, end);
        } else if (currentProp.name === "slot") {
            const arg = currentProp.arg;
            if (arg) {
                arg.content += "." + mod;
                setLocEnd(arg.loc, end);
            }
        } else {
            const exp = createSimpleExpression(mod, true, getLoc(start, end));
            currentProp.modifiers.push(exp);
        }
    },
    onattribdata (start, end) {
        currentAttrValue += getSlice(start, end);
        if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
        currentAttrEndIndex = end;
    },
    onattribentity (char, start, end) {
        currentAttrValue += char;
        if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
        currentAttrEndIndex = end;
    },
    onattribnameend (end) {
        const start = currentProp.loc.start.offset;
        const name = getSlice(start, end);
        if (currentProp.type === 7) currentProp.rawName = name;
        if (currentOpenTag.props.some((p)=>(p.type === 7 ? p.rawName : p.name) === name)) emitError(2, start);
    },
    onattribend (quote, end) {
        if (currentOpenTag && currentProp) {
            setLocEnd(currentProp.loc, end);
            if (quote !== 0) {
                if (currentAttrValue.includes("&")) currentAttrValue = currentOptions.decodeEntities(currentAttrValue, true);
                if (currentProp.type === 6) {
                    if (currentProp.name === "class") currentAttrValue = condense(currentAttrValue).trim();
                    if (quote === 1 && !currentAttrValue) emitError(13, end);
                    currentProp.value = {
                        type: 2,
                        content: currentAttrValue,
                        loc: quote === 1 ? getLoc(currentAttrStartIndex, currentAttrEndIndex) : getLoc(currentAttrStartIndex - 1, currentAttrEndIndex + 1)
                    };
                    if (tokenizer.inSFCRoot && currentOpenTag.tag === "template" && currentProp.name === "lang" && currentAttrValue && currentAttrValue !== "html") tokenizer.enterRCDATA(toCharCodes(`</template`), 0);
                } else {
                    let expParseMode = 0 /* Normal */ ;
                    currentProp.exp = createExp(currentAttrValue, false, getLoc(currentAttrStartIndex, currentAttrEndIndex), 0, expParseMode);
                    if (currentProp.name === "for") currentProp.forParseResult = parseForExpression(currentProp.exp);
                    let syncIndex = -1;
                    if (currentProp.name === "bind" && (syncIndex = currentProp.modifiers.findIndex((mod)=>mod.content === "sync")) > -1 && checkCompatEnabled("COMPILER_V_BIND_SYNC", currentOptions, currentProp.loc, currentProp.arg.loc.source)) {
                        currentProp.name = "model";
                        currentProp.modifiers.splice(syncIndex, 1);
                    }
                }
            }
            if (currentProp.type !== 7 || currentProp.name !== "pre") currentOpenTag.props.push(currentProp);
        }
        currentAttrValue = "";
        currentAttrStartIndex = currentAttrEndIndex = -1;
    },
    oncomment (start, end) {
        if (currentOptions.comments) addNode({
            type: 3,
            content: getSlice(start, end),
            loc: getLoc(start - 4, end + 3)
        });
    },
    onend () {
        const end = currentInput.length;
        for(let index = 0; index < stack.length; index++){
            onCloseTag(stack[index], end - 1);
            emitError(24, stack[index].loc.start.offset);
        }
    },
    oncdata (start, end) {
        if (stack[0].ns !== 0) onText(getSlice(start, end), start, end);
        else emitError(1, start - 9);
    },
    onprocessinginstruction (start) {
        if ((stack[0] ? stack[0].ns : currentOptions.ns) === 0) emitError(21, start - 1);
    }
});
const forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const stripParensRE = /^\(|\)$/g;
function parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match(forAliasRE);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false)=>{
        const start = loc.start.offset + offset;
        const end = start + content.length;
        return createExp(content, false, getLoc(start, end), 0, asParam ? 1 /* Params */  : 0 /* Normal */ );
    };
    const result = {
        source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: void 0,
        key: void 0,
        index: void 0,
        finalized: false
    };
    let valueContent = LHS.trim().replace(stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match(forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace(forIteratorRE, "").trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(keyContent, keyOffset, true);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = createAliasExpression(indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length), true);
        }
    }
    if (valueContent) result.value = createAliasExpression(valueContent, trimmedOffset, true);
    return result;
}
function getSlice(start, end) {
    return currentInput.slice(start, end);
}
function endOpenTag(end) {
    if (tokenizer.inSFCRoot) currentOpenTag.innerLoc = getLoc(end + 1, end + 1);
    addNode(currentOpenTag);
    const { tag, ns } = currentOpenTag;
    if (ns === 0 && currentOptions.isPreTag(tag)) inPre++;
    if (currentOptions.isVoidTag(tag)) onCloseTag(currentOpenTag, end);
    else {
        stack.unshift(currentOpenTag);
        if (ns === 1 || ns === 2) tokenizer.inXML = true;
    }
    currentOpenTag = null;
}
function onText(content, start, end) {
    {
        const tag = stack[0] && stack[0].tag;
        if (tag !== "script" && tag !== "style" && content.includes("&")) content = currentOptions.decodeEntities(content, false);
    }
    const parent = stack[0] || currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
        lastNode.content += content;
        setLocEnd(lastNode.loc, end);
    } else parent.children.push({
        type: 2,
        content,
        loc: getLoc(start, end)
    });
}
function onCloseTag(el, end, isImplied = false) {
    if (isImplied) setLocEnd(el.loc, backTrack(end, 60));
    else setLocEnd(el.loc, lookAhead(end, 62) + 1);
    if (tokenizer.inSFCRoot) {
        if (el.children.length) el.innerLoc.end = (0, _shared.extend)({}, el.children[el.children.length - 1].loc.end);
        else el.innerLoc.end = (0, _shared.extend)({}, el.innerLoc.start);
        el.innerLoc.source = getSlice(el.innerLoc.start.offset, el.innerLoc.end.offset);
    }
    const { tag, ns, children } = el;
    if (!inVPre) {
        if (tag === "slot") el.tagType = 2;
        else if (isFragmentTemplate(el)) el.tagType = 3;
        else if (isComponent(el)) el.tagType = 1;
    }
    if (!tokenizer.inRCDATA) el.children = condenseWhitespace(children);
    if (ns === 0 && currentOptions.isIgnoreNewlineTag(tag)) {
        const first = children[0];
        if (first && first.type === 2) first.content = first.content.replace(/^\r?\n/, "");
    }
    if (ns === 0 && currentOptions.isPreTag(tag)) inPre--;
    if (currentVPreBoundary === el) {
        inVPre = tokenizer.inVPre = false;
        currentVPreBoundary = null;
    }
    if (tokenizer.inXML && (stack[0] ? stack[0].ns : currentOptions.ns) === 0) tokenizer.inXML = false;
    {
        const props = el.props;
        if (!tokenizer.inSFCRoot && isCompatEnabled("COMPILER_NATIVE_TEMPLATE", currentOptions) && el.tag === "template" && !isFragmentTemplate(el)) {
            const parent = stack[0] || currentRoot;
            const index = parent.children.indexOf(el);
            parent.children.splice(index, 1, ...el.children);
        }
        const inlineTemplateProp = props.find((p)=>p.type === 6 && p.name === "inline-template");
        if (inlineTemplateProp && checkCompatEnabled("COMPILER_INLINE_TEMPLATE", currentOptions, inlineTemplateProp.loc) && el.children.length) inlineTemplateProp.value = {
            type: 2,
            content: getSlice(el.children[0].loc.start.offset, el.children[el.children.length - 1].loc.end.offset),
            loc: inlineTemplateProp.loc
        };
    }
}
function lookAhead(index, c) {
    let i = index;
    while(currentInput.charCodeAt(i) !== c && i < currentInput.length - 1)i++;
    return i;
}
function backTrack(index, c) {
    let i = index;
    while(currentInput.charCodeAt(i) !== c && i >= 0)i--;
    return i;
}
const specialTemplateDir = /* @__PURE__ */ new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]);
function isFragmentTemplate({ tag, props }) {
    if (tag === "template") for(let i = 0; i < props.length; i++){
        if (props[i].type === 7 && specialTemplateDir.has(props[i].name)) return true;
    }
    return false;
}
function isComponent({ tag, props }) {
    if (currentOptions.isCustomElement(tag)) return false;
    if (tag === "component" || isUpperCase(tag.charCodeAt(0)) || isCoreComponent(tag) || currentOptions.isBuiltInComponent && currentOptions.isBuiltInComponent(tag) || currentOptions.isNativeTag && !currentOptions.isNativeTag(tag)) return true;
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6) {
            if (p.name === "is" && p.value) {
                if (p.value.content.startsWith("vue:")) return true;
                else if (checkCompatEnabled("COMPILER_IS_ON_ELEMENT", currentOptions, p.loc)) return true;
            }
        } else if (p.name === "bind" && isStaticArgOf(p.arg, "is") && checkCompatEnabled("COMPILER_IS_ON_ELEMENT", currentOptions, p.loc)) return true;
    }
    return false;
}
function isUpperCase(c) {
    return c > 64 && c < 91;
}
const windowsNewlineRE = /\r\n/g;
function condenseWhitespace(nodes) {
    const shouldCondense = currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.type === 2) {
            if (!inPre) {
                if (isAllWhitespace(node.content)) {
                    const prev = nodes[i - 1] && nodes[i - 1].type;
                    const next = nodes[i + 1] && nodes[i + 1].type;
                    if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && hasNewlineChar(node.content)))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else node.content = " ";
                } else if (shouldCondense) node.content = condense(node.content);
            } else node.content = node.content.replace(windowsNewlineRE, "\n");
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function hasNewlineChar(str) {
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c === 10 || c === 13) return true;
    }
    return false;
}
function condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for(let i = 0; i < str.length; i++){
        if (isWhitespace(str.charCodeAt(i))) {
            if (!prevCharIsWhitespace) {
                ret += " ";
                prevCharIsWhitespace = true;
            }
        } else {
            ret += str[i];
            prevCharIsWhitespace = false;
        }
    }
    return ret;
}
function addNode(node) {
    (stack[0] || currentRoot).children.push(node);
}
function getLoc(start, end) {
    return {
        start: tokenizer.getPos(start),
        // @ts-expect-error allow late attachment
        end: end == null ? end : tokenizer.getPos(end),
        // @ts-expect-error allow late attachment
        source: end == null ? end : getSlice(start, end)
    };
}
function cloneLoc(loc) {
    return getLoc(loc.start.offset, loc.end.offset);
}
function setLocEnd(loc, end) {
    loc.end = tokenizer.getPos(end);
    loc.source = getSlice(loc.start.offset, end);
}
function dirToAttr(dir) {
    const attr = {
        type: 6,
        name: dir.rawName,
        nameLoc: getLoc(dir.loc.start.offset, dir.loc.start.offset + dir.rawName.length),
        value: void 0,
        loc: dir.loc
    };
    if (dir.exp) {
        const loc = dir.exp.loc;
        if (loc.end.offset < dir.loc.end.offset) {
            loc.start.offset--;
            loc.start.column--;
            loc.end.offset++;
            loc.end.column++;
        }
        attr.value = {
            type: 2,
            content: dir.exp.content,
            loc
        };
    }
    return attr;
}
function createExp(content, isStatic = false, loc, constType = 0, parseMode = 0 /* Normal */ ) {
    const exp = createSimpleExpression(content, isStatic, loc, constType);
    return exp;
}
function emitError(code, index, message) {
    currentOptions.onError(createCompilerError(code, getLoc(index, index), void 0, message));
}
function reset() {
    tokenizer.reset();
    currentOpenTag = null;
    currentProp = null;
    currentAttrValue = "";
    currentAttrStartIndex = -1;
    currentAttrEndIndex = -1;
    stack.length = 0;
}
function baseParse(input, options) {
    reset();
    currentInput = input;
    currentOptions = (0, _shared.extend)({}, defaultParserOptions);
    if (options) {
        let key;
        for(key in options)if (options[key] != null) currentOptions[key] = options[key];
    }
    tokenizer.mode = currentOptions.parseMode === "html" ? 1 : currentOptions.parseMode === "sfc" ? 2 : 0;
    tokenizer.inXML = currentOptions.ns === 1 || currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
        tokenizer.delimiterOpen = toCharCodes(delimiters[0]);
        tokenizer.delimiterClose = toCharCodes(delimiters[1]);
    }
    const root = currentRoot = createRoot([], input);
    tokenizer.parse(currentInput);
    root.loc = getLoc(0, input.length);
    root.children = condenseWhitespace(root.children);
    currentRoot = null;
    return root;
}
function cacheStatic(root, context) {
    walk(root, void 0, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    !!getSingleElementRoot(root));
}
function getSingleElementRoot(root) {
    const children = root.children.filter((x)=>x.type !== 3);
    return children.length === 1 && children[0].type === 1 && !isSlotOutlet(children[0]) ? children[0] : null;
}
function walk(node, parent, context, doNotHoistNode = false, inFor = false) {
    const { children } = node;
    const toCache = [];
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.type === 1 && child.tagType === 0) {
            const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
            if (constantType > 0) {
                if (constantType >= 2) {
                    child.codegenNode.patchFlag = -1;
                    toCache.push(child);
                    continue;
                }
            } else {
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13) {
                    const flag = codegenNode.patchFlag;
                    if ((flag === void 0 || flag === 512 || flag === 1) && getGeneratedPropsConstantType(child, context) >= 2) {
                        const props = getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        } else if (child.type === 12) {
            const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
            if (constantType >= 2) {
                if (child.codegenNode.type === 14 && child.codegenNode.arguments.length > 0) child.codegenNode.arguments.push(-1 + ``);
                toCache.push(child);
                continue;
            }
        }
        if (child.type === 1) {
            const isComponent = child.tagType === 1;
            if (isComponent) context.scopes.vSlot++;
            walk(child, node, context, false, inFor);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11) walk(child, node, context, child.children.length === 1, true);
        else if (child.type === 9) for(let i2 = 0; i2 < child.branches.length; i2++)walk(child.branches[i2], node, context, child.branches[i2].children.length === 1, inFor);
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
        if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && (0, _shared.isArray)(node.codegenNode.children)) {
            node.codegenNode.children = getCacheExpression(createArrayExpression(node.codegenNode.children));
            cachedAsArray = true;
        } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !(0, _shared.isArray)(node.codegenNode.children) && node.codegenNode.children.type === 15) {
            const slot = getSlotNode(node.codegenNode, "default");
            if (slot) {
                slot.returns = getCacheExpression(createArrayExpression(slot.returns));
                cachedAsArray = true;
            }
        } else if (node.tagType === 3 && parent && parent.type === 1 && parent.tagType === 1 && parent.codegenNode && parent.codegenNode.type === 13 && parent.codegenNode.children && !(0, _shared.isArray)(parent.codegenNode.children) && parent.codegenNode.children.type === 15) {
            const slotName = findDir(node, "slot", true);
            const slot = slotName && slotName.arg && getSlotNode(parent.codegenNode, slotName.arg);
            if (slot) {
                slot.returns = getCacheExpression(createArrayExpression(slot.returns));
                cachedAsArray = true;
            }
        }
    }
    if (!cachedAsArray) for (const child of toCache)child.codegenNode = context.cache(child.codegenNode);
    function getCacheExpression(value) {
        const exp = context.cache(value);
        exp.needArraySpread = true;
        return exp;
    }
    function getSlotNode(node2, name) {
        if (node2.children && !(0, _shared.isArray)(node2.children) && node2.children.type === 15) {
            const slot = node2.children.properties.find((p)=>p.key === name || p.key.content === name);
            return slot && slot.value;
        }
    }
    if (toCache.length && context.transformHoist) context.transformHoist(children, context, node);
}
function getConstantType(node, context) {
    const { constantCache } = context;
    switch(node.type){
        case 1:
            if (node.tagType !== 0) return 0;
            const cached = constantCache.get(node);
            if (cached !== void 0) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13) return 0;
            if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") return 0;
            if (codegenNode.patchFlag === void 0) {
                let returnType2 = 3;
                const generatedPropsType = getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0) {
                    constantCache.set(node, 0);
                    return 0;
                }
                if (generatedPropsType < returnType2) returnType2 = generatedPropsType;
                for(let i = 0; i < node.children.length; i++){
                    const childType = getConstantType(node.children[i], context);
                    if (childType === 0) {
                        constantCache.set(node, 0);
                        return 0;
                    }
                    if (childType < returnType2) returnType2 = childType;
                }
                if (returnType2 > 1) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 && p.name === "bind" && p.exp) {
                        const expType = getConstantType(p.exp, context);
                        if (expType === 0) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                        if (expType < returnType2) returnType2 = expType;
                    }
                }
                if (codegenNode.isBlock) {
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                    }
                    context.removeHelper(OPEN_BLOCK);
                    context.removeHelper(getVNodeBlockHelper(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper(getVNodeHelper(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType2);
                return returnType2;
            } else {
                constantCache.set(node, 0);
                return 0;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
            return 0;
        case 5:
        case 12:
            return getConstantType(node.content, context);
        case 4:
            return node.constType;
        case 8:
            let returnType = 3;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, _shared.isString)(child) || (0, _shared.isSymbol)(child)) continue;
                const childType = getConstantType(child, context);
                if (childType === 0) return 0;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        case 20:
            return 2;
        default:
            return 0;
    }
}
const allowHoistedHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_CLASS,
    NORMALIZE_STYLE,
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !(0, _shared.isString)(value.callee) && allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4) return getConstantType(arg, context);
        else if (arg.type === 14) return getConstantTypeOfHelperCall(arg, context);
    }
    return 0;
}
function getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = getNodeProps(node);
    if (props && props.type === 15) {
        const { properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key, value } = properties[i];
            const keyType = getConstantType(key, context);
            if (keyType === 0) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4) valueType = getConstantType(value, context);
            else if (value.type === 14) valueType = getConstantTypeOfHelperCall(value, context);
            else valueType = 0;
            if (valueType === 0) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) return codegenNode.props;
}
function createTransformContext(root, { filename = "", prefixIdentifiers = false, hoistStatic = false, hmr = false, cacheHandlers = false, nodeTransforms = [], directiveTransforms = {}, transformHoist = null, isBuiltInComponent = (0, _shared.NOOP), isCustomElement = (0, _shared.NOOP), expressionPlugins = [], scopeId = null, slotted = true, ssr = false, inSSR = false, ssrCssVars = ``, bindingMetadata = (0, _shared.EMPTY_OBJ), inline = false, isTS = false, onError = defaultOnError, onWarn = defaultOnWarn, compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
        // options
        filename,
        selfName: nameMatch && (0, _shared.capitalize)((0, _shared.camelize)(nameMatch[1])),
        prefixIdentifiers,
        hoistStatic,
        hmr,
        cacheHandlers,
        nodeTransforms,
        directiveTransforms,
        transformHoist,
        isBuiltInComponent,
        isCustomElement,
        expressionPlugins,
        scopeId,
        slotted,
        ssr,
        inSSR,
        ssrCssVars,
        bindingMetadata,
        inline,
        isTS,
        onError,
        onWarn,
        compatConfig,
        // state
        root,
        helpers: /* @__PURE__ */ new Map(),
        components: /* @__PURE__ */ new Set(),
        directives: /* @__PURE__ */ new Set(),
        hoists: [],
        imports: [],
        cached: [],
        constantCache: /* @__PURE__ */ new WeakMap(),
        temps: 0,
        identifiers: /* @__PURE__ */ Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        grandParent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${helperNameMap[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                context.currentNode = null;
                context.onNodeRemoved();
            } else if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: (0, _shared.NOOP),
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, _shared.isString)(exp)) exp = createSimpleExpression(exp);
            context.hoists.push(exp);
            const identifier = createSimpleExpression(`_hoisted_${context.hoists.length}`, false, exp.loc, 2);
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false, inVOnce = false) {
            const cacheExp = createCacheExpression(context.cached.length, exp, isVNode, inVOnce);
            context.cached.push(cacheExp);
            return cacheExp;
        }
    };
    context.filters = /* @__PURE__ */ new Set();
    return context;
}
function transform(root, options) {
    const context = createTransformContext(root, options);
    traverseNode(root, context);
    if (options.hoistStatic) cacheStatic(root, context);
    if (!options.ssr) createRootCodegen(root, context);
    root.helpers = /* @__PURE__ */ new Set([
        ...context.helpers.keys()
    ]);
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    root.filters = [
        ...context.filters
    ];
}
function createRootCodegen(root, context) {
    const { helper } = context;
    const { children } = root;
    if (children.length === 1) {
        const singleElementRootChild = getSingleElementRoot(root);
        if (singleElementRootChild && singleElementRootChild.codegenNode) {
            const codegenNode = singleElementRootChild.codegenNode;
            if (codegenNode.type === 13) convertToBlock(codegenNode, context);
            root.codegenNode = codegenNode;
        } else root.codegenNode = children[0];
    } else if (children.length > 1) {
        let patchFlag = 64;
        root.codegenNode = createVNodeCall(context, helper(FRAGMENT), void 0, root.children, patchFlag, void 0, void 0, true, void 0, false);
    }
}
function traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, _shared.isString)(child)) continue;
        context.grandParent = context.parent;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        traverseNode(child, context);
    }
}
function traverseNode(node, context) {
    context.currentNode = node;
    const { nodeTransforms } = context;
    const exitFns = [];
    for(let i2 = 0; i2 < nodeTransforms.length; i2++){
        const onExit = nodeTransforms[i2](node, context);
        if (onExit) {
            if ((0, _shared.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) return;
        else node = context.currentNode;
    }
    switch(node.type){
        case 3:
            if (!context.ssr) context.helper(CREATE_COMMENT);
            break;
        case 5:
            if (!context.ssr) context.helper(TO_DISPLAY_STRING);
            break;
        // for container types, further traverse downwards
        case 9:
            for(let i2 = 0; i2 < node.branches.length; i2++)traverseNode(node.branches[i2], context);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            traverseChildren(node, context);
            break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function createStructuralDirectiveTransform(name, fn) {
    const matches = (0, _shared.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1) {
            const { props } = node;
            if (node.tagType === 3 && props.some(isVSlot)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 && matches(prop.name)) {
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const PURE_ANNOTATION = `/*@__PURE__*/`;
const aliasHelper = (s)=>`${helperNameMap[s]}: _${helperNameMap[s]}`;
function createCodegenContext(ast, { mode = "function", prefixIdentifiers = mode === "module", sourceMap = false, filename = `template.vue.html`, scopeId = null, optimizeImports = false, runtimeGlobalName = `Vue`, runtimeModuleName = `vue`, ssrRuntimeModuleName = "vue/server-renderer", ssr = false, isTS = false, inSSR = false }) {
    const context = {
        mode,
        prefixIdentifiers,
        sourceMap,
        filename,
        scopeId,
        optimizeImports,
        runtimeGlobalName,
        runtimeModuleName,
        ssrRuntimeModuleName,
        ssr,
        isTS,
        inSSR,
        source: ast.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: void 0,
        helper (key) {
            return `_${helperNameMap[key]}`;
        },
        push (code, newlineIndex = -2 /* None */ , node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push("\n" + `  `.repeat(n), 0 /* Start */ );
    }
    return context;
}
function generate(ast, options = {}) {
    const context = createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode, push, prefixIdentifiers, indent, deindent, newline, scopeId, ssr } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    genFunctionPreamble(ast, preambleContext);
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        "_ctx",
        "_push",
        "_parent",
        "_attrs"
    ] : [
        "_ctx",
        "_cache"
    ];
    const signature = args.join(", ");
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        if (hasHelpers) {
            push(`const { ${helpers.map(aliasHelper).join(", ")} } = _Vue
`, -1 /* End */ );
            newline();
        }
    }
    if (ast.components.length) {
        genAssets(ast.components, "component", context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        genAssets(ast.directives, "directive", context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        genAssets(ast.filters, "filter", context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`
`, 0 /* Start */ );
        newline();
    }
    if (!ssr) push(`return `);
    if (ast.codegenNode) genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast,
        code: context.code,
        preamble: ``,
        map: context.map ? context.map.toJSON() : void 0
    };
}
function genFunctionPreamble(ast, context) {
    const { ssr, prefixIdentifiers, push, newline, runtimeModuleName, runtimeGlobalName, ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
        push(`const _Vue = ${VueBinding}
`, -1 /* End */ );
        if (ast.hoists.length) {
            const staticHelpers = [
                CREATE_VNODE,
                CREATE_ELEMENT_VNODE,
                CREATE_COMMENT,
                CREATE_TEXT,
                CREATE_STATIC
            ].filter((helper)=>helpers.includes(helper)).map(aliasHelper).join(", ");
            push(`const { ${staticHelpers} } = _Vue
`, -1 /* End */ );
        }
    }
    genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function genAssets(assets, type, { helper, push, newline, isTS }) {
    const resolver = helper(type === "filter" ? RESOLVE_FILTER : type === "component" ? RESOLVE_COMPONENT : RESOLVE_DIRECTIVE);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        const maybeSelfReference = id.endsWith("__self");
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push, newline } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = `);
            genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function isText(n) {
    return (0, _shared.isString)(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
}
function genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function genNodeList(nodes, context, multilines = false, comma = true) {
    const { push, newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, _shared.isString)(node)) push(node, -3 /* Unknown */ );
        else if ((0, _shared.isArray)(node)) genNodeListAsArray(node, context);
        else genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(",");
                newline();
            } else comma && push(", ");
        }
    }
}
function genNode(node, context) {
    if ((0, _shared.isString)(node)) {
        context.push(node, -3 /* Unknown */ );
        return;
    }
    if ((0, _shared.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1:
        case 9:
        case 11:
            genNode(node.codegenNode, context);
            break;
        case 2:
            genText(node, context);
            break;
        case 4:
            genExpression(node, context);
            break;
        case 5:
            genInterpolation(node, context);
            break;
        case 12:
            genNode(node.codegenNode, context);
            break;
        case 8:
            genCompoundExpression(node, context);
            break;
        case 3:
            genComment(node, context);
            break;
        case 13:
            genVNodeCall(node, context);
            break;
        case 14:
            genCallExpression(node, context);
            break;
        case 15:
            genObjectExpression(node, context);
            break;
        case 17:
            genArrayExpression(node, context);
            break;
        case 18:
            genFunctionExpression(node, context);
            break;
        case 19:
            genConditionalExpression(node, context);
            break;
        case 20:
            genCacheExpression(node, context);
            break;
        case 21:
            genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22:
            break;
        case 23:
            break;
        case 24:
            break;
        case 25:
            break;
        case 26:
            break;
        /* v8 ignore start */ case 10:
            break;
        default:
    }
}
function genText(node, context) {
    context.push(JSON.stringify(node.content), -3 /* Unknown */ , node);
}
function genExpression(node, context) {
    const { content, isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, -3 /* Unknown */ , node);
}
function genInterpolation(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(TO_DISPLAY_STRING)}(`);
    genNode(node.content, context);
    push(`)`);
}
function genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, _shared.isString)(child)) context.push(child, -3 /* Unknown */ );
        else genNode(child, context);
    }
}
function genExpressionAsPropertyKey(node, context) {
    const { push } = context;
    if (node.type === 8) {
        push(`[`);
        genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        const text = isSimpleIdentifier(node.content) ? node.content : JSON.stringify(node.content);
        push(text, -2 /* None */ , node);
    } else push(`[${node.content}]`, -3 /* Unknown */ , node);
}
function genComment(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`, -3 /* Unknown */ , node);
}
function genVNodeCall(node, context) {
    const { push, helper, pure } = context;
    const { tag, props, children, patchFlag, dynamicProps, directives, isBlock, disableTracking, isComponent } = node;
    let patchFlagString;
    if (patchFlag) patchFlagString = String(patchFlag);
    if (directives) push(helper(WITH_DIRECTIVES) + `(`);
    if (isBlock) push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
    if (pure) push(PURE_ANNOTATION);
    const callHelper = isBlock ? getVNodeBlockHelper(context.inSSR, isComponent) : getVNodeHelper(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, -2 /* None */ , node);
    genNodeList(genNullableArgs([
        tag,
        props,
        children,
        patchFlagString,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        genNode(directives, context);
        push(`)`);
    }
}
function genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
function genCallExpression(node, context) {
    const { push, helper, pure } = context;
    const callee = (0, _shared.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push(PURE_ANNOTATION);
    push(callee + `(`, -2 /* None */ , node);
    genNodeList(node.arguments, context);
    push(`)`);
}
function genObjectExpression(node, context) {
    const { push, indent, deindent, newline } = context;
    const { properties } = node;
    if (!properties.length) {
        push(`{}`, -2 /* None */ , node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key, value } = properties[i];
        genExpressionAsPropertyKey(key, context);
        push(`: `);
        genNode(value, context);
        if (i < properties.length - 1) {
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function genArrayExpression(node, context) {
    genNodeListAsArray(node.elements, context);
}
function genFunctionExpression(node, context) {
    const { push, indent, deindent } = context;
    const { params, returns, body, newline, isSlot } = node;
    if (isSlot) push(`_${helperNameMap[WITH_CTX]}(`);
    push(`(`, -2 /* None */ , node);
    if ((0, _shared.isArray)(params)) genNodeList(params, context);
    else if (params) genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, _shared.isArray)(returns)) genNodeListAsArray(returns, context);
        else genNode(returns, context);
    } else if (body) genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function genConditionalExpression(node, context) {
    const { test, consequent, alternate, newline: needNewline } = node;
    const { push, indent, deindent, newline } = context;
    if (test.type === 4) {
        const needsParens = !isSimpleIdentifier(test.content);
        needsParens && push(`(`);
        genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) context.indentLevel++;
    genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function genCacheExpression(node, context) {
    const { push, helper, indent, deindent, newline } = context;
    const { needPauseTracking, needArraySpread } = node;
    if (needArraySpread) push(`[...(`);
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
        indent();
        push(`${helper(SET_BLOCK_TRACKING)}(-1`);
        if (node.inVOnce) push(`, true`);
        push(`),`);
        newline();
        push(`(`);
    }
    push(`_cache[${node.index}] = `);
    genNode(node.value, context);
    if (needPauseTracking) {
        push(`).cacheIndex = ${node.index},`);
        newline();
        push(`${helper(SET_BLOCK_TRACKING)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
    if (needArraySpread) push(`)]`);
}
const prohibitedKeywordRE = new RegExp("\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b");
const stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace(stripStringRE, "").match(prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError(createCompilerError(46, node.loc, void 0, message));
    }
}
const transformExpression = (node, context)=>{
    if (node.type === 5) node.content = processExpression(node.content, context);
    else if (node.type === 1) {
        const memo = findDir(node, "memo");
        for(let i = 0; i < node.props.length; i++){
            const dir = node.props[i];
            if (dir.type === 7 && dir.name !== "for") {
                const exp = dir.exp;
                const arg = dir.arg;
                if (exp && exp.type === 4 && !(dir.name === "on" && arg) && // key has been processed in transformFor(vMemo + vFor)
                !(memo && arg && arg.type === 4 && arg.content === "key")) dir.exp = processExpression(exp, context, // slot args must be processed as function params
                dir.name === "slot");
                if (arg && arg.type === 4 && !arg.isStatic) dir.arg = processExpression(arg, context);
            }
        }
    }
};
function processExpression(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
function stringifyExpression(exp) {
    if ((0, _shared.isString)(exp)) return exp;
    else if (exp.type === 4) return exp.content;
    else return exp.children.map(stringifyExpression).join("");
}
const transformIf = createStructuralDirectiveTransform(/^(?:if|else|else-if)$/, (node, dir, context)=>{
    return processIf(node, dir, context, (ifNode, branch, isRoot)=>{
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9) key += sibling.branches.length;
        }
        return ()=>{
            if (isRoot) ifNode.codegenNode = createCodegenNodeForBranch(branch, key, context);
            else {
                const parentCondition = getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
function processIf(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError(createCompilerError(28, dir.loc));
        dir.exp = createSimpleExpression(`true`, false, loc);
    }
    if (dir.name === "if") {
        const branch = createIfBranch(node, dir);
        const ifNode = {
            type: 9,
            loc: cloneLoc(node.loc),
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && isCommentOrWhitespace(sibling)) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9) {
                if ((dir.name === "else-if" || dir.name === "else") && sibling.branches[sibling.branches.length - 1].condition === void 0) context.onError(createCompilerError(30, node.loc));
                context.removeNode();
                const branch = createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                traverseNode(branch, context);
                if (onExit) onExit();
                context.currentNode = null;
            } else context.onError(createCompilerError(30, node.loc));
            break;
        }
    }
}
function createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
        type: 10,
        loc: node.loc,
        condition: dir.name === "else" ? void 0 : dir.exp,
        children: isTemplateIf && !findDir(node, "for") ? node.children : [
            node
        ],
        userKey: findProp(node, `key`),
        isTemplateIf
    };
}
function createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return createConditionalExpression(branch.condition, createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    createCallExpression(context.helper(CREATE_COMMENT), [
        '""',
        "true"
    ]));
    else return createChildrenCodegenNode(branch, keyIndex, context);
}
function createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper } = context;
    const keyProperty = createObjectProperty(`key`, createSimpleExpression(`${keyIndex}`, false, locStub, 2));
    const { children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11) {
            const vnodeCall = firstChild.codegenNode;
            injectProp(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64;
            return createVNodeCall(context, helper(FRAGMENT), createObjectExpression([
                keyProperty
            ]), children, patchFlag, void 0, void 0, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = getMemoedVNodeCall(ret);
        if (vnodeCall.type === 13) convertToBlock(vnodeCall, context);
        injectProp(vnodeCall, keyProperty, context);
        return ret;
    }
}
function isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6) {
        if (a.value.content !== b.value.content) return false;
    } else {
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function getParentCondition(node) {
    while(true){
        if (node.type === 19) {
            if (node.alternate.type === 19) node = node.alternate;
            else return node;
        } else if (node.type === 20) node = node.value;
    }
}
const transformFor = createStructuralDirectiveTransform("for", (node, dir, context)=>{
    const { helper, removeHelper } = context;
    return processFor(node, dir, context, (forNode)=>{
        const renderExp = createCallExpression(helper(RENDER_LIST), [
            forNode.source
        ]);
        const isTemplate = isTemplateNode(node);
        const memo = findDir(node, "memo");
        const keyProp = findProp(node, `key`, false, true);
        keyProp && keyProp.type;
        let keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? createSimpleExpression(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyProp && keyExp ? createObjectProperty(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = createVNodeCall(context, helper(FRAGMENT), void 0, renderExp, fragmentFlag, void 0, void 0, true, !isStableFragment, false, node.loc);
        return ()=>{
            let childBlock;
            const { children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
            const slotOutlet = isSlotOutlet(node) ? node : isTemplate && node.children.length === 1 && isSlotOutlet(node.children[0]) ? node.children[0] : null;
            if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) injectProp(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) childBlock = createVNodeCall(context, helper(FRAGMENT), keyProperty ? createObjectExpression([
                keyProperty
            ]) : void 0, node.children, 64, void 0, void 0, true, void 0, false);
            else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) injectProp(childBlock, keyProperty, context);
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        removeHelper(OPEN_BLOCK);
                        removeHelper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                    } else removeHelper(getVNodeHelper(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper(OPEN_BLOCK);
                    helper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                } else helper(getVNodeHelper(context.inSSR, childBlock.isComponent));
            }
            if (memo) {
                const loop = createFunctionExpression(createForLoopParams(forNode.parseResult, [
                    createSimpleExpression(`_cached`)
                ]));
                loop.body = createBlockStatement([
                    createCompoundExpression([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    createCompoundExpression([
                        `if (_cached && _cached.el`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString(IS_MEMO_SAME)}(_cached, _memo)) return _cached`
                    ]),
                    createCompoundExpression([
                        `const _item = `,
                        childBlock
                    ]),
                    createSimpleExpression(`_item.memo = _memo`),
                    createSimpleExpression(`return _item`)
                ]);
                renderExp.arguments.push(loop, createSimpleExpression(`_cache`), createSimpleExpression(String(context.cached.length)));
                context.cached.push(null);
            } else renderExp.arguments.push(createFunctionExpression(createForLoopParams(forNode.parseResult), childBlock, true));
        };
    });
});
function processFor(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError(createCompilerError(31, dir.loc));
        return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
        context.onError(createCompilerError(32, dir.loc));
        return;
    }
    finalizeForParseResult(parseResult, context);
    const { addIdentifiers, removeIdentifiers, scopes } = context;
    const { source, value, key, index } = parseResult;
    const forNode = {
        type: 11,
        loc: dir.loc,
        source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult,
        children: isTemplateNode(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
function finalizeForParseResult(result, context) {
    if (result.finalized) return;
    result.finalized = true;
}
function createForLoopParams({ value, key, index }, memoArgs = []) {
    return createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2)=>arg || createSimpleExpression(`_`.repeat(i2 + 1), false));
}
const defaultFallback = createSimpleExpression(`undefined`, false);
const trackSlotScopes = (node, context)=>{
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
        const vSlot = findDir(node, "slot");
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
const trackVForSlotScopes = (node, context)=>{
    let vFor;
    if (isTemplateNode(node) && node.props.some(isVSlot) && (vFor = findDir(node, "for"))) {
        const result = vFor.forParseResult;
        if (result) {
            finalizeForParseResult(result, context);
            const { value, key, index } = result;
            const { addIdentifiers, removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const buildClientSlotFn = (props, _vForExp, children, loc)=>createFunctionExpression(props, children, false, true, children.length ? children[0].loc : loc);
function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
    context.helper(WITH_CTX);
    const { children, loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = findDir(node, "slot", true);
    if (onComponentSlot) {
        const { arg, exp } = onComponentSlot;
        if (arg && !isStaticExp(arg)) hasDynamicSlots = true;
        slotsProperties.push(createObjectProperty(arg || createSimpleExpression("default", true), buildSlotFn(exp, void 0, children, loc)));
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!isTemplateNode(slotElement) || !(slotDir = findDir(slotElement, "slot", true))) {
            if (slotElement.type !== 3) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            context.onError(createCompilerError(37, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = createSimpleExpression(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        let staticSlotName;
        if (isStaticExp(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const vFor = findDir(slotElement, "for");
        const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
        let vIf;
        let vElse;
        if (vIf = findDir(slotElement, "if")) {
            hasDynamicSlots = true;
            dynamicSlots.push(createConditionalExpression(vIf.exp, buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), defaultFallback));
        } else if (vElse = findDir(slotElement, /^else(?:-if)?$/, true)) {
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (!isCommentOrWhitespace(prev)) break;
            }
            if (prev && isTemplateNode(prev) && findDir(prev, /^(?:else-)?if$/)) {
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19)conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? createConditionalExpression(vElse.exp, buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), defaultFallback) : buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError(createCompilerError(30, vElse.loc));
        } else if (vFor) {
            hasDynamicSlots = true;
            const parseResult = vFor.forParseResult;
            if (parseResult) {
                finalizeForParseResult(parseResult, context);
                dynamicSlots.push(createCallExpression(context.helper(RENDER_LIST), [
                    parseResult.source,
                    createFunctionExpression(createForLoopParams(parseResult), buildDynamicSlot(slotName, slotFunction), true)
                ]));
            } else context.onError(createCompilerError(32, vFor.loc));
        } else {
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError(createCompilerError(38, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === "default") hasNamedDefaultSlot = true;
            }
            slotsProperties.push(createObjectProperty(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children2)=>{
            const fn = buildSlotFn(props, void 0, children2, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return createObjectProperty(`default`, fn);
        };
        if (!hasTemplateSlots) slotsProperties.push(buildDefaultSlotProperty(void 0, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        !implicitDefaultChildren.every(isWhitespaceText)) {
            if (hasNamedDefaultSlot) context.onError(createCompilerError(39, implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(void 0, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 : hasForwardedSlots(node.children) ? 3 : 1;
    let slots = createObjectExpression(slotsProperties.concat(createObjectProperty(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    createSimpleExpression(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = createCallExpression(context.helper(CREATE_SLOTS), [
        slots,
        createArrayExpression(dynamicSlots)
    ]);
    return {
        slots,
        hasDynamicSlots
    };
}
function buildDynamicSlot(name, fn, index) {
    const props = [
        createObjectProperty(`name`, name),
        createObjectProperty(`fn`, fn)
    ];
    if (index != null) props.push(createObjectProperty(`key`, createSimpleExpression(String(index), true)));
    return createObjectExpression(props);
}
function hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1:
                if (child.tagType === 2 || hasForwardedSlots(child.children)) return true;
                break;
            case 9:
                if (hasForwardedSlots(child.branches)) return true;
                break;
            case 10:
            case 11:
                if (hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
const directiveImportMap = /* @__PURE__ */ new WeakMap();
const transformElement = (node, context)=>{
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) return;
        const { tag, props } = node;
        const isComponent = node.tagType === 1;
        let vnodeTag = isComponent ? resolveComponentType(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, _shared.isObject)(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
        let vnodeProps;
        let vnodeChildren;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === TELEPORT || vnodeTag === SUSPENSE || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math");
        if (props.length > 0) {
            const propsBuildResult = buildProps(node, context, void 0, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? createArrayExpression(directives.map((dir)=>buildDirectiveArgs(dir, context))) : void 0;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        if (node.children.length > 0) {
            if (vnodeTag === KEEP_ALIVE) {
                shouldUseBlock = true;
                patchFlag |= 1024;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== TELEPORT && // explained above.
            vnodeTag !== KEEP_ALIVE;
            if (shouldBuildAsSlots) {
                const { slots, hasDynamicSlots } = buildSlots(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024;
            } else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
                const child = node.children[0];
                const type = child.type;
                const hasDynamicTextChild = type === 5 || type === 8;
                if (hasDynamicTextChild && getConstantType(child, context) === 0) patchFlag |= 1;
                if (hasDynamicTextChild || type === 2) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
        node.codegenNode = createVNodeCall(context, vnodeTag, vnodeProps, vnodeChildren, patchFlag === 0 ? void 0 : patchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
    };
};
function resolveComponentType(node, context, ssr = false) {
    let { tag } = node;
    const isExplicitDynamic = isComponentTag(tag);
    const isProp = findProp(node, "is", false, true);
    if (isProp) {
        if (isExplicitDynamic || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context)) {
            let exp;
            if (isProp.type === 6) exp = isProp.value && createSimpleExpression(isProp.value.content, true);
            else {
                exp = isProp.exp;
                if (!exp) exp = createSimpleExpression(`is`, false, isProp.arg.loc);
            }
            if (exp) return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
                exp
            ]);
        } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) tag = isProp.value.content.slice(4);
    }
    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    context.helper(RESOLVE_COMPONENT);
    context.components.add(tag);
    return toValidAssetId(tag, `component`);
}
function buildProps(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag, loc: elementLoc, children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg)=>{
        if (properties.length) {
            mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
            properties = [];
        }
        if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = ()=>{
        if (context.scopes.vFor > 0) properties.push(createObjectProperty(createSimpleExpression("ref_for", true), createSimpleExpression("true")));
    };
    const analyzePatchFlag = ({ key, value })=>{
        if (isStaticExp(key)) {
            const name = key.content;
            const isEventHandler = (0, _shared.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== "onclick" && // omit v-model handlers
            name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
            !(0, _shared.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, _shared.isReservedProp)(name)) hasVnodeHook = true;
            if (isEventHandler && value.type === 14) value = value.arguments[0];
            if (value.type === 20 || (value.type === 4 || value.type === 8) && getConstantType(value, context) > 0) return;
            if (name === "ref") hasRef = true;
            else if (name === "class") hasClassBinding = true;
            else if (name === "style") hasStyleBinding = true;
            else if (name !== "key" && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            if (isComponent && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (prop.type === 6) {
            const { loc, name, nameLoc, value } = prop;
            let isStatic = true;
            if (name === "ref") {
                hasRef = true;
                pushRefVForMarker();
            }
            if (name === "is" && (isComponentTag(tag) || value && value.content.startsWith("vue:") || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            properties.push(createObjectProperty(createSimpleExpression(name, true, nameLoc), createSimpleExpression(value ? value.content : "", isStatic, value ? value.loc : loc)));
        } else {
            const { name, arg, exp, loc, modifiers } = prop;
            const isVBind = name === "bind";
            const isVOn = name === "on";
            if (name === "slot") {
                if (!isComponent) context.onError(createCompilerError(40, loc));
                continue;
            }
            if (name === "once" || name === "memo") continue;
            if (name === "is" || isVBind && isStaticArgOf(arg, "is") && (isComponentTag(tag) || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            if (isVOn && ssr) continue;
            if (// #938: elements with dynamic keys should be forced into blocks
            isVBind && isStaticArgOf(arg, "key") || // inline before-update hooks need to force block so that it is invoked
            // before children
            isVOn && hasChildren && isStaticArgOf(arg, "vue:before-update")) shouldUseBlock = true;
            if (isVBind && isStaticArgOf(arg, "ref")) pushRefVForMarker();
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (isVBind) {
                        pushMergeArg();
                        if (isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER", context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        pushRefVForMarker();
                        pushMergeArg();
                        mergeArgs.push(exp);
                    } else pushMergeArg({
                        type: 14,
                        loc,
                        callee: context.helper(TO_HANDLERS),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError(createCompilerError(isVBind ? 34 : 35, loc));
                continue;
            }
            if (isVBind && modifiers.some((mod)=>mod.content === "prop")) patchFlag |= 32;
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                const { props: props2, needRuntime } = directiveTransform(prop, node, context);
                !ssr && props2.forEach(analyzePatchFlag);
                if (isVOn && arg && !isStaticExp(arg)) pushMergeArg(createObjectExpression(props2, elementLoc));
                else properties.push(...props2);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, _shared.isSymbol)(needRuntime)) directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, _shared.isBuiltInDirective)(name)) {
                runtimeDirectives.push(prop);
                if (hasChildren) shouldUseBlock = true;
            }
        }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
        pushMergeArg();
        if (mergeArgs.length > 1) propsExpression = createCallExpression(context.helper(MERGE_PROPS), mergeArgs, elementLoc);
        else propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = createObjectExpression(dedupeProperties(properties), elementLoc);
    if (hasDynamicKeys) patchFlag |= 16;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2;
        if (hasStyleBinding && !isComponent) patchFlag |= 4;
        if (dynamicPropNames.length) patchFlag |= 8;
        if (hasHydrationEventBinding) patchFlag |= 32;
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) patchFlag |= 512;
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15:
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if (isStaticExp(key)) {
                    if (key.content === "class") classKeyIndex = i;
                    else if (key.content === "style") styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            if (!hasDynamicKey) {
                if (classProp && !isStaticExp(classProp.value)) classProp.value = createCallExpression(context.helper(NORMALIZE_CLASS), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17)) styleProp.value = createCallExpression(context.helper(NORMALIZE_STYLE), [
                    styleProp.value
                ]);
            } else propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                propsExpression
            ]);
            break;
        case 14:
            break;
        default:
            propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                createCallExpression(context.helper(GUARD_REACTIVE_PROPS), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag,
        dynamicPropNames,
        shouldUseBlock
    };
}
function dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        if (prop.key.type === 8 || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === "style" || name === "class" || (0, _shared.isOn)(name)) mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function mergeAsArray(existing, incoming) {
    if (existing.value.type === 17) existing.value.elements.push(incoming.value);
    else existing.value = createArrayExpression([
        existing.value,
        incoming.value
    ], existing.loc);
}
function buildDirectiveArgs(dir, context) {
    const dirArgs = [];
    const runtime = directiveImportMap.get(dir);
    if (runtime) dirArgs.push(context.helperString(runtime));
    else {
        context.helper(RESOLVE_DIRECTIVE);
        context.directives.add(dir.name);
        dirArgs.push(toValidAssetId(dir.name, `directive`));
    }
    const { loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = createSimpleExpression(`true`, false, loc);
        dirArgs.push(createObjectExpression(dir.modifiers.map((modifier)=>createObjectProperty(modifier, trueExpression)), loc));
    }
    return createArrayExpression(dirArgs, dir.loc);
}
function stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
}
function isComponentTag(tag) {
    return tag === "component" || tag === "Component";
}
const transformSlotOutlet = (node, context)=>{
    if (isSlotOutlet(node)) {
        const { children, loc } = node;
        const { slotName, slotProps } = processSlotOutlet(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = createFunctionExpression([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen);
        node.codegenNode = createCallExpression(context.helper(RENDER_SLOT), slotArgs, loc);
    }
};
function processSlotOutlet(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (p.value) {
                if (p.name === "name") slotName = JSON.stringify(p.value.content);
                else {
                    p.name = (0, _shared.camelize)(p.name);
                    nonNameProps.push(p);
                }
            }
        } else if (p.name === "bind" && isStaticArgOf(p.arg, "name")) {
            if (p.exp) slotName = p.exp;
            else if (p.arg && p.arg.type === 4) {
                const name = (0, _shared.camelize)(p.arg.content);
                slotName = p.exp = createSimpleExpression(name, false, p.arg.loc);
            }
        } else {
            if (p.name === "bind" && p.arg && isStaticExp(p.arg)) p.arg.content = (0, _shared.camelize)(p.arg.content);
            nonNameProps.push(p);
        }
    }
    if (nonNameProps.length > 0) {
        const { props, directives } = buildProps(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError(createCompilerError(36, directives[0].loc));
    }
    return {
        slotName,
        slotProps
    };
}
const transformOn = (dir, node, context, augmentor)=>{
    const { loc, modifiers, arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError(createCompilerError(35, loc));
    let eventName;
    if (arg.type === 4) {
        if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vue:")) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? // for non-element and vnode lifecycle event listeners, auto convert
            // it to camelCase. See issue #2249
            (0, _shared.toHandlerKey)((0, _shared.camelize)(rawName)) : // preserve case for plain element listeners that have uppercase
            // letters, as these may be custom elements' custom events
            `on:${rawName}`;
            eventName = createSimpleExpression(eventString, true, arg.loc);
        } else eventName = createCompoundExpression([
            `${context.helperString(TO_HANDLER_KEY)}(`,
            arg,
            `)`
        ]);
    } else {
        eventName = arg;
        eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
        eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = void 0;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = isMemberExpression(exp);
        const isInlineStatement = !(isMemberExp || isFnExpression(exp));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) exp = createCompoundExpression([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            createObjectProperty(eventName, exp || createSimpleExpression(`() => {}`, false, loc))
        ]
    };
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) ret.props[0].value = context.cache(ret.props[0].value);
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
const transformBind = (dir, _node, context)=>{
    const { modifiers, loc } = dir;
    const arg = dir.arg;
    let { exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) exp = void 0;
    if (arg.type !== 4) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = arg.content ? `${arg.content} || ""` : `""`;
    if (modifiers.some((mod)=>mod.content === "camel")) {
        if (arg.type === 4) {
            if (arg.isStatic) arg.content = (0, _shared.camelize)(arg.content);
            else arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.some((mod)=>mod.content === "prop")) injectPrefix(arg, ".");
        if (modifiers.some((mod)=>mod.content === "attr")) injectPrefix(arg, "^");
    }
    return {
        props: [
            createObjectProperty(arg, exp)
        ]
    };
};
const injectPrefix = (arg, prefix)=>{
    if (arg.type === 4) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
const transformText = (node, context)=>{
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) return ()=>{
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (isText$1(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if (isText$1(next)) {
                        if (!currentContainer) currentContainer = children[i] = createCompoundExpression([
                            child
                        ], child.loc);
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = void 0;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) return;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (isText$1(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") callArgs.push(child);
                if (!context.ssr && getConstantType(child, context) === 0) callArgs.push(1 + ``);
                children[i] = {
                    type: 12,
                    content: child,
                    loc: child.loc,
                    codegenNode: createCallExpression(context.helper(CREATE_TEXT), callArgs)
                };
            }
        }
    };
};
const seen$1 = /* @__PURE__ */ new WeakSet();
const transformOnce = (node, context)=>{
    if (node.type === 1 && findDir(node, "once", true)) {
        if (seen$1.has(node) || context.inVOnce || context.inSSR) return;
        seen$1.add(node);
        context.inVOnce = true;
        context.helper(SET_BLOCK_TRACKING);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true, true);
        };
    }
};
const transformModel = (dir, node, context)=>{
    const { exp, arg } = dir;
    if (!exp) {
        context.onError(createCompilerError(41, dir.loc));
        return createTransformProps();
    }
    const rawExp = exp.loc.source.trim();
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
        context.onError(createCompilerError(44, exp.loc));
        return createTransformProps();
    }
    if (bindingType === "literal-const" || bindingType === "setup-const") {
        context.onError(createCompilerError(45, exp.loc));
        return createTransformProps();
    }
    if (!expString.trim() || !isMemberExpression(exp) && true) {
        context.onError(createCompilerError(42, exp.loc));
        return createTransformProps();
    }
    const propName = arg ? arg : createSimpleExpression("modelValue", true);
    const eventName = arg ? isStaticExp(arg) ? `onUpdate:${(0, _shared.camelize)(arg.content)}` : createCompoundExpression([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = createCompoundExpression([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        createObjectProperty(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        createObjectProperty(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
        const modifiers = dir.modifiers.map((m)=>m.content).map((m)=>(isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? isStaticExp(arg) ? `${arg.content}Modifiers` : createCompoundExpression([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push(createObjectProperty(modifiersKey, createSimpleExpression(`{ ${modifiers} }`, false, dir.loc, 2)));
    }
    return createTransformProps(props);
};
function createTransformProps(props = []) {
    return {
        props
    };
}
const validDivisionCharRE = /[\w).+\-_$\]]/;
const transformFilter = (node, context)=>{
    if (!isCompatEnabled("COMPILER_FILTERS", context)) return;
    if (node.type === 5) rewriteFilter(node.content, context);
    else if (node.type === 1) node.props.forEach((prop)=>{
        if (prop.type === 7 && prop.name !== "for" && prop.exp) rewriteFilter(prop.exp, context);
    });
};
function rewriteFilter(node, context) {
    if (node.type === 4) parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) parseFilter(child, context);
        else if (child.type === 8) rewriteFilter(node, context);
        else if (child.type === 5) rewriteFilter(child.content, context);
    }
}
function parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 39 && prev !== 92) inSingle = false;
        } else if (inDouble) {
            if (c === 34 && prev !== 92) inDouble = false;
        } else if (inTemplateString) {
            if (c === 96 && prev !== 92) inTemplateString = false;
        } else if (inRegex) {
            if (c === 47 && prev !== 92) inRegex = false;
        } else if (c === 124 && // pipe
        exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
            if (expression === void 0) {
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 34:
                    inDouble = true;
                    break;
                // "
                case 39:
                    inSingle = true;
                    break;
                // '
                case 96:
                    inTemplateString = true;
                    break;
                // `
                case 40:
                    paren++;
                    break;
                // (
                case 41:
                    paren--;
                    break;
                // )
                case 91:
                    square++;
                    break;
                // [
                case 93:
                    square--;
                    break;
                // ]
                case 123:
                    curly++;
                    break;
                // {
                case 125:
                    curly--;
                    break;
            }
            if (c === 47) {
                let j = i - 1;
                let p;
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== " ") break;
                }
                if (!p || !validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === void 0) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = wrapFilter(expression, filters[i], context);
        node.content = expression;
        node.ast = void 0;
    }
}
function wrapFilter(exp, filter, context) {
    context.helper(RESOLVE_FILTER);
    const i = filter.indexOf("(");
    if (i < 0) {
        context.filters.add(filter);
        return `${toValidAssetId(filter, "filter")}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${toValidAssetId(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
}
const seen = /* @__PURE__ */ new WeakSet();
const transformMemo = (node, context)=>{
    if (node.type === 1) {
        const dir = findDir(node, "memo");
        if (!dir || seen.has(node) || context.inSSR) return;
        seen.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
                if (node.tagType !== 1) convertToBlock(codegenNode, context);
                node.codegenNode = createCallExpression(context.helper(WITH_MEMO), [
                    dir.exp,
                    createFunctionExpression(void 0, codegenNode),
                    `_cache`,
                    String(context.cached.length)
                ]);
                context.cached.push(null);
            }
        };
    }
};
const transformVBindShorthand = (node, context)=>{
    if (node.type === 1) {
        for (const prop of node.props)if (prop.type === 7 && prop.name === "bind" && (!prop.exp || // #13930 :foo in in-DOM templates will be parsed into :foo="" by browser
        prop.exp.type === 4 && !prop.exp.content.trim()) && prop.arg) {
            const arg = prop.arg;
            if (arg.type !== 4 || !arg.isStatic) {
                context.onError(createCompilerError(53, arg.loc));
                prop.exp = createSimpleExpression("", true, arg.loc);
            } else {
                const propName = (0, _shared.camelize)(arg.content);
                if (validFirstIdentCharRE.test(propName[0]) || // allow hyphen first char for https://github.com/vuejs/language-tools/pull/3424
                propName[0] === "-") prop.exp = createSimpleExpression(propName, false, arg.loc);
            }
        }
    }
};
function getBaseTransformPreset(prefixIdentifiers) {
    return [
        [
            transformVBindShorthand,
            transformOnce,
            transformIf,
            transformMemo,
            transformFor,
            transformFilter,
            transformSlotOutlet,
            transformElement,
            trackSlotScopes,
            transformText
        ],
        {
            on: transformOn,
            bind: transformBind,
            model: transformModel
        }
    ];
}
function baseCompile(source, options = {}) {
    const onError = options.onError || defaultOnError;
    const isModuleMode = options.mode === "module";
    if (options.prefixIdentifiers === true) onError(createCompilerError(48));
    else if (isModuleMode) onError(createCompilerError(49));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError(createCompilerError(50));
    if (options.scopeId && !isModuleMode) onError(createCompilerError(51));
    const resolvedOptions = (0, _shared.extend)({}, options, {
        prefixIdentifiers
    });
    const ast = (0, _shared.isString)(source) ? baseParse(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
    transform(ast, (0, _shared.extend)({}, resolvedOptions, {
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, _shared.extend)({}, directiveTransforms, options.directiveTransforms || {})
    }));
    return generate(ast, resolvedOptions);
}
const BindingTypes = {
    "DATA": "data",
    "PROPS": "props",
    "PROPS_ALIASED": "props-aliased",
    "SETUP_LET": "setup-let",
    "SETUP_CONST": "setup-const",
    "SETUP_REACTIVE_CONST": "setup-reactive-const",
    "SETUP_MAYBE_REF": "setup-maybe-ref",
    "SETUP_REF": "setup-ref",
    "OPTIONS": "options",
    "LITERAL_CONST": "literal-const"
};
const noopDirectiveTransform = ()=>({
        props: []
    });

},{"@vue/shared":"jjpTC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"jiQes":[function(require,module,exports) {
/*!
* Quasar Framework v2.19.3
* (c) 2015-present Razvan Stoenescu
* Released under the MIT License.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AddressbarColor", ()=>AddressbarColor_default);
parcelHelpers.export(exports, "AppFullscreen", ()=>Plugin);
parcelHelpers.export(exports, "AppVisibility", ()=>Plugin$1);
parcelHelpers.export(exports, "BottomSheet", ()=>BottomSheet_default);
parcelHelpers.export(exports, "ClosePopup", ()=>ClosePopup_default);
parcelHelpers.export(exports, "Cookies", ()=>Plugin$2);
parcelHelpers.export(exports, "Dark", ()=>Plugin$3);
parcelHelpers.export(exports, "Dialog", ()=>Dialog_default);
parcelHelpers.export(exports, "EventBus", ()=>EventBus);
parcelHelpers.export(exports, "IconSet", ()=>Plugin$4);
parcelHelpers.export(exports, "Intersection", ()=>Intersection_default);
parcelHelpers.export(exports, "Lang", ()=>Plugin$5);
parcelHelpers.export(exports, "Loading", ()=>Plugin$6);
parcelHelpers.export(exports, "LoadingBar", ()=>Plugin$7);
parcelHelpers.export(exports, "LocalStorage", ()=>Plugin$8);
parcelHelpers.export(exports, "Meta", ()=>Meta_default);
parcelHelpers.export(exports, "Morph", ()=>Morph_default);
parcelHelpers.export(exports, "Mutation", ()=>Mutation_default);
parcelHelpers.export(exports, "Notify", ()=>Notify_default);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "QAjaxBar", ()=>QAjaxBar_default);
parcelHelpers.export(exports, "QAvatar", ()=>QAvatar_default);
parcelHelpers.export(exports, "QBadge", ()=>QBadge_default);
parcelHelpers.export(exports, "QBanner", ()=>QBanner_default);
parcelHelpers.export(exports, "QBar", ()=>QBar_default);
parcelHelpers.export(exports, "QBreadcrumbs", ()=>QBreadcrumbs_default);
parcelHelpers.export(exports, "QBreadcrumbsEl", ()=>QBreadcrumbsEl_default);
parcelHelpers.export(exports, "QBtn", ()=>QBtn_default);
parcelHelpers.export(exports, "QBtnDropdown", ()=>QBtnDropdown_default);
parcelHelpers.export(exports, "QBtnGroup", ()=>QBtnGroup_default);
parcelHelpers.export(exports, "QBtnToggle", ()=>QBtnToggle_default);
parcelHelpers.export(exports, "QCard", ()=>QCard_default);
parcelHelpers.export(exports, "QCardActions", ()=>QCardActions_default);
parcelHelpers.export(exports, "QCardSection", ()=>QCardSection_default);
parcelHelpers.export(exports, "QCarousel", ()=>QCarousel_default);
parcelHelpers.export(exports, "QCarouselControl", ()=>QCarouselControl_default);
parcelHelpers.export(exports, "QCarouselSlide", ()=>QCarouselSlide_default);
parcelHelpers.export(exports, "QChatMessage", ()=>QChatMessage_default);
parcelHelpers.export(exports, "QCheckbox", ()=>QCheckbox_default);
parcelHelpers.export(exports, "QChip", ()=>QChip_default);
parcelHelpers.export(exports, "QCircularProgress", ()=>QCircularProgress_default);
parcelHelpers.export(exports, "QColor", ()=>QColor_default);
parcelHelpers.export(exports, "QDate", ()=>QDate_default);
parcelHelpers.export(exports, "QDialog", ()=>QDialog_default);
parcelHelpers.export(exports, "QDrawer", ()=>QDrawer_default);
parcelHelpers.export(exports, "QEditor", ()=>QEditor_default);
parcelHelpers.export(exports, "QExpansionItem", ()=>QExpansionItem_default);
parcelHelpers.export(exports, "QFab", ()=>QFab_default);
parcelHelpers.export(exports, "QFabAction", ()=>QFabAction_default);
parcelHelpers.export(exports, "QField", ()=>QField_default);
parcelHelpers.export(exports, "QFile", ()=>QFile_default);
parcelHelpers.export(exports, "QFooter", ()=>QFooter_default);
parcelHelpers.export(exports, "QForm", ()=>QForm_default);
parcelHelpers.export(exports, "QFormChildMixin", ()=>QFormChildMixin_default);
parcelHelpers.export(exports, "QHeader", ()=>QHeader_default);
parcelHelpers.export(exports, "QIcon", ()=>QIcon_default);
parcelHelpers.export(exports, "QImg", ()=>QImg_default);
parcelHelpers.export(exports, "QInfiniteScroll", ()=>QInfiniteScroll_default);
parcelHelpers.export(exports, "QInnerLoading", ()=>QInnerLoading_default);
parcelHelpers.export(exports, "QInput", ()=>QInput_default);
parcelHelpers.export(exports, "QIntersection", ()=>QIntersection_default);
parcelHelpers.export(exports, "QItem", ()=>QItem_default);
parcelHelpers.export(exports, "QItemLabel", ()=>QItemLabel_default);
parcelHelpers.export(exports, "QItemSection", ()=>QItemSection_default);
parcelHelpers.export(exports, "QKnob", ()=>QKnob_default);
parcelHelpers.export(exports, "QLayout", ()=>QLayout_default);
parcelHelpers.export(exports, "QLinearProgress", ()=>QLinearProgress_default);
parcelHelpers.export(exports, "QList", ()=>QList_default);
parcelHelpers.export(exports, "QMarkupTable", ()=>QMarkupTable_default);
parcelHelpers.export(exports, "QMenu", ()=>QMenu_default);
parcelHelpers.export(exports, "QNoSsr", ()=>QNoSsr_default);
parcelHelpers.export(exports, "QOptionGroup", ()=>QOptionGroup_default);
parcelHelpers.export(exports, "QPage", ()=>QPage_default);
parcelHelpers.export(exports, "QPageContainer", ()=>QPageContainer_default);
parcelHelpers.export(exports, "QPageScroller", ()=>QPageScroller_default);
parcelHelpers.export(exports, "QPageSticky", ()=>QPageSticky_default);
parcelHelpers.export(exports, "QPagination", ()=>QPagination_default);
parcelHelpers.export(exports, "QParallax", ()=>QParallax_default);
parcelHelpers.export(exports, "QPopupEdit", ()=>QPopupEdit_default);
parcelHelpers.export(exports, "QPopupProxy", ()=>QPopupProxy_default);
parcelHelpers.export(exports, "QPullToRefresh", ()=>QPullToRefresh_default);
parcelHelpers.export(exports, "QRadio", ()=>QRadio_default);
parcelHelpers.export(exports, "QRange", ()=>QRange_default);
parcelHelpers.export(exports, "QRating", ()=>QRating_default);
parcelHelpers.export(exports, "QResizeObserver", ()=>QResizeObserver_default);
parcelHelpers.export(exports, "QResponsive", ()=>QResponsive_default);
parcelHelpers.export(exports, "QRouteTab", ()=>QRouteTab_default);
parcelHelpers.export(exports, "QScrollArea", ()=>QScrollArea_default);
parcelHelpers.export(exports, "QScrollObserver", ()=>QScrollObserver_default);
parcelHelpers.export(exports, "QSelect", ()=>QSelect_default);
parcelHelpers.export(exports, "QSeparator", ()=>QSeparator_default);
parcelHelpers.export(exports, "QSkeleton", ()=>QSkeleton_default);
parcelHelpers.export(exports, "QSlideItem", ()=>QSlideItem_default);
parcelHelpers.export(exports, "QSlideTransition", ()=>QSlideTransition_default);
parcelHelpers.export(exports, "QSlider", ()=>QSlider_default);
parcelHelpers.export(exports, "QSpace", ()=>QSpace_default);
parcelHelpers.export(exports, "QSpinner", ()=>QSpinner_default);
parcelHelpers.export(exports, "QSpinnerAudio", ()=>QSpinnerAudio_default);
parcelHelpers.export(exports, "QSpinnerBall", ()=>QSpinnerBall_default);
parcelHelpers.export(exports, "QSpinnerBars", ()=>QSpinnerBars_default);
parcelHelpers.export(exports, "QSpinnerBox", ()=>QSpinnerBox_default);
parcelHelpers.export(exports, "QSpinnerClock", ()=>QSpinnerClock_default);
parcelHelpers.export(exports, "QSpinnerComment", ()=>QSpinnerComment_default);
parcelHelpers.export(exports, "QSpinnerCube", ()=>QSpinnerCube_default);
parcelHelpers.export(exports, "QSpinnerDots", ()=>QSpinnerDots_default);
parcelHelpers.export(exports, "QSpinnerFacebook", ()=>QSpinnerFacebook_default);
parcelHelpers.export(exports, "QSpinnerGears", ()=>QSpinnerGears_default);
parcelHelpers.export(exports, "QSpinnerGrid", ()=>QSpinnerGrid_default);
parcelHelpers.export(exports, "QSpinnerHearts", ()=>QSpinnerHearts_default);
parcelHelpers.export(exports, "QSpinnerHourglass", ()=>QSpinnerHourglass_default);
parcelHelpers.export(exports, "QSpinnerInfinity", ()=>QSpinnerInfinity_default);
parcelHelpers.export(exports, "QSpinnerIos", ()=>QSpinnerIos_default);
parcelHelpers.export(exports, "QSpinnerOrbit", ()=>QSpinnerOrbit_default);
parcelHelpers.export(exports, "QSpinnerOval", ()=>QSpinnerOval_default);
parcelHelpers.export(exports, "QSpinnerPie", ()=>QSpinnerPie_default);
parcelHelpers.export(exports, "QSpinnerPuff", ()=>QSpinnerPuff_default);
parcelHelpers.export(exports, "QSpinnerRadio", ()=>QSpinnerRadio_default);
parcelHelpers.export(exports, "QSpinnerRings", ()=>QSpinnerRings_default);
parcelHelpers.export(exports, "QSpinnerTail", ()=>QSpinnerTail_default);
parcelHelpers.export(exports, "QSplitter", ()=>QSplitter_default);
parcelHelpers.export(exports, "QStep", ()=>QStep_default);
parcelHelpers.export(exports, "QStepper", ()=>QStepper_default);
parcelHelpers.export(exports, "QStepperNavigation", ()=>QStepperNavigation_default);
parcelHelpers.export(exports, "QTab", ()=>QTab_default);
parcelHelpers.export(exports, "QTabPanel", ()=>QTabPanel_default);
parcelHelpers.export(exports, "QTabPanels", ()=>QTabPanels_default);
parcelHelpers.export(exports, "QTable", ()=>QTable_default);
parcelHelpers.export(exports, "QTabs", ()=>QTabs_default);
parcelHelpers.export(exports, "QTd", ()=>QTd_default);
parcelHelpers.export(exports, "QTh", ()=>QTh_default);
parcelHelpers.export(exports, "QTime", ()=>QTime_default);
parcelHelpers.export(exports, "QTimeline", ()=>QTimeline_default);
parcelHelpers.export(exports, "QTimelineEntry", ()=>QTimelineEntry_default);
parcelHelpers.export(exports, "QToggle", ()=>QToggle_default);
parcelHelpers.export(exports, "QToolbar", ()=>QToolbar_default);
parcelHelpers.export(exports, "QToolbarTitle", ()=>QToolbarTitle_default);
parcelHelpers.export(exports, "QTooltip", ()=>QTooltip_default);
parcelHelpers.export(exports, "QTr", ()=>QTr_default);
parcelHelpers.export(exports, "QTree", ()=>QTree_default);
parcelHelpers.export(exports, "QUploader", ()=>QUploader_default);
parcelHelpers.export(exports, "QUploaderAddTrigger", ()=>QUploaderAddTrigger_default);
parcelHelpers.export(exports, "QVideo", ()=>QVideo_default);
parcelHelpers.export(exports, "QVirtualScroll", ()=>QVirtualScroll_default);
parcelHelpers.export(exports, "Quasar", ()=>Quasar);
parcelHelpers.export(exports, "Ripple", ()=>Ripple_default);
parcelHelpers.export(exports, "Screen", ()=>Screen_default);
parcelHelpers.export(exports, "Scroll", ()=>Scroll_default);
parcelHelpers.export(exports, "ScrollFire", ()=>ScrollFire_default);
parcelHelpers.export(exports, "SessionStorage", ()=>Plugin$9);
parcelHelpers.export(exports, "TouchHold", ()=>TouchHold_default);
parcelHelpers.export(exports, "TouchPan", ()=>TouchPan_default);
parcelHelpers.export(exports, "TouchRepeat", ()=>TouchRepeat_default);
parcelHelpers.export(exports, "TouchSwipe", ()=>TouchSwipe_default);
parcelHelpers.export(exports, "clone", ()=>cloneDeep);
parcelHelpers.export(exports, "colors", ()=>colors_default);
parcelHelpers.export(exports, "copyToClipboard", ()=>copyToClipboard);
parcelHelpers.export(exports, "createMetaMixin", ()=>create_meta_mixin_default);
parcelHelpers.export(exports, "createUploaderComponent", ()=>create_uploader_component_default);
parcelHelpers.export(exports, "date", ()=>date_default);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "dom", ()=>dom_default);
parcelHelpers.export(exports, "event", ()=>event_default);
parcelHelpers.export(exports, "exportFile", ()=>exportFile);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "format", ()=>format_default);
parcelHelpers.export(exports, "frameDebounce", ()=>frameDebounce);
parcelHelpers.export(exports, "getCssVar", ()=>getCssVar);
parcelHelpers.export(exports, "is", ()=>is_default);
parcelHelpers.export(exports, "morph", ()=>morph);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "openURL", ()=>open_url_default);
parcelHelpers.export(exports, "patterns", ()=>patterns_default);
parcelHelpers.export(exports, "runSequentialPromises", ()=>runSequentialPromises);
parcelHelpers.export(exports, "scroll", ()=>scroll_default);
parcelHelpers.export(exports, "setCssVar", ()=>setCssVar);
parcelHelpers.export(exports, "throttle", ()=>throttle);
parcelHelpers.export(exports, "uid", ()=>uid);
parcelHelpers.export(exports, "useDialogPluginComponent", ()=>useDialogPluginComponent);
parcelHelpers.export(exports, "useFormChild", ()=>useFormChild);
parcelHelpers.export(exports, "useHydration", ()=>useHydration);
parcelHelpers.export(exports, "useId", ()=>useId);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useMeta", ()=>useMeta);
parcelHelpers.export(exports, "useQuasar", ()=>useQuasar);
parcelHelpers.export(exports, "useRenderCache", ()=>useRenderCache);
parcelHelpers.export(exports, "useSplitAttrs", ()=>useSplitAttrs);
parcelHelpers.export(exports, "useTick", ()=>useTick);
parcelHelpers.export(exports, "useTimeout", ()=>useTimeout);
var _vue = require("vue");
var global = arguments[3];
//#region src/flags.dev.js
/**
* Quasar runtime flags are needed only if NOT using
* Quasar CLI or @quasar/vite-plugin or vue-cli-plugin-quasar
*/ let attachPoint = null;
function getAttachPoint() {
    if (attachPoint !== null) return attachPoint;
    return attachPoint = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
}
if (typeof __QUASAR_SSR__ !== "boolean") getAttachPoint().__QUASAR_SSR__ = false;
if (typeof __QUASAR_SSR_CLIENT__ !== "boolean") getAttachPoint().__QUASAR_SSR_CLIENT__ = false;
if (typeof __QUASAR_SSR_PWA__ !== "boolean") getAttachPoint().__QUASAR_SSR_PWA__ = false;
//#endregion
//#region src/utils/private.inject-obj-prop/inject-obj-prop.js
function injectProp(target, propName, get, set) {
    Object.defineProperty(target, propName, {
        get,
        set,
        enumerable: true
    });
    return target;
}
function injectMultipleProps(target, props) {
    for(const key in props)injectProp(target, key, props[key]);
    return target;
}
//#endregion
//#region src/plugins/platform/Platform.js
/**
* __ QUASAR_SSR __            -> runs on SSR on client or server
* __ QUASAR_SSR_SERVER __     -> runs on SSR on server
* __ QUASAR_SSR_CLIENT __     -> runs on SSR on client
* __ QUASAR_SSR_PWA __        -> built with SSR+PWA; may run on SSR on client or on PWA client
*                              (needs runtime detection)
*/ const isRuntimeSsrPreHydration = (0, _vue.ref)(__QUASAR_SSR_CLIENT__ && (__QUASAR_SSR_PWA__ ? document.body.getAttribute("data-server-rendered") !== null : true));
let preHydrationBrowser;
function getMatch(userAgent, platformMatch) {
    const match = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(userAgent) || /(opr)[\/]([\w.]+)/.exec(userAgent) || /(vivaldi)[\/]([\w.]+)/.exec(userAgent) || /(chrome|crios)[\/]([\w.]+)/.exec(userAgent) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent) || /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent) || /(webkit)[\/]([\w.]+)/.exec(userAgent) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent) || [];
    return {
        browser: match[5] || match[3] || match[1] || "",
        version: match[4] || match[2] || "0",
        platform: platformMatch[0] || ""
    };
}
function getPlatformMatch(userAgent) {
    return /(ipad)/.exec(userAgent) || /(ipod)/.exec(userAgent) || /(windows phone)/.exec(userAgent) || /(iphone)/.exec(userAgent) || /(kindle)/.exec(userAgent) || /(silk)/.exec(userAgent) || /(android)/.exec(userAgent) || /(win)/.exec(userAgent) || /(mac)/.exec(userAgent) || /(linux)/.exec(userAgent) || /(cros)/.exec(userAgent) || /(playbook)/.exec(userAgent) || /(bb)/.exec(userAgent) || /(blackberry)/.exec(userAgent) || [];
}
const hasTouch = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function getPlatform(UA) {
    const userAgent = UA.toLowerCase();
    const matched = getMatch(userAgent, getPlatformMatch(userAgent));
    const browser = {
        mobile: false,
        desktop: false,
        cordova: false,
        capacitor: false,
        nativeMobile: false,
        electron: false,
        bex: false,
        linux: false,
        mac: false,
        win: false,
        cros: false,
        chrome: false,
        firefox: false,
        opera: false,
        safari: false,
        vivaldi: false,
        edge: false,
        edgeChromium: false,
        ie: false,
        webkit: false,
        android: false,
        ios: false,
        ipad: false,
        iphone: false,
        ipod: false,
        kindle: false,
        winphone: false,
        blackberry: false,
        playbook: false,
        silk: false
    };
    if (matched.browser) {
        browser[matched.browser] = true;
        browser.version = matched.version;
        browser.versionNumber = parseInt(matched.version, 10);
    }
    if (matched.platform) browser[matched.platform] = true;
    const knownMobiles = browser.android || browser.ios || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser["windows phone"];
    if (knownMobiles === true || userAgent.indexOf("mobile") !== -1) browser.mobile = true;
    else browser.desktop = true;
    if (browser["windows phone"]) {
        browser.winphone = true;
        delete browser["windows phone"];
    }
    if (browser.edga || browser.edgios || browser.edg) {
        browser.edge = true;
        matched.browser = "edge";
    } else if (browser.crios) {
        browser.chrome = true;
        matched.browser = "chrome";
    } else if (browser.fxios) {
        browser.firefox = true;
        matched.browser = "firefox";
    }
    if (browser.ipod || browser.ipad || browser.iphone) browser.ios = true;
    if (browser.vivaldi) {
        matched.browser = "vivaldi";
        browser.vivaldi = true;
    }
    if (browser.chrome || browser.opr || browser.safari || browser.vivaldi || browser.mobile === true && browser.ios !== true && knownMobiles !== true) browser.webkit = true;
    if (browser.opr) {
        matched.browser = "opera";
        browser.opera = true;
    }
    if (browser.safari) {
        if (browser.blackberry || browser.bb) {
            matched.browser = "blackberry";
            browser.blackberry = true;
        } else if (browser.playbook) {
            matched.browser = "playbook";
            browser.playbook = true;
        } else if (browser.android) {
            matched.browser = "android";
            browser.android = true;
        } else if (browser.kindle) {
            matched.browser = "kindle";
            browser.kindle = true;
        } else if (browser.silk) {
            matched.browser = "silk";
            browser.silk = true;
        }
    }
    browser.name = matched.browser;
    browser.platform = matched.platform;
    if (userAgent.indexOf("electron") !== -1) browser.electron = true;
    else if (document.location.href.indexOf("-extension://") !== -1) browser.bex = true;
    else {
        if (window.Capacitor !== void 0) {
            browser.capacitor = true;
            browser.nativeMobile = true;
            browser.nativeMobileWrapper = "capacitor";
        } else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
            browser.cordova = true;
            browser.nativeMobile = true;
            browser.nativeMobileWrapper = "cordova";
        }
        if (isRuntimeSsrPreHydration.value === true) preHydrationBrowser = {
            is: {
                ...browser
            }
        };
        if (hasTouch === true && browser.mac === true && (browser.desktop === true && browser.safari === true || browser.nativeMobile === true && browser.android !== true && browser.ios !== true && browser.ipad !== true)) {
            delete browser.mac;
            delete browser.desktop;
            const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
            Object.assign(browser, {
                mobile: true,
                ios: true,
                platform,
                [platform]: true
            });
        }
        if (browser.mobile !== true && window.navigator.userAgentData && window.navigator.userAgentData.mobile) {
            delete browser.desktop;
            browser.mobile = true;
        }
    }
    return browser;
}
const userAgent = navigator.userAgent || navigator.vendor || window.opera;
const ssrClient = {
    has: {
        touch: false,
        webStorage: false
    },
    within: {
        iframe: false
    }
};
const client = {
    userAgent,
    is: getPlatform(userAgent),
    has: {
        touch: hasTouch
    },
    within: {
        iframe: window.self !== window.top
    }
};
const Platform = {
    install (opts) {
        const { $q } = opts;
        if (isRuntimeSsrPreHydration.value === true) {
            opts.onSSRHydrated.push(()=>{
                Object.assign($q.platform, client);
                isRuntimeSsrPreHydration.value = false;
            });
            $q.platform = (0, _vue.reactive)(this);
        } else $q.platform = this;
    }
};
{
    let hasWebStorage;
    injectProp(client.has, "webStorage", ()=>{
        if (hasWebStorage !== void 0) return hasWebStorage;
        try {
            if (window.localStorage) {
                hasWebStorage = true;
                return true;
            }
        } catch  {}
        hasWebStorage = false;
        return false;
    });
    Object.assign(Platform, client);
    if (isRuntimeSsrPreHydration.value === true) {
        Object.assign(Platform, preHydrationBrowser, ssrClient);
        preHydrationBrowser = null;
    }
}//#endregion
//#region src/utils/private.create/create.js
function createComponent(raw) {
    return (0, _vue.markRaw)((0, _vue.defineComponent)(raw));
}
function createDirective(raw) {
    return (0, _vue.markRaw)(raw);
}
const createReactivePlugin = (state, plugin)=>{
    const reactiveState = (0, _vue.reactive)(state);
    for(const name in state)injectProp(plugin, name, ()=>reactiveState[name], (val)=>{
        reactiveState[name] = val;
    });
    return plugin;
};
//#endregion
//#region src/utils/event/event.js
const listenOpts = {
    hasPassive: false,
    passiveCapture: true,
    notPassiveCapture: true
};
try {
    const opts = Object.defineProperty({}, "passive", {
        get () {
            Object.assign(listenOpts, {
                hasPassive: true,
                passive: {
                    passive: true
                },
                notPassive: {
                    passive: false
                },
                passiveCapture: {
                    passive: true,
                    capture: true
                },
                notPassiveCapture: {
                    passive: false,
                    capture: true
                }
            });
        }
    });
    window.addEventListener("qtest", null, opts);
    window.removeEventListener("qtest", null, opts);
} catch  {}
function noop() {}
function leftClick(e) {
    return e.button === 0;
}
function middleClick(e) {
    return e.button === 1;
}
function rightClick(e) {
    return e.button === 2;
}
function position(e) {
    if (e.touches && e.touches[0]) e = e.touches[0];
    else if (e.changedTouches && e.changedTouches[0]) e = e.changedTouches[0];
    else if (e.targetTouches && e.targetTouches[0]) e = e.targetTouches[0];
    return {
        top: e.clientY,
        left: e.clientX
    };
}
function getEventPath(e) {
    if (e.path) return e.path;
    if (e.composedPath) return e.composedPath();
    const path = [];
    let el = e.target;
    while(el){
        path.push(el);
        if (el.tagName === "HTML") {
            path.push(document);
            path.push(window);
            return path;
        }
        el = el.parentElement;
    }
}
const LINE_HEIGHT = 40, PAGE_HEIGHT = 800;
function getMouseWheelDistance(e) {
    let x = e.deltaX, y = e.deltaY;
    if ((x || y) && e.deltaMode) {
        const multiplier = e.deltaMode === 1 ? LINE_HEIGHT : PAGE_HEIGHT;
        x *= multiplier;
        y *= multiplier;
    }
    if (e.shiftKey && !x) [y, x] = [
        x,
        y
    ];
    return {
        x,
        y
    };
}
function stop(e) {
    e.stopPropagation();
}
function prevent(e) {
    if (e.cancelable !== false) e.preventDefault();
}
function stopAndPrevent(e) {
    if (e.cancelable !== false) e.preventDefault();
    e.stopPropagation();
}
function preventDraggable(el, status) {
    if (el === void 0 || status === true && el.__dragPrevented === true) return;
    const fn = status === true ? (element)=>{
        element.__dragPrevented = true;
        element.addEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
    } : (element)=>{
        delete element.__dragPrevented;
        element.removeEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
    };
    el.querySelectorAll("a, img").forEach(fn);
}
function addEvt(ctx, targetName, events) {
    const name = `__q_${targetName}_evt`;
    ctx[name] = ctx[name] !== void 0 ? ctx[name].concat(events) : events;
    events.forEach((evt)=>{
        evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
}
function cleanEvt(ctx, targetName) {
    const name = `__q_${targetName}_evt`;
    if (ctx[name] !== void 0) {
        ctx[name].forEach((evt)=>{
            evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
        });
        ctx[name] = void 0;
    }
}
var event_default = {
    listenOpts,
    leftClick,
    middleClick,
    rightClick,
    position,
    getEventPath,
    getMouseWheelDistance,
    stop,
    prevent,
    stopAndPrevent,
    preventDraggable
};
//#endregion
//#region src/utils/debounce/debounce.js
function debounce(fn, wait = 250, immediate) {
    let timer = null;
    function debounced() {
        const args = arguments;
        const later = ()=>{
            timer = null;
            if (immediate !== true) fn.apply(this, args);
        };
        if (timer !== null) clearTimeout(timer);
        else if (immediate === true) fn.apply(this, args);
        timer = setTimeout(later, wait);
    }
    debounced.cancel = ()=>{
        if (timer !== null) clearTimeout(timer);
    };
    return debounced;
}
//#endregion
//#region src/plugins/screen/Screen.js
const SIZE_LIST = [
    "sm",
    "md",
    "lg",
    "xl"
];
const { passive: passive$4 } = listenOpts;
var Screen_default = createReactivePlugin({
    width: 0,
    height: 0,
    name: "xs",
    sizes: {
        sm: 600,
        md: 1024,
        lg: 1440,
        xl: 1920
    },
    lt: {
        sm: true,
        md: true,
        lg: true,
        xl: true
    },
    gt: {
        xs: false,
        sm: false,
        md: false,
        lg: false
    },
    xs: true,
    sm: false,
    md: false,
    lg: false,
    xl: false
}, {
    setSizes: noop,
    setDebounce: noop,
    install ({ $q, onSSRHydrated }) {
        $q.screen = this;
        if (this.__installed === true) {
            if ($q.config.screen !== void 0) {
                if ($q.config.screen.bodyClasses === false) document.body.classList.remove(`screen--${this.name}`);
                else this.__update(true);
            }
            return;
        }
        const { visualViewport } = window;
        const target = visualViewport || window;
        const scrollingElement = document.scrollingElement || document.documentElement;
        const getSize = visualViewport === void 0 || client.is.mobile === true ? ()=>[
                Math.max(window.innerWidth, scrollingElement.clientWidth),
                Math.max(window.innerHeight, scrollingElement.clientHeight)
            ] : ()=>[
                visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth,
                visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight
            ];
        const classes = $q.config.screen?.bodyClasses === true;
        this.__update = (force)=>{
            const [w, h] = getSize();
            if (h !== this.height) this.height = h;
            if (w !== this.width) this.width = w;
            else if (force !== true) return;
            let s = this.sizes;
            this.gt.xs = w >= s.sm;
            this.gt.sm = w >= s.md;
            this.gt.md = w >= s.lg;
            this.gt.lg = w >= s.xl;
            this.lt.sm = w < s.sm;
            this.lt.md = w < s.md;
            this.lt.lg = w < s.lg;
            this.lt.xl = w < s.xl;
            this.xs = this.lt.sm;
            this.sm = this.gt.xs === true && this.lt.md === true;
            this.md = this.gt.sm === true && this.lt.lg === true;
            this.lg = this.gt.md === true && this.lt.xl === true;
            this.xl = this.gt.lg;
            s = this.xs === true && "xs" || this.sm === true && "sm" || this.md === true && "md" || this.lg === true && "lg" || "xl";
            if (s !== this.name) {
                if (classes === true) {
                    document.body.classList.remove(`screen--${this.name}`);
                    document.body.classList.add(`screen--${s}`);
                }
                this.name = s;
            }
        };
        let updateEvt, updateSizes = {}, updateDebounce = 16;
        this.setSizes = (sizes)=>{
            SIZE_LIST.forEach((name)=>{
                if (sizes[name] !== void 0) updateSizes[name] = sizes[name];
            });
        };
        this.setDebounce = (deb)=>{
            updateDebounce = deb;
        };
        const start = ()=>{
            const style = getComputedStyle(document.body);
            if (style.getPropertyValue("--q-size-sm")) SIZE_LIST.forEach((name)=>{
                this.sizes[name] = parseInt(style.getPropertyValue(`--q-size-${name}`), 10);
            });
            this.setSizes = (sizes)=>{
                SIZE_LIST.forEach((name)=>{
                    if (sizes[name]) this.sizes[name] = sizes[name];
                });
                this.__update(true);
            };
            this.setDebounce = (delay)=>{
                if (updateEvt !== void 0) target.removeEventListener("resize", updateEvt, passive$4);
                updateEvt = delay > 0 ? debounce(this.__update, delay) : this.__update;
                target.addEventListener("resize", updateEvt, passive$4);
            };
            this.setDebounce(updateDebounce);
            if (Object.keys(updateSizes).length !== 0) {
                this.setSizes(updateSizes);
                updateSizes = void 0;
            } else this.__update();
            if (classes === true && this.name === "xs") document.body.classList.add("screen--xs");
        };
        if (isRuntimeSsrPreHydration.value === true) onSSRHydrated.push(start);
        else start();
    }
});
//#endregion
//#region src/plugins/dark/Dark.js
const Plugin$3 = createReactivePlugin({
    isActive: false,
    mode: false
}, {
    __media: void 0,
    set (val) {
        Plugin$3.mode = val;
        if (val === "auto") {
            if (Plugin$3.__media === void 0) {
                Plugin$3.__media = window.matchMedia("(prefers-color-scheme: dark)");
                Plugin$3.__updateMedia = ()=>{
                    Plugin$3.set("auto");
                };
                Plugin$3.__media.addListener(Plugin$3.__updateMedia);
            }
            val = Plugin$3.__media.matches;
        } else if (Plugin$3.__media !== void 0) {
            Plugin$3.__media.removeListener(Plugin$3.__updateMedia);
            Plugin$3.__media = void 0;
        }
        Plugin$3.isActive = val === true;
        document.body.classList.remove(`body--${val === true ? "light" : "dark"}`);
        document.body.classList.add(`body--${val === true ? "dark" : "light"}`);
    },
    toggle () {
        Plugin$3.set(Plugin$3.isActive === false);
    },
    install ({ $q, ssrContext }) {
        const dark = __QUASAR_SSR_CLIENT__ ? document.body.classList.contains("body--dark") : $q.config.dark;
        $q.dark = this;
        if (this.__installed !== true) this.set(dark !== void 0 ? dark : false);
    }
});
//#endregion
//#region src/utils/css-var/set-css-var.js
function setCssVar(propName, value1, element = document.body) {
    if (typeof propName !== "string") throw new TypeError("Expected a string as propName");
    if (typeof value1 !== "string") throw new TypeError("Expected a string as value");
    if (!(element instanceof Element)) throw new TypeError("Expected a DOM element");
    element.style.setProperty(`--q-${propName}`, value1);
}
//#endregion
//#region src/utils/private.keyboard/key-composition.js
let lastKeyCompositionStatus = false;
function onKeyDownComposition(evt) {
    lastKeyCompositionStatus = evt.isComposing === true;
}
function shouldIgnoreKey(evt) {
    return lastKeyCompositionStatus === true || evt !== Object(evt) || evt.isComposing === true || evt.qKeyEvent === true;
}
function isKeyCode(evt, keyCodes) {
    return shouldIgnoreKey(evt) === true ? false : [].concat(keyCodes).includes(evt.keyCode);
}
//#endregion
//#region src/plugins/private.body/Body.js
function getMobilePlatform(is) {
    if (is.ios === true) return "ios";
    if (is.android === true) return "android";
}
function getBodyClasses({ is, has, within }, cfg) {
    const cls = [
        is.desktop === true ? "desktop" : "mobile",
        `${has.touch === false ? "no-" : ""}touch`
    ];
    if (is.mobile === true) {
        const mobile = getMobilePlatform(is);
        if (mobile !== void 0) cls.push("platform-" + mobile);
    }
    if (is.nativeMobile === true) {
        const type = is.nativeMobileWrapper;
        cls.push(type);
        cls.push("native-mobile");
        if (is.ios === true && (cfg[type] === void 0 || cfg[type].iosStatusBarPadding !== false)) cls.push("q-ios-padding");
    } else if (is.electron === true) cls.push("electron");
    else if (is.bex === true) cls.push("bex");
    if (within.iframe === true) cls.push("within-iframe");
    return cls;
}
function applyClientSsrCorrections() {
    const { is } = client;
    const classes = document.body.className;
    const classList = new Set(classes.replace(/ {2}/g, " ").split(" "));
    if (is.nativeMobile !== true && is.electron !== true && is.bex !== true) {
        if (is.desktop === true) {
            classList.delete("mobile");
            classList.delete("platform-ios");
            classList.delete("platform-android");
            classList.add("desktop");
        } else if (is.mobile === true) {
            classList.delete("desktop");
            classList.add("mobile");
            classList.delete("platform-ios");
            classList.delete("platform-android");
            const mobile = getMobilePlatform(is);
            if (mobile !== void 0) classList.add(`platform-${mobile}`);
        }
    }
    if (client.has.touch === true) {
        classList.delete("no-touch");
        classList.add("touch");
    }
    if (client.within.iframe === true) classList.add("within-iframe");
    const newCls = Array.from(classList).join(" ");
    if (classes !== newCls) document.body.className = newCls;
}
function setColors(brand) {
    for(const color in brand)setCssVar(color, brand[color]);
}
var Body_default = {
    install (opts) {
        if (this.__installed === true) return;
        if (isRuntimeSsrPreHydration.value === true) applyClientSsrCorrections();
        else {
            const { $q } = opts;
            if ($q.config.brand !== void 0) setColors($q.config.brand);
            const cls = getBodyClasses(client, $q.config);
            document.body.classList.add.apply(document.body.classList, cls);
        }
        if (client.is.ios === true) document.body.addEventListener("touchstart", noop);
        window.addEventListener("keydown", onKeyDownComposition, true);
    }
};
//#endregion
//#region src/plugins/private.history/History.js
const getTrue = ()=>true;
function filterInvalidPath(path) {
    return typeof path === "string" && path !== "" && path !== "/" && path !== "#/";
}
function normalizeExitPath(path) {
    if (path.startsWith("#") === true) path = path.substring(1);
    if (path.startsWith("/") === false) path = "/" + path;
    if (path.endsWith("/") === true) path = path.substring(0, path.length - 1);
    return "#" + path;
}
function getShouldExitFn(cfg) {
    if (cfg.backButtonExit === false) return ()=>false;
    if (cfg.backButtonExit === "*") return getTrue;
    const exitPaths = [
        "#/"
    ];
    if (Array.isArray(cfg.backButtonExit) === true) exitPaths.push(...cfg.backButtonExit.filter(filterInvalidPath).map(normalizeExitPath));
    return ()=>exitPaths.includes(window.location.hash);
}
var History_default = {
    __history: [],
    add: noop,
    remove: noop,
    install ({ $q }) {
        if (this.__installed === true) return;
        const { cordova: cordova1, capacitor } = client.is;
        if (cordova1 !== true && capacitor !== true) return;
        const qConf = $q.config[cordova1 === true ? "cordova" : "capacitor"];
        if (qConf?.backButton === false) return;
        if (capacitor === true && (window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)) return;
        this.add = (entry)=>{
            if (entry.condition === void 0) entry.condition = getTrue;
            this.__history.push(entry);
        };
        this.remove = (entry)=>{
            const index = this.__history.indexOf(entry);
            if (index >= 0) this.__history.splice(index, 1);
        };
        const shouldExit = getShouldExitFn(Object.assign({
            backButtonExit: true
        }, qConf));
        const backHandler = ()=>{
            if (this.__history.length) {
                const entry = this.__history[this.__history.length - 1];
                if (entry.condition() === true) {
                    this.__history.pop();
                    entry.handler();
                }
            } else if (shouldExit() === true) navigator.app.exitApp();
            else window.history.back();
        };
        if (cordova1 === true) document.addEventListener("deviceready", ()=>{
            document.addEventListener("backbutton", backHandler, false);
        });
        else window.Capacitor.Plugins.App.addListener("backButton", backHandler);
    }
};
//#endregion
//#region lang/en-US.js
var en_US_default = {
    isoName: "en-US",
    nativeName: "English (US)",
    label: {
        clear: "Clear",
        ok: "OK",
        cancel: "Cancel",
        close: "Close",
        set: "Set",
        select: "Select",
        reset: "Reset",
        remove: "Remove",
        update: "Update",
        create: "Create",
        search: "Search",
        filter: "Filter",
        refresh: "Refresh",
        expand: (label)=>label ? `Expand "${label}"` : "Expand",
        collapse: (label)=>label ? `Collapse "${label}"` : "Collapse"
    },
    date: {
        days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        firstDayOfWeek: 0,
        format24h: false,
        pluralDay: "days",
        prevMonth: "Previous month",
        nextMonth: "Next month",
        prevYear: "Previous year",
        nextYear: "Next year",
        today: "Today",
        prevRangeYears: (range)=>`Previous ${range} years`,
        nextRangeYears: (range)=>`Next ${range} years`
    },
    table: {
        noData: "No data available",
        noResults: "No matching records found",
        loading: "Loading...",
        selectedRecords: (rows)=>rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
        recordsPerPage: "Records per page:",
        allRows: "All",
        pagination: (start, end, total)=>start + "-" + end + " of " + total,
        columns: "Columns"
    },
    pagination: {
        first: "First page",
        prev: "Previous page",
        next: "Next page",
        last: "Last page"
    },
    editor: {
        url: "URL",
        bold: "Bold",
        italic: "Italic",
        strikethrough: "Strikethrough",
        underline: "Underline",
        unorderedList: "Unordered List",
        orderedList: "Ordered List",
        subscript: "Subscript",
        superscript: "Superscript",
        hyperlink: "Hyperlink",
        toggleFullscreen: "Toggle Fullscreen",
        quote: "Quote",
        left: "Left align",
        center: "Center align",
        right: "Right align",
        justify: "Justify align",
        print: "Print",
        outdent: "Decrease indentation",
        indent: "Increase indentation",
        removeFormat: "Remove formatting",
        formatting: "Formatting",
        fontSize: "Font Size",
        align: "Align",
        hr: "Insert Horizontal Rule",
        undo: "Undo",
        redo: "Redo",
        heading1: "Heading 1",
        heading2: "Heading 2",
        heading3: "Heading 3",
        heading4: "Heading 4",
        heading5: "Heading 5",
        heading6: "Heading 6",
        paragraph: "Paragraph",
        code: "Code",
        size1: "Very small",
        size2: "A bit small",
        size3: "Normal",
        size4: "Medium-large",
        size5: "Big",
        size6: "Very big",
        size7: "Maximum",
        defaultFont: "Default Font",
        viewSource: "View Source"
    },
    tree: {
        noNodes: "No nodes available",
        noResults: "No matching nodes found"
    }
};
//#endregion
//#region src/plugins/lang/Lang.js
function getLocale() {
    const val = Array.isArray(navigator.languages) === true && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
    if (typeof val === "string") return val.split(/[-_]/).map((v, i)=>i === 0 ? v.toLowerCase() : i > 1 || v.length < 4 ? v.toUpperCase() : v[0].toUpperCase() + v.slice(1).toLowerCase()).join("-");
}
const Plugin$5 = createReactivePlugin({
    __qLang: {}
}, {
    getLocale,
    set (langObject = en_US_default, ssrContext) {
        const lang = {
            ...langObject,
            rtl: langObject.rtl === true,
            getLocale
        };
        lang.set = Plugin$5.set;
        if (Plugin$5.__langConfig === void 0 || Plugin$5.__langConfig.noHtmlAttrs !== true) {
            const el = document.documentElement;
            el.setAttribute("dir", lang.rtl === true ? "rtl" : "ltr");
            el.setAttribute("lang", lang.isoName);
        }
        Object.assign(Plugin$5.__qLang, lang);
    },
    install ({ $q, lang, ssrContext }) {
        $q.lang = Plugin$5.__qLang;
        Plugin$5.__langConfig = $q.config.lang;
        if (this.__installed === true) {
            if (lang !== void 0) this.set(lang);
        } else {
            this.props = new Proxy(this.__qLang, {
                get () {
                    return Reflect.get(...arguments);
                },
                ownKeys (target) {
                    return Reflect.ownKeys(target).filter((key)=>key !== "set" && key !== "getLocale");
                }
            });
            this.set(lang || en_US_default);
        }
    }
});
//#endregion
//#region icon-set/material-icons.js
var material_icons_default = {
    name: "material-icons",
    type: {
        positive: "check_circle",
        negative: "warning",
        info: "info",
        warning: "priority_high"
    },
    arrow: {
        up: "arrow_upward",
        right: "arrow_forward",
        down: "arrow_downward",
        left: "arrow_back",
        dropdown: "arrow_drop_down"
    },
    chevron: {
        left: "chevron_left",
        right: "chevron_right"
    },
    colorPicker: {
        spectrum: "gradient",
        tune: "tune",
        palette: "style"
    },
    pullToRefresh: {
        icon: "refresh"
    },
    carousel: {
        left: "chevron_left",
        right: "chevron_right",
        up: "keyboard_arrow_up",
        down: "keyboard_arrow_down",
        navigationIcon: "lens"
    },
    chip: {
        remove: "cancel",
        selected: "check"
    },
    datetime: {
        arrowLeft: "chevron_left",
        arrowRight: "chevron_right",
        now: "access_time",
        today: "today"
    },
    editor: {
        bold: "format_bold",
        italic: "format_italic",
        strikethrough: "strikethrough_s",
        underline: "format_underlined",
        unorderedList: "format_list_bulleted",
        orderedList: "format_list_numbered",
        subscript: "vertical_align_bottom",
        superscript: "vertical_align_top",
        hyperlink: "link",
        toggleFullscreen: "fullscreen",
        quote: "format_quote",
        left: "format_align_left",
        center: "format_align_center",
        right: "format_align_right",
        justify: "format_align_justify",
        print: "print",
        outdent: "format_indent_decrease",
        indent: "format_indent_increase",
        removeFormat: "format_clear",
        formatting: "text_format",
        fontSize: "format_size",
        align: "format_align_left",
        hr: "remove",
        undo: "undo",
        redo: "redo",
        heading: "format_size",
        code: "code",
        size: "format_size",
        font: "font_download",
        viewSource: "code"
    },
    expansionItem: {
        icon: "keyboard_arrow_down",
        denseIcon: "arrow_drop_down"
    },
    fab: {
        icon: "add",
        activeIcon: "close"
    },
    field: {
        clear: "cancel",
        error: "error"
    },
    pagination: {
        first: "first_page",
        prev: "keyboard_arrow_left",
        next: "keyboard_arrow_right",
        last: "last_page"
    },
    rating: {
        icon: "grade"
    },
    stepper: {
        done: "check",
        active: "edit",
        error: "warning"
    },
    tabs: {
        left: "chevron_left",
        right: "chevron_right",
        up: "keyboard_arrow_up",
        down: "keyboard_arrow_down"
    },
    table: {
        arrowUp: "arrow_upward",
        warning: "warning",
        firstPage: "first_page",
        prevPage: "chevron_left",
        nextPage: "chevron_right",
        lastPage: "last_page"
    },
    tree: {
        icon: "play_arrow"
    },
    uploader: {
        done: "done",
        clear: "clear",
        add: "add_box",
        upload: "cloud_upload",
        removeQueue: "clear_all",
        removeUploaded: "done_all"
    }
};
//#endregion
//#region src/plugins/icon-set/IconSet.js
const Plugin$4 = createReactivePlugin({
    iconMapFn: null,
    __qIconSet: {}
}, {
    set (setObject, ssrContext) {
        const def = {
            ...setObject
        };
        def.set = Plugin$4.set;
        Object.assign(Plugin$4.__qIconSet, def);
    },
    install ({ $q, iconSet, ssrContext }) {
        if ($q.config.iconMapFn !== void 0) this.iconMapFn = $q.config.iconMapFn;
        $q.iconSet = this.__qIconSet;
        injectProp($q, "iconMapFn", ()=>this.iconMapFn, (val)=>{
            this.iconMapFn = val;
        });
        if (this.__installed === true) {
            if (iconSet !== void 0) this.set(iconSet);
        } else {
            this.props = new Proxy(this.__qIconSet, {
                get () {
                    return Reflect.get(...arguments);
                },
                ownKeys (target) {
                    return Reflect.ownKeys(target).filter((key)=>key !== "set");
                }
            });
            this.set(iconSet || material_icons_default);
        }
    }
});
//#endregion
//#region src/utils/private.symbols/symbols.js
const timelineKey = "_q_t_";
const stepperKey = "_q_s_";
const layoutKey = "_q_l_";
const pageContainerKey = "_q_pc_";
const fabKey = "_q_f_";
const formKey = "_q_fo_";
const tabsKey = "_q_tabs_";
const uploaderKey = "_q_u_";
function emptyRenderFn() {}
//#endregion
//#region src/utils/private.config/instance-config.js
const globalConfig = {};
let globalConfigIsFrozen = false;
function freezeGlobalConfig() {
    globalConfigIsFrozen = true;
}
//#endregion
//#region src/utils/is/is.js
function isDeepEqual(a, b) {
    if (a === b) return true;
    if (a !== null && b !== null && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length, i;
        if (a.constructor === Array) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (isDeepEqual(a[i], b[i]) !== true) return false;
            return true;
        }
        if (a.constructor === Map) {
            if (a.size !== b.size) return false;
            let iter = a.entries();
            i = iter.next();
            while(i.done !== true){
                if (b.has(i.value[0]) !== true) return false;
                i = iter.next();
            }
            iter = a.entries();
            i = iter.next();
            while(i.done !== true){
                if (isDeepEqual(i.value[1], b.get(i.value[0])) !== true) return false;
                i = iter.next();
            }
            return true;
        }
        if (a.constructor === Set) {
            if (a.size !== b.size) return false;
            const iter = a.entries();
            i = iter.next();
            while(i.done !== true){
                if (b.has(i.value[0]) !== true) return false;
                i = iter.next();
            }
            return true;
        }
        if (a.buffer != null && a.buffer.constructor === ArrayBuffer) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a).filter((key)=>a[key] !== void 0);
        length = keys.length;
        if (length !== Object.keys(b).filter((key)=>b[key] !== void 0).length) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (isDeepEqual(a[key], b[key]) !== true) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function isObject(v) {
    return v !== null && typeof v === "object" && Array.isArray(v) !== true;
}
function isDate(v) {
    return Object.prototype.toString.call(v) === "[object Date]";
}
function isRegexp(v) {
    return Object.prototype.toString.call(v) === "[object RegExp]";
}
function isNumber(v) {
    return typeof v === "number" && isFinite(v);
}
var is_default = {
    deepEqual: isDeepEqual,
    object: isObject,
    date: isDate,
    regexp: isRegexp,
    number: isNumber
};
//#endregion
//#region src/install-quasar.js
/**
* If the list below changes, make sure
* to also edit /ui/testing/specs/generators/generator.plugin.js
* on the "autoInstalledPlugins" array
*/ const autoInstalledPlugins = [
    Platform,
    Body_default,
    Plugin$3,
    Screen_default,
    History_default,
    Plugin$5,
    Plugin$4
];
function createChildApp(appCfg, parentApp) {
    const app = (0, _vue.createApp)(appCfg);
    app.config.globalProperties = parentApp.config.globalProperties;
    const { reload, ...appContext } = parentApp._context;
    Object.assign(app._context, appContext);
    return app;
}
function installPlugins(pluginOpts, pluginList) {
    pluginList.forEach((Plugin)=>{
        Plugin.install(pluginOpts);
        Plugin.__installed = true;
    });
}
function prepareApp(app, uiOpts, pluginOpts) {
    app.config.globalProperties.$q = pluginOpts.$q;
    app.provide("_q_", pluginOpts.$q);
    installPlugins(pluginOpts, autoInstalledPlugins);
    if (uiOpts.components !== void 0) Object.values(uiOpts.components).forEach((c)=>{
        if (isObject(c) === true && c.name !== void 0) app.component(c.name, c);
    });
    if (uiOpts.directives !== void 0) Object.values(uiOpts.directives).forEach((d)=>{
        if (isObject(d) === true && d.name !== void 0) app.directive(d.name, d);
    });
    if (uiOpts.plugins !== void 0) installPlugins(pluginOpts, Object.values(uiOpts.plugins).filter((p)=>typeof p.install === "function" && autoInstalledPlugins.includes(p) === false));
    if (isRuntimeSsrPreHydration.value === true) pluginOpts.$q.onSSRHydrated = ()=>{
        pluginOpts.onSSRHydrated.forEach((fn)=>{
            fn();
        });
        pluginOpts.$q.onSSRHydrated = ()=>{};
    };
}
var install_quasar_default = function installQuasar(parentApp, opts = {}) {
    const $q = {
        version: "2.19.3"
    };
    if (globalConfigIsFrozen === false) {
        if (opts.config !== void 0) Object.assign(globalConfig, opts.config);
        $q.config = {
            ...globalConfig
        };
        freezeGlobalConfig();
    } else $q.config = opts.config || {};
    prepareApp(parentApp, opts, {
        parentApp,
        $q,
        lang: opts.lang,
        iconSet: opts.iconSet,
        onSSRHydrated: []
    });
};
//#endregion
//#region src/utils/format/format.js
const units = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB"
];
function humanStorageSize(bytes, decimals = 1) {
    let u = 0;
    while(parseInt(bytes, 10) >= 1024 && u < units.length - 1){
        bytes /= 1024;
        ++u;
    }
    return `${bytes.toFixed(decimals)}${units[u]}`;
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function between(v, min, max) {
    return max <= min ? min : Math.min(max, Math.max(min, v));
}
function normalizeToInterval(v, min, max) {
    if (max <= min) return min;
    const size = max - min + 1;
    let index = min + (v - min) % size;
    if (index < min) index = size + index;
    return index === 0 ? 0 : index;
}
function pad(v, length = 2, char = "0") {
    if (v === void 0 || v === null) return v;
    const val = String(v);
    return val.length >= length ? val : new Array(length - val.length + 1).join(char) + val;
}
var format_default = {
    humanStorageSize,
    capitalize,
    between,
    normalizeToInterval,
    pad
};
//#endregion
//#region src/components/ajax-bar/QAjaxBar.js
const xhr = XMLHttpRequest, open = xhr.prototype.open, positionValues = [
    "top",
    "right",
    "bottom",
    "left"
];
let stack = [];
let highjackCount = 0;
function translate({ p, pos, active, horiz, reverse, dir }) {
    let x = 1, y = 1;
    if (horiz === true) {
        if (reverse === true) x = -1;
        if (pos === "bottom") y = -1;
        return {
            transform: `translate3d(${x * (p - 100)}%,${active ? 0 : y * -200}%,0)`
        };
    }
    if (reverse === true) y = -1;
    if (pos === "right") x = -1;
    return {
        transform: `translate3d(${active ? 0 : dir * x * -200}%,${y * (p - 100)}%,0)`
    };
}
function inc(p, amount) {
    if (typeof amount !== "number") {
        if (p < 25) amount = Math.random() * 3 + 3;
        else if (p < 65) amount = Math.random() * 3;
        else if (p < 85) amount = Math.random() * 2;
        else if (p < 99) amount = .6;
        else amount = 0;
    }
    return between(p + amount, 0, 100);
}
function highjackAjax(stackEntry) {
    highjackCount++;
    stack.push(stackEntry);
    if (highjackCount > 1) return;
    xhr.prototype.open = function qOpen(_, url) {
        const stopStack = [];
        const loadStart = ()=>{
            stack.forEach((entry)=>{
                if (entry.hijackFilter.value === null || entry.hijackFilter.value(url) === true) {
                    entry.start();
                    stopStack.push(entry.stop);
                }
            });
        };
        const loadEnd = ()=>{
            stopStack.forEach((stop)=>{
                stop();
            });
        };
        this.addEventListener("loadstart", loadStart, {
            once: true
        });
        this.addEventListener("loadend", loadEnd, {
            once: true
        });
        open.apply(this, arguments);
    };
}
function restoreAjax(start) {
    stack = stack.filter((entry)=>entry.start !== start);
    highjackCount = Math.max(0, highjackCount - 1);
    if (highjackCount === 0) xhr.prototype.open = open;
}
var QAjaxBar_default = createComponent({
    name: "QAjaxBar",
    props: {
        position: {
            type: String,
            default: "top",
            validator: (val)=>positionValues.includes(val)
        },
        size: {
            type: String,
            default: "2px"
        },
        color: String,
        skipHijack: Boolean,
        reverse: Boolean,
        hijackFilter: Function
    },
    emits: [
        "start",
        "stop"
    ],
    setup (props, { emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const progress = (0, _vue.ref)(0);
        const onScreen = (0, _vue.ref)(false);
        const animate = (0, _vue.ref)(true);
        let sessions = 0, timer = null, speed;
        const classes = (0, _vue.computed)(()=>`q-loading-bar q-loading-bar--${props.position}` + (props.color !== void 0 ? ` bg-${props.color}` : "") + (animate.value === true ? "" : " no-transition"));
        const horizontal = (0, _vue.computed)(()=>props.position === "top" || props.position === "bottom");
        const sizeProp = (0, _vue.computed)(()=>horizontal.value === true ? "height" : "width");
        const style = (0, _vue.computed)(()=>{
            const active = onScreen.value;
            const obj = translate({
                p: progress.value,
                pos: props.position,
                active,
                horiz: horizontal.value,
                reverse: proxy.$q.lang.rtl === true && [
                    "top",
                    "bottom"
                ].includes(props.position) ? props.reverse === false : props.reverse,
                dir: proxy.$q.lang.rtl === true ? -1 : 1
            });
            obj[sizeProp.value] = props.size;
            obj.opacity = active ? 1 : 0;
            return obj;
        });
        const attributes = (0, _vue.computed)(()=>onScreen.value === true ? {
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": progress.value
            } : {
                "aria-hidden": "true"
            });
        function start(newSpeed = 300) {
            const oldSpeed = speed;
            speed = Math.max(0, newSpeed) || 0;
            sessions++;
            if (sessions > 1) {
                if (oldSpeed === 0 && newSpeed > 0) planNextStep();
                else if (timer !== null && oldSpeed > 0 && newSpeed <= 0) {
                    clearTimeout(timer);
                    timer = null;
                }
                return sessions;
            }
            if (timer !== null) clearTimeout(timer);
            emit("start");
            progress.value = 0;
            /**
			* We're trying to avoid side effects if start() is called inside a watchEffect()
			* so we're accessing the _value property directly (under the covers implementation detail of ref())
			*
			* Otherwise, any refs() accessed here would be marked as deps for the watchEffect()
			* -- and we are changing them below, which would cause an infinite loop
			*/ timer = setTimeout(()=>{
                timer = null;
                animate.value = true;
                if (newSpeed > 0) planNextStep();
            }, onScreen._value === true ? 500 : 1);
            if (onScreen._value !== true) {
                onScreen.value = true;
                animate.value = false;
            }
            return sessions;
        }
        function increment(amount) {
            if (sessions > 0) progress.value = inc(progress.value, amount);
            return sessions;
        }
        function stop() {
            sessions = Math.max(0, sessions - 1);
            if (sessions > 0) return sessions;
            if (timer !== null) {
                clearTimeout(timer);
                timer = null;
            }
            emit("stop");
            const end = ()=>{
                animate.value = true;
                progress.value = 100;
                timer = setTimeout(()=>{
                    timer = null;
                    onScreen.value = false;
                }, 1e3);
            };
            if (progress.value === 0) timer = setTimeout(end, 1);
            else end();
            return sessions;
        }
        function planNextStep() {
            if (progress.value < 100) timer = setTimeout(()=>{
                timer = null;
                increment();
                planNextStep();
            }, speed);
        }
        let hijacked;
        (0, _vue.onMounted)(()=>{
            if (props.skipHijack !== true) {
                hijacked = true;
                highjackAjax({
                    start,
                    stop,
                    hijackFilter: (0, _vue.computed)(()=>props.hijackFilter || null)
                });
            }
        });
        (0, _vue.onBeforeUnmount)(()=>{
            if (timer !== null) clearTimeout(timer);
            if (hijacked === true) restoreAjax(start);
        });
        Object.assign(proxy, {
            start,
            stop,
            increment
        });
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                style: style.value,
                ...attributes.value
            });
    }
});
//#endregion
//#region src/composables/private.use-size/use-size.js
const useSizeDefaults = {
    xs: 18,
    sm: 24,
    md: 32,
    lg: 38,
    xl: 46
};
const useSizeProps = {
    size: String
};
function useSize(props, sizes = useSizeDefaults) {
    return (0, _vue.computed)(()=>props.size !== void 0 ? {
            fontSize: props.size in sizes ? `${sizes[props.size]}px` : props.size
        } : null);
}
//#endregion
//#region src/utils/private.render/render.js
function hSlot(slot, otherwise) {
    return slot !== void 0 ? slot() || otherwise : otherwise;
}
function hUniqueSlot(slot, otherwise) {
    if (slot !== void 0) {
        const vnode = slot();
        if (vnode !== void 0 && vnode !== null) return vnode.slice();
    }
    return otherwise;
}
/**
* Source definitely exists,
* so it's merged with the possible slot
*/ function hMergeSlot(slot, source) {
    return slot !== void 0 ? source.concat(slot()) : source;
}
/**
* Merge with possible slot,
* even if source might not exist
*/ function hMergeSlotSafely(slot, source) {
    if (slot === void 0) return source;
    return source !== void 0 ? source.concat(slot()) : slot();
}
function hDir(tag, data, children, key, condition, getDirsFn) {
    data.key = key + condition;
    const vnode = (0, _vue.h)(tag, data, children);
    return condition === true ? (0, _vue.withDirectives)(vnode, getDirsFn()) : vnode;
}
//#endregion
//#region src/components/icon/QIcon.js
const defaultViewBox = "0 0 24 24";
const sameFn = (i)=>i;
const ionFn = (i)=>`ionicons ${i}`;
const libMap = {
    "mdi-": (i)=>`mdi ${i}`,
    "icon-": sameFn,
    "bt-": (i)=>`bt ${i}`,
    "eva-": (i)=>`eva ${i}`,
    "ion-md": ionFn,
    "ion-ios": ionFn,
    "ion-logo": ionFn,
    "iconfont ": sameFn,
    "ti-": (i)=>`themify-icon ${i}`,
    "bi-": (i)=>`bootstrap-icons ${i}`,
    "i-": sameFn
};
const matMap = {
    o_: "-outlined",
    r_: "-round",
    s_: "-sharp"
};
const symMap = {
    sym_o_: "-outlined",
    sym_r_: "-rounded",
    sym_s_: "-sharp"
};
const libRE = new RegExp("^(" + Object.keys(libMap).join("|") + ")");
const matRE = new RegExp("^(" + Object.keys(matMap).join("|") + ")");
const symRE = new RegExp("^(" + Object.keys(symMap).join("|") + ")");
const mRE = /^[Mm]\s?[-+]?\.?\d/;
const imgRE = /^img:/;
const svgUseRE = /^svguse:/;
const ionRE = /^ion-/;
const faRE = /^(fa-(classic|sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
var QIcon_default = createComponent({
    name: "QIcon",
    props: {
        ...useSizeProps,
        tag: {
            type: String,
            default: "i"
        },
        name: String,
        color: String,
        left: Boolean,
        right: Boolean
    },
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const sizeStyle = useSize(props);
        const classes = (0, _vue.computed)(()=>"q-icon" + (props.left === true ? " on-left" : "") + (props.right === true ? " on-right" : "") + (props.color !== void 0 ? ` text-${props.color}` : ""));
        const type = (0, _vue.computed)(()=>{
            let cls;
            let icon = props.name;
            if (icon === "none" || !icon) return {
                none: true
            };
            if ($q.iconMapFn !== null) {
                const res = $q.iconMapFn(icon);
                if (res !== void 0) {
                    if (res.icon !== void 0) {
                        icon = res.icon;
                        if (icon === "none" || !icon) return {
                            none: true
                        };
                    } else return {
                        cls: res.cls,
                        content: res.content !== void 0 ? res.content : " "
                    };
                }
            }
            if (mRE.test(icon) === true) {
                const [def, viewBox = defaultViewBox] = icon.split("|");
                return {
                    svg: true,
                    viewBox,
                    nodes: def.split("&&").map((path)=>{
                        const [d, style, transform] = path.split("@@");
                        return (0, _vue.h)("path", {
                            style,
                            d,
                            transform
                        });
                    })
                };
            }
            if (imgRE.test(icon) === true) return {
                img: true,
                src: icon.substring(4)
            };
            if (svgUseRE.test(icon) === true) {
                const [def, viewBox = defaultViewBox] = icon.split("|");
                return {
                    svguse: true,
                    src: def.substring(7),
                    viewBox
                };
            }
            let content = " ";
            const matches = icon.match(libRE);
            if (matches !== null) cls = libMap[matches[1]](icon);
            else if (faRE.test(icon) === true) cls = icon;
            else if (ionRE.test(icon) === true) cls = `ionicons ion-${$q.platform.is.ios === true ? "ios" : "md"}${icon.substring(3)}`;
            else if (symRE.test(icon) === true) {
                cls = "notranslate material-symbols";
                const symMatches = icon.match(symRE);
                if (symMatches !== null) {
                    icon = icon.substring(6);
                    cls += symMap[symMatches[1]];
                }
                content = icon;
            } else {
                cls = "notranslate material-icons";
                const matMatches = icon.match(matRE);
                if (matMatches !== null) {
                    icon = icon.substring(2);
                    cls += matMap[matMatches[1]];
                }
                content = icon;
            }
            return {
                cls,
                content
            };
        });
        return ()=>{
            const data = {
                class: classes.value,
                style: sizeStyle.value,
                "aria-hidden": "true"
            };
            if (type.value.none === true) return (0, _vue.h)(props.tag, data, hSlot(slots.default));
            if (type.value.img === true) return (0, _vue.h)(props.tag, data, hMergeSlot(slots.default, [
                (0, _vue.h)("img", {
                    src: type.value.src
                })
            ]));
            if (type.value.svg === true) return (0, _vue.h)(props.tag, data, hMergeSlot(slots.default, [
                (0, _vue.h)("svg", {
                    viewBox: type.value.viewBox || "0 0 24 24"
                }, type.value.nodes)
            ]));
            if (type.value.svguse === true) return (0, _vue.h)(props.tag, data, hMergeSlot(slots.default, [
                (0, _vue.h)("svg", {
                    viewBox: type.value.viewBox
                }, [
                    (0, _vue.h)("use", {
                        "xlink:href": type.value.src
                    })
                ])
            ]));
            if (type.value.cls !== void 0) data.class += " " + type.value.cls;
            return (0, _vue.h)(props.tag, data, hMergeSlot(slots.default, [
                type.value.content
            ]));
        };
    }
});
//#endregion
//#region src/components/avatar/QAvatar.js
var QAvatar_default = createComponent({
    name: "QAvatar",
    props: {
        ...useSizeProps,
        fontSize: String,
        color: String,
        textColor: String,
        icon: String,
        square: Boolean,
        rounded: Boolean
    },
    setup (props, { slots }) {
        const sizeStyle = useSize(props);
        const classes = (0, _vue.computed)(()=>"q-avatar" + (props.color ? ` bg-${props.color}` : "") + (props.textColor ? ` text-${props.textColor} q-chip--colored` : "") + (props.square === true ? " q-avatar--square" : props.rounded === true ? " rounded-borders" : ""));
        const contentStyle = (0, _vue.computed)(()=>props.fontSize ? {
                fontSize: props.fontSize
            } : null);
        return ()=>{
            const icon = props.icon !== void 0 ? [
                (0, _vue.h)(QIcon_default, {
                    name: props.icon
                })
            ] : void 0;
            return (0, _vue.h)("div", {
                class: classes.value,
                style: sizeStyle.value
            }, [
                (0, _vue.h)("div", {
                    class: "q-avatar__content row flex-center overflow-hidden",
                    style: contentStyle.value
                }, hMergeSlotSafely(slots.default, icon))
            ]);
        };
    }
});
//#endregion
//#region src/components/badge/QBadge.js
const alignValues$3 = [
    "top",
    "middle",
    "bottom"
];
var QBadge_default = createComponent({
    name: "QBadge",
    props: {
        color: String,
        textColor: String,
        floating: Boolean,
        transparent: Boolean,
        multiLine: Boolean,
        outline: Boolean,
        rounded: Boolean,
        label: [
            Number,
            String
        ],
        align: {
            type: String,
            validator: (v)=>alignValues$3.includes(v)
        }
    },
    setup (props, { slots }) {
        const style = (0, _vue.computed)(()=>props.align !== void 0 ? {
                verticalAlign: props.align
            } : null);
        const classes = (0, _vue.computed)(()=>{
            const text = props.outline === true ? props.color || props.textColor : props.textColor;
            return `q-badge flex inline items-center no-wrap q-badge--${props.multiLine === true ? "multi" : "single"}-line` + (props.outline === true ? " q-badge--outline" : props.color !== void 0 ? ` bg-${props.color}` : "") + (text !== void 0 ? ` text-${text}` : "") + (props.floating === true ? " q-badge--floating" : "") + (props.rounded === true ? " q-badge--rounded" : "") + (props.transparent === true ? " q-badge--transparent" : "");
        });
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                style: style.value,
                role: "status",
                "aria-label": props.label
            }, hMergeSlot(slots.default, props.label !== void 0 ? [
                props.label
            ] : []));
    }
});
//#endregion
//#region src/composables/private.use-dark/use-dark.js
const useDarkProps = {
    dark: {
        type: Boolean,
        default: null
    }
};
function useDark(props, $q) {
    return (0, _vue.computed)(()=>props.dark === null ? $q.dark.isActive : props.dark);
}
//#endregion
//#region src/components/banner/QBanner.js
var QBanner_default = createComponent({
    name: "QBanner",
    props: {
        ...useDarkProps,
        inlineActions: Boolean,
        dense: Boolean,
        rounded: Boolean
    },
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const classes = (0, _vue.computed)(()=>"q-banner row items-center" + (props.dense === true ? " q-banner--dense" : "") + (isDark.value === true ? " q-banner--dark q-dark" : "") + (props.rounded === true ? " rounded-borders" : ""));
        const actionClass = (0, _vue.computed)(()=>`q-banner__actions row items-center justify-end col-${props.inlineActions === true ? "auto" : "all"}`);
        return ()=>{
            const child = [
                (0, _vue.h)("div", {
                    class: "q-banner__avatar col-auto row items-center self-start"
                }, hSlot(slots.avatar)),
                (0, _vue.h)("div", {
                    class: "q-banner__content col text-body2"
                }, hSlot(slots.default))
            ];
            const actions = hSlot(slots.action);
            if (actions !== void 0) child.push((0, _vue.h)("div", {
                class: actionClass.value
            }, actions));
            return (0, _vue.h)("div", {
                class: classes.value + (props.inlineActions === false && actions !== void 0 ? " q-banner--top-padding" : ""),
                role: "alert"
            }, child);
        };
    }
});
//#endregion
//#region src/components/bar/QBar.js
var QBar_default = createComponent({
    name: "QBar",
    props: {
        ...useDarkProps,
        dense: Boolean
    },
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const classes = (0, _vue.computed)(()=>`q-bar row no-wrap items-center q-bar--${props.dense === true ? "dense" : "standard"}  q-bar--${isDark.value === true ? "dark" : "light"}`);
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                role: "toolbar"
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/composables/private.use-align/use-align.js
const alignMap = {
    left: "start",
    center: "center",
    right: "end",
    between: "between",
    around: "around",
    evenly: "evenly",
    stretch: "stretch"
};
const alignValues$2 = Object.keys(alignMap);
const useAlignProps = {
    align: {
        type: String,
        validator: (v)=>alignValues$2.includes(v)
    }
};
function useAlign(props) {
    return (0, _vue.computed)(()=>{
        const align = props.align === void 0 ? props.vertical === true ? "stretch" : "left" : props.align;
        return `${props.vertical === true ? "items" : "justify"}-${alignMap[align]}`;
    });
}
//#endregion
//#region src/utils/private.vm/vm.js
function getParentProxy(proxy) {
    if (Object(proxy.$parent) === proxy.$parent) return proxy.$parent;
    let { parent } = proxy.$;
    while(Object(parent) === parent){
        if (Object(parent.proxy) === parent.proxy) return parent.proxy;
        parent = parent.parent;
    }
}
function fillNormalizedVNodes(children, vnode) {
    if (typeof vnode.type === "symbol") {
        if (Array.isArray(vnode.children) === true) vnode.children.forEach((child)=>{
            fillNormalizedVNodes(children, child);
        });
    } else children.add(vnode);
}
function getNormalizedVNodes(vnodes) {
    const children = /* @__PURE__ */ new Set();
    vnodes.forEach((vnode)=>{
        fillNormalizedVNodes(children, vnode);
    });
    return Array.from(children);
}
function vmHasRouter(vm) {
    return vm.appContext.config.globalProperties.$router !== void 0;
}
function vmIsDestroyed(vm) {
    return vm.isUnmounted === true || vm.isDeactivated === true;
}
//#endregion
//#region src/components/breadcrumbs/QBreadcrumbs.js
const disabledValues = [
    "",
    true
];
var QBreadcrumbs_default = createComponent({
    name: "QBreadcrumbs",
    props: {
        ...useAlignProps,
        separator: {
            type: String,
            default: "/"
        },
        separatorColor: String,
        activeColor: {
            type: String,
            default: "primary"
        },
        gutter: {
            type: String,
            validator: (v)=>[
                    "none",
                    "xs",
                    "sm",
                    "md",
                    "lg",
                    "xl"
                ].includes(v),
            default: "sm"
        }
    },
    setup (props, { slots }) {
        const alignClass = useAlign(props);
        const classes = (0, _vue.computed)(()=>`flex items-center ${alignClass.value}${props.gutter === "none" ? "" : ` q-gutter-${props.gutter}`}`);
        const sepClass = (0, _vue.computed)(()=>props.separatorColor ? ` text-${props.separatorColor}` : "");
        const activeClass = (0, _vue.computed)(()=>` text-${props.activeColor}`);
        return ()=>{
            if (slots.default === void 0) return;
            const vnodes = getNormalizedVNodes(hSlot(slots.default));
            if (vnodes.length === 0) return;
            let els = 1;
            const child = [], len = vnodes.filter((c)=>c.type?.name === "QBreadcrumbsEl").length, separator = slots.separator !== void 0 ? slots.separator : ()=>props.separator;
            vnodes.forEach((comp)=>{
                if (comp.type?.name === "QBreadcrumbsEl") {
                    const middle = els < len;
                    const disabled = comp.props !== null && disabledValues.includes(comp.props.disable);
                    const cls = (middle === true ? "" : " q-breadcrumbs--last") + (disabled !== true && middle === true ? activeClass.value : "");
                    els++;
                    child.push((0, _vue.h)("div", {
                        class: `flex items-center${cls}`
                    }, [
                        comp
                    ]));
                    if (middle === true) child.push((0, _vue.h)("div", {
                        class: "q-breadcrumbs__separator" + sepClass.value
                    }, separator()));
                } else child.push(comp);
            });
            return (0, _vue.h)("div", {
                class: "q-breadcrumbs"
            }, [
                (0, _vue.h)("div", {
                    class: classes.value
                }, child)
            ]);
        };
    }
});
//#endregion
//#region src/composables/private.use-router-link/use-router-link.js
function getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
function isSameRouteRecord(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key], outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (Array.isArray(outerValue) === false || outerValue.length !== innerValue.length || innerValue.some((value1, i)=>value1 !== outerValue[i])) return false;
    }
    return true;
}
function isEquivalentArray(a, b) {
    return Array.isArray(b) === true ? a.length === b.length && a.every((value1, i)=>value1 === b[i]) : a.length === 1 && a[0] === b;
}
function isSameRouteLocationParamsValue(a, b) {
    return Array.isArray(a) === true ? isEquivalentArray(a, b) : Array.isArray(b) === true ? isEquivalentArray(b, a) : a === b;
}
function isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a)if (isSameRouteLocationParamsValue(a[key], b[key]) === false) return false;
    return true;
}
const useRouterLinkNonMatchingProps = {
    to: [
        String,
        Object
    ],
    replace: Boolean,
    href: String,
    target: String,
    disable: Boolean
};
const useRouterLinkProps = {
    ...useRouterLinkNonMatchingProps,
    exact: Boolean,
    activeClass: {
        type: String,
        default: "q-router-link--active"
    },
    exactActiveClass: {
        type: String,
        default: "q-router-link--exact-active"
    }
};
function useRouterLink({ fallbackTag, useDisableForRouterLinkProps = true } = {}) {
    const vm = (0, _vue.getCurrentInstance)();
    const { props, proxy, emit } = vm;
    const hasRouter = vmHasRouter(vm);
    const hasHrefLink = (0, _vue.computed)(()=>props.disable !== true && props.href !== void 0);
    const hasRouterLinkProps = useDisableForRouterLinkProps === true ? (0, _vue.computed)(()=>hasRouter === true && props.disable !== true && hasHrefLink.value !== true && props.to !== void 0 && props.to !== null && props.to !== "") : (0, _vue.computed)(()=>hasRouter === true && hasHrefLink.value !== true && props.to !== void 0 && props.to !== null && props.to !== "");
    const resolvedLink = (0, _vue.computed)(()=>hasRouterLinkProps.value === true ? getLink(props.to) : null);
    const hasRouterLink = (0, _vue.computed)(()=>resolvedLink.value !== null);
    const hasLink = (0, _vue.computed)(()=>hasHrefLink.value === true || hasRouterLink.value === true);
    const linkTag = (0, _vue.computed)(()=>props.type === "a" || hasLink.value === true ? "a" : props.tag || fallbackTag || "div");
    const linkAttrs = (0, _vue.computed)(()=>hasHrefLink.value === true ? {
            href: props.href,
            target: props.target
        } : hasRouterLink.value === true ? {
            href: resolvedLink.value.href,
            target: props.target
        } : {});
    const linkActiveIndex = (0, _vue.computed)(()=>{
        if (hasRouterLink.value === false) return -1;
        const { matched } = resolvedLink.value, { length } = matched, routeMatched = matched[length - 1];
        if (routeMatched === void 0) return -1;
        const currentMatched = proxy.$route.matched;
        if (currentMatched.length === 0) return -1;
        const index = currentMatched.findIndex(isSameRouteRecord.bind(null, routeMatched));
        if (index !== -1) return index;
        const parentRecordPath = getOriginalPath(matched[length - 2]);
        return length > 1 && getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex(isSameRouteRecord.bind(null, matched[length - 2])) : index;
    });
    const linkIsActive = (0, _vue.computed)(()=>hasRouterLink.value === true && linkActiveIndex.value !== -1 && includesParams(proxy.$route.params, resolvedLink.value.params));
    const linkIsExactActive = (0, _vue.computed)(()=>linkIsActive.value === true && linkActiveIndex.value === proxy.$route.matched.length - 1 && isSameRouteLocationParams(proxy.$route.params, resolvedLink.value.params));
    const linkClass = (0, _vue.computed)(()=>hasRouterLink.value === true ? linkIsExactActive.value === true ? ` ${props.exactActiveClass} ${props.activeClass}` : props.exact === true ? "" : linkIsActive.value === true ? ` ${props.activeClass}` : "" : "");
    function getLink(to) {
        try {
            return proxy.$router.resolve(to);
        } catch  {}
        return null;
    }
    /**
	* @returns Promise<RouterError | false | undefined>
	*/ function navigateToRouterLink(e, { returnRouterError, to = props.to, replace = props.replace } = {}) {
        if (props.disable === true) {
            e.preventDefault();
            return Promise.resolve(false);
        }
        if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button !== void 0 && e.button !== 0 || props.target === "_blank") return Promise.resolve(false);
        e.preventDefault();
        const promise = proxy.$router[replace === true ? "replace" : "push"](to);
        return returnRouterError === true ? promise : promise.then(()=>{}).catch(()=>{});
    }
    function navigateOnClick(e) {
        if (hasRouterLink.value === true) {
            const go = (opts)=>navigateToRouterLink(e, opts);
            emit("click", e, go);
            if (e.defaultPrevented !== true) go();
        } else emit("click", e);
    }
    return {
        hasRouterLink,
        hasHrefLink,
        hasLink,
        linkTag,
        resolvedLink,
        linkIsActive,
        linkIsExactActive,
        linkClass,
        linkAttrs,
        getLink,
        navigateToRouterLink,
        navigateOnClick
    };
}
//#endregion
//#region src/components/breadcrumbs/QBreadcrumbsEl.js
var QBreadcrumbsEl_default = createComponent({
    name: "QBreadcrumbsEl",
    props: {
        ...useRouterLinkProps,
        label: String,
        icon: String,
        tag: {
            type: String,
            default: "span"
        }
    },
    emits: [
        "click"
    ],
    setup (props, { slots }) {
        const { linkTag, linkAttrs, linkClass, navigateOnClick } = useRouterLink();
        const data = (0, _vue.computed)(()=>({
                class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (props.disable !== true ? "q-link--focusable" + linkClass.value : "q-breadcrumbs__el--disable"),
                ...linkAttrs.value,
                onClick: navigateOnClick
            }));
        const iconClass = (0, _vue.computed)(()=>"q-breadcrumbs__el-icon" + (props.label !== void 0 ? " q-breadcrumbs__el-icon--with-label" : ""));
        return ()=>{
            const child = [];
            if (props.icon !== void 0) child.push((0, _vue.h)(QIcon_default, {
                class: iconClass.value,
                name: props.icon
            }));
            if (props.label !== void 0) child.push(props.label);
            return (0, _vue.h)(linkTag.value, {
                ...data.value
            }, hMergeSlot(slots.default, child));
        };
    }
});
//#endregion
//#region src/components/spinner/use-spinner.js
const useSpinnerProps = {
    size: {
        type: [
            String,
            Number
        ],
        default: "1em"
    },
    color: String
};
function useSpinner(props) {
    return {
        cSize: (0, _vue.computed)(()=>props.size in useSizeDefaults ? `${useSizeDefaults[props.size]}px` : props.size),
        classes: (0, _vue.computed)(()=>"q-spinner" + (props.color ? ` text-${props.color}` : ""))
    };
}
//#endregion
//#region src/components/spinner/QSpinner.js
var QSpinner_default = createComponent({
    name: "QSpinner",
    props: {
        ...useSpinnerProps,
        thickness: {
            type: Number,
            default: 5
        }
    },
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value + " q-spinner-mat",
                width: cSize.value,
                height: cSize.value,
                viewBox: "25 25 50 50"
            }, [
                (0, _vue.h)("circle", {
                    class: "path",
                    cx: "50",
                    cy: "50",
                    r: "20",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": props.thickness,
                    "stroke-miterlimit": "10"
                })
            ]);
    }
});
//#endregion
//#region src/utils/dom/dom.js
function offset(el) {
    if (el === window) return {
        top: 0,
        left: 0
    };
    const { top, left } = el.getBoundingClientRect();
    return {
        top,
        left
    };
}
function style(el, property) {
    return window.getComputedStyle(el).getPropertyValue(property);
}
function height(el) {
    return el === window ? window.innerHeight : el.getBoundingClientRect().height;
}
function width$1(el) {
    return el === window ? window.innerWidth : el.getBoundingClientRect().width;
}
function css(element, cssObject) {
    const elementStyle = element.style;
    for(const prop in cssObject)elementStyle[prop] = cssObject[prop];
}
function cssBatch(elements, elementCssObject) {
    elements.forEach((el)=>css(el, elementCssObject));
}
function ready(fn) {
    if (typeof fn !== "function") return;
    if (document.readyState !== "loading") return fn();
    document.addEventListener("DOMContentLoaded", fn, false);
}
function getElement$1(el) {
    if (el === void 0 || el === null) return;
    if (typeof el === "string") try {
        return document.querySelector(el) || void 0;
    } catch  {
        return;
    }
    const target = (0, _vue.unref)(el);
    if (target) return target.$el || target;
}
function childHasFocus(el, focusedEl) {
    if (el === void 0 || el === null || el.contains(focusedEl) === true) return true;
    for(let next = el.nextElementSibling; next !== null; next = next.nextElementSibling)if (next.contains(focusedEl)) return true;
    return false;
}
var dom_default = {
    offset,
    style,
    height,
    width: width$1,
    css,
    cssBatch,
    ready
};
//#endregion
//#region src/utils/throttle/throttle.js
function throttle(fn, limit = 250) {
    let wait = false, result;
    return function runThrottle() {
        if (wait === false) {
            wait = true;
            setTimeout(()=>{
                wait = false;
            }, limit);
            result = fn.apply(this, arguments);
        }
        return result;
    };
}
//#endregion
//#region src/directives/ripple/Ripple.js
function showRipple(evt, el, ctx, forceCenter) {
    if (ctx.modifiers.stop === true) stop(evt);
    const color = ctx.modifiers.color;
    let center = ctx.modifiers.center;
    center = center === true || forceCenter === true;
    const node = document.createElement("span"), innerNode = document.createElement("span"), pos = position(evt), { left, top, width, height } = el.getBoundingClientRect(), diameter = Math.sqrt(width * width + height * height), radius = diameter / 2, centerX = `${(width - diameter) / 2}px`, x = center ? centerX : `${pos.left - left - radius}px`, centerY = `${(height - diameter) / 2}px`, y = center ? centerY : `${pos.top - top - radius}px`;
    innerNode.className = "q-ripple__inner";
    css(innerNode, {
        height: `${diameter}px`,
        width: `${diameter}px`,
        transform: `translate3d(${x},${y},0) scale3d(.2,.2,1)`,
        opacity: 0
    });
    node.className = `q-ripple${color ? " text-" + color : ""}`;
    node.setAttribute("dir", "ltr");
    node.appendChild(innerNode);
    el.appendChild(node);
    const abort = ()=>{
        node.remove();
        clearTimeout(timer);
    };
    ctx.abort.push(abort);
    let timer = setTimeout(()=>{
        innerNode.classList.add("q-ripple__inner--enter");
        innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
        innerNode.style.opacity = .2;
        timer = setTimeout(()=>{
            innerNode.classList.remove("q-ripple__inner--enter");
            innerNode.classList.add("q-ripple__inner--leave");
            innerNode.style.opacity = 0;
            timer = setTimeout(()=>{
                node.remove();
                ctx.abort.splice(ctx.abort.indexOf(abort), 1);
            }, 275);
        }, 250);
    }, 50);
}
function updateModifiers$1(ctx, { modifiers, value: value1, arg }) {
    const cfg = Object.assign({}, ctx.cfg.ripple, modifiers, value1);
    ctx.modifiers = {
        early: cfg.early === true,
        stop: cfg.stop === true,
        center: cfg.center === true,
        color: cfg.color || arg,
        keyCodes: [].concat(cfg.keyCodes || 13)
    };
}
var Ripple_default = createDirective({
    name: "ripple",
    beforeMount (el, binding) {
        const cfg = binding.instance.$.appContext.config.globalProperties.$q.config || {};
        if (cfg.ripple === false) return;
        const ctx = {
            cfg,
            enabled: binding.value !== false,
            modifiers: {},
            abort: [],
            start (evt) {
                if (ctx.enabled === true && evt.qSkipRipple !== true && evt.type === (ctx.modifiers.early === true ? "pointerdown" : "click")) showRipple(evt, el, ctx, evt.qKeyEvent === true);
            },
            keystart: throttle((evt)=>{
                if (ctx.enabled === true && evt.qSkipRipple !== true && isKeyCode(evt, ctx.modifiers.keyCodes) === true && evt.type === `key${ctx.modifiers.early === true ? "down" : "up"}`) showRipple(evt, el, ctx, true);
            }, 300)
        };
        updateModifiers$1(ctx, binding);
        el.__qripple = ctx;
        addEvt(ctx, "main", [
            [
                el,
                "pointerdown",
                "start",
                "passive"
            ],
            [
                el,
                "click",
                "start",
                "passive"
            ],
            [
                el,
                "keydown",
                "keystart",
                "passive"
            ],
            [
                el,
                "keyup",
                "keystart",
                "passive"
            ]
        ]);
    },
    updated (el, binding) {
        if (binding.oldValue !== binding.value) {
            const ctx = el.__qripple;
            if (ctx !== void 0) {
                ctx.enabled = binding.value !== false;
                if (ctx.enabled === true && Object(binding.value) === binding.value) updateModifiers$1(ctx, binding);
            }
        }
    },
    beforeUnmount (el) {
        const ctx = el.__qripple;
        if (ctx !== void 0) {
            ctx.abort.forEach((fn)=>{
                fn();
            });
            cleanEvt(ctx, "main");
            delete el._qripple;
        }
    }
});
//#endregion
//#region src/components/btn/use-btn.js
const btnPadding = {
    none: 0,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
};
const defaultSizes$2 = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
};
const formTypes = [
    "button",
    "submit",
    "reset"
];
const mediaTypeRE = /[^\s]\/[^\s]/;
const btnDesignOptions = [
    "flat",
    "outline",
    "push",
    "unelevated"
];
function getBtnDesign(props, defaultValue) {
    if (props.flat === true) return "flat";
    if (props.outline === true) return "outline";
    if (props.push === true) return "push";
    if (props.unelevated === true) return "unelevated";
    return defaultValue;
}
function getBtnDesignAttr(props) {
    const design = getBtnDesign(props);
    return design !== void 0 ? {
        [design]: true
    } : {};
}
const nonRoundBtnProps = {
    ...useSizeProps,
    ...useRouterLinkNonMatchingProps,
    type: {
        type: String,
        default: "button"
    },
    label: [
        Number,
        String
    ],
    icon: String,
    iconRight: String,
    ...btnDesignOptions.reduce((acc, val)=>(acc[val] = Boolean) && acc, {}),
    square: Boolean,
    rounded: Boolean,
    glossy: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    padding: String,
    color: String,
    textColor: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    tabindex: [
        Number,
        String
    ],
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    align: {
        ...useAlignProps.align,
        default: "center"
    },
    stack: Boolean,
    stretch: Boolean,
    loading: {
        type: Boolean,
        default: null
    },
    disable: Boolean
};
const useBtnProps = {
    ...nonRoundBtnProps,
    round: Boolean
};
function useBtn(props) {
    const sizeStyle = useSize(props, defaultSizes$2);
    const alignClass = useAlign(props);
    const { hasRouterLink, hasLink, linkTag, linkAttrs, navigateOnClick } = useRouterLink({
        fallbackTag: "button"
    });
    const style = (0, _vue.computed)(()=>{
        const obj = props.fab === false && props.fabMini === false ? sizeStyle.value : {};
        return props.padding !== void 0 ? Object.assign({}, obj, {
            padding: props.padding.split(/\s+/).map((v)=>v in btnPadding ? btnPadding[v] + "px" : v).join(" "),
            minWidth: "0",
            minHeight: "0"
        }) : obj;
    });
    const isRounded = (0, _vue.computed)(()=>props.rounded === true || props.fab === true || props.fabMini === true);
    const isActionable = (0, _vue.computed)(()=>props.disable !== true && props.loading !== true);
    const tabIndex = (0, _vue.computed)(()=>isActionable.value === true ? props.tabindex || 0 : -1);
    const design = (0, _vue.computed)(()=>getBtnDesign(props, "standard"));
    const attributes = (0, _vue.computed)(()=>{
        const acc = {
            tabindex: tabIndex.value
        };
        if (hasLink.value === true) Object.assign(acc, linkAttrs.value);
        else if (formTypes.includes(props.type) === true) acc.type = props.type;
        if (linkTag.value === "a") {
            if (props.disable === true) acc["aria-disabled"] = "true";
            else if (acc.href === void 0) acc.role = "button";
            if (hasRouterLink.value !== true && mediaTypeRE.test(props.type) === true) acc.type = props.type;
        } else if (props.disable === true) {
            acc.disabled = "";
            acc["aria-disabled"] = "true";
        }
        if (props.loading === true && props.percentage !== void 0) Object.assign(acc, {
            role: "progressbar",
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": props.percentage
        });
        return acc;
    });
    return {
        classes: (0, _vue.computed)(()=>{
            let colors;
            if (props.color !== void 0) {
                if (props.flat === true || props.outline === true) colors = `text-${props.textColor || props.color}`;
                else colors = `bg-${props.color} text-${props.textColor || "white"}`;
            } else if (props.textColor) colors = `text-${props.textColor}`;
            const shape = props.round === true ? "round" : `rectangle${isRounded.value === true ? " q-btn--rounded" : props.square === true ? " q-btn--square" : ""}`;
            return `q-btn--${design.value} q-btn--${shape}` + (colors !== void 0 ? " " + colors : "") + (isActionable.value === true ? " q-btn--actionable q-focusable q-hoverable" : props.disable === true ? " disabled" : "") + (props.fab === true ? " q-btn--fab" : props.fabMini === true ? " q-btn--fab-mini" : "") + (props.noCaps === true ? " q-btn--no-uppercase" : "") + (props.dense === true ? " q-btn--dense" : "") + (props.stretch === true ? " no-border-radius self-stretch" : "") + (props.glossy === true ? " glossy" : "") + (props.square ? " q-btn--square" : "");
        }),
        style,
        innerClasses: (0, _vue.computed)(()=>alignClass.value + (props.stack === true ? " column" : " row") + (props.noWrap === true ? " no-wrap text-no-wrap" : "") + (props.loading === true ? " q-btn__content--hidden" : "")),
        attributes,
        hasLink,
        linkTag,
        navigateOnClick,
        isActionable
    };
}
//#endregion
//#region src/components/btn/QBtn.js
const { passiveCapture } = listenOpts;
let touchTarget = null, keyboardTarget = null, mouseTarget = null;
var QBtn_default = createComponent({
    name: "QBtn",
    props: {
        ...useBtnProps,
        percentage: Number,
        darkPercentage: Boolean,
        onTouchstart: [
            Function,
            Array
        ]
    },
    emits: [
        "click",
        "keydown",
        "mousedown",
        "keyup"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { classes, style, innerClasses, attributes, hasLink, linkTag, navigateOnClick, isActionable } = useBtn(props);
        const rootRef = (0, _vue.ref)(null);
        const blurTargetRef = (0, _vue.ref)(null);
        let localTouchTargetEl = null, avoidMouseRipple, mouseTimer = null;
        const hasLabel = (0, _vue.computed)(()=>props.label !== void 0 && props.label !== null && props.label !== "");
        const ripple = (0, _vue.computed)(()=>props.disable === true || props.ripple === false ? false : {
                keyCodes: hasLink.value === true ? [
                    13,
                    32
                ] : [
                    13
                ],
                ...props.ripple === true ? {} : props.ripple
            });
        const rippleProps = (0, _vue.computed)(()=>({
                center: props.round
            }));
        const percentageStyle = (0, _vue.computed)(()=>{
            const val = Math.max(0, Math.min(100, props.percentage));
            return val > 0 ? {
                transition: "transform 0.6s",
                transform: `translateX(${val - 100}%)`
            } : {};
        });
        const onEvents = (0, _vue.computed)(()=>{
            if (props.loading === true) return {
                onMousedown: onLoadingEvt,
                onTouchstart: onLoadingEvt,
                onClick: onLoadingEvt,
                onKeydown: onLoadingEvt,
                onKeyup: onLoadingEvt
            };
            if (isActionable.value === true) {
                const acc = {
                    onClick,
                    onKeydown,
                    onMousedown
                };
                if (proxy.$q.platform.has.touch === true) {
                    const suffix = props.onTouchstart !== void 0 ? "" : "Passive";
                    acc[`onTouchstart${suffix}`] = onTouchstart;
                }
                return acc;
            }
            return {
                onClick: stopAndPrevent
            };
        });
        const nodeProps = (0, _vue.computed)(()=>({
                ref: rootRef,
                class: "q-btn q-btn-item non-selectable no-outline " + classes.value,
                style: style.value,
                ...attributes.value,
                ...onEvents.value
            }));
        function onClick(e) {
            if (rootRef.value === null) return;
            if (e !== void 0) {
                if (e.defaultPrevented === true) return;
                const el = document.activeElement;
                if (props.type === "submit" && el !== document.body && rootRef.value.contains(el) === false && el.contains(rootRef.value) === false) {
                    if (e.qAvoidFocus !== true) rootRef.value.focus();
                    const onClickCleanup = ()=>{
                        document.removeEventListener("keydown", stopAndPrevent, true);
                        document.removeEventListener("keyup", onClickCleanup, passiveCapture);
                        rootRef.value?.removeEventListener("blur", onClickCleanup, passiveCapture);
                    };
                    document.addEventListener("keydown", stopAndPrevent, true);
                    document.addEventListener("keyup", onClickCleanup, passiveCapture);
                    rootRef.value.addEventListener("blur", onClickCleanup, passiveCapture);
                }
            }
            navigateOnClick(e);
        }
        function onKeydown(e) {
            if (rootRef.value === null) return;
            emit("keydown", e);
            if (isKeyCode(e, [
                13,
                32
            ]) === true && keyboardTarget !== rootRef.value) {
                if (keyboardTarget !== null) cleanup();
                if (e.defaultPrevented !== true) {
                    if (e.qAvoidFocus !== true) rootRef.value.focus();
                    keyboardTarget = rootRef.value;
                    rootRef.value.classList.add("q-btn--active");
                    document.addEventListener("keyup", onPressEnd, true);
                    rootRef.value.addEventListener("blur", onPressEnd, passiveCapture);
                }
                stopAndPrevent(e);
            }
        }
        function onTouchstart(e) {
            if (rootRef.value === null) return;
            emit("touchstart", e);
            if (e.defaultPrevented === true) return;
            if (touchTarget !== rootRef.value) {
                if (touchTarget !== null) cleanup();
                touchTarget = rootRef.value;
                localTouchTargetEl = e.target;
                localTouchTargetEl.addEventListener("touchcancel", onPressEnd, passiveCapture);
                localTouchTargetEl.addEventListener("touchend", onPressEnd, passiveCapture);
            }
            avoidMouseRipple = true;
            if (mouseTimer !== null) clearTimeout(mouseTimer);
            mouseTimer = setTimeout(()=>{
                mouseTimer = null;
                avoidMouseRipple = false;
            }, 200);
        }
        function onMousedown(e) {
            if (rootRef.value === null) return;
            e.qSkipRipple = avoidMouseRipple === true;
            emit("mousedown", e);
            if (e.defaultPrevented !== true && mouseTarget !== rootRef.value) {
                if (mouseTarget !== null) cleanup();
                mouseTarget = rootRef.value;
                rootRef.value.classList.add("q-btn--active");
                document.addEventListener("mouseup", onPressEnd, passiveCapture);
            }
        }
        function onPressEnd(e) {
            if (rootRef.value === null) return;
            if (e?.type === "blur" && document.activeElement === rootRef.value) return;
            if (e?.type === "keyup") {
                if (keyboardTarget === rootRef.value && isKeyCode(e, [
                    13,
                    32
                ]) === true) {
                    const evt = new MouseEvent("click", e);
                    evt.qKeyEvent = true;
                    if (e.defaultPrevented === true) prevent(evt);
                    if (e.cancelBubble === true) stop(evt);
                    rootRef.value.dispatchEvent(evt);
                    stopAndPrevent(e);
                    e.qKeyEvent = true;
                }
                emit("keyup", e);
            }
            cleanup();
        }
        function cleanup(destroying) {
            const blurTarget = blurTargetRef.value;
            if (destroying !== true && (touchTarget === rootRef.value || mouseTarget === rootRef.value) && blurTarget !== null && blurTarget !== document.activeElement) {
                blurTarget.setAttribute("tabindex", -1);
                blurTarget.focus();
            }
            if (touchTarget === rootRef.value) {
                if (localTouchTargetEl !== null) {
                    localTouchTargetEl.removeEventListener("touchcancel", onPressEnd, passiveCapture);
                    localTouchTargetEl.removeEventListener("touchend", onPressEnd, passiveCapture);
                }
                touchTarget = localTouchTargetEl = null;
            }
            if (mouseTarget === rootRef.value) {
                document.removeEventListener("mouseup", onPressEnd, passiveCapture);
                mouseTarget = null;
            }
            if (keyboardTarget === rootRef.value) {
                document.removeEventListener("keyup", onPressEnd, true);
                rootRef.value?.removeEventListener("blur", onPressEnd, passiveCapture);
                keyboardTarget = null;
            }
            rootRef.value?.classList.remove("q-btn--active");
        }
        function onLoadingEvt(evt) {
            stopAndPrevent(evt);
            evt.qSkipRipple = true;
        }
        (0, _vue.onBeforeUnmount)(()=>{
            cleanup(true);
        });
        Object.assign(proxy, {
            click: (e)=>{
                if (isActionable.value === true) onClick(e);
            }
        });
        return ()=>{
            let inner = [];
            if (props.icon !== void 0) inner.push((0, _vue.h)(QIcon_default, {
                name: props.icon,
                left: props.stack !== true && hasLabel.value === true,
                role: "img"
            }));
            if (hasLabel.value === true) inner.push((0, _vue.h)("span", {
                class: "block"
            }, [
                props.label
            ]));
            inner = hMergeSlot(slots.default, inner);
            if (props.iconRight !== void 0 && props.round === false) inner.push((0, _vue.h)(QIcon_default, {
                name: props.iconRight,
                right: props.stack !== true && hasLabel.value === true,
                role: "img"
            }));
            const child = [
                (0, _vue.h)("span", {
                    class: "q-focus-helper",
                    ref: blurTargetRef
                })
            ];
            if (props.loading === true && props.percentage !== void 0) child.push((0, _vue.h)("span", {
                class: "q-btn__progress absolute-full overflow-hidden" + (props.darkPercentage === true ? " q-btn__progress--dark" : "")
            }, [
                (0, _vue.h)("span", {
                    class: "q-btn__progress-indicator fit block",
                    style: percentageStyle.value
                })
            ]));
            child.push((0, _vue.h)("span", {
                class: "q-btn__content text-center col items-center q-anchor--skip " + innerClasses.value
            }, inner));
            if (props.loading !== null) child.push((0, _vue.h)((0, _vue.Transition), {
                name: "q-transition--fade"
            }, ()=>props.loading === true ? [
                    (0, _vue.h)("span", {
                        key: "loading",
                        class: "absolute-full flex flex-center"
                    }, slots.loading !== void 0 ? slots.loading() : [
                        (0, _vue.h)(QSpinner_default)
                    ])
                ] : null));
            return (0, _vue.withDirectives)((0, _vue.h)(linkTag.value, nodeProps.value, child), [
                [
                    Ripple_default,
                    ripple.value,
                    void 0,
                    rippleProps.value
                ]
            ]);
        };
    }
});
//#endregion
//#region src/components/btn-group/QBtnGroup.js
var QBtnGroup_default = createComponent({
    name: "QBtnGroup",
    props: {
        unelevated: Boolean,
        outline: Boolean,
        flat: Boolean,
        rounded: Boolean,
        square: Boolean,
        push: Boolean,
        stretch: Boolean,
        glossy: Boolean,
        spread: Boolean
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>{
            const cls = [
                "unelevated",
                "outline",
                "flat",
                "rounded",
                "square",
                "push",
                "stretch",
                "glossy"
            ].filter((t)=>props[t] === true).map((t)=>`q-btn-group--${t}`).join(" ");
            return `q-btn-group row no-wrap${cls.length !== 0 ? " " + cls : ""}` + (props.spread === true ? " q-btn-group--spread" : " inline");
        });
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/utils/private.selection/selection.js
function clearSelection() {
    if (window.getSelection !== void 0) {
        const selection = window.getSelection();
        if (selection.empty !== void 0) selection.empty();
        else if (selection.removeAllRanges !== void 0) {
            selection.removeAllRanges();
            if (Platform.is.mobile !== true) selection.addRange(document.createRange());
        }
    } else if (document.selection !== void 0) document.selection.empty();
}
//#endregion
//#region src/composables/private.use-anchor/use-anchor.js
const useAnchorStaticProps = {
    target: {
        type: [
            Boolean,
            String,
            Element
        ],
        default: true
    },
    noParentEvent: Boolean
};
const useAnchorProps = {
    ...useAnchorStaticProps,
    contextMenu: Boolean
};
function useAnchor({ showing, avoidEmit, configureAnchorEl }) {
    const { props, proxy, emit } = (0, _vue.getCurrentInstance)();
    const anchorEl = (0, _vue.ref)(null);
    let touchTimer = null;
    function canShow(evt) {
        return anchorEl.value === null ? false : evt === void 0 || evt.touches === void 0 || evt.touches.length <= 1;
    }
    const anchorEvents = {};
    if (configureAnchorEl === void 0) {
        Object.assign(anchorEvents, {
            hide (evt) {
                proxy.hide(evt);
            },
            toggle (evt) {
                proxy.toggle(evt);
                evt.qAnchorHandled = true;
            },
            toggleKey (evt) {
                if (isKeyCode(evt, 13) === true) anchorEvents.toggle(evt);
            },
            contextClick (evt) {
                proxy.hide(evt);
                prevent(evt);
                (0, _vue.nextTick)(()=>{
                    proxy.show(evt);
                    evt.qAnchorHandled = true;
                });
            },
            prevent,
            mobileTouch (evt) {
                anchorEvents.mobileCleanup(evt);
                if (canShow(evt) !== true) return;
                proxy.hide(evt);
                anchorEl.value.classList.add("non-selectable");
                const target = evt.target;
                addEvt(anchorEvents, "anchor", [
                    [
                        target,
                        "touchmove",
                        "mobileCleanup",
                        "passive"
                    ],
                    [
                        target,
                        "touchend",
                        "mobileCleanup",
                        "passive"
                    ],
                    [
                        target,
                        "touchcancel",
                        "mobileCleanup",
                        "passive"
                    ],
                    [
                        anchorEl.value,
                        "contextmenu",
                        "prevent",
                        "notPassive"
                    ]
                ]);
                touchTimer = setTimeout(()=>{
                    touchTimer = null;
                    proxy.show(evt);
                    evt.qAnchorHandled = true;
                }, 300);
            },
            mobileCleanup (evt) {
                anchorEl.value.classList.remove("non-selectable");
                if (touchTimer !== null) {
                    clearTimeout(touchTimer);
                    touchTimer = null;
                }
                if (showing.value === true && evt !== void 0) clearSelection();
            }
        });
        configureAnchorEl = function configureAnchorElFn(context = props.contextMenu) {
            if (props.noParentEvent === true || anchorEl.value === null) return;
            let evts;
            if (context === true) {
                if (proxy.$q.platform.is.mobile === true) evts = [
                    [
                        anchorEl.value,
                        "touchstart",
                        "mobileTouch",
                        "passive"
                    ]
                ];
                else evts = [
                    [
                        anchorEl.value,
                        "mousedown",
                        "hide",
                        "passive"
                    ],
                    [
                        anchorEl.value,
                        "contextmenu",
                        "contextClick",
                        "notPassive"
                    ]
                ];
            } else evts = [
                [
                    anchorEl.value,
                    "click",
                    "toggle",
                    "passive"
                ],
                [
                    anchorEl.value,
                    "keyup",
                    "toggleKey",
                    "passive"
                ]
            ];
            addEvt(anchorEvents, "anchor", evts);
        };
    }
    function unconfigureAnchorEl() {
        cleanEvt(anchorEvents, "anchor");
    }
    function setAnchorEl(el) {
        anchorEl.value = el;
        while(anchorEl.value.classList.contains("q-anchor--skip"))anchorEl.value = anchorEl.value.parentNode;
        configureAnchorEl();
    }
    function pickAnchorEl() {
        if (props.target === false || props.target === "" || proxy.$el.parentNode === null) anchorEl.value = null;
        else if (props.target === true) setAnchorEl(proxy.$el.parentNode);
        else {
            let el = props.target;
            if (typeof props.target === "string") try {
                el = document.querySelector(props.target);
            } catch  {
                el = void 0;
            }
            if (el !== void 0 && el !== null) {
                anchorEl.value = el.$el || el;
                configureAnchorEl();
            } else {
                anchorEl.value = null;
                console.error(`Anchor: target "${props.target}" not found`);
            }
        }
    }
    (0, _vue.watch)(()=>props.contextMenu, (val)=>{
        if (anchorEl.value !== null) {
            unconfigureAnchorEl();
            configureAnchorEl(val);
        }
    });
    (0, _vue.watch)(()=>props.target, ()=>{
        if (anchorEl.value !== null) unconfigureAnchorEl();
        pickAnchorEl();
    });
    (0, _vue.watch)(()=>props.noParentEvent, (val)=>{
        if (anchorEl.value !== null) {
            if (val === true) unconfigureAnchorEl();
            else configureAnchorEl();
        }
    });
    (0, _vue.onMounted)(()=>{
        pickAnchorEl();
        if (avoidEmit !== true && props.modelValue === true && anchorEl.value === null) emit("update:modelValue", false);
    });
    (0, _vue.onBeforeUnmount)(()=>{
        if (touchTimer !== null) clearTimeout(touchTimer);
        unconfigureAnchorEl();
    });
    return {
        anchorEl,
        canShow,
        anchorEvents
    };
}
//#endregion
//#region src/composables/private.use-scroll-target/use-scroll-target.js
function useScrollTarget(props, configureScrollTarget) {
    const localScrollTarget = (0, _vue.ref)(null);
    let scrollFn;
    function changeScrollEvent(scrollTarget, fn) {
        const fnProp = `${fn !== void 0 ? "add" : "remove"}EventListener`;
        const fnHandler = fn !== void 0 ? fn : scrollFn;
        if (scrollTarget !== window) scrollTarget[fnProp]("scroll", fnHandler, listenOpts.passive);
        window[fnProp]("scroll", fnHandler, listenOpts.passive);
        scrollFn = fn;
    }
    function unconfigureScrollTarget() {
        if (localScrollTarget.value !== null) {
            changeScrollEvent(localScrollTarget.value);
            localScrollTarget.value = null;
        }
    }
    (0, _vue.onBeforeUnmount)((0, _vue.watch)(()=>props.noParentEvent, ()=>{
        if (localScrollTarget.value !== null) {
            unconfigureScrollTarget();
            configureScrollTarget();
        }
    }));
    return {
        localScrollTarget,
        unconfigureScrollTarget,
        changeScrollEvent
    };
}
//#endregion
//#region src/composables/private.use-model-toggle/use-model-toggle.js
const useModelToggleProps = {
    modelValue: {
        type: Boolean,
        default: null
    },
    "onUpdate:modelValue": [
        Function,
        Array
    ]
};
const useModelToggleEmits = [
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
];
function useModelToggle({ showing, canShow, hideOnRouteChange, handleShow, handleHide, processOnMount }) {
    const vm = (0, _vue.getCurrentInstance)();
    const { props, emit, proxy } = vm;
    let payload;
    function toggle(evt) {
        if (showing.value === true) hide(evt);
        else show(evt);
    }
    function show(evt) {
        if (props.disable === true || evt?.qAnchorHandled === true || canShow !== void 0 && canShow(evt) !== true) return;
        const listener = props["onUpdate:modelValue"] !== void 0;
        if (listener === true && true) {
            emit("update:modelValue", true);
            payload = evt;
            (0, _vue.nextTick)(()=>{
                if (payload === evt) payload = void 0;
            });
        }
        if (props.modelValue === null || listener === false || false) processShow(evt);
    }
    function processShow(evt) {
        if (showing.value === true) return;
        showing.value = true;
        emit("beforeShow", evt);
        if (handleShow !== void 0) handleShow(evt);
        else emit("show", evt);
    }
    function hide(evt) {
        if (props.disable === true) return;
        const listener = props["onUpdate:modelValue"] !== void 0;
        if (listener === true && true) {
            emit("update:modelValue", false);
            payload = evt;
            (0, _vue.nextTick)(()=>{
                if (payload === evt) payload = void 0;
            });
        }
        if (props.modelValue === null || listener === false || false) processHide(evt);
    }
    function processHide(evt) {
        if (showing.value === false) return;
        showing.value = false;
        emit("beforeHide", evt);
        if (handleHide !== void 0) handleHide(evt);
        else emit("hide", evt);
    }
    function processModelChange(val) {
        if (props.disable === true && val === true) {
            if (props["onUpdate:modelValue"] !== void 0) emit("update:modelValue", false);
        } else if (val === true !== showing.value) (val === true ? processShow : processHide)(payload);
    }
    (0, _vue.watch)(()=>props.modelValue, processModelChange);
    if (hideOnRouteChange !== void 0 && vmHasRouter(vm) === true) (0, _vue.watch)(()=>proxy.$route.fullPath, ()=>{
        if (hideOnRouteChange.value === true && showing.value === true) hide();
    });
    if (processOnMount === true) (0, _vue.onMounted)(()=>{
        processModelChange(props.modelValue);
    });
    const publicMethods = {
        show,
        hide,
        toggle
    };
    Object.assign(proxy, publicMethods);
    return publicMethods;
}
//#endregion
//#region src/utils/private.focus/focus-manager.js
let queue = [];
let waitFlags = [];
function clearFlag(flag) {
    waitFlags = waitFlags.filter((entry)=>entry !== flag);
}
function addFocusWaitFlag(flag) {
    clearFlag(flag);
    waitFlags.push(flag);
}
function removeFocusWaitFlag(flag) {
    clearFlag(flag);
    if (waitFlags.length === 0 && queue.length !== 0) {
        queue[queue.length - 1]();
        queue = [];
    }
}
function addFocusFn(fn) {
    if (waitFlags.length === 0) fn();
    else queue.push(fn);
}
function removeFocusFn(fn) {
    queue = queue.filter((entry)=>entry !== fn);
}
//#endregion
//#region src/utils/private.config/nodes.js
const nodesList = [];
const portalTypeList = [];
let portalIndex = 1;
let target = document.body;
function createGlobalNode(id, portalType) {
    const el = document.createElement("div");
    el.id = portalType !== void 0 ? `q-portal--${portalType}--${portalIndex++}` : id;
    if (globalConfig.globalNodes !== void 0) {
        const cls = globalConfig.globalNodes.class;
        if (cls !== void 0) el.className = cls;
    }
    target.appendChild(el);
    nodesList.push(el);
    portalTypeList.push(portalType);
    return el;
}
function removeGlobalNode(el) {
    const nodeIndex = nodesList.indexOf(el);
    nodesList.splice(nodeIndex, 1);
    portalTypeList.splice(nodeIndex, 1);
    el.remove();
}
function changeGlobalNodesTarget(newTarget) {
    if (newTarget === target) return;
    target = newTarget;
    if (target === document.body || portalTypeList.reduce((acc, type)=>type === "dialog" ? acc + 1 : acc, 0) < 2) {
        nodesList.forEach((node)=>{
            if (node.contains(target) === false) target.appendChild(node);
        });
        return;
    }
    const lastDialogIndex = portalTypeList.lastIndexOf("dialog");
    for(let i = 0; i < nodesList.length; i++){
        const el = nodesList[i];
        if ((i === lastDialogIndex || portalTypeList[i] !== "dialog") && el.contains(target) === false) target.appendChild(el);
    }
}
//#endregion
//#region src/utils/private.portal/portal.js
const portalProxyList = [];
function getPortalProxy(el) {
    return portalProxyList.find((proxy)=>proxy.contentEl !== null && proxy.contentEl.contains(el));
}
function closePortalMenus(proxy, evt) {
    do {
        if (proxy.$options.name === "QMenu") {
            proxy.hide(evt);
            if (proxy.$props.separateClosePopup === true) return getParentProxy(proxy);
        } else if (proxy.__qPortal === true) {
            const parent = getParentProxy(proxy);
            if (parent?.$options.name === "QPopupProxy") {
                proxy.hide(evt);
                return parent;
            } else return proxy;
        }
        proxy = getParentProxy(proxy);
    }while (proxy !== void 0 && proxy !== null);
}
function closePortals(proxy, evt, depth) {
    while(depth !== 0 && proxy !== void 0 && proxy !== null){
        if (proxy.__qPortal === true) {
            depth--;
            if (proxy.$options.name === "QMenu") {
                proxy = closePortalMenus(proxy, evt);
                continue;
            }
            proxy.hide(evt);
        }
        proxy = getParentProxy(proxy);
    }
}
//#endregion
//#region src/composables/private.use-portal/use-portal.js
/**
* Noop internal component to ease testing
* of the teleported content.
*
* const wrapper = mount(QDialog, { ... })
* const teleportedWrapper = wrapper.findComponent({ name: 'QPortal' })
*/ const QPortal = createComponent({
    name: "QPortal",
    setup (_, { slots }) {
        return ()=>slots.default();
    }
});
function isOnGlobalDialog(vm) {
    vm = vm.parent;
    while(vm !== void 0 && vm !== null){
        if (vm.type.name === "QGlobalDialog") return true;
        if (vm.type.name === "QDialog" || vm.type.name === "QMenu") return false;
        vm = vm.parent;
    }
    return false;
}
function usePortal(vm, innerRef, renderPortalContent, type) {
    const portalIsActive = (0, _vue.ref)(false);
    const portalIsAccessible = (0, _vue.ref)(false);
    let portalEl = null;
    const focusObj = {};
    const onGlobalDialog = type === "dialog" && isOnGlobalDialog(vm);
    function showPortal(isReady) {
        if (isReady === true) {
            removeFocusWaitFlag(focusObj);
            portalIsAccessible.value = true;
            return;
        }
        portalIsAccessible.value = false;
        if (portalIsActive.value === false) {
            if (onGlobalDialog === false && portalEl === null) portalEl = createGlobalNode(false, type);
            portalIsActive.value = true;
            portalProxyList.push(vm.proxy);
            addFocusWaitFlag(focusObj);
        }
    }
    function hidePortal(isReady) {
        portalIsAccessible.value = false;
        if (isReady !== true) return;
        removeFocusWaitFlag(focusObj);
        portalIsActive.value = false;
        const index = portalProxyList.indexOf(vm.proxy);
        if (index !== -1) portalProxyList.splice(index, 1);
        if (portalEl !== null) {
            removeGlobalNode(portalEl);
            portalEl = null;
        }
    }
    (0, _vue.onUnmounted)(()=>{
        hidePortal(true);
    });
    vm.proxy.__qPortal = true;
    injectProp(vm.proxy, "contentEl", ()=>innerRef.value);
    return {
        showPortal,
        hidePortal,
        portalIsActive,
        portalIsAccessible,
        renderPortal: ()=>onGlobalDialog === true ? renderPortalContent() : portalIsActive.value === true ? [
                (0, _vue.h)((0, _vue.Teleport), {
                    to: portalEl
                }, (0, _vue.h)(QPortal, renderPortalContent))
            ] : void 0
    };
}
//#endregion
//#region src/composables/private.use-transition/use-transition.js
const useTransitionProps = {
    transitionShow: {
        type: String,
        default: "fade"
    },
    transitionHide: {
        type: String,
        default: "fade"
    },
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    }
};
function useTransition(props, defaultShowFn = ()=>{}, defaultHideFn = ()=>{}) {
    return {
        transitionProps: (0, _vue.computed)(()=>{
            const show = `q-transition--${props.transitionShow || defaultShowFn()}`;
            const hide = `q-transition--${props.transitionHide || defaultHideFn()}`;
            return {
                appear: true,
                enterFromClass: `${show}-enter-from`,
                enterActiveClass: `${show}-enter-active`,
                enterToClass: `${show}-enter-to`,
                leaveFromClass: `${hide}-leave-from`,
                leaveActiveClass: `${hide}-leave-active`,
                leaveToClass: `${hide}-leave-to`
            };
        }),
        transitionStyle: (0, _vue.computed)(()=>`--q-transition-duration: ${props.transitionDuration}ms`)
    };
}
//#endregion
//#region src/composables/use-tick/use-tick.js
function useTick() {
    let tickFn;
    const vm = (0, _vue.getCurrentInstance)();
    function removeTick() {
        tickFn = void 0;
    }
    (0, _vue.onDeactivated)(removeTick);
    (0, _vue.onBeforeUnmount)(removeTick);
    return {
        removeTick,
        registerTick (fn) {
            tickFn = fn;
            (0, _vue.nextTick)(()=>{
                if (tickFn === fn) {
                    if (vmIsDestroyed(vm) === false) tickFn();
                    tickFn = void 0;
                }
            });
        }
    };
}
//#endregion
//#region src/composables/use-timeout/use-timeout.js
function useTimeout() {
    let timer = null;
    const vm = (0, _vue.getCurrentInstance)();
    function removeTimeout() {
        if (timer !== null) {
            clearTimeout(timer);
            timer = null;
        }
    }
    (0, _vue.onDeactivated)(removeTimeout);
    (0, _vue.onBeforeUnmount)(removeTimeout);
    return {
        removeTimeout,
        registerTimeout (fn, delay) {
            removeTimeout();
            if (vmIsDestroyed(vm) === false) timer = setTimeout(()=>{
                timer = null;
                fn();
            }, delay);
        }
    };
}
//#endregion
//#region src/utils/scroll/scroll.js
const scrollTargetProp = [
    Element,
    String
];
const scrollTargets = [
    null,
    document,
    document.body,
    document.scrollingElement,
    document.documentElement
];
function getScrollTarget(el, targetEl) {
    let target = getElement$1(targetEl);
    if (target === void 0) {
        if (el === void 0 || el === null) return window;
        target = el.closest(".scroll,.scroll-y,.overflow-auto");
    }
    return scrollTargets.includes(target) ? window : target;
}
function getScrollHeight(el) {
    return (el === window ? document.body : el).scrollHeight;
}
function getScrollWidth(el) {
    return (el === window ? document.body : el).scrollWidth;
}
function getVerticalScrollPosition(scrollTarget) {
    return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
function getHorizontalScrollPosition(scrollTarget) {
    return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
function animVerticalScrollTo(el, to, duration = 0) {
    const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
    const pos = getVerticalScrollPosition(el);
    if (duration <= 0) {
        if (pos !== to) setScroll$1(el, to);
        return;
    }
    requestAnimationFrame((nowTime)=>{
        const frameTime = nowTime - prevTime;
        const newPos = pos + (to - pos) / Math.max(frameTime, duration) * frameTime;
        setScroll$1(el, newPos);
        if (newPos !== to) animVerticalScrollTo(el, to, duration - frameTime, nowTime);
    });
}
function animHorizontalScrollTo(el, to, duration = 0) {
    const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
    const pos = getHorizontalScrollPosition(el);
    if (duration <= 0) {
        if (pos !== to) setHorizontalScroll(el, to);
        return;
    }
    requestAnimationFrame((nowTime)=>{
        const frameTime = nowTime - prevTime;
        const newPos = pos + (to - pos) / Math.max(frameTime, duration) * frameTime;
        setHorizontalScroll(el, newPos);
        if (newPos !== to) animHorizontalScrollTo(el, to, duration - frameTime, nowTime);
    });
}
function setScroll$1(scrollTarget, offset) {
    if (scrollTarget === window) {
        window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, offset);
        return;
    }
    scrollTarget.scrollTop = offset;
}
function setHorizontalScroll(scrollTarget, offset) {
    if (scrollTarget === window) {
        window.scrollTo(offset, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
        return;
    }
    scrollTarget.scrollLeft = offset;
}
function setVerticalScrollPosition(scrollTarget, offset, duration) {
    if (duration) {
        animVerticalScrollTo(scrollTarget, offset, duration);
        return;
    }
    setScroll$1(scrollTarget, offset);
}
function setHorizontalScrollPosition(scrollTarget, offset, duration) {
    if (duration) {
        animHorizontalScrollTo(scrollTarget, offset, duration);
        return;
    }
    setHorizontalScroll(scrollTarget, offset);
}
let size;
function getScrollbarWidth() {
    if (size !== void 0) return size;
    const inner = document.createElement("p"), outer = document.createElement("div");
    css(inner, {
        width: "100%",
        height: "200px"
    });
    css(outer, {
        position: "absolute",
        top: "0px",
        left: "0px",
        visibility: "hidden",
        width: "200px",
        height: "150px",
        overflow: "hidden"
    });
    outer.appendChild(inner);
    document.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = "scroll";
    let w2 = inner.offsetWidth;
    if (w1 === w2) w2 = outer.clientWidth;
    outer.remove();
    size = w1 - w2;
    return size;
}
function hasScrollbar(el, onY = true) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    return onY ? el.scrollHeight > el.clientHeight && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(el)["overflow-y"])) : el.scrollWidth > el.clientWidth && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(el)["overflow-x"]));
}
var scroll_default = {
    getScrollTarget,
    getScrollHeight,
    getScrollWidth,
    getVerticalScrollPosition,
    getHorizontalScrollPosition,
    animVerticalScrollTo,
    animHorizontalScrollTo,
    setVerticalScrollPosition,
    setHorizontalScrollPosition,
    getScrollbarWidth,
    hasScrollbar
};
//#endregion
//#region src/utils/private.keyboard/escape-key.js
const handlers$1 = [];
let escDown;
function onKeydown(evt) {
    escDown = evt.keyCode === 27;
}
function onBlur() {
    if (escDown === true) escDown = false;
}
function onKeyup(evt) {
    if (escDown === true) {
        escDown = false;
        if (isKeyCode(evt, 27) === true) handlers$1[handlers$1.length - 1](evt);
    }
}
function update$4(action) {
    window[action]("keydown", onKeydown);
    window[action]("blur", onBlur);
    window[action]("keyup", onKeyup);
    escDown = false;
}
function addEscapeKey(fn) {
    if (client.is.desktop === true) {
        handlers$1.push(fn);
        if (handlers$1.length === 1) update$4("addEventListener");
    }
}
function removeEscapeKey(fn) {
    const index = handlers$1.indexOf(fn);
    if (index !== -1) {
        handlers$1.splice(index, 1);
        if (handlers$1.length === 0) update$4("removeEventListener");
    }
}
//#endregion
//#region src/utils/private.focus/focusout.js
const handlers = [];
function trigger$1(e) {
    handlers[handlers.length - 1](e);
}
function addFocusout(fn) {
    if (client.is.desktop === true) {
        handlers.push(fn);
        if (handlers.length === 1) document.body.addEventListener("focusin", trigger$1);
    }
}
function removeFocusout(fn) {
    const index = handlers.indexOf(fn);
    if (index !== -1) {
        handlers.splice(index, 1);
        if (handlers.length === 0) document.body.removeEventListener("focusin", trigger$1);
    }
}
//#endregion
//#region src/utils/private.click-outside/click-outside.js
let timer = null;
const { notPassiveCapture } = listenOpts, registeredList = [];
function globalHandler(evt) {
    if (timer !== null) {
        clearTimeout(timer);
        timer = null;
    }
    const target = evt.target;
    if (target === void 0 || target.nodeType === 8 || target.classList.contains("no-pointer-events") === true) return;
    let portalIndex = portalProxyList.length - 1;
    while(portalIndex >= 0){
        const proxy = portalProxyList[portalIndex].$;
        if (proxy.type.name === "QTooltip") {
            portalIndex--;
            continue;
        }
        if (proxy.type.name !== "QDialog") break;
        if (proxy.props.seamless !== true) return;
        portalIndex--;
    }
    for(let i = registeredList.length - 1; i >= 0; i--){
        const state = registeredList[i];
        if ((state.anchorEl.value === null || state.anchorEl.value.contains(target) === false) && (target === document.body || state.innerRef.value !== null && state.innerRef.value.contains(target) === false)) {
            evt.qClickOutside = true;
            state.onClickOutside(evt);
        } else return;
    }
}
function addClickOutside(clickOutsideProps) {
    registeredList.push(clickOutsideProps);
    if (registeredList.length === 1) {
        document.addEventListener("mousedown", globalHandler, notPassiveCapture);
        document.addEventListener("touchstart", globalHandler, notPassiveCapture);
    }
}
function removeClickOutside(clickOutsideProps) {
    const index = registeredList.findIndex((h)=>h === clickOutsideProps);
    if (index !== -1) {
        registeredList.splice(index, 1);
        if (registeredList.length === 0) {
            if (timer !== null) {
                clearTimeout(timer);
                timer = null;
            }
            document.removeEventListener("mousedown", globalHandler, notPassiveCapture);
            document.removeEventListener("touchstart", globalHandler, notPassiveCapture);
        }
    }
}
//#endregion
//#region src/utils/private.position-engine/position-engine.js
let vpLeft, vpTop;
function validatePosition(pos) {
    const parts = pos.split(" ");
    if (parts.length !== 2) return false;
    if ([
        "top",
        "center",
        "bottom"
    ].includes(parts[0]) !== true) {
        console.error("Anchor/Self position must start with one of top/center/bottom");
        return false;
    }
    if ([
        "left",
        "middle",
        "right",
        "start",
        "end"
    ].includes(parts[1]) !== true) {
        console.error("Anchor/Self position must end with one of left/middle/right/start/end");
        return false;
    }
    return true;
}
function validateOffset(val) {
    if (!val) return true;
    if (val.length !== 2) return false;
    if (typeof val[0] !== "number" || typeof val[1] !== "number") return false;
    return true;
}
const horizontalPos = {
    "start#ltr": "left",
    "start#rtl": "right",
    "end#ltr": "right",
    "end#rtl": "left"
};
[
    "left",
    "middle",
    "right"
].forEach((pos)=>{
    horizontalPos[`${pos}#ltr`] = pos;
    horizontalPos[`${pos}#rtl`] = pos;
});
function parsePosition(pos, rtl) {
    const parts = pos.split(" ");
    return {
        vertical: parts[0],
        horizontal: horizontalPos[`${parts[1]}#${rtl === true ? "rtl" : "ltr"}`]
    };
}
function getAnchorProps(el, offset) {
    let { top, left, right, bottom, width, height } = el.getBoundingClientRect();
    if (offset !== void 0) {
        top -= offset[1];
        left -= offset[0];
        bottom += offset[1];
        right += offset[0];
        width += offset[0];
        height += offset[1];
    }
    return {
        top,
        bottom,
        height,
        left,
        right,
        width,
        middle: left + (right - left) / 2,
        center: top + (bottom - top) / 2
    };
}
function getAbsoluteAnchorProps(el, absoluteOffset, offset) {
    let { top, left } = el.getBoundingClientRect();
    top += absoluteOffset.top;
    left += absoluteOffset.left;
    if (offset !== void 0) {
        top += offset[1];
        left += offset[0];
    }
    return {
        top,
        bottom: top + 1,
        height: 1,
        left,
        right: left + 1,
        width: 1,
        middle: left,
        center: top
    };
}
function getTargetProps(width, height) {
    return {
        top: 0,
        center: height / 2,
        bottom: height,
        left: 0,
        middle: width / 2,
        right: width
    };
}
function getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin) {
    return {
        top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
        left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal]
    };
}
function setPosition(cfg, retryNumber = 0) {
    if (cfg.targetEl === null || cfg.anchorEl === null || retryNumber > 5) return;
    if (cfg.targetEl.offsetHeight === 0 || cfg.targetEl.offsetWidth === 0) {
        setTimeout(()=>{
            setPosition(cfg, retryNumber + 1);
        }, 10);
        return;
    }
    const { targetEl, offset, anchorEl, anchorOrigin, selfOrigin, absoluteOffset, fit, cover, maxHeight, maxWidth } = cfg;
    if (client.is.ios === true && window.visualViewport !== void 0) {
        const el = document.body.style;
        const { offsetLeft: left, offsetTop: top } = window.visualViewport;
        if (left !== vpLeft) {
            el.setProperty("--q-pe-left", left + "px");
            vpLeft = left;
        }
        if (top !== vpTop) {
            el.setProperty("--q-pe-top", top + "px");
            vpTop = top;
        }
    }
    const { scrollLeft, scrollTop } = targetEl;
    const anchorProps = absoluteOffset === void 0 ? getAnchorProps(anchorEl, cover === true ? [
        0,
        0
    ] : offset) : getAbsoluteAnchorProps(anchorEl, absoluteOffset, offset);
    /**
	* We "reset" the critical CSS properties
	* so we can take an accurate measurement.
	*
	* Ensure that targetEl has a max-width & max-height
	* set in CSS and that the value does NOT exceeds 100vw/vh.
	* All users of the position-engine (currently QMenu & QTooltip)
	* have CSS for this.
	*/ Object.assign(targetEl.style, {
        top: 0,
        left: 0,
        minWidth: null,
        minHeight: null,
        maxWidth,
        maxHeight,
        visibility: "visible"
    });
    const { offsetWidth: origElWidth, offsetHeight: origElHeight } = targetEl;
    const { elWidth, elHeight } = fit === true || cover === true ? {
        elWidth: Math.max(anchorProps.width, origElWidth),
        elHeight: cover === true ? Math.max(anchorProps.height, origElHeight) : origElHeight
    } : {
        elWidth: origElWidth,
        elHeight: origElHeight
    };
    let elStyle = {
        maxWidth,
        maxHeight
    };
    if (fit === true || cover === true) {
        elStyle.minWidth = anchorProps.width + "px";
        if (cover === true) elStyle.minHeight = anchorProps.height + "px";
    }
    Object.assign(targetEl.style, elStyle);
    const targetProps = getTargetProps(elWidth, elHeight);
    let props = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
    if (absoluteOffset === void 0 || offset === void 0) applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
    else {
        const { top, left } = props;
        applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
        let hasChanged = false;
        if (props.top !== top) {
            hasChanged = true;
            const offsetY = 2 * offset[1];
            anchorProps.center = anchorProps.top -= offsetY;
            anchorProps.bottom -= offsetY + 2;
        }
        if (props.left !== left) {
            hasChanged = true;
            const offsetX = 2 * offset[0];
            anchorProps.middle = anchorProps.left -= offsetX;
            anchorProps.right -= offsetX + 2;
        }
        if (hasChanged === true) {
            props = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
            applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
        }
    }
    elStyle = {
        top: props.top + "px",
        left: props.left + "px"
    };
    if (props.maxHeight !== void 0) {
        elStyle.maxHeight = props.maxHeight + "px";
        if (anchorProps.height > props.maxHeight) elStyle.minHeight = elStyle.maxHeight;
    }
    if (props.maxWidth !== void 0) {
        elStyle.maxWidth = props.maxWidth + "px";
        if (anchorProps.width > props.maxWidth) elStyle.minWidth = elStyle.maxWidth;
    }
    Object.assign(targetEl.style, elStyle);
    if (targetEl.scrollTop !== scrollTop) targetEl.scrollTop = scrollTop;
    if (targetEl.scrollLeft !== scrollLeft) targetEl.scrollLeft = scrollLeft;
}
function applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin) {
    const currentHeight = targetProps.bottom, currentWidth = targetProps.right, margin = getScrollbarWidth(), innerHeight = window.innerHeight - margin, innerWidth = document.body.clientWidth;
    if (props.top < 0 || props.top + currentHeight > innerHeight) {
        if (selfOrigin.vertical === "center") {
            props.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
            props.maxHeight = Math.min(currentHeight, innerHeight);
        } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
            const anchorY = Math.min(innerHeight, anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top);
            props.maxHeight = Math.min(currentHeight, anchorY);
            props.top = Math.max(0, anchorY - currentHeight);
        } else {
            props.top = Math.max(0, anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom);
            props.maxHeight = Math.min(currentHeight, innerHeight - props.top);
        }
    }
    if (props.left < 0 || props.left + currentWidth > innerWidth) {
        props.maxWidth = Math.min(currentWidth, innerWidth);
        if (selfOrigin.horizontal === "middle") props.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
        else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
            const anchorX = Math.min(innerWidth, anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left);
            props.maxWidth = Math.min(currentWidth, anchorX);
            props.left = Math.max(0, anchorX - props.maxWidth);
        } else {
            props.left = Math.max(0, anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right);
            props.maxWidth = Math.min(currentWidth, innerWidth - props.left);
        }
    }
}
//#endregion
//#region src/components/menu/QMenu.js
var QMenu_default = createComponent({
    name: "QMenu",
    inheritAttrs: false,
    props: {
        ...useAnchorProps,
        ...useModelToggleProps,
        ...useDarkProps,
        ...useTransitionProps,
        persistent: Boolean,
        autoClose: Boolean,
        separateClosePopup: Boolean,
        noEscDismiss: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        fit: Boolean,
        cover: Boolean,
        square: Boolean,
        anchor: {
            type: String,
            validator: validatePosition
        },
        self: {
            type: String,
            validator: validatePosition
        },
        offset: {
            type: Array,
            validator: validateOffset
        },
        scrollTarget: scrollTargetProp,
        touchPosition: Boolean,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        }
    },
    emits: [
        ...useModelToggleEmits,
        "click",
        "escapeKey"
    ],
    setup (props, { slots, emit, attrs }) {
        let refocusTarget = null, absoluteOffset, unwatchPosition, avoidAutoClose;
        const vm = (0, _vue.getCurrentInstance)();
        const { proxy } = vm;
        const { $q } = proxy;
        const innerRef = (0, _vue.ref)(null);
        const showing = (0, _vue.ref)(false);
        const hideOnRouteChange = (0, _vue.computed)(()=>props.persistent !== true && props.noRouteDismiss !== true);
        const isDark = useDark(props, $q);
        const { registerTick, removeTick } = useTick();
        const { registerTimeout } = useTimeout();
        const { transitionProps, transitionStyle } = useTransition(props);
        const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = useScrollTarget(props, configureScrollTarget);
        const { anchorEl, canShow } = useAnchor({
            showing
        });
        const { hide } = useModelToggle({
            showing,
            canShow,
            handleShow,
            handleHide,
            hideOnRouteChange,
            processOnMount: true
        });
        const { showPortal, hidePortal, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "menu");
        const clickOutsideProps = {
            anchorEl,
            innerRef,
            onClickOutside (e) {
                if (props.persistent !== true && showing.value === true) {
                    hide(e);
                    if (e.type === "touchstart" || e.target.classList.contains("q-dialog__backdrop")) stopAndPrevent(e);
                    return true;
                }
            }
        };
        const anchorOrigin = (0, _vue.computed)(()=>parsePosition(props.anchor || (props.cover === true ? "center middle" : "bottom start"), $q.lang.rtl));
        const selfOrigin = (0, _vue.computed)(()=>props.cover === true ? anchorOrigin.value : parsePosition(props.self || "top start", $q.lang.rtl));
        const menuClass = (0, _vue.computed)(()=>(props.square === true ? " q-menu--square" : "") + (isDark.value === true ? " q-menu--dark q-dark" : ""));
        const onEvents = (0, _vue.computed)(()=>props.autoClose === true ? {
                onClick: onAutoClose
            } : {});
        const handlesFocus = (0, _vue.computed)(()=>showing.value === true && props.persistent !== true);
        (0, _vue.watch)(handlesFocus, (val)=>{
            if (val === true) {
                addEscapeKey(onEscapeKey);
                addClickOutside(clickOutsideProps);
            } else {
                removeEscapeKey(onEscapeKey);
                removeClickOutside(clickOutsideProps);
            }
        });
        function focus() {
            addFocusFn(()=>{
                let node = innerRef.value;
                if (node && node.contains(document.activeElement) !== true) {
                    node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
                    node.focus({
                        preventScroll: true
                    });
                }
            });
        }
        function handleShow(evt) {
            refocusTarget = props.noRefocus === false ? document.activeElement : null;
            addFocusout(onFocusout);
            showPortal();
            configureScrollTarget();
            absoluteOffset = void 0;
            if (evt !== void 0 && (props.touchPosition || props.contextMenu)) {
                const pos = position(evt);
                if (pos.left !== void 0) {
                    const { top, left } = anchorEl.value.getBoundingClientRect();
                    absoluteOffset = {
                        left: pos.left - left,
                        top: pos.top - top
                    };
                }
            }
            if (unwatchPosition === void 0) unwatchPosition = (0, _vue.watch)(()=>$q.screen.width + "|" + $q.screen.height + "|" + props.self + "|" + props.anchor + "|" + $q.lang.rtl, updatePosition);
            if (props.noFocus !== true) document.activeElement.blur();
            registerTick(()=>{
                updatePosition();
                if (props.noFocus !== true) focus();
            });
            registerTimeout(()=>{
                if ($q.platform.is.ios === true) {
                    avoidAutoClose = props.autoClose;
                    innerRef.value.click();
                }
                updatePosition();
                showPortal(true);
                emit("show", evt);
            }, props.transitionDuration);
        }
        function handleHide(evt) {
            removeTick();
            hidePortal();
            anchorCleanup(true);
            if (refocusTarget !== null && (evt === void 0 || evt.qClickOutside !== true)) {
                ((evt?.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
                refocusTarget = null;
            }
            registerTimeout(()=>{
                hidePortal(true);
                emit("hide", evt);
            }, props.transitionDuration);
        }
        function anchorCleanup(hiding) {
            absoluteOffset = void 0;
            if (unwatchPosition !== void 0) {
                unwatchPosition();
                unwatchPosition = void 0;
            }
            if (hiding === true || showing.value === true) {
                removeFocusout(onFocusout);
                unconfigureScrollTarget();
                removeClickOutside(clickOutsideProps);
                removeEscapeKey(onEscapeKey);
            }
            if (hiding !== true) refocusTarget = null;
        }
        function configureScrollTarget() {
            if (anchorEl.value !== null || props.scrollTarget !== void 0) {
                localScrollTarget.value = getScrollTarget(anchorEl.value, props.scrollTarget);
                changeScrollEvent(localScrollTarget.value, updatePosition);
            }
        }
        function onAutoClose(e) {
            if (avoidAutoClose !== true) {
                closePortalMenus(proxy, e);
                emit("click", e);
            } else avoidAutoClose = false;
        }
        function onFocusout(evt) {
            if (handlesFocus.value === true && props.noFocus !== true && childHasFocus(innerRef.value, evt.target) !== true) focus();
        }
        function onEscapeKey(evt) {
            if (props.noEscDismiss !== true) {
                emit("escapeKey");
                hide(evt);
            }
        }
        function updatePosition() {
            setPosition({
                targetEl: innerRef.value,
                offset: props.offset,
                anchorEl: anchorEl.value,
                anchorOrigin: anchorOrigin.value,
                selfOrigin: selfOrigin.value,
                absoluteOffset,
                fit: props.fit,
                cover: props.cover,
                maxHeight: props.maxHeight,
                maxWidth: props.maxWidth
            });
        }
        function renderPortalContent() {
            return (0, _vue.h)((0, _vue.Transition), transitionProps.value, ()=>showing.value === true ? (0, _vue.h)("div", {
                    role: "menu",
                    ...attrs,
                    ref: innerRef,
                    tabindex: -1,
                    class: [
                        "q-menu q-position-engine scroll" + menuClass.value,
                        attrs.class
                    ],
                    style: [
                        attrs.style,
                        transitionStyle.value
                    ],
                    ...onEvents.value
                }, hSlot(slots.default)) : null);
        }
        (0, _vue.onBeforeUnmount)(anchorCleanup);
        Object.assign(proxy, {
            focus,
            updatePosition
        });
        return renderPortal;
    }
});
//#endregion
//#region src/utils/uid/uid.js
/**
* Based on the work of https://github.com/jchook/uuid-random
*/ let buf, bufIdx = 0;
const hexBytes = new Array(256);
for(let i = 0; i < 256; i++)hexBytes[i] = (i + 256).toString(16).substring(1);
const randomBytes = (()=>{
    const lib = typeof crypto !== "undefined" ? crypto : typeof window !== "undefined" ? window.crypto || window.msCrypto : void 0;
    if (lib !== void 0) {
        if (lib.randomBytes !== void 0) return lib.randomBytes;
        if (lib.getRandomValues !== void 0) return (n)=>{
            const bytes = new Uint8Array(n);
            lib.getRandomValues(bytes);
            return bytes;
        };
    }
    return (n)=>{
        const r = [];
        for(let i = n; i > 0; i--)r.push(Math.floor(Math.random() * 256));
        return r;
    };
})();
const BUFFER_SIZE = 4096;
function uid() {
    if (buf === void 0 || bufIdx + 16 > BUFFER_SIZE) {
        bufIdx = 0;
        buf = randomBytes(BUFFER_SIZE);
    }
    const b = Array.prototype.slice.call(buf, bufIdx, bufIdx += 16);
    b[6] = b[6] & 15 | 64;
    b[8] = b[8] & 63 | 128;
    return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + "-" + hexBytes[b[4]] + hexBytes[b[5]] + "-" + hexBytes[b[6]] + hexBytes[b[7]] + "-" + hexBytes[b[8]] + hexBytes[b[9]] + "-" + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
}
//#endregion
//#region src/composables/use-id/use-id.js
function parseValue(val) {
    return val === void 0 || val === null ? null : val;
}
function getId(val, required) {
    return val === void 0 || val === null ? required === true ? `f_${uid()}` : null : val;
}
/**
* Returns an "id" which is a ref() that can be used as
* a unique identifier to apply to a DOM node attribute.
*
* On SSR, it takes care of generating the id on the client side (only) to
* avoid hydration errors.
*/ function useId({ getValue, required = true } = {}) {
    if (isRuntimeSsrPreHydration.value === true) {
        const id = getValue !== void 0 ? (0, _vue.ref)(parseValue(getValue())) : (0, _vue.ref)(null);
        if (required === true && id.value === null) (0, _vue.onMounted)(()=>{
            id.value = `f_${uid()}`;
        });
        if (getValue !== void 0) (0, _vue.watch)(getValue, (newId)=>{
            id.value = getId(newId, required);
        });
        return id;
    }
    return getValue !== void 0 ? (0, _vue.computed)(()=>getId(getValue(), required)) : (0, _vue.ref)(`f_${uid()}`);
}
//#endregion
//#region src/components/btn-dropdown/QBtnDropdown.js
const btnPropsList = Object.keys(nonRoundBtnProps);
function passBtnProps(props) {
    return btnPropsList.reduce((acc, key)=>{
        const val = props[key];
        if (val !== void 0) acc[key] = val;
        return acc;
    }, {});
}
var QBtnDropdown_default = createComponent({
    name: "QBtnDropdown",
    props: {
        ...nonRoundBtnProps,
        ...useTransitionProps,
        modelValue: Boolean,
        split: Boolean,
        dropdownIcon: String,
        contentClass: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        cover: Boolean,
        persistent: Boolean,
        noEscDismiss: Boolean,
        noRouteDismiss: Boolean,
        autoClose: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        menuAnchor: {
            type: String,
            default: "bottom end"
        },
        menuSelf: {
            type: String,
            default: "top end"
        },
        menuOffset: Array,
        disableMainBtn: Boolean,
        disableDropdown: Boolean,
        noIconAnimation: Boolean,
        toggleAriaLabel: String
    },
    emits: [
        "update:modelValue",
        "click",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const showing = (0, _vue.ref)(props.modelValue);
        const menuRef = (0, _vue.ref)(null);
        const targetUid = useId();
        const ariaAttrs = (0, _vue.computed)(()=>{
            const acc = {
                "aria-expanded": showing.value === true ? "true" : "false",
                "aria-haspopup": "true",
                "aria-controls": targetUid.value,
                "aria-label": props.toggleAriaLabel || proxy.$q.lang.label[showing.value === true ? "collapse" : "expand"](props.label)
            };
            if (props.disable === true || props.split === false && props.disableMainBtn === true || props.disableDropdown === true) acc["aria-disabled"] = "true";
            return acc;
        });
        const iconClass = (0, _vue.computed)(()=>"q-btn-dropdown__arrow" + (showing.value === true && props.noIconAnimation === false ? " rotate-180" : "") + (props.split === false ? " q-btn-dropdown__arrow-container" : ""));
        const btnDesignAttr = (0, _vue.computed)(()=>getBtnDesignAttr(props));
        const btnProps = (0, _vue.computed)(()=>passBtnProps(props));
        (0, _vue.watch)(()=>props.modelValue, (val)=>{
            menuRef.value?.[val ? "show" : "hide"]();
        });
        (0, _vue.watch)(()=>props.split, hide);
        function onBeforeShow(e) {
            showing.value = true;
            emit("beforeShow", e);
        }
        function onShow(e) {
            emit("show", e);
            emit("update:modelValue", true);
        }
        function onBeforeHide(e) {
            showing.value = false;
            emit("beforeHide", e);
        }
        function onHide(e) {
            emit("hide", e);
            emit("update:modelValue", false);
        }
        function onClick(e) {
            emit("click", e);
        }
        function onClickHide(e) {
            stop(e);
            hide();
            emit("click", e);
        }
        function toggle(evt) {
            menuRef.value?.toggle(evt);
        }
        function show(evt) {
            menuRef.value?.show(evt);
        }
        function hide(evt) {
            menuRef.value?.hide(evt);
        }
        Object.assign(proxy, {
            show,
            hide,
            toggle
        });
        (0, _vue.onMounted)(()=>{
            if (props.modelValue === true) show();
        });
        return ()=>{
            const Arrow = [
                (0, _vue.h)(QIcon_default, {
                    class: iconClass.value,
                    name: props.dropdownIcon || proxy.$q.iconSet.arrow.dropdown
                })
            ];
            if (props.disableDropdown !== true) Arrow.push((0, _vue.h)(QMenu_default, {
                ref: menuRef,
                id: targetUid.value,
                class: props.contentClass,
                style: props.contentStyle,
                cover: props.cover,
                fit: true,
                persistent: props.persistent,
                noEscDismiss: props.noEscDismiss,
                noRouteDismiss: props.noRouteDismiss,
                autoClose: props.autoClose,
                noFocus: props.noFocus,
                noRefocus: props.noRefocus,
                anchor: props.menuAnchor,
                self: props.menuSelf,
                offset: props.menuOffset,
                separateClosePopup: true,
                transitionShow: props.transitionShow,
                transitionHide: props.transitionHide,
                transitionDuration: props.transitionDuration,
                onBeforeShow,
                onShow,
                onBeforeHide,
                onHide
            }, slots.default));
            if (props.split === false) return (0, _vue.h)(QBtn_default, {
                class: "q-btn-dropdown q-btn-dropdown--simple",
                ...btnProps.value,
                ...ariaAttrs.value,
                disable: props.disable === true || props.disableMainBtn === true,
                noWrap: true,
                round: false,
                onClick
            }, {
                default: ()=>hSlot(slots.label, []).concat(Arrow),
                loading: slots.loading
            });
            return (0, _vue.h)(QBtnGroup_default, {
                class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
                rounded: props.rounded,
                square: props.square,
                ...btnDesignAttr.value,
                glossy: props.glossy,
                stretch: props.stretch
            }, ()=>[
                    (0, _vue.h)(QBtn_default, {
                        class: "q-btn-dropdown--current",
                        ...btnProps.value,
                        disable: props.disable === true || props.disableMainBtn === true,
                        noWrap: true,
                        round: false,
                        onClick: onClickHide
                    }, {
                        default: slots.label,
                        loading: slots.loading
                    }),
                    (0, _vue.h)(QBtn_default, {
                        class: "q-btn-dropdown__arrow-container q-anchor--skip",
                        ...ariaAttrs.value,
                        ...btnDesignAttr.value,
                        disable: props.disable === true || props.disableDropdown === true,
                        rounded: props.rounded,
                        color: props.color,
                        textColor: props.textColor,
                        dense: props.dense,
                        size: props.size,
                        padding: props.padding,
                        ripple: props.ripple
                    }, ()=>Arrow)
                ]);
        };
    }
});
//#endregion
//#region src/composables/use-form/private.use-form.js
const useFormProps = {
    name: String
};
function useFormAttrs(props) {
    return (0, _vue.computed)(()=>({
            type: "hidden",
            name: props.name,
            value: props.modelValue
        }));
}
function useFormInject(formAttrs = {}) {
    return (child, action, className)=>{
        child[action]((0, _vue.h)("input", {
            class: "hidden" + (className || ""),
            ...formAttrs.value
        }));
    };
}
function useFormInputNameAttr(props) {
    return (0, _vue.computed)(()=>props.name || props.for);
}
//#endregion
//#region src/components/btn-toggle/QBtnToggle.js
var QBtnToggle_default = createComponent({
    name: "QBtnToggle",
    props: {
        ...useFormProps,
        modelValue: {
            required: true
        },
        options: {
            type: Array,
            required: true,
            validator: (v)=>v.every((opt)=>("label" in opt || "icon" in opt || "slot" in opt) && "value" in opt)
        },
        color: String,
        textColor: String,
        toggleColor: {
            type: String,
            default: "primary"
        },
        toggleTextColor: String,
        outline: Boolean,
        flat: Boolean,
        unelevated: Boolean,
        rounded: Boolean,
        push: Boolean,
        glossy: Boolean,
        size: String,
        padding: String,
        noCaps: Boolean,
        noWrap: Boolean,
        dense: Boolean,
        readonly: Boolean,
        disable: Boolean,
        stack: Boolean,
        stretch: Boolean,
        spread: Boolean,
        clearable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        }
    },
    emits: [
        "update:modelValue",
        "clear",
        "click"
    ],
    setup (props, { slots, emit }) {
        const hasActiveValue = (0, _vue.computed)(()=>props.options.find((opt)=>opt.value === props.modelValue) !== void 0);
        const injectFormInput = useFormInject((0, _vue.computed)(()=>({
                type: "hidden",
                name: props.name,
                value: props.modelValue
            })));
        const btnDesignAttr = (0, _vue.computed)(()=>getBtnDesignAttr(props));
        const btnOptionDesign = (0, _vue.computed)(()=>({
                rounded: props.rounded,
                dense: props.dense,
                ...btnDesignAttr.value
            }));
        const btnOptions = (0, _vue.computed)(()=>props.options.map((item, i)=>{
                const { attrs, value: value1, slot, ...opt } = item;
                return {
                    slot,
                    props: {
                        key: i,
                        "aria-pressed": value1 === props.modelValue ? "true" : "false",
                        ...attrs,
                        ...opt,
                        ...btnOptionDesign.value,
                        disable: props.disable === true || opt.disable === true,
                        color: value1 === props.modelValue ? mergeOpt(opt, "toggleColor") : mergeOpt(opt, "color"),
                        textColor: value1 === props.modelValue ? mergeOpt(opt, "toggleTextColor") : mergeOpt(opt, "textColor"),
                        noCaps: mergeOpt(opt, "noCaps") === true,
                        noWrap: mergeOpt(opt, "noWrap") === true,
                        size: mergeOpt(opt, "size"),
                        padding: mergeOpt(opt, "padding"),
                        ripple: mergeOpt(opt, "ripple"),
                        stack: mergeOpt(opt, "stack") === true,
                        stretch: mergeOpt(opt, "stretch") === true,
                        onClick (e) {
                            set(value1, item, e);
                        }
                    }
                };
            }));
        function set(value1, opt, e) {
            if (props.readonly !== true) {
                if (props.modelValue === value1) {
                    if (props.clearable === true) {
                        emit("update:modelValue", null, null);
                        emit("clear");
                    }
                } else emit("update:modelValue", value1, opt);
                emit("click", e);
            }
        }
        function mergeOpt(opt, key) {
            return opt[key] === void 0 ? props[key] : opt[key];
        }
        function getContent() {
            const child = btnOptions.value.map((opt)=>(0, _vue.h)(QBtn_default, opt.props, opt.slot !== void 0 ? slots[opt.slot] : void 0));
            if (props.name !== void 0 && props.disable !== true && hasActiveValue.value === true) injectFormInput(child, "push");
            return hMergeSlot(slots.default, child);
        }
        return ()=>(0, _vue.h)(QBtnGroup_default, {
                class: "q-btn-toggle",
                ...btnDesignAttr.value,
                rounded: props.rounded,
                stretch: props.stretch,
                glossy: props.glossy,
                spread: props.spread
            }, getContent);
    }
});
//#endregion
//#region src/components/card/QCard.js
var QCard_default = createComponent({
    name: "QCard",
    props: {
        ...useDarkProps,
        tag: {
            type: String,
            default: "div"
        },
        square: Boolean,
        flat: Boolean,
        bordered: Boolean
    },
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const classes = (0, _vue.computed)(()=>"q-card" + (isDark.value === true ? " q-card--dark q-dark" : "") + (props.bordered === true ? " q-card--bordered" : "") + (props.square === true ? " q-card--square no-border-radius" : "") + (props.flat === true ? " q-card--flat no-shadow" : ""));
        return ()=>(0, _vue.h)(props.tag, {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/card/QCardSection.js
var QCardSection_default = createComponent({
    name: "QCardSection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        horizontal: Boolean
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>`q-card__section q-card__section--${props.horizontal === true ? "horiz row no-wrap" : "vert"}`);
        return ()=>(0, _vue.h)(props.tag, {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/card/QCardActions.js
var QCardActions_default = createComponent({
    name: "QCardActions",
    props: {
        ...useAlignProps,
        vertical: Boolean
    },
    setup (props, { slots }) {
        const alignClass = useAlign(props);
        const classes = (0, _vue.computed)(()=>`q-card__actions ${alignClass.value} q-card__actions--${props.vertical === true ? "vert column" : "horiz row"}`);
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/utils/private.touch/touch.js
const modifiersAll = {
    left: true,
    right: true,
    up: true,
    down: true,
    horizontal: true,
    vertical: true
};
const directionList = Object.keys(modifiersAll);
modifiersAll.all = true;
function getModifierDirections(mod) {
    const dir = {};
    for (const direction of directionList)if (mod[direction] === true) dir[direction] = true;
    if (Object.keys(dir).length === 0) return modifiersAll;
    if (dir.horizontal === true) dir.left = dir.right = true;
    else if (dir.left === true && dir.right === true) dir.horizontal = true;
    if (dir.vertical === true) dir.up = dir.down = true;
    else if (dir.up === true && dir.down === true) dir.vertical = true;
    if (dir.horizontal === true && dir.vertical === true) dir.all = true;
    return dir;
}
const avoidNodeNamesList = [
    "INPUT",
    "TEXTAREA"
];
function shouldStart(evt, ctx) {
    return ctx.event === void 0 && evt.target !== void 0 && evt.target.draggable !== true && typeof ctx.handler === "function" && avoidNodeNamesList.includes(evt.target.nodeName.toUpperCase()) === false && (evt.qClonedBy === void 0 || evt.qClonedBy.indexOf(ctx.uid) === -1);
}
//#endregion
//#region src/directives/touch-swipe/TouchSwipe.js
function parseArg(arg) {
    const data = [
        .06,
        6,
        50
    ];
    if (typeof arg === "string" && arg.length) arg.split(":").forEach((val, index)=>{
        const v = parseFloat(val);
        if (v) data[index] = v;
    });
    return data;
}
var TouchSwipe_default = createDirective({
    name: "touch-swipe",
    beforeMount (el, { value: value1, arg, modifiers }) {
        if (modifiers.mouse !== true && client.has.touch !== true) return;
        const mouseCapture = modifiers.mouseCapture === true ? "Capture" : "";
        const ctx = {
            handler: value1,
            sensitivity: parseArg(arg),
            direction: getModifierDirections(modifiers),
            noop,
            mouseStart (evt) {
                if (shouldStart(evt, ctx) && leftClick(evt)) {
                    addEvt(ctx, "temp", [
                        [
                            document,
                            "mousemove",
                            "move",
                            `notPassive${mouseCapture}`
                        ],
                        [
                            document,
                            "mouseup",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt, true);
                }
            },
            touchStart (evt) {
                if (shouldStart(evt, ctx)) {
                    const target = evt.target;
                    addEvt(ctx, "temp", [
                        [
                            target,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            target,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            target,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt);
                }
            },
            start (evt, mouseEvent) {
                if (client.is.firefox === true) preventDraggable(el, true);
                const pos = position(evt);
                ctx.event = {
                    x: pos.left,
                    y: pos.top,
                    time: Date.now(),
                    mouse: mouseEvent === true,
                    dir: false
                };
            },
            move (evt) {
                if (ctx.event === void 0) return;
                if (ctx.event.dir !== false) {
                    stopAndPrevent(evt);
                    return;
                }
                const time = Date.now() - ctx.event.time;
                if (time === 0) return;
                const pos = position(evt), distX = pos.left - ctx.event.x, absX = Math.abs(distX), distY = pos.top - ctx.event.y, absY = Math.abs(distY);
                if (ctx.event.mouse !== true) {
                    if (absX < ctx.sensitivity[1] && absY < ctx.sensitivity[1]) {
                        ctx.end(evt);
                        return;
                    }
                } else if (window.getSelection().toString() !== "") {
                    ctx.end(evt);
                    return;
                } else if (absX < ctx.sensitivity[2] && absY < ctx.sensitivity[2]) return;
                const velX = absX / time, velY = absY / time;
                if (ctx.direction.vertical === true && absX < absY && absX < 100 && velY > ctx.sensitivity[0]) ctx.event.dir = distY < 0 ? "up" : "down";
                if (ctx.direction.horizontal === true && absX > absY && absY < 100 && velX > ctx.sensitivity[0]) ctx.event.dir = distX < 0 ? "left" : "right";
                if (ctx.direction.up === true && absX < absY && distY < 0 && absX < 100 && velY > ctx.sensitivity[0]) ctx.event.dir = "up";
                if (ctx.direction.down === true && absX < absY && distY > 0 && absX < 100 && velY > ctx.sensitivity[0]) ctx.event.dir = "down";
                if (ctx.direction.left === true && absX > absY && distX < 0 && absY < 100 && velX > ctx.sensitivity[0]) ctx.event.dir = "left";
                if (ctx.direction.right === true && absX > absY && distX > 0 && absY < 100 && velX > ctx.sensitivity[0]) ctx.event.dir = "right";
                if (ctx.event.dir !== false) {
                    stopAndPrevent(evt);
                    if (ctx.event.mouse === true) {
                        document.body.classList.add("no-pointer-events--children");
                        document.body.classList.add("non-selectable");
                        clearSelection();
                        ctx.styleCleanup = (withDelay)=>{
                            ctx.styleCleanup = void 0;
                            document.body.classList.remove("non-selectable");
                            const remove = ()=>{
                                document.body.classList.remove("no-pointer-events--children");
                            };
                            if (withDelay === true) setTimeout(remove, 50);
                            else remove();
                        };
                    }
                    ctx.handler({
                        evt,
                        touch: ctx.event.mouse !== true,
                        mouse: ctx.event.mouse,
                        direction: ctx.event.dir,
                        duration: time,
                        distance: {
                            x: absX,
                            y: absY
                        }
                    });
                } else ctx.end(evt);
            },
            end (evt) {
                if (ctx.event === void 0) return;
                cleanEvt(ctx, "temp");
                if (client.is.firefox === true) preventDraggable(el, false);
                ctx.styleCleanup?.(true);
                if (evt !== void 0 && ctx.event.dir !== false) stopAndPrevent(evt);
                ctx.event = void 0;
            }
        };
        el.__qtouchswipe = ctx;
        if (modifiers.mouse === true) addEvt(ctx, "main", [
            [
                el,
                "mousedown",
                "mouseStart",
                `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : ""}`
            ]
        ]);
        if (client.has.touch === true) addEvt(ctx, "main", [
            [
                el,
                "touchstart",
                "touchStart",
                `passive${modifiers.capture === true ? "Capture" : ""}`
            ],
            [
                el,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (el, bindings) {
        const ctx = el.__qtouchswipe;
        if (ctx !== void 0) {
            if (bindings.oldValue !== bindings.value) {
                if (typeof bindings.value !== "function") ctx.end();
                ctx.handler = bindings.value;
            }
            ctx.direction = getModifierDirections(bindings.modifiers);
        }
    },
    beforeUnmount (el) {
        const ctx = el.__qtouchswipe;
        if (ctx !== void 0) {
            cleanEvt(ctx, "main");
            cleanEvt(ctx, "temp");
            if (client.is.firefox === true) preventDraggable(el, false);
            ctx.styleCleanup?.();
            delete el.__qtouchswipe;
        }
    }
});
//#endregion
//#region src/composables/use-render-cache/use-render-cache.js
function useRenderCache() {
    let cache = Object.create(null);
    return {
        getCache: (key, defaultValue)=>cache[key] === void 0 ? cache[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue : cache[key],
        setCache (key, obj) {
            cache[key] = obj;
        },
        hasCache (key) {
            return Object.hasOwnProperty.call(cache, key);
        },
        clearCache (key) {
            if (key !== void 0) delete cache[key];
            else cache = Object.create(null);
        }
    };
}
//#endregion
//#region src/composables/private.use-panel/use-panel.js
const usePanelChildProps = {
    name: {
        required: true
    },
    disable: Boolean
};
const PanelWrapper$1 = {
    setup (_, { slots }) {
        return ()=>(0, _vue.h)("div", {
                class: "q-panel scroll",
                role: "tabpanel"
            }, hSlot(slots.default));
    }
};
const usePanelProps = {
    modelValue: {
        required: true
    },
    animated: Boolean,
    infinite: Boolean,
    swipeable: Boolean,
    vertical: Boolean,
    transitionPrev: String,
    transitionNext: String,
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    },
    keepAlive: Boolean,
    keepAliveInclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveExclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveMax: Number
};
const usePanelEmits = [
    "update:modelValue",
    "beforeTransition",
    "transition"
];
function usePanel() {
    const { props, emit, proxy } = (0, _vue.getCurrentInstance)();
    const { getCache } = useRenderCache();
    const { registerTimeout } = useTimeout();
    let panels, forcedPanelTransition;
    const panelTransition = (0, _vue.ref)(null);
    const panelIndex = {
        value: null
    };
    function onSwipe(evt) {
        const dir = props.vertical === true ? "up" : "left";
        goToPanelByOffset((proxy.$q.lang.rtl === true ? -1 : 1) * (evt.direction === dir ? 1 : -1));
    }
    const panelDirectives = (0, _vue.computed)(()=>[
            [
                TouchSwipe_default,
                onSwipe,
                void 0,
                {
                    horizontal: props.vertical !== true,
                    vertical: props.vertical,
                    mouse: true
                }
            ]
        ]);
    const transitionPrev = (0, _vue.computed)(()=>props.transitionPrev || `slide-${props.vertical === true ? "down" : "right"}`);
    const transitionNext = (0, _vue.computed)(()=>props.transitionNext || `slide-${props.vertical === true ? "up" : "left"}`);
    const transitionStyle = (0, _vue.computed)(()=>`--q-transition-duration: ${props.transitionDuration}ms`);
    const contentKey = (0, _vue.computed)(()=>typeof props.modelValue === "string" || typeof props.modelValue === "number" ? props.modelValue : String(props.modelValue));
    const keepAliveProps = (0, _vue.computed)(()=>({
            include: props.keepAliveInclude,
            exclude: props.keepAliveExclude,
            max: props.keepAliveMax
        }));
    const needsUniqueKeepAliveWrapper = (0, _vue.computed)(()=>props.keepAliveInclude !== void 0 || props.keepAliveExclude !== void 0);
    (0, _vue.watch)(()=>props.modelValue, (newVal, oldVal)=>{
        const index = isValidPanelName(newVal) === true ? getPanelIndex(newVal) : -1;
        if (forcedPanelTransition !== true) updatePanelTransition(index === -1 ? 0 : index < getPanelIndex(oldVal) ? -1 : 1);
        if (panelIndex.value !== index) {
            panelIndex.value = index;
            emit("beforeTransition", newVal, oldVal);
            registerTimeout(()=>{
                emit("transition", newVal, oldVal);
            }, props.transitionDuration);
        }
    });
    function nextPanel() {
        goToPanelByOffset(1);
    }
    function previousPanel() {
        goToPanelByOffset(-1);
    }
    function goToPanel(name) {
        emit("update:modelValue", name);
    }
    function isValidPanelName(name) {
        return name !== void 0 && name !== null && name !== "";
    }
    function getPanelIndex(name) {
        return panels.findIndex((panel)=>panel.props.name === name && panel.props.disable !== "" && panel.props.disable !== true);
    }
    function getEnabledPanels() {
        return panels.filter((panel)=>panel.props.disable !== "" && panel.props.disable !== true);
    }
    function updatePanelTransition(direction) {
        const val = direction !== 0 && props.animated === true && panelIndex.value !== -1 ? "q-transition--" + (direction === -1 ? transitionPrev.value : transitionNext.value) : null;
        if (panelTransition.value !== val) panelTransition.value = val;
    }
    function goToPanelByOffset(direction, startIndex = panelIndex.value) {
        let index = startIndex + direction;
        while(index !== -1 && index < panels.length){
            const opt = panels[index];
            if (opt !== void 0 && opt.props.disable !== "" && opt.props.disable !== true) {
                updatePanelTransition(direction);
                forcedPanelTransition = true;
                emit("update:modelValue", opt.props.name);
                setTimeout(()=>{
                    forcedPanelTransition = false;
                });
                return;
            }
            index += direction;
        }
        if (props.infinite === true && panels.length !== 0 && startIndex !== -1 && startIndex !== panels.length) goToPanelByOffset(direction, direction === -1 ? panels.length : -1);
    }
    function updatePanelIndex() {
        const index = getPanelIndex(props.modelValue);
        if (panelIndex.value !== index) panelIndex.value = index;
        return true;
    }
    function getPanelContentChild() {
        const panel = isValidPanelName(props.modelValue) === true && updatePanelIndex() && panels[panelIndex.value];
        return props.keepAlive === true ? [
            (0, _vue.h)((0, _vue.KeepAlive), keepAliveProps.value, [
                (0, _vue.h)(needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, ()=>({
                        ...PanelWrapper$1,
                        name: contentKey.value
                    })) : PanelWrapper$1, {
                    key: contentKey.value,
                    style: transitionStyle.value
                }, ()=>panel)
            ])
        ] : [
            (0, _vue.h)("div", {
                class: "q-panel scroll",
                style: transitionStyle.value,
                key: contentKey.value,
                role: "tabpanel"
            }, [
                panel
            ])
        ];
    }
    function getPanelContent() {
        if (panels.length === 0) return;
        return props.animated === true ? [
            (0, _vue.h)((0, _vue.Transition), {
                name: panelTransition.value
            }, getPanelContentChild)
        ] : getPanelContentChild();
    }
    function updatePanelsList(slots) {
        panels = getNormalizedVNodes(hSlot(slots.default, [])).filter((panel)=>panel.props !== null && panel.props.slot === void 0 && isValidPanelName(panel.props.name) === true);
        return panels.length;
    }
    function getPanels() {
        return panels;
    }
    Object.assign(proxy, {
        next: nextPanel,
        previous: previousPanel,
        goTo: goToPanel
    });
    return {
        panelIndex,
        panelDirectives,
        updatePanelsList,
        updatePanelIndex,
        getPanelContent,
        getEnabledPanels,
        getPanels,
        isValidPanelName,
        keepAliveProps,
        needsUniqueKeepAliveWrapper,
        goToPanelByOffset,
        goToPanel,
        nextPanel,
        previousPanel
    };
}
//#endregion
//#region src/composables/private.use-fullscreen/use-fullscreen.js
let counter = 0;
const useFullscreenProps = {
    fullscreen: Boolean,
    noRouteFullscreenExit: Boolean
};
const useFullscreenEmits = [
    "update:fullscreen",
    "fullscreen"
];
function useFullscreen() {
    const vm = (0, _vue.getCurrentInstance)();
    const { props, emit, proxy } = vm;
    let historyEntry, fullscreenFillerNode, container;
    const inFullscreen = (0, _vue.ref)(false);
    if (vmHasRouter(vm) === true) (0, _vue.watch)(()=>proxy.$route.fullPath, ()=>{
        if (props.noRouteFullscreenExit !== true) exitFullscreen();
    });
    (0, _vue.watch)(()=>props.fullscreen, (v)=>{
        if (inFullscreen.value !== v) toggleFullscreen();
    });
    (0, _vue.watch)(inFullscreen, (v)=>{
        emit("update:fullscreen", v);
        emit("fullscreen", v);
    });
    function toggleFullscreen() {
        if (inFullscreen.value === true) exitFullscreen();
        else setFullscreen();
    }
    function setFullscreen() {
        if (inFullscreen.value === true) return;
        inFullscreen.value = true;
        container = proxy.$el.parentNode;
        container.replaceChild(fullscreenFillerNode, proxy.$el);
        document.body.appendChild(proxy.$el);
        counter++;
        if (counter === 1) document.body.classList.add("q-body--fullscreen-mixin");
        historyEntry = {
            handler: exitFullscreen
        };
        History_default.add(historyEntry);
    }
    function exitFullscreen() {
        if (inFullscreen.value !== true) return;
        if (historyEntry !== void 0) {
            History_default.remove(historyEntry);
            historyEntry = void 0;
        }
        container.replaceChild(proxy.$el, fullscreenFillerNode);
        inFullscreen.value = false;
        counter = Math.max(0, counter - 1);
        if (counter === 0) {
            document.body.classList.remove("q-body--fullscreen-mixin");
            if (proxy.$el.scrollIntoView !== void 0) setTimeout(()=>{
                proxy.$el.scrollIntoView();
            });
        }
    }
    (0, _vue.onBeforeMount)(()=>{
        fullscreenFillerNode = document.createElement("span");
    });
    (0, _vue.onMounted)(()=>{
        if (props.fullscreen === true) setFullscreen();
    });
    (0, _vue.onBeforeUnmount)(exitFullscreen);
    Object.assign(proxy, {
        toggleFullscreen,
        setFullscreen,
        exitFullscreen
    });
    return {
        inFullscreen,
        toggleFullscreen
    };
}
//#endregion
//#region src/components/carousel/QCarousel.js
const navigationPositionOptions = [
    "top",
    "right",
    "bottom",
    "left"
];
const controlTypeOptions = [
    "regular",
    "flat",
    "outline",
    "push",
    "unelevated"
];
var QCarousel_default = createComponent({
    name: "QCarousel",
    props: {
        ...useDarkProps,
        ...usePanelProps,
        ...useFullscreenProps,
        transitionPrev: {
            type: String,
            default: "fade"
        },
        transitionNext: {
            type: String,
            default: "fade"
        },
        height: String,
        padding: Boolean,
        controlColor: String,
        controlTextColor: String,
        controlType: {
            type: String,
            validator: (v)=>controlTypeOptions.includes(v),
            default: "flat"
        },
        autoplay: [
            Number,
            Boolean
        ],
        arrows: Boolean,
        prevIcon: String,
        nextIcon: String,
        navigation: Boolean,
        navigationPosition: {
            type: String,
            validator: (v)=>navigationPositionOptions.includes(v)
        },
        navigationIcon: String,
        navigationActiveIcon: String,
        thumbnails: Boolean
    },
    emits: [
        ...useFullscreenEmits,
        ...usePanelEmits
    ],
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        let timer = null, panelsLen;
        const { updatePanelsList, getPanelContent, panelDirectives, goToPanel, previousPanel, nextPanel, getEnabledPanels, panelIndex } = usePanel();
        const { inFullscreen } = useFullscreen();
        const style = (0, _vue.computed)(()=>inFullscreen.value !== true && props.height !== void 0 ? {
                height: props.height
            } : {});
        const direction = (0, _vue.computed)(()=>props.vertical === true ? "vertical" : "horizontal");
        const navigationPosition = (0, _vue.computed)(()=>props.navigationPosition || (props.vertical === true ? "right" : "bottom"));
        const classes = (0, _vue.computed)(()=>`q-carousel q-panel-parent q-carousel--with${props.padding === true ? "" : "out"}-padding` + (inFullscreen.value === true ? " fullscreen" : "") + (isDark.value === true ? " q-carousel--dark q-dark" : "") + (props.arrows === true ? ` q-carousel--arrows-${direction.value}` : "") + (props.navigation === true ? ` q-carousel--navigation-${navigationPosition.value}` : ""));
        const arrowIcons = (0, _vue.computed)(()=>{
            const ico = [
                props.prevIcon || $q.iconSet.carousel[props.vertical === true ? "up" : "left"],
                props.nextIcon || $q.iconSet.carousel[props.vertical === true ? "down" : "right"]
            ];
            return props.vertical === false && $q.lang.rtl === true ? ico.reverse() : ico;
        });
        const navIcon = (0, _vue.computed)(()=>props.navigationIcon || $q.iconSet.carousel.navigationIcon);
        const navActiveIcon = (0, _vue.computed)(()=>props.navigationActiveIcon || navIcon.value);
        const controlProps = (0, _vue.computed)(()=>({
                color: props.controlColor,
                textColor: props.controlTextColor,
                round: true,
                [props.controlType]: true,
                dense: true
            }));
        (0, _vue.watch)(()=>props.modelValue, ()=>{
            if (props.autoplay) startTimer();
        });
        (0, _vue.watch)(()=>props.autoplay, (val)=>{
            if (val) startTimer();
            else if (timer !== null) {
                clearTimeout(timer);
                timer = null;
            }
        });
        function startTimer() {
            const duration = isNumber(props.autoplay) === true ? Math.abs(props.autoplay) : 5e3;
            if (timer !== null) clearTimeout(timer);
            timer = setTimeout(()=>{
                timer = null;
                if (duration >= 0) nextPanel();
                else previousPanel();
            }, duration);
        }
        (0, _vue.onMounted)(()=>{
            if (props.autoplay) startTimer();
        });
        (0, _vue.onBeforeUnmount)(()=>{
            if (timer !== null) clearTimeout(timer);
        });
        function getNavigationContainer(type, mapping) {
            return (0, _vue.h)("div", {
                class: `q-carousel__control q-carousel__navigation no-wrap absolute flex q-carousel__navigation--${type} q-carousel__navigation--${navigationPosition.value}` + (props.controlColor !== void 0 ? ` text-${props.controlColor}` : "")
            }, [
                (0, _vue.h)("div", {
                    class: "q-carousel__navigation-inner flex flex-center no-wrap"
                }, getEnabledPanels().map(mapping))
            ]);
        }
        function getContent() {
            const node = [];
            if (props.navigation === true) {
                const fn = slots["navigation-icon"] !== void 0 ? slots["navigation-icon"] : (opts)=>(0, _vue.h)(QBtn_default, {
                        key: "nav" + opts.name,
                        class: `q-carousel__navigation-icon q-carousel__navigation-icon--${opts.active === true ? "" : "in"}active`,
                        ...opts.btnProps,
                        onClick: opts.onClick
                    });
                const maxIndex = panelsLen - 1;
                node.push(getNavigationContainer("buttons", (panel, index)=>{
                    const name = panel.props.name;
                    const active = panelIndex.value === index;
                    return fn({
                        index,
                        maxIndex,
                        name,
                        active,
                        btnProps: {
                            icon: active === true ? navActiveIcon.value : navIcon.value,
                            size: "sm",
                            ...controlProps.value
                        },
                        onClick: ()=>{
                            goToPanel(name);
                        }
                    });
                }));
            } else if (props.thumbnails === true) {
                const color = props.controlColor !== void 0 ? ` text-${props.controlColor}` : "";
                node.push(getNavigationContainer("thumbnails", (panel)=>{
                    const slide = panel.props;
                    return (0, _vue.h)("img", {
                        key: "tmb#" + slide.name,
                        class: `q-carousel__thumbnail q-carousel__thumbnail--${slide.name === props.modelValue ? "" : "in"}active` + color,
                        src: slide.imgSrc || slide["img-src"],
                        onClick: ()=>{
                            goToPanel(slide.name);
                        }
                    });
                }));
            }
            if (props.arrows === true && panelIndex.value >= 0) {
                if (props.infinite === true || panelIndex.value > 0) node.push((0, _vue.h)("div", {
                    key: "prev",
                    class: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${direction.value} absolute flex flex-center`
                }, [
                    (0, _vue.h)(QBtn_default, {
                        icon: arrowIcons.value[0],
                        ...controlProps.value,
                        onClick: previousPanel
                    })
                ]));
                if (props.infinite === true || panelIndex.value < panelsLen - 1) node.push((0, _vue.h)("div", {
                    key: "next",
                    class: `q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--${direction.value} absolute flex flex-center`
                }, [
                    (0, _vue.h)(QBtn_default, {
                        icon: arrowIcons.value[1],
                        ...controlProps.value,
                        onClick: nextPanel
                    })
                ]));
            }
            return hMergeSlot(slots.control, node);
        }
        return ()=>{
            panelsLen = updatePanelsList(slots);
            return (0, _vue.h)("div", {
                class: classes.value,
                style: style.value
            }, [
                hDir("div", {
                    class: "q-carousel__slides-container"
                }, getPanelContent(), "sl-cont", props.swipeable, ()=>panelDirectives.value)
            ].concat(getContent()));
        };
    }
});
//#endregion
//#region src/components/carousel/QCarouselSlide.js
var QCarouselSlide_default = createComponent({
    name: "QCarouselSlide",
    props: {
        ...usePanelChildProps,
        imgSrc: String
    },
    setup (props, { slots }) {
        const style = (0, _vue.computed)(()=>props.imgSrc ? {
                backgroundImage: `url("${props.imgSrc}")`
            } : {});
        return ()=>(0, _vue.h)("div", {
                class: "q-carousel__slide",
                style: style.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/carousel/QCarouselControl.js
var QCarouselControl_default = createComponent({
    name: "QCarouselControl",
    props: {
        position: {
            type: String,
            default: "bottom-right",
            validator: (v)=>[
                    "top-right",
                    "top-left",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "right",
                    "bottom",
                    "left"
                ].includes(v)
        },
        offset: {
            type: Array,
            default: ()=>[
                    18,
                    18
                ],
            validator: (v)=>v.length === 2
        }
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>`q-carousel__control absolute absolute-${props.position}`);
        const style = (0, _vue.computed)(()=>({
                margin: `${props.offset[1]}px ${props.offset[0]}px`
            }));
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                style: style.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/chat/QChatMessage.js
var QChatMessage_default = createComponent({
    name: "QChatMessage",
    props: {
        sent: Boolean,
        label: String,
        bgColor: String,
        textColor: String,
        name: String,
        avatar: String,
        text: Array,
        stamp: String,
        size: String,
        labelHtml: Boolean,
        nameHtml: Boolean,
        textHtml: Boolean,
        stampHtml: Boolean
    },
    setup (props, { slots }) {
        const op = (0, _vue.computed)(()=>props.sent === true ? "sent" : "received");
        const textClass = (0, _vue.computed)(()=>`q-message-text-content q-message-text-content--${op.value}` + (props.textColor !== void 0 ? ` text-${props.textColor}` : ""));
        const messageClass = (0, _vue.computed)(()=>`q-message-text q-message-text--${op.value}` + (props.bgColor !== void 0 ? ` text-${props.bgColor}` : ""));
        const containerClass = (0, _vue.computed)(()=>"q-message-container row items-end no-wrap" + (props.sent === true ? " reverse" : ""));
        const sizeClass = (0, _vue.computed)(()=>props.size !== void 0 ? `col-${props.size}` : "");
        const domProps = (0, _vue.computed)(()=>({
                msg: props.textHtml === true ? "innerHTML" : "textContent",
                stamp: props.stampHtml === true ? "innerHTML" : "textContent",
                name: props.nameHtml === true ? "innerHTML" : "textContent",
                label: props.labelHtml === true ? "innerHTML" : "textContent"
            }));
        function wrapStamp(node) {
            if (slots.stamp !== void 0) return [
                node,
                (0, _vue.h)("div", {
                    class: "q-message-stamp"
                }, slots.stamp())
            ];
            if (props.stamp) return [
                node,
                (0, _vue.h)("div", {
                    class: "q-message-stamp",
                    [domProps.value.stamp]: props.stamp
                })
            ];
            return [
                node
            ];
        }
        function getText(contentList, withSlots) {
            const content = withSlots === true ? contentList.length > 1 ? (text)=>text : (text)=>(0, _vue.h)("div", [
                    text
                ]) : (text)=>(0, _vue.h)("div", {
                    [domProps.value.msg]: text
                });
            return contentList.map((msg, index)=>(0, _vue.h)("div", {
                    key: index,
                    class: messageClass.value
                }, [
                    (0, _vue.h)("div", {
                        class: textClass.value
                    }, wrapStamp(content(msg)))
                ]));
        }
        return ()=>{
            const container = [];
            if (slots.avatar !== void 0) container.push(slots.avatar());
            else if (props.avatar !== void 0) container.push((0, _vue.h)("img", {
                class: `q-message-avatar q-message-avatar--${op.value}`,
                src: props.avatar,
                "aria-hidden": "true"
            }));
            const msg = [];
            if (slots.name !== void 0) msg.push((0, _vue.h)("div", {
                class: `q-message-name q-message-name--${op.value}`
            }, slots.name()));
            else if (props.name !== void 0) msg.push((0, _vue.h)("div", {
                class: `q-message-name q-message-name--${op.value}`,
                [domProps.value.name]: props.name
            }));
            if (slots.default !== void 0) msg.push(getText(getNormalizedVNodes(slots.default()), true));
            else if (props.text !== void 0) msg.push(getText(props.text));
            container.push((0, _vue.h)("div", {
                class: sizeClass.value
            }, msg));
            const child = [];
            if (slots.label !== void 0) child.push((0, _vue.h)("div", {
                class: "q-message-label"
            }, slots.label()));
            else if (props.label !== void 0) child.push((0, _vue.h)("div", {
                class: "q-message-label",
                [domProps.value.label]: props.label
            }));
            child.push((0, _vue.h)("div", {
                class: containerClass.value
            }, container));
            return (0, _vue.h)("div", {
                class: `q-message q-message-${op.value}`
            }, child);
        };
    }
});
//#endregion
//#region src/composables/private.use-refocus-target/use-refocus-target.js
function useRefocusTarget(props, rootRef) {
    const refocusRef = (0, _vue.ref)(null);
    const refocusTargetEl = (0, _vue.computed)(()=>{
        if (props.disable === true) return null;
        return (0, _vue.h)("span", {
            ref: refocusRef,
            class: "no-outline",
            tabindex: -1
        });
    });
    function refocusTarget(e) {
        const root = rootRef.value;
        if (e?.qAvoidFocus === true) return;
        if (e?.type.indexOf("key") === 0) {
            if (document.activeElement !== root && root?.contains(document.activeElement) === true) root.focus();
        } else if (refocusRef.value !== null && (e === void 0 || root?.contains(e.target) === true)) refocusRef.value.focus();
    }
    return {
        refocusTargetEl,
        refocusTarget
    };
}
//#endregion
//#region src/utils/private.option-sizes/option-sizes.js
var option_sizes_default = {
    xs: 30,
    sm: 35,
    md: 40,
    lg: 50,
    xl: 60
};
//#endregion
//#region src/components/checkbox/use-checkbox.js
const useCheckboxProps = {
    ...useDarkProps,
    ...useSizeProps,
    ...useFormProps,
    modelValue: {
        required: true,
        default: null
    },
    val: {},
    trueValue: {
        default: true
    },
    falseValue: {
        default: false
    },
    indeterminateValue: {
        default: null
    },
    checkedIcon: String,
    uncheckedIcon: String,
    indeterminateIcon: String,
    toggleOrder: {
        type: String,
        validator: (v)=>v === "tf" || v === "ft"
    },
    toggleIndeterminate: Boolean,
    label: String,
    leftLabel: Boolean,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [
        String,
        Number
    ]
};
const useCheckboxEmits = [
    "update:modelValue"
];
function useCheckbox(type, getInner) {
    const { props, slots, emit, proxy } = (0, _vue.getCurrentInstance)();
    const { $q } = proxy;
    const isDark = useDark(props, $q);
    const rootRef = (0, _vue.ref)(null);
    const { refocusTargetEl, refocusTarget } = useRefocusTarget(props, rootRef);
    const sizeStyle = useSize(props, option_sizes_default);
    const modelIsArray = (0, _vue.computed)(()=>props.val !== void 0 && Array.isArray(props.modelValue));
    const index = (0, _vue.computed)(()=>{
        const val = (0, _vue.toRaw)(props.val);
        return modelIsArray.value === true ? props.modelValue.findIndex((opt)=>(0, _vue.toRaw)(opt) === val) : -1;
    });
    const isTrue = (0, _vue.computed)(()=>modelIsArray.value === true ? index.value !== -1 : (0, _vue.toRaw)(props.modelValue) === (0, _vue.toRaw)(props.trueValue));
    const isFalse = (0, _vue.computed)(()=>modelIsArray.value === true ? index.value === -1 : (0, _vue.toRaw)(props.modelValue) === (0, _vue.toRaw)(props.falseValue));
    const isIndeterminate = (0, _vue.computed)(()=>isTrue.value === false && isFalse.value === false);
    const tabindex = (0, _vue.computed)(()=>props.disable === true ? -1 : props.tabindex || 0);
    const classes = (0, _vue.computed)(()=>`q-${type} cursor-pointer no-outline row inline no-wrap items-center` + (props.disable === true ? " disabled" : "") + (isDark.value === true ? ` q-${type}--dark` : "") + (props.dense === true ? ` q-${type}--dense` : "") + (props.leftLabel === true ? " reverse" : ""));
    const innerClass = (0, _vue.computed)(()=>{
        return `q-${type}__inner relative-position non-selectable q-${type}__inner--${isTrue.value === true ? "truthy" : isFalse.value === true ? "falsy" : "indet"}${props.color !== void 0 && (props.keepColor === true || (type === "toggle" ? isTrue.value === true : isFalse.value !== true)) ? ` text-${props.color}` : ""}`;
    });
    const injectFormInput = useFormInject((0, _vue.computed)(()=>{
        const prop = {
            type: "checkbox"
        };
        if (props.name !== void 0) Object.assign(prop, {
            ".checked": isTrue.value,
            "^checked": isTrue.value === true ? "checked" : void 0,
            name: props.name,
            value: modelIsArray.value === true ? props.val : props.trueValue
        });
        return prop;
    }));
    const attributes = (0, _vue.computed)(()=>{
        const attrs = {
            tabindex: tabindex.value,
            role: type === "toggle" ? "switch" : "checkbox",
            "aria-label": props.label,
            "aria-checked": isIndeterminate.value === true ? "mixed" : isTrue.value === true ? "true" : "false"
        };
        if (props.disable === true) attrs["aria-disabled"] = "true";
        return attrs;
    });
    function onClick(e) {
        if (e !== void 0) {
            stopAndPrevent(e);
            refocusTarget(e);
        }
        if (props.disable !== true) emit("update:modelValue", getNextValue(), e);
    }
    function getNextValue() {
        if (modelIsArray.value === true) {
            if (isTrue.value === true) {
                const val = props.modelValue.slice();
                val.splice(index.value, 1);
                return val;
            }
            return props.modelValue.concat([
                props.val
            ]);
        }
        if (isTrue.value === true) {
            if (props.toggleOrder !== "ft" || props.toggleIndeterminate === false) return props.falseValue;
        } else if (isFalse.value === true) {
            if (props.toggleOrder === "ft" || props.toggleIndeterminate === false) return props.trueValue;
        } else return props.toggleOrder !== "ft" ? props.trueValue : props.falseValue;
        return props.indeterminateValue;
    }
    function onKeydown(e) {
        if (e.keyCode === 13 || e.keyCode === 32) stopAndPrevent(e);
    }
    function onKeyup(e) {
        if (e.keyCode === 13 || e.keyCode === 32) onClick(e);
    }
    const getInnerContent = getInner(isTrue, isIndeterminate);
    Object.assign(proxy, {
        toggle: onClick
    });
    return ()=>{
        const inner = getInnerContent();
        if (props.disable !== true) injectFormInput(inner, "unshift", ` q-${type}__native absolute q-ma-none q-pa-none`);
        const child = [
            (0, _vue.h)("div", {
                class: innerClass.value,
                style: sizeStyle.value,
                "aria-hidden": "true"
            }, inner)
        ];
        if (refocusTargetEl.value !== null) child.push(refocusTargetEl.value);
        const label = props.label !== void 0 ? hMergeSlot(slots.default, [
            props.label
        ]) : hSlot(slots.default);
        if (label !== void 0) child.push((0, _vue.h)("div", {
            class: `q-${type}__label q-anchor--skip`
        }, label));
        return (0, _vue.h)("div", {
            ref: rootRef,
            class: classes.value,
            ...attributes.value,
            onClick,
            onKeydown,
            onKeyup
        }, child);
    };
}
//#endregion
//#region src/components/checkbox/QCheckbox.js
const createBgNode = ()=>(0, _vue.h)("div", {
        key: "svg",
        class: "q-checkbox__bg absolute"
    }, [
        (0, _vue.h)("svg", {
            class: "q-checkbox__svg fit absolute-full",
            viewBox: "0 0 24 24"
        }, [
            (0, _vue.h)("path", {
                class: "q-checkbox__truthy",
                fill: "none",
                d: "M1.73,12.91 8.1,19.28 22.79,4.59"
            }),
            (0, _vue.h)("path", {
                class: "q-checkbox__indet",
                d: "M4,14H20V10H4"
            })
        ])
    ]);
var QCheckbox_default = createComponent({
    name: "QCheckbox",
    props: useCheckboxProps,
    emits: useCheckboxEmits,
    setup (props) {
        const bgNode = createBgNode();
        function getInner(isTrue, isIndeterminate) {
            const icon = (0, _vue.computed)(()=>(isTrue.value === true ? props.checkedIcon : isIndeterminate.value === true ? props.indeterminateIcon : props.uncheckedIcon) || null);
            return ()=>icon.value !== null ? [
                    (0, _vue.h)("div", {
                        key: "icon",
                        class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
                    }, [
                        (0, _vue.h)(QIcon_default, {
                            class: "q-checkbox__icon",
                            name: icon.value
                        })
                    ])
                ] : [
                    bgNode
                ];
        }
        return useCheckbox("checkbox", getInner);
    }
});
//#endregion
//#region src/components/chip/QChip.js
const defaultSizes$1 = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
};
var QChip_default = createComponent({
    name: "QChip",
    props: {
        ...useDarkProps,
        ...useSizeProps,
        dense: Boolean,
        icon: String,
        iconRight: String,
        iconRemove: String,
        iconSelected: String,
        label: [
            String,
            Number
        ],
        color: String,
        textColor: String,
        modelValue: {
            type: Boolean,
            default: true
        },
        selected: {
            type: Boolean,
            default: null
        },
        square: Boolean,
        outline: Boolean,
        clickable: Boolean,
        removable: Boolean,
        removeAriaLabel: String,
        tabindex: [
            String,
            Number
        ],
        disable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: true
        }
    },
    emits: [
        "update:modelValue",
        "update:selected",
        "remove",
        "click"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const sizeStyle = useSize(props, defaultSizes$1);
        const hasLeftIcon = (0, _vue.computed)(()=>props.selected === true || props.icon !== void 0);
        const leftIcon = (0, _vue.computed)(()=>props.selected === true ? props.iconSelected || $q.iconSet.chip.selected : props.icon);
        const removeIcon = (0, _vue.computed)(()=>props.iconRemove || $q.iconSet.chip.remove);
        const isClickable = (0, _vue.computed)(()=>props.disable === false && (props.clickable === true || props.selected !== null));
        const classes = (0, _vue.computed)(()=>{
            const text = props.outline === true ? props.color || props.textColor : props.textColor;
            return "q-chip row inline no-wrap items-center" + (props.outline === false && props.color !== void 0 ? ` bg-${props.color}` : "") + (text ? ` text-${text} q-chip--colored` : "") + (props.disable === true ? " disabled" : "") + (props.dense === true ? " q-chip--dense" : "") + (props.outline === true ? " q-chip--outline" : "") + (props.selected === true ? " q-chip--selected" : "") + (isClickable.value === true ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (props.square === true ? " q-chip--square" : "") + (isDark.value === true ? " q-chip--dark q-dark" : "");
        });
        const attributes = (0, _vue.computed)(()=>{
            const chip = props.disable === true ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: props.tabindex || 0
            };
            return {
                chip,
                remove: {
                    ...chip,
                    role: "button",
                    "aria-hidden": "false",
                    "aria-label": props.removeAriaLabel || $q.lang.label.remove
                }
            };
        });
        function onKeyup(e) {
            if (e.keyCode === 13) onClick(e);
        }
        function onClick(e) {
            if (!props.disable) {
                emit("update:selected", !props.selected);
                emit("click", e);
            }
        }
        function onRemove(e) {
            if (e.keyCode === void 0 || e.keyCode === 13) {
                stopAndPrevent(e);
                if (props.disable === false) {
                    emit("update:modelValue", false);
                    emit("remove");
                }
            }
        }
        function getContent() {
            const child = [];
            if (isClickable.value === true) child.push((0, _vue.h)("div", {
                class: "q-focus-helper"
            }));
            if (hasLeftIcon.value === true) child.push((0, _vue.h)(QIcon_default, {
                class: "q-chip__icon q-chip__icon--left",
                name: leftIcon.value
            }));
            const label = props.label !== void 0 ? [
                (0, _vue.h)("div", {
                    class: "ellipsis"
                }, [
                    props.label
                ])
            ] : void 0;
            child.push((0, _vue.h)("div", {
                class: "q-chip__content col row no-wrap items-center q-anchor--skip"
            }, hMergeSlotSafely(slots.default, label)));
            if (props.iconRight) child.push((0, _vue.h)(QIcon_default, {
                class: "q-chip__icon q-chip__icon--right",
                name: props.iconRight
            }));
            if (props.removable === true) child.push((0, _vue.h)(QIcon_default, {
                class: "q-chip__icon q-chip__icon--remove cursor-pointer",
                name: removeIcon.value,
                ...attributes.value.remove,
                onClick: onRemove,
                onKeyup: onRemove
            }));
            return child;
        }
        return ()=>{
            if (props.modelValue === false) return;
            const data = {
                class: classes.value,
                style: sizeStyle.value
            };
            if (isClickable.value === true) Object.assign(data, attributes.value.chip, {
                onClick,
                onKeyup
            });
            return hDir("div", data, getContent(), "ripple", props.ripple !== false && props.disable !== true, ()=>[
                    [
                        Ripple_default,
                        props.ripple
                    ]
                ]);
        };
    }
});
//#endregion
//#region src/components/circular-progress/circular-progress.js
const useCircularCommonProps = {
    ...useSizeProps,
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    color: String,
    centerColor: String,
    trackColor: String,
    fontSize: String,
    rounded: Boolean,
    thickness: {
        type: Number,
        default: .2,
        validator: (v)=>v >= 0 && v <= 1
    },
    angle: {
        type: Number,
        default: 0
    },
    showValue: Boolean,
    reverse: Boolean,
    instantFeedback: Boolean
};
//#endregion
//#region src/components/circular-progress/QCircularProgress.js
const radius = 50, diameter = 2 * radius, circumference = diameter * Math.PI, strokeDashArray = Math.round(circumference * 1e3) / 1e3;
var QCircularProgress_default = createComponent({
    name: "QCircularProgress",
    props: {
        ...useCircularCommonProps,
        value: {
            type: Number,
            default: 0
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        indeterminate: Boolean
    },
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const sizeStyle = useSize(props);
        const svgStyle = (0, _vue.computed)(()=>{
            const angle = ($q.lang.rtl === true ? -1 : 1) * props.angle;
            return {
                transform: props.reverse !== ($q.lang.rtl === true) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - angle}deg)` : `rotate3d(0, 0, 1, ${angle - 90}deg)`
            };
        });
        const circleStyle = (0, _vue.computed)(()=>props.instantFeedback !== true && props.indeterminate !== true ? {
                transition: `stroke-dashoffset ${props.animationSpeed}ms ease 0s, stroke ${props.animationSpeed}ms ease`
            } : "");
        const viewBox = (0, _vue.computed)(()=>diameter / (1 - props.thickness / 2));
        const viewBoxAttr = (0, _vue.computed)(()=>`${viewBox.value / 2} ${viewBox.value / 2} ${viewBox.value} ${viewBox.value}`);
        const normalized = (0, _vue.computed)(()=>between(props.value, props.min, props.max));
        const range = (0, _vue.computed)(()=>props.max - props.min);
        const strokeWidth = (0, _vue.computed)(()=>props.thickness / 2 * viewBox.value);
        const strokeDashOffset = (0, _vue.computed)(()=>{
            const dashRatio = (props.max - normalized.value) / range.value;
            const dashGap = props.rounded === true && normalized.value < props.max && dashRatio < .25 ? strokeWidth.value / 2 * (1 - dashRatio / .25) : 0;
            return circumference * dashRatio + dashGap;
        });
        function getCircle({ thickness, offset, color, cls, rounded }) {
            return (0, _vue.h)("circle", {
                class: "q-circular-progress__" + cls + (color !== void 0 ? ` text-${color}` : ""),
                style: circleStyle.value,
                fill: "transparent",
                stroke: "currentColor",
                "stroke-width": thickness,
                "stroke-dasharray": strokeDashArray,
                "stroke-dashoffset": offset,
                "stroke-linecap": rounded,
                cx: viewBox.value,
                cy: viewBox.value,
                r: radius
            });
        }
        return ()=>{
            const svgChild = [];
            if (props.centerColor !== void 0 && props.centerColor !== "transparent") svgChild.push((0, _vue.h)("circle", {
                class: `q-circular-progress__center text-${props.centerColor}`,
                fill: "currentColor",
                r: radius - strokeWidth.value / 2,
                cx: viewBox.value,
                cy: viewBox.value
            }));
            if (props.trackColor !== void 0 && props.trackColor !== "transparent") svgChild.push(getCircle({
                cls: "track",
                thickness: strokeWidth.value,
                offset: 0,
                color: props.trackColor
            }));
            svgChild.push(getCircle({
                cls: "circle",
                thickness: strokeWidth.value,
                offset: strokeDashOffset.value,
                color: props.color,
                rounded: props.rounded === true ? "round" : void 0
            }));
            const child = [
                (0, _vue.h)("svg", {
                    class: "q-circular-progress__svg",
                    style: svgStyle.value,
                    viewBox: viewBoxAttr.value,
                    "aria-hidden": "true"
                }, svgChild)
            ];
            if (props.showValue === true) child.push((0, _vue.h)("div", {
                class: "q-circular-progress__text absolute-full row flex-center content-center",
                style: {
                    fontSize: props.fontSize
                }
            }, slots.default !== void 0 ? slots.default() : [
                (0, _vue.h)("div", normalized.value)
            ]));
            return (0, _vue.h)("div", {
                class: `q-circular-progress q-circular-progress--${props.indeterminate === true ? "in" : ""}determinate`,
                style: sizeStyle.value,
                role: "progressbar",
                "aria-valuemin": props.min,
                "aria-valuemax": props.max,
                "aria-valuenow": props.indeterminate === true ? void 0 : normalized.value
            }, hMergeSlotSafely(slots.internal, child));
        };
    }
});
//#endregion
//#region src/directives/touch-pan/TouchPan.js
function getChanges(evt, ctx, isFinal) {
    const pos = position(evt);
    let dir, distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y, absX = Math.abs(distX), absY = Math.abs(distY);
    const direction = ctx.direction;
    if (direction.horizontal === true && direction.vertical !== true) dir = distX < 0 ? "left" : "right";
    else if (direction.horizontal !== true && direction.vertical === true) dir = distY < 0 ? "up" : "down";
    else if (direction.up === true && distY < 0) {
        dir = "up";
        if (absX > absY) {
            if (direction.left === true && distX < 0) dir = "left";
            else if (direction.right === true && distX > 0) dir = "right";
        }
    } else if (direction.down === true && distY > 0) {
        dir = "down";
        if (absX > absY) {
            if (direction.left === true && distX < 0) dir = "left";
            else if (direction.right === true && distX > 0) dir = "right";
        }
    } else if (direction.left === true && distX < 0) {
        dir = "left";
        if (absX < absY) {
            if (direction.up === true && distY < 0) dir = "up";
            else if (direction.down === true && distY > 0) dir = "down";
        }
    } else if (direction.right === true && distX > 0) {
        dir = "right";
        if (absX < absY) {
            if (direction.up === true && distY < 0) dir = "up";
            else if (direction.down === true && distY > 0) dir = "down";
        }
    }
    let synthetic = false;
    if (dir === void 0 && isFinal === false) {
        if (ctx.event.isFirst === true || ctx.event.lastDir === void 0) return {};
        dir = ctx.event.lastDir;
        synthetic = true;
        if (dir === "left" || dir === "right") {
            pos.left -= distX;
            absX = 0;
            distX = 0;
        } else {
            pos.top -= distY;
            absY = 0;
            distY = 0;
        }
    }
    return {
        synthetic,
        payload: {
            evt,
            touch: ctx.event.mouse !== true,
            mouse: ctx.event.mouse === true,
            position: pos,
            direction: dir,
            isFirst: ctx.event.isFirst,
            isFinal: isFinal === true,
            duration: Date.now() - ctx.event.time,
            distance: {
                x: absX,
                y: absY
            },
            offset: {
                x: distX,
                y: distY
            },
            delta: {
                x: pos.left - ctx.event.lastX,
                y: pos.top - ctx.event.lastY
            }
        }
    };
}
let uid$3 = 0;
var TouchPan_default = createDirective({
    name: "touch-pan",
    beforeMount (el, { value: value1, modifiers }) {
        if (modifiers.mouse !== true && client.has.touch !== true) return;
        function handleEvent(evt, mouseEvent) {
            if (modifiers.mouse === true && mouseEvent === true) stopAndPrevent(evt);
            else {
                if (modifiers.stop === true) stop(evt);
                if (modifiers.prevent === true) prevent(evt);
            }
        }
        const ctx = {
            uid: "qvtp_" + uid$3++,
            handler: value1,
            modifiers,
            direction: getModifierDirections(modifiers),
            noop,
            mouseStart (evt) {
                if (shouldStart(evt, ctx) && leftClick(evt)) {
                    addEvt(ctx, "temp", [
                        [
                            document,
                            "mousemove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            document,
                            "mouseup",
                            "end",
                            "passiveCapture"
                        ]
                    ]);
                    ctx.start(evt, true);
                }
            },
            touchStart (evt) {
                if (shouldStart(evt, ctx)) {
                    const target = evt.target;
                    addEvt(ctx, "temp", [
                        [
                            target,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            target,
                            "touchcancel",
                            "end",
                            "passiveCapture"
                        ],
                        [
                            target,
                            "touchend",
                            "end",
                            "passiveCapture"
                        ]
                    ]);
                    ctx.start(evt);
                }
            },
            start (evt, mouseEvent) {
                if (client.is.firefox === true) preventDraggable(el, true);
                ctx.lastEvt = evt;
                if (mouseEvent === true || modifiers.stop === true) {
                    if (ctx.direction.all !== true && (mouseEvent !== true || ctx.modifiers.mouseAllDir !== true && ctx.modifiers.mousealldir !== true)) {
                        const clone = evt.type.indexOf("mouse") !== -1 ? new MouseEvent(evt.type, evt) : new TouchEvent(evt.type, evt);
                        if (evt.defaultPrevented === true) prevent(clone);
                        if (evt.cancelBubble === true) stop(clone);
                        Object.assign(clone, {
                            qKeyEvent: evt.qKeyEvent,
                            qClickOutside: evt.qClickOutside,
                            qAnchorHandled: evt.qAnchorHandled,
                            qClonedBy: evt.qClonedBy === void 0 ? [
                                ctx.uid
                            ] : evt.qClonedBy.concat(ctx.uid)
                        });
                        ctx.initialEvent = {
                            target: evt.target,
                            event: clone
                        };
                    }
                    stop(evt);
                }
                const { left, top } = position(evt);
                ctx.event = {
                    x: left,
                    y: top,
                    time: Date.now(),
                    mouse: mouseEvent === true,
                    detected: false,
                    isFirst: true,
                    isFinal: false,
                    lastX: left,
                    lastY: top
                };
            },
            move (evt) {
                if (ctx.event === void 0) return;
                const pos = position(evt), distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y;
                if (distX === 0 && distY === 0) return;
                ctx.lastEvt = evt;
                const isMouseEvt = ctx.event.mouse === true;
                const start = ()=>{
                    handleEvent(evt, isMouseEvt);
                    let cursor;
                    if (modifiers.preserveCursor !== true && modifiers.preservecursor !== true) {
                        cursor = document.documentElement.style.cursor || "";
                        document.documentElement.style.cursor = "grabbing";
                    }
                    if (isMouseEvt === true) document.body.classList.add("no-pointer-events--children");
                    document.body.classList.add("non-selectable");
                    clearSelection();
                    ctx.styleCleanup = (withDelayedFn)=>{
                        ctx.styleCleanup = void 0;
                        if (cursor !== void 0) document.documentElement.style.cursor = cursor;
                        document.body.classList.remove("non-selectable");
                        if (isMouseEvt === true) {
                            const remove = ()=>{
                                document.body.classList.remove("no-pointer-events--children");
                            };
                            if (withDelayedFn !== void 0) setTimeout(()=>{
                                remove();
                                withDelayedFn();
                            }, 50);
                            else remove();
                        } else if (withDelayedFn !== void 0) withDelayedFn();
                    };
                };
                if (ctx.event.detected === true) {
                    if (ctx.event.isFirst !== true) handleEvent(evt, ctx.event.mouse);
                    const { payload, synthetic } = getChanges(evt, ctx, false);
                    if (payload !== void 0) {
                        if (ctx.handler(payload) === false) ctx.end(evt);
                        else {
                            if (ctx.styleCleanup === void 0 && ctx.event.isFirst === true) start();
                            ctx.event.lastX = payload.position.left;
                            ctx.event.lastY = payload.position.top;
                            ctx.event.lastDir = synthetic === true ? void 0 : payload.direction;
                            ctx.event.isFirst = false;
                        }
                    }
                    return;
                }
                if (ctx.direction.all === true || isMouseEvt === true && (ctx.modifiers.mouseAllDir === true || ctx.modifiers.mousealldir === true)) {
                    start();
                    ctx.event.detected = true;
                    ctx.move(evt);
                    return;
                }
                const absX = Math.abs(distX), absY = Math.abs(distY);
                if (absX !== absY) {
                    if (ctx.direction.horizontal === true && absX > absY || ctx.direction.vertical === true && absX < absY || ctx.direction.up === true && absX < absY && distY < 0 || ctx.direction.down === true && absX < absY && distY > 0 || ctx.direction.left === true && absX > absY && distX < 0 || ctx.direction.right === true && absX > absY && distX > 0) {
                        ctx.event.detected = true;
                        ctx.move(evt);
                    } else ctx.end(evt, true);
                }
            },
            end (evt, abort) {
                if (ctx.event === void 0) return;
                cleanEvt(ctx, "temp");
                if (client.is.firefox === true) preventDraggable(el, false);
                if (abort === true) {
                    ctx.styleCleanup?.();
                    if (ctx.event.detected !== true && ctx.initialEvent !== void 0) ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
                } else if (ctx.event.detected === true) {
                    if (ctx.event.isFirst === true) ctx.handler(getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);
                    const { payload } = getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
                    const fn = ()=>{
                        ctx.handler(payload);
                    };
                    if (ctx.styleCleanup !== void 0) ctx.styleCleanup(fn);
                    else fn();
                }
                ctx.event = void 0;
                ctx.initialEvent = void 0;
                ctx.lastEvt = void 0;
            }
        };
        el.__qtouchpan = ctx;
        if (modifiers.mouse === true) addEvt(ctx, "main", [
            [
                el,
                "mousedown",
                "mouseStart",
                `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : ""}`
            ]
        ]);
        if (client.has.touch === true) addEvt(ctx, "main", [
            [
                el,
                "touchstart",
                "touchStart",
                `passive${modifiers.capture === true ? "Capture" : ""}`
            ],
            [
                el,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (el, bindings) {
        const ctx = el.__qtouchpan;
        if (ctx !== void 0) {
            if (bindings.oldValue !== bindings.value) {
                if (typeof value !== "function") ctx.end();
                ctx.handler = bindings.value;
            }
            ctx.direction = getModifierDirections(bindings.modifiers);
        }
    },
    beforeUnmount (el) {
        const ctx = el.__qtouchpan;
        if (ctx !== void 0) {
            if (ctx.event !== void 0) ctx.end();
            cleanEvt(ctx, "main");
            cleanEvt(ctx, "temp");
            if (client.is.firefox === true) preventDraggable(el, false);
            ctx.styleCleanup?.();
            delete el.__qtouchpan;
        }
    }
});
//#endregion
//#region src/components/slider/use-slider.js
const markerPrefixClass = "q-slider__marker-labels";
const defaultMarkerConvertFn = (v)=>({
        value: v
    });
const defaultMarkerLabelRenderFn = ({ marker })=>(0, _vue.h)("div", {
        key: marker.value,
        style: marker.style,
        class: marker.classes
    }, marker.label);
const keyCodes$2 = [
    34,
    37,
    40,
    33,
    39,
    38
];
const useSliderProps = {
    ...useDarkProps,
    ...useFormProps,
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    innerMin: Number,
    innerMax: Number,
    step: {
        type: Number,
        default: 1,
        validator: (v)=>v >= 0
    },
    snap: Boolean,
    vertical: Boolean,
    reverse: Boolean,
    color: String,
    markerLabelsClass: String,
    label: Boolean,
    labelColor: String,
    labelTextColor: String,
    labelAlways: Boolean,
    switchLabelSide: Boolean,
    markers: [
        Boolean,
        Number
    ],
    markerLabels: [
        Boolean,
        Array,
        Object,
        Function
    ],
    switchMarkerLabelsSide: Boolean,
    trackImg: String,
    trackColor: String,
    innerTrackImg: String,
    innerTrackColor: String,
    selectionColor: String,
    selectionImg: String,
    thumbSize: {
        type: String,
        default: "20px"
    },
    trackSize: {
        type: String,
        default: "4px"
    },
    disable: Boolean,
    readonly: Boolean,
    dense: Boolean,
    tabindex: [
        String,
        Number
    ],
    thumbColor: String,
    thumbPath: {
        type: String,
        default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
    }
};
const useSliderEmits = [
    "pan",
    "update:modelValue",
    "change"
];
function useSlider({ updateValue, updatePosition, getDragging, formAttrs }) {
    const { props, emit, slots, proxy: { $q } } = (0, _vue.getCurrentInstance)();
    const isDark = useDark(props, $q);
    const injectFormInput = useFormInject(formAttrs);
    const active = (0, _vue.ref)(false);
    const preventFocus = (0, _vue.ref)(false);
    const focus = (0, _vue.ref)(false);
    const dragging = (0, _vue.ref)(false);
    const axis = (0, _vue.computed)(()=>props.vertical === true ? "--v" : "--h");
    const labelSide = (0, _vue.computed)(()=>"-" + (props.switchLabelSide === true ? "switched" : "standard"));
    const isReversed = (0, _vue.computed)(()=>props.vertical === true ? props.reverse === true : props.reverse !== ($q.lang.rtl === true));
    const innerMin = (0, _vue.computed)(()=>isNaN(props.innerMin) === true || props.innerMin < props.min ? props.min : props.innerMin);
    const innerMax = (0, _vue.computed)(()=>isNaN(props.innerMax) === true || props.innerMax > props.max ? props.max : props.innerMax);
    const editable = (0, _vue.computed)(()=>props.disable !== true && props.readonly !== true && innerMin.value < innerMax.value);
    const roundValueFn = (0, _vue.computed)(()=>{
        if (props.step === 0) return (v)=>v;
        const decimals = (String(props.step).trim().split(".")[1] || "").length;
        return (v)=>parseFloat(v.toFixed(decimals));
    });
    const keyStep = (0, _vue.computed)(()=>props.step === 0 ? 1 : props.step);
    const tabindex = (0, _vue.computed)(()=>editable.value === true ? props.tabindex || 0 : -1);
    const trackLen = (0, _vue.computed)(()=>props.max - props.min);
    const innerBarLen = (0, _vue.computed)(()=>innerMax.value - innerMin.value);
    const innerMinRatio = (0, _vue.computed)(()=>convertModelToRatio(innerMin.value));
    const innerMaxRatio = (0, _vue.computed)(()=>convertModelToRatio(innerMax.value));
    const positionProp = (0, _vue.computed)(()=>props.vertical === true ? isReversed.value === true ? "bottom" : "top" : isReversed.value === true ? "right" : "left");
    const sizeProp = (0, _vue.computed)(()=>props.vertical === true ? "height" : "width");
    const thicknessProp = (0, _vue.computed)(()=>props.vertical === true ? "width" : "height");
    const orientation = (0, _vue.computed)(()=>props.vertical === true ? "vertical" : "horizontal");
    const attributes = (0, _vue.computed)(()=>{
        const acc = {
            role: "slider",
            "aria-valuemin": innerMin.value,
            "aria-valuemax": innerMax.value,
            "aria-orientation": orientation.value,
            "data-step": props.step
        };
        if (props.disable === true) acc["aria-disabled"] = "true";
        else if (props.readonly === true) acc["aria-readonly"] = "true";
        return acc;
    });
    const classes = (0, _vue.computed)(()=>`q-slider q-slider${axis.value} q-slider--${active.value === true ? "" : "in"}active inline no-wrap ` + (props.vertical === true ? "row" : "column") + (props.disable === true ? " disabled" : " q-slider--enabled" + (editable.value === true ? " q-slider--editable" : "")) + (focus.value === "both" ? " q-slider--focus" : "") + (props.label || props.labelAlways === true ? " q-slider--label" : "") + (props.labelAlways === true ? " q-slider--label-always" : "") + (isDark.value === true ? " q-slider--dark" : "") + (props.dense === true ? " q-slider--dense q-slider--dense" + axis.value : ""));
    function getPositionClass(name) {
        const cls = "q-slider__" + name;
        return `${cls} ${cls}${axis.value} ${cls}${axis.value}${labelSide.value}`;
    }
    function getAxisClass(name) {
        const cls = "q-slider__" + name;
        return `${cls} ${cls}${axis.value}`;
    }
    const selectionBarClass = (0, _vue.computed)(()=>{
        const color = props.selectionColor || props.color;
        return "q-slider__selection absolute" + (color !== void 0 ? ` text-${color}` : "");
    });
    const markerClass = (0, _vue.computed)(()=>getAxisClass("markers") + " absolute overflow-hidden");
    const trackContainerClass = (0, _vue.computed)(()=>getAxisClass("track-container"));
    const pinClass = (0, _vue.computed)(()=>getPositionClass("pin"));
    const labelClass = (0, _vue.computed)(()=>getPositionClass("label"));
    const textContainerClass = (0, _vue.computed)(()=>getPositionClass("text-container"));
    const markerLabelsContainerClass = (0, _vue.computed)(()=>getPositionClass("marker-labels-container") + (props.markerLabelsClass !== void 0 ? ` ${props.markerLabelsClass}` : ""));
    const trackClass = (0, _vue.computed)(()=>"q-slider__track relative-position no-outline" + (props.trackColor !== void 0 ? ` bg-${props.trackColor}` : ""));
    const trackStyle = (0, _vue.computed)(()=>{
        const acc = {
            [thicknessProp.value]: props.trackSize
        };
        if (props.trackImg !== void 0) acc.backgroundImage = `url(${props.trackImg}) !important`;
        return acc;
    });
    const innerBarClass = (0, _vue.computed)(()=>"q-slider__inner absolute" + (props.innerTrackColor !== void 0 ? ` bg-${props.innerTrackColor}` : ""));
    const innerBarStyle = (0, _vue.computed)(()=>{
        const innerDiff = innerMaxRatio.value - innerMinRatio.value;
        const acc = {
            [positionProp.value]: `${100 * innerMinRatio.value}%`,
            [sizeProp.value]: innerDiff === 0 ? "2px" : `${100 * innerDiff}%`
        };
        if (props.innerTrackImg !== void 0) acc.backgroundImage = `url(${props.innerTrackImg}) !important`;
        return acc;
    });
    function convertRatioToModel(ratio) {
        const { min, max, step } = props;
        let model = min + ratio * (max - min);
        if (step > 0) {
            const modulo = (model - innerMin.value) % step;
            model += (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0) - modulo;
        }
        model = roundValueFn.value(model);
        return between(model, innerMin.value, innerMax.value);
    }
    function convertModelToRatio(model) {
        return trackLen.value === 0 ? 0 : (model - props.min) / trackLen.value;
    }
    function getDraggingRatio(evt, draggingInfo) {
        const pos = position(evt), val = props.vertical === true ? between((pos.top - draggingInfo.top) / draggingInfo.height, 0, 1) : between((pos.left - draggingInfo.left) / draggingInfo.width, 0, 1);
        return between(isReversed.value === true ? 1 - val : val, innerMinRatio.value, innerMaxRatio.value);
    }
    const markerStep = (0, _vue.computed)(()=>isNumber(props.markers) === true ? props.markers : keyStep.value);
    const markerTicks = (0, _vue.computed)(()=>{
        const acc = [];
        const step = markerStep.value;
        const max = props.max;
        let value1 = props.min;
        do {
            acc.push(value1);
            value1 += step;
        }while (value1 < max);
        acc.push(max);
        return acc;
    });
    const markerLabelClass = (0, _vue.computed)(()=>{
        const prefix = ` ${markerPrefixClass}${axis.value}-`;
        return `q-slider__marker-labels${prefix}${props.switchMarkerLabelsSide === true ? "switched" : "standard"}${prefix}${isReversed.value === true ? "rtl" : "ltr"}`;
    });
    const markerLabelsList = (0, _vue.computed)(()=>{
        if (props.markerLabels === false) return null;
        return getMarkerList(props.markerLabels).map((entry, index)=>({
                index,
                value: entry.value,
                label: entry.label || entry.value,
                classes: markerLabelClass.value + (entry.classes !== void 0 ? " " + entry.classes : ""),
                style: {
                    ...getMarkerLabelStyle(entry.value),
                    ...entry.style || {}
                }
            }));
    });
    const markerScope = (0, _vue.computed)(()=>({
            markerList: markerLabelsList.value,
            markerMap: markerLabelsMap.value,
            classes: markerLabelClass.value,
            getStyle: getMarkerLabelStyle
        }));
    const markerStyle = (0, _vue.computed)(()=>{
        const size = innerBarLen.value === 0 ? "2px" : 100 * markerStep.value / innerBarLen.value;
        return {
            ...innerBarStyle.value,
            backgroundSize: props.vertical === true ? `2px ${size}%` : `${size}% 2px`
        };
    });
    function getMarkerList(def) {
        if (def === false) return null;
        if (def === true) return markerTicks.value.map(defaultMarkerConvertFn);
        if (typeof def === "function") return markerTicks.value.map((value1)=>{
            const item = def(value1);
            return isObject(item) === true ? {
                ...item,
                value: value1
            } : {
                value: value1,
                label: item
            };
        });
        const filterFn = ({ value: value1 })=>value1 >= props.min && value1 <= props.max;
        if (Array.isArray(def) === true) return def.map((item)=>isObject(item) === true ? item : {
                value: item
            }).filter(filterFn);
        return Object.keys(def).map((key)=>{
            const item = def[key];
            const value1 = Number(key);
            return isObject(item) === true ? {
                ...item,
                value: value1
            } : {
                value: value1,
                label: item
            };
        }).filter(filterFn);
    }
    function getMarkerLabelStyle(val) {
        return {
            [positionProp.value]: `${100 * (val - props.min) / trackLen.value}%`
        };
    }
    const markerLabelsMap = (0, _vue.computed)(()=>{
        if (props.markerLabels === false) return null;
        const acc = {};
        markerLabelsList.value.forEach((entry)=>{
            acc[entry.value] = entry;
        });
        return acc;
    });
    function getMarkerLabelsContent() {
        if (slots["marker-label-group"] !== void 0) return slots["marker-label-group"](markerScope.value);
        const fn = slots["marker-label"] || defaultMarkerLabelRenderFn;
        return markerLabelsList.value.map((marker)=>fn({
                marker,
                ...markerScope.value
            }));
    }
    const panDirective = (0, _vue.computed)(()=>[
            [
                TouchPan_default,
                onPan,
                void 0,
                {
                    [orientation.value]: true,
                    prevent: true,
                    stop: true,
                    mouse: true,
                    mouseAllDir: true
                }
            ]
        ]);
    function onPan(event) {
        if (event.isFinal === true) {
            if (dragging.value !== void 0) {
                updatePosition(event.evt);
                if (event.touch === true) updateValue(true);
                dragging.value = void 0;
                emit("pan", "end");
            }
            active.value = false;
            focus.value = false;
        } else if (event.isFirst === true) {
            dragging.value = getDragging(event.evt);
            updatePosition(event.evt);
            updateValue();
            active.value = true;
            emit("pan", "start");
        } else {
            updatePosition(event.evt);
            updateValue();
        }
    }
    function onBlur() {
        focus.value = false;
    }
    function onActivate(evt) {
        updatePosition(evt, getDragging(evt));
        updateValue();
        preventFocus.value = true;
        active.value = true;
        document.addEventListener("mouseup", onDeactivate, true);
    }
    function onDeactivate() {
        preventFocus.value = false;
        active.value = false;
        updateValue(true);
        onBlur();
        document.removeEventListener("mouseup", onDeactivate, true);
    }
    function onMobileClick(evt) {
        updatePosition(evt, getDragging(evt));
        updateValue(true);
    }
    function onKeyup(evt) {
        if (keyCodes$2.includes(evt.keyCode)) updateValue(true);
    }
    function getTextContainerStyle(ratio) {
        if (props.vertical === true) return null;
        const p = $q.lang.rtl !== props.reverse ? 1 - ratio : ratio;
        return {
            transform: `translateX(calc(${2 * p - 1} * ${props.thumbSize} / 2 + ${50 - 100 * p}%))`
        };
    }
    function getThumbRenderFn(thumb) {
        const focusClass = (0, _vue.computed)(()=>preventFocus.value === false && (focus.value === thumb.focusValue || focus.value === "both") ? " q-slider--focus" : "");
        const thumbClasses = (0, _vue.computed)(()=>`q-slider__thumb q-slider__thumb${axis.value} q-slider__thumb${axis.value}-${isReversed.value === true ? "rtl" : "ltr"} absolute non-selectable` + focusClass.value + (thumb.thumbColor.value !== void 0 ? ` text-${thumb.thumbColor.value}` : ""));
        const style = (0, _vue.computed)(()=>({
                width: props.thumbSize,
                height: props.thumbSize,
                [positionProp.value]: `${100 * thumb.ratio.value}%`,
                zIndex: focus.value === thumb.focusValue ? 2 : void 0
            }));
        const pinColor = (0, _vue.computed)(()=>thumb.labelColor.value !== void 0 ? ` text-${thumb.labelColor.value}` : "");
        const textContainerStyle = (0, _vue.computed)(()=>getTextContainerStyle(thumb.ratio.value));
        const textClass = (0, _vue.computed)(()=>"q-slider__text" + (thumb.labelTextColor.value !== void 0 ? ` text-${thumb.labelTextColor.value}` : ""));
        return ()=>{
            const thumbContent = [
                (0, _vue.h)("svg", {
                    class: "q-slider__thumb-shape absolute-full",
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                }, [
                    (0, _vue.h)("path", {
                        d: props.thumbPath
                    })
                ]),
                (0, _vue.h)("div", {
                    class: "q-slider__focus-ring fit"
                })
            ];
            if (props.label === true || props.labelAlways === true) {
                thumbContent.push((0, _vue.h)("div", {
                    class: pinClass.value + " absolute fit no-pointer-events" + pinColor.value
                }, [
                    (0, _vue.h)("div", {
                        class: labelClass.value,
                        style: {
                            minWidth: props.thumbSize
                        }
                    }, [
                        (0, _vue.h)("div", {
                            class: textContainerClass.value,
                            style: textContainerStyle.value
                        }, [
                            (0, _vue.h)("span", {
                                class: textClass.value
                            }, thumb.label.value)
                        ])
                    ])
                ]));
                if (props.name !== void 0 && props.disable !== true) injectFormInput(thumbContent, "push");
            }
            return (0, _vue.h)("div", {
                class: thumbClasses.value,
                style: style.value,
                ...thumb.getNodeData()
            }, thumbContent);
        };
    }
    function getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, injectThumb) {
        const trackContent = [];
        if (props.innerTrackColor !== "transparent") trackContent.push((0, _vue.h)("div", {
            key: "inner",
            class: innerBarClass.value,
            style: innerBarStyle.value
        }));
        if (props.selectionColor !== "transparent") trackContent.push((0, _vue.h)("div", {
            key: "selection",
            class: selectionBarClass.value,
            style: selectionBarStyle.value
        }));
        if (props.markers !== false) trackContent.push((0, _vue.h)("div", {
            key: "marker",
            class: markerClass.value,
            style: markerStyle.value
        }));
        injectThumb(trackContent);
        const content = [
            hDir("div", {
                key: "trackC",
                class: trackContainerClass.value,
                tabindex: trackContainerTabindex.value,
                ...trackContainerEvents.value
            }, [
                (0, _vue.h)("div", {
                    class: trackClass.value,
                    style: trackStyle.value
                }, trackContent)
            ], "slide", editable.value, ()=>panDirective.value)
        ];
        if (props.markerLabels !== false) content[props.switchMarkerLabelsSide === true ? "unshift" : "push"]((0, _vue.h)("div", {
            key: "markerL",
            class: markerLabelsContainerClass.value
        }, getMarkerLabelsContent()));
        return content;
    }
    (0, _vue.onBeforeUnmount)(()=>{
        document.removeEventListener("mouseup", onDeactivate, true);
    });
    return {
        state: {
            active,
            focus,
            preventFocus,
            dragging,
            editable,
            classes,
            tabindex,
            attributes,
            roundValueFn,
            keyStep,
            trackLen,
            innerMin,
            innerMinRatio,
            innerMax,
            innerMaxRatio,
            positionProp,
            sizeProp,
            isReversed
        },
        methods: {
            onActivate,
            onMobileClick,
            onBlur,
            onKeyup,
            getContent,
            getThumbRenderFn,
            convertRatioToModel,
            convertModelToRatio,
            getDraggingRatio
        }
    };
}
//#endregion
//#region src/components/slider/QSlider.js
const getNodeData = ()=>({});
var QSlider_default = createComponent({
    name: "QSlider",
    props: {
        ...useSliderProps,
        modelValue: {
            required: true,
            default: null,
            validator: (v)=>typeof v === "number" || v === null
        },
        labelValue: [
            String,
            Number
        ]
    },
    emits: useSliderEmits,
    setup (props, { emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const { state, methods } = useSlider({
            updateValue,
            updatePosition,
            getDragging,
            formAttrs: useFormAttrs(props)
        });
        const rootRef = (0, _vue.ref)(null);
        const curRatio = (0, _vue.ref)(0);
        const model = (0, _vue.ref)(0);
        function normalizeModel() {
            model.value = props.modelValue === null ? state.innerMin.value : between(props.modelValue, state.innerMin.value, state.innerMax.value);
        }
        (0, _vue.watch)(()=>`${props.modelValue}|${state.innerMin.value}|${state.innerMax.value}`, normalizeModel);
        normalizeModel();
        const modelRatio = (0, _vue.computed)(()=>methods.convertModelToRatio(model.value));
        const ratio = (0, _vue.computed)(()=>state.active.value === true ? curRatio.value : modelRatio.value);
        const selectionBarStyle = (0, _vue.computed)(()=>{
            const acc = {
                [state.positionProp.value]: `${100 * state.innerMinRatio.value}%`,
                [state.sizeProp.value]: `${100 * (ratio.value - state.innerMinRatio.value)}%`
            };
            if (props.selectionImg !== void 0) acc.backgroundImage = `url(${props.selectionImg}) !important`;
            return acc;
        });
        const getThumb = methods.getThumbRenderFn({
            focusValue: true,
            getNodeData,
            ratio,
            label: (0, _vue.computed)(()=>props.labelValue !== void 0 ? props.labelValue : model.value),
            thumbColor: (0, _vue.computed)(()=>props.thumbColor || props.color),
            labelColor: (0, _vue.computed)(()=>props.labelColor),
            labelTextColor: (0, _vue.computed)(()=>props.labelTextColor)
        });
        const trackContainerEvents = (0, _vue.computed)(()=>{
            if (state.editable.value !== true) return {};
            return $q.platform.is.mobile === true ? {
                onClick: methods.onMobileClick
            } : {
                onMousedown: methods.onActivate,
                onFocus,
                onBlur: methods.onBlur,
                onKeydown,
                onKeyup: methods.onKeyup
            };
        });
        function updateValue(change) {
            if (model.value !== props.modelValue) emit("update:modelValue", model.value);
            if (change === true) emit("change", model.value);
        }
        function getDragging() {
            return rootRef.value.getBoundingClientRect();
        }
        function updatePosition(event, dragging = state.dragging.value) {
            const localRatio = methods.getDraggingRatio(event, dragging);
            model.value = methods.convertRatioToModel(localRatio);
            curRatio.value = props.snap !== true || props.step === 0 ? localRatio : methods.convertModelToRatio(model.value);
        }
        function onFocus() {
            state.focus.value = true;
        }
        function onKeydown(evt) {
            if (keyCodes$2.includes(evt.keyCode) === false) return;
            stopAndPrevent(evt);
            const stepVal = ([
                34,
                33
            ].includes(evt.keyCode) ? 10 : 1) * state.keyStep.value, offset = ([
                34,
                37,
                40
            ].includes(evt.keyCode) ? -1 : 1) * (state.isReversed.value === true ? -1 : 1) * (props.vertical === true ? -1 : 1) * stepVal;
            model.value = between(state.roundValueFn.value(model.value + offset), state.innerMin.value, state.innerMax.value);
            updateValue();
        }
        return ()=>{
            const content = methods.getContent(selectionBarStyle, state.tabindex, trackContainerEvents, (node)=>{
                node.push(getThumb());
            });
            return (0, _vue.h)("div", {
                ref: rootRef,
                class: state.classes.value + (props.modelValue === null ? " q-slider--no-value" : ""),
                ...state.attributes.value,
                "aria-valuenow": props.modelValue
            }, content);
        };
    }
});
//#endregion
//#region src/composables/use-hydration/use-hydration.js
function useHydration() {
    const isHydrated = (0, _vue.ref)(!isRuntimeSsrPreHydration.value);
    if (isHydrated.value === false) (0, _vue.onMounted)(()=>{
        isHydrated.value = true;
    });
    return {
        isHydrated
    };
}
//#endregion
//#region src/components/resize-observer/QResizeObserver.js
const hasObserver = typeof ResizeObserver !== "undefined";
const resizeProps = hasObserver === true ? {} : {
    style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
    url: "about:blank"
};
var QResizeObserver_default = createComponent({
    name: "QResizeObserver",
    props: {
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        }
    },
    emits: [
        "resize"
    ],
    setup (props, { emit }) {
        let timer = null, targetEl, size = {
            width: -1,
            height: -1
        };
        function trigger(immediately) {
            if (immediately === true || props.debounce === 0 || props.debounce === "0") emitEvent();
            else if (timer === null) timer = setTimeout(emitEvent, props.debounce);
        }
        function emitEvent() {
            if (timer !== null) {
                clearTimeout(timer);
                timer = null;
            }
            if (targetEl) {
                const { offsetWidth: width, offsetHeight: height } = targetEl;
                if (width !== size.width || height !== size.height) {
                    size = {
                        width,
                        height
                    };
                    emit("resize", size);
                }
            }
        }
        const { proxy } = (0, _vue.getCurrentInstance)();
        proxy.trigger = trigger;
        if (hasObserver === true) {
            let observer;
            const init = (stop)=>{
                targetEl = proxy.$el.parentNode;
                if (targetEl) {
                    observer = new ResizeObserver(trigger);
                    observer.observe(targetEl);
                    emitEvent();
                } else if (stop !== true) (0, _vue.nextTick)(()=>{
                    init(true);
                });
            };
            (0, _vue.onMounted)(()=>{
                init();
            });
            (0, _vue.onBeforeUnmount)(()=>{
                if (timer !== null) clearTimeout(timer);
                if (observer !== void 0) {
                    if (observer.disconnect !== void 0) observer.disconnect();
                    else if (targetEl) observer.unobserve(targetEl);
                }
            });
            return noop;
        } else {
            const { isHydrated } = useHydration();
            let curDocView;
            function cleanup() {
                if (timer !== null) {
                    clearTimeout(timer);
                    timer = null;
                }
                if (curDocView !== void 0) {
                    if (curDocView.removeEventListener !== void 0) curDocView.removeEventListener("resize", trigger, listenOpts.passive);
                    curDocView = void 0;
                }
            }
            function onObjLoad() {
                cleanup();
                if (targetEl?.contentDocument) {
                    curDocView = targetEl.contentDocument.defaultView;
                    curDocView.addEventListener("resize", trigger, listenOpts.passive);
                    emitEvent();
                }
            }
            (0, _vue.onMounted)(()=>{
                (0, _vue.nextTick)(()=>{
                    targetEl = proxy.$el;
                    if (targetEl) onObjLoad();
                });
            });
            (0, _vue.onBeforeUnmount)(cleanup);
            return ()=>{
                if (isHydrated.value === true) return (0, _vue.h)("object", {
                    class: "q--avoid-card-border",
                    style: resizeProps.style,
                    tabindex: -1,
                    type: "text/html",
                    data: resizeProps.url,
                    "aria-hidden": "true",
                    onLoad: onObjLoad
                });
            };
        }
    }
});
//#endregion
//#region src/utils/private.rtl/rtl.js
let rtlHasScrollBug = false;
if (!__QUASAR_SSR__) {
    const scroller = document.createElement("div");
    scroller.setAttribute("dir", "rtl");
    Object.assign(scroller.style, {
        width: "1px",
        height: "1px",
        overflow: "auto"
    });
    const spacer = document.createElement("div");
    Object.assign(spacer.style, {
        width: "1000px",
        height: "1px"
    });
    document.body.appendChild(scroller);
    scroller.appendChild(spacer);
    scroller.scrollLeft = -1000;
    rtlHasScrollBug = scroller.scrollLeft >= 0;
    scroller.remove();
}
//#endregion
//#region src/components/tabs/QTabs.js
function getIndicatorClass(color, top, vertical) {
    const pos = vertical === true ? [
        "left",
        "right"
    ] : [
        "top",
        "bottom"
    ];
    return `absolute-${top === true ? pos[0] : pos[1]}${color ? ` text-${color}` : ""}`;
}
const alignValues$1 = [
    "left",
    "center",
    "right",
    "justify"
];
var QTabs_default = createComponent({
    name: "QTabs",
    props: {
        modelValue: [
            Number,
            String
        ],
        align: {
            type: String,
            default: "center",
            validator: (v)=>alignValues$1.includes(v)
        },
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        vertical: Boolean,
        shrink: Boolean,
        stretch: Boolean,
        activeClass: String,
        activeColor: String,
        activeBgColor: String,
        indicatorColor: String,
        leftIcon: String,
        rightIcon: String,
        outsideArrows: Boolean,
        mobileArrows: Boolean,
        switchIndicator: Boolean,
        narrowIndicator: Boolean,
        inlineLabel: Boolean,
        noCaps: Boolean,
        dense: Boolean,
        contentClass: String,
        "onUpdate:modelValue": [
            Function,
            Array
        ]
    },
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const { registerTick: registerScrollTick } = useTick();
        const { registerTick: registerUpdateArrowsTick } = useTick();
        const { registerTick: registerAnimateTick } = useTick();
        const { registerTimeout: registerFocusTimeout, removeTimeout: removeFocusTimeout } = useTimeout();
        const { registerTimeout: registerScrollToTabTimeout, removeTimeout: removeScrollToTabTimeout } = useTimeout();
        const rootRef = (0, _vue.ref)(null);
        const contentRef = (0, _vue.ref)(null);
        const currentModel = (0, _vue.ref)(props.modelValue);
        const scrollable = (0, _vue.ref)(false);
        const leftArrow = (0, _vue.ref)(true);
        const rightArrow = (0, _vue.ref)(false);
        const justify = (0, _vue.ref)(false);
        const tabDataList = [];
        const tabDataListLen = (0, _vue.ref)(0);
        const hasFocus = (0, _vue.ref)(false);
        let animateTimer = null, scrollTimer = null, unwatchRoute;
        const tabProps = (0, _vue.computed)(()=>({
                activeClass: props.activeClass,
                activeColor: props.activeColor,
                activeBgColor: props.activeBgColor,
                indicatorClass: getIndicatorClass(props.indicatorColor, props.switchIndicator, props.vertical),
                narrowIndicator: props.narrowIndicator,
                inlineLabel: props.inlineLabel,
                noCaps: props.noCaps
            }));
        const hasActiveTab = (0, _vue.computed)(()=>{
            const len = tabDataListLen.value;
            const val = currentModel.value;
            for(let i = 0; i < len; i++)if (tabDataList[i].name.value === val) return true;
            return false;
        });
        const alignClass = (0, _vue.computed)(()=>{
            return `q-tabs__content--align-${scrollable.value === true ? "left" : justify.value === true ? "justify" : props.align}`;
        });
        const classes = (0, _vue.computed)(()=>`q-tabs row no-wrap items-center q-tabs--${scrollable.value === true ? "" : "not-"}scrollable q-tabs--${props.vertical === true ? "vertical" : "horizontal"} q-tabs__arrows--${props.outsideArrows === true ? "outside" : "inside"} q-tabs--mobile-with${props.mobileArrows === true ? "" : "out"}-arrows` + (props.dense === true ? " q-tabs--dense" : "") + (props.shrink === true ? " col-shrink" : "") + (props.stretch === true ? " self-stretch" : ""));
        const innerClass = (0, _vue.computed)(()=>"q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + alignClass.value + (props.contentClass !== void 0 ? ` ${props.contentClass}` : ""));
        const domProps = (0, _vue.computed)(()=>props.vertical === true ? {
                container: "height",
                content: "offsetHeight",
                scroll: "scrollHeight"
            } : {
                container: "width",
                content: "offsetWidth",
                scroll: "scrollWidth"
            });
        const isRTL = (0, _vue.computed)(()=>props.vertical !== true && $q.lang.rtl === true);
        const rtlPosCorrection = (0, _vue.computed)(()=>rtlHasScrollBug === false && isRTL.value === true);
        (0, _vue.watch)(isRTL, updateArrows);
        (0, _vue.watch)(()=>props.modelValue, (name)=>{
            updateModel({
                name,
                setCurrent: true,
                skipEmit: true
            });
        });
        (0, _vue.watch)(()=>props.outsideArrows, recalculateScroll);
        function updateModel({ name, setCurrent, skipEmit }) {
            if (currentModel.value === name) return;
            if (skipEmit !== true && props["onUpdate:modelValue"] !== void 0) emit("update:modelValue", name);
            if (setCurrent === true || props["onUpdate:modelValue"] === void 0) {
                animate(currentModel.value, name);
                currentModel.value = name;
            }
        }
        function recalculateScroll() {
            registerScrollTick(()=>{
                if (rootRef.value) updateContainer({
                    width: rootRef.value.offsetWidth,
                    height: rootRef.value.offsetHeight
                });
            });
        }
        function updateContainer(domSize) {
            if (domProps.value === void 0 || contentRef.value === null) return;
            const size = domSize[domProps.value.container], scrollSize = Math.min(contentRef.value[domProps.value.scroll], Array.prototype.reduce.call(contentRef.value.children, (acc, el)=>acc + (el[domProps.value.content] || 0), 0)), scroll = size > 0 && scrollSize > size;
            scrollable.value = scroll;
            if (scroll === true) registerUpdateArrowsTick(updateArrows);
            justify.value = size < parseInt(props.breakpoint, 10);
        }
        function animate(oldName, newName) {
            const oldTab = oldName !== void 0 && oldName !== null && oldName !== "" ? tabDataList.find((tab)=>tab.name.value === oldName) : null, newTab = newName !== void 0 && newName !== null && newName !== "" ? tabDataList.find((tab)=>tab.name.value === newName) : null;
            if (hadActivated === true) hadActivated = false;
            else if (oldTab && newTab) {
                const oldEl = oldTab.tabIndicatorRef.value, newEl = newTab.tabIndicatorRef.value;
                if (animateTimer !== null) {
                    clearTimeout(animateTimer);
                    animateTimer = null;
                }
                oldEl.style.transition = "none";
                oldEl.style.transform = "none";
                newEl.style.transition = "none";
                newEl.style.transform = "none";
                const oldPos = oldEl.getBoundingClientRect(), newPos = newEl.getBoundingClientRect();
                newEl.style.transform = props.vertical === true ? `translate3d(0,${oldPos.top - newPos.top}px,0) scale3d(1,${newPos.height ? oldPos.height / newPos.height : 1},1)` : `translate3d(${oldPos.left - newPos.left}px,0,0) scale3d(${newPos.width ? oldPos.width / newPos.width : 1},1,1)`;
                registerAnimateTick(()=>{
                    animateTimer = setTimeout(()=>{
                        animateTimer = null;
                        newEl.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)";
                        newEl.style.transform = "none";
                    }, 70);
                });
            }
            if (newTab && scrollable.value === true) scrollToTabEl(newTab.rootRef.value);
        }
        function scrollToTabEl(el) {
            const { left, width, top, height } = contentRef.value.getBoundingClientRect(), newPos = el.getBoundingClientRect();
            let offset = props.vertical === true ? newPos.top - top : newPos.left - left;
            if (offset < 0) {
                contentRef.value[props.vertical === true ? "scrollTop" : "scrollLeft"] += Math.floor(offset);
                updateArrows();
                return;
            }
            offset += props.vertical === true ? newPos.height - height : newPos.width - width;
            if (offset > 0) {
                contentRef.value[props.vertical === true ? "scrollTop" : "scrollLeft"] += Math.ceil(offset);
                updateArrows();
            }
        }
        function updateArrows() {
            const content = contentRef.value;
            if (content === null) return;
            const rect = content.getBoundingClientRect(), pos = props.vertical === true ? content.scrollTop : Math.abs(content.scrollLeft);
            if (isRTL.value === true) {
                leftArrow.value = Math.ceil(pos + rect.width) < content.scrollWidth - 1;
                rightArrow.value = pos > 0;
            } else {
                leftArrow.value = pos > 0;
                rightArrow.value = props.vertical === true ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
            }
        }
        function animScrollTo(value1) {
            if (scrollTimer !== null) clearInterval(scrollTimer);
            scrollTimer = setInterval(()=>{
                if (scrollTowards(value1) === true) stopAnimScroll();
            }, 5);
        }
        function scrollToStart() {
            animScrollTo(rtlPosCorrection.value === true ? Number.MAX_SAFE_INTEGER : 0);
        }
        function scrollToEnd() {
            animScrollTo(rtlPosCorrection.value === true ? 0 : Number.MAX_SAFE_INTEGER);
        }
        function stopAnimScroll() {
            if (scrollTimer !== null) {
                clearInterval(scrollTimer);
                scrollTimer = null;
            }
        }
        function onKbdNavigate(keyCode, fromEl) {
            const tabs = Array.prototype.filter.call(contentRef.value.children, (el)=>el === fromEl || el.matches && el.matches(".q-tab.q-focusable") === true);
            const len = tabs.length;
            if (len === 0) return;
            if (keyCode === 36) {
                scrollToTabEl(tabs[0]);
                tabs[0].focus();
                return true;
            }
            if (keyCode === 35) {
                scrollToTabEl(tabs[len - 1]);
                tabs[len - 1].focus();
                return true;
            }
            const dirPrev = keyCode === (props.vertical === true ? 38 : 37);
            const dirNext = keyCode === (props.vertical === true ? 40 : 39);
            const dir = dirPrev === true ? -1 : dirNext === true ? 1 : void 0;
            if (dir !== void 0) {
                const rtlDir = isRTL.value === true ? -1 : 1;
                const index = tabs.indexOf(fromEl) + dir * rtlDir;
                if (index >= 0 && index < len) {
                    scrollToTabEl(tabs[index]);
                    tabs[index].focus({
                        preventScroll: true
                    });
                }
                return true;
            }
        }
        const posFn = (0, _vue.computed)(()=>rtlPosCorrection.value === true ? {
                get: (content)=>Math.abs(content.scrollLeft),
                set: (content, pos)=>{
                    content.scrollLeft = -pos;
                }
            } : props.vertical === true ? {
                get: (content)=>content.scrollTop,
                set: (content, pos)=>{
                    content.scrollTop = pos;
                }
            } : {
                get: (content)=>content.scrollLeft,
                set: (content, pos)=>{
                    content.scrollLeft = pos;
                }
            });
        function scrollTowards(value1) {
            const content = contentRef.value, { get, set } = posFn.value;
            let done = false, pos = get(content);
            const direction = value1 < pos ? -1 : 1;
            pos += direction * 5;
            if (pos < 0) {
                done = true;
                pos = 0;
            } else if (direction === -1 && pos <= value1 || direction === 1 && pos >= value1) {
                done = true;
                pos = value1;
            }
            set(content, pos);
            updateArrows();
            return done;
        }
        function hasQueryIncluded(targetQuery, matchingQuery) {
            for(const key in targetQuery)if (targetQuery[key] !== matchingQuery[key]) return false;
            return true;
        }
        function updateActiveRoute() {
            let name = null, bestScore = {
                matchedLen: 0,
                queryDiff: 9999,
                hrefLen: 0
            };
            const list = tabDataList.filter((tab)=>tab.routeData?.hasRouterLink.value === true);
            const { hash: currentHash, query: currentQuery } = proxy.$route;
            const currentQueryLen = Object.keys(currentQuery).length;
            for (const tab of list){
                const exact = tab.routeData.exact.value === true;
                if (tab.routeData[exact === true ? "linkIsExactActive" : "linkIsActive"].value !== true) continue;
                const { hash, query, matched, href } = tab.routeData.resolvedLink.value;
                const queryLen = Object.keys(query).length;
                if (exact === true) {
                    if (hash !== currentHash) continue;
                    if (queryLen !== currentQueryLen || hasQueryIncluded(currentQuery, query) === false) continue;
                    name = tab.name.value;
                    break;
                }
                if (hash !== "" && hash !== currentHash) continue;
                if (queryLen !== 0 && hasQueryIncluded(query, currentQuery) === false) continue;
                const newScore = {
                    matchedLen: matched.length,
                    queryDiff: currentQueryLen - queryLen,
                    hrefLen: href.length - hash.length
                };
                if (newScore.matchedLen > bestScore.matchedLen) {
                    name = tab.name.value;
                    bestScore = newScore;
                    continue;
                } else if (newScore.matchedLen !== bestScore.matchedLen) continue;
                if (newScore.queryDiff < bestScore.queryDiff) {
                    name = tab.name.value;
                    bestScore = newScore;
                } else if (newScore.queryDiff !== bestScore.queryDiff) continue;
                if (newScore.hrefLen > bestScore.hrefLen) {
                    name = tab.name.value;
                    bestScore = newScore;
                }
            }
            if (name === null && tabDataList.some((tab)=>tab.routeData === void 0 && tab.name.value === currentModel.value) === true) {
                hadActivated = false;
                return;
            }
            updateModel({
                name,
                setCurrent: true
            });
        }
        function onFocusin(e) {
            removeFocusTimeout();
            if (hasFocus.value !== true && rootRef.value !== null && e.target && typeof e.target.closest === "function") {
                const tab = e.target.closest(".q-tab");
                if (tab && rootRef.value.contains(tab) === true) {
                    hasFocus.value = true;
                    if (scrollable.value === true) scrollToTabEl(tab);
                }
            }
        }
        function onFocusout() {
            registerFocusTimeout(()=>{
                hasFocus.value = false;
            }, 30);
        }
        function verifyRouteModel() {
            if ($tabs.avoidRouteWatcher === false) registerScrollToTabTimeout(updateActiveRoute);
            else removeScrollToTabTimeout();
        }
        function watchRoute() {
            if (unwatchRoute === void 0) {
                const unwatch = (0, _vue.watch)(()=>proxy.$route.fullPath, verifyRouteModel);
                unwatchRoute = ()=>{
                    unwatch();
                    unwatchRoute = void 0;
                };
            }
        }
        function registerTab(tabData) {
            tabDataList.push(tabData);
            tabDataListLen.value++;
            recalculateScroll();
            if (tabData.routeData === void 0 || proxy.$route === void 0) registerScrollToTabTimeout(()=>{
                if (scrollable.value === true) {
                    const value1 = currentModel.value;
                    const newTab = value1 !== void 0 && value1 !== null && value1 !== "" ? tabDataList.find((tab)=>tab.name.value === value1) : null;
                    if (newTab) scrollToTabEl(newTab.rootRef.value);
                }
            });
            else {
                watchRoute();
                if (tabData.routeData.hasRouterLink.value === true) verifyRouteModel();
            }
        }
        function unregisterTab(tabData) {
            tabDataList.splice(tabDataList.indexOf(tabData), 1);
            tabDataListLen.value--;
            recalculateScroll();
            if (unwatchRoute !== void 0 && tabData.routeData !== void 0) {
                if (tabDataList.every((tab)=>tab.routeData === void 0) === true) unwatchRoute();
                verifyRouteModel();
            }
        }
        const $tabs = {
            currentModel,
            tabProps,
            hasFocus,
            hasActiveTab,
            registerTab,
            unregisterTab,
            verifyRouteModel,
            updateModel,
            onKbdNavigate,
            avoidRouteWatcher: false
        };
        (0, _vue.provide)(tabsKey, $tabs);
        function cleanup() {
            if (animateTimer !== null) clearTimeout(animateTimer);
            stopAnimScroll();
            unwatchRoute?.();
        }
        let hadRouteWatcher, hadActivated;
        (0, _vue.onBeforeUnmount)(cleanup);
        (0, _vue.onDeactivated)(()=>{
            hadRouteWatcher = unwatchRoute !== void 0;
            cleanup();
        });
        (0, _vue.onActivated)(()=>{
            if (hadRouteWatcher === true) {
                watchRoute();
                hadActivated = true;
                verifyRouteModel();
            }
            recalculateScroll();
        });
        return ()=>(0, _vue.h)("div", {
                ref: rootRef,
                class: classes.value,
                role: "tablist",
                onFocusin,
                onFocusout
            }, [
                (0, _vue.h)(QResizeObserver_default, {
                    onResize: updateContainer
                }),
                (0, _vue.h)("div", {
                    ref: contentRef,
                    class: innerClass.value,
                    onScroll: updateArrows
                }, hSlot(slots.default)),
                (0, _vue.h)(QIcon_default, {
                    class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (leftArrow.value === true ? "" : " q-tabs__arrow--faded"),
                    name: props.leftIcon || $q.iconSet.tabs[props.vertical === true ? "up" : "left"],
                    onMousedownPassive: scrollToStart,
                    onTouchstartPassive: scrollToStart,
                    onMouseupPassive: stopAnimScroll,
                    onMouseleavePassive: stopAnimScroll,
                    onTouchendPassive: stopAnimScroll
                }),
                (0, _vue.h)(QIcon_default, {
                    class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (rightArrow.value === true ? "" : " q-tabs__arrow--faded"),
                    name: props.rightIcon || $q.iconSet.tabs[props.vertical === true ? "down" : "right"],
                    onMousedownPassive: scrollToEnd,
                    onTouchstartPassive: scrollToEnd,
                    onMouseupPassive: stopAnimScroll,
                    onMouseleavePassive: stopAnimScroll,
                    onTouchendPassive: stopAnimScroll
                })
            ]);
    }
});
//#endregion
//#region src/components/tabs/use-tab.js
let id$1 = 0;
const useTabEmits = [
    "click",
    "keydown"
];
const useTabProps = {
    icon: String,
    label: [
        Number,
        String
    ],
    alert: [
        Boolean,
        String
    ],
    alertIcon: String,
    name: {
        type: [
            Number,
            String
        ],
        default: ()=>`t_${id$1++}`
    },
    noCaps: Boolean,
    tabindex: [
        String,
        Number
    ],
    disable: Boolean,
    contentClass: String,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    }
};
function useTab(props, slots, emit, routeData) {
    const $tabs = (0, _vue.inject)(tabsKey, emptyRenderFn);
    if ($tabs === emptyRenderFn) {
        console.error("QTab/QRouteTab component needs to be child of QTabs");
        return emptyRenderFn;
    }
    const { proxy } = (0, _vue.getCurrentInstance)();
    const blurTargetRef = (0, _vue.ref)(null);
    const rootRef = (0, _vue.ref)(null);
    const tabIndicatorRef = (0, _vue.ref)(null);
    const ripple = (0, _vue.computed)(()=>props.disable === true || props.ripple === false ? false : Object.assign({
            keyCodes: [
                13,
                32
            ],
            early: true
        }, props.ripple === true ? {} : props.ripple));
    const isActive = (0, _vue.computed)(()=>$tabs.currentModel.value === props.name);
    const classes = (0, _vue.computed)(()=>"q-tab relative-position self-stretch flex flex-center text-center" + (isActive.value === true ? " q-tab--active" + ($tabs.tabProps.value.activeClass ? " " + $tabs.tabProps.value.activeClass : "") + ($tabs.tabProps.value.activeColor ? ` text-${$tabs.tabProps.value.activeColor}` : "") + ($tabs.tabProps.value.activeBgColor ? ` bg-${$tabs.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (props.icon && props.label && $tabs.tabProps.value.inlineLabel === false ? " q-tab--full" : "") + (props.noCaps === true || $tabs.tabProps.value.noCaps === true ? " q-tab--no-caps" : "") + (props.disable === true ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (routeData !== void 0 ? routeData.linkClass.value : ""));
    const innerClass = (0, _vue.computed)(()=>"q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + ($tabs.tabProps.value.inlineLabel === true ? "row no-wrap q-tab__content--inline" : "column") + (props.contentClass !== void 0 ? ` ${props.contentClass}` : ""));
    const tabIndex = (0, _vue.computed)(()=>props.disable === true || $tabs.hasFocus.value === true || isActive.value === false && $tabs.hasActiveTab.value === true ? -1 : props.tabindex || 0);
    function onClick(e, keyboard) {
        if (keyboard !== true && e?.qAvoidFocus !== true) blurTargetRef.value?.focus();
        if (props.disable === true) {
            if (routeData?.hasRouterLink.value === true) stopAndPrevent(e);
            return;
        }
        if (routeData === void 0) {
            $tabs.updateModel({
                name: props.name
            });
            emit("click", e);
            return;
        }
        if (routeData.hasRouterLink.value === true) {
            const go = (opts = {})=>{
                let hardError;
                const reqId = opts.to === void 0 || isDeepEqual(opts.to, props.to) === true ? $tabs.avoidRouteWatcher = uid() : null;
                return routeData.navigateToRouterLink(e, {
                    ...opts,
                    returnRouterError: true
                }).catch((err)=>{
                    hardError = err;
                }).then((softError)=>{
                    if (reqId === $tabs.avoidRouteWatcher) {
                        $tabs.avoidRouteWatcher = false;
                        if (hardError === void 0 && (softError === void 0 || softError.message?.startsWith("Avoided redundant navigation") === true)) $tabs.updateModel({
                            name: props.name
                        });
                    }
                    if (opts.returnRouterError === true) return hardError !== void 0 ? Promise.reject(hardError) : softError;
                });
            };
            emit("click", e, go);
            if (e.defaultPrevented !== true) go();
            return;
        }
        emit("click", e);
    }
    function onKeydown(e) {
        if (isKeyCode(e, [
            13,
            32
        ])) onClick(e, true);
        else if (shouldIgnoreKey(e) !== true && e.keyCode >= 35 && e.keyCode <= 40 && e.altKey !== true && e.metaKey !== true) {
            if ($tabs.onKbdNavigate(e.keyCode, proxy.$el) === true) stopAndPrevent(e);
        }
        emit("keydown", e);
    }
    function getContent() {
        const narrow = $tabs.tabProps.value.narrowIndicator, content = [], indicator = (0, _vue.h)("div", {
            ref: tabIndicatorRef,
            class: [
                "q-tab__indicator",
                $tabs.tabProps.value.indicatorClass
            ]
        });
        if (props.icon !== void 0) content.push((0, _vue.h)(QIcon_default, {
            class: "q-tab__icon",
            name: props.icon
        }));
        if (props.label !== void 0) content.push((0, _vue.h)("div", {
            class: "q-tab__label"
        }, props.label));
        if (props.alert !== false) content.push(props.alertIcon !== void 0 ? (0, _vue.h)(QIcon_default, {
            class: "q-tab__alert-icon",
            color: props.alert !== true ? props.alert : void 0,
            name: props.alertIcon
        }) : (0, _vue.h)("div", {
            class: "q-tab__alert" + (props.alert !== true ? ` text-${props.alert}` : "")
        }));
        if (narrow === true) content.push(indicator);
        const node = [
            (0, _vue.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: blurTargetRef
            }),
            (0, _vue.h)("div", {
                class: innerClass.value
            }, hMergeSlot(slots.default, content))
        ];
        if (narrow === false) node.push(indicator);
        return node;
    }
    const tabData = {
        name: (0, _vue.computed)(()=>props.name),
        rootRef,
        tabIndicatorRef,
        routeData
    };
    (0, _vue.onBeforeUnmount)(()=>{
        $tabs.unregisterTab(tabData);
    });
    (0, _vue.onMounted)(()=>{
        $tabs.registerTab(tabData);
    });
    function renderTab(tag, customData) {
        return (0, _vue.withDirectives)((0, _vue.h)(tag, {
            ref: rootRef,
            class: classes.value,
            tabindex: tabIndex.value,
            role: "tab",
            "aria-selected": isActive.value === true ? "true" : "false",
            "aria-disabled": props.disable === true ? "true" : void 0,
            onClick,
            onKeydown,
            ...customData
        }, getContent()), [
            [
                Ripple_default,
                ripple.value
            ]
        ]);
    }
    return {
        renderTab,
        $tabs
    };
}
//#endregion
//#region src/components/tabs/QTab.js
var QTab_default = createComponent({
    name: "QTab",
    props: useTabProps,
    emits: useTabEmits,
    setup (props, { slots, emit }) {
        const { renderTab } = useTab(props, slots, emit);
        return ()=>renderTab("div");
    }
});
//#endregion
//#region src/components/tab-panels/QTabPanels.js
var QTabPanels_default = createComponent({
    name: "QTabPanels",
    props: {
        ...usePanelProps,
        ...useDarkProps
    },
    emits: usePanelEmits,
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const { updatePanelsList, getPanelContent, panelDirectives } = usePanel();
        const classes = (0, _vue.computed)(()=>"q-tab-panels q-panel-parent" + (isDark.value === true ? " q-tab-panels--dark q-dark" : ""));
        return ()=>{
            updatePanelsList(slots);
            return hDir("div", {
                class: classes.value
            }, getPanelContent(), "pan", props.swipeable, ()=>panelDirectives.value);
        };
    }
});
//#endregion
//#region src/components/tab-panels/QTabPanel.js
var QTabPanel_default = createComponent({
    name: "QTabPanel",
    props: usePanelChildProps,
    setup (_, { slots }) {
        return ()=>(0, _vue.h)("div", {
                class: "q-tab-panel",
                role: "tabpanel"
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/utils/patterns/patterns.js
const hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
const testPattern = {
    date: (v)=>/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
    time: (v)=>/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v),
    fulltime: (v)=>/^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v),
    timeOrFulltime: (v)=>/^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v),
    email: (v)=>/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
    hexColor: (v)=>hex.test(v),
    hexaColor: (v)=>hexa.test(v),
    hexOrHexaColor: (v)=>hexOrHexa.test(v),
    rgbColor: (v)=>rgb.test(v),
    rgbaColor: (v)=>rgba.test(v),
    rgbOrRgbaColor: (v)=>rgb.test(v) || rgba.test(v),
    hexOrRgbColor: (v)=>hex.test(v) || rgb.test(v),
    hexaOrRgbaColor: (v)=>hexa.test(v) || rgba.test(v),
    anyColor: (v)=>hexOrHexa.test(v) || rgb.test(v) || rgba.test(v)
};
var patterns_default = {
    testPattern
};
//#endregion
//#region src/utils/colors/colors.js
const reRGBA = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function rgbToHex({ r, g, b, a }) {
    const alpha = a !== void 0;
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    if (r > 255 || g > 255 || b > 255 || alpha && a > 100) throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
    a = alpha ? (Math.round(255 * a / 100) | 256).toString(16).slice(1) : "";
    return "#" + (b | g << 8 | r << 16 | 16777216).toString(16).slice(1) + a;
}
function rgbToString({ r, g, b, a }) {
    return `rgb${a !== void 0 ? "a" : ""}(${r},${g},${b}${a !== void 0 ? "," + a / 100 : ""})`;
}
function hexToRgb(hex) {
    if (typeof hex !== "string") throw new TypeError("Expected a string");
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    else if (hex.length === 4) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    const num = parseInt(hex, 16);
    return hex.length > 6 ? {
        r: num >> 24 & 255,
        g: num >> 16 & 255,
        b: num >> 8 & 255,
        a: Math.round((num & 255) / 2.55)
    } : {
        r: num >> 16,
        g: num >> 8 & 255,
        b: num & 255
    };
}
function hsvToRgb({ h, s, v, a }) {
    let r, g, b;
    s = s / 100;
    v = v / 100;
    h = h / 360;
    const i = Math.floor(h * 6), f = h * 6 - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255),
        a
    };
}
function rgbToHsv({ r, g, b, a }) {
    const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, s = max === 0 ? 0 : d / max, v = max / 255;
    let h;
    switch(max){
        case min:
            h = 0;
            break;
        case r:
            h = g - b + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
        case g:
            h = b - r + d * 2;
            h /= 6 * d;
            break;
        case b:
            h = r - g + d * 4;
            h /= 6 * d;
            break;
    }
    return {
        h: Math.round(h * 360),
        s: Math.round(s * 100),
        v: Math.round(v * 100),
        a
    };
}
function textToRgb(str) {
    if (typeof str !== "string") throw new TypeError("Expected a string");
    const color = str.replace(/ /g, "");
    const m = reRGBA.exec(color);
    if (m === null) return hexToRgb(color);
    const rgb = {
        r: Math.min(255, parseInt(m[2], 10)),
        g: Math.min(255, parseInt(m[3], 10)),
        b: Math.min(255, parseInt(m[4], 10))
    };
    if (m[1]) {
        const alpha = parseFloat(m[5]);
        rgb.a = Math.min(1, isNaN(alpha) === true ? 1 : alpha) * 100;
    }
    return rgb;
}
function lighten(color, percent) {
    if (typeof color !== "string") throw new TypeError("Expected a string as color");
    if (typeof percent !== "number") throw new TypeError("Expected a numeric percent");
    const rgb = textToRgb(color), t = percent < 0 ? 0 : 255, p = Math.abs(percent) / 100, R = rgb.r, G = rgb.g, B = rgb.b;
    return "#" + (16777216 + (Math.round((t - R) * p) + R) * 65536 + (Math.round((t - G) * p) + G) * 256 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}
function luminosity(color) {
    if (typeof color !== "string" && (!color || color.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    const rgb = typeof color === "string" ? textToRgb(color) : color, r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255, R = r <= .03928 ? r / 12.92 : ((r + .055) / 1.055) ** 2.4, G = g <= .03928 ? g / 12.92 : ((g + .055) / 1.055) ** 2.4, B = b <= .03928 ? b / 12.92 : ((b + .055) / 1.055) ** 2.4;
    return .2126 * R + .7152 * G + .0722 * B;
}
function brightness(color) {
    if (typeof color !== "string" && (!color || color.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    const rgb = typeof color === "string" ? textToRgb(color) : color;
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
}
function blend(fgColor, bgColor) {
    if (typeof fgColor !== "string" && (!fgColor || fgColor.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
    if (typeof bgColor !== "string" && (!bgColor || bgColor.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
    const rgb1 = typeof fgColor === "string" ? textToRgb(fgColor) : fgColor, r1 = rgb1.r / 255, g1 = rgb1.g / 255, b1 = rgb1.b / 255, a1 = rgb1.a !== void 0 ? rgb1.a / 100 : 1, rgb2 = typeof bgColor === "string" ? textToRgb(bgColor) : bgColor, r2 = rgb2.r / 255, g2 = rgb2.g / 255, b2 = rgb2.b / 255, a2 = rgb2.a !== void 0 ? rgb2.a / 100 : 1, a = a1 + a2 * (1 - a1);
    const ret = {
        r: Math.round((r1 * a1 + r2 * a2 * (1 - a1)) / a * 255),
        g: Math.round((g1 * a1 + g2 * a2 * (1 - a1)) / a * 255),
        b: Math.round((b1 * a1 + b2 * a2 * (1 - a1)) / a * 255),
        a: Math.round(a * 100)
    };
    return typeof fgColor === "string" ? rgbToHex(ret) : ret;
}
function changeAlpha(color, offset) {
    if (typeof color !== "string") throw new TypeError("Expected a string as color");
    if (offset === void 0 || offset < -1 || offset > 1) throw new TypeError("Expected offset to be between -1 and 1");
    const { r, g, b, a } = textToRgb(color);
    const alpha = a !== void 0 ? a / 100 : 0;
    return rgbToHex({
        r,
        g,
        b,
        a: Math.round(Math.min(1, Math.max(0, alpha + offset)) * 100)
    });
}
function getPaletteColor(colorName) {
    if (typeof colorName !== "string") throw new TypeError("Expected a string as color");
    const el = document.createElement("div");
    el.className = `text-${colorName} invisible fixed no-pointer-events`;
    document.body.appendChild(el);
    const result = getComputedStyle(el).getPropertyValue("color");
    el.remove();
    return rgbToHex(textToRgb(result));
}
var colors_default = {
    rgbToHex,
    hexToRgb,
    hsvToRgb,
    rgbToHsv,
    textToRgb,
    lighten,
    luminosity,
    brightness,
    blend,
    changeAlpha,
    getPaletteColor
};
//#endregion
//#region src/components/color/QColor.js
const palette = [
    "rgb(255,204,204)",
    "rgb(255,230,204)",
    "rgb(255,255,204)",
    "rgb(204,255,204)",
    "rgb(204,255,230)",
    "rgb(204,255,255)",
    "rgb(204,230,255)",
    "rgb(204,204,255)",
    "rgb(230,204,255)",
    "rgb(255,204,255)",
    "rgb(255,153,153)",
    "rgb(255,204,153)",
    "rgb(255,255,153)",
    "rgb(153,255,153)",
    "rgb(153,255,204)",
    "rgb(153,255,255)",
    "rgb(153,204,255)",
    "rgb(153,153,255)",
    "rgb(204,153,255)",
    "rgb(255,153,255)",
    "rgb(255,102,102)",
    "rgb(255,179,102)",
    "rgb(255,255,102)",
    "rgb(102,255,102)",
    "rgb(102,255,179)",
    "rgb(102,255,255)",
    "rgb(102,179,255)",
    "rgb(102,102,255)",
    "rgb(179,102,255)",
    "rgb(255,102,255)",
    "rgb(255,51,51)",
    "rgb(255,153,51)",
    "rgb(255,255,51)",
    "rgb(51,255,51)",
    "rgb(51,255,153)",
    "rgb(51,255,255)",
    "rgb(51,153,255)",
    "rgb(51,51,255)",
    "rgb(153,51,255)",
    "rgb(255,51,255)",
    "rgb(255,0,0)",
    "rgb(255,128,0)",
    "rgb(255,255,0)",
    "rgb(0,255,0)",
    "rgb(0,255,128)",
    "rgb(0,255,255)",
    "rgb(0,128,255)",
    "rgb(0,0,255)",
    "rgb(128,0,255)",
    "rgb(255,0,255)",
    "rgb(245,0,0)",
    "rgb(245,123,0)",
    "rgb(245,245,0)",
    "rgb(0,245,0)",
    "rgb(0,245,123)",
    "rgb(0,245,245)",
    "rgb(0,123,245)",
    "rgb(0,0,245)",
    "rgb(123,0,245)",
    "rgb(245,0,245)",
    "rgb(214,0,0)",
    "rgb(214,108,0)",
    "rgb(214,214,0)",
    "rgb(0,214,0)",
    "rgb(0,214,108)",
    "rgb(0,214,214)",
    "rgb(0,108,214)",
    "rgb(0,0,214)",
    "rgb(108,0,214)",
    "rgb(214,0,214)",
    "rgb(163,0,0)",
    "rgb(163,82,0)",
    "rgb(163,163,0)",
    "rgb(0,163,0)",
    "rgb(0,163,82)",
    "rgb(0,163,163)",
    "rgb(0,82,163)",
    "rgb(0,0,163)",
    "rgb(82,0,163)",
    "rgb(163,0,163)",
    "rgb(92,0,0)",
    "rgb(92,46,0)",
    "rgb(92,92,0)",
    "rgb(0,92,0)",
    "rgb(0,92,46)",
    "rgb(0,92,92)",
    "rgb(0,46,92)",
    "rgb(0,0,92)",
    "rgb(46,0,92)",
    "rgb(92,0,92)",
    "rgb(255,255,255)",
    "rgb(205,205,205)",
    "rgb(178,178,178)",
    "rgb(153,153,153)",
    "rgb(127,127,127)",
    "rgb(102,102,102)",
    "rgb(76,76,76)",
    "rgb(51,51,51)",
    "rgb(25,25,25)",
    "rgb(0,0,0)"
];
const thumbPath = "M5 5 h10 v10 h-10 v-10 z";
const alphaTrackImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==";
var QColor_default = createComponent({
    name: "QColor",
    props: {
        ...useDarkProps,
        ...useFormProps,
        modelValue: String,
        defaultValue: String,
        defaultView: {
            type: String,
            default: "spectrum",
            validator: (v)=>[
                    "spectrum",
                    "tune",
                    "palette"
                ].includes(v)
        },
        formatModel: {
            type: String,
            default: "auto",
            validator: (v)=>[
                    "auto",
                    "hex",
                    "rgb",
                    "hexa",
                    "rgba"
                ].includes(v)
        },
        palette: Array,
        noHeader: Boolean,
        noHeaderTabs: Boolean,
        noFooter: Boolean,
        square: Boolean,
        flat: Boolean,
        bordered: Boolean,
        disable: Boolean,
        readonly: Boolean
    },
    emits: [
        "update:modelValue",
        "change"
    ],
    setup (props, { emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const { getCache } = useRenderCache();
        const spectrumRef = (0, _vue.ref)(null);
        const errorIconRef = (0, _vue.ref)(null);
        const forceHex = (0, _vue.computed)(()=>props.formatModel === "auto" ? null : props.formatModel.indexOf("hex") !== -1);
        const forceAlpha = (0, _vue.computed)(()=>props.formatModel === "auto" ? null : props.formatModel.indexOf("a") !== -1);
        const topView = (0, _vue.ref)(props.formatModel === "auto" ? props.modelValue === void 0 || props.modelValue === null || props.modelValue === "" || props.modelValue.startsWith("#") ? "hex" : "rgb" : props.formatModel.startsWith("hex") ? "hex" : "rgb");
        const view = (0, _vue.ref)(props.defaultView);
        const model = (0, _vue.ref)(parseModel(props.modelValue || props.defaultValue));
        const editable = (0, _vue.computed)(()=>props.disable !== true && props.readonly !== true);
        const isHex = (0, _vue.computed)(()=>props.modelValue === void 0 || props.modelValue === null || props.modelValue === "" || props.modelValue.startsWith("#"));
        const isOutputHex = (0, _vue.computed)(()=>forceHex.value !== null ? forceHex.value : isHex.value);
        const injectFormInput = useFormInject((0, _vue.computed)(()=>({
                type: "hidden",
                name: props.name,
                value: model.value[isOutputHex.value === true ? "hex" : "rgb"]
            })));
        const hasAlpha = (0, _vue.computed)(()=>forceAlpha.value !== null ? forceAlpha.value : model.value.a !== void 0);
        const currentBgColor = (0, _vue.computed)(()=>({
                backgroundColor: model.value.rgb || "#000"
            }));
        const headerClass = (0, _vue.computed)(()=>{
            return `q-color-picker__header-content q-color-picker__header-content--${(model.value.a !== void 0 && model.value.a < 65 ? true : luminosity(model.value) > .4) ? "light" : "dark"}`;
        });
        const spectrumStyle = (0, _vue.computed)(()=>({
                background: `hsl(${model.value.h},100%,50%)`
            }));
        const spectrumPointerStyle = (0, _vue.computed)(()=>({
                top: `${100 - model.value.v}%`,
                [$q.lang.rtl === true ? "right" : "left"]: `${model.value.s}%`
            }));
        const computedPalette = (0, _vue.computed)(()=>props.palette !== void 0 && props.palette.length !== 0 ? props.palette : palette);
        const classes = (0, _vue.computed)(()=>"q-color-picker" + (props.bordered === true ? " q-color-picker--bordered" : "") + (props.square === true ? " q-color-picker--square no-border-radius" : "") + (props.flat === true ? " q-color-picker--flat no-shadow" : "") + (props.disable === true ? " disabled" : "") + (isDark.value === true ? " q-color-picker--dark q-dark" : ""));
        const attributes = (0, _vue.computed)(()=>props.disable === true ? {
                "aria-disabled": "true"
            } : {});
        const spectrumDirective = (0, _vue.computed)(()=>[
                [
                    TouchPan_default,
                    onSpectrumPan,
                    void 0,
                    {
                        prevent: true,
                        stop: true,
                        mouse: true
                    }
                ]
            ]);
        (0, _vue.watch)(()=>props.modelValue, (v)=>{
            const localModel = parseModel(v || props.defaultValue);
            if (localModel.hex !== model.value.hex) model.value = localModel;
        });
        (0, _vue.watch)(()=>props.defaultValue, (v)=>{
            if (!props.modelValue && v) {
                const localModel = parseModel(v);
                if (localModel.hex !== model.value.hex) model.value = localModel;
            }
        });
        function updateModel(rgb, change) {
            model.value.hex = rgbToHex(rgb);
            model.value.rgb = rgbToString(rgb);
            model.value.r = rgb.r;
            model.value.g = rgb.g;
            model.value.b = rgb.b;
            model.value.a = rgb.a;
            const value1 = model.value[isOutputHex.value === true ? "hex" : "rgb"];
            emit("update:modelValue", value1);
            if (change === true) emit("change", value1);
        }
        function parseModel(v) {
            const alpha = forceAlpha.value !== void 0 ? forceAlpha.value : props.formatModel === "auto" ? null : props.formatModel.indexOf("a") !== -1;
            if (typeof v !== "string" || v.length === 0 || testPattern.anyColor(v.replace(/ /g, "")) !== true) return {
                h: 0,
                s: 0,
                v: 0,
                r: 0,
                g: 0,
                b: 0,
                a: alpha === true ? 100 : void 0,
                hex: void 0,
                rgb: void 0
            };
            const localModel = textToRgb(v);
            if (alpha === true && localModel.a === void 0) localModel.a = 100;
            localModel.hex = rgbToHex(localModel);
            localModel.rgb = rgbToString(localModel);
            return Object.assign(localModel, rgbToHsv(localModel));
        }
        function changeSpectrum(left, top, change) {
            const panel = spectrumRef.value;
            if (panel === null) return;
            const width = panel.clientWidth, height = panel.clientHeight, rect = panel.getBoundingClientRect();
            let x = Math.min(width, Math.max(0, left - rect.left));
            if ($q.lang.rtl === true) x = width - x;
            const y = Math.min(height, Math.max(0, top - rect.top)), s = Math.round(100 * x / width), v = Math.round(100 * Math.max(0, Math.min(1, -(y / height) + 1))), rgb = hsvToRgb({
                h: model.value.h,
                s,
                v,
                a: hasAlpha.value === true ? model.value.a : void 0
            });
            model.value.s = s;
            model.value.v = v;
            updateModel(rgb, change);
        }
        function onHue(val, change) {
            const hue = Math.round(val);
            const rgb = hsvToRgb({
                h: hue,
                s: model.value.s,
                v: model.value.v,
                a: hasAlpha.value === true ? model.value.a : void 0
            });
            model.value.h = hue;
            updateModel(rgb, change);
        }
        function onHueChange(val) {
            onHue(val, true);
        }
        function onNumericChange(value1, formatModel, max, evt, change) {
            if (evt !== void 0) stop(evt);
            if (!/^[0-9]+$/.test(value1)) {
                if (change === true) proxy.$forceUpdate();
                return;
            }
            const val = Math.floor(Number(value1));
            if (val < 0 || val > max) {
                if (change === true) proxy.$forceUpdate();
                return;
            }
            const rgb = {
                r: formatModel === "r" ? val : model.value.r,
                g: formatModel === "g" ? val : model.value.g,
                b: formatModel === "b" ? val : model.value.b,
                a: hasAlpha.value === true ? formatModel === "a" ? val : model.value.a : void 0
            };
            if (formatModel !== "a") {
                const hsv = rgbToHsv(rgb);
                model.value.h = hsv.h;
                model.value.s = hsv.s;
                model.value.v = hsv.v;
            }
            updateModel(rgb, change);
            if (change !== true && evt?.target.selectionEnd !== void 0) {
                const index = evt.target.selectionEnd;
                (0, _vue.nextTick)(()=>{
                    evt.target.setSelectionRange(index, index);
                });
            }
        }
        function onEditorChange(evt, change) {
            let rgb;
            const inp = evt.target.value;
            stop(evt);
            if (topView.value === "hex") {
                if (inp.length !== (hasAlpha.value === true ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(inp)) return true;
                rgb = hexToRgb(inp);
            } else {
                let localModel;
                if (!inp.endsWith(")")) return true;
                else if (hasAlpha.value !== true && inp.startsWith("rgb(")) {
                    localModel = inp.substring(4, inp.length - 1).split(",").map((n)=>parseInt(n, 10));
                    if (localModel.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(inp)) return true;
                } else if (hasAlpha.value === true && inp.startsWith("rgba(")) {
                    localModel = inp.substring(5, inp.length - 1).split(",");
                    if (localModel.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(inp)) return true;
                    for(let i = 0; i < 3; i++){
                        const v = parseInt(localModel[i], 10);
                        if (v < 0 || v > 255) return true;
                        localModel[i] = v;
                    }
                    const v = parseFloat(localModel[3]);
                    if (v < 0 || v > 1) return true;
                    localModel[3] = v;
                } else return true;
                if (localModel[0] < 0 || localModel[0] > 255 || localModel[1] < 0 || localModel[1] > 255 || localModel[2] < 0 || localModel[2] > 255 || hasAlpha.value === true && (localModel[3] < 0 || localModel[3] > 1)) return true;
                rgb = {
                    r: localModel[0],
                    g: localModel[1],
                    b: localModel[2],
                    a: hasAlpha.value === true ? localModel[3] * 100 : void 0
                };
            }
            const hsv = rgbToHsv(rgb);
            model.value.h = hsv.h;
            model.value.s = hsv.s;
            model.value.v = hsv.v;
            updateModel(rgb, change);
            if (change !== true) {
                const index = evt.target.selectionEnd;
                (0, _vue.nextTick)(()=>{
                    evt.target.setSelectionRange(index, index);
                });
            }
        }
        function onPalettePick(color) {
            const def = parseModel(color);
            const rgb = {
                r: def.r,
                g: def.g,
                b: def.b,
                a: def.a
            };
            if (rgb.a === void 0) rgb.a = model.value.a;
            model.value.h = def.h;
            model.value.s = def.s;
            model.value.v = def.v;
            updateModel(rgb, true);
        }
        function onSpectrumPan(evt) {
            if (evt.isFinal) changeSpectrum(evt.position.left, evt.position.top, true);
            else onSpectrumChange(evt);
        }
        const onSpectrumChange = throttle((evt)=>{
            changeSpectrum(evt.position.left, evt.position.top);
        }, 20);
        function onSpectrumClick(evt) {
            changeSpectrum(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset, true);
        }
        function onActivate(evt) {
            changeSpectrum(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset);
        }
        function updateErrorIcon(val) {
            if (errorIconRef.value !== null) errorIconRef.value.$el.style.opacity = val ? 1 : 0;
        }
        function setTopView(val) {
            topView.value = val;
        }
        function getHeader() {
            const child = [];
            if (props.noHeaderTabs !== true) child.push((0, _vue.h)(QTabs_default, {
                class: "q-color-picker__header-tabs",
                modelValue: topView.value,
                dense: true,
                align: "justify",
                "onUpdate:modelValue": setTopView
            }, ()=>[
                    (0, _vue.h)(QTab_default, {
                        label: "HEX" + (hasAlpha.value === true ? "A" : ""),
                        name: "hex",
                        ripple: false
                    }),
                    (0, _vue.h)(QTab_default, {
                        label: "RGB" + (hasAlpha.value === true ? "A" : ""),
                        name: "rgb",
                        ripple: false
                    })
                ]));
            child.push((0, _vue.h)("div", {
                class: "q-color-picker__header-banner row flex-center no-wrap"
            }, [
                (0, _vue.h)("input", {
                    class: "fit",
                    value: model.value[topView.value],
                    ...editable.value !== true ? {
                        readonly: true
                    } : {},
                    ...getCache("topIn", {
                        onInput: (evt)=>{
                            updateErrorIcon(onEditorChange(evt) === true);
                        },
                        onChange: stop,
                        onBlur: (evt)=>{
                            if (onEditorChange(evt, true) === true) proxy.$forceUpdate();
                            updateErrorIcon(false);
                        }
                    })
                }),
                (0, _vue.h)(QIcon_default, {
                    ref: errorIconRef,
                    class: "q-color-picker__error-icon absolute no-pointer-events",
                    name: $q.iconSet.type.negative
                })
            ]));
            return (0, _vue.h)("div", {
                class: "q-color-picker__header relative-position overflow-hidden"
            }, [
                (0, _vue.h)("div", {
                    class: "q-color-picker__header-bg absolute-full"
                }),
                (0, _vue.h)("div", {
                    class: headerClass.value,
                    style: currentBgColor.value
                }, child)
            ]);
        }
        function getContent() {
            return (0, _vue.h)(QTabPanels_default, {
                modelValue: view.value,
                animated: true
            }, ()=>[
                    (0, _vue.h)(QTabPanel_default, {
                        class: "q-color-picker__spectrum-tab overflow-hidden",
                        name: "spectrum"
                    }, getSpectrumTab),
                    (0, _vue.h)(QTabPanel_default, {
                        class: "q-pa-md q-color-picker__tune-tab",
                        name: "tune"
                    }, getTuneTab),
                    (0, _vue.h)(QTabPanel_default, {
                        class: "q-color-picker__palette-tab",
                        name: "palette"
                    }, getPaletteTab)
                ]);
        }
        function setView(val) {
            view.value = val;
        }
        function getFooter() {
            return (0, _vue.h)("div", {
                class: "q-color-picker__footer relative-position overflow-hidden"
            }, [
                (0, _vue.h)(QTabs_default, {
                    class: "absolute-full",
                    modelValue: view.value,
                    dense: true,
                    align: "justify",
                    "onUpdate:modelValue": setView
                }, ()=>[
                        (0, _vue.h)(QTab_default, {
                            icon: $q.iconSet.colorPicker.spectrum,
                            name: "spectrum",
                            ripple: false
                        }),
                        (0, _vue.h)(QTab_default, {
                            icon: $q.iconSet.colorPicker.tune,
                            name: "tune",
                            ripple: false
                        }),
                        (0, _vue.h)(QTab_default, {
                            icon: $q.iconSet.colorPicker.palette,
                            name: "palette",
                            ripple: false
                        })
                    ])
            ]);
        }
        function getSpectrumTab() {
            const data = {
                ref: spectrumRef,
                class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (editable.value !== true ? " readonly" : ""),
                style: spectrumStyle.value,
                ...editable.value === true ? {
                    onClick: onSpectrumClick,
                    onMousedown: onActivate
                } : {}
            };
            const child = [
                (0, _vue.h)("div", {
                    style: {
                        paddingBottom: "100%"
                    }
                }),
                (0, _vue.h)("div", {
                    class: "q-color-picker__spectrum-white absolute-full"
                }),
                (0, _vue.h)("div", {
                    class: "q-color-picker__spectrum-black absolute-full"
                }),
                (0, _vue.h)("div", {
                    class: "absolute",
                    style: spectrumPointerStyle.value
                }, [
                    model.value.hex !== void 0 ? (0, _vue.h)("div", {
                        class: "q-color-picker__spectrum-circle"
                    }) : null
                ])
            ];
            const sliders = [
                (0, _vue.h)(QSlider_default, {
                    class: "q-color-picker__hue non-selectable",
                    modelValue: model.value.h,
                    min: 0,
                    max: 360,
                    trackSize: "8px",
                    innerTrackColor: "transparent",
                    selectionColor: "transparent",
                    readonly: editable.value !== true,
                    thumbPath,
                    "onUpdate:modelValue": onHue,
                    onChange: onHueChange
                })
            ];
            if (hasAlpha.value === true) sliders.push((0, _vue.h)(QSlider_default, {
                class: "q-color-picker__alpha non-selectable",
                modelValue: model.value.a,
                min: 0,
                max: 100,
                trackSize: "8px",
                trackColor: "white",
                innerTrackColor: "transparent",
                selectionColor: "transparent",
                trackImg: alphaTrackImg,
                readonly: editable.value !== true,
                hideSelection: true,
                thumbPath,
                ...getCache("alphaSlide", {
                    "onUpdate:modelValue": (value1)=>onNumericChange(value1, "a", 100),
                    onChange: (value1)=>onNumericChange(value1, "a", 100, void 0, true)
                })
            }));
            return [
                hDir("div", data, child, "spec", editable.value, ()=>spectrumDirective.value),
                (0, _vue.h)("div", {
                    class: "q-color-picker__sliders"
                }, sliders)
            ];
        }
        function getTuneTab() {
            return [
                (0, _vue.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, _vue.h)("div", "R"),
                    (0, _vue.h)(QSlider_default, {
                        modelValue: model.value.r,
                        min: 0,
                        max: 255,
                        color: "red",
                        dark: isDark.value,
                        readonly: editable.value !== true,
                        ...getCache("rSlide", {
                            "onUpdate:modelValue": (value1)=>onNumericChange(value1, "r", 255),
                            onChange: (value1)=>onNumericChange(value1, "r", 255, void 0, true)
                        })
                    }),
                    (0, _vue.h)("input", {
                        value: model.value.r,
                        maxlength: 3,
                        readonly: editable.value !== true,
                        onChange: stop,
                        ...getCache("rIn", {
                            onInput: (evt)=>onNumericChange(evt.target.value, "r", 255, evt),
                            onBlur: (evt)=>onNumericChange(evt.target.value, "r", 255, evt, true)
                        })
                    })
                ]),
                (0, _vue.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, _vue.h)("div", "G"),
                    (0, _vue.h)(QSlider_default, {
                        modelValue: model.value.g,
                        min: 0,
                        max: 255,
                        color: "green",
                        dark: isDark.value,
                        readonly: editable.value !== true,
                        ...getCache("gSlide", {
                            "onUpdate:modelValue": (value1)=>onNumericChange(value1, "g", 255),
                            onChange: (value1)=>onNumericChange(value1, "g", 255, void 0, true)
                        })
                    }),
                    (0, _vue.h)("input", {
                        value: model.value.g,
                        maxlength: 3,
                        readonly: editable.value !== true,
                        onChange: stop,
                        ...getCache("gIn", {
                            onInput: (evt)=>onNumericChange(evt.target.value, "g", 255, evt),
                            onBlur: (evt)=>onNumericChange(evt.target.value, "g", 255, evt, true)
                        })
                    })
                ]),
                (0, _vue.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, _vue.h)("div", "B"),
                    (0, _vue.h)(QSlider_default, {
                        modelValue: model.value.b,
                        min: 0,
                        max: 255,
                        color: "blue",
                        readonly: editable.value !== true,
                        dark: isDark.value,
                        ...getCache("bSlide", {
                            "onUpdate:modelValue": (value1)=>onNumericChange(value1, "b", 255),
                            onChange: (value1)=>onNumericChange(value1, "b", 255, void 0, true)
                        })
                    }),
                    (0, _vue.h)("input", {
                        value: model.value.b,
                        maxlength: 3,
                        readonly: editable.value !== true,
                        onChange: stop,
                        ...getCache("bIn", {
                            onInput: (evt)=>onNumericChange(evt.target.value, "b", 255, evt),
                            onBlur: (evt)=>onNumericChange(evt.target.value, "b", 255, evt, true)
                        })
                    })
                ]),
                hasAlpha.value === true ? (0, _vue.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, _vue.h)("div", "A"),
                    (0, _vue.h)(QSlider_default, {
                        modelValue: model.value.a,
                        color: "grey",
                        readonly: editable.value !== true,
                        dark: isDark.value,
                        ...getCache("aSlide", {
                            "onUpdate:modelValue": (value1)=>onNumericChange(value1, "a", 100),
                            onChange: (value1)=>onNumericChange(value1, "a", 100, void 0, true)
                        })
                    }),
                    (0, _vue.h)("input", {
                        value: model.value.a,
                        maxlength: 3,
                        readonly: editable.value !== true,
                        onChange: stop,
                        ...getCache("aIn", {
                            onInput: (evt)=>onNumericChange(evt.target.value, "a", 100, evt),
                            onBlur: (evt)=>onNumericChange(evt.target.value, "a", 100, evt, true)
                        })
                    })
                ]) : null
            ];
        }
        function getPaletteTab() {
            const fn = (color)=>(0, _vue.h)("div", {
                    class: "q-color-picker__cube col-auto",
                    style: {
                        backgroundColor: color
                    },
                    ...editable.value === true ? getCache("palette#" + color, {
                        onClick: ()=>{
                            onPalettePick(color);
                        }
                    }) : {}
                });
            return [
                (0, _vue.h)("div", {
                    class: "row items-center q-color-picker__palette-rows" + (editable.value === true ? " q-color-picker__palette-rows--editable" : "")
                }, computedPalette.value.map(fn))
            ];
        }
        return ()=>{
            const child = [
                getContent()
            ];
            if (props.name !== void 0 && props.disable !== true) injectFormInput(child, "push");
            if (props.noHeader !== true) child.unshift(getHeader());
            if (props.noFooter !== true) child.push(getFooter());
            return (0, _vue.h)("div", {
                class: classes.value,
                ...attributes.value
            }, child);
        };
    }
});
//#endregion
//#region src/utils/date/private.persian.js
const breaks = [
    -61,
    9,
    38,
    199,
    426,
    686,
    756,
    818,
    1111,
    1181,
    1210,
    1635,
    2060,
    2097,
    2192,
    2262,
    2324,
    2394,
    2456,
    3178
];
function toJalaali(gy, gm, gd) {
    if (Object.prototype.toString.call(gy) === "[object Date]") {
        gd = gy.getDate();
        gm = gy.getMonth() + 1;
        gy = gy.getFullYear();
    }
    return d2j(g2d(gy, gm, gd));
}
function toGregorian(jy, jm, jd) {
    return d2g(j2d(jy, jm, jd));
}
function isLeapJalaaliYear(jy) {
    return jalCalLeap(jy) === 0;
}
function jalaaliMonthLength(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    if (isLeapJalaaliYear(jy)) return 30;
    return 29;
}
function jalCalLeap(jy) {
    const bl = breaks.length;
    let jp = breaks[0], jm, jump, leap, n, i;
    if (jy < jp || jy >= breaks[bl - 1]) throw new Error("Invalid Jalaali year " + jy);
    for(i = 1; i < bl; i += 1){
        jm = breaks[i];
        jump = jm - jp;
        if (jy < jm) break;
        jp = jm;
    }
    n = jy - jp;
    if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) leap = 4;
    return leap;
}
function jalCal(jy, withoutLeap) {
    const bl = breaks.length, gy = jy + 621;
    let leapJ = -14, jp = breaks[0], jm, jump, leap, n, i;
    if (jy < jp || jy >= breaks[bl - 1]) throw new Error("Invalid Jalaali year " + jy);
    for(i = 1; i < bl; i += 1){
        jm = breaks[i];
        jump = jm - jp;
        if (jy < jm) break;
        leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4);
        jp = jm;
    }
    n = jy - jp;
    leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
    if (mod(jump, 33) === 4 && jump - n === 4) leapJ += 1;
    const leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
    const march = 20 + leapJ - leapG;
    if (!withoutLeap) {
        if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
        leap = mod(mod(n + 1, 33) - 1, 4);
        if (leap === -1) leap = 4;
    }
    return {
        leap,
        gy,
        march
    };
}
function j2d(jy, jm, jd) {
    const r = jalCal(jy, true);
    return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}
function d2j(jdn) {
    const gy = d2g(jdn).gy;
    let jy = gy - 621, jd, jm, k;
    const r = jalCal(jy, false);
    k = jdn - g2d(gy, 3, r.march);
    if (k >= 0) {
        if (k <= 185) {
            jm = 1 + div(k, 31);
            jd = mod(k, 31) + 1;
            return {
                jy,
                jm,
                jd
            };
        } else k -= 186;
    } else {
        jy -= 1;
        k += 179;
        if (r.leap === 1) k += 1;
    }
    jm = 7 + div(k, 30);
    jd = mod(k, 30) + 1;
    return {
        jy,
        jm,
        jd
    };
}
function g2d(gy, gm, gd) {
    let d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
    d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
    return d;
}
function d2g(jdn) {
    let j = 4 * jdn + 139361631;
    j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
    const i = div(mod(j, 1461), 4) * 5 + 308, gd = div(mod(i, 153), 5) + 1, gm = mod(div(i, 153), 12) + 1;
    return {
        gy: div(j, 1461) - 100100 + div(8 - gm, 6),
        gm,
        gd
    };
}
function div(a, b) {
    return ~~(a / b);
}
function mod(a, b) {
    return a - ~~(a / b) * b;
}
//#endregion
//#region src/components/date/use-datetime.js
const calendars = [
    "gregorian",
    "persian"
];
const useDatetimeProps = {
    mask: {
        type: String
    },
    locale: Object,
    calendar: {
        type: String,
        validator: (v)=>calendars.includes(v),
        default: "gregorian"
    },
    landscape: Boolean,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    readonly: Boolean,
    disable: Boolean
};
const useDatetimeEmits = [
    "update:modelValue"
];
function getDayHash(date) {
    return date.year + "/" + pad(date.month) + "/" + pad(date.day);
}
function useDatetime(props, $q) {
    const editable = (0, _vue.computed)(()=>props.disable !== true && props.readonly !== true);
    const tabindex = (0, _vue.computed)(()=>editable.value === true ? 0 : -1);
    const headerClass = (0, _vue.computed)(()=>{
        const cls = [];
        if (props.color !== void 0) cls.push(`bg-${props.color}`);
        if (props.textColor !== void 0) cls.push(`text-${props.textColor}`);
        return cls.join(" ");
    });
    function getLocale() {
        return props.locale !== void 0 ? {
            ...$q.lang.date,
            ...props.locale
        } : $q.lang.date;
    }
    function getCurrentDate(dateOnly) {
        const d = /* @__PURE__ */ new Date();
        const timeFill = dateOnly === true ? null : 0;
        if (props.calendar === "persian") {
            const jDate = toJalaali(d);
            return {
                year: jDate.jy,
                month: jDate.jm,
                day: jDate.jd
            };
        }
        return {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            day: d.getDate(),
            hour: timeFill,
            minute: timeFill,
            second: timeFill,
            millisecond: timeFill
        };
    }
    return {
        editable,
        tabindex,
        headerClass,
        getLocale,
        getCurrentDate
    };
}
//#endregion
//#region src/utils/date/date.js
const MILLISECONDS_IN_DAY = 864e5, MILLISECONDS_IN_HOUR = 36e5, MILLISECONDS_IN_MINUTE = 6e4, defaultMask = "YYYY-MM-DDTHH:mm:ss.SSSZ", token = /\[((?:[^\]\\]|\\]|\\)*)\]|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g, reverseToken = /(\[[^\]]*\])|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g, regexStore = {};
function getRegexData(mask, dateLocale) {
    const days = "(" + dateLocale.days.join("|") + ")", key = mask + days;
    if (regexStore[key] !== void 0) return regexStore[key];
    const daysShort = "(" + dateLocale.daysShort.join("|") + ")", months = "(" + dateLocale.months.join("|") + ")", monthsShort = "(" + dateLocale.monthsShort.join("|") + ")";
    const map = {};
    let index = 0;
    const regexText = mask.replace(reverseToken, (match)=>{
        index++;
        switch(match){
            case "YY":
                map.YY = index;
                return "(-?\\d{1,2})";
            case "YYYY":
                map.YYYY = index;
                return "(-?\\d{1,4})";
            case "M":
                map.M = index;
                return "(\\d{1,2})";
            case "Mo":
                map.M = index++;
                return "(\\d{1,2}(st|nd|rd|th))";
            case "MM":
                map.M = index;
                return "(\\d{2})";
            case "MMM":
                map.MMM = index;
                return monthsShort;
            case "MMMM":
                map.MMMM = index;
                return months;
            case "D":
                map.D = index;
                return "(\\d{1,2})";
            case "Do":
                map.D = index++;
                return "(\\d{1,2}(st|nd|rd|th))";
            case "DD":
                map.D = index;
                return "(\\d{2})";
            case "H":
                map.H = index;
                return "(\\d{1,2})";
            case "HH":
                map.H = index;
                return "(\\d{2})";
            case "h":
                map.h = index;
                return "(\\d{1,2})";
            case "hh":
                map.h = index;
                return "(\\d{2})";
            case "m":
                map.m = index;
                return "(\\d{1,2})";
            case "mm":
                map.m = index;
                return "(\\d{2})";
            case "s":
                map.s = index;
                return "(\\d{1,2})";
            case "ss":
                map.s = index;
                return "(\\d{2})";
            case "S":
                map.S = index;
                return "(\\d{1})";
            case "SS":
                map.S = index;
                return "(\\d{2})";
            case "SSS":
                map.S = index;
                return "(\\d{3})";
            case "A":
                map.A = index;
                return "(AM|PM)";
            case "a":
                map.a = index;
                return "(am|pm)";
            case "aa":
                map.aa = index;
                return "(a\\.m\\.|p\\.m\\.)";
            case "ddd":
                return daysShort;
            case "dddd":
                return days;
            case "Q":
            case "d":
            case "E":
                return "(\\d{1})";
            case "do":
                index++;
                return "(\\d{1}(st|nd|rd|th))";
            case "Qo":
                return "(1st|2nd|3rd|4th)";
            case "DDD":
            case "DDDD":
                return "(\\d{1,3})";
            case "DDDo":
                index++;
                return "(\\d{1,3}(st|nd|rd|th))";
            case "w":
                return "(\\d{1,2})";
            case "wo":
                index++;
                return "(\\d{1,2}(st|nd|rd|th))";
            case "ww":
                return "(\\d{2})";
            case "Z":
                map.Z = index;
                return "(Z|[+-]\\d{2}:\\d{2})";
            case "ZZ":
                map.ZZ = index;
                return "(Z|[+-]\\d{2}\\d{2})";
            case "X":
                map.X = index;
                return "(-?\\d+)";
            case "x":
                map.x = index;
                return "(-?\\d{4,})";
            default:
                index--;
                if (match[0] === "[") match = match.substring(1, match.length - 1);
                return match.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
    });
    const res = {
        map,
        regex: new RegExp("^" + regexText)
    };
    regexStore[key] = res;
    return res;
}
function getDateLocale(paramDateLocale, langProps) {
    return paramDateLocale !== void 0 ? paramDateLocale : langProps !== void 0 ? langProps.date : en_US_default.date;
}
function formatTimezone(offset, delimeter = "") {
    const sign = offset > 0 ? "-" : "+", absOffset = Math.abs(offset), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
    return sign + pad(hours) + delimeter + pad(minutes);
}
function applyYearMonthDayChange(date, mod, sign) {
    let year = date.getFullYear(), month = date.getMonth();
    const day = date.getDate();
    if (mod.year !== void 0) {
        year += sign * mod.year;
        delete mod.year;
    }
    if (mod.month !== void 0) {
        month += sign * mod.month;
        delete mod.month;
    }
    date.setDate(1);
    date.setMonth(2);
    date.setFullYear(year);
    date.setMonth(month);
    date.setDate(Math.min(day, daysInMonth(date)));
    if (mod.date !== void 0) {
        date.setDate(date.getDate() + sign * mod.date);
        delete mod.date;
    }
    return date;
}
function applyYearMonthDay(date, mod, middle) {
    const year = mod.year !== void 0 ? mod.year : date[`get${middle}FullYear`](), month = mod.month !== void 0 ? mod.month - 1 : date[`get${middle}Month`](), maxDay = new Date(year, month + 1, 0).getDate(), day = Math.min(maxDay, mod.date !== void 0 ? mod.date : date[`get${middle}Date`]());
    date[`set${middle}Date`](1);
    date[`set${middle}Month`](2);
    date[`set${middle}FullYear`](year);
    date[`set${middle}Month`](month);
    date[`set${middle}Date`](day);
    delete mod.year;
    delete mod.month;
    delete mod.date;
    return date;
}
function getChange(date, rawMod, sign) {
    const mod = normalizeMod(rawMod), d = new Date(date), t = mod.year !== void 0 || mod.month !== void 0 || mod.date !== void 0 ? applyYearMonthDayChange(d, mod, sign) : d;
    for(const key in mod){
        const op = capitalize(key);
        t[`set${op}`](t[`get${op}`]() + sign * mod[key]);
    }
    return t;
}
function normalizeMod(mod) {
    const acc = {
        ...mod
    };
    if (mod.years !== void 0) {
        acc.year = mod.years;
        delete acc.years;
    }
    if (mod.months !== void 0) {
        acc.month = mod.months;
        delete acc.months;
    }
    if (mod.days !== void 0) {
        acc.date = mod.days;
        delete acc.days;
    }
    if (mod.day !== void 0) {
        acc.date = mod.day;
        delete acc.day;
    }
    if (mod.hour !== void 0) {
        acc.hours = mod.hour;
        delete acc.hour;
    }
    if (mod.minute !== void 0) {
        acc.minutes = mod.minute;
        delete acc.minute;
    }
    if (mod.second !== void 0) {
        acc.seconds = mod.second;
        delete acc.second;
    }
    if (mod.millisecond !== void 0) {
        acc.milliseconds = mod.millisecond;
        delete acc.millisecond;
    }
    return acc;
}
function adjustDate(date, rawMod, utc) {
    const mod = normalizeMod(rawMod), middle = utc === true ? "UTC" : "", d = new Date(date), t = mod.year !== void 0 || mod.month !== void 0 || mod.date !== void 0 ? applyYearMonthDay(d, mod, middle) : d;
    for(const key in mod)t[`set${middle}${key.charAt(0).toUpperCase() + key.slice(1)}`](mod[key]);
    return t;
}
function extractDate(str, mask, dateLocale) {
    const d = __splitDate(str, mask, dateLocale);
    const date = new Date(d.year, d.month === null ? null : d.month - 1, d.day === null ? 1 : d.day, d.hour, d.minute, d.second, d.millisecond);
    const tzOffset = date.getTimezoneOffset();
    return d.timezoneOffset === null || d.timezoneOffset === tzOffset ? date : getChange(date, {
        minutes: d.timezoneOffset - tzOffset
    }, 1);
}
function __splitDate(str, mask, dateLocale, calendar, defaultModel) {
    const date = {
        year: null,
        month: null,
        day: null,
        hour: null,
        minute: null,
        second: null,
        millisecond: null,
        timezoneOffset: null,
        dateHash: null,
        timeHash: null
    };
    if (defaultModel !== void 0) Object.assign(date, defaultModel);
    if (str === void 0 || str === null || str === "" || typeof str !== "string") return date;
    if (mask === void 0) mask = defaultMask;
    const langOpts = getDateLocale(dateLocale, Plugin$5.props), months = langOpts.months, monthsShort = langOpts.monthsShort;
    const { regex, map } = getRegexData(mask, langOpts);
    const match = str.match(regex);
    if (match === null) return date;
    let tzString = "";
    if (map.X !== void 0 || map.x !== void 0) {
        const stamp = parseInt(match[map.X !== void 0 ? map.X : map.x], 10);
        if (isNaN(stamp) === true || stamp < 0) return date;
        const d = /* @__PURE__ */ new Date(stamp * (map.X !== void 0 ? 1e3 : 1));
        date.year = d.getFullYear();
        date.month = d.getMonth() + 1;
        date.day = d.getDate();
        date.hour = d.getHours();
        date.minute = d.getMinutes();
        date.second = d.getSeconds();
        date.millisecond = d.getMilliseconds();
    } else {
        if (map.YYYY !== void 0) date.year = parseInt(match[map.YYYY], 10);
        else if (map.YY !== void 0) {
            const y = parseInt(match[map.YY], 10);
            date.year = y < 0 ? y : 2e3 + y;
        }
        if (map.M !== void 0) {
            date.month = parseInt(match[map.M], 10);
            if (date.month < 1 || date.month > 12) return date;
        } else if (map.MMM !== void 0) date.month = monthsShort.indexOf(match[map.MMM]) + 1;
        else if (map.MMMM !== void 0) date.month = months.indexOf(match[map.MMMM]) + 1;
        if (map.D !== void 0) {
            date.day = parseInt(match[map.D], 10);
            if (date.year === null || date.month === null || date.day < 1) return date;
            const maxDay = calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
            if (date.day > maxDay) return date;
        }
        if (map.H !== void 0) date.hour = parseInt(match[map.H], 10) % 24;
        else if (map.h !== void 0) {
            date.hour = parseInt(match[map.h], 10) % 12;
            if (map.A && match[map.A] === "PM" || map.a && match[map.a] === "pm" || map.aa && match[map.aa] === "p.m.") date.hour += 12;
            date.hour = date.hour % 24;
        }
        if (map.m !== void 0) date.minute = parseInt(match[map.m], 10) % 60;
        if (map.s !== void 0) date.second = parseInt(match[map.s], 10) % 60;
        if (map.S !== void 0) date.millisecond = parseInt(match[map.S], 10) * 10 ** (3 - match[map.S].length);
        if (map.Z !== void 0 || map.ZZ !== void 0) {
            tzString = map.Z !== void 0 ? match[map.Z].replace(":", "") : match[map.ZZ];
            date.timezoneOffset = (tzString[0] === "+" ? -1 : 1) * (60 * tzString.slice(1, 3) + Number(tzString.slice(3, 5)));
        }
    }
    date.dateHash = pad(date.year, 4) + "/" + pad(date.month) + "/" + pad(date.day);
    date.timeHash = pad(date.hour) + ":" + pad(date.minute) + ":" + pad(date.second) + tzString;
    return date;
}
function isValid(date) {
    return typeof date === "number" ? true : isNaN(Date.parse(date)) === false;
}
function buildDate(mod, utc) {
    return adjustDate(/* @__PURE__ */ new Date(), mod, utc);
}
function getDayOfWeek(date) {
    const dow = new Date(date).getDay();
    return dow === 0 ? 7 : dow;
}
function getWeekOfYear(date) {
    const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    thursday.setDate(thursday.getDate() - (thursday.getDay() + 6) % 7 + 3);
    const firstThursday = new Date(thursday.getFullYear(), 0, 4);
    firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
    const ds = thursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
    thursday.setHours(thursday.getHours() - ds);
    const weekDiff = (thursday - firstThursday) / (MILLISECONDS_IN_DAY * 7);
    return 1 + Math.floor(weekDiff);
}
function getDayIdentifier(date) {
    return date.getFullYear() * 1e4 + date.getMonth() * 100 + date.getDate();
}
function getDateIdentifier(date, onlyDate) {
    const d = new Date(date);
    return onlyDate === true ? getDayIdentifier(d) : d.getTime();
}
function isBetweenDates(date, from, to, opts = {}) {
    const d1 = getDateIdentifier(from, opts.onlyDate), d2 = getDateIdentifier(to, opts.onlyDate), cur = getDateIdentifier(date, opts.onlyDate);
    return (cur > d1 || opts.inclusiveFrom === true && cur === d1) && (cur < d2 || opts.inclusiveTo === true && cur === d2);
}
function addToDate(date, mod) {
    return getChange(date, mod, 1);
}
function subtractFromDate(date, mod) {
    return getChange(date, mod, -1);
}
function startOfDate(date, unit, utc) {
    const t = new Date(date), prefix = `set${utc === true ? "UTC" : ""}`;
    switch(unit){
        case "year":
        case "years":
            t[`${prefix}Month`](0);
        case "month":
        case "months":
            t[`${prefix}Date`](1);
        case "day":
        case "days":
        case "date":
            t[`${prefix}Hours`](0);
        case "hour":
        case "hours":
            t[`${prefix}Minutes`](0);
        case "minute":
        case "minutes":
            t[`${prefix}Seconds`](0);
        case "second":
        case "seconds":
            t[`${prefix}Milliseconds`](0);
    }
    return t;
}
function endOfDate(date, unit, utc) {
    const t = new Date(date), prefix = `set${utc === true ? "UTC" : ""}`;
    switch(unit){
        case "year":
        case "years":
            t[`${prefix}Month`](11);
        case "month":
        case "months":
            t[`${prefix}Date`](daysInMonth(t));
        case "day":
        case "days":
        case "date":
            t[`${prefix}Hours`](23);
        case "hour":
        case "hours":
            t[`${prefix}Minutes`](59);
        case "minute":
        case "minutes":
            t[`${prefix}Seconds`](59);
        case "second":
        case "seconds":
            t[`${prefix}Milliseconds`](999);
    }
    return t;
}
function getMaxDate(date) {
    let t = new Date(date);
    Array.prototype.slice.call(arguments, 1).forEach((d)=>{
        t = Math.max(t, new Date(d));
    });
    return new Date(t);
}
function getMinDate(date) {
    let t = new Date(date);
    Array.prototype.slice.call(arguments, 1).forEach((d)=>{
        t = Math.min(t, new Date(d));
    });
    return new Date(t);
}
function getDiff(t, sub, interval) {
    return (t.getTime() - t.getTimezoneOffset() * MILLISECONDS_IN_MINUTE - (sub.getTime() - sub.getTimezoneOffset() * MILLISECONDS_IN_MINUTE)) / interval;
}
function getDateDiff(date, subtract, unit = "days") {
    const t = new Date(date), sub = new Date(subtract);
    switch(unit){
        case "years":
        case "year":
            return t.getFullYear() - sub.getFullYear();
        case "months":
        case "month":
            return (t.getFullYear() - sub.getFullYear()) * 12 + t.getMonth() - sub.getMonth();
        case "days":
        case "day":
        case "date":
            return getDiff(startOfDate(t, "day"), startOfDate(sub, "day"), MILLISECONDS_IN_DAY);
        case "hours":
        case "hour":
            return getDiff(startOfDate(t, "hour"), startOfDate(sub, "hour"), MILLISECONDS_IN_HOUR);
        case "minutes":
        case "minute":
            return getDiff(startOfDate(t, "minute"), startOfDate(sub, "minute"), MILLISECONDS_IN_MINUTE);
        case "seconds":
        case "second":
            return getDiff(startOfDate(t, "second"), startOfDate(sub, "second"), 1e3);
    }
}
function getDayOfYear(date) {
    return getDateDiff(date, startOfDate(date, "year"), "days") + 1;
}
function inferDateFormat(date) {
    return isDate(date) === true ? "date" : typeof date === "number" ? "number" : "string";
}
function getDateBetween(date, min, max) {
    const t = new Date(date);
    if (min) {
        const low = new Date(min);
        if (t < low) return low;
    }
    if (max) {
        const high = new Date(max);
        if (t > high) return high;
    }
    return t;
}
function isSameDate(date, date2, unit) {
    const t = new Date(date), d = new Date(date2);
    if (unit === void 0) return t.getTime() === d.getTime();
    switch(unit){
        case "second":
        case "seconds":
            if (t.getSeconds() !== d.getSeconds()) return false;
        case "minute":
        case "minutes":
            if (t.getMinutes() !== d.getMinutes()) return false;
        case "hour":
        case "hours":
            if (t.getHours() !== d.getHours()) return false;
        case "day":
        case "days":
        case "date":
            if (t.getDate() !== d.getDate()) return false;
        case "month":
        case "months":
            if (t.getMonth() !== d.getMonth()) return false;
        case "year":
        case "years":
            if (t.getFullYear() !== d.getFullYear()) return false;
            break;
        default:
            throw new Error(`date isSameDate unknown unit ${unit}`);
    }
    return true;
}
function daysInMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
function getOrdinal(n) {
    if (n >= 11 && n <= 13) return `${n}th`;
    switch(n % 10){
        case 1:
            return `${n}st`;
        case 2:
            return `${n}nd`;
        case 3:
            return `${n}rd`;
    }
    return `${n}th`;
}
const formatter = {
    YY (date, dateLocale, forcedYear) {
        const y = this.YYYY(date, dateLocale, forcedYear) % 100;
        return y >= 0 ? pad(y) : "-" + pad(Math.abs(y));
    },
    YYYY (date, _dateLocale, forcedYear) {
        return forcedYear !== void 0 && forcedYear !== null ? forcedYear : date.getFullYear();
    },
    M (date) {
        return date.getMonth() + 1;
    },
    Mo (date) {
        return getOrdinal(date.getMonth() + 1);
    },
    MM (date) {
        return pad(date.getMonth() + 1);
    },
    MMM (date, dateLocale) {
        return dateLocale.monthsShort[date.getMonth()];
    },
    MMMM (date, dateLocale) {
        return dateLocale.months[date.getMonth()];
    },
    Q (date) {
        return Math.ceil((date.getMonth() + 1) / 3);
    },
    Qo (date) {
        return getOrdinal(this.Q(date));
    },
    D (date) {
        return date.getDate();
    },
    Do (date) {
        return getOrdinal(date.getDate());
    },
    DD (date) {
        return pad(date.getDate());
    },
    DDD (date) {
        return getDayOfYear(date);
    },
    DDDo (date) {
        return getOrdinal(getDayOfYear(date));
    },
    DDDD (date) {
        return pad(getDayOfYear(date), 3);
    },
    d (date) {
        return date.getDay();
    },
    do (date) {
        return getOrdinal(date.getDay());
    },
    dd (date, dateLocale) {
        return dateLocale.days[date.getDay()].slice(0, 2);
    },
    ddd (date, dateLocale) {
        return dateLocale.daysShort[date.getDay()];
    },
    dddd (date, dateLocale) {
        return dateLocale.days[date.getDay()];
    },
    E (date) {
        return date.getDay() || 7;
    },
    w (date) {
        return getWeekOfYear(date);
    },
    wo (date) {
        return getOrdinal(getWeekOfYear(date));
    },
    ww (date) {
        return pad(getWeekOfYear(date));
    },
    H (date) {
        return date.getHours();
    },
    HH (date) {
        return pad(date.getHours());
    },
    h (date) {
        const hours = date.getHours();
        return hours === 0 ? 12 : hours > 12 ? hours % 12 : hours;
    },
    hh (date) {
        return pad(this.h(date));
    },
    m (date) {
        return date.getMinutes();
    },
    mm (date) {
        return pad(date.getMinutes());
    },
    s (date) {
        return date.getSeconds();
    },
    ss (date) {
        return pad(date.getSeconds());
    },
    S (date) {
        return Math.floor(date.getMilliseconds() / 100);
    },
    SS (date) {
        return pad(Math.floor(date.getMilliseconds() / 10));
    },
    SSS (date) {
        return pad(date.getMilliseconds(), 3);
    },
    A (date) {
        return date.getHours() < 12 ? "AM" : "PM";
    },
    a (date) {
        return date.getHours() < 12 ? "am" : "pm";
    },
    aa (date) {
        return date.getHours() < 12 ? "a.m." : "p.m.";
    },
    Z (date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
        return formatTimezone(forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset, ":");
    },
    ZZ (date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
        return formatTimezone(forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset);
    },
    X (date) {
        return Math.floor(date.getTime() / 1e3);
    },
    x (date) {
        return date.getTime();
    }
};
function formatDate(val, mask, dateLocale, __forcedYear, __forcedTimezoneOffset) {
    if (val !== 0 && !val || val === Infinity || val === -Infinity) return;
    const date = new Date(val);
    if (isNaN(date)) return;
    if (mask === void 0) mask = defaultMask;
    const locale = getDateLocale(dateLocale, Plugin$5.props);
    return mask.replace(token, (match, text)=>match in formatter ? formatter[match](date, locale, __forcedYear, __forcedTimezoneOffset) : text === void 0 ? match : text.split("\\]").join("]"));
}
function clone(date) {
    return isDate(date) === true ? new Date(date.getTime()) : date;
}
var date_default = {
    isValid,
    extractDate,
    buildDate,
    getDayOfWeek,
    getWeekOfYear,
    isBetweenDates,
    addToDate,
    subtractFromDate,
    adjustDate,
    startOfDate,
    endOfDate,
    getMaxDate,
    getMinDate,
    getDateDiff,
    getDayOfYear,
    inferDateFormat,
    getDateBetween,
    isSameDate,
    daysInMonth,
    formatDate,
    clone
};
//#endregion
//#region src/components/date/QDate.js
const yearsInterval = 20;
const views = [
    "Calendar",
    "Years",
    "Months"
];
const viewIsValid = (v)=>views.includes(v);
const yearMonthValidator = (v)=>/^-?[\d]+\/[0-1]\d$/.test(v);
const lineStr = " \u2014 ";
function getMonthHash(date) {
    return date.year + "/" + pad(date.month);
}
var QDate_default = createComponent({
    name: "QDate",
    props: {
        ...useDatetimeProps,
        ...useFormProps,
        ...useDarkProps,
        modelValue: {
            required: true,
            validator: (val)=>typeof val === "string" || Array.isArray(val) === true || Object(val) === val || val === null
        },
        multiple: Boolean,
        range: Boolean,
        title: String,
        subtitle: String,
        mask: {
            ...useDatetimeProps.mask,
            default: "YYYY/MM/DD"
        },
        defaultYearMonth: {
            type: String,
            validator: yearMonthValidator
        },
        yearsInMonthView: Boolean,
        events: [
            Array,
            Function
        ],
        eventColor: [
            String,
            Function
        ],
        emitImmediately: Boolean,
        options: [
            Array,
            Function
        ],
        navigationMinYearMonth: {
            type: String,
            validator: yearMonthValidator
        },
        navigationMaxYearMonth: {
            type: String,
            validator: yearMonthValidator
        },
        noUnset: Boolean,
        firstDayOfWeek: [
            String,
            Number
        ],
        todayBtn: Boolean,
        minimal: Boolean,
        defaultView: {
            type: String,
            default: "Calendar",
            validator: viewIsValid
        }
    },
    emits: [
        ...useDatetimeEmits,
        "rangeStart",
        "rangeEnd",
        "navigation"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const { getCache } = useRenderCache();
        const { tabindex, headerClass, getLocale, getCurrentDate } = useDatetime(props, $q);
        let lastEmitValue;
        const injectFormInput = useFormInject(useFormAttrs(props));
        const blurTargetRef = (0, _vue.ref)(null);
        const innerMask = (0, _vue.ref)(getMask());
        const innerLocale = (0, _vue.ref)(getLocale());
        const mask = (0, _vue.computed)(()=>getMask());
        const locale = (0, _vue.computed)(()=>getLocale());
        const today = (0, _vue.computed)(()=>getCurrentDate());
        const viewModel = (0, _vue.ref)(getViewModel(innerMask.value, innerLocale.value));
        const view = (0, _vue.ref)(props.defaultView);
        const direction = (0, _vue.computed)(()=>$q.lang.rtl === true ? "right" : "left");
        const monthDirection = (0, _vue.ref)(direction.value);
        const yearDirection = (0, _vue.ref)(direction.value);
        const localYear = viewModel.value.year;
        const startYear = (0, _vue.ref)(localYear - localYear % yearsInterval - (localYear < 0 ? yearsInterval : 0));
        const editRange = (0, _vue.ref)(null);
        const classes = (0, _vue.computed)(()=>{
            const type = props.landscape === true ? "landscape" : "portrait";
            return `q-date q-date--${type} q-date--${type}-${props.minimal === true ? "minimal" : "standard"}` + (isDark.value === true ? " q-date--dark q-dark" : "") + (props.bordered === true ? " q-date--bordered" : "") + (props.square === true ? " q-date--square no-border-radius" : "") + (props.flat === true ? " q-date--flat no-shadow" : "") + (props.disable === true ? " disabled" : props.readonly === true ? " q-date--readonly" : "");
        });
        const computedColor = (0, _vue.computed)(()=>props.color || "primary");
        const computedTextColor = (0, _vue.computed)(()=>props.textColor || "white");
        const isImmediate = (0, _vue.computed)(()=>props.emitImmediately === true && props.multiple !== true && props.range !== true);
        const normalizedModel = (0, _vue.computed)(()=>Array.isArray(props.modelValue) === true ? props.modelValue : props.modelValue !== null && props.modelValue !== void 0 ? [
                props.modelValue
            ] : []);
        const daysModel = (0, _vue.computed)(()=>normalizedModel.value.filter((date)=>typeof date === "string").map((date)=>decodeString(date, innerMask.value, innerLocale.value)).filter((date)=>date.dateHash !== null && date.day !== null && date.month !== null && date.year !== null));
        const rangeModel = (0, _vue.computed)(()=>{
            const fn = (date)=>decodeString(date, innerMask.value, innerLocale.value);
            return normalizedModel.value.filter((date)=>isObject(date) === true && date.from !== void 0 && date.to !== void 0).map((range)=>({
                    from: fn(range.from),
                    to: fn(range.to)
                })).filter((range)=>range.from.dateHash !== null && range.to.dateHash !== null && range.from.dateHash < range.to.dateHash);
        });
        const getNativeDateFn = (0, _vue.computed)(()=>props.calendar !== "persian" ? (model)=>new Date(model.year, model.month - 1, model.day) : (model)=>{
                const gDate = toGregorian(model.year, model.month, model.day);
                return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
            });
        const encodeObjectFn = (0, _vue.computed)(()=>props.calendar === "persian" ? getDayHash : (date, dateMask, dateLocale)=>formatDate(new Date(date.year, date.month - 1, date.day, date.hour, date.minute, date.second, date.millisecond), dateMask === void 0 ? innerMask.value : dateMask, dateLocale === void 0 ? innerLocale.value : dateLocale, date.year, date.timezoneOffset));
        const daysInModel = (0, _vue.computed)(()=>daysModel.value.length + rangeModel.value.reduce((acc, range)=>acc + 1 + getDateDiff(getNativeDateFn.value(range.to), getNativeDateFn.value(range.from)), 0));
        const headerTitle = (0, _vue.computed)(()=>{
            if (props.title !== void 0 && props.title !== null && props.title.length !== 0) return props.title;
            if (editRange.value !== null) {
                const model = editRange.value.init;
                const date = getNativeDateFn.value(model);
                return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day + lineStr + "?";
            }
            if (daysInModel.value === 0) return lineStr;
            if (daysInModel.value > 1) return `${daysInModel.value} ${innerLocale.value.pluralDay}`;
            const model = daysModel.value[0];
            const date = getNativeDateFn.value(model);
            if (isNaN(date.valueOf()) === true) return lineStr;
            if (innerLocale.value.headerTitle !== void 0) return innerLocale.value.headerTitle(date, model);
            return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day;
        });
        const minSelectedModel = (0, _vue.computed)(()=>{
            return daysModel.value.concat(rangeModel.value.map((range)=>range.from)).sort((a, b)=>a.year - b.year || a.month - b.month)[0];
        });
        const maxSelectedModel = (0, _vue.computed)(()=>{
            return daysModel.value.concat(rangeModel.value.map((range)=>range.to)).sort((a, b)=>b.year - a.year || b.month - a.month)[0];
        });
        const headerSubtitle = (0, _vue.computed)(()=>{
            if (props.subtitle !== void 0 && props.subtitle !== null && props.subtitle.length !== 0) return props.subtitle;
            if (daysInModel.value === 0) return lineStr;
            if (daysInModel.value > 1) {
                const from = minSelectedModel.value;
                const to = maxSelectedModel.value;
                const month = innerLocale.value.monthsShort;
                return month[from.month - 1] + (from.year !== to.year ? " " + from.year + lineStr + month[to.month - 1] + " " : from.month !== to.month ? lineStr + month[to.month - 1] : "") + " " + to.year;
            }
            return daysModel.value[0].year;
        });
        const dateArrow = (0, _vue.computed)(()=>{
            const val = [
                $q.iconSet.datetime.arrowLeft,
                $q.iconSet.datetime.arrowRight
            ];
            return $q.lang.rtl === true ? val.reverse() : val;
        });
        const computedFirstDayOfWeek = (0, _vue.computed)(()=>props.firstDayOfWeek !== void 0 ? Number(props.firstDayOfWeek) : innerLocale.value.firstDayOfWeek);
        const daysOfWeek = (0, _vue.computed)(()=>{
            const days = innerLocale.value.daysShort, first = computedFirstDayOfWeek.value;
            return first > 0 ? days.slice(first, 7).concat(days.slice(0, first)) : days;
        });
        const daysInMonth = (0, _vue.computed)(()=>{
            const date = viewModel.value;
            return props.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
        });
        const evtColor = (0, _vue.computed)(()=>typeof props.eventColor === "function" ? props.eventColor : ()=>props.eventColor);
        const minNav = (0, _vue.computed)(()=>{
            if (props.navigationMinYearMonth === void 0) return null;
            const data = props.navigationMinYearMonth.split("/");
            return {
                year: parseInt(data[0], 10),
                month: parseInt(data[1], 10)
            };
        });
        const maxNav = (0, _vue.computed)(()=>{
            if (props.navigationMaxYearMonth === void 0) return null;
            const data = props.navigationMaxYearMonth.split("/");
            return {
                year: parseInt(data[0], 10),
                month: parseInt(data[1], 10)
            };
        });
        const navBoundaries = (0, _vue.computed)(()=>{
            const data = {
                month: {
                    prev: true,
                    next: true
                },
                year: {
                    prev: true,
                    next: true
                }
            };
            if (minNav.value !== null && minNav.value.year >= viewModel.value.year) {
                data.year.prev = false;
                if (minNav.value.year === viewModel.value.year && minNav.value.month >= viewModel.value.month) data.month.prev = false;
            }
            if (maxNav.value !== null && maxNav.value.year <= viewModel.value.year) {
                data.year.next = false;
                if (maxNav.value.year === viewModel.value.year && maxNav.value.month <= viewModel.value.month) data.month.next = false;
            }
            return data;
        });
        const daysMap = (0, _vue.computed)(()=>{
            const map = {};
            daysModel.value.forEach((entry)=>{
                const hash = getMonthHash(entry);
                if (map[hash] === void 0) map[hash] = [];
                map[hash].push(entry.day);
            });
            return map;
        });
        const rangeMap = (0, _vue.computed)(()=>{
            const map = {};
            rangeModel.value.forEach((entry)=>{
                const hashFrom = getMonthHash(entry.from);
                const hashTo = getMonthHash(entry.to);
                if (map[hashFrom] === void 0) map[hashFrom] = [];
                map[hashFrom].push({
                    from: entry.from.day,
                    to: hashFrom === hashTo ? entry.to.day : void 0,
                    range: entry
                });
                if (hashFrom < hashTo) {
                    let hash;
                    const { year, month } = entry.from;
                    const cur = month < 12 ? {
                        year,
                        month: month + 1
                    } : {
                        year: year + 1,
                        month: 1
                    };
                    while((hash = getMonthHash(cur)) <= hashTo){
                        if (map[hash] === void 0) map[hash] = [];
                        map[hash].push({
                            from: void 0,
                            to: hash === hashTo ? entry.to.day : void 0,
                            range: entry
                        });
                        cur.month++;
                        if (cur.month > 12) {
                            cur.year++;
                            cur.month = 1;
                        }
                    }
                }
            });
            return map;
        });
        const rangeView = (0, _vue.computed)(()=>{
            if (editRange.value === null) return;
            const { init, initHash, final, finalHash } = editRange.value;
            const [from, to] = initHash <= finalHash ? [
                init,
                final
            ] : [
                final,
                init
            ];
            const fromHash = getMonthHash(from);
            const toHash = getMonthHash(to);
            if (fromHash !== viewMonthHash.value && toHash !== viewMonthHash.value) return;
            const localView = {};
            if (fromHash === viewMonthHash.value) {
                localView.from = from.day;
                localView.includeFrom = true;
            } else localView.from = 1;
            if (toHash === viewMonthHash.value) {
                localView.to = to.day;
                localView.includeTo = true;
            } else localView.to = daysInMonth.value;
            return localView;
        });
        const viewMonthHash = (0, _vue.computed)(()=>getMonthHash(viewModel.value));
        const selectionDaysMap = (0, _vue.computed)(()=>{
            const map = {};
            if (props.options === void 0) {
                for(let i = 1; i <= daysInMonth.value; i++)map[i] = true;
                return map;
            }
            const fn = typeof props.options === "function" ? props.options : (date)=>props.options.includes(date);
            for(let i = 1; i <= daysInMonth.value; i++)map[i] = fn(viewMonthHash.value + "/" + pad(i));
            return map;
        });
        const eventDaysMap = (0, _vue.computed)(()=>{
            const map = {};
            if (props.events === void 0) for(let i = 1; i <= daysInMonth.value; i++)map[i] = false;
            else {
                const fn = typeof props.events === "function" ? props.events : (date)=>props.events.includes(date);
                for(let i = 1; i <= daysInMonth.value; i++){
                    const dayHash = viewMonthHash.value + "/" + pad(i);
                    map[i] = fn(dayHash) === true && evtColor.value(dayHash);
                }
            }
            return map;
        });
        const viewDays = (0, _vue.computed)(()=>{
            let date, endDay;
            const { year, month } = viewModel.value;
            if (props.calendar !== "persian") {
                date = new Date(year, month - 1, 1);
                endDay = new Date(year, month - 1, 0).getDate();
            } else {
                const gDate = toGregorian(year, month, 1);
                date = new Date(gDate.gy, gDate.gm - 1, gDate.gd);
                let prevJM = month - 1;
                let prevJY = year;
                if (prevJM === 0) {
                    prevJM = 12;
                    prevJY--;
                }
                endDay = jalaaliMonthLength(prevJY, prevJM);
            }
            return {
                days: date.getDay() - computedFirstDayOfWeek.value - 1,
                endDay
            };
        });
        const days = (0, _vue.computed)(()=>{
            const res = [];
            const { days: localDays, endDay } = viewDays.value;
            const len = localDays < 0 ? localDays + 7 : localDays;
            if (len < 6) for(let i = endDay - len; i <= endDay; i++)res.push({
                i,
                fill: true
            });
            const index = res.length;
            for(let i = 1; i <= daysInMonth.value; i++){
                const day = {
                    i,
                    event: eventDaysMap.value[i],
                    classes: []
                };
                if (selectionDaysMap.value[i] === true) {
                    day.in = true;
                    day.flat = true;
                }
                res.push(day);
            }
            if (daysMap.value[viewMonthHash.value] !== void 0) daysMap.value[viewMonthHash.value].forEach((day)=>{
                const i = index + day - 1;
                Object.assign(res[i], {
                    selected: true,
                    unelevated: true,
                    flat: false,
                    color: computedColor.value,
                    textColor: computedTextColor.value
                });
            });
            if (rangeMap.value[viewMonthHash.value] !== void 0) rangeMap.value[viewMonthHash.value].forEach((entry)=>{
                if (entry.from !== void 0) {
                    const from = index + entry.from - 1;
                    const to = index + (entry.to || daysInMonth.value) - 1;
                    for(let day = from; day <= to; day++)Object.assign(res[day], {
                        range: entry.range,
                        unelevated: true,
                        color: computedColor.value,
                        textColor: computedTextColor.value
                    });
                    Object.assign(res[from], {
                        rangeFrom: true,
                        flat: false
                    });
                    if (entry.to !== void 0) Object.assign(res[to], {
                        rangeTo: true,
                        flat: false
                    });
                } else if (entry.to !== void 0) {
                    const to = index + entry.to - 1;
                    for(let day = index; day <= to; day++)Object.assign(res[day], {
                        range: entry.range,
                        unelevated: true,
                        color: computedColor.value,
                        textColor: computedTextColor.value
                    });
                    Object.assign(res[to], {
                        flat: false,
                        rangeTo: true
                    });
                } else {
                    const to = index + daysInMonth.value - 1;
                    for(let day = index; day <= to; day++)Object.assign(res[day], {
                        range: entry.range,
                        unelevated: true,
                        color: computedColor.value,
                        textColor: computedTextColor.value
                    });
                }
            });
            if (rangeView.value !== void 0) {
                const from = index + rangeView.value.from - 1;
                const to = index + rangeView.value.to - 1;
                for(let day = from; day <= to; day++){
                    res[day].color = computedColor.value;
                    res[day].editRange = true;
                }
                if (rangeView.value.includeFrom === true) res[from].editRangeFrom = true;
                if (rangeView.value.includeTo === true) res[to].editRangeTo = true;
            }
            if (viewModel.value.year === today.value.year && viewModel.value.month === today.value.month) res[index + today.value.day - 1].today = true;
            const left = res.length % 7;
            if (left > 0) {
                const afterDays = 7 - left;
                for(let i = 1; i <= afterDays; i++)res.push({
                    i,
                    fill: true
                });
            }
            res.forEach((day)=>{
                let cls = "q-date__calendar-item ";
                if (day.fill === true) cls += "q-date__calendar-item--fill";
                else {
                    cls += `q-date__calendar-item--${day.in === true ? "in" : "out"}`;
                    if (day.range !== void 0) cls += ` q-date__range${day.rangeTo === true ? "-to" : day.rangeFrom === true ? "-from" : ""}`;
                    if (day.editRange === true) cls += ` q-date__edit-range${day.editRangeFrom === true ? "-from" : ""}${day.editRangeTo === true ? "-to" : ""}`;
                    if (day.range !== void 0 || day.editRange === true) cls += ` text-${day.color}`;
                }
                day.classes = cls;
            });
            return res;
        });
        const attributes = (0, _vue.computed)(()=>props.disable === true ? {
                "aria-disabled": "true"
            } : {});
        (0, _vue.watch)(()=>props.modelValue, (v)=>{
            if (lastEmitValue === JSON.stringify(v)) lastEmitValue = 0;
            else {
                const model = getViewModel(innerMask.value, innerLocale.value);
                updateViewModel(model.year, model.month, model);
            }
        });
        (0, _vue.watch)(view, ()=>{
            if (blurTargetRef.value !== null && proxy.$el.contains(document.activeElement) === true) blurTargetRef.value.focus();
        });
        (0, _vue.watch)(()=>viewModel.value.year + "|" + viewModel.value.month, ()=>{
            emit("navigation", {
                year: viewModel.value.year,
                month: viewModel.value.month
            });
        });
        (0, _vue.watch)(mask, (val)=>{
            updateValue(val, innerLocale.value, "mask");
            innerMask.value = val;
        });
        (0, _vue.watch)(locale, (val)=>{
            updateValue(innerMask.value, val, "locale");
            innerLocale.value = val;
        });
        function setLastValue(v) {
            lastEmitValue = JSON.stringify(v);
        }
        function setToday() {
            const { year, month, day } = today.value;
            const date = {
                ...viewModel.value,
                year,
                month,
                day
            };
            const monthMap = daysMap.value[getMonthHash(date)];
            if (monthMap === void 0 || monthMap.includes(date.day) === false) addToModel(date);
            setCalendarTo(date.year, date.month);
        }
        function setView(viewMode) {
            if (viewIsValid(viewMode) === true) view.value = viewMode;
        }
        function offsetCalendar(type, descending) {
            if ([
                "month",
                "year"
            ].includes(type)) (type === "month" ? goToMonth : goToYear)(descending === true ? -1 : 1);
        }
        function setCalendarTo(year, month) {
            view.value = "Calendar";
            updateViewModel(year, month);
        }
        function setEditingRange(from, to) {
            if (props.range === false || !from) {
                editRange.value = null;
                return;
            }
            const init = Object.assign({
                ...viewModel.value
            }, from);
            const final = to !== void 0 ? Object.assign({
                ...viewModel.value
            }, to) : init;
            editRange.value = {
                init,
                initHash: getDayHash(init),
                final,
                finalHash: getDayHash(final)
            };
            setCalendarTo(init.year, init.month);
        }
        function getMask() {
            return props.calendar === "persian" ? "YYYY/MM/DD" : props.mask;
        }
        function decodeString(date, dateMask, dateLocale) {
            return __splitDate(date, dateMask, dateLocale, props.calendar, {
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            });
        }
        function getViewModel(dateMask, dateLocale) {
            const model = Array.isArray(props.modelValue) === true ? props.modelValue : props.modelValue ? [
                props.modelValue
            ] : [];
            if (model.length === 0) return getDefaultViewModel();
            const target = model[model.length - 1];
            const decoded = decodeString(target.from !== void 0 ? target.from : target, dateMask, dateLocale);
            return decoded.dateHash === null ? getDefaultViewModel() : decoded;
        }
        function getDefaultViewModel() {
            let year, month;
            if (props.defaultYearMonth !== void 0) {
                const d = props.defaultYearMonth.split("/");
                year = parseInt(d[0], 10);
                month = parseInt(d[1], 10);
            } else {
                const d = today.value !== void 0 ? today.value : getCurrentDate();
                year = d.year;
                month = d.month;
            }
            return {
                year,
                month,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                dateHash: year + "/" + pad(month) + "/01"
            };
        }
        function goToMonth(offset) {
            let year = viewModel.value.year;
            let month = Number(viewModel.value.month) + offset;
            if (month === 13) {
                month = 1;
                year++;
            } else if (month === 0) {
                month = 12;
                year--;
            }
            updateViewModel(year, month);
            if (isImmediate.value === true) emitImmediately("month");
        }
        function goToYear(offset) {
            updateViewModel(Number(viewModel.value.year) + offset, viewModel.value.month);
            if (isImmediate.value === true) emitImmediately("year");
        }
        function setYear(year) {
            updateViewModel(year, viewModel.value.month);
            view.value = props.defaultView === "Years" ? "Months" : "Calendar";
            if (isImmediate.value === true) emitImmediately("year");
        }
        function setMonth(month) {
            updateViewModel(viewModel.value.year, month);
            view.value = "Calendar";
            if (isImmediate.value === true) emitImmediately("month");
        }
        function toggleDate(date, monthHash) {
            (daysMap.value[monthHash]?.includes(date.day) === true ? removeFromModel : addToModel)(date);
        }
        function getShortDate(date) {
            return {
                year: date.year,
                month: date.month,
                day: date.day
            };
        }
        function updateViewModel(year, month, time) {
            if (minNav.value !== null && year <= minNav.value.year) {
                if (month < minNav.value.month || year < minNav.value.year) month = minNav.value.month;
                year = minNav.value.year;
            }
            if (maxNav.value !== null && year >= maxNav.value.year) {
                if (month > maxNav.value.month || year > maxNav.value.year) month = maxNav.value.month;
                year = maxNav.value.year;
            }
            if (time !== void 0) {
                const { hour, minute, second, millisecond, timezoneOffset, timeHash } = time;
                Object.assign(viewModel.value, {
                    hour,
                    minute,
                    second,
                    millisecond,
                    timezoneOffset,
                    timeHash
                });
            }
            const newHash = year + "/" + pad(month) + "/01";
            if (newHash !== viewModel.value.dateHash) {
                monthDirection.value = viewModel.value.dateHash < newHash === ($q.lang.rtl !== true) ? "left" : "right";
                if (year !== viewModel.value.year) yearDirection.value = monthDirection.value;
                (0, _vue.nextTick)(()=>{
                    startYear.value = year - year % yearsInterval - (year < 0 ? yearsInterval : 0);
                    Object.assign(viewModel.value, {
                        year,
                        month,
                        day: 1,
                        dateHash: newHash
                    });
                });
            }
        }
        function emitValue(val, action, date) {
            const value1 = val !== null && val.length === 1 && props.multiple === false ? val[0] : val;
            const { reason, details } = getEmitParams(action, date);
            setLastValue(value1);
            emit("update:modelValue", value1, reason, details);
        }
        function emitImmediately(reason) {
            const date = daysModel.value[0] !== void 0 && daysModel.value[0].dateHash !== null ? {
                ...daysModel.value[0]
            } : {
                ...viewModel.value
            };
            (0, _vue.nextTick)(()=>{
                date.year = viewModel.value.year;
                date.month = viewModel.value.month;
                const maxDay = props.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
                date.day = Math.min(Math.max(1, date.day), maxDay);
                const value1 = encodeEntry(date);
                const { details } = getEmitParams("", date);
                setLastValue(value1);
                emit("update:modelValue", value1, reason, details);
            });
        }
        function getEmitParams(action, date) {
            return date.from !== void 0 ? {
                reason: `${action}-range`,
                details: {
                    ...getShortDate(date.target),
                    from: getShortDate(date.from),
                    to: getShortDate(date.to)
                }
            } : {
                reason: `${action}-day`,
                details: getShortDate(date)
            };
        }
        function encodeEntry(date, dateMask, dateLocale) {
            return date.from !== void 0 ? {
                from: encodeObjectFn.value(date.from, dateMask, dateLocale),
                to: encodeObjectFn.value(date.to, dateMask, dateLocale)
            } : encodeObjectFn.value(date, dateMask, dateLocale);
        }
        function addToModel(date) {
            let value1;
            if (props.multiple === true) {
                if (date.from !== void 0) {
                    const fromHash = getDayHash(date.from);
                    const toHash = getDayHash(date.to);
                    const localDays = daysModel.value.filter((day)=>day.dateHash < fromHash || day.dateHash > toHash);
                    const ranges = rangeModel.value.filter(({ from, to })=>to.dateHash < fromHash || from.dateHash > toHash);
                    value1 = localDays.concat(ranges).concat(date).map((entry)=>encodeEntry(entry));
                } else {
                    const model = normalizedModel.value.slice();
                    model.push(encodeEntry(date));
                    value1 = model;
                }
            } else value1 = encodeEntry(date);
            emitValue(value1, "add", date);
        }
        function removeFromModel(date) {
            if (props.noUnset === true) return;
            let model = null;
            if (props.multiple === true && Array.isArray(props.modelValue) === true) {
                const val = encodeEntry(date);
                if (date.from !== void 0) model = props.modelValue.filter((item)=>item.from !== void 0 ? item.from !== val.from && item.to !== val.to : true);
                else model = props.modelValue.filter((item)=>item !== val);
                if (model.length === 0) model = null;
            }
            emitValue(model, "remove", date);
        }
        function updateValue(dateMask, dateLocale, reason) {
            const model = daysModel.value.concat(rangeModel.value).map((entry)=>encodeEntry(entry, dateMask, dateLocale)).filter((entry)=>entry.from !== void 0 ? entry.from.dateHash !== null && entry.to.dateHash !== null : entry.dateHash !== null);
            const value1 = (props.multiple === true ? model : model[0]) || null;
            setLastValue(value1);
            emit("update:modelValue", value1, reason);
        }
        function getHeader() {
            if (props.minimal === true) return;
            return (0, _vue.h)("div", {
                class: "q-date__header " + headerClass.value
            }, [
                (0, _vue.h)("div", {
                    class: "relative-position"
                }, [
                    (0, _vue.h)((0, _vue.Transition), {
                        name: "q-transition--fade"
                    }, ()=>(0, _vue.h)("div", {
                            key: "h-yr-" + headerSubtitle.value,
                            class: "q-date__header-subtitle q-date__header-link " + (view.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
                            tabindex: tabindex.value,
                            ...getCache("vY", {
                                onClick () {
                                    view.value = "Years";
                                },
                                onKeyup (e) {
                                    if (e.keyCode === 13) view.value = "Years";
                                }
                            })
                        }, [
                            headerSubtitle.value
                        ]))
                ]),
                (0, _vue.h)("div", {
                    class: "q-date__header-title relative-position flex no-wrap"
                }, [
                    (0, _vue.h)("div", {
                        class: "relative-position col"
                    }, [
                        (0, _vue.h)((0, _vue.Transition), {
                            name: "q-transition--fade"
                        }, ()=>(0, _vue.h)("div", {
                                key: "h-sub" + headerTitle.value,
                                class: "q-date__header-title-label q-date__header-link " + (view.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
                                tabindex: tabindex.value,
                                ...getCache("vC", {
                                    onClick () {
                                        view.value = "Calendar";
                                    },
                                    onKeyup (e) {
                                        if (e.keyCode === 13) view.value = "Calendar";
                                    }
                                })
                            }, [
                                headerTitle.value
                            ]))
                    ]),
                    props.todayBtn === true ? (0, _vue.h)(QBtn_default, {
                        class: "q-date__header-today self-start",
                        icon: $q.iconSet.datetime.today,
                        "aria-label": $q.lang.date.today,
                        flat: true,
                        size: "sm",
                        round: true,
                        tabindex: tabindex.value,
                        onClick: setToday
                    }) : null
                ])
            ]);
        }
        function getNavigation({ label, type, key, dir, goTo, boundaries, cls }) {
            return [
                (0, _vue.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, _vue.h)(QBtn_default, {
                        round: true,
                        dense: true,
                        size: "sm",
                        flat: true,
                        icon: dateArrow.value[0],
                        "aria-label": type === "Years" ? $q.lang.date.prevYear : $q.lang.date.prevMonth,
                        tabindex: tabindex.value,
                        disable: boundaries.prev === false,
                        ...getCache("go-#" + type, {
                            onClick () {
                                goTo(-1);
                            }
                        })
                    })
                ]),
                (0, _vue.h)("div", {
                    class: "relative-position overflow-hidden flex flex-center" + cls
                }, [
                    (0, _vue.h)((0, _vue.Transition), {
                        name: "q-transition--jump-" + dir
                    }, ()=>(0, _vue.h)("div", {
                            key
                        }, [
                            (0, _vue.h)(QBtn_default, {
                                flat: true,
                                dense: true,
                                noCaps: true,
                                label,
                                tabindex: tabindex.value,
                                ...getCache("view#" + type, {
                                    onClick: ()=>{
                                        view.value = type;
                                    }
                                })
                            })
                        ]))
                ]),
                (0, _vue.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, _vue.h)(QBtn_default, {
                        round: true,
                        dense: true,
                        size: "sm",
                        flat: true,
                        icon: dateArrow.value[1],
                        "aria-label": type === "Years" ? $q.lang.date.nextYear : $q.lang.date.nextMonth,
                        tabindex: tabindex.value,
                        disable: boundaries.next === false,
                        ...getCache("go+#" + type, {
                            onClick () {
                                goTo(1);
                            }
                        })
                    })
                ])
            ];
        }
        const renderViews = {
            Calendar: ()=>[
                    (0, _vue.h)("div", {
                        key: "calendar-view",
                        class: "q-date__view q-date__calendar"
                    }, [
                        (0, _vue.h)("div", {
                            class: "q-date__navigation row items-center no-wrap"
                        }, getNavigation({
                            label: innerLocale.value.months[viewModel.value.month - 1],
                            type: "Months",
                            key: viewModel.value.month,
                            dir: monthDirection.value,
                            goTo: goToMonth,
                            boundaries: navBoundaries.value.month,
                            cls: " col"
                        }).concat(getNavigation({
                            label: viewModel.value.year,
                            type: "Years",
                            key: viewModel.value.year,
                            dir: yearDirection.value,
                            goTo: goToYear,
                            boundaries: navBoundaries.value.year,
                            cls: ""
                        }))),
                        (0, _vue.h)("div", {
                            class: "q-date__calendar-weekdays row items-center no-wrap"
                        }, daysOfWeek.value.map((day)=>(0, _vue.h)("div", {
                                class: "q-date__calendar-item"
                            }, [
                                (0, _vue.h)("div", day)
                            ]))),
                        (0, _vue.h)("div", {
                            class: "q-date__calendar-days-container relative-position overflow-hidden"
                        }, [
                            (0, _vue.h)((0, _vue.Transition), {
                                name: "q-transition--slide-" + monthDirection.value
                            }, ()=>(0, _vue.h)("div", {
                                    key: viewMonthHash.value,
                                    class: "q-date__calendar-days fit"
                                }, days.value.map((day)=>(0, _vue.h)("div", {
                                        class: day.classes
                                    }, [
                                        day.in === true ? (0, _vue.h)(QBtn_default, {
                                            class: day.today === true ? "q-date__today" : "",
                                            dense: true,
                                            flat: day.flat,
                                            unelevated: day.unelevated,
                                            color: day.color,
                                            textColor: day.textColor,
                                            label: day.i,
                                            tabindex: tabindex.value,
                                            ...getCache("day#" + day.i, {
                                                onClick: ()=>{
                                                    onDayClick(day.i);
                                                },
                                                onMouseover: ()=>{
                                                    onDayMouseover(day.i);
                                                }
                                            })
                                        }, day.event !== false ? ()=>(0, _vue.h)("div", {
                                                class: "q-date__event bg-" + day.event
                                            }) : null) : (0, _vue.h)("div", String(day.i))
                                    ]))))
                        ])
                    ])
                ],
            Months () {
                const currentYear = viewModel.value.year === today.value.year;
                const isDisabled = (month)=>minNav.value !== null && viewModel.value.year === minNav.value.year && minNav.value.month > month || maxNav.value !== null && viewModel.value.year === maxNav.value.year && maxNav.value.month < month;
                const content = innerLocale.value.monthsShort.map((month, i)=>{
                    const active = viewModel.value.month === i + 1;
                    return (0, _vue.h)("div", {
                        class: "q-date__months-item flex flex-center"
                    }, [
                        (0, _vue.h)(QBtn_default, {
                            class: currentYear === true && today.value.month === i + 1 ? "q-date__today" : null,
                            flat: active !== true,
                            label: month,
                            unelevated: active,
                            color: active === true ? computedColor.value : null,
                            textColor: active === true ? computedTextColor.value : null,
                            tabindex: tabindex.value,
                            disable: isDisabled(i + 1),
                            ...getCache("month#" + i, {
                                onClick: ()=>{
                                    setMonth(i + 1);
                                }
                            })
                        })
                    ]);
                });
                if (props.yearsInMonthView === true) content.unshift((0, _vue.h)("div", {
                    class: "row no-wrap full-width"
                }, [
                    getNavigation({
                        label: viewModel.value.year,
                        type: "Years",
                        key: viewModel.value.year,
                        dir: yearDirection.value,
                        goTo: goToYear,
                        boundaries: navBoundaries.value.year,
                        cls: " col"
                    })
                ]));
                return (0, _vue.h)("div", {
                    key: "months-view",
                    class: "q-date__view q-date__months flex flex-center"
                }, content);
            },
            Years () {
                const start = startYear.value, stop = start + yearsInterval, years = [];
                const isDisabled = (year)=>minNav.value !== null && minNav.value.year > year || maxNav.value !== null && maxNav.value.year < year;
                for(let i = start; i <= stop; i++){
                    const active = viewModel.value.year === i;
                    years.push((0, _vue.h)("div", {
                        class: "q-date__years-item flex flex-center"
                    }, [
                        (0, _vue.h)(QBtn_default, {
                            key: "yr" + i,
                            class: today.value.year === i ? "q-date__today" : null,
                            flat: !active,
                            label: i,
                            dense: true,
                            unelevated: active,
                            color: active === true ? computedColor.value : null,
                            textColor: active === true ? computedTextColor.value : null,
                            tabindex: tabindex.value,
                            disable: isDisabled(i),
                            ...getCache("yr#" + i, {
                                onClick: ()=>{
                                    setYear(i);
                                }
                            })
                        })
                    ]));
                }
                return (0, _vue.h)("div", {
                    class: "q-date__view q-date__years flex flex-center"
                }, [
                    (0, _vue.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, _vue.h)(QBtn_default, {
                            round: true,
                            dense: true,
                            flat: true,
                            icon: dateArrow.value[0],
                            "aria-label": $q.lang.date.prevRangeYears(yearsInterval),
                            tabindex: tabindex.value,
                            disable: isDisabled(start),
                            ...getCache("y-", {
                                onClick: ()=>{
                                    startYear.value -= yearsInterval;
                                }
                            })
                        })
                    ]),
                    (0, _vue.h)("div", {
                        class: "q-date__years-content col self-stretch row items-center"
                    }, years),
                    (0, _vue.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, _vue.h)(QBtn_default, {
                            round: true,
                            dense: true,
                            flat: true,
                            icon: dateArrow.value[1],
                            "aria-label": $q.lang.date.nextRangeYears(yearsInterval),
                            tabindex: tabindex.value,
                            disable: isDisabled(stop),
                            ...getCache("y+", {
                                onClick: ()=>{
                                    startYear.value += yearsInterval;
                                }
                            })
                        })
                    ])
                ]);
            }
        };
        function onDayClick(dayIndex) {
            const day = {
                ...viewModel.value,
                day: dayIndex
            };
            if (props.range === false) {
                toggleDate(day, viewMonthHash.value);
                return;
            }
            if (editRange.value === null) {
                const dayProps = days.value.find((item)=>item.fill !== true && item.i === dayIndex);
                if (props.noUnset !== true && dayProps.range !== void 0) {
                    removeFromModel({
                        target: day,
                        from: dayProps.range.from,
                        to: dayProps.range.to
                    });
                    return;
                }
                if (dayProps.selected === true) {
                    removeFromModel(day);
                    return;
                }
                const initHash = getDayHash(day);
                editRange.value = {
                    init: day,
                    initHash,
                    final: day,
                    finalHash: initHash
                };
                emit("rangeStart", getShortDate(day));
            } else {
                const initHash = editRange.value.initHash, finalHash = getDayHash(day), payload = initHash <= finalHash ? {
                    from: editRange.value.init,
                    to: day
                } : {
                    from: day,
                    to: editRange.value.init
                };
                editRange.value = null;
                addToModel(initHash === finalHash ? day : {
                    target: day,
                    ...payload
                });
                emit("rangeEnd", {
                    from: getShortDate(payload.from),
                    to: getShortDate(payload.to)
                });
            }
        }
        function onDayMouseover(dayIndex) {
            if (editRange.value !== null) {
                const final = {
                    ...viewModel.value,
                    day: dayIndex
                };
                Object.assign(editRange.value, {
                    final,
                    finalHash: getDayHash(final)
                });
            }
        }
        Object.assign(proxy, {
            setToday,
            setView,
            offsetCalendar,
            setCalendarTo,
            setEditingRange
        });
        return ()=>{
            const content = [
                (0, _vue.h)("div", {
                    class: "q-date__content col relative-position"
                }, [
                    (0, _vue.h)((0, _vue.Transition), {
                        name: "q-transition--fade"
                    }, renderViews[view.value])
                ])
            ];
            const def = hSlot(slots.default);
            if (def !== void 0) content.push((0, _vue.h)("div", {
                class: "q-date__actions"
            }, def));
            if (props.name !== void 0 && props.disable !== true) injectFormInput(content, "push");
            return (0, _vue.h)("div", {
                class: classes.value,
                ...attributes.value
            }, [
                getHeader(),
                (0, _vue.h)("div", {
                    ref: blurTargetRef,
                    class: "q-date__main col column",
                    tabindex: -1
                }, content)
            ]);
        };
    }
});
//#endregion
//#region src/composables/private.use-history/use-history.js
function useHistory(showing, hide, hideOnRouteChange) {
    let historyEntry;
    function removeFromHistory() {
        if (historyEntry !== void 0) {
            History_default.remove(historyEntry);
            historyEntry = void 0;
        }
    }
    (0, _vue.onBeforeUnmount)(()=>{
        if (showing.value === true) removeFromHistory();
    });
    return {
        removeFromHistory,
        addToHistory () {
            historyEntry = {
                condition: ()=>hideOnRouteChange.value === true,
                handler: hide
            };
            History_default.add(historyEntry);
        }
    };
}
//#endregion
//#region src/utils/scroll/prevent-scroll.js
let registered = 0, scrollPositionX, scrollPositionY, maxScrollTop, vpPendingUpdate = false, bodyLeft, bodyTop, href, closeTimer = null;
function onWheel(e) {
    if (shouldPreventScroll(e)) stopAndPrevent(e);
}
function shouldPreventScroll(e) {
    if (e.target === document.body || e.target.classList.contains("q-layout__backdrop")) return true;
    const path = getEventPath(e), shift = e.shiftKey && !e.deltaX, scrollY = !shift && Math.abs(e.deltaX) <= Math.abs(e.deltaY), delta = shift || scrollY ? e.deltaY : e.deltaX;
    for(let index = 0; index < path.length; index++){
        const el = path[index];
        if (hasScrollbar(el, scrollY)) return scrollY ? delta < 0 && el.scrollTop === 0 ? true : delta > 0 && el.scrollTop + el.clientHeight === el.scrollHeight : delta < 0 && el.scrollLeft === 0 ? true : delta > 0 && el.scrollLeft + el.clientWidth === el.scrollWidth;
    }
    return true;
}
function onAppleScroll(e) {
    if (e.target === document) document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
}
function onAppleResize(evt) {
    if (vpPendingUpdate === true) return;
    vpPendingUpdate = true;
    requestAnimationFrame(()=>{
        vpPendingUpdate = false;
        const { height } = evt.target, { clientHeight, scrollTop } = document.scrollingElement;
        if (maxScrollTop === void 0 || height !== window.innerHeight) {
            maxScrollTop = clientHeight - height;
            document.scrollingElement.scrollTop = scrollTop;
        }
        if (scrollTop > maxScrollTop) document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop) / 8);
    });
}
function apply$1(action) {
    const body = document.body, hasViewport = window.visualViewport !== void 0;
    if (action === "add") {
        const { overflowY, overflowX } = window.getComputedStyle(body);
        scrollPositionX = getHorizontalScrollPosition(window);
        scrollPositionY = getVerticalScrollPosition(window);
        bodyLeft = body.style.left;
        bodyTop = body.style.top;
        href = window.location.href;
        body.style.left = `-${scrollPositionX}px`;
        body.style.top = `-${scrollPositionY}px`;
        if (overflowX !== "hidden" && (overflowX === "scroll" || body.scrollWidth > window.innerWidth)) body.classList.add("q-body--force-scrollbar-x");
        if (overflowY !== "hidden" && (overflowY === "scroll" || body.scrollHeight > window.innerHeight)) body.classList.add("q-body--force-scrollbar-y");
        body.classList.add("q-body--prevent-scroll");
        document.qScrollPrevented = true;
        if (client.is.ios === true) {
            if (hasViewport === true) {
                window.scrollTo(0, 0);
                window.visualViewport.addEventListener("resize", onAppleResize, listenOpts.passiveCapture);
                window.visualViewport.addEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
                window.scrollTo(0, 0);
            } else window.addEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
        }
    }
    if (client.is.desktop === true && client.is.mac === true) window[`${action}EventListener`]("wheel", onWheel, listenOpts.notPassive);
    if (action === "remove") {
        if (client.is.ios === true) {
            if (hasViewport === true) {
                window.visualViewport.removeEventListener("resize", onAppleResize, listenOpts.passiveCapture);
                window.visualViewport.removeEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
            } else window.removeEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
        }
        body.classList.remove("q-body--prevent-scroll");
        body.classList.remove("q-body--force-scrollbar-x");
        body.classList.remove("q-body--force-scrollbar-y");
        document.qScrollPrevented = false;
        body.style.left = bodyLeft;
        body.style.top = bodyTop;
        if (window.location.href === href) window.scrollTo(scrollPositionX, scrollPositionY);
        maxScrollTop = void 0;
    }
}
function preventScroll(state) {
    let action = "add";
    if (state === true) {
        registered++;
        if (closeTimer !== null) {
            clearTimeout(closeTimer);
            closeTimer = null;
            return;
        }
        if (registered > 1) return;
    } else {
        if (registered === 0) return;
        registered--;
        if (registered > 0) return;
        action = "remove";
        if (client.is.ios === true && client.is.nativeMobile === true) {
            if (closeTimer !== null) clearTimeout(closeTimer);
            closeTimer = setTimeout(()=>{
                apply$1(action);
                closeTimer = null;
            }, 100);
            return;
        }
    }
    apply$1(action);
}
//#endregion
//#region src/composables/private.use-prevent-scroll/use-prevent-scroll.js
function usePreventScroll() {
    let currentState;
    return {
        preventBodyScroll (state) {
            if (state !== currentState && (currentState !== void 0 || state === true)) {
                currentState = state;
                preventScroll(state);
            }
        }
    };
}
//#endregion
//#region src/components/dialog/QDialog.js
let maximizedModals = 0;
const positionClass$1 = {
    standard: "fixed-full flex-center",
    top: "fixed-top justify-center",
    bottom: "fixed-bottom justify-center",
    right: "fixed-right items-center",
    left: "fixed-left items-center"
};
const defaultTransitions = {
    standard: [
        "scale",
        "scale"
    ],
    top: [
        "slide-down",
        "slide-up"
    ],
    bottom: [
        "slide-up",
        "slide-down"
    ],
    right: [
        "slide-left",
        "slide-right"
    ],
    left: [
        "slide-right",
        "slide-left"
    ]
};
var QDialog_default = createComponent({
    name: "QDialog",
    inheritAttrs: false,
    props: {
        ...useModelToggleProps,
        ...useTransitionProps,
        transitionShow: String,
        transitionHide: String,
        persistent: Boolean,
        autoClose: Boolean,
        allowFocusOutside: Boolean,
        noEscDismiss: Boolean,
        noBackdropDismiss: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        noShake: Boolean,
        seamless: Boolean,
        maximized: Boolean,
        fullWidth: Boolean,
        fullHeight: Boolean,
        square: Boolean,
        backdropFilter: String,
        position: {
            type: String,
            default: "standard",
            validator: (val)=>[
                    "standard",
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].includes(val)
        }
    },
    emits: [
        ...useModelToggleEmits,
        "shake",
        "click",
        "escapeKey"
    ],
    setup (props, { slots, emit, attrs }) {
        const vm = (0, _vue.getCurrentInstance)();
        const innerRef = (0, _vue.ref)(null);
        const showing = (0, _vue.ref)(false);
        const animating = (0, _vue.ref)(false);
        let shakeTimeout = null, refocusTarget = null, isMaximized, avoidAutoClose;
        const hideOnRouteChange = (0, _vue.computed)(()=>props.persistent !== true && props.noRouteDismiss !== true && props.seamless !== true);
        const { preventBodyScroll } = usePreventScroll();
        const { registerTimeout } = useTimeout();
        const { registerTick, removeTick } = useTick();
        const { transitionProps, transitionStyle } = useTransition(props, ()=>defaultTransitions[props.position][0], ()=>defaultTransitions[props.position][1]);
        const backdropStyle = (0, _vue.computed)(()=>transitionStyle.value + (props.backdropFilter !== void 0 ? `;backdrop-filter:${props.backdropFilter};-webkit-backdrop-filter:${props.backdropFilter}` : ""));
        const { showPortal, hidePortal, portalIsAccessible, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "dialog");
        const { hide } = useModelToggle({
            showing,
            hideOnRouteChange,
            handleShow,
            handleHide,
            processOnMount: true
        });
        const { addToHistory, removeFromHistory } = useHistory(showing, hide, hideOnRouteChange);
        const classes = (0, _vue.computed)(()=>`q-dialog__inner flex no-pointer-events q-dialog__inner--${props.maximized === true ? "maximized" : "minimized"} q-dialog__inner--${props.position} ${positionClass$1[props.position]}` + (animating.value === true ? " q-dialog__inner--animating" : "") + (props.fullWidth === true ? " q-dialog__inner--fullwidth" : "") + (props.fullHeight === true ? " q-dialog__inner--fullheight" : "") + (props.square === true ? " q-dialog__inner--square" : ""));
        const useBackdrop = (0, _vue.computed)(()=>showing.value === true && props.seamless !== true);
        const onEvents = (0, _vue.computed)(()=>props.autoClose === true ? {
                onClick: onAutoClose
            } : {});
        const rootClasses = (0, _vue.computed)(()=>[
                `q-dialog fullscreen no-pointer-events q-dialog--${useBackdrop.value === true ? "modal" : "seamless"}`,
                attrs.class
            ]);
        (0, _vue.watch)(()=>props.maximized, (state)=>{
            if (showing.value === true) updateMaximized(state);
        });
        (0, _vue.watch)(useBackdrop, (val)=>{
            preventBodyScroll(val);
            if (val === true) {
                addFocusout(onFocusChange);
                addEscapeKey(onEscapeKey);
            } else {
                removeFocusout(onFocusChange);
                removeEscapeKey(onEscapeKey);
            }
        });
        function handleShow(evt) {
            addToHistory();
            refocusTarget = props.noRefocus === false && document.activeElement !== null ? document.activeElement : null;
            updateMaximized(props.maximized);
            showPortal();
            animating.value = true;
            if (props.noFocus !== true) {
                document.activeElement?.blur();
                registerTick(focus);
            } else removeTick();
            registerTimeout(()=>{
                if (vm.proxy.$q.platform.is.ios === true) {
                    if (props.seamless !== true && document.activeElement) {
                        const { top, bottom } = document.activeElement.getBoundingClientRect(), { innerHeight } = window, height = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
                        if (top > 0 && bottom > height / 2) document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollHeight - height, bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height / 2));
                        document.activeElement.scrollIntoView();
                    }
                    avoidAutoClose = true;
                    innerRef.value.click();
                    avoidAutoClose = false;
                }
                showPortal(true);
                animating.value = false;
                emit("show", evt);
            }, props.transitionDuration);
        }
        function handleHide(evt) {
            removeTick();
            removeFromHistory();
            cleanup(true);
            animating.value = true;
            hidePortal();
            if (refocusTarget !== null) {
                ((evt?.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
                refocusTarget = null;
            }
            registerTimeout(()=>{
                hidePortal(true);
                animating.value = false;
                emit("hide", evt);
            }, props.transitionDuration);
        }
        function focus(selector) {
            addFocusFn(()=>{
                let node = innerRef.value;
                if (node === null) return;
                if (selector !== void 0) {
                    const target = node.querySelector(selector);
                    if (target !== null) {
                        target.focus({
                            preventScroll: true
                        });
                        return;
                    }
                }
                if (node.contains(document.activeElement) !== true) {
                    node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
                    node.focus({
                        preventScroll: true
                    });
                }
            });
        }
        function shake(focusTarget) {
            if (focusTarget && typeof focusTarget.focus === "function") focusTarget.focus({
                preventScroll: true
            });
            else focus();
            emit("shake");
            const node = innerRef.value;
            if (node !== null) {
                node.classList.remove("q-animate--scale");
                node.classList.add("q-animate--scale");
                if (shakeTimeout !== null) clearTimeout(shakeTimeout);
                shakeTimeout = setTimeout(()=>{
                    shakeTimeout = null;
                    if (innerRef.value !== null) {
                        node.classList.remove("q-animate--scale");
                        focus();
                    }
                }, 170);
            }
        }
        function onEscapeKey() {
            if (props.seamless !== true) {
                if (props.persistent === true || props.noEscDismiss === true) {
                    if (props.maximized !== true && props.noShake !== true) shake();
                } else {
                    emit("escapeKey");
                    hide();
                }
            }
        }
        function cleanup(hiding) {
            if (shakeTimeout !== null) {
                clearTimeout(shakeTimeout);
                shakeTimeout = null;
            }
            if (hiding === true || showing.value === true) {
                updateMaximized(false);
                if (props.seamless !== true) {
                    preventBodyScroll(false);
                    removeFocusout(onFocusChange);
                    removeEscapeKey(onEscapeKey);
                }
            }
            if (hiding !== true) refocusTarget = null;
        }
        function updateMaximized(active) {
            if (active === true) {
                if (isMaximized !== true) {
                    if (maximizedModals < 1) document.body.classList.add("q-body--dialog");
                    maximizedModals++;
                    isMaximized = true;
                }
            } else if (isMaximized === true) {
                if (maximizedModals < 2) document.body.classList.remove("q-body--dialog");
                maximizedModals--;
                isMaximized = false;
            }
        }
        function onAutoClose(e) {
            if (avoidAutoClose !== true) {
                hide(e);
                emit("click", e);
            }
        }
        function onBackdropClick(e) {
            if (props.persistent !== true && props.noBackdropDismiss !== true) hide(e);
            else if (props.noShake !== true) shake();
        }
        function onFocusChange(evt) {
            if (props.allowFocusOutside !== true && portalIsAccessible.value === true && childHasFocus(innerRef.value, evt.target) !== true) focus('[tabindex]:not([tabindex="-1"])');
        }
        Object.assign(vm.proxy, {
            focus,
            shake,
            __updateRefocusTarget (target) {
                refocusTarget = target || null;
            }
        });
        (0, _vue.onBeforeUnmount)(cleanup);
        function renderPortalContent() {
            return (0, _vue.h)("div", {
                role: "dialog",
                "aria-modal": useBackdrop.value === true ? "true" : "false",
                ...attrs,
                class: rootClasses.value
            }, [
                (0, _vue.h)((0, _vue.Transition), {
                    name: "q-transition--fade",
                    appear: true
                }, ()=>useBackdrop.value === true ? (0, _vue.h)("div", {
                        class: "q-dialog__backdrop fixed-full",
                        style: backdropStyle.value,
                        "aria-hidden": "true",
                        tabindex: -1,
                        onClick: onBackdropClick
                    }) : null),
                (0, _vue.h)((0, _vue.Transition), transitionProps.value, ()=>showing.value === true ? (0, _vue.h)("div", {
                        ref: innerRef,
                        class: classes.value,
                        style: transitionStyle.value,
                        tabindex: -1,
                        ...onEvents.value
                    }, hSlot(slots.default)) : null)
            ]);
        }
        return renderPortal;
    }
});
//#endregion
//#region src/components/drawer/QDrawer.js
const duration = 150;
var QDrawer_default = createComponent({
    name: "QDrawer",
    inheritAttrs: false,
    props: {
        ...useModelToggleProps,
        ...useDarkProps,
        side: {
            type: String,
            default: "left",
            validator: (v)=>[
                    "left",
                    "right"
                ].includes(v)
        },
        width: {
            type: Number,
            default: 300
        },
        mini: Boolean,
        miniToOverlay: Boolean,
        miniWidth: {
            type: Number,
            default: 57
        },
        noMiniAnimation: Boolean,
        breakpoint: {
            type: Number,
            default: 1023
        },
        showIfAbove: Boolean,
        behavior: {
            type: String,
            validator: (v)=>[
                    "default",
                    "desktop",
                    "mobile"
                ].includes(v),
            default: "default"
        },
        bordered: Boolean,
        elevated: Boolean,
        overlay: Boolean,
        persistent: Boolean,
        noSwipeOpen: Boolean,
        noSwipeClose: Boolean,
        noSwipeBackdrop: Boolean
    },
    emits: [
        ...useModelToggleEmits,
        "onLayout",
        "miniState"
    ],
    setup (props, { slots, emit, attrs }) {
        const vm = (0, _vue.getCurrentInstance)();
        const { proxy: { $q } } = vm;
        const isDark = useDark(props, $q);
        const { preventBodyScroll } = usePreventScroll();
        const { registerTimeout, removeTimeout } = useTimeout();
        const $layout = (0, _vue.inject)(layoutKey, emptyRenderFn);
        if ($layout === emptyRenderFn) {
            console.error("QDrawer needs to be child of QLayout");
            return emptyRenderFn;
        }
        let lastDesktopState, timerMini = null, layoutTotalWidthWatcher;
        const belowBreakpoint = (0, _vue.ref)(props.behavior === "mobile" || props.behavior !== "desktop" && $layout.totalWidth.value <= props.breakpoint);
        const isMini = (0, _vue.computed)(()=>props.mini === true && belowBreakpoint.value !== true);
        const size = (0, _vue.computed)(()=>isMini.value === true ? props.miniWidth : props.width);
        const showing = (0, _vue.ref)(props.showIfAbove === true && belowBreakpoint.value === false ? true : props.modelValue === true);
        const hideOnRouteChange = (0, _vue.computed)(()=>props.persistent !== true && (belowBreakpoint.value === true || onScreenOverlay.value === true));
        function handleShow(evt, noEvent) {
            addToHistory();
            if (evt !== false) $layout.animate();
            applyPosition(0);
            if (belowBreakpoint.value === true) {
                const otherInstance = $layout.instances[otherSide.value];
                if (otherInstance?.belowBreakpoint === true) otherInstance.hide(false);
                applyBackdrop(1);
                if ($layout.isContainer.value !== true) preventBodyScroll(true);
            } else {
                applyBackdrop(0);
                if (evt !== false) setScrollable(false);
            }
            registerTimeout(()=>{
                if (evt !== false) setScrollable(true);
                if (noEvent !== true) emit("show", evt);
            }, duration);
        }
        function handleHide(evt, noEvent) {
            removeFromHistory();
            if (evt !== false) $layout.animate();
            applyBackdrop(0);
            applyPosition(stateDirection.value * size.value);
            cleanup();
            if (noEvent !== true) registerTimeout(()=>{
                emit("hide", evt);
            }, duration);
            else removeTimeout();
        }
        const { show, hide } = useModelToggle({
            showing,
            hideOnRouteChange,
            handleShow,
            handleHide
        });
        const { addToHistory, removeFromHistory } = useHistory(showing, hide, hideOnRouteChange);
        const instance = {
            belowBreakpoint,
            hide
        };
        const rightSide = (0, _vue.computed)(()=>props.side === "right");
        const stateDirection = (0, _vue.computed)(()=>($q.lang.rtl === true ? -1 : 1) * (rightSide.value === true ? 1 : -1));
        const flagBackdropBg = (0, _vue.ref)(0);
        const flagPanning = (0, _vue.ref)(false);
        const flagMiniAnimate = (0, _vue.ref)(false);
        const flagContentPosition = (0, _vue.ref)(size.value * stateDirection.value);
        const otherSide = (0, _vue.computed)(()=>rightSide.value === true ? "left" : "right");
        const offset = (0, _vue.computed)(()=>showing.value === true && belowBreakpoint.value === false && props.overlay === false ? props.miniToOverlay === true ? props.miniWidth : size.value : 0);
        const fixed = (0, _vue.computed)(()=>props.overlay === true || props.miniToOverlay === true || $layout.view.value.indexOf(rightSide.value ? "R" : "L") !== -1 || $q.platform.is.ios === true && $layout.isContainer.value === true);
        const onLayout = (0, _vue.computed)(()=>props.overlay === false && showing.value === true && belowBreakpoint.value === false);
        const onScreenOverlay = (0, _vue.computed)(()=>props.overlay === true && showing.value === true && belowBreakpoint.value === false);
        const backdropClass = (0, _vue.computed)(()=>"fullscreen q-drawer__backdrop" + (showing.value === false && flagPanning.value === false ? " hidden" : ""));
        const backdropStyle = (0, _vue.computed)(()=>({
                backgroundColor: `rgba(0,0,0,${flagBackdropBg.value * .4})`
            }));
        const headerSlot = (0, _vue.computed)(()=>rightSide.value === true ? $layout.rows.value.top[2] === "r" : $layout.rows.value.top[0] === "l");
        const footerSlot = (0, _vue.computed)(()=>rightSide.value === true ? $layout.rows.value.bottom[2] === "r" : $layout.rows.value.bottom[0] === "l");
        const aboveStyle = (0, _vue.computed)(()=>{
            const css = {};
            if ($layout.header.space === true && headerSlot.value === false) {
                if (fixed.value === true) css.top = `${$layout.header.offset}px`;
                else if ($layout.header.space === true) css.top = `${$layout.header.size}px`;
            }
            if ($layout.footer.space === true && footerSlot.value === false) {
                if (fixed.value === true) css.bottom = `${$layout.footer.offset}px`;
                else if ($layout.footer.space === true) css.bottom = `${$layout.footer.size}px`;
            }
            return css;
        });
        const style = (0, _vue.computed)(()=>{
            const acc = {
                width: `${size.value}px`,
                transform: `translateX(${flagContentPosition.value}px)`
            };
            return belowBreakpoint.value === true ? acc : Object.assign(acc, aboveStyle.value);
        });
        const contentClass = (0, _vue.computed)(()=>"q-drawer__content fit " + ($layout.isContainer.value !== true ? "scroll" : "overflow-auto"));
        const classes = (0, _vue.computed)(()=>`q-drawer q-drawer--${props.side}` + (flagMiniAnimate.value === true ? " q-drawer--mini-animate" : "") + (props.bordered === true ? " q-drawer--bordered" : "") + (isDark.value === true ? " q-drawer--dark q-dark" : "") + (flagPanning.value === true ? " no-transition" : showing.value === true ? "" : " q-layout--prevent-focus") + (belowBreakpoint.value === true ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${isMini.value === true ? "mini" : "standard"}` + (fixed.value === true || onLayout.value !== true ? " fixed" : "") + (props.overlay === true || props.miniToOverlay === true ? " q-drawer--on-top" : "") + (headerSlot.value === true ? " q-drawer--top-padding" : "")));
        const openDirective = (0, _vue.computed)(()=>{
            return [
                [
                    TouchPan_default,
                    onOpenPan,
                    void 0,
                    {
                        [$q.lang.rtl === true ? props.side : otherSide.value]: true,
                        mouse: true
                    }
                ]
            ];
        });
        const contentCloseDirective = (0, _vue.computed)(()=>{
            return [
                [
                    TouchPan_default,
                    onClosePan,
                    void 0,
                    {
                        [$q.lang.rtl === true ? otherSide.value : props.side]: true,
                        mouse: true
                    }
                ]
            ];
        });
        const backdropCloseDirective = (0, _vue.computed)(()=>{
            return [
                [
                    TouchPan_default,
                    onClosePan,
                    void 0,
                    {
                        [$q.lang.rtl === true ? otherSide.value : props.side]: true,
                        mouse: true,
                        mouseAllDir: true
                    }
                ]
            ];
        });
        function updateBelowBreakpoint() {
            updateLocal(belowBreakpoint, props.behavior === "mobile" || props.behavior !== "desktop" && $layout.totalWidth.value <= props.breakpoint);
        }
        (0, _vue.watch)(belowBreakpoint, (val)=>{
            if (val === true) {
                lastDesktopState = showing.value;
                if (showing.value === true) hide(false);
            } else if (props.overlay === false && props.behavior !== "mobile" && lastDesktopState !== false) {
                if (showing.value === true) {
                    applyPosition(0);
                    applyBackdrop(0);
                    cleanup();
                } else show(false);
            }
        });
        (0, _vue.watch)(()=>props.side, (newSide, oldSide)=>{
            if ($layout.instances[oldSide] === instance) {
                $layout.instances[oldSide] = void 0;
                $layout[oldSide].space = false;
                $layout[oldSide].offset = 0;
            }
            $layout.instances[newSide] = instance;
            $layout[newSide].size = size.value;
            $layout[newSide].space = onLayout.value;
            $layout[newSide].offset = offset.value;
        });
        (0, _vue.watch)($layout.totalWidth, ()=>{
            if ($layout.isContainer.value === true || document.qScrollPrevented !== true) updateBelowBreakpoint();
        });
        (0, _vue.watch)(()=>props.behavior + props.breakpoint, updateBelowBreakpoint);
        (0, _vue.watch)($layout.isContainer, (val)=>{
            if (showing.value === true) preventBodyScroll(val !== true);
            if (val === true) updateBelowBreakpoint();
        });
        (0, _vue.watch)($layout.scrollbarWidth, ()=>{
            applyPosition(showing.value === true ? 0 : void 0);
        });
        (0, _vue.watch)(offset, (val)=>{
            updateLayout("offset", val);
        });
        (0, _vue.watch)(onLayout, (val)=>{
            emit("onLayout", val);
            updateLayout("space", val);
        });
        (0, _vue.watch)(rightSide, ()=>{
            applyPosition();
        });
        (0, _vue.watch)(size, (val)=>{
            applyPosition();
            updateSizeOnLayout(props.miniToOverlay, val);
        });
        (0, _vue.watch)(()=>props.miniToOverlay, (val)=>{
            updateSizeOnLayout(val, size.value);
        });
        (0, _vue.watch)(()=>$q.lang.rtl, ()=>{
            applyPosition();
        });
        (0, _vue.watch)(()=>props.mini, ()=>{
            if (props.noMiniAnimation) return;
            if (props.modelValue === true) {
                animateMini();
                $layout.animate();
            }
        });
        (0, _vue.watch)(isMini, (val)=>{
            emit("miniState", val);
        });
        function applyPosition(position) {
            if (position === void 0) (0, _vue.nextTick)(()=>{
                position = showing.value === true ? 0 : size.value;
                applyPosition(stateDirection.value * position);
            });
            else {
                if ($layout.isContainer.value === true && rightSide.value === true && (belowBreakpoint.value === true || Math.abs(position) === size.value)) position += stateDirection.value * $layout.scrollbarWidth.value;
                flagContentPosition.value = position;
            }
        }
        function applyBackdrop(x) {
            flagBackdropBg.value = x;
        }
        function setScrollable(v) {
            const action = v === true ? "remove" : $layout.isContainer.value !== true ? "add" : "";
            if (action !== "") document.body.classList[action]("q-body--drawer-toggle");
        }
        function animateMini() {
            if (timerMini !== null) clearTimeout(timerMini);
            if (vm.proxy && vm.proxy.$el) vm.proxy.$el.classList.add("q-drawer--mini-animate");
            flagMiniAnimate.value = true;
            timerMini = setTimeout(()=>{
                timerMini = null;
                flagMiniAnimate.value = false;
                vm?.proxy?.$el?.classList.remove("q-drawer--mini-animate");
            }, 150);
        }
        function onOpenPan(evt) {
            if (showing.value !== false) return;
            const width = size.value, position = between(evt.distance.x, 0, width);
            if (evt.isFinal === true) {
                if (position >= Math.min(75, width) === true) show();
                else {
                    $layout.animate();
                    applyBackdrop(0);
                    applyPosition(stateDirection.value * width);
                }
                flagPanning.value = false;
                return;
            }
            applyPosition(($q.lang.rtl === true ? rightSide.value !== true : rightSide.value) ? Math.max(width - position, 0) : Math.min(0, position - width));
            applyBackdrop(between(position / width, 0, 1));
            if (evt.isFirst === true) flagPanning.value = true;
        }
        function onClosePan(evt) {
            if (showing.value !== true) return;
            const width = size.value, dir = evt.direction === props.side, position = ($q.lang.rtl === true ? dir !== true : dir) ? between(evt.distance.x, 0, width) : 0;
            if (evt.isFinal === true) {
                if (Math.abs(position) < Math.min(75, width) === true) {
                    $layout.animate();
                    applyBackdrop(1);
                    applyPosition(0);
                } else hide();
                flagPanning.value = false;
                return;
            }
            applyPosition(stateDirection.value * position);
            applyBackdrop(between(1 - position / width, 0, 1));
            if (evt.isFirst === true) flagPanning.value = true;
        }
        function cleanup() {
            preventBodyScroll(false);
            setScrollable(true);
        }
        function updateLayout(prop, val) {
            $layout.update(props.side, prop, val);
        }
        function updateLocal(prop, val) {
            if (prop.value !== val) prop.value = val;
        }
        function updateSizeOnLayout(miniToOverlay, newSize) {
            updateLayout("size", miniToOverlay === true ? props.miniWidth : newSize);
        }
        $layout.instances[props.side] = instance;
        updateSizeOnLayout(props.miniToOverlay, size.value);
        updateLayout("space", onLayout.value);
        updateLayout("offset", offset.value);
        if (props.showIfAbove === true && props.modelValue !== true && showing.value === true && props["onUpdate:modelValue"] !== void 0) emit("update:modelValue", true);
        (0, _vue.onMounted)(()=>{
            emit("onLayout", onLayout.value);
            emit("miniState", isMini.value);
            lastDesktopState = props.showIfAbove === true;
            const fn = ()=>{
                (showing.value === true ? handleShow : handleHide)(false, true);
            };
            if ($layout.totalWidth.value !== 0) {
                (0, _vue.nextTick)(fn);
                return;
            }
            layoutTotalWidthWatcher = (0, _vue.watch)($layout.totalWidth, ()=>{
                layoutTotalWidthWatcher();
                layoutTotalWidthWatcher = void 0;
                if (showing.value === false && props.showIfAbove === true && belowBreakpoint.value === false) show(false);
                else fn();
            });
        });
        (0, _vue.onBeforeUnmount)(()=>{
            layoutTotalWidthWatcher?.();
            if (timerMini !== null) {
                clearTimeout(timerMini);
                timerMini = null;
            }
            if (showing.value === true) cleanup();
            if ($layout.instances[props.side] === instance) {
                $layout.instances[props.side] = void 0;
                updateLayout("size", 0);
                updateLayout("offset", 0);
                updateLayout("space", false);
            }
        });
        return ()=>{
            const child = [];
            if (belowBreakpoint.value === true) {
                if (props.noSwipeOpen === false) child.push((0, _vue.withDirectives)((0, _vue.h)("div", {
                    key: "open",
                    class: `q-drawer__opener fixed-${props.side}`,
                    "aria-hidden": "true"
                }), openDirective.value));
                child.push(hDir("div", {
                    ref: "backdrop",
                    class: backdropClass.value,
                    style: backdropStyle.value,
                    "aria-hidden": "true",
                    onClick: hide
                }, void 0, "backdrop", props.noSwipeBackdrop !== true && showing.value === true, ()=>backdropCloseDirective.value));
            }
            const mini = isMini.value === true && slots.mini !== void 0;
            const content = [
                (0, _vue.h)("div", {
                    ...attrs,
                    key: String(mini),
                    class: [
                        contentClass.value,
                        attrs.class
                    ]
                }, mini === true ? slots.mini() : hSlot(slots.default))
            ];
            if (props.elevated === true && showing.value === true) content.push((0, _vue.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            }));
            child.push(hDir("aside", {
                ref: "content",
                class: classes.value,
                style: style.value
            }, content, "contentclose", props.noSwipeClose !== true && belowBreakpoint.value === true, ()=>contentCloseDirective.value));
            return (0, _vue.h)("div", {
                class: "q-drawer-container"
            }, child);
        };
    }
});
//#endregion
//#region src/components/editor/editor-caret.js
function getBlockElement(el, parent) {
    if (parent && el === parent) return null;
    const nodeName = el.nodeName.toLowerCase();
    if ([
        "div",
        "li",
        "ul",
        "ol",
        "blockquote"
    ].includes(nodeName) === true) return el;
    const display = (window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle).display;
    if (display === "block" || display === "table") return el;
    return getBlockElement(el.parentNode);
}
function isChildOf(el, parent, orSame) {
    return !el || el === document.body ? false : orSame === true && el === parent || (parent === document ? document.body : parent).contains(el.parentNode);
}
function createRange(node, chars, range) {
    if (!range) {
        range = document.createRange();
        range.selectNode(node);
        range.setStart(node, 0);
    }
    if (chars.count === 0) range.setEnd(node, chars.count);
    else if (chars.count > 0) {
        if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.length < chars.count) chars.count -= node.textContent.length;
            else {
                range.setEnd(node, chars.count);
                chars.count = 0;
            }
        } else for(let lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++)range = createRange(node.childNodes[lp], chars, range);
    }
    return range;
}
const urlRegex = /^https?:\/\//;
var Caret = class {
    constructor(el, eVm){
        this.el = el;
        this.eVm = eVm;
        this._range = null;
    }
    get selection() {
        if (this.el) {
            const sel = document.getSelection();
            if (isChildOf(sel.anchorNode, this.el, true) && isChildOf(sel.focusNode, this.el, true)) return sel;
        }
        return null;
    }
    get hasSelection() {
        return this.selection !== null ? this.selection.toString().length !== 0 : false;
    }
    get range() {
        const sel = this.selection;
        if (sel?.rangeCount) return sel.getRangeAt(0);
        return this._range;
    }
    get parent() {
        const range = this.range;
        if (range !== null) {
            const node = range.startContainer;
            return node.nodeType === document.ELEMENT_NODE ? node : node.parentNode;
        }
        return null;
    }
    get blockParent() {
        const parent = this.parent;
        if (parent !== null) return getBlockElement(parent, this.el);
        return null;
    }
    save(range = this.range) {
        if (range !== null) this._range = range;
    }
    restore(range = this._range) {
        const r = document.createRange(), sel = document.getSelection();
        if (range !== null) {
            r.setStart(range.startContainer, range.startOffset);
            r.setEnd(range.endContainer, range.endOffset);
            sel.removeAllRanges();
            sel.addRange(r);
        } else {
            sel.selectAllChildren(this.el);
            sel.collapseToEnd();
        }
    }
    savePosition() {
        let charCount = -1, node;
        const selection = document.getSelection(), parentEl = this.el.parentNode;
        if (selection.focusNode && isChildOf(selection.focusNode, parentEl)) {
            node = selection.focusNode;
            charCount = selection.focusOffset;
            while(node && node !== parentEl)if (node !== this.el && node.previousSibling) {
                node = node.previousSibling;
                charCount += node.textContent.length;
            } else node = node.parentNode;
        }
        this.savedPos = charCount;
    }
    restorePosition(length = 0) {
        if (this.savedPos > 0 && this.savedPos < length) {
            const selection = window.getSelection(), range = createRange(this.el, {
                count: this.savedPos
            });
            if (range) {
                range.collapse(false);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    }
    hasParent(name, spanLevel) {
        const el = spanLevel ? this.parent : this.blockParent;
        return el !== null ? el.nodeName.toLowerCase() === name.toLowerCase() : false;
    }
    hasParents(list, recursive, el = this.parent) {
        if (el === null) return false;
        if (list.includes(el.nodeName.toLowerCase()) === true) return true;
        return recursive === true ? this.hasParents(list, recursive, el.parentNode) : false;
    }
    is(cmd, param) {
        if (this.selection === null) return false;
        switch(cmd){
            case "formatBlock":
                return param === "DIV" && this.parent === this.el || this.hasParent(param, param === "PRE");
            case "link":
                return this.hasParent("A", true);
            case "fontSize":
                return document.queryCommandValue(cmd) === param;
            case "fontName":
                const res = document.queryCommandValue(cmd);
                return res === `"${param}"` || res === param;
            case "fullscreen":
                return this.eVm.inFullscreen.value;
            case "viewsource":
                return this.eVm.isViewingSource.value;
            case void 0:
                return false;
            default:
                const state = document.queryCommandState(cmd);
                return param !== void 0 ? state === param : state;
        }
    }
    getParentAttribute(attrib) {
        if (this.parent !== null) return this.parent.getAttribute(attrib);
        return null;
    }
    can(name) {
        if (name === "outdent") return this.hasParents([
            "blockquote",
            "li"
        ], true);
        if (name === "indent") return this.hasParents([
            "li"
        ], true);
        if (name === "link") return this.selection !== null || this.is("link");
    }
    apply(cmd, param, done = noop) {
        if (cmd === "formatBlock") {
            if ([
                "BLOCKQUOTE",
                "H1",
                "H2",
                "H3",
                "H4",
                "H5",
                "H6"
            ].includes(param) && this.is(cmd, param)) {
                cmd = "outdent";
                param = null;
            }
            if (param === "PRE" && this.is(cmd, "PRE")) param = "P";
        } else if (cmd === "print") {
            done();
            const win = window.open();
            win.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `);
            win.print();
            win.close();
            return;
        } else if (cmd === "link") {
            const link = this.getParentAttribute("href");
            if (link === null) {
                const selection = this.selectWord(this.selection);
                const url = selection ? selection.toString() : "";
                if (!url.length && (!this.range || !this.range.cloneContents().querySelector("img"))) return;
                this.eVm.editLinkUrl.value = urlRegex.test(url) ? url : "https://";
                this.save(selection.getRangeAt(0));
                document.execCommand("createLink", false, this.eVm.editLinkUrl.value);
            } else {
                this.eVm.editLinkUrl.value = link;
                this.range.selectNodeContents(this.parent);
                this.save();
            }
            return;
        } else if (cmd === "fullscreen") {
            this.eVm.toggleFullscreen();
            done();
            return;
        } else if (cmd === "viewsource") {
            this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === false;
            this.eVm.setContent(this.eVm.props.modelValue);
            done();
            return;
        }
        document.execCommand(cmd, false, param);
        done();
    }
    selectWord(sel) {
        if (sel === null || sel.isCollapsed !== true || sel.modify === void 0) return sel;
        const range = document.createRange();
        range.setStart(sel.anchorNode, sel.anchorOffset);
        range.setEnd(sel.focusNode, sel.focusOffset);
        const direction = range.collapsed ? [
            "backward",
            "forward"
        ] : [
            "forward",
            "backward"
        ];
        range.detach();
        const endNode = sel.focusNode, endOffset = sel.focusOffset;
        sel.collapse(sel.anchorNode, sel.anchorOffset);
        sel.modify("move", direction[0], "character");
        sel.modify("move", direction[1], "word");
        sel.extend(endNode, endOffset);
        sel.modify("extend", direction[1], "character");
        sel.modify("extend", direction[0], "word");
        return sel;
    }
};
//#endregion
//#region src/components/tooltip/QTooltip.js
var QTooltip_default = createComponent({
    name: "QTooltip",
    inheritAttrs: false,
    props: {
        ...useAnchorStaticProps,
        ...useModelToggleProps,
        ...useTransitionProps,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        },
        transitionShow: {
            ...useTransitionProps.transitionShow,
            default: "jump-down"
        },
        transitionHide: {
            ...useTransitionProps.transitionHide,
            default: "jump-up"
        },
        anchor: {
            type: String,
            default: "bottom middle",
            validator: validatePosition
        },
        self: {
            type: String,
            default: "top middle",
            validator: validatePosition
        },
        offset: {
            type: Array,
            default: ()=>[
                    14,
                    14
                ],
            validator: validateOffset
        },
        scrollTarget: scrollTargetProp,
        delay: {
            type: Number,
            default: 0
        },
        hideDelay: {
            type: Number,
            default: 0
        },
        persistent: Boolean
    },
    emits: [
        ...useModelToggleEmits
    ],
    setup (props, { slots, emit, attrs }) {
        let unwatchPosition, observer;
        const vm = (0, _vue.getCurrentInstance)();
        const { proxy: { $q } } = vm;
        const innerRef = (0, _vue.ref)(null);
        const showing = (0, _vue.ref)(false);
        const anchorOrigin = (0, _vue.computed)(()=>parsePosition(props.anchor, $q.lang.rtl));
        const selfOrigin = (0, _vue.computed)(()=>parsePosition(props.self, $q.lang.rtl));
        const hideOnRouteChange = (0, _vue.computed)(()=>props.persistent !== true);
        const { registerTick, removeTick } = useTick();
        const { registerTimeout } = useTimeout();
        const { transitionProps, transitionStyle } = useTransition(props);
        const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = useScrollTarget(props, configureScrollTarget);
        const { anchorEl, canShow, anchorEvents } = useAnchor({
            showing,
            configureAnchorEl
        });
        const { show, hide } = useModelToggle({
            showing,
            canShow,
            handleShow,
            handleHide,
            hideOnRouteChange,
            processOnMount: true
        });
        Object.assign(anchorEvents, {
            delayShow,
            delayHide
        });
        const { showPortal, hidePortal, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "tooltip");
        if ($q.platform.is.mobile === true) {
            const clickOutsideProps = {
                anchorEl,
                innerRef,
                onClickOutside (e) {
                    hide(e);
                    if (e.target.classList.contains("q-dialog__backdrop")) stopAndPrevent(e);
                    return true;
                }
            };
            (0, _vue.watch)((0, _vue.computed)(()=>props.modelValue === null && props.persistent !== true && showing.value === true), (val)=>{
                (val === true ? addClickOutside : removeClickOutside)(clickOutsideProps);
            });
            (0, _vue.onBeforeUnmount)(()=>{
                removeClickOutside(clickOutsideProps);
            });
        }
        function handleShow(evt) {
            showPortal();
            registerTick(()=>{
                observer = new MutationObserver(()=>updatePosition());
                observer.observe(innerRef.value, {
                    attributes: false,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
                updatePosition();
                configureScrollTarget();
            });
            if (unwatchPosition === void 0) unwatchPosition = (0, _vue.watch)(()=>$q.screen.width + "|" + $q.screen.height + "|" + props.self + "|" + props.anchor + "|" + $q.lang.rtl, updatePosition);
            registerTimeout(()=>{
                showPortal(true);
                emit("show", evt);
            }, props.transitionDuration);
        }
        function handleHide(evt) {
            removeTick();
            hidePortal();
            anchorCleanup();
            registerTimeout(()=>{
                hidePortal(true);
                emit("hide", evt);
            }, props.transitionDuration);
        }
        function anchorCleanup() {
            if (observer !== void 0) {
                observer.disconnect();
                observer = void 0;
            }
            if (unwatchPosition !== void 0) {
                unwatchPosition();
                unwatchPosition = void 0;
            }
            unconfigureScrollTarget();
            cleanEvt(anchorEvents, "tooltipTemp");
        }
        function updatePosition() {
            setPosition({
                targetEl: innerRef.value,
                offset: props.offset,
                anchorEl: anchorEl.value,
                anchorOrigin: anchorOrigin.value,
                selfOrigin: selfOrigin.value,
                maxHeight: props.maxHeight,
                maxWidth: props.maxWidth
            });
        }
        function delayShow(evt) {
            if ($q.platform.is.mobile === true) {
                clearSelection();
                document.body.classList.add("non-selectable");
                const target = anchorEl.value;
                addEvt(anchorEvents, "tooltipTemp", [
                    "touchmove",
                    "touchcancel",
                    "touchend",
                    "click"
                ].map((e)=>[
                        target,
                        e,
                        "delayHide",
                        "passiveCapture"
                    ]));
            }
            registerTimeout(()=>{
                show(evt);
            }, props.delay);
        }
        function delayHide(evt) {
            if ($q.platform.is.mobile === true) {
                cleanEvt(anchorEvents, "tooltipTemp");
                clearSelection();
                setTimeout(()=>{
                    document.body.classList.remove("non-selectable");
                }, 10);
            }
            registerTimeout(()=>{
                hide(evt);
            }, props.hideDelay);
        }
        function configureAnchorEl() {
            if (props.noParentEvent === true || anchorEl.value === null) return;
            addEvt(anchorEvents, "anchor", $q.platform.is.mobile === true ? [
                [
                    anchorEl.value,
                    "touchstart",
                    "delayShow",
                    "passive"
                ]
            ] : [
                [
                    anchorEl.value,
                    "mouseenter",
                    "delayShow",
                    "passive"
                ],
                [
                    anchorEl.value,
                    "mouseleave",
                    "delayHide",
                    "passive"
                ]
            ]);
        }
        function configureScrollTarget() {
            if (anchorEl.value !== null || props.scrollTarget !== void 0) {
                localScrollTarget.value = getScrollTarget(anchorEl.value, props.scrollTarget);
                const fn = props.noParentEvent === true ? updatePosition : hide;
                changeScrollEvent(localScrollTarget.value, fn);
            }
        }
        function getTooltipContent() {
            return showing.value === true ? (0, _vue.h)("div", {
                ...attrs,
                ref: innerRef,
                class: [
                    "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
                    attrs.class
                ],
                style: [
                    attrs.style,
                    transitionStyle.value
                ],
                role: "tooltip"
            }, hSlot(slots.default)) : null;
        }
        function renderPortalContent() {
            return (0, _vue.h)((0, _vue.Transition), transitionProps.value, getTooltipContent);
        }
        (0, _vue.onBeforeUnmount)(anchorCleanup);
        Object.assign(vm.proxy, {
            updatePosition
        });
        return renderPortal;
    }
});
//#endregion
//#region src/components/item/QItem.js
var QItem_default = createComponent({
    name: "QItem",
    props: {
        ...useDarkProps,
        ...useRouterLinkProps,
        tag: {
            type: String,
            default: "div"
        },
        active: {
            type: Boolean,
            default: null
        },
        clickable: Boolean,
        dense: Boolean,
        insetLevel: Number,
        tabindex: [
            String,
            Number
        ],
        focused: Boolean,
        manualFocus: Boolean
    },
    emits: [
        "click",
        "keyup"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const { hasLink, linkAttrs, linkClass, linkTag, navigateOnClick } = useRouterLink();
        const rootRef = (0, _vue.ref)(null);
        const blurTargetRef = (0, _vue.ref)(null);
        const isActionable = (0, _vue.computed)(()=>props.clickable === true || hasLink.value === true || props.tag === "label");
        const isClickable = (0, _vue.computed)(()=>props.disable !== true && isActionable.value === true);
        const classes = (0, _vue.computed)(()=>"q-item q-item-type row no-wrap" + (props.dense === true ? " q-item--dense" : "") + (isDark.value === true ? " q-item--dark" : "") + (hasLink.value === true && props.active === null ? linkClass.value : props.active === true ? ` q-item--active${props.activeClass !== void 0 ? ` ${props.activeClass}` : ""}` : "") + (props.disable === true ? " disabled" : "") + (isClickable.value === true ? " q-item--clickable q-link cursor-pointer " + (props.manualFocus === true ? "q-manual-focusable" : "q-focusable q-hoverable") + (props.focused === true ? " q-manual-focusable--focused" : "") : ""));
        const style = (0, _vue.computed)(()=>{
            if (props.insetLevel === void 0) return null;
            return {
                ["padding" + ($q.lang.rtl === true ? "Right" : "Left")]: 16 + props.insetLevel * 56 + "px"
            };
        });
        function onClick(e) {
            if (isClickable.value === true) {
                if (blurTargetRef.value !== null && e.qAvoidFocus !== true) {
                    if (e.qKeyEvent !== true && document.activeElement === rootRef.value) blurTargetRef.value.focus();
                    else if (document.activeElement === blurTargetRef.value) rootRef.value.focus();
                }
                navigateOnClick(e);
            }
        }
        function onKeyup(e) {
            if (isClickable.value === true && isKeyCode(e, [
                13,
                32
            ]) === true) {
                stopAndPrevent(e);
                e.qKeyEvent = true;
                const evt = new MouseEvent("click", e);
                evt.qKeyEvent = true;
                rootRef.value.dispatchEvent(evt);
            }
            emit("keyup", e);
        }
        function getContent() {
            const child = hUniqueSlot(slots.default, []);
            if (isClickable.value === true) child.unshift((0, _vue.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: blurTargetRef
            }));
            return child;
        }
        return ()=>{
            const data = {
                ref: rootRef,
                class: classes.value,
                style: style.value,
                role: "listitem",
                onClick,
                onKeyup
            };
            if (isClickable.value === true) {
                data.tabindex = props.tabindex || "0";
                Object.assign(data, linkAttrs.value);
            } else if (isActionable.value === true) data["aria-disabled"] = "true";
            return (0, _vue.h)(linkTag.value, data, getContent());
        };
    }
});
//#endregion
//#region src/components/item/QItemSection.js
var QItemSection_default = createComponent({
    name: "QItemSection",
    props: {
        avatar: Boolean,
        thumbnail: Boolean,
        side: Boolean,
        top: Boolean,
        noWrap: Boolean
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>`q-item__section column q-item__section--${props.avatar === true || props.side === true || props.thumbnail === true ? "side" : "main"}` + (props.top === true ? " q-item__section--top justify-start" : " justify-center") + (props.avatar === true ? " q-item__section--avatar" : "") + (props.thumbnail === true ? " q-item__section--thumbnail" : "") + (props.noWrap === true ? " q-item__section--nowrap" : ""));
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/editor/editor-utils.js
function run(e, btn, eVm) {
    if (btn.handler) btn.handler(e, eVm, eVm.caret);
    else eVm.runCmd(btn.cmd, btn.param);
}
function getGroup(children) {
    return (0, _vue.h)("div", {
        class: "q-editor__toolbar-group"
    }, children);
}
function getBtn(eVm, btn, clickHandler, active = false) {
    const toggled = active || (btn.type === "toggle" ? btn.toggled ? btn.toggled(eVm) : btn.cmd && eVm.caret.is(btn.cmd, btn.param) : false), child = [];
    if (eVm.$q.platform.is.desktop && (btn.tip || btn.htmlTip)) {
        const Key = btn.key ? (0, _vue.h)("div", [
            (0, _vue.h)("small", `(CTRL + ${String.fromCharCode(btn.key)})`)
        ]) : null;
        child.push((0, _vue.h)(QTooltip_default, {
            delay: 1e3
        }, ()=>[
                (0, _vue.h)("div", btn.htmlTip ? {
                    innerHTML: btn.htmlTip
                } : btn.tip),
                Key
            ]));
    }
    return (0, _vue.h)(QBtn_default, {
        ...eVm.buttonProps.value,
        icon: btn.icon !== null ? btn.icon : void 0,
        color: toggled ? btn.toggleColor || eVm.props.toolbarToggleColor : btn.color || eVm.props.toolbarColor,
        textColor: toggled && !eVm.props.toolbarPush ? null : btn.textColor || eVm.props.toolbarTextColor,
        label: btn.label,
        "aria-label": btn.label === null ? btn.tip : void 0,
        disable: btn.disable ? typeof btn.disable === "function" ? btn.disable(eVm) : true : false,
        size: "sm",
        onClick (e) {
            clickHandler?.();
            run(e, btn, eVm);
        }
    }, ()=>child);
}
function getDropdown(eVm, btn) {
    const onlyIcons = btn.list === "only-icons";
    let label = btn.label, icon = btn.icon !== null ? btn.icon : void 0, contentClass, Items;
    function closeDropdown() {
        Dropdown.component.proxy.hide();
    }
    if (onlyIcons) {
        Items = btn.options.map((localBtn)=>{
            const active = localBtn.type === void 0 ? eVm.caret.is(localBtn.cmd, localBtn.param) : false;
            if (active) {
                label = localBtn.tip;
                icon = localBtn.icon !== null ? localBtn.icon : void 0;
            }
            return getBtn(eVm, localBtn, closeDropdown, active);
        });
        contentClass = eVm.toolbarBackgroundClass.value;
        Items = [
            getGroup(Items)
        ];
    } else {
        const activeClass = eVm.props.toolbarToggleColor !== void 0 ? `text-${eVm.props.toolbarToggleColor}` : null;
        const inactiveClass = eVm.props.toolbarTextColor !== void 0 ? `text-${eVm.props.toolbarTextColor}` : null;
        const noIcons = btn.list === "no-icons";
        Items = btn.options.map((localBtn)=>{
            const disable = localBtn.disable ? localBtn.disable(eVm) : false;
            const active = localBtn.type === void 0 ? eVm.caret.is(localBtn.cmd, localBtn.param) : false;
            if (active) {
                label = localBtn.tip;
                icon = localBtn.icon !== null ? localBtn.icon : void 0;
            }
            const htmlTip = localBtn.htmlTip;
            return (0, _vue.h)(QItem_default, {
                active,
                activeClass,
                clickable: true,
                disable,
                dense: true,
                onClick (e) {
                    closeDropdown();
                    if (e?.qAvoidFocus !== true) eVm.contentRef.value?.focus();
                    eVm.caret.restore();
                    run(e, localBtn, eVm);
                }
            }, ()=>[
                    noIcons === true ? null : (0, _vue.h)(QItemSection_default, {
                        class: active ? activeClass : inactiveClass,
                        side: true
                    }, ()=>(0, _vue.h)(QIcon_default, {
                            name: localBtn.icon !== null ? localBtn.icon : void 0
                        })),
                    (0, _vue.h)(QItemSection_default, htmlTip ? ()=>(0, _vue.h)("div", {
                            class: "text-no-wrap",
                            innerHTML: localBtn.htmlTip
                        }) : localBtn.tip ? ()=>(0, _vue.h)("div", {
                            class: "text-no-wrap"
                        }, localBtn.tip) : void 0)
                ]);
        });
        contentClass = [
            eVm.toolbarBackgroundClass.value,
            inactiveClass
        ];
    }
    const highlight = btn.highlight && label !== btn.label;
    const Dropdown = (0, _vue.h)(QBtnDropdown_default, {
        ...eVm.buttonProps.value,
        noCaps: true,
        noWrap: true,
        color: highlight ? eVm.props.toolbarToggleColor : eVm.props.toolbarColor,
        textColor: highlight && !eVm.props.toolbarPush ? null : eVm.props.toolbarTextColor,
        label: btn.fixedLabel ? btn.label : label,
        icon: btn.fixedIcon ? btn.icon !== null ? btn.icon : void 0 : icon,
        contentClass,
        onShow: (evt)=>eVm.emit("dropdownShow", evt),
        onHide: (evt)=>eVm.emit("dropdownHide", evt),
        onBeforeShow: (evt)=>eVm.emit("dropdownBeforeShow", evt),
        onBeforeHide: (evt)=>eVm.emit("dropdownBeforeHide", evt)
    }, ()=>Items);
    return Dropdown;
}
function getToolbar(eVm) {
    if (eVm.caret) return eVm.buttons.value.filter((f)=>!eVm.isViewingSource.value || f.find((fb)=>fb.cmd === "viewsource")).map((group)=>getGroup(group.map((btn)=>{
            if (eVm.isViewingSource.value && btn.cmd !== "viewsource") return false;
            if (btn.type === "slot") return hSlot(eVm.slots[btn.slot]);
            if (btn.type === "dropdown") return getDropdown(eVm, btn);
            return getBtn(eVm, btn);
        })));
}
function getFonts(defaultFont, defaultFontLabel, defaultFontIcon, fonts = {}) {
    const aliases = Object.keys(fonts);
    if (aliases.length === 0) return {};
    const def = {
        default_font: {
            cmd: "fontName",
            param: defaultFont,
            icon: defaultFontIcon,
            tip: defaultFontLabel
        }
    };
    aliases.forEach((alias)=>{
        const name = fonts[alias];
        def[alias] = {
            cmd: "fontName",
            param: name,
            icon: defaultFontIcon,
            tip: name,
            htmlTip: `<font face="${name}">${name}</font>`
        };
    });
    return def;
}
function getLinkEditor(eVm) {
    if (eVm.caret) {
        const color = eVm.props.toolbarColor || eVm.props.toolbarTextColor;
        let link = eVm.editLinkUrl.value;
        const updateLink = ()=>{
            eVm.caret.restore();
            if (link !== eVm.editLinkUrl.value) document.execCommand("createLink", false, link === "" ? " " : link);
            eVm.editLinkUrl.value = null;
        };
        return [
            (0, _vue.h)("div", {
                class: `q-mx-xs text-${color}`
            }, `${eVm.$q.lang.editor.url}: `),
            (0, _vue.h)("input", {
                key: "qedt_btm_input",
                class: "col q-editor__link-input",
                value: link,
                onInput: (evt)=>{
                    stop(evt);
                    link = evt.target.value;
                },
                onKeydown: (evt)=>{
                    if (shouldIgnoreKey(evt) === true) return;
                    switch(evt.keyCode){
                        case 13:
                            prevent(evt);
                            return updateLink();
                        case 27:
                            prevent(evt);
                            eVm.caret.restore();
                            if (!eVm.editLinkUrl.value || eVm.editLinkUrl.value === "https://") document.execCommand("unlink");
                            eVm.editLinkUrl.value = null;
                            break;
                    }
                }
            }),
            getGroup([
                (0, _vue.h)(QBtn_default, {
                    key: "qedt_btm_rem",
                    ...eVm.buttonProps.value,
                    label: eVm.$q.lang.label.remove,
                    noCaps: true,
                    onClick: ()=>{
                        eVm.caret.restore();
                        document.execCommand("unlink");
                        eVm.editLinkUrl.value = null;
                    }
                }),
                (0, _vue.h)(QBtn_default, {
                    key: "qedt_btm_upd",
                    ...eVm.buttonProps.value,
                    label: eVm.$q.lang.label.update,
                    noCaps: true,
                    onClick: updateLink
                })
            ])
        ];
    }
}
//#endregion
//#region src/composables/use-split-attrs/use-split-attrs.js
const listenerRE = /^on[A-Z]/;
function useSplitAttrs() {
    const { attrs, vnode } = (0, _vue.getCurrentInstance)();
    const acc = {
        listeners: (0, _vue.ref)({}),
        attributes: (0, _vue.ref)({})
    };
    function update() {
        const attributes = {};
        const listeners = {};
        for(const key in attrs)if (key !== "class" && key !== "style" && listenerRE.test(key) === false) attributes[key] = attrs[key];
        for(const key in vnode.props)if (listenerRE.test(key) === true) listeners[key] = vnode.props[key];
        acc.attributes.value = attributes;
        acc.listeners.value = listeners;
    }
    (0, _vue.onBeforeUpdate)(update);
    update();
    return acc;
}
//#endregion
//#region src/utils/extend/extend.js
const toString = Object.prototype.toString, hasOwn = Object.prototype.hasOwnProperty, notPlainObject = new Set([
    "Boolean",
    "Number",
    "String",
    "Function",
    "Array",
    "Date",
    "RegExp"
].map((name)=>"[object " + name + "]"));
function isPlainObject(obj) {
    if (obj !== Object(obj) || notPlainObject.has(toString.call(obj)) === true) return false;
    if (obj.constructor && hasOwn.call(obj, "constructor") === false && hasOwn.call(obj.constructor.prototype, "isPrototypeOf") === false) return false;
    let key;
    for(key in obj);
    return key === void 0 || hasOwn.call(obj, key);
}
function extend() {
    let options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, deep = false;
    const length = arguments.length;
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        i = 2;
    }
    if (Object(target) !== target && typeof target !== "function") target = {};
    if (length === i) {
        target = this;
        i--;
    }
    for(; i < length; i++)if ((options = arguments[i]) !== null) for(name in options){
        src = target[name];
        copy = options[name];
        if (target === copy) continue;
        if (deep === true && copy && ((copyIsArray = Array.isArray(copy)) || isPlainObject(copy) === true)) {
            if (copyIsArray === true) clone = Array.isArray(src) === true ? src : [];
            else clone = isPlainObject(src) === true ? src : {};
            target[name] = extend(deep, clone, copy);
        } else if (copy !== void 0) target[name] = copy;
    }
    return target;
}
//#endregion
//#region src/components/editor/QEditor.js
var QEditor_default = createComponent({
    name: "QEditor",
    props: {
        ...useDarkProps,
        ...useFullscreenProps,
        modelValue: {
            type: String,
            required: true
        },
        readonly: Boolean,
        disable: Boolean,
        minHeight: {
            type: String,
            default: "10rem"
        },
        maxHeight: String,
        height: String,
        definitions: Object,
        fonts: Object,
        placeholder: String,
        toolbar: {
            type: Array,
            validator: (v)=>v.length === 0 || v.every((group)=>group.length),
            default: ()=>[
                    [
                        "left",
                        "center",
                        "right",
                        "justify"
                    ],
                    [
                        "bold",
                        "italic",
                        "underline",
                        "strike"
                    ],
                    [
                        "undo",
                        "redo"
                    ]
                ]
        },
        toolbarColor: String,
        toolbarBg: String,
        toolbarTextColor: String,
        toolbarToggleColor: {
            type: String,
            default: "primary"
        },
        toolbarOutline: Boolean,
        toolbarPush: Boolean,
        toolbarRounded: Boolean,
        paragraphTag: {
            type: String,
            validator: (v)=>[
                    "div",
                    "p"
                ].includes(v),
            default: "div"
        },
        contentStyle: Object,
        contentClass: [
            Object,
            Array,
            String
        ],
        square: Boolean,
        flat: Boolean,
        dense: Boolean
    },
    emits: [
        ...useFullscreenEmits,
        "update:modelValue",
        "keydown",
        "click",
        "focus",
        "blur",
        "dropdownShow",
        "dropdownHide",
        "dropdownBeforeShow",
        "dropdownBeforeHide",
        "linkShow",
        "linkHide"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const { inFullscreen, toggleFullscreen } = useFullscreen();
        const splitAttrs = useSplitAttrs();
        const rootRef = (0, _vue.ref)(null);
        const contentRef = (0, _vue.ref)(null);
        const editLinkUrl = (0, _vue.ref)(null);
        const isViewingSource = (0, _vue.ref)(false);
        const editable = (0, _vue.computed)(()=>!props.readonly && !props.disable);
        let defaultFont, offsetBottom;
        let lastEmit = props.modelValue;
        document.execCommand("defaultParagraphSeparator", false, props.paragraphTag);
        defaultFont = window.getComputedStyle(document.body).fontFamily;
        const toolbarBackgroundClass = (0, _vue.computed)(()=>props.toolbarBg ? ` bg-${props.toolbarBg}` : "");
        const buttonProps = (0, _vue.computed)(()=>{
            return {
                type: "a",
                flat: props.toolbarOutline !== true && props.toolbarPush !== true,
                noWrap: true,
                outline: props.toolbarOutline,
                push: props.toolbarPush,
                rounded: props.toolbarRounded,
                dense: true,
                color: props.toolbarColor,
                disable: !editable.value,
                size: "sm"
            };
        });
        const buttonDef = (0, _vue.computed)(()=>{
            const e = $q.lang.editor, i = $q.iconSet.editor;
            return {
                bold: {
                    cmd: "bold",
                    icon: i.bold,
                    tip: e.bold,
                    key: 66
                },
                italic: {
                    cmd: "italic",
                    icon: i.italic,
                    tip: e.italic,
                    key: 73
                },
                strike: {
                    cmd: "strikeThrough",
                    icon: i.strikethrough,
                    tip: e.strikethrough,
                    key: 83
                },
                underline: {
                    cmd: "underline",
                    icon: i.underline,
                    tip: e.underline,
                    key: 85
                },
                unordered: {
                    cmd: "insertUnorderedList",
                    icon: i.unorderedList,
                    tip: e.unorderedList
                },
                ordered: {
                    cmd: "insertOrderedList",
                    icon: i.orderedList,
                    tip: e.orderedList
                },
                subscript: {
                    cmd: "subscript",
                    icon: i.subscript,
                    tip: e.subscript,
                    htmlTip: "x<subscript>2</subscript>"
                },
                superscript: {
                    cmd: "superscript",
                    icon: i.superscript,
                    tip: e.superscript,
                    htmlTip: "x<superscript>2</superscript>"
                },
                link: {
                    cmd: "link",
                    disable: (eVm)=>eVm.caret && !eVm.caret.can("link"),
                    icon: i.hyperlink,
                    tip: e.hyperlink,
                    key: 76
                },
                fullscreen: {
                    cmd: "fullscreen",
                    icon: i.toggleFullscreen,
                    tip: e.toggleFullscreen,
                    key: 70
                },
                viewsource: {
                    cmd: "viewsource",
                    icon: i.viewSource,
                    tip: e.viewSource
                },
                quote: {
                    cmd: "formatBlock",
                    param: "BLOCKQUOTE",
                    icon: i.quote,
                    tip: e.quote,
                    key: 81
                },
                left: {
                    cmd: "justifyLeft",
                    icon: i.left,
                    tip: e.left
                },
                center: {
                    cmd: "justifyCenter",
                    icon: i.center,
                    tip: e.center
                },
                right: {
                    cmd: "justifyRight",
                    icon: i.right,
                    tip: e.right
                },
                justify: {
                    cmd: "justifyFull",
                    icon: i.justify,
                    tip: e.justify
                },
                print: {
                    type: "no-state",
                    cmd: "print",
                    icon: i.print,
                    tip: e.print,
                    key: 80
                },
                outdent: {
                    type: "no-state",
                    disable: (eVm)=>eVm.caret && !eVm.caret.can("outdent"),
                    cmd: "outdent",
                    icon: i.outdent,
                    tip: e.outdent
                },
                indent: {
                    type: "no-state",
                    disable: (eVm)=>eVm.caret && !eVm.caret.can("indent"),
                    cmd: "indent",
                    icon: i.indent,
                    tip: e.indent
                },
                removeFormat: {
                    type: "no-state",
                    cmd: "removeFormat",
                    icon: i.removeFormat,
                    tip: e.removeFormat
                },
                hr: {
                    type: "no-state",
                    cmd: "insertHorizontalRule",
                    icon: i.hr,
                    tip: e.hr
                },
                undo: {
                    type: "no-state",
                    cmd: "undo",
                    icon: i.undo,
                    tip: e.undo,
                    key: 90
                },
                redo: {
                    type: "no-state",
                    cmd: "redo",
                    icon: i.redo,
                    tip: e.redo,
                    key: 89
                },
                h1: {
                    cmd: "formatBlock",
                    param: "H1",
                    icon: i.heading1 || i.heading,
                    tip: e.heading1,
                    htmlTip: `<h1 class="q-ma-none">${e.heading1}</h1>`
                },
                h2: {
                    cmd: "formatBlock",
                    param: "H2",
                    icon: i.heading2 || i.heading,
                    tip: e.heading2,
                    htmlTip: `<h2 class="q-ma-none">${e.heading2}</h2>`
                },
                h3: {
                    cmd: "formatBlock",
                    param: "H3",
                    icon: i.heading3 || i.heading,
                    tip: e.heading3,
                    htmlTip: `<h3 class="q-ma-none">${e.heading3}</h3>`
                },
                h4: {
                    cmd: "formatBlock",
                    param: "H4",
                    icon: i.heading4 || i.heading,
                    tip: e.heading4,
                    htmlTip: `<h4 class="q-ma-none">${e.heading4}</h4>`
                },
                h5: {
                    cmd: "formatBlock",
                    param: "H5",
                    icon: i.heading5 || i.heading,
                    tip: e.heading5,
                    htmlTip: `<h5 class="q-ma-none">${e.heading5}</h5>`
                },
                h6: {
                    cmd: "formatBlock",
                    param: "H6",
                    icon: i.heading6 || i.heading,
                    tip: e.heading6,
                    htmlTip: `<h6 class="q-ma-none">${e.heading6}</h6>`
                },
                p: {
                    cmd: "formatBlock",
                    param: props.paragraphTag,
                    icon: i.heading,
                    tip: e.paragraph
                },
                code: {
                    cmd: "formatBlock",
                    param: "PRE",
                    icon: i.code,
                    htmlTip: `<code>${e.code}</code>`
                },
                "size-1": {
                    cmd: "fontSize",
                    param: "1",
                    icon: i.size1 || i.size,
                    tip: e.size1,
                    htmlTip: `<font size="1">${e.size1}</font>`
                },
                "size-2": {
                    cmd: "fontSize",
                    param: "2",
                    icon: i.size2 || i.size,
                    tip: e.size2,
                    htmlTip: `<font size="2">${e.size2}</font>`
                },
                "size-3": {
                    cmd: "fontSize",
                    param: "3",
                    icon: i.size3 || i.size,
                    tip: e.size3,
                    htmlTip: `<font size="3">${e.size3}</font>`
                },
                "size-4": {
                    cmd: "fontSize",
                    param: "4",
                    icon: i.size4 || i.size,
                    tip: e.size4,
                    htmlTip: `<font size="4">${e.size4}</font>`
                },
                "size-5": {
                    cmd: "fontSize",
                    param: "5",
                    icon: i.size5 || i.size,
                    tip: e.size5,
                    htmlTip: `<font size="5">${e.size5}</font>`
                },
                "size-6": {
                    cmd: "fontSize",
                    param: "6",
                    icon: i.size6 || i.size,
                    tip: e.size6,
                    htmlTip: `<font size="6">${e.size6}</font>`
                },
                "size-7": {
                    cmd: "fontSize",
                    param: "7",
                    icon: i.size7 || i.size,
                    tip: e.size7,
                    htmlTip: `<font size="7">${e.size7}</font>`
                }
            };
        });
        const buttons = (0, _vue.computed)(()=>{
            const userDef = props.definitions || {};
            const def = props.definitions || props.fonts ? extend(true, {}, buttonDef.value, userDef, getFonts(defaultFont, $q.lang.editor.defaultFont, $q.iconSet.editor.font, props.fonts)) : buttonDef.value;
            return props.toolbar.map((group)=>group.map((token)=>{
                    if (token.options) return {
                        type: "dropdown",
                        icon: token.icon,
                        label: token.label,
                        size: "sm",
                        dense: true,
                        fixedLabel: token.fixedLabel,
                        fixedIcon: token.fixedIcon,
                        highlight: token.highlight,
                        list: token.list,
                        options: token.options.map((item)=>def[item])
                    };
                    const obj = def[token];
                    if (obj) return obj.type === "no-state" || userDef[token] && (obj.cmd === void 0 || buttonDef.value[obj.cmd] && buttonDef.value[obj.cmd].type === "no-state") ? obj : Object.assign({
                        type: "toggle"
                    }, obj);
                    else return {
                        type: "slot",
                        slot: token
                    };
                }));
        });
        const eVm = {
            $q,
            props,
            slots,
            emit,
            inFullscreen,
            toggleFullscreen,
            runCmd,
            isViewingSource,
            editLinkUrl,
            toolbarBackgroundClass,
            buttonProps,
            contentRef,
            buttons,
            setContent
        };
        (0, _vue.watch)(()=>props.modelValue, (v)=>{
            if (lastEmit !== v) {
                lastEmit = v;
                setContent(v, true);
            }
        });
        (0, _vue.watch)(editLinkUrl, (v)=>{
            emit(`link${v ? "Show" : "Hide"}`);
        });
        const hasToolbar = (0, _vue.computed)(()=>props.toolbar && props.toolbar.length !== 0);
        const keys = (0, _vue.computed)(()=>{
            const k = {}, add = (btn)=>{
                if (btn.key) k[btn.key] = {
                    cmd: btn.cmd,
                    param: btn.param
                };
            };
            buttons.value.forEach((group)=>{
                group.forEach((token)=>{
                    if (token.options) token.options.forEach(add);
                    else add(token);
                });
            });
            return k;
        });
        const innerStyle = (0, _vue.computed)(()=>inFullscreen.value ? props.contentStyle : [
                {
                    minHeight: props.minHeight,
                    height: props.height,
                    maxHeight: props.maxHeight
                },
                props.contentStyle
            ]);
        const classes = (0, _vue.computed)(()=>`q-editor q-editor--${isViewingSource.value === true ? "source" : "default"}` + (props.disable === true ? " disabled" : "") + (inFullscreen.value === true ? " fullscreen column" : "") + (props.square === true ? " q-editor--square no-border-radius" : "") + (props.flat === true ? " q-editor--flat" : "") + (props.dense === true ? " q-editor--dense" : "") + (isDark.value === true ? " q-editor--dark q-dark" : ""));
        const innerClass = (0, _vue.computed)(()=>[
                props.contentClass,
                "q-editor__content",
                {
                    col: inFullscreen.value,
                    "overflow-auto": inFullscreen.value || props.maxHeight
                }
            ]);
        const attributes = (0, _vue.computed)(()=>props.disable === true ? {
                "aria-disabled": "true"
            } : {});
        function onInput() {
            if (contentRef.value !== null) {
                const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
                const val = contentRef.value[prop];
                if (val !== props.modelValue) {
                    lastEmit = val;
                    emit("update:modelValue", val);
                }
            }
        }
        function onKeydown(e) {
            emit("keydown", e);
            if (e.ctrlKey !== true || shouldIgnoreKey(e) === true) {
                refreshToolbar();
                return;
            }
            const key = e.keyCode;
            const target = keys.value[key];
            if (target !== void 0) {
                const { cmd, param } = target;
                stopAndPrevent(e);
                runCmd(cmd, param, false);
            }
        }
        function onClick(e) {
            refreshToolbar();
            emit("click", e);
        }
        function onBlur(e) {
            if (contentRef.value !== null) {
                const { scrollTop, scrollHeight } = contentRef.value;
                offsetBottom = scrollHeight - scrollTop;
            }
            eVm.caret.save();
            emit("blur", e);
        }
        function onFocus(e) {
            (0, _vue.nextTick)(()=>{
                if (contentRef.value !== null && offsetBottom !== void 0) contentRef.value.scrollTop = contentRef.value.scrollHeight - offsetBottom;
            });
            emit("focus", e);
        }
        function onFocusin(e) {
            const root = rootRef.value;
            if (root !== null && root.contains(e.target) === true && (e.relatedTarget === null || root.contains(e.relatedTarget) !== true)) {
                const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
                eVm.caret.restorePosition(contentRef.value[prop].length);
                refreshToolbar();
            }
        }
        function onFocusout(e) {
            const root = rootRef.value;
            if (root !== null && root.contains(e.target) === true && (e.relatedTarget === null || root.contains(e.relatedTarget) !== true)) {
                eVm.caret.savePosition();
                refreshToolbar();
            }
        }
        function onPointerStart() {
            offsetBottom = void 0;
        }
        function onSelectionchange() {
            eVm.caret.save();
        }
        function setContent(v, restorePosition) {
            if (contentRef.value !== null) {
                if (restorePosition === true) eVm.caret.savePosition();
                const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
                contentRef.value[prop] = v;
                if (restorePosition === true) {
                    eVm.caret.restorePosition(contentRef.value[prop].length);
                    refreshToolbar();
                }
            }
        }
        function runCmd(cmd, param, update = true) {
            focus();
            eVm.caret.restore();
            eVm.caret.apply(cmd, param, ()=>{
                focus();
                eVm.caret.save();
                if (update) refreshToolbar();
            });
        }
        function refreshToolbar() {
            setTimeout(()=>{
                editLinkUrl.value = null;
                proxy.$forceUpdate();
            }, 1);
        }
        function focus() {
            addFocusFn(()=>{
                contentRef.value?.focus({
                    preventScroll: true
                });
            });
        }
        function getContentEl() {
            return contentRef.value;
        }
        (0, _vue.onMounted)(()=>{
            eVm.caret = proxy.caret = new Caret(contentRef.value, eVm);
            setContent(props.modelValue);
            refreshToolbar();
            document.addEventListener("selectionchange", onSelectionchange);
        });
        (0, _vue.onBeforeUnmount)(()=>{
            document.removeEventListener("selectionchange", onSelectionchange);
        });
        Object.assign(proxy, {
            runCmd,
            refreshToolbar,
            focus,
            getContentEl
        });
        return ()=>{
            let toolbars;
            if (hasToolbar.value) {
                const bars = [
                    (0, _vue.h)("div", {
                        key: "qedt_top",
                        class: "q-editor__toolbar row no-wrap scroll-x" + toolbarBackgroundClass.value
                    }, getToolbar(eVm))
                ];
                if (editLinkUrl.value !== null) bars.push((0, _vue.h)("div", {
                    key: "qedt_btm",
                    class: "q-editor__toolbar row no-wrap items-center scroll-x" + toolbarBackgroundClass.value
                }, getLinkEditor(eVm)));
                toolbars = (0, _vue.h)("div", {
                    key: "toolbar_ctainer",
                    class: "q-editor__toolbars-container"
                }, bars);
            }
            return (0, _vue.h)("div", {
                ref: rootRef,
                class: classes.value,
                style: {
                    height: inFullscreen.value === true ? "100%" : null
                },
                ...attributes.value,
                onFocusin,
                onFocusout
            }, [
                toolbars,
                (0, _vue.h)("div", {
                    ref: contentRef,
                    style: innerStyle.value,
                    class: innerClass.value,
                    contenteditable: editable.value,
                    placeholder: props.placeholder,
                    ...splitAttrs.listeners.value,
                    onInput,
                    onKeydown,
                    onClick,
                    onBlur,
                    onFocus,
                    onMousedown: onPointerStart,
                    onTouchstartPassive: onPointerStart
                })
            ]);
        };
    }
});
//#endregion
//#region src/components/item/QItemLabel.js
var QItemLabel_default = createComponent({
    name: "QItemLabel",
    props: {
        overline: Boolean,
        caption: Boolean,
        header: Boolean,
        lines: [
            Number,
            String
        ]
    },
    setup (props, { slots }) {
        const parsedLines = (0, _vue.computed)(()=>parseInt(props.lines, 10));
        const classes = (0, _vue.computed)(()=>"q-item__label" + (props.overline === true ? " q-item__label--overline text-overline" : "") + (props.caption === true ? " q-item__label--caption text-caption" : "") + (props.header === true ? " q-item__label--header" : "") + (parsedLines.value === 1 ? " ellipsis" : ""));
        const style = (0, _vue.computed)(()=>props.lines !== void 0 && parsedLines.value > 1 ? {
                overflow: "hidden",
                display: "-webkit-box",
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": parsedLines.value
            } : null);
        return ()=>(0, _vue.h)("div", {
                style: style.value,
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/slide-transition/QSlideTransition.js
var QSlideTransition_default = createComponent({
    name: "QSlideTransition",
    props: {
        appear: Boolean,
        duration: {
            type: Number,
            default: 300
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup (props, { slots, emit }) {
        let animating = false, doneFn, element;
        let timer = null, timerFallback = null, animListener, lastEvent;
        function cleanup() {
            doneFn?.();
            doneFn = null;
            animating = false;
            if (timer !== null) {
                clearTimeout(timer);
                timer = null;
            }
            if (timerFallback !== null) {
                clearTimeout(timerFallback);
                timerFallback = null;
            }
            element?.removeEventListener("transitionend", animListener);
            animListener = null;
        }
        function begin(el, height, done) {
            if (height !== void 0) el.style.height = `${height}px`;
            el.style.transition = `height ${props.duration}ms cubic-bezier(.25, .8, .50, 1)`;
            animating = true;
            doneFn = done;
        }
        function end(el, event) {
            el.style.overflowY = null;
            el.style.height = null;
            el.style.transition = null;
            cleanup();
            if (event !== lastEvent) emit(event);
        }
        function onEnter(el, done) {
            let pos = 0;
            element = el;
            if (animating === true) {
                cleanup();
                pos = el.offsetHeight === el.scrollHeight ? 0 : void 0;
            } else {
                lastEvent = "hide";
                el.style.overflowY = "hidden";
            }
            begin(el, pos, done);
            timer = setTimeout(()=>{
                timer = null;
                el.style.height = `${el.scrollHeight}px`;
                animListener = (evt)=>{
                    timerFallback = null;
                    if (Object(evt) !== evt || evt.target === el) end(el, "show");
                };
                el.addEventListener("transitionend", animListener);
                timerFallback = setTimeout(animListener, props.duration * 1.1);
            }, 100);
        }
        function onLeave(el, done) {
            let pos;
            element = el;
            if (animating === true) cleanup();
            else {
                lastEvent = "show";
                el.style.overflowY = "hidden";
                pos = el.scrollHeight;
            }
            begin(el, pos, done);
            timer = setTimeout(()=>{
                timer = null;
                el.style.height = 0;
                animListener = (evt)=>{
                    timerFallback = null;
                    if (Object(evt) !== evt || evt.target === el) end(el, "hide");
                };
                el.addEventListener("transitionend", animListener);
                timerFallback = setTimeout(animListener, props.duration * 1.1);
            }, 100);
        }
        (0, _vue.onBeforeUnmount)(()=>{
            if (animating === true) cleanup();
        });
        return ()=>(0, _vue.h)((0, _vue.Transition), {
                css: false,
                appear: props.appear,
                onEnter,
                onLeave
            }, slots.default);
    }
});
//#endregion
//#region src/components/separator/QSeparator.js
const insetMap = {
    true: "inset",
    item: "item-inset",
    "item-thumbnail": "item-thumbnail-inset"
};
const margins = {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 24
};
var QSeparator_default = createComponent({
    name: "QSeparator",
    props: {
        ...useDarkProps,
        spaced: [
            Boolean,
            String
        ],
        inset: [
            Boolean,
            String
        ],
        vertical: Boolean,
        color: String,
        size: String
    },
    setup (props) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const orientation = (0, _vue.computed)(()=>props.vertical === true ? "vertical" : "horizontal");
        const orientClass = (0, _vue.computed)(()=>` q-separator--${orientation.value}`);
        const insetClass = (0, _vue.computed)(()=>props.inset !== false ? `${orientClass.value}-${insetMap[props.inset]}` : "");
        const classes = (0, _vue.computed)(()=>`q-separator${orientClass.value}${insetClass.value}` + (props.color !== void 0 ? ` bg-${props.color}` : "") + (isDark.value === true ? " q-separator--dark" : ""));
        const style = (0, _vue.computed)(()=>{
            const acc = {};
            if (props.size !== void 0) acc[props.vertical === true ? "width" : "height"] = props.size;
            if (props.spaced !== false) {
                const size = props.spaced === true ? `${margins.md}px` : props.spaced in margins ? `${margins[props.spaced]}px` : props.spaced;
                const dir = props.vertical === true ? [
                    "Left",
                    "Right"
                ] : [
                    "Top",
                    "Bottom"
                ];
                acc[`margin${dir[0]}`] = acc[`margin${dir[1]}`] = size;
            }
            return acc;
        });
        return ()=>(0, _vue.h)("hr", {
                class: classes.value,
                style: style.value,
                "aria-orientation": orientation.value
            });
    }
});
//#endregion
//#region src/components/expansion-item/QExpansionItem.js
const itemGroups = (0, _vue.shallowReactive)({});
const LINK_PROPS = Object.keys(useRouterLinkProps);
var QExpansionItem_default = createComponent({
    name: "QExpansionItem",
    props: {
        ...useRouterLinkProps,
        ...useModelToggleProps,
        ...useDarkProps,
        icon: String,
        label: String,
        labelLines: [
            Number,
            String
        ],
        caption: String,
        captionLines: [
            Number,
            String
        ],
        dense: Boolean,
        toggleAriaLabel: String,
        expandIcon: String,
        expandedIcon: String,
        expandIconClass: [
            Array,
            String,
            Object
        ],
        duration: {},
        headerInsetLevel: Number,
        contentInsetLevel: Number,
        expandSeparator: Boolean,
        defaultOpened: Boolean,
        hideExpandIcon: Boolean,
        expandIconToggle: Boolean,
        switchToggleSide: Boolean,
        denseToggle: Boolean,
        group: String,
        popup: Boolean,
        headerStyle: [
            Array,
            String,
            Object
        ],
        headerClass: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...useModelToggleEmits,
        "click",
        "afterShow",
        "afterHide"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const showing = (0, _vue.ref)(props.modelValue !== null ? props.modelValue : props.defaultOpened);
        const blurTargetRef = (0, _vue.ref)(null);
        const targetUid = useId();
        const { show, hide, toggle } = useModelToggle({
            showing
        });
        let uniqueId, exitGroup;
        const classes = (0, _vue.computed)(()=>`q-expansion-item q-item-type q-expansion-item--${showing.value === true ? "expanded" : "collapsed"} q-expansion-item--${props.popup === true ? "popup" : "standard"}`);
        const contentStyle = (0, _vue.computed)(()=>{
            if (props.contentInsetLevel === void 0) return null;
            return {
                ["padding" + ($q.lang.rtl === true ? "Right" : "Left")]: props.contentInsetLevel * 56 + "px"
            };
        });
        const hasLink = (0, _vue.computed)(()=>props.disable !== true && (props.href !== void 0 || props.to !== void 0 && props.to !== null && props.to !== ""));
        const linkProps = (0, _vue.computed)(()=>{
            const acc = {};
            LINK_PROPS.forEach((key)=>{
                acc[key] = props[key];
            });
            return acc;
        });
        const isClickable = (0, _vue.computed)(()=>hasLink.value === true || props.expandIconToggle !== true);
        const expansionIcon = (0, _vue.computed)(()=>props.expandedIcon !== void 0 && showing.value === true ? props.expandedIcon : props.expandIcon || $q.iconSet.expansionItem[props.denseToggle === true ? "denseIcon" : "icon"]);
        const activeToggleIcon = (0, _vue.computed)(()=>props.disable !== true && (hasLink.value === true || props.expandIconToggle === true));
        const headerSlotScope = (0, _vue.computed)(()=>({
                expanded: showing.value === true,
                detailsId: targetUid.value,
                toggle,
                show,
                hide
            }));
        const toggleAriaAttrs = (0, _vue.computed)(()=>{
            const toggleAriaLabel = props.toggleAriaLabel !== void 0 ? props.toggleAriaLabel : $q.lang.label[showing.value === true ? "collapse" : "expand"](props.label);
            return {
                role: "button",
                "aria-expanded": showing.value === true ? "true" : "false",
                "aria-controls": targetUid.value,
                "aria-label": toggleAriaLabel
            };
        });
        (0, _vue.watch)(()=>props.group, (name)=>{
            exitGroup?.();
            if (name !== void 0) enterGroup();
        });
        function onHeaderClick(e) {
            if (hasLink.value !== true) toggle(e);
            emit("click", e);
        }
        function toggleIconKeyboard(e) {
            if (e.keyCode === 13) toggleIcon(e, true);
        }
        function toggleIcon(e, keyboard) {
            if (keyboard !== true && e.qAvoidFocus !== true) blurTargetRef.value?.focus();
            toggle(e);
            stopAndPrevent(e);
        }
        function onShow() {
            emit("afterShow");
        }
        function onHide() {
            emit("afterHide");
        }
        function enterGroup() {
            if (uniqueId === void 0) uniqueId = uid();
            if (showing.value === true) itemGroups[props.group] = uniqueId;
            const stopShowWatcher = (0, _vue.watch)(showing, (val)=>{
                if (val === true) itemGroups[props.group] = uniqueId;
                else if (itemGroups[props.group] === uniqueId) delete itemGroups[props.group];
            });
            const stopGroupWatcher = (0, _vue.watch)(()=>itemGroups[props.group], (val, oldVal)=>{
                if (oldVal === uniqueId && val !== void 0 && val !== uniqueId) hide();
            });
            exitGroup = ()=>{
                stopShowWatcher();
                stopGroupWatcher();
                if (itemGroups[props.group] === uniqueId) delete itemGroups[props.group];
                exitGroup = void 0;
            };
        }
        function getToggleIcon() {
            const data = {
                class: [
                    `q-focusable relative-position cursor-pointer${props.denseToggle === true && props.switchToggleSide === true ? " items-end" : ""}`,
                    props.expandIconClass
                ],
                side: props.switchToggleSide !== true,
                avatar: props.switchToggleSide
            };
            const child = [
                (0, _vue.h)(QIcon_default, {
                    class: "q-expansion-item__toggle-icon" + (props.expandedIcon === void 0 && showing.value === true ? " q-expansion-item__toggle-icon--rotated" : ""),
                    name: expansionIcon.value
                })
            ];
            if (activeToggleIcon.value === true) {
                Object.assign(data, {
                    tabindex: 0,
                    ...toggleAriaAttrs.value,
                    onClick: toggleIcon,
                    onKeyup: toggleIconKeyboard
                });
                child.unshift((0, _vue.h)("div", {
                    ref: blurTargetRef,
                    class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
                    tabindex: -1
                }));
            }
            return (0, _vue.h)(QItemSection_default, data, ()=>child);
        }
        function getHeaderChild() {
            let child;
            if (slots.header !== void 0) child = [].concat(slots.header(headerSlotScope.value));
            else {
                child = [
                    (0, _vue.h)(QItemSection_default, ()=>[
                            (0, _vue.h)(QItemLabel_default, {
                                lines: props.labelLines
                            }, ()=>props.label || ""),
                            props.caption ? (0, _vue.h)(QItemLabel_default, {
                                lines: props.captionLines,
                                caption: true
                            }, ()=>props.caption) : null
                        ])
                ];
                if (props.icon) child[props.switchToggleSide === true ? "push" : "unshift"]((0, _vue.h)(QItemSection_default, {
                    side: props.switchToggleSide === true,
                    avatar: props.switchToggleSide !== true
                }, ()=>(0, _vue.h)(QIcon_default, {
                        name: props.icon
                    })));
            }
            if (props.disable !== true && props.hideExpandIcon !== true) child[props.switchToggleSide === true ? "unshift" : "push"](getToggleIcon());
            return child;
        }
        function getHeader() {
            const data = {
                ref: "item",
                style: props.headerStyle,
                class: props.headerClass,
                dark: isDark.value,
                disable: props.disable,
                dense: props.dense,
                insetLevel: props.headerInsetLevel
            };
            if (isClickable.value === true) {
                data.clickable = true;
                data.onClick = onHeaderClick;
                Object.assign(data, hasLink.value === true ? linkProps.value : toggleAriaAttrs.value);
            }
            return (0, _vue.h)(QItem_default, data, getHeaderChild);
        }
        function getTransitionChild() {
            return (0, _vue.withDirectives)((0, _vue.h)("div", {
                key: "e-content",
                class: "q-expansion-item__content relative-position",
                style: contentStyle.value,
                id: targetUid.value
            }, hSlot(slots.default)), [
                [
                    (0, _vue.vShow),
                    showing.value
                ]
            ]);
        }
        function getContent() {
            const node = [
                getHeader(),
                (0, _vue.h)(QSlideTransition_default, {
                    duration: props.duration,
                    onShow,
                    onHide
                }, getTransitionChild)
            ];
            if (props.expandSeparator === true) node.push((0, _vue.h)(QSeparator_default, {
                class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
                dark: isDark.value
            }), (0, _vue.h)(QSeparator_default, {
                class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
                dark: isDark.value
            }));
            return node;
        }
        if (props.group !== void 0) enterGroup();
        (0, _vue.onBeforeUnmount)(()=>{
            exitGroup?.();
        });
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, [
                (0, _vue.h)("div", {
                    class: "q-expansion-item__container relative-position"
                }, getContent())
            ]);
    }
});
//#endregion
//#region src/components/fab/use-fab.js
const labelPositions = [
    "top",
    "right",
    "bottom",
    "left"
];
const useFabProps = {
    type: {
        type: String,
        default: "a"
    },
    outline: Boolean,
    push: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    square: Boolean,
    padding: String,
    label: {
        type: [
            String,
            Number
        ],
        default: ""
    },
    labelPosition: {
        type: String,
        default: "right",
        validator: (v)=>labelPositions.includes(v)
    },
    externalLabel: Boolean,
    hideLabel: {
        type: Boolean
    },
    labelClass: [
        Array,
        String,
        Object
    ],
    labelStyle: [
        Array,
        String,
        Object
    ],
    disable: Boolean,
    tabindex: [
        Number,
        String
    ]
};
function useFab(props, showing) {
    return {
        formClass: (0, _vue.computed)(()=>`q-fab--form-${props.square === true ? "square" : "rounded"}`),
        stacked: (0, _vue.computed)(()=>props.externalLabel === false && [
                "top",
                "bottom"
            ].includes(props.labelPosition)),
        labelProps: (0, _vue.computed)(()=>{
            if (props.externalLabel === true) {
                const hideLabel = props.hideLabel === null ? showing.value === false : props.hideLabel;
                return {
                    action: "push",
                    data: {
                        class: [
                            props.labelClass,
                            `q-fab__label q-tooltip--style q-fab__label--external q-fab__label--external-${props.labelPosition}` + (hideLabel === true ? " q-fab__label--external-hidden" : "")
                        ],
                        style: props.labelStyle
                    }
                };
            }
            return {
                action: [
                    "left",
                    "top"
                ].includes(props.labelPosition) ? "unshift" : "push",
                data: {
                    class: [
                        props.labelClass,
                        `q-fab__label q-fab__label--internal q-fab__label--internal-${props.labelPosition}` + (props.hideLabel === true ? " q-fab__label--internal-hidden" : "")
                    ],
                    style: props.labelStyle
                }
            };
        })
    };
}
//#endregion
//#region src/components/fab/QFab.js
const directions = [
    "up",
    "right",
    "down",
    "left"
];
const alignValues = [
    "left",
    "center",
    "right"
];
var QFab_default = createComponent({
    name: "QFab",
    props: {
        ...useFabProps,
        ...useModelToggleProps,
        icon: String,
        activeIcon: String,
        hideIcon: Boolean,
        hideLabel: {
            ...useFabProps.hideLabel,
            default: null
        },
        direction: {
            type: String,
            default: "right",
            validator: (v)=>directions.includes(v)
        },
        persistent: Boolean,
        verticalActionsAlign: {
            type: String,
            default: "center",
            validator: (v)=>alignValues.includes(v)
        }
    },
    emits: useModelToggleEmits,
    setup (props, { slots }) {
        const triggerRef = (0, _vue.ref)(null);
        const showing = (0, _vue.ref)(props.modelValue === true);
        const targetUid = useId();
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const { formClass, labelProps } = useFab(props, showing);
        const { hide, toggle } = useModelToggle({
            showing,
            hideOnRouteChange: (0, _vue.computed)(()=>props.persistent !== true)
        });
        const slotScope = (0, _vue.computed)(()=>({
                opened: showing.value
            }));
        const classes = (0, _vue.computed)(()=>`q-fab z-fab row inline justify-center q-fab--align-${props.verticalActionsAlign} ${formClass.value}` + (showing.value === true ? " q-fab--opened" : " q-fab--closed"));
        const actionClass = (0, _vue.computed)(()=>`q-fab__actions flex no-wrap inline q-fab__actions--${props.direction} q-fab__actions--${showing.value === true ? "opened" : "closed"}`);
        const actionAttrs = (0, _vue.computed)(()=>{
            const attrs = {
                id: targetUid.value,
                role: "menu"
            };
            if (showing.value !== true) attrs["aria-hidden"] = "true";
            return attrs;
        });
        const iconHolderClass = (0, _vue.computed)(()=>`q-fab__icon-holder  q-fab__icon-holder--${showing.value === true ? "opened" : "closed"}`);
        function getIcon(kebab, camel) {
            const slotFn = slots[kebab];
            const localClass = `q-fab__${kebab} absolute-full`;
            return slotFn === void 0 ? (0, _vue.h)(QIcon_default, {
                class: localClass,
                name: props[camel] || $q.iconSet.fab[camel]
            }) : (0, _vue.h)("div", {
                class: localClass
            }, slotFn(slotScope.value));
        }
        function getTriggerContent() {
            const child = [];
            if (props.hideIcon !== true) child.push((0, _vue.h)("div", {
                class: iconHolderClass.value
            }, [
                getIcon("icon", "icon"),
                getIcon("active-icon", "activeIcon")
            ]));
            if (props.label !== "" || slots.label !== void 0) child[labelProps.value.action]((0, _vue.h)("div", labelProps.value.data, slots.label !== void 0 ? slots.label(slotScope.value) : [
                props.label
            ]));
            return hMergeSlot(slots.tooltip, child);
        }
        (0, _vue.provide)(fabKey, {
            showing,
            onChildClick (evt) {
                hide(evt);
                if (evt?.qAvoidFocus !== true) triggerRef.value?.$el.focus();
            }
        });
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, [
                (0, _vue.h)(QBtn_default, {
                    ref: triggerRef,
                    class: formClass.value,
                    ...props,
                    noWrap: true,
                    stack: props.stacked,
                    align: void 0,
                    icon: void 0,
                    label: void 0,
                    noCaps: true,
                    fab: true,
                    "aria-expanded": showing.value === true ? "true" : "false",
                    "aria-haspopup": "true",
                    "aria-controls": targetUid.value,
                    onClick: toggle
                }, getTriggerContent),
                (0, _vue.h)("div", {
                    class: actionClass.value,
                    ...actionAttrs.value
                }, hSlot(slots.default))
            ]);
    }
});
//#endregion
//#region src/components/fab/QFabAction.js
const anchorMap = {
    start: "self-end",
    center: "self-center",
    end: "self-start"
};
const anchorValues = Object.keys(anchorMap);
var QFabAction_default = createComponent({
    name: "QFabAction",
    props: {
        ...useFabProps,
        icon: {
            type: String,
            default: ""
        },
        anchor: {
            type: String,
            validator: (v)=>anchorValues.includes(v)
        },
        to: [
            String,
            Object
        ],
        replace: Boolean
    },
    emits: [
        "click"
    ],
    setup (props, { slots, emit }) {
        const $fab = (0, _vue.inject)(fabKey, ()=>({
                showing: {
                    value: true
                },
                onChildClick: noop
            }));
        const { formClass, labelProps } = useFab(props, $fab.showing);
        const classes = (0, _vue.computed)(()=>{
            const align = anchorMap[props.anchor];
            return formClass.value + (align !== void 0 ? ` ${align}` : "");
        });
        const isDisabled = (0, _vue.computed)(()=>props.disable === true || $fab.showing.value !== true);
        function click(e) {
            $fab.onChildClick(e);
            emit("click", e);
        }
        function getContent() {
            const child = [];
            if (slots.icon !== void 0) child.push(slots.icon());
            else if (props.icon !== "") child.push((0, _vue.h)(QIcon_default, {
                name: props.icon
            }));
            if (props.label !== "" || slots.label !== void 0) child[labelProps.value.action]((0, _vue.h)("div", labelProps.value.data, slots.label !== void 0 ? slots.label() : [
                props.label
            ]));
            return hMergeSlot(slots.default, child);
        }
        const vm = (0, _vue.getCurrentInstance)();
        Object.assign(vm.proxy, {
            click
        });
        return ()=>(0, _vue.h)(QBtn_default, {
                class: classes.value,
                ...props,
                noWrap: true,
                stack: props.stacked,
                icon: void 0,
                label: void 0,
                noCaps: true,
                fabMini: true,
                disable: isDisabled.value,
                onClick: click
            }, getContent);
    }
});
//#endregion
//#region src/composables/use-form/use-form-child.js
function useFormChild({ validate, resetValidation, requiresQForm }) {
    const $form = (0, _vue.inject)(formKey, false);
    if ($form !== false) {
        const { props, proxy } = (0, _vue.getCurrentInstance)();
        Object.assign(proxy, {
            validate,
            resetValidation
        });
        (0, _vue.watch)(()=>props.disable, (val)=>{
            if (val === true) {
                if (typeof resetValidation === "function") resetValidation();
                $form.unbindComponent(proxy);
            } else $form.bindComponent(proxy);
        });
        (0, _vue.onMounted)(()=>{
            if (props.disable !== true) $form.bindComponent(proxy);
        });
        (0, _vue.onBeforeUnmount)(()=>{
            if (props.disable !== true) $form.unbindComponent(proxy);
        });
    } else if (requiresQForm === true) console.error("Parent QForm not found on useFormChild()!");
}
//#endregion
//#region src/composables/private.use-validate/use-validate.js
const lazyRulesValues = [
    true,
    false,
    "ondemand"
];
const useValidateProps = {
    modelValue: {},
    error: {
        type: Boolean,
        default: null
    },
    errorMessage: String,
    noErrorIcon: Boolean,
    rules: Array,
    reactiveRules: Boolean,
    lazyRules: {
        type: [
            Boolean,
            String
        ],
        default: false,
        validator: (v)=>lazyRulesValues.includes(v)
    }
};
function useValidate(focused, innerLoading) {
    const { props, proxy } = (0, _vue.getCurrentInstance)();
    const innerError = (0, _vue.ref)(false);
    const innerErrorMessage = (0, _vue.ref)(null);
    const isDirtyModel = (0, _vue.ref)(false);
    useFormChild({
        validate,
        resetValidation
    });
    let validateIndex = 0, unwatchRules;
    const hasRules = (0, _vue.computed)(()=>props.rules !== void 0 && props.rules !== null && props.rules.length !== 0);
    const canDebounceValidate = (0, _vue.computed)(()=>props.disable !== true && hasRules.value === true && innerLoading.value === false);
    const hasError = (0, _vue.computed)(()=>props.error === true || innerError.value === true);
    const errorMessage = (0, _vue.computed)(()=>typeof props.errorMessage === "string" && props.errorMessage.length !== 0 ? props.errorMessage : innerErrorMessage.value);
    (0, _vue.watch)(()=>props.modelValue, ()=>{
        isDirtyModel.value = true;
        if (canDebounceValidate.value === true && props.lazyRules === false) debouncedValidate();
    });
    function onRulesChange() {
        if (props.lazyRules !== "ondemand" && canDebounceValidate.value === true && isDirtyModel.value === true) debouncedValidate();
    }
    (0, _vue.watch)(()=>props.reactiveRules, (val)=>{
        if (val === true) {
            if (unwatchRules === void 0) unwatchRules = (0, _vue.watch)(()=>props.rules, onRulesChange, {
                immediate: true,
                deep: true
            });
        } else if (unwatchRules !== void 0) {
            unwatchRules();
            unwatchRules = void 0;
        }
    }, {
        immediate: true
    });
    (0, _vue.watch)(()=>props.lazyRules, onRulesChange);
    (0, _vue.watch)(focused, (val)=>{
        if (val === true) isDirtyModel.value = true;
        else if (canDebounceValidate.value === true && props.lazyRules !== "ondemand") debouncedValidate();
    });
    function resetValidation() {
        validateIndex++;
        innerLoading.value = false;
        isDirtyModel.value = false;
        innerError.value = false;
        innerErrorMessage.value = null;
        debouncedValidate.cancel();
    }
    function validate(val = props.modelValue) {
        if (props.disable === true || hasRules.value === false) return true;
        const index = ++validateIndex;
        const setDirty = innerLoading.value !== true ? ()=>{
            isDirtyModel.value = true;
        } : ()=>{};
        const update = (err, msg)=>{
            if (err === true) setDirty();
            innerError.value = err;
            innerErrorMessage.value = msg || null;
            innerLoading.value = false;
        };
        const promises = [];
        for(let i = 0; i < props.rules.length; i++){
            const rule = props.rules[i];
            let res;
            if (typeof rule === "function") res = rule(val, testPattern);
            else if (typeof rule === "string" && testPattern[rule] !== void 0) res = testPattern[rule](val);
            if (res === false || typeof res === "string") {
                update(true, res);
                return false;
            } else if (res !== true && res !== void 0) promises.push(res);
        }
        if (promises.length === 0) {
            update(false);
            return true;
        }
        innerLoading.value = true;
        return Promise.all(promises).then((res)=>{
            if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
                if (index === validateIndex) update(false);
                return true;
            }
            const msg = res.find((r)=>r === false || typeof r === "string");
            if (index === validateIndex) update(msg !== void 0, msg);
            return msg === void 0;
        }, (e)=>{
            if (index === validateIndex) {
                console.error(e);
                update(true);
            }
            return false;
        });
    }
    const debouncedValidate = debounce(validate, 0);
    (0, _vue.onBeforeUnmount)(()=>{
        unwatchRules?.();
        debouncedValidate.cancel();
    });
    Object.assign(proxy, {
        resetValidation,
        validate
    });
    injectProp(proxy, "hasError", ()=>hasError.value);
    return {
        isDirtyModel,
        hasRules,
        hasError,
        errorMessage,
        validate,
        resetValidation
    };
}
//#endregion
//#region src/composables/private.use-field/use-field.js
function fieldValueIsFilled(val) {
    return val !== void 0 && val !== null && String(val).length !== 0;
}
const useNonInputFieldProps = {
    ...useDarkProps,
    ...useValidateProps,
    label: String,
    stackLabel: Boolean,
    hint: String,
    hideHint: Boolean,
    prefix: String,
    suffix: String,
    labelColor: String,
    color: String,
    bgColor: String,
    filled: Boolean,
    outlined: Boolean,
    borderless: Boolean,
    standout: [
        Boolean,
        String
    ],
    square: Boolean,
    loading: Boolean,
    labelSlot: Boolean,
    bottomSlots: Boolean,
    hideBottomSpace: Boolean,
    rounded: Boolean,
    dense: Boolean,
    itemAligned: Boolean,
    counter: Boolean,
    clearable: Boolean,
    clearIcon: String,
    disable: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
    for: String
};
const useFieldProps = {
    ...useNonInputFieldProps,
    maxlength: [
        Number,
        String
    ]
};
const useFieldEmits = [
    "update:modelValue",
    "clear",
    "focus",
    "blur"
];
function useFieldState({ requiredForAttr = true, tagProp, changeEvent = false } = {}) {
    const { props, proxy } = (0, _vue.getCurrentInstance)();
    const isDark = useDark(props, proxy.$q);
    const targetUid = useId({
        required: requiredForAttr,
        getValue: ()=>props.for
    });
    return {
        requiredForAttr,
        changeEvent,
        tag: tagProp === true ? (0, _vue.computed)(()=>props.tag) : {
            value: "label"
        },
        isDark,
        editable: (0, _vue.computed)(()=>props.disable !== true && props.readonly !== true),
        innerLoading: (0, _vue.ref)(false),
        focused: (0, _vue.ref)(false),
        hasPopupOpen: false,
        splitAttrs: useSplitAttrs(),
        targetUid,
        rootRef: (0, _vue.ref)(null),
        targetRef: (0, _vue.ref)(null),
        controlRef: (0, _vue.ref)(null)
    };
}
function useField(state) {
    const { props, emit, slots, attrs, proxy } = (0, _vue.getCurrentInstance)();
    const { $q } = proxy;
    let focusoutTimer = null;
    if (state.hasValue === void 0) state.hasValue = (0, _vue.computed)(()=>fieldValueIsFilled(props.modelValue));
    if (state.emitValue === void 0) state.emitValue = (value1)=>{
        emit("update:modelValue", value1);
    };
    if (state.controlEvents === void 0) state.controlEvents = {
        onFocusin: onControlFocusin,
        onFocusout: onControlFocusout
    };
    Object.assign(state, {
        clearValue,
        onControlFocusin,
        onControlFocusout,
        focus
    });
    if (state.computedCounter === void 0) state.computedCounter = (0, _vue.computed)(()=>{
        if (props.counter !== false) {
            const len = typeof props.modelValue === "string" || typeof props.modelValue === "number" ? String(props.modelValue).length : Array.isArray(props.modelValue) === true ? props.modelValue.length : 0;
            const max = props.maxlength !== void 0 ? props.maxlength : props.maxValues;
            return len + (max !== void 0 ? " / " + max : "");
        }
    });
    const { isDirtyModel, hasRules, hasError, errorMessage, resetValidation } = useValidate(state.focused, state.innerLoading);
    const floatingLabel = state.floatingLabel !== void 0 ? (0, _vue.computed)(()=>props.stackLabel === true || state.focused.value === true || state.floatingLabel.value === true) : (0, _vue.computed)(()=>props.stackLabel === true || state.focused.value === true || state.hasValue.value === true);
    const shouldRenderBottom = (0, _vue.computed)(()=>props.bottomSlots === true || props.hint !== void 0 || hasRules.value === true || props.counter === true || props.error !== null);
    const styleType = (0, _vue.computed)(()=>{
        if (props.filled === true) return "filled";
        if (props.outlined === true) return "outlined";
        if (props.borderless === true) return "borderless";
        if (props.standout) return "standout";
        return "standard";
    });
    const classes = (0, _vue.computed)(()=>`q-field row no-wrap items-start q-field--${styleType.value}` + (state.fieldClass !== void 0 ? ` ${state.fieldClass.value}` : "") + (props.rounded === true ? " q-field--rounded" : "") + (props.square === true ? " q-field--square" : "") + (floatingLabel.value === true ? " q-field--float" : "") + (hasLabel.value === true ? " q-field--labeled" : "") + (props.dense === true ? " q-field--dense" : "") + (props.itemAligned === true ? " q-field--item-aligned q-item-type" : "") + (state.isDark.value === true ? " q-field--dark" : "") + (state.getControl === void 0 ? " q-field--auto-height" : "") + (state.focused.value === true ? " q-field--focused" : "") + (hasError.value === true ? " q-field--error" : "") + (hasError.value === true || state.focused.value === true ? " q-field--highlighted" : "") + (props.hideBottomSpace !== true && shouldRenderBottom.value === true ? " q-field--with-bottom" : "") + (props.disable === true ? " q-field--disabled" : props.readonly === true ? " q-field--readonly" : ""));
    const contentClass = (0, _vue.computed)(()=>"q-field__control relative-position row no-wrap" + (props.bgColor !== void 0 ? ` bg-${props.bgColor}` : "") + (hasError.value === true ? " text-negative" : typeof props.standout === "string" && props.standout.length !== 0 && state.focused.value === true ? ` ${props.standout}` : props.color !== void 0 ? ` text-${props.color}` : ""));
    const hasLabel = (0, _vue.computed)(()=>props.labelSlot === true || props.label !== void 0);
    const labelClass = (0, _vue.computed)(()=>"q-field__label no-pointer-events absolute ellipsis" + (props.labelColor !== void 0 && hasError.value !== true ? ` text-${props.labelColor}` : ""));
    const controlSlotScope = (0, _vue.computed)(()=>({
            id: state.targetUid.value,
            editable: state.editable.value,
            focused: state.focused.value,
            floatingLabel: floatingLabel.value,
            modelValue: props.modelValue,
            emitValue: state.emitValue
        }));
    const attributes = (0, _vue.computed)(()=>{
        const acc = {};
        if (state.targetUid.value) acc.for = state.targetUid.value;
        if (props.disable === true) acc["aria-disabled"] = "true";
        return acc;
    });
    function focusHandler() {
        const el = document.activeElement;
        let target = state.targetRef?.value;
        if (target && (el === null || el.id !== state.targetUid.value)) {
            if (target.hasAttribute("tabindex") !== true) target = target.querySelector("[tabindex]");
            if (target !== el) target?.focus({
                preventScroll: true
            });
        }
    }
    function focus() {
        addFocusFn(focusHandler);
    }
    function blur() {
        removeFocusFn(focusHandler);
        const el = document.activeElement;
        if (el !== null && state.rootRef.value.contains(el)) el.blur();
    }
    function onControlFocusin(e) {
        if (focusoutTimer !== null) {
            clearTimeout(focusoutTimer);
            focusoutTimer = null;
        }
        if (state.editable.value === true && state.focused.value === false) {
            state.focused.value = true;
            emit("focus", e);
        }
    }
    function onControlFocusout(e, then) {
        if (focusoutTimer !== null) clearTimeout(focusoutTimer);
        focusoutTimer = setTimeout(()=>{
            focusoutTimer = null;
            if (document.hasFocus() === true && (state.hasPopupOpen === true || state.controlRef === void 0 || state.controlRef.value === null || state.controlRef.value.contains(document.activeElement) !== false)) return;
            if (state.focused.value === true) {
                state.focused.value = false;
                emit("blur", e);
            }
            then?.();
        });
    }
    function clearValue(e) {
        stopAndPrevent(e);
        if ($q.platform.is.mobile !== true) (state.targetRef?.value || state.rootRef.value).focus();
        else if (state.rootRef.value.contains(document.activeElement) === true) document.activeElement.blur();
        if (props.type === "file") state.inputRef.value.value = null;
        emit("update:modelValue", null);
        if (state.changeEvent === true) emit("change", null);
        emit("clear", props.modelValue);
        (0, _vue.nextTick)(()=>{
            const isDirty = isDirtyModel.value;
            resetValidation();
            isDirtyModel.value = isDirty;
        });
    }
    function onClearableKeyup(evt) {
        if ([
            13,
            32
        ].includes(evt.keyCode)) clearValue(evt);
    }
    function getContent() {
        const node = [];
        if (slots.prepend !== void 0) node.push((0, _vue.h)("div", {
            class: "q-field__prepend q-field__marginal row no-wrap items-center",
            key: "prepend",
            onClick: prevent
        }, slots.prepend()));
        node.push((0, _vue.h)("div", {
            class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
        }, getControlContainer()));
        if (hasError.value === true && props.noErrorIcon === false) node.push(getInnerAppendNode("error", [
            (0, _vue.h)(QIcon_default, {
                name: $q.iconSet.field.error,
                color: "negative"
            })
        ]));
        if (props.loading === true || state.innerLoading.value === true) node.push(getInnerAppendNode("inner-loading-append", slots.loading !== void 0 ? slots.loading() : [
            (0, _vue.h)(QSpinner_default, {
                color: props.color
            })
        ]));
        else if (props.clearable === true && state.hasValue.value === true && state.editable.value === true) node.push(getInnerAppendNode("inner-clearable-append", [
            (0, _vue.h)(QIcon_default, {
                class: "q-field__focusable-action",
                name: props.clearIcon || $q.iconSet.field.clear,
                tabindex: 0,
                role: "button",
                "aria-hidden": "false",
                "aria-label": $q.lang.label.clear,
                onKeyup: onClearableKeyup,
                onClick: clearValue
            })
        ]));
        if (slots.append !== void 0) node.push((0, _vue.h)("div", {
            class: "q-field__append q-field__marginal row no-wrap items-center",
            key: "append",
            onClick: prevent
        }, slots.append()));
        if (state.getInnerAppend !== void 0) node.push(getInnerAppendNode("inner-append", state.getInnerAppend()));
        if (state.getControlChild !== void 0) node.push(state.getControlChild());
        return node;
    }
    function getControlContainer() {
        const node = [];
        if (props.prefix !== void 0 && props.prefix !== null) node.push((0, _vue.h)("div", {
            class: "q-field__prefix no-pointer-events row items-center"
        }, props.prefix));
        if (state.getShadowControl !== void 0 && state.hasShadow.value === true) node.push(state.getShadowControl());
        if (hasLabel.value === true) node.push((0, _vue.h)("div", {
            class: labelClass.value
        }, hSlot(slots.label, props.label)));
        if (state.getControl !== void 0) node.push(state.getControl());
        else if (slots.rawControl !== void 0) node.push(slots.rawControl());
        else if (slots.control !== void 0) node.push((0, _vue.h)("div", {
            ref: state.targetRef,
            class: "q-field__native row",
            tabindex: -1,
            ...state.splitAttrs.attributes.value,
            "data-autofocus": props.autofocus === true || void 0
        }, slots.control(controlSlotScope.value)));
        if (props.suffix !== void 0 && props.suffix !== null) node.push((0, _vue.h)("div", {
            class: "q-field__suffix no-pointer-events row items-center"
        }, props.suffix));
        return node.concat(hSlot(slots.default));
    }
    function getBottom() {
        let msg, key;
        if (hasError.value === true) {
            if (errorMessage.value !== null) {
                msg = [
                    (0, _vue.h)("div", {
                        role: "alert"
                    }, errorMessage.value)
                ];
                key = `q--slot-error-${errorMessage.value}`;
            } else {
                msg = hSlot(slots.error);
                key = "q--slot-error";
            }
        } else if (props.hideHint !== true || state.focused.value === true) {
            if (props.hint !== void 0) {
                msg = [
                    (0, _vue.h)("div", props.hint)
                ];
                key = `q--slot-hint-${props.hint}`;
            } else {
                msg = hSlot(slots.hint);
                key = "q--slot-hint";
            }
        }
        const hasCounter = props.counter === true || slots.counter !== void 0;
        if (props.hideBottomSpace === true && hasCounter === false && msg === void 0) return;
        const main = (0, _vue.h)("div", {
            key,
            class: "q-field__messages col"
        }, msg);
        return (0, _vue.h)("div", {
            class: "q-field__bottom row items-start q-field__bottom--" + (props.hideBottomSpace !== true ? "animated" : "stale"),
            onClick: prevent
        }, [
            props.hideBottomSpace === true ? main : (0, _vue.h)((0, _vue.Transition), {
                name: "q-transition--field-message"
            }, ()=>main),
            hasCounter === true ? (0, _vue.h)("div", {
                class: "q-field__counter"
            }, slots.counter !== void 0 ? slots.counter() : state.computedCounter.value) : null
        ]);
    }
    function getInnerAppendNode(key, content) {
        return content === null ? null : (0, _vue.h)("div", {
            key,
            class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
        }, content);
    }
    let shouldActivate = false;
    (0, _vue.onDeactivated)(()=>{
        shouldActivate = true;
    });
    (0, _vue.onActivated)(()=>{
        if (shouldActivate === true && props.autofocus === true) proxy.focus();
    });
    if (props.autofocus === true) (0, _vue.onMounted)(()=>{
        proxy.focus();
    });
    (0, _vue.onBeforeUnmount)(()=>{
        if (focusoutTimer !== null) clearTimeout(focusoutTimer);
    });
    Object.assign(proxy, {
        focus,
        blur
    });
    return function renderField() {
        const labelAttrs = state.getControl === void 0 && slots.control === void 0 ? {
            ...state.splitAttrs.attributes.value,
            "data-autofocus": props.autofocus === true || void 0,
            ...attributes.value
        } : attributes.value;
        return (0, _vue.h)(state.tag.value, {
            ref: state.rootRef,
            class: [
                classes.value,
                attrs.class
            ],
            style: attrs.style,
            ...labelAttrs
        }, [
            slots.before !== void 0 ? (0, _vue.h)("div", {
                class: "q-field__before q-field__marginal row no-wrap items-center",
                onClick: prevent
            }, slots.before()) : null,
            (0, _vue.h)("div", {
                class: "q-field__inner relative-position col self-stretch"
            }, [
                (0, _vue.h)("div", {
                    ref: state.controlRef,
                    class: contentClass.value,
                    tabindex: -1,
                    ...state.controlEvents
                }, getContent()),
                shouldRenderBottom.value === true ? getBottom() : null
            ]),
            slots.after !== void 0 ? (0, _vue.h)("div", {
                class: "q-field__after q-field__marginal row no-wrap items-center",
                onClick: prevent
            }, slots.after()) : null
        ]);
    };
}
//#endregion
//#region src/components/field/QField.js
var QField_default = createComponent({
    name: "QField",
    inheritAttrs: false,
    props: {
        ...useFieldProps,
        tag: {
            type: String,
            default: "label"
        }
    },
    emits: useFieldEmits,
    setup () {
        return useField(useFieldState({
            tagProp: true
        }));
    }
});
//#endregion
//#region src/composables/private.use-file/use-file.js
function filterFiles(files, rejectedFiles, failedPropValidation, filterFn) {
    const acceptedFiles = [];
    files.forEach((file)=>{
        if (filterFn(file) === true) acceptedFiles.push(file);
        else rejectedFiles.push({
            failedPropValidation,
            file
        });
    });
    return acceptedFiles;
}
function stopAndPreventDrag(e) {
    if (e?.dataTransfer) e.dataTransfer.dropEffect = "copy";
    stopAndPrevent(e);
}
const useFileProps = {
    multiple: Boolean,
    accept: String,
    capture: String,
    maxFileSize: [
        Number,
        String
    ],
    maxTotalSize: [
        Number,
        String
    ],
    maxFiles: [
        Number,
        String
    ],
    filter: Function
};
const useFileEmits = [
    "rejected"
];
function useFile({ editable, dnd, getFileInput, addFilesToQueue }) {
    const { props, emit, proxy } = (0, _vue.getCurrentInstance)();
    const dndRef = (0, _vue.ref)(null);
    const extensions = (0, _vue.computed)(()=>props.accept !== void 0 ? props.accept.split(",").map((ext)=>{
            ext = ext.trim();
            if (ext === "*") return "*/";
            else if (ext.endsWith("/*")) ext = ext.slice(0, ext.length - 1);
            return ext.toUpperCase();
        }) : null);
    const maxFilesNumber = (0, _vue.computed)(()=>parseInt(props.maxFiles, 10));
    const maxTotalSizeNumber = (0, _vue.computed)(()=>parseInt(props.maxTotalSize, 10));
    function pickFiles(e) {
        if (editable.value) {
            if (e !== Object(e)) e = {
                target: null
            };
            if (e.target?.matches('input[type="file"]') === true) {
                if (e.clientX === 0 && e.clientY === 0) stop(e);
            } else {
                const input = getFileInput();
                if (input !== e.target) input?.click(e);
            }
        }
    }
    function addFiles(files) {
        if (editable.value && files) addFilesToQueue(null, files);
    }
    function processFiles(e, filesToProcess, currentFileList, append) {
        let files = Array.from(filesToProcess || e.target.files);
        const rejectedFiles = [];
        const done = ()=>{
            if (rejectedFiles.length !== 0) emit("rejected", rejectedFiles);
        };
        if (props.accept !== void 0 && extensions.value.indexOf("*/") === -1) {
            files = filterFiles(files, rejectedFiles, "accept", (file)=>extensions.value.some((ext)=>file.type.toUpperCase().startsWith(ext) || file.name.toUpperCase().endsWith(ext)));
            if (files.length === 0) return done();
        }
        if (props.maxFileSize !== void 0) {
            const maxFileSize = parseInt(props.maxFileSize, 10);
            files = filterFiles(files, rejectedFiles, "max-file-size", (file)=>file.size <= maxFileSize);
            if (files.length === 0) return done();
        }
        if (props.multiple !== true && files.length !== 0) files = [
            files[0]
        ];
        files.forEach((file)=>{
            file.__key = file.webkitRelativePath + file.lastModified + file.name + file.size;
        });
        if (append === true) {
            const filenameMap = currentFileList.map((entry)=>entry.__key);
            files = filterFiles(files, rejectedFiles, "duplicate", (file)=>filenameMap.includes(file.__key) === false);
        }
        if (files.length === 0) return done();
        if (props.maxTotalSize !== void 0) {
            let size = append === true ? currentFileList.reduce((total, file)=>total + file.size, 0) : 0;
            files = filterFiles(files, rejectedFiles, "max-total-size", (file)=>{
                size += file.size;
                return size <= maxTotalSizeNumber.value;
            });
            if (files.length === 0) return done();
        }
        if (typeof props.filter === "function") {
            const filteredFiles = props.filter(files);
            files = filterFiles(files, rejectedFiles, "filter", (file)=>filteredFiles.includes(file));
        }
        if (props.maxFiles !== void 0) {
            let filesNumber = append === true ? currentFileList.length : 0;
            files = filterFiles(files, rejectedFiles, "max-files", ()=>{
                filesNumber++;
                return filesNumber <= maxFilesNumber.value;
            });
            if (files.length === 0) return done();
        }
        done();
        if (files.length !== 0) return files;
    }
    function onDragover(e) {
        stopAndPreventDrag(e);
        if (dnd.value !== true) dnd.value = true;
    }
    function onDragleave(e) {
        stopAndPrevent(e);
        if ((e.relatedTarget !== null || client.is.safari !== true ? e.relatedTarget !== dndRef.value : document.elementsFromPoint(e.clientX, e.clientY).includes(dndRef.value) === false) === true) dnd.value = false;
    }
    function onDrop(e) {
        stopAndPreventDrag(e);
        const files = e.dataTransfer.files;
        if (files.length !== 0) addFilesToQueue(null, files);
        dnd.value = false;
    }
    function getDndNode(type) {
        if (dnd.value === true) return (0, _vue.h)("div", {
            ref: dndRef,
            class: `q-${type}__dnd absolute-full`,
            onDragenter: stopAndPreventDrag,
            onDragover: stopAndPreventDrag,
            onDragleave,
            onDrop
        });
    }
    Object.assign(proxy, {
        pickFiles,
        addFiles
    });
    return {
        pickFiles,
        addFiles,
        onDragover,
        onDragleave,
        processFiles,
        getDndNode,
        maxFilesNumber,
        maxTotalSizeNumber
    };
}
//#endregion
//#region src/composables/private.use-file/use-file-dom-props.js
function useFileDomProps(props, typeGuard) {
    function getFormDomProps() {
        const model = props.modelValue;
        try {
            const dt = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
            if (Object(model) === model) ("length" in model ? Array.from(model) : [
                model
            ]).forEach((file)=>{
                dt.items.add(file);
            });
            return {
                files: dt.files
            };
        } catch  {
            return {
                files: void 0
            };
        }
    }
    return typeGuard === true ? (0, _vue.computed)(()=>{
        if (props.type !== "file") return;
        return getFormDomProps();
    }) : (0, _vue.computed)(getFormDomProps);
}
//#endregion
//#region src/components/file/QFile.js
var QFile_default = createComponent({
    name: "QFile",
    inheritAttrs: false,
    props: {
        ...useNonInputFieldProps,
        ...useFormProps,
        ...useFileProps,
        modelValue: [
            File,
            FileList,
            Array
        ],
        append: Boolean,
        useChips: Boolean,
        displayValue: [
            String,
            Number
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        counterLabel: Function,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...useFieldEmits,
        ...useFileEmits
    ],
    setup (props, { slots, emit, attrs }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const state = useFieldState();
        const inputRef = (0, _vue.ref)(null);
        const dnd = (0, _vue.ref)(false);
        const nameProp = useFormInputNameAttr(props);
        const { pickFiles, onDragover, onDragleave, processFiles, getDndNode } = useFile({
            editable: state.editable,
            dnd,
            getFileInput,
            addFilesToQueue
        });
        const formDomProps = useFileDomProps(props);
        const innerValue = (0, _vue.computed)(()=>Object(props.modelValue) === props.modelValue ? "length" in props.modelValue ? Array.from(props.modelValue) : [
                props.modelValue
            ] : []);
        const hasValue = (0, _vue.computed)(()=>fieldValueIsFilled(innerValue.value));
        const selectedString = (0, _vue.computed)(()=>innerValue.value.map((file)=>file.name).join(", "));
        const totalSize = (0, _vue.computed)(()=>humanStorageSize(innerValue.value.reduce((acc, file)=>acc + file.size, 0)));
        const counterProps = (0, _vue.computed)(()=>({
                totalSize: totalSize.value,
                filesNumber: innerValue.value.length,
                maxFiles: props.maxFiles
            }));
        const inputAttrs = (0, _vue.computed)(()=>({
                tabindex: -1,
                type: "file",
                title: "",
                accept: props.accept,
                capture: props.capture,
                name: nameProp.value,
                ...attrs,
                id: state.targetUid.value,
                disabled: state.editable.value !== true
            }));
        const fieldClass = (0, _vue.computed)(()=>"q-file q-field--auto-height" + (dnd.value === true ? " q-file--dnd" : ""));
        const isAppending = (0, _vue.computed)(()=>props.multiple === true && props.append === true);
        function removeAtIndex(index) {
            const files = innerValue.value.slice();
            files.splice(index, 1);
            emitValue(files);
        }
        function removeFile(file) {
            const index = innerValue.value.indexOf(file);
            if (index !== -1) removeAtIndex(index);
        }
        function emitValue(files) {
            emit("update:modelValue", props.multiple === true ? files : files[0]);
        }
        function onKeydown(e) {
            if (e.keyCode === 13) prevent(e);
        }
        function onKeyup(e) {
            if (e.keyCode === 13 || e.keyCode === 32) pickFiles(e);
        }
        function getFileInput() {
            return inputRef.value;
        }
        function addFilesToQueue(e, fileList) {
            const files = processFiles(e, fileList, innerValue.value, isAppending.value);
            const fileInput = getFileInput();
            if (fileInput !== void 0 && fileInput !== null) fileInput.value = "";
            if (files === void 0) return;
            if (props.multiple === true ? props.modelValue && files.every((f)=>innerValue.value.includes(f)) : props.modelValue === files[0]) return;
            emitValue(isAppending.value === true ? innerValue.value.concat(files) : files);
        }
        function getFiller() {
            return [
                (0, _vue.h)("input", {
                    class: [
                        props.inputClass,
                        "q-file__filler"
                    ],
                    style: props.inputStyle
                })
            ];
        }
        function getSelection() {
            if (slots.file !== void 0) return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, index)=>slots.file({
                    index,
                    file,
                    ref: this
                }));
            if (slots.selected !== void 0) return innerValue.value.length === 0 ? getFiller() : slots.selected({
                files: innerValue.value,
                ref: this
            });
            if (props.useChips === true) return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, i)=>(0, _vue.h)(QChip_default, {
                    key: "file-" + i,
                    removable: state.editable.value,
                    dense: true,
                    textColor: props.color,
                    tabindex: props.tabindex,
                    onRemove: ()=>{
                        removeAtIndex(i);
                    }
                }, ()=>(0, _vue.h)("span", {
                        class: "ellipsis",
                        textContent: file.name
                    })));
            const textContent = props.displayValue !== void 0 ? props.displayValue : selectedString.value;
            return textContent.length !== 0 ? [
                (0, _vue.h)("div", {
                    class: props.inputClass,
                    style: props.inputStyle,
                    textContent
                })
            ] : getFiller();
        }
        function getInput() {
            const data = {
                ref: inputRef,
                ...inputAttrs.value,
                ...formDomProps.value,
                class: "q-field__input fit absolute-full cursor-pointer",
                onChange: addFilesToQueue
            };
            if (props.multiple === true) data.multiple = true;
            return (0, _vue.h)("input", data);
        }
        Object.assign(state, {
            fieldClass,
            emitValue,
            hasValue,
            inputRef,
            innerValue,
            floatingLabel: (0, _vue.computed)(()=>hasValue.value === true || fieldValueIsFilled(props.displayValue)),
            computedCounter: (0, _vue.computed)(()=>{
                if (props.counterLabel !== void 0) return props.counterLabel(counterProps.value);
                const max = props.maxFiles;
                return `${innerValue.value.length}${max !== void 0 ? " / " + max : ""} (${totalSize.value})`;
            }),
            getControlChild: ()=>getDndNode("file"),
            getControl: ()=>{
                const data = {
                    ref: state.targetRef,
                    class: "q-field__native row items-center cursor-pointer",
                    tabindex: props.tabindex
                };
                if (state.editable.value === true) Object.assign(data, {
                    onDragover,
                    onDragleave,
                    onKeydown,
                    onKeyup
                });
                return (0, _vue.h)("div", data, [
                    getInput()
                ].concat(getSelection()));
            }
        });
        Object.assign(proxy, {
            removeAtIndex,
            removeFile,
            getNativeElement: ()=>inputRef.value
        });
        injectProp(proxy, "nativeEl", ()=>inputRef.value);
        return useField(state);
    }
});
//#endregion
//#region src/components/footer/QFooter.js
var QFooter_default = createComponent({
    name: "QFooter",
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        reveal: Boolean,
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const $layout = (0, _vue.inject)(layoutKey, emptyRenderFn);
        if ($layout === emptyRenderFn) {
            console.error("QFooter needs to be child of QLayout");
            return emptyRenderFn;
        }
        const size = (0, _vue.ref)(parseInt(props.heightHint, 10));
        const revealed = (0, _vue.ref)(true);
        const windowHeight = (0, _vue.ref)(isRuntimeSsrPreHydration.value === true || $layout.isContainer.value === true ? 0 : window.innerHeight);
        const fixed = (0, _vue.computed)(()=>props.reveal === true || $layout.view.value.indexOf("F") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true);
        const containerHeight = (0, _vue.computed)(()=>$layout.isContainer.value === true ? $layout.containerHeight.value : windowHeight.value);
        const offset = (0, _vue.computed)(()=>{
            if (props.modelValue !== true) return 0;
            if (fixed.value === true) return revealed.value === true ? size.value : 0;
            const localOffset = $layout.scroll.value.position + containerHeight.value + size.value - $layout.height.value;
            return localOffset > 0 ? localOffset : 0;
        });
        const hidden = (0, _vue.computed)(()=>props.modelValue !== true || fixed.value === true && revealed.value !== true);
        const revealOnFocus = (0, _vue.computed)(()=>props.modelValue === true && hidden.value === true && props.reveal === true);
        const classes = (0, _vue.computed)(()=>"q-footer q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-bottom" + (props.bordered === true ? " q-footer--bordered" : "") + (hidden.value === true ? " q-footer--hidden" : "") + (props.modelValue !== true ? " q-layout--prevent-focus" + (fixed.value !== true ? " hidden" : "") : ""));
        const style = (0, _vue.computed)(()=>{
            const view = $layout.rows.value.bottom, css = {};
            if (view[0] === "l" && $layout.left.space === true) css[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
            if (view[2] === "r" && $layout.right.space === true) css[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
            return css;
        });
        function updateLayout(prop, val) {
            $layout.update("footer", prop, val);
        }
        function updateLocal(prop, val) {
            if (prop.value !== val) prop.value = val;
        }
        function onResize({ height }) {
            updateLocal(size, height);
            updateLayout("size", height);
        }
        function updateRevealed() {
            if (props.reveal !== true) return;
            const { direction, position, inflectionPoint } = $layout.scroll.value;
            updateLocal(revealed, direction === "up" || position - inflectionPoint < 100 || $layout.height.value - containerHeight.value - position - size.value < 300);
        }
        function onFocusin(evt) {
            if (revealOnFocus.value === true) updateLocal(revealed, true);
            emit("focusin", evt);
        }
        (0, _vue.watch)(()=>props.modelValue, (val)=>{
            updateLayout("space", val);
            updateLocal(revealed, true);
            $layout.animate();
        });
        (0, _vue.watch)(offset, (val)=>{
            updateLayout("offset", val);
        });
        (0, _vue.watch)(()=>props.reveal, (val)=>{
            if (val === false) updateLocal(revealed, props.modelValue);
        });
        (0, _vue.watch)(revealed, (val)=>{
            $layout.animate();
            emit("reveal", val);
        });
        (0, _vue.watch)([
            size,
            $layout.scroll,
            $layout.height
        ], updateRevealed);
        (0, _vue.watch)(()=>$q.screen.height, (val)=>{
            if ($layout.isContainer.value !== true) updateLocal(windowHeight, val);
        });
        const instance = {};
        $layout.instances.footer = instance;
        if (props.modelValue === true) updateLayout("size", size.value);
        updateLayout("space", props.modelValue);
        updateLayout("offset", offset.value);
        (0, _vue.onBeforeUnmount)(()=>{
            if ($layout.instances.footer === instance) {
                $layout.instances.footer = void 0;
                updateLayout("size", 0);
                updateLayout("offset", 0);
                updateLayout("space", false);
            }
        });
        return ()=>{
            const child = hMergeSlot(slots.default, [
                (0, _vue.h)(QResizeObserver_default, {
                    debounce: 0,
                    onResize
                })
            ]);
            if (props.elevated === true) child.push((0, _vue.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            }));
            return (0, _vue.h)("footer", {
                class: classes.value,
                style: style.value,
                onFocusin
            }, child);
        };
    }
});
//#endregion
//#region src/components/form/QForm.js
var QForm_default = createComponent({
    name: "QForm",
    props: {
        autofocus: Boolean,
        noErrorFocus: Boolean,
        noResetFocus: Boolean,
        greedy: Boolean,
        onSubmit: Function
    },
    emits: [
        "reset",
        "validationSuccess",
        "validationError"
    ],
    setup (props, { slots, emit }) {
        const vm = (0, _vue.getCurrentInstance)();
        const rootRef = (0, _vue.ref)(null);
        let validateIndex = 0;
        const registeredComponents = [];
        function validate(shouldFocus) {
            const localFocus = typeof shouldFocus === "boolean" ? shouldFocus : props.noErrorFocus !== true;
            const index = ++validateIndex;
            const emitEvent = (res, compRef)=>{
                emit(`validation${res === true ? "Success" : "Error"}`, compRef);
            };
            const validateComponent = (comp)=>{
                const valid = comp.validate();
                return typeof valid.then === "function" ? valid.then((isValid)=>({
                        valid: isValid,
                        comp
                    }), (err)=>({
                        valid: false,
                        comp,
                        err
                    })) : Promise.resolve({
                    valid,
                    comp
                });
            };
            return (props.greedy === true ? Promise.all(registeredComponents.map(validateComponent)).then((res)=>res.filter((r)=>r.valid !== true)) : registeredComponents.reduce((acc, comp)=>acc.then(()=>validateComponent(comp).then((r)=>{
                        if (r.valid === false) return Promise.reject(r);
                    })), Promise.resolve()).catch((error)=>[
                    error
                ])).then((errors)=>{
                if (errors === void 0 || errors.length === 0) {
                    if (index === validateIndex) emitEvent(true);
                    return true;
                }
                if (index === validateIndex) {
                    const { comp, err } = errors[0];
                    if (err !== void 0) console.error(err);
                    emitEvent(false, comp);
                    if (localFocus === true) {
                        const activeError = errors.find(({ comp: compRef })=>typeof compRef.focus === "function" && vmIsDestroyed(compRef.$) === false);
                        if (activeError !== void 0) activeError.comp.focus();
                    }
                }
                return false;
            });
        }
        function resetValidation() {
            validateIndex++;
            registeredComponents.forEach((comp)=>{
                if (typeof comp.resetValidation === "function") comp.resetValidation();
            });
        }
        function submit(evt) {
            if (evt !== void 0) stopAndPrevent(evt);
            const index = validateIndex + 1;
            validate().then((val)=>{
                if (index === validateIndex && val === true) {
                    if (props.onSubmit !== void 0) emit("submit", evt);
                    else if (evt?.target !== void 0 && typeof evt.target.submit === "function") evt.target.submit();
                }
            });
        }
        function reset(evt) {
            if (evt !== void 0) stopAndPrevent(evt);
            emit("reset");
            (0, _vue.nextTick)(()=>{
                resetValidation();
                if (props.autofocus === true && props.noResetFocus !== true) focus();
            });
        }
        function focus() {
            addFocusFn(()=>{
                if (rootRef.value === null) return;
                (rootRef.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || rootRef.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || rootRef.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(rootRef.value.querySelectorAll("[tabindex]"), (el)=>el.tabIndex !== -1))?.focus({
                    preventScroll: true
                });
            });
        }
        (0, _vue.provide)(formKey, {
            bindComponent (vmProxy) {
                registeredComponents.push(vmProxy);
            },
            unbindComponent (vmProxy) {
                const index = registeredComponents.indexOf(vmProxy);
                if (index !== -1) registeredComponents.splice(index, 1);
            }
        });
        let shouldActivate = false;
        (0, _vue.onDeactivated)(()=>{
            shouldActivate = true;
        });
        (0, _vue.onActivated)(()=>{
            if (shouldActivate === true && props.autofocus === true) focus();
        });
        (0, _vue.onMounted)(()=>{
            if (props.autofocus === true) focus();
        });
        Object.assign(vm.proxy, {
            validate,
            resetValidation,
            submit,
            reset,
            focus,
            getValidationComponents: ()=>registeredComponents
        });
        return ()=>(0, _vue.h)("form", {
                class: "q-form",
                ref: rootRef,
                onSubmit: submit,
                onReset: reset
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/form/QFormChildMixin.js
var QFormChildMixin_default = {
    inject: {
        [formKey]: {
            default: noop
        }
    },
    watch: {
        disable (val) {
            const $form = this.$.provides[formKey];
            if ($form !== void 0) {
                if (val === true) {
                    this.resetValidation();
                    $form.unbindComponent(this);
                } else $form.bindComponent(this);
            }
        }
    },
    methods: {
        validate () {},
        resetValidation () {}
    },
    mounted () {
        if (this.disable !== true) this.$.provides[formKey]?.bindComponent(this);
    },
    beforeUnmount () {
        if (this.disable !== true) this.$.provides[formKey]?.unbindComponent(this);
    }
};
//#endregion
//#region src/components/header/QHeader.js
var QHeader_default = createComponent({
    name: "QHeader",
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        reveal: Boolean,
        revealOffset: {
            type: Number,
            default: 250
        },
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const $layout = (0, _vue.inject)(layoutKey, emptyRenderFn);
        if ($layout === emptyRenderFn) {
            console.error("QHeader needs to be child of QLayout");
            return emptyRenderFn;
        }
        const size = (0, _vue.ref)(parseInt(props.heightHint, 10));
        const revealed = (0, _vue.ref)(true);
        const fixed = (0, _vue.computed)(()=>props.reveal === true || $layout.view.value.indexOf("H") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true);
        const offset = (0, _vue.computed)(()=>{
            if (props.modelValue !== true) return 0;
            if (fixed.value === true) return revealed.value === true ? size.value : 0;
            const localOffset = size.value - $layout.scroll.value.position;
            return localOffset > 0 ? localOffset : 0;
        });
        const hidden = (0, _vue.computed)(()=>props.modelValue !== true || fixed.value === true && revealed.value !== true);
        const revealOnFocus = (0, _vue.computed)(()=>props.modelValue === true && hidden.value === true && props.reveal === true);
        const classes = (0, _vue.computed)(()=>"q-header q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-top" + (props.bordered === true ? " q-header--bordered" : "") + (hidden.value === true ? " q-header--hidden" : "") + (props.modelValue !== true ? " q-layout--prevent-focus" : ""));
        const style = (0, _vue.computed)(()=>{
            const view = $layout.rows.value.top, css = {};
            if (view[0] === "l" && $layout.left.space === true) css[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
            if (view[2] === "r" && $layout.right.space === true) css[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
            return css;
        });
        function updateLayout(prop, val) {
            $layout.update("header", prop, val);
        }
        function updateLocal(prop, val) {
            if (prop.value !== val) prop.value = val;
        }
        function onResize({ height }) {
            updateLocal(size, height);
            updateLayout("size", height);
        }
        function onFocusin(evt) {
            if (revealOnFocus.value === true) updateLocal(revealed, true);
            emit("focusin", evt);
        }
        (0, _vue.watch)(()=>props.modelValue, (val)=>{
            updateLayout("space", val);
            updateLocal(revealed, true);
            $layout.animate();
        });
        (0, _vue.watch)(offset, (val)=>{
            updateLayout("offset", val);
        });
        (0, _vue.watch)(()=>props.reveal, (val)=>{
            if (val === false) updateLocal(revealed, props.modelValue);
        });
        (0, _vue.watch)(revealed, (val)=>{
            $layout.animate();
            emit("reveal", val);
        });
        (0, _vue.watch)($layout.scroll, (scroll)=>{
            if (props.reveal === true) updateLocal(revealed, scroll.direction === "up" || scroll.position <= props.revealOffset || scroll.position - scroll.inflectionPoint < 100);
        });
        const instance = {};
        $layout.instances.header = instance;
        if (props.modelValue === true) updateLayout("size", size.value);
        updateLayout("space", props.modelValue);
        updateLayout("offset", offset.value);
        (0, _vue.onBeforeUnmount)(()=>{
            if ($layout.instances.header === instance) {
                $layout.instances.header = void 0;
                updateLayout("size", 0);
                updateLayout("offset", 0);
                updateLayout("space", false);
            }
        });
        return ()=>{
            const child = hUniqueSlot(slots.default, []);
            if (props.elevated === true) child.push((0, _vue.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            }));
            child.push((0, _vue.h)(QResizeObserver_default, {
                debounce: 0,
                onResize
            }));
            return (0, _vue.h)("header", {
                class: classes.value,
                style: style.value,
                onFocusin
            }, child);
        };
    }
});
//#endregion
//#region src/composables/private.use-ratio/use-ratio.js
const useRatioProps = {
    ratio: [
        String,
        Number
    ]
};
function useRatio(props, naturalRatio) {
    return (0, _vue.computed)(()=>{
        const ratio = Number(props.ratio || (naturalRatio !== void 0 ? naturalRatio.value : void 0));
        return isNaN(ratio) !== true && ratio > 0 ? {
            paddingBottom: `${100 / ratio}%`
        } : null;
    });
}
//#endregion
//#region src/components/img/QImg.js
const defaultRatio = 1.7778;
var QImg_default = createComponent({
    name: "QImg",
    props: {
        ...useRatioProps,
        src: String,
        srcset: String,
        sizes: String,
        alt: String,
        crossorigin: String,
        decoding: String,
        referrerpolicy: String,
        draggable: Boolean,
        loading: {
            type: String,
            default: "lazy"
        },
        loadingShowDelay: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        fetchpriority: {
            type: String,
            default: "auto"
        },
        width: String,
        height: String,
        initialRatio: {
            type: [
                Number,
                String
            ],
            default: defaultRatio
        },
        placeholderSrc: String,
        errorSrc: String,
        fit: {
            type: String,
            default: "cover"
        },
        position: {
            type: String,
            default: "50% 50%"
        },
        imgClass: String,
        imgStyle: Object,
        noSpinner: Boolean,
        noNativeMenu: Boolean,
        noTransition: Boolean,
        spinnerColor: String,
        spinnerSize: String
    },
    emits: [
        "load",
        "error"
    ],
    setup (props, { slots, emit }) {
        const naturalRatio = (0, _vue.ref)(props.initialRatio);
        const ratioStyle = useRatio(props, naturalRatio);
        const vm = (0, _vue.getCurrentInstance)();
        const { registerTimeout: registerLoadTimeout, removeTimeout: removeLoadTimeout } = useTimeout();
        const { registerTimeout: registerLoadShowTimeout, removeTimeout: removeLoadShowTimeout } = useTimeout();
        const placeholderImg = (0, _vue.computed)(()=>props.placeholderSrc !== void 0 ? {
                src: props.placeholderSrc
            } : null);
        const errorImg = (0, _vue.computed)(()=>props.errorSrc !== void 0 ? {
                src: props.errorSrc,
                __qerror: true
            } : null);
        const images = [
            (0, _vue.ref)(null),
            (0, _vue.ref)(placeholderImg.value)
        ];
        const position = (0, _vue.ref)(0);
        const isLoading = (0, _vue.ref)(false);
        const hasError = (0, _vue.ref)(false);
        const classes = (0, _vue.computed)(()=>`q-img q-img--${props.noNativeMenu === true ? "no-" : ""}menu`);
        const style = (0, _vue.computed)(()=>({
                width: props.width,
                height: props.height
            }));
        const imgClass = (0, _vue.computed)(()=>`q-img__image ${props.imgClass !== void 0 ? props.imgClass + " " : ""}q-img__image--with${props.noTransition === true ? "out" : ""}-transition q-img__image--`);
        const imgStyle = (0, _vue.computed)(()=>({
                ...props.imgStyle,
                objectFit: props.fit,
                objectPosition: props.position
            }));
        function setLoading() {
            removeLoadShowTimeout();
            if (props.loadingShowDelay === 0) {
                isLoading.value = true;
                return;
            }
            registerLoadShowTimeout(()=>{
                isLoading.value = true;
            }, props.loadingShowDelay);
        }
        function clearLoading() {
            removeLoadShowTimeout();
            isLoading.value = false;
        }
        function onLoad({ target }) {
            if (vmIsDestroyed(vm) === false) {
                removeLoadTimeout();
                naturalRatio.value = target.naturalHeight === 0 ? .5 : target.naturalWidth / target.naturalHeight;
                waitForCompleteness(target, 1);
            }
        }
        function waitForCompleteness(target, count) {
            if (count === 1e3 || vmIsDestroyed(vm) === true) return;
            if (target.complete === true) onReady(target);
            else registerLoadTimeout(()=>{
                waitForCompleteness(target, count + 1);
            }, 50);
        }
        function onReady(target) {
            if (vmIsDestroyed(vm) === true) return;
            position.value = position.value ^ 1;
            images[position.value].value = null;
            clearLoading();
            if (target.getAttribute("__qerror") !== "true") hasError.value = false;
            emit("load", target.currentSrc || target.src);
        }
        function onError(err) {
            removeLoadTimeout();
            clearLoading();
            hasError.value = true;
            images[position.value].value = errorImg.value;
            images[position.value ^ 1].value = placeholderImg.value;
            emit("error", err);
        }
        function getImage(index) {
            const img = images[index].value;
            const data = {
                key: "img_" + index,
                class: imgClass.value,
                style: imgStyle.value,
                alt: props.alt,
                crossorigin: props.crossorigin,
                decoding: props.decoding,
                referrerpolicy: props.referrerpolicy,
                height: props.height,
                width: props.width,
                loading: props.loading,
                fetchpriority: props.fetchpriority,
                "aria-hidden": "true",
                draggable: props.draggable,
                ...img
            };
            if (position.value === index) Object.assign(data, {
                class: data.class + "current",
                onLoad,
                onError
            });
            else data.class += "loaded";
            return (0, _vue.h)("div", {
                class: "q-img__container absolute-full",
                key: "img" + index
            }, (0, _vue.h)("img", data));
        }
        function getContent() {
            if (isLoading.value === false) return (0, _vue.h)("div", {
                key: "content",
                class: "q-img__content absolute-full q-anchor--skip"
            }, hSlot(slots[hasError.value === true ? "error" : "default"]));
            return (0, _vue.h)("div", {
                key: "loading",
                class: "q-img__loading absolute-full flex flex-center"
            }, slots.loading !== void 0 ? slots.loading() : props.noSpinner === true ? void 0 : [
                (0, _vue.h)(QSpinner_default, {
                    color: props.spinnerColor,
                    size: props.spinnerSize
                })
            ]);
        }
        {
            function watchSrc() {
                (0, _vue.watch)(()=>props.src || props.srcset || props.sizes ? {
                        src: props.src,
                        srcset: props.srcset,
                        sizes: props.sizes
                    } : null, (imgProps)=>{
                    removeLoadTimeout();
                    hasError.value = false;
                    if (imgProps === null) {
                        clearLoading();
                        images[position.value ^ 1].value = placeholderImg.value;
                    } else setLoading();
                    images[position.value].value = imgProps;
                }, {
                    immediate: true
                });
            }
            if (isRuntimeSsrPreHydration.value === true) (0, _vue.onMounted)(watchSrc);
            else watchSrc();
        }
        return ()=>{
            const content = [];
            if (ratioStyle.value !== null) content.push((0, _vue.h)("div", {
                key: "filler",
                style: ratioStyle.value
            }));
            if (images[0].value !== null) content.push(getImage(0));
            if (images[1].value !== null) content.push(getImage(1));
            content.push((0, _vue.h)((0, _vue.Transition), {
                name: "q-transition--fade"
            }, getContent));
            return (0, _vue.h)("div", {
                key: "main",
                class: classes.value,
                style: style.value,
                role: "img",
                "aria-label": props.alt
            }, content);
        };
    }
});
//#endregion
//#region src/components/infinite-scroll/QInfiniteScroll.js
const { passive: passive$3 } = listenOpts;
var QInfiniteScroll_default = createComponent({
    name: "QInfiniteScroll",
    props: {
        offset: {
            type: Number,
            default: 500
        },
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        },
        scrollTarget: scrollTargetProp,
        initialIndex: {
            type: Number,
            default: 0
        },
        disable: Boolean,
        reverse: Boolean
    },
    emits: [
        "load"
    ],
    setup (props, { slots, emit }) {
        const isFetching = (0, _vue.ref)(false);
        const isWorking = (0, _vue.ref)(true);
        const rootRef = (0, _vue.ref)(null);
        const loadingRef = (0, _vue.ref)(null);
        let index = props.initialIndex;
        let localScrollTarget, poll;
        const classes = (0, _vue.computed)(()=>"q-infinite-scroll__loading" + (isFetching.value === true ? "" : " invisible"));
        function immediatePoll() {
            if (props.disable === true || isFetching.value === true || isWorking.value === false) return;
            const scrollHeight = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), containerHeight = height(localScrollTarget);
            if (props.reverse === false) {
                if (Math.round(scrollPosition + containerHeight + props.offset) >= Math.round(scrollHeight)) trigger();
            } else if (Math.round(scrollPosition) <= props.offset) trigger();
        }
        function trigger() {
            if (props.disable === true || isFetching.value === true || isWorking.value === false) return;
            index++;
            isFetching.value = true;
            const heightBefore = getScrollHeight(localScrollTarget);
            emit("load", index, (isDone)=>{
                if (isWorking.value === true) {
                    isFetching.value = false;
                    (0, _vue.nextTick)(()=>{
                        if (props.reverse === true) {
                            const heightAfter = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), heightDifference = heightAfter - heightBefore;
                            setVerticalScrollPosition(localScrollTarget, scrollPosition + heightDifference);
                        }
                        if (isDone === true) stop();
                        else if (rootRef.value) {
                            if (rootRef.value.closest("body")) poll();
                        }
                    });
                }
            });
        }
        function reset() {
            index = 0;
        }
        function resume() {
            if (isWorking.value === false) {
                isWorking.value = true;
                localScrollTarget.addEventListener("scroll", poll, passive$3);
            }
            immediatePoll();
        }
        function stop() {
            if (isWorking.value === true) {
                isWorking.value = false;
                isFetching.value = false;
                localScrollTarget.removeEventListener("scroll", poll, passive$3);
                poll?.cancel?.();
            }
        }
        function updateScrollTarget() {
            if (localScrollTarget && isWorking.value === true) localScrollTarget.removeEventListener("scroll", poll, passive$3);
            localScrollTarget = getScrollTarget(rootRef.value, props.scrollTarget);
            if (isWorking.value === true) {
                localScrollTarget.addEventListener("scroll", poll, passive$3);
                if (props.reverse === true) {
                    const scrollHeight = getScrollHeight(localScrollTarget), containerHeight = height(localScrollTarget);
                    setVerticalScrollPosition(localScrollTarget, scrollHeight - containerHeight);
                }
                immediatePoll();
            }
        }
        function setIndex(newIndex) {
            index = newIndex;
        }
        function setDebounce(val) {
            val = parseInt(val, 10);
            const oldPoll = poll;
            poll = val <= 0 ? immediatePoll : debounce(immediatePoll, isNaN(val) === true ? 100 : val);
            if (localScrollTarget && isWorking.value === true) {
                if (oldPoll !== void 0) localScrollTarget.removeEventListener("scroll", oldPoll, passive$3);
                localScrollTarget.addEventListener("scroll", poll, passive$3);
            }
        }
        function updateSvgAnimations(isRetry) {
            if (renderLoadingSlot.value === true) {
                if (loadingRef.value === null) {
                    if (isRetry !== true) (0, _vue.nextTick)(()=>{
                        updateSvgAnimations(true);
                    });
                    return;
                }
                const action = `${isFetching.value === true ? "un" : ""}pauseAnimations`;
                Array.from(loadingRef.value.getElementsByTagName("svg")).forEach((el)=>{
                    el[action]();
                });
            }
        }
        const renderLoadingSlot = (0, _vue.computed)(()=>props.disable !== true && isWorking.value === true);
        (0, _vue.watch)([
            isFetching,
            renderLoadingSlot
        ], ()=>{
            updateSvgAnimations();
        });
        (0, _vue.watch)(()=>props.disable, (val)=>{
            if (val === true) stop();
            else resume();
        });
        (0, _vue.watch)(()=>props.reverse, ()=>{
            if (isFetching.value === false && isWorking.value === true) immediatePoll();
        });
        (0, _vue.watch)(()=>props.scrollTarget, updateScrollTarget);
        (0, _vue.watch)(()=>props.debounce, setDebounce);
        let scrollPos = false;
        (0, _vue.onActivated)(()=>{
            if (scrollPos !== false && localScrollTarget) setVerticalScrollPosition(localScrollTarget, scrollPos);
        });
        (0, _vue.onDeactivated)(()=>{
            scrollPos = localScrollTarget ? getVerticalScrollPosition(localScrollTarget) : false;
        });
        (0, _vue.onBeforeUnmount)(()=>{
            if (isWorking.value === true) localScrollTarget.removeEventListener("scroll", poll, passive$3);
        });
        (0, _vue.onMounted)(()=>{
            setDebounce(props.debounce);
            updateScrollTarget();
            if (isFetching.value === false) updateSvgAnimations();
        });
        const vm = (0, _vue.getCurrentInstance)();
        Object.assign(vm.proxy, {
            poll: ()=>{
                poll?.();
            },
            trigger,
            stop,
            reset,
            resume,
            setIndex,
            updateScrollTarget
        });
        return ()=>{
            const child = hUniqueSlot(slots.default, []);
            if (renderLoadingSlot.value === true) child[props.reverse === false ? "push" : "unshift"]((0, _vue.h)("div", {
                ref: loadingRef,
                class: classes.value
            }, hSlot(slots.loading)));
            return (0, _vue.h)("div", {
                class: "q-infinite-scroll",
                ref: rootRef
            }, child);
        };
    }
});
//#endregion
//#region src/components/inner-loading/QInnerLoading.js
var QInnerLoading_default = createComponent({
    name: "QInnerLoading",
    props: {
        ...useDarkProps,
        ...useTransitionProps,
        showing: Boolean,
        color: String,
        size: {
            type: [
                String,
                Number
            ],
            default: "42px"
        },
        label: String,
        labelClass: String,
        labelStyle: [
            String,
            Array,
            Object
        ]
    },
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const { transitionProps, transitionStyle } = useTransition(props);
        const classes = (0, _vue.computed)(()=>"q-inner-loading q--avoid-card-border absolute-full column flex-center" + (isDark.value === true ? " q-inner-loading--dark" : ""));
        const labelClass = (0, _vue.computed)(()=>"q-inner-loading__label" + (props.labelClass !== void 0 ? ` ${props.labelClass}` : ""));
        function getInner() {
            const child = [
                (0, _vue.h)(QSpinner_default, {
                    size: props.size,
                    color: props.color
                })
            ];
            if (props.label !== void 0) child.push((0, _vue.h)("div", {
                class: labelClass.value,
                style: props.labelStyle
            }, [
                props.label
            ]));
            return child;
        }
        function getContent() {
            return props.showing === true ? (0, _vue.h)("div", {
                class: classes.value,
                style: transitionStyle.value
            }, slots.default !== void 0 ? slots.default() : getInner()) : null;
        }
        return ()=>(0, _vue.h)((0, _vue.Transition), transitionProps.value, getContent);
    }
});
//#endregion
//#region src/components/input/use-mask.js
const NAMED_MASKS = {
    date: "####/##/##",
    datetime: "####/##/## ##:##",
    time: "##:##",
    fulltime: "##:##:##",
    phone: "(###) ### - ####",
    card: "#### #### #### ####"
};
const { tokenMap: DEFAULT_TOKEN_MAP, tokenKeys: DEFAULT_TOKEN_MAP_KEYS } = getTokenMap({
    "#": {
        pattern: "[\\d]",
        negate: "[^\\d]"
    },
    S: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]"
    },
    N: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]"
    },
    A: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: (v)=>v.toLocaleUpperCase()
    },
    a: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: (v)=>v.toLocaleLowerCase()
    },
    X: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: (v)=>v.toLocaleUpperCase()
    },
    x: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: (v)=>v.toLocaleLowerCase()
    }
});
function getTokenMap(tokens) {
    const tokenKeys = Object.keys(tokens);
    const tokenMap = {};
    tokenKeys.forEach((key)=>{
        const entry = tokens[key];
        tokenMap[key] = {
            ...entry,
            regex: new RegExp(entry.pattern)
        };
    });
    return {
        tokenMap,
        tokenKeys
    };
}
function getTokenRegexMask(keys) {
    return new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + keys.join("") + "])|(.)", "g");
}
const escRegex = /[.*+?^${}()|[\]\\]/g;
const DEFAULT_TOKEN_REGEX_MASK = getTokenRegexMask(DEFAULT_TOKEN_MAP_KEYS);
const MARKER = String.fromCharCode(1);
const useMaskProps = {
    mask: String,
    reverseFillMask: Boolean,
    fillMask: [
        Boolean,
        String
    ],
    unmaskedValue: Boolean,
    maskTokens: Object
};
function useMask(props, emit, emitValue, inputRef) {
    let maskMarked, maskReplaced, computedMask, computedUnmask, pastedTextStart, selectionAnchor;
    const tokens = (0, _vue.computed)(()=>{
        if (props.maskTokens === void 0 || props.maskTokens === null) return {
            tokenMap: DEFAULT_TOKEN_MAP,
            tokenRegexMask: DEFAULT_TOKEN_REGEX_MASK
        };
        const { tokenMap: customTokens } = getTokenMap(props.maskTokens);
        const tokenMap = {
            ...DEFAULT_TOKEN_MAP,
            ...customTokens
        };
        return {
            tokenMap,
            tokenRegexMask: getTokenRegexMask(Object.keys(tokenMap))
        };
    });
    const hasMask = (0, _vue.ref)(null);
    const innerValue = (0, _vue.ref)(getInitialMaskedValue());
    function getIsTypeText() {
        return props.autogrow === true || [
            "textarea",
            "text",
            "search",
            "url",
            "tel",
            "password"
        ].includes(props.type);
    }
    (0, _vue.watch)(()=>props.type + props.autogrow, updateMaskInternals);
    (0, _vue.watch)(()=>props.mask, (v)=>{
        if (v !== void 0) updateMaskValue(innerValue.value, true);
        else {
            const val = unmaskValue(innerValue.value);
            updateMaskInternals();
            if (props.modelValue !== val) emit("update:modelValue", val);
        }
    });
    (0, _vue.watch)(()=>props.fillMask + props.reverseFillMask, ()=>{
        if (hasMask.value === true) updateMaskValue(innerValue.value, true);
    });
    (0, _vue.watch)(()=>props.unmaskedValue, ()=>{
        if (hasMask.value === true) updateMaskValue(innerValue.value);
    });
    function getInitialMaskedValue() {
        updateMaskInternals();
        if (hasMask.value === true) {
            const masked = maskValue(unmaskValue(props.modelValue));
            return props.fillMask !== false ? fillWithMask(masked) : masked;
        }
        return props.modelValue;
    }
    function getPaddedMaskMarked(size) {
        if (size < maskMarked.length) return maskMarked.slice(-size);
        let pad = "", localMaskMarked = maskMarked;
        const padPos = localMaskMarked.indexOf(MARKER);
        if (padPos !== -1) {
            for(let i = size - localMaskMarked.length; i > 0; i--)pad += MARKER;
            localMaskMarked = localMaskMarked.slice(0, padPos) + pad + localMaskMarked.slice(padPos);
        }
        return localMaskMarked;
    }
    function updateMaskInternals() {
        hasMask.value = props.mask !== void 0 && props.mask.length !== 0 && getIsTypeText();
        if (hasMask.value === false) {
            computedUnmask = void 0;
            maskMarked = "";
            maskReplaced = "";
            return;
        }
        const localComputedMask = NAMED_MASKS[props.mask] === void 0 ? props.mask : NAMED_MASKS[props.mask], fillChar = typeof props.fillMask === "string" && props.fillMask.length !== 0 ? props.fillMask.slice(0, 1) : "_", fillCharEscaped = fillChar.replace(escRegex, "\\$&"), unmask = [], extract = [], mask = [];
        let firstMatch = props.reverseFillMask === true, unmaskChar = "", negateChar = "";
        localComputedMask.replace(tokens.value.tokenRegexMask, (_, char1, esc, token, char2)=>{
            if (token !== void 0) {
                const c = tokens.value.tokenMap[token];
                mask.push(c);
                negateChar = c.negate;
                if (firstMatch === true) {
                    extract.push("(?:" + negateChar + "+)?(" + c.pattern + "+)?(?:" + negateChar + "+)?(" + c.pattern + "+)?");
                    firstMatch = false;
                }
                extract.push("(?:" + negateChar + "+)?(" + c.pattern + ")?");
            } else if (esc !== void 0) {
                unmaskChar = "\\" + (esc === "\\" ? "" : esc);
                mask.push(esc);
                unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
            } else {
                const c = char1 !== void 0 ? char1 : char2;
                unmaskChar = c === "\\" ? "\\\\\\\\" : c.replace(escRegex, "\\\\$&");
                mask.push(c);
                unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
            }
        });
        const unmaskMatcher = new RegExp("^" + unmask.join("") + "(" + (unmaskChar === "" ? "." : "[^" + unmaskChar + "]") + "+)?" + (unmaskChar === "" ? "" : "[" + unmaskChar + "]*") + "$"), extractLast = extract.length - 1, extractMatcher = extract.map((re, index)=>{
            if (index === 0 && props.reverseFillMask === true) return new RegExp("^" + fillCharEscaped + "*" + re);
            else if (index === extractLast) return new RegExp("^" + re + "(" + (negateChar === "" ? "." : negateChar) + "+)?" + (props.reverseFillMask === true ? "$" : fillCharEscaped + "*"));
            return new RegExp("^" + re);
        });
        computedMask = mask;
        computedUnmask = (val)=>{
            const unmaskMatch = unmaskMatcher.exec(props.reverseFillMask === true ? val : val.slice(0, mask.length + 1));
            if (unmaskMatch !== null) val = unmaskMatch.slice(1).join("");
            const extractMatch = [], extractMatcherLength = extractMatcher.length;
            for(let i = 0, str = val; i < extractMatcherLength; i++){
                const m = extractMatcher[i].exec(str);
                if (m === null) break;
                str = str.slice(m.shift().length);
                extractMatch.push(...m);
            }
            if (extractMatch.length !== 0) return extractMatch.join("");
            return val;
        };
        maskMarked = mask.map((v)=>typeof v === "string" ? v : MARKER).join("");
        maskReplaced = maskMarked.split(MARKER).join(fillChar);
    }
    function updateMaskValue(rawVal, updateMaskInternalsFlag, inputType) {
        const inp = inputRef.value, end = inp.selectionEnd, endReverse = inp.value.length - end, unmasked = unmaskValue(rawVal);
        if (updateMaskInternalsFlag === true) updateMaskInternals();
        const preMasked = maskValue(unmasked, updateMaskInternalsFlag), masked = props.fillMask !== false ? fillWithMask(preMasked) : preMasked, changed = innerValue.value !== masked;
        if (inp.value !== masked) inp.value = masked;
        if (changed === true) innerValue.value = masked;
        if (document.activeElement === inp) (0, _vue.nextTick)(()=>{
            if (masked === maskReplaced) {
                const cursor = props.reverseFillMask === true ? maskReplaced.length : 0;
                inp.setSelectionRange(cursor, cursor, "forward");
                return;
            }
            if (inputType === "insertFromPaste" && props.reverseFillMask !== true) {
                const maxEnd = inp.selectionEnd;
                let cursor = end - 1;
                for(let i = pastedTextStart; i <= cursor && i < maxEnd; i++)if (maskMarked[i] !== MARKER) cursor++;
                moveCursor.right(inp, cursor);
                return;
            }
            if ([
                "deleteContentBackward",
                "deleteContentForward"
            ].indexOf(inputType) !== -1) {
                const cursor = props.reverseFillMask === true ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
                inp.setSelectionRange(cursor, cursor, "forward");
                return;
            }
            if (props.reverseFillMask === true) {
                if (changed === true) {
                    const cursor = Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
                    if (cursor === 1 && end === 1) inp.setSelectionRange(cursor, cursor, "forward");
                    else moveCursor.rightReverse(inp, cursor);
                } else {
                    const cursor = masked.length - endReverse;
                    inp.setSelectionRange(cursor, cursor, "backward");
                }
            } else if (changed === true) {
                const cursor = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, end) - 1);
                moveCursor.right(inp, cursor);
            } else {
                const cursor = end - 1;
                moveCursor.right(inp, cursor);
            }
        });
        const val = props.unmaskedValue === true ? unmaskValue(masked) : masked;
        if (String(props.modelValue) !== val && (props.modelValue !== null || val !== "")) emitValue(val, true);
    }
    function moveCursorForPaste(inp, start, end) {
        const preMasked = maskValue(unmaskValue(inp.value));
        start = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, start));
        pastedTextStart = start;
        inp.setSelectionRange(start, end, "forward");
    }
    const moveCursor = {
        left (inp, cursor) {
            const noMarkBefore = maskMarked.slice(cursor - 1).indexOf(MARKER) === -1;
            let i = Math.max(0, cursor - 1);
            for(; i >= 0; i--)if (maskMarked[i] === MARKER) {
                cursor = i;
                if (noMarkBefore === true) cursor++;
                break;
            }
            if (i < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER) return moveCursor.right(inp, 0);
            if (cursor >= 0) inp.setSelectionRange(cursor, cursor, "backward");
        },
        right (inp, cursor) {
            const limit = inp.value.length;
            let i = Math.min(limit, cursor + 1);
            for(; i <= limit; i++)if (maskMarked[i] === MARKER) {
                cursor = i;
                break;
            } else if (maskMarked[i - 1] === MARKER) cursor = i;
            if (i > limit && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER) return moveCursor.left(inp, limit);
            inp.setSelectionRange(cursor, cursor, "forward");
        },
        leftReverse (inp, cursor) {
            const localMaskMarked = getPaddedMaskMarked(inp.value.length);
            let i = Math.max(0, cursor - 1);
            for(; i >= 0; i--)if (localMaskMarked[i - 1] === MARKER) {
                cursor = i;
                break;
            } else if (localMaskMarked[i] === MARKER) {
                cursor = i;
                if (i === 0) break;
            }
            if (i < 0 && localMaskMarked[cursor] !== void 0 && localMaskMarked[cursor] !== MARKER) return moveCursor.rightReverse(inp, 0);
            if (cursor >= 0) inp.setSelectionRange(cursor, cursor, "backward");
        },
        rightReverse (inp, cursor) {
            const limit = inp.value.length, localMaskMarked = getPaddedMaskMarked(limit), noMarkBefore = localMaskMarked.slice(0, cursor + 1).indexOf(MARKER) === -1;
            let i = Math.min(limit, cursor + 1);
            for(; i <= limit; i++)if (localMaskMarked[i - 1] === MARKER) {
                cursor = i;
                if (cursor > 0 && noMarkBefore === true) cursor--;
                break;
            }
            if (i > limit && localMaskMarked[cursor - 1] !== void 0 && localMaskMarked[cursor - 1] !== MARKER) return moveCursor.leftReverse(inp, limit);
            inp.setSelectionRange(cursor, cursor, "forward");
        }
    };
    function onMaskedClick(e) {
        emit("click", e);
        selectionAnchor = void 0;
    }
    function onMaskedKeydown(e) {
        emit("keydown", e);
        if (shouldIgnoreKey(e) === true || e.altKey === true) return;
        const inp = inputRef.value, start = inp.selectionStart, end = inp.selectionEnd;
        if (!e.shiftKey) selectionAnchor = void 0;
        if (e.keyCode === 37 || e.keyCode === 39) {
            if (e.shiftKey && selectionAnchor === void 0) selectionAnchor = inp.selectionDirection === "forward" ? start : end;
            const fn = moveCursor[(e.keyCode === 39 ? "right" : "left") + (props.reverseFillMask === true ? "Reverse" : "")];
            e.preventDefault();
            fn(inp, selectionAnchor === start ? end : start);
            if (e.shiftKey) {
                const cursor = inp.selectionStart;
                inp.setSelectionRange(Math.min(selectionAnchor, cursor), Math.max(selectionAnchor, cursor), "forward");
            }
        } else if (e.keyCode === 8 && props.reverseFillMask !== true && start === end) {
            moveCursor.left(inp, start);
            inp.setSelectionRange(inp.selectionStart, end, "backward");
        } else if (e.keyCode === 46 && props.reverseFillMask === true && start === end) {
            moveCursor.rightReverse(inp, end);
            inp.setSelectionRange(start, inp.selectionEnd, "forward");
        }
    }
    function maskValue(val, updateMaskInternalsFlag) {
        if (val === void 0 || val === null || val === "") return "";
        if (props.reverseFillMask === true) return maskValueReverse(val, updateMaskInternalsFlag);
        const mask = computedMask;
        let valIndex = 0, output = "";
        for(let maskIndex = 0; maskIndex < mask.length; maskIndex++){
            const valChar = val[valIndex], maskDef = mask[maskIndex];
            if (typeof maskDef === "string") {
                output += maskDef;
                if (updateMaskInternalsFlag === true && valChar === maskDef) valIndex++;
            } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
                output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
                valIndex++;
            } else return output;
        }
        return output;
    }
    function maskValueReverse(val, updateMaskInternalsFlag) {
        const mask = computedMask, firstTokenIndex = maskMarked.indexOf(MARKER);
        let valIndex = val.length - 1, output = "";
        for(let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex !== -1; maskIndex--){
            const maskDef = mask[maskIndex];
            let valChar = val[valIndex];
            if (typeof maskDef === "string") {
                output = maskDef + output;
                if (updateMaskInternalsFlag === true && valChar === maskDef) valIndex--;
            } else if (valChar !== void 0 && maskDef.regex.test(valChar)) do {
                output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
                valIndex--;
                valChar = val[valIndex];
            }while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
            else return output;
        }
        return output;
    }
    function unmaskValue(val) {
        return typeof val !== "string" || computedUnmask === void 0 ? typeof val === "number" ? computedUnmask(String(val)) : val : computedUnmask(val);
    }
    function fillWithMask(val) {
        if (maskReplaced.length - val.length <= 0) return val;
        return props.reverseFillMask === true && val.length !== 0 ? maskReplaced.slice(0, -val.length) + val : val + maskReplaced.slice(val.length);
    }
    return {
        innerValue,
        hasMask,
        moveCursorForPaste,
        updateMaskValue,
        onMaskedKeydown,
        onMaskedClick
    };
}
//#endregion
//#region src/composables/private.use-key-composition/use-key-composition.js
const isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
const isChinese = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u;
const isKorean = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/;
const isPlainText = /[a-z0-9_ -]$/i;
function useKeyComposition(onInput) {
    return function onComposition(e) {
        if (e.type === "compositionend" || e.type === "change") {
            if (e.target.qComposing !== true) return;
            e.target.qComposing = false;
            onInput(e);
        } else if (e.type === "compositionupdate" && e.target.qComposing !== true && typeof e.data === "string") {
            if ((client.is.firefox === true ? isPlainText.test(e.data) === false : isJapanese.test(e.data) === true || isChinese.test(e.data) === true || isKorean.test(e.data) === true) === true) e.target.qComposing = true;
        }
    };
}
//#endregion
//#region src/components/input/QInput.js
var QInput_default = createComponent({
    name: "QInput",
    inheritAttrs: false,
    props: {
        ...useFieldProps,
        ...useMaskProps,
        ...useFormProps,
        modelValue: [
            String,
            Number,
            FileList
        ],
        shadowText: String,
        type: {
            type: String,
            default: "text"
        },
        debounce: [
            String,
            Number
        ],
        autogrow: Boolean,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...useFieldEmits,
        "paste",
        "change",
        "keydown",
        "click",
        "animationend"
    ],
    setup (props, { emit, attrs }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const temp = {};
        let emitCachedValue = NaN, typedNumber, stopValueWatcher, emitTimer = null, emitValueFn;
        const inputRef = (0, _vue.ref)(null);
        const nameProp = useFormInputNameAttr(props);
        const { innerValue, hasMask, moveCursorForPaste, updateMaskValue, onMaskedKeydown, onMaskedClick } = useMask(props, emit, emitValue, inputRef);
        const formDomProps = useFileDomProps(props, true);
        const hasValue = (0, _vue.computed)(()=>fieldValueIsFilled(innerValue.value));
        const onComposition = useKeyComposition(onInput);
        const state = useFieldState({
            changeEvent: true
        });
        const isTextarea = (0, _vue.computed)(()=>props.type === "textarea" || props.autogrow === true);
        const isTypeText = (0, _vue.computed)(()=>isTextarea.value === true || [
                "text",
                "search",
                "url",
                "tel",
                "password"
            ].includes(props.type));
        const onEvents = (0, _vue.computed)(()=>{
            const evt = {
                ...state.splitAttrs.listeners.value,
                onInput,
                onPaste,
                onChange,
                onBlur: onFinishEditing,
                onFocus: stop
            };
            evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
            if (hasMask.value === true) {
                evt.onKeydown = onMaskedKeydown;
                evt.onClick = onMaskedClick;
            }
            if (props.autogrow === true) evt.onAnimationend = onAnimationend;
            return evt;
        });
        const inputAttrs = (0, _vue.computed)(()=>{
            const acc = {
                tabindex: 0,
                "data-autofocus": props.autofocus === true || void 0,
                rows: props.type === "textarea" ? 6 : void 0,
                "aria-label": props.label,
                name: nameProp.value,
                ...state.splitAttrs.attributes.value,
                id: state.targetUid.value,
                maxlength: props.maxlength,
                disabled: props.disable === true,
                readonly: props.readonly === true
            };
            if (isTextarea.value === false) acc.type = props.type;
            if (props.autogrow === true) acc.rows = 1;
            return acc;
        });
        (0, _vue.watch)(()=>props.type, ()=>{
            if (inputRef.value) inputRef.value.value = props.modelValue;
        });
        (0, _vue.watch)(()=>props.modelValue, (v)=>{
            if (hasMask.value === true) {
                if (stopValueWatcher === true) {
                    stopValueWatcher = false;
                    if (String(v) === emitCachedValue) return;
                }
                updateMaskValue(v);
            } else if (innerValue.value !== v) {
                innerValue.value = v;
                if (props.type === "number" && temp.hasOwnProperty("value") === true) {
                    if (typedNumber === true) typedNumber = false;
                    else delete temp.value;
                }
            }
            if (props.autogrow === true) (0, _vue.nextTick)(adjustHeight);
        });
        (0, _vue.watch)(()=>props.autogrow, (val)=>{
            if (val === true) (0, _vue.nextTick)(adjustHeight);
            else if (inputRef.value !== null && attrs.rows > 0) inputRef.value.style.height = "auto";
        });
        (0, _vue.watch)(()=>props.dense, ()=>{
            if (props.autogrow === true) (0, _vue.nextTick)(adjustHeight);
        });
        function focus() {
            addFocusFn(()=>{
                const el = document.activeElement;
                if (inputRef.value !== null && inputRef.value !== el && (el === null || el.id !== state.targetUid.value)) inputRef.value.focus({
                    preventScroll: true
                });
            });
        }
        function select() {
            inputRef.value?.select();
        }
        function onPaste(e) {
            if (hasMask.value === true && props.reverseFillMask !== true) {
                const inp = e.target;
                moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
            }
            emit("paste", e);
        }
        function onInput(e) {
            if (!e || !e.target) return;
            if (props.type === "file") {
                emit("update:modelValue", e.target.files);
                return;
            }
            const val = e.target.value;
            if (e.target.qComposing === true) {
                temp.value = val;
                return;
            }
            if (hasMask.value === true) updateMaskValue(val, false, e.inputType);
            else {
                emitValue(val);
                if (isTypeText.value === true && e.target === document.activeElement) {
                    const { selectionStart, selectionEnd } = e.target;
                    if (selectionStart !== void 0 && selectionEnd !== void 0) (0, _vue.nextTick)(()=>{
                        if (e.target === document.activeElement && val.indexOf(e.target.value) === 0) e.target.setSelectionRange(selectionStart, selectionEnd);
                    });
                }
            }
            if (props.autogrow === true) adjustHeight();
        }
        function onAnimationend(e) {
            emit("animationend", e);
            adjustHeight();
        }
        function emitValue(val, stopWatcher) {
            emitValueFn = ()=>{
                emitTimer = null;
                if (props.type !== "number" && temp.hasOwnProperty("value") === true) delete temp.value;
                if (props.modelValue !== val && emitCachedValue !== val) {
                    emitCachedValue = val;
                    if (stopWatcher === true) stopValueWatcher = true;
                    emit("update:modelValue", val);
                    (0, _vue.nextTick)(()=>{
                        if (emitCachedValue === val) emitCachedValue = NaN;
                    });
                }
                emitValueFn = void 0;
            };
            if (props.type === "number") {
                typedNumber = true;
                temp.value = val;
            }
            if (props.debounce !== void 0) {
                if (emitTimer !== null) clearTimeout(emitTimer);
                temp.value = val;
                emitTimer = setTimeout(emitValueFn, props.debounce);
            } else emitValueFn();
        }
        function adjustHeight() {
            requestAnimationFrame(()=>{
                const inp = inputRef.value;
                if (inp !== null) {
                    const parentStyle = inp.parentNode.style;
                    const { scrollTop } = inp;
                    const { overflowY, maxHeight } = $q.platform.is.firefox === true ? {} : window.getComputedStyle(inp);
                    const changeOverflow = overflowY !== void 0 && overflowY !== "scroll";
                    if (changeOverflow === true) inp.style.overflowY = "hidden";
                    parentStyle.marginBottom = inp.scrollHeight - 1 + "px";
                    inp.style.height = "1px";
                    inp.style.height = inp.scrollHeight + "px";
                    if (changeOverflow === true) inp.style.overflowY = parseInt(maxHeight, 10) < inp.scrollHeight ? "auto" : "hidden";
                    parentStyle.marginBottom = "";
                    inp.scrollTop = scrollTop;
                }
            });
        }
        function onChange(e) {
            onComposition(e);
            if (emitTimer !== null) {
                clearTimeout(emitTimer);
                emitTimer = null;
            }
            emitValueFn?.();
            emit("change", e.target.value);
        }
        function onFinishEditing(e) {
            if (e !== void 0) stop(e);
            if (emitTimer !== null) {
                clearTimeout(emitTimer);
                emitTimer = null;
            }
            emitValueFn?.();
            typedNumber = false;
            stopValueWatcher = false;
            delete temp.value;
            if (props.type !== "file") setTimeout(()=>{
                if (inputRef.value !== null) inputRef.value.value = innerValue.value !== void 0 ? innerValue.value : "";
            });
        }
        function getCurValue() {
            return temp.hasOwnProperty("value") === true ? temp.value : innerValue.value !== void 0 ? innerValue.value : "";
        }
        (0, _vue.onBeforeUnmount)(()=>{
            onFinishEditing();
        });
        (0, _vue.onMounted)(()=>{
            if (props.autogrow === true) adjustHeight();
        });
        Object.assign(state, {
            innerValue,
            fieldClass: (0, _vue.computed)(()=>`q-${isTextarea.value === true ? "textarea" : "input"}` + (props.autogrow === true ? " q-textarea--autogrow" : "")),
            hasShadow: (0, _vue.computed)(()=>props.type !== "file" && typeof props.shadowText === "string" && props.shadowText.length !== 0),
            inputRef,
            emitValue,
            hasValue,
            floatingLabel: (0, _vue.computed)(()=>hasValue.value === true && (props.type !== "number" || isNaN(innerValue.value) === false) || fieldValueIsFilled(props.displayValue)),
            getControl: ()=>(0, _vue.h)(isTextarea.value === true ? "textarea" : "input", {
                    ref: inputRef,
                    class: [
                        "q-field__native q-placeholder",
                        props.inputClass
                    ],
                    style: props.inputStyle,
                    ...inputAttrs.value,
                    ...onEvents.value,
                    ...props.type !== "file" ? {
                        value: getCurValue()
                    } : formDomProps.value
                }),
            getShadowControl: ()=>(0, _vue.h)("div", {
                    class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (isTextarea.value === true ? "" : " text-no-wrap")
                }, [
                    (0, _vue.h)("span", {
                        class: "invisible"
                    }, getCurValue()),
                    (0, _vue.h)("span", props.shadowText)
                ])
        });
        const renderFn = useField(state);
        Object.assign(proxy, {
            focus,
            select,
            getNativeElement: ()=>inputRef.value
        });
        injectProp(proxy, "nativeEl", ()=>inputRef.value);
        return renderFn;
    }
});
//#endregion
//#region src/directives/intersection/Intersection.js
const defaultCfg$1 = {
    threshold: 0,
    root: null,
    rootMargin: "0px"
};
function update$3(el, ctx, value1) {
    let handler, cfg, changed;
    if (typeof value1 === "function") {
        handler = value1;
        cfg = defaultCfg$1;
        changed = ctx.cfg === void 0;
    } else {
        handler = value1.handler;
        cfg = Object.assign({}, defaultCfg$1, value1.cfg);
        changed = ctx.cfg === void 0 || isDeepEqual(ctx.cfg, cfg) === false;
    }
    if (ctx.handler !== handler) ctx.handler = handler;
    if (changed === true) {
        ctx.cfg = cfg;
        ctx.observer?.unobserve(el);
        ctx.observer = new IntersectionObserver(([entry])=>{
            if (typeof ctx.handler === "function") {
                if (entry.rootBounds === null && document.body.contains(el) === true) {
                    ctx.observer.unobserve(el);
                    ctx.observer.observe(el);
                    return;
                }
                if (ctx.handler(entry, ctx.observer) === false || ctx.once === true && entry.isIntersecting === true) destroy$1(el);
            }
        }, cfg);
        ctx.observer.observe(el);
    }
}
function destroy$1(el) {
    const ctx = el.__qvisible;
    if (ctx !== void 0) {
        ctx.observer?.unobserve(el);
        delete el.__qvisible;
    }
}
var Intersection_default = createDirective({
    name: "intersection",
    mounted (el, { modifiers, value: value1 }) {
        const ctx = {
            once: modifiers.once === true
        };
        update$3(el, ctx, value1);
        el.__qvisible = ctx;
    },
    updated (el, binding) {
        const ctx = el.__qvisible;
        if (ctx !== void 0) update$3(el, ctx, binding.value);
    },
    beforeUnmount: destroy$1
});
//#endregion
//#region src/components/intersection/QIntersection.js
var QIntersection_default = createComponent({
    name: "QIntersection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        once: Boolean,
        transition: String,
        transitionDuration: {
            type: [
                String,
                Number
            ],
            default: 300
        },
        ssrPrerender: Boolean,
        margin: String,
        threshold: [
            Number,
            Array
        ],
        root: {
            default: null
        },
        disable: Boolean,
        onVisibility: Function
    },
    setup (props, { slots, emit }) {
        const showing = (0, _vue.ref)(isRuntimeSsrPreHydration.value === true ? props.ssrPrerender : false);
        const intersectionProps = (0, _vue.computed)(()=>props.root !== void 0 || props.margin !== void 0 || props.threshold !== void 0 ? {
                handler: trigger,
                cfg: {
                    root: props.root,
                    rootMargin: props.margin,
                    threshold: props.threshold
                }
            } : trigger);
        const hasDirective = (0, _vue.computed)(()=>props.disable !== true && (isRuntimeSsrPreHydration.value !== true || props.once !== true || props.ssrPrerender !== true));
        const directives = (0, _vue.computed)(()=>[
                [
                    Intersection_default,
                    intersectionProps.value,
                    void 0,
                    {
                        once: props.once
                    }
                ]
            ]);
        const transitionStyle = (0, _vue.computed)(()=>`--q-transition-duration: ${props.transitionDuration}ms`);
        function trigger(entry) {
            if (showing.value !== entry.isIntersecting) {
                showing.value = entry.isIntersecting;
                if (props.onVisibility !== void 0) emit("visibility", showing.value);
            }
        }
        function getContent() {
            if (showing.value === true) return [
                (0, _vue.h)("div", {
                    key: "content",
                    style: transitionStyle.value
                }, hSlot(slots.default))
            ];
            if (slots.hidden !== void 0) return [
                (0, _vue.h)("div", {
                    key: "hidden",
                    style: transitionStyle.value
                }, slots.hidden())
            ];
        }
        return ()=>{
            const child = props.transition ? [
                (0, _vue.h)((0, _vue.Transition), {
                    name: "q-transition--" + props.transition
                }, getContent)
            ] : getContent();
            return hDir(props.tag, {
                class: "q-intersection"
            }, child, "main", hasDirective.value, ()=>directives.value);
        };
    }
});
//#endregion
//#region src/components/item/QList.js
const roleAttrExceptions = [
    "ul",
    "ol"
];
var QList_default = createComponent({
    name: "QList",
    props: {
        ...useDarkProps,
        bordered: Boolean,
        dense: Boolean,
        separator: Boolean,
        padding: Boolean,
        tag: {
            type: String,
            default: "div"
        }
    },
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const role = (0, _vue.computed)(()=>roleAttrExceptions.includes(props.tag) ? null : "list");
        const classes = (0, _vue.computed)(()=>"q-list" + (props.bordered === true ? " q-list--bordered" : "") + (props.dense === true ? " q-list--dense" : "") + (props.separator === true ? " q-list--separator" : "") + (isDark.value === true ? " q-list--dark" : "") + (props.padding === true ? " q-list--padding" : ""));
        return ()=>(0, _vue.h)(props.tag, {
                class: classes.value,
                role: role.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/knob/QKnob.js
const keyCodes$1 = [
    34,
    37,
    40,
    33,
    39,
    38
];
const commonPropsName = Object.keys(useCircularCommonProps);
var QKnob_default = createComponent({
    name: "QKnob",
    props: {
        ...useFormProps,
        ...useCircularCommonProps,
        modelValue: {
            type: Number,
            required: true
        },
        innerMin: Number,
        innerMax: Number,
        step: {
            type: Number,
            default: 1,
            validator: (v)=>v >= 0
        },
        tabindex: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        disable: Boolean,
        readonly: Boolean
    },
    emits: [
        "update:modelValue",
        "change",
        "dragValue"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const model = (0, _vue.ref)(props.modelValue);
        const dragging = (0, _vue.ref)(false);
        const innerMin = (0, _vue.computed)(()=>isNaN(props.innerMin) === true || props.innerMin < props.min ? props.min : props.innerMin);
        const innerMax = (0, _vue.computed)(()=>isNaN(props.innerMax) === true || props.innerMax > props.max ? props.max : props.innerMax);
        let centerPosition;
        function normalizeModel() {
            model.value = props.modelValue === null ? innerMin.value : between(props.modelValue, innerMin.value, innerMax.value);
            updateValue(true);
        }
        (0, _vue.watch)(()=>`${props.modelValue}|${innerMin.value}|${innerMax.value}`, normalizeModel);
        normalizeModel();
        const editable = (0, _vue.computed)(()=>props.disable === false && props.readonly === false);
        const classes = (0, _vue.computed)(()=>"q-knob non-selectable" + (editable.value === true ? " q-knob--editable" : props.disable === true ? " disabled" : ""));
        const decimals = (0, _vue.computed)(()=>(String(props.step).trim().split(".")[1] || "").length);
        const step = (0, _vue.computed)(()=>props.step === 0 ? 1 : props.step);
        const instantFeedback = (0, _vue.computed)(()=>props.instantFeedback === true || dragging.value === true);
        const onEvents = $q.platform.is.mobile === true ? (0, _vue.computed)(()=>editable.value === true ? {
                onClick
            } : {}) : (0, _vue.computed)(()=>editable.value === true ? {
                onMousedown,
                onClick,
                onKeydown,
                onKeyup
            } : {});
        const attrs = (0, _vue.computed)(()=>editable.value === true ? {
                tabindex: props.tabindex
            } : {
                [`aria-${props.disable === true ? "disabled" : "readonly"}`]: "true"
            });
        const circularProps = (0, _vue.computed)(()=>{
            const agg = {};
            commonPropsName.forEach((name)=>{
                agg[name] = props[name];
            });
            return agg;
        });
        function pan(event) {
            if (event.isFinal) {
                updatePosition(event.evt, true);
                dragging.value = false;
            } else if (event.isFirst) {
                updateCenterPosition();
                dragging.value = true;
                updatePosition(event.evt);
            } else updatePosition(event.evt);
        }
        const directives = (0, _vue.computed)(()=>[
                [
                    TouchPan_default,
                    pan,
                    void 0,
                    {
                        prevent: true,
                        stop: true,
                        mouse: true
                    }
                ]
            ]);
        function updateCenterPosition() {
            const { top, left, width, height } = proxy.$el.getBoundingClientRect();
            centerPosition = {
                top: top + height / 2,
                left: left + width / 2
            };
        }
        function onMousedown(evt) {
            updateCenterPosition();
            updatePosition(evt);
        }
        function onClick(evt) {
            updateCenterPosition();
            updatePosition(evt, true);
        }
        function onKeydown(evt) {
            if (keyCodes$1.includes(evt.keyCode) === false) return;
            stopAndPrevent(evt);
            const stepVal = ([
                34,
                33
            ].includes(evt.keyCode) ? 10 : 1) * step.value, offset = [
                34,
                37,
                40
            ].includes(evt.keyCode) ? -stepVal : stepVal;
            model.value = between(parseFloat((model.value + offset).toFixed(decimals.value)), innerMin.value, innerMax.value);
            updateValue();
        }
        function updatePosition(evt, change) {
            const pos = position(evt), height = Math.abs(pos.top - centerPosition.top), distance = Math.sqrt(height ** 2 + Math.abs(pos.left - centerPosition.left) ** 2);
            let angle = Math.asin(height / distance) * (180 / Math.PI);
            if (pos.top < centerPosition.top) angle = centerPosition.left < pos.left ? 90 - angle : 270 + angle;
            else angle = centerPosition.left < pos.left ? angle + 90 : 270 - angle;
            if ($q.lang.rtl === true) angle = normalizeToInterval(-angle - props.angle, 0, 360);
            else if (props.angle) angle = normalizeToInterval(angle - props.angle, 0, 360);
            if (props.reverse === true) angle = 360 - angle;
            let newModel = props.min + angle / 360 * (props.max - props.min);
            if (step.value !== 0) {
                const modulo = newModel % step.value;
                newModel = newModel - modulo + (Math.abs(modulo) >= step.value / 2 ? (modulo < 0 ? -1 : 1) * step.value : 0);
                newModel = parseFloat(newModel.toFixed(decimals.value));
            }
            newModel = between(newModel, innerMin.value, innerMax.value);
            emit("dragValue", newModel);
            if (model.value !== newModel) model.value = newModel;
            updateValue(change);
        }
        function onKeyup(evt) {
            if (keyCodes$1.includes(evt.keyCode)) updateValue(true);
        }
        function updateValue(change) {
            if (props.modelValue !== model.value) emit("update:modelValue", model.value);
            if (change === true) emit("change", model.value);
        }
        const formAttrs = useFormAttrs(props);
        function getNameInput() {
            return (0, _vue.h)("input", formAttrs.value);
        }
        return ()=>{
            const data = {
                class: classes.value,
                role: "slider",
                "aria-valuemin": innerMin.value,
                "aria-valuemax": innerMax.value,
                "aria-valuenow": props.modelValue,
                ...attrs.value,
                ...circularProps.value,
                value: model.value,
                instantFeedback: instantFeedback.value,
                ...onEvents.value
            };
            const child = {
                default: slots.default
            };
            if (editable.value === true && props.name !== void 0) child.internal = getNameInput;
            return hDir(QCircularProgress_default, data, child, "knob", editable.value, ()=>directives.value);
        };
    }
});
//#endregion
//#region src/components/scroll-observer/QScrollObserver.js
const { passive: passive$2 } = listenOpts;
const axisValues = [
    "both",
    "horizontal",
    "vertical"
];
var QScrollObserver_default = createComponent({
    name: "QScrollObserver",
    props: {
        axis: {
            type: String,
            validator: (v)=>axisValues.includes(v),
            default: "vertical"
        },
        debounce: [
            String,
            Number
        ],
        scrollTarget: scrollTargetProp
    },
    emits: [
        "scroll"
    ],
    setup (props, { emit }) {
        const scroll = {
            position: {
                top: 0,
                left: 0
            },
            direction: "down",
            directionChanged: false,
            delta: {
                top: 0,
                left: 0
            },
            inflectionPoint: {
                top: 0,
                left: 0
            }
        };
        let clearTimer = null, localScrollTarget, parentEl;
        (0, _vue.watch)(()=>props.scrollTarget, ()=>{
            unconfigureScrollTarget();
            configureScrollTarget();
        });
        function emitEvent() {
            clearTimer?.();
            const top = Math.max(0, getVerticalScrollPosition(localScrollTarget));
            const left = getHorizontalScrollPosition(localScrollTarget);
            const delta = {
                top: top - scroll.position.top,
                left: left - scroll.position.left
            };
            if (props.axis === "vertical" && delta.top === 0 || props.axis === "horizontal" && delta.left === 0) return;
            const curDir = Math.abs(delta.top) >= Math.abs(delta.left) ? delta.top < 0 ? "up" : "down" : delta.left < 0 ? "left" : "right";
            scroll.position = {
                top,
                left
            };
            scroll.directionChanged = scroll.direction !== curDir;
            scroll.delta = delta;
            if (scroll.directionChanged === true) {
                scroll.direction = curDir;
                scroll.inflectionPoint = scroll.position;
            }
            emit("scroll", {
                ...scroll
            });
        }
        function configureScrollTarget() {
            localScrollTarget = getScrollTarget(parentEl, props.scrollTarget);
            localScrollTarget.addEventListener("scroll", trigger, passive$2);
            trigger(true);
        }
        function unconfigureScrollTarget() {
            if (localScrollTarget !== void 0) {
                localScrollTarget.removeEventListener("scroll", trigger, passive$2);
                localScrollTarget = void 0;
            }
        }
        function trigger(immediately) {
            if (immediately === true || props.debounce === 0 || props.debounce === "0") emitEvent();
            else if (clearTimer === null) {
                const [timer, fn] = props.debounce ? [
                    setTimeout(emitEvent, props.debounce),
                    clearTimeout
                ] : [
                    requestAnimationFrame(emitEvent),
                    cancelAnimationFrame
                ];
                clearTimer = ()=>{
                    fn(timer);
                    clearTimer = null;
                };
            }
        }
        const { proxy } = (0, _vue.getCurrentInstance)();
        (0, _vue.watch)(()=>proxy.$q.lang.rtl, emitEvent);
        (0, _vue.onMounted)(()=>{
            parentEl = proxy.$el.parentNode;
            configureScrollTarget();
        });
        (0, _vue.onBeforeUnmount)(()=>{
            clearTimer?.();
            unconfigureScrollTarget();
        });
        Object.assign(proxy, {
            trigger,
            getPosition: ()=>scroll
        });
        return noop;
    }
});
//#endregion
//#region src/components/layout/QLayout.js
var QLayout_default = createComponent({
    name: "QLayout",
    props: {
        container: Boolean,
        view: {
            type: String,
            default: "hhh lpr fff",
            validator: (v)=>/^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(v.toLowerCase())
        },
        onScroll: Function,
        onScrollHeight: Function,
        onResize: Function
    },
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const rootRef = (0, _vue.ref)(null);
        const height = (0, _vue.ref)($q.screen.height);
        const width = (0, _vue.ref)(props.container === true ? 0 : $q.screen.width);
        const scroll = (0, _vue.ref)({
            position: 0,
            direction: "down",
            inflectionPoint: 0
        });
        const containerHeight = (0, _vue.ref)(0);
        const scrollbarWidth = (0, _vue.ref)(isRuntimeSsrPreHydration.value === true ? 0 : getScrollbarWidth());
        const classes = (0, _vue.computed)(()=>"q-layout q-layout--" + (props.container === true ? "containerized" : "standard"));
        const style = (0, _vue.computed)(()=>props.container === false ? {
                minHeight: $q.screen.height + "px"
            } : null);
        const targetStyle = (0, _vue.computed)(()=>scrollbarWidth.value !== 0 ? {
                [$q.lang.rtl === true ? "left" : "right"]: `${scrollbarWidth.value}px`
            } : null);
        const targetChildStyle = (0, _vue.computed)(()=>scrollbarWidth.value !== 0 ? {
                [$q.lang.rtl === true ? "right" : "left"]: 0,
                [$q.lang.rtl === true ? "left" : "right"]: `-${scrollbarWidth.value}px`,
                width: `calc(100% + ${scrollbarWidth.value}px)`
            } : null);
        function onPageScroll(data) {
            if (props.container === true || document.qScrollPrevented !== true) {
                const info = {
                    position: data.position.top,
                    direction: data.direction,
                    directionChanged: data.directionChanged,
                    inflectionPoint: data.inflectionPoint.top,
                    delta: data.delta.top
                };
                scroll.value = info;
                if (props.onScroll !== void 0) emit("scroll", info);
            }
        }
        function onPageResize(data) {
            const { height: newHeight, width: newWidth } = data;
            let resized = false;
            if (height.value !== newHeight) {
                resized = true;
                height.value = newHeight;
                if (props.onScrollHeight !== void 0) emit("scrollHeight", newHeight);
                updateScrollbarWidth();
            }
            if (width.value !== newWidth) {
                resized = true;
                width.value = newWidth;
            }
            if (resized === true && props.onResize !== void 0) emit("resize", data);
        }
        function onContainerResize({ height: newHeight }) {
            if (containerHeight.value !== newHeight) {
                containerHeight.value = newHeight;
                updateScrollbarWidth();
            }
        }
        function updateScrollbarWidth() {
            if (props.container === true) {
                const newWidth = height.value > containerHeight.value ? getScrollbarWidth() : 0;
                if (scrollbarWidth.value !== newWidth) scrollbarWidth.value = newWidth;
            }
        }
        let animateTimer = null;
        const $layout = {
            instances: {},
            view: (0, _vue.computed)(()=>props.view),
            isContainer: (0, _vue.computed)(()=>props.container),
            rootRef,
            height,
            containerHeight,
            scrollbarWidth,
            totalWidth: (0, _vue.computed)(()=>width.value + scrollbarWidth.value),
            rows: (0, _vue.computed)(()=>{
                const rows = props.view.toLowerCase().split(" ");
                return {
                    top: rows[0].split(""),
                    middle: rows[1].split(""),
                    bottom: rows[2].split("")
                };
            }),
            header: (0, _vue.reactive)({
                size: 0,
                offset: 0,
                space: false
            }),
            right: (0, _vue.reactive)({
                size: 300,
                offset: 0,
                space: false
            }),
            footer: (0, _vue.reactive)({
                size: 0,
                offset: 0,
                space: false
            }),
            left: (0, _vue.reactive)({
                size: 300,
                offset: 0,
                space: false
            }),
            scroll,
            animate () {
                if (animateTimer !== null) clearTimeout(animateTimer);
                else document.body.classList.add("q-body--layout-animate");
                animateTimer = setTimeout(()=>{
                    animateTimer = null;
                    document.body.classList.remove("q-body--layout-animate");
                }, 155);
            },
            update (part, prop, val) {
                $layout[part][prop] = val;
            }
        };
        (0, _vue.provide)(layoutKey, $layout);
        if (getScrollbarWidth() > 0) {
            let timer = null;
            const el = document.body;
            function restoreScrollbar() {
                timer = null;
                el.classList.remove("hide-scrollbar");
            }
            function hideScrollbar() {
                if (timer === null) {
                    if (el.scrollHeight > $q.screen.height) return;
                    el.classList.add("hide-scrollbar");
                } else clearTimeout(timer);
                timer = setTimeout(restoreScrollbar, 300);
            }
            function updateScrollEvent(action) {
                if (timer !== null && action === "remove") {
                    clearTimeout(timer);
                    restoreScrollbar();
                }
                window[`${action}EventListener`]("resize", hideScrollbar);
            }
            (0, _vue.watch)(()=>props.container !== true ? "add" : "remove", updateScrollEvent);
            if (props.container !== true) updateScrollEvent("add");
            (0, _vue.onUnmounted)(()=>{
                updateScrollEvent("remove");
            });
        }
        return ()=>{
            const content = hMergeSlot(slots.default, [
                (0, _vue.h)(QScrollObserver_default, {
                    onScroll: onPageScroll
                }),
                (0, _vue.h)(QResizeObserver_default, {
                    onResize: onPageResize
                })
            ]);
            const layout = (0, _vue.h)("div", {
                class: classes.value,
                style: style.value,
                ref: props.container === true ? void 0 : rootRef,
                tabindex: -1
            }, content);
            if (props.container === true) return (0, _vue.h)("div", {
                class: "q-layout-container overflow-hidden",
                ref: rootRef
            }, [
                (0, _vue.h)(QResizeObserver_default, {
                    onResize: onContainerResize
                }),
                (0, _vue.h)("div", {
                    class: "absolute-full",
                    style: targetStyle.value
                }, [
                    (0, _vue.h)("div", {
                        class: "scroll",
                        style: targetChildStyle.value
                    }, [
                        layout
                    ])
                ])
            ]);
            return layout;
        };
    }
});
//#endregion
//#region src/components/markup-table/QMarkupTable.js
const separatorValues = [
    "horizontal",
    "vertical",
    "cell",
    "none"
];
var QMarkupTable_default = createComponent({
    name: "QMarkupTable",
    props: {
        ...useDarkProps,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        wrapCells: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: (v)=>separatorValues.includes(v)
        }
    },
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const classes = (0, _vue.computed)(()=>`q-markup-table q-table__container q-table__card q-table--${props.separator}-separator` + (isDark.value === true ? " q-table--dark q-table__card--dark q-dark" : "") + (props.dense === true ? " q-table--dense" : "") + (props.flat === true ? " q-table--flat" : "") + (props.bordered === true ? " q-table--bordered" : "") + (props.square === true ? " q-table--square" : "") + (props.wrapCells === false ? " q-table--no-wrap" : ""));
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, [
                (0, _vue.h)("table", {
                    class: "q-table"
                }, hSlot(slots.default))
            ]);
    }
});
//#endregion
//#region src/components/no-ssr/QNoSsr.js
var QNoSsr_default = createComponent({
    name: "QNoSsr",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        placeholder: String
    },
    setup (props, { slots }) {
        const { isHydrated } = useHydration();
        return ()=>{
            if (isHydrated.value === true) {
                const node = hSlot(slots.default);
                return node === void 0 ? node : node.length > 1 ? (0, _vue.h)(props.tag, {}, node) : node[0];
            }
            const data = {
                class: "q-no-ssr-placeholder"
            };
            const node = hSlot(slots.placeholder);
            if (node !== void 0) return node.length > 1 ? (0, _vue.h)(props.tag, data, node) : node[0];
            if (props.placeholder !== void 0) return (0, _vue.h)(props.tag, data, props.placeholder);
        };
    }
});
//#endregion
//#region src/components/radio/QRadio.js
const createSvg = ()=>(0, _vue.h)("svg", {
        key: "svg",
        class: "q-radio__bg absolute non-selectable",
        viewBox: "0 0 24 24"
    }, [
        (0, _vue.h)("path", {
            d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
        }),
        (0, _vue.h)("path", {
            class: "q-radio__check",
            d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
        })
    ]);
var QRadio_default = createComponent({
    name: "QRadio",
    props: {
        ...useDarkProps,
        ...useSizeProps,
        ...useFormProps,
        modelValue: {
            required: true
        },
        val: {
            required: true
        },
        label: String,
        leftLabel: Boolean,
        checkedIcon: String,
        uncheckedIcon: String,
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        disable: Boolean,
        tabindex: [
            String,
            Number
        ]
    },
    emits: [
        "update:modelValue"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, proxy.$q);
        const sizeStyle = useSize(props, option_sizes_default);
        const rootRef = (0, _vue.ref)(null);
        const { refocusTargetEl, refocusTarget } = useRefocusTarget(props, rootRef);
        const isTrue = (0, _vue.computed)(()=>(0, _vue.toRaw)(props.modelValue) === (0, _vue.toRaw)(props.val));
        const classes = (0, _vue.computed)(()=>"q-radio cursor-pointer no-outline row inline no-wrap items-center" + (props.disable === true ? " disabled" : "") + (isDark.value === true ? " q-radio--dark" : "") + (props.dense === true ? " q-radio--dense" : "") + (props.leftLabel === true ? " reverse" : ""));
        const innerClass = (0, _vue.computed)(()=>{
            const color = props.color !== void 0 && (props.keepColor === true || isTrue.value === true) ? ` text-${props.color}` : "";
            return `q-radio__inner relative-position q-radio__inner--${isTrue.value === true ? "truthy" : "falsy"}${color}`;
        });
        const icon = (0, _vue.computed)(()=>(isTrue.value === true ? props.checkedIcon : props.uncheckedIcon) || null);
        const tabindex = (0, _vue.computed)(()=>props.disable === true ? -1 : props.tabindex || 0);
        const injectFormInput = useFormInject((0, _vue.computed)(()=>{
            const prop = {
                type: "radio"
            };
            if (props.name !== void 0) Object.assign(prop, {
                ".checked": isTrue.value === true,
                "^checked": isTrue.value === true ? "checked" : void 0,
                name: props.name,
                value: props.val
            });
            return prop;
        }));
        function onClick(e) {
            if (e !== void 0) {
                stopAndPrevent(e);
                refocusTarget(e);
            }
            if (props.disable !== true && isTrue.value !== true) emit("update:modelValue", props.val, e);
        }
        function onKeydown(e) {
            if (e.keyCode === 13 || e.keyCode === 32) stopAndPrevent(e);
        }
        function onKeyup(e) {
            if (e.keyCode === 13 || e.keyCode === 32) onClick(e);
        }
        Object.assign(proxy, {
            set: onClick
        });
        const svg = createSvg();
        return ()=>{
            const content = icon.value !== null ? [
                (0, _vue.h)("div", {
                    key: "icon",
                    class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
                }, [
                    (0, _vue.h)(QIcon_default, {
                        class: "q-radio__icon",
                        name: icon.value
                    })
                ])
            ] : [
                svg
            ];
            if (props.disable !== true) injectFormInput(content, "unshift", " q-radio__native q-ma-none q-pa-none");
            const child = [
                (0, _vue.h)("div", {
                    class: innerClass.value,
                    style: sizeStyle.value,
                    "aria-hidden": "true"
                }, content)
            ];
            if (refocusTargetEl.value !== null) child.push(refocusTargetEl.value);
            const label = props.label !== void 0 ? hMergeSlot(slots.default, [
                props.label
            ]) : hSlot(slots.default);
            if (label !== void 0) child.push((0, _vue.h)("div", {
                class: "q-radio__label q-anchor--skip"
            }, label));
            return (0, _vue.h)("div", {
                ref: rootRef,
                class: classes.value,
                tabindex: tabindex.value,
                role: "radio",
                "aria-label": props.label,
                "aria-checked": isTrue.value === true ? "true" : "false",
                "aria-disabled": props.disable === true ? "true" : void 0,
                onClick,
                onKeydown,
                onKeyup
            }, child);
        };
    }
});
//#endregion
//#region src/components/toggle/QToggle.js
var QToggle_default = createComponent({
    name: "QToggle",
    props: {
        ...useCheckboxProps,
        icon: String,
        iconColor: String
    },
    emits: useCheckboxEmits,
    setup (props) {
        function getInner(isTrue, isIndeterminate) {
            const icon = (0, _vue.computed)(()=>(isTrue.value === true ? props.checkedIcon : isIndeterminate.value === true ? props.indeterminateIcon : props.uncheckedIcon) || props.icon);
            const color = (0, _vue.computed)(()=>isTrue.value === true ? props.iconColor : null);
            return ()=>[
                    (0, _vue.h)("div", {
                        class: "q-toggle__track"
                    }),
                    (0, _vue.h)("div", {
                        class: "q-toggle__thumb absolute flex flex-center no-wrap"
                    }, icon.value !== void 0 ? [
                        (0, _vue.h)(QIcon_default, {
                            name: icon.value,
                            color: color.value
                        })
                    ] : void 0)
                ];
        }
        return useCheckbox("toggle", getInner);
    }
});
//#endregion
//#region src/components/option-group/QOptionGroup.js
const components = {
    radio: QRadio_default,
    checkbox: QCheckbox_default,
    toggle: QToggle_default
};
const typeValues = Object.keys(components);
function getPropValueFn$1(userPropName, defaultPropName) {
    if (typeof userPropName === "function") return userPropName;
    const propName = userPropName !== void 0 ? userPropName : defaultPropName;
    return (opt)=>opt[propName];
}
var QOptionGroup_default = createComponent({
    name: "QOptionGroup",
    props: {
        ...useDarkProps,
        modelValue: {
            required: true
        },
        options: {
            type: Array,
            validator: (opts)=>opts.every(isObject),
            default: ()=>[]
        },
        optionValue: [
            Function,
            String
        ],
        optionLabel: [
            Function,
            String
        ],
        optionDisable: [
            Function,
            String
        ],
        name: String,
        type: {
            type: String,
            default: "radio",
            validator: (v)=>typeValues.includes(v)
        },
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        size: String,
        leftLabel: Boolean,
        inline: Boolean,
        disable: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    setup (props, { emit, slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const arrayModel = Array.isArray(props.modelValue);
        if (props.type === "radio") {
            if (arrayModel === true) console.error("q-option-group: model should not be array");
        } else if (arrayModel === false) console.error("q-option-group: model should be array in your case");
        const isDark = useDark(props, $q);
        const component = (0, _vue.computed)(()=>components[props.type]);
        const getOptionValue = (0, _vue.computed)(()=>getPropValueFn$1(props.optionValue, "value"));
        const getOptionLabel = (0, _vue.computed)(()=>getPropValueFn$1(props.optionLabel, "label"));
        const getOptionDisable = (0, _vue.computed)(()=>getPropValueFn$1(props.optionDisable, "disable"));
        const innerOptions = (0, _vue.computed)(()=>props.options.map((opt)=>({
                    val: getOptionValue.value(opt),
                    name: opt.name === void 0 ? props.name : opt.name,
                    disable: props.disable || getOptionDisable.value(opt),
                    leftLabel: opt.leftLabel === void 0 ? props.leftLabel : opt.leftLabel,
                    color: opt.color === void 0 ? props.color : opt.color,
                    checkedIcon: opt.checkedIcon,
                    uncheckedIcon: opt.uncheckedIcon,
                    dark: opt.dark === void 0 ? isDark.value : opt.dark,
                    size: opt.size === void 0 ? props.size : opt.size,
                    dense: props.dense,
                    keepColor: opt.keepColor === void 0 ? props.keepColor : opt.keepColor
                })));
        const classes = (0, _vue.computed)(()=>"q-option-group q-gutter-x-sm" + (props.inline === true ? " q-option-group--inline" : ""));
        const attrs = (0, _vue.computed)(()=>{
            const acc = {
                role: "group"
            };
            if (props.type === "radio") {
                acc.role = "radiogroup";
                if (props.disable === true) acc["aria-disabled"] = "true";
            }
            return acc;
        });
        function onUpdateModelValue(value1) {
            emit("update:modelValue", value1);
        }
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                ...attrs.value
            }, props.options.map((opt, i)=>{
                const child = slots["label-" + i] !== void 0 ? ()=>slots["label-" + i](opt) : slots.label !== void 0 ? ()=>slots.label(opt) : void 0;
                return (0, _vue.h)("div", [
                    (0, _vue.h)(component.value, {
                        label: child === void 0 ? getOptionLabel.value(opt) : null,
                        modelValue: props.modelValue,
                        "onUpdate:modelValue": onUpdateModelValue,
                        ...innerOptions.value[i]
                    }, child)
                ]);
            }));
    }
});
//#endregion
//#region src/components/page/QPage.js
var QPage_default = createComponent({
    name: "QPage",
    props: {
        padding: Boolean,
        styleFn: Function
    },
    setup (props, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const $layout = (0, _vue.inject)(layoutKey, emptyRenderFn);
        if ($layout === emptyRenderFn) {
            console.error("QPage needs to be a deep child of QLayout");
            return emptyRenderFn;
        }
        if ((0, _vue.inject)("_q_pc_", emptyRenderFn) === emptyRenderFn) {
            console.error("QPage needs to be child of QPageContainer");
            return emptyRenderFn;
        }
        const style = (0, _vue.computed)(()=>{
            const offset = ($layout.header.space === true ? $layout.header.size : 0) + ($layout.footer.space === true ? $layout.footer.size : 0);
            if (typeof props.styleFn === "function") {
                const height = $layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height;
                return props.styleFn(offset, height);
            }
            return {
                minHeight: $layout.isContainer.value === true ? $layout.containerHeight.value - offset + "px" : $q.screen.height === 0 ? offset !== 0 ? `calc(100vh - ${offset}px)` : "100vh" : $q.screen.height - offset + "px"
            };
        });
        const classes = (0, _vue.computed)(()=>`q-page${props.padding === true ? " q-layout-padding" : ""}`);
        return ()=>(0, _vue.h)("main", {
                class: classes.value,
                style: style.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/page/QPageContainer.js
var QPageContainer_default = createComponent({
    name: "QPageContainer",
    setup (_, { slots }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const $layout = (0, _vue.inject)(layoutKey, emptyRenderFn);
        if ($layout === emptyRenderFn) {
            console.error("QPageContainer needs to be child of QLayout");
            return emptyRenderFn;
        }
        (0, _vue.provide)(pageContainerKey, true);
        const style = (0, _vue.computed)(()=>{
            const css = {};
            if ($layout.header.space === true) css.paddingTop = `${$layout.header.size}px`;
            if ($layout.right.space === true) css[`padding${$q.lang.rtl === true ? "Left" : "Right"}`] = `${$layout.right.size}px`;
            if ($layout.footer.space === true) css.paddingBottom = `${$layout.footer.size}px`;
            if ($layout.left.space === true) css[`padding${$q.lang.rtl === true ? "Right" : "Left"}`] = `${$layout.left.size}px`;
            return css;
        });
        return ()=>(0, _vue.h)("div", {
                class: "q-page-container",
                style: style.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/page-sticky/use-page-sticky.js
const usePageStickyProps = {
    position: {
        type: String,
        default: "bottom-right",
        validator: (v)=>[
                "top-right",
                "top-left",
                "bottom-right",
                "bottom-left",
                "top",
                "right",
                "bottom",
                "left"
            ].includes(v)
    },
    offset: {
        type: Array,
        validator: (v)=>v.length === 2
    },
    expand: Boolean
};
function usePageSticky() {
    const { props, proxy: { $q } } = (0, _vue.getCurrentInstance)();
    const $layout = (0, _vue.inject)(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
        console.error("QPageSticky needs to be child of QLayout");
        return emptyRenderFn;
    }
    const attach = (0, _vue.computed)(()=>{
        const pos = props.position;
        return {
            top: pos.indexOf("top") !== -1,
            right: pos.indexOf("right") !== -1,
            bottom: pos.indexOf("bottom") !== -1,
            left: pos.indexOf("left") !== -1,
            vertical: pos === "top" || pos === "bottom",
            horizontal: pos === "left" || pos === "right"
        };
    });
    const top = (0, _vue.computed)(()=>$layout.header.offset);
    const right = (0, _vue.computed)(()=>$layout.right.offset);
    const bottom = (0, _vue.computed)(()=>$layout.footer.offset);
    const left = (0, _vue.computed)(()=>$layout.left.offset);
    const style = (0, _vue.computed)(()=>{
        let posX = 0, posY = 0;
        const side = attach.value;
        const dir = $q.lang.rtl === true ? -1 : 1;
        if (side.top === true && top.value !== 0) posY = `${top.value}px`;
        else if (side.bottom === true && bottom.value !== 0) posY = `${-bottom.value}px`;
        if (side.left === true && left.value !== 0) posX = `${dir * left.value}px`;
        else if (side.right === true && right.value !== 0) posX = `${-dir * right.value}px`;
        const css = {
            transform: `translate(${posX}, ${posY})`
        };
        if (props.offset) css.margin = `${props.offset[1]}px ${props.offset[0]}px`;
        if (side.vertical === true) {
            if (left.value !== 0) css[$q.lang.rtl === true ? "right" : "left"] = `${left.value}px`;
            if (right.value !== 0) css[$q.lang.rtl === true ? "left" : "right"] = `${right.value}px`;
        } else if (side.horizontal === true) {
            if (top.value !== 0) css.top = `${top.value}px`;
            if (bottom.value !== 0) css.bottom = `${bottom.value}px`;
        }
        return css;
    });
    const classes = (0, _vue.computed)(()=>`q-page-sticky row flex-center fixed-${props.position} q-page-sticky--${props.expand === true ? "expand" : "shrink"}`);
    function getStickyContent(slots) {
        const content = hSlot(slots.default);
        return (0, _vue.h)("div", {
            class: classes.value,
            style: style.value
        }, props.expand === true ? content : [
            (0, _vue.h)("div", content)
        ]);
    }
    return {
        $layout,
        getStickyContent
    };
}
//#endregion
//#region src/components/page-scroller/QPageScroller.js
var QPageScroller_default = createComponent({
    name: "QPageScroller",
    props: {
        ...usePageStickyProps,
        scrollOffset: {
            type: Number,
            default: 1e3
        },
        reverse: Boolean,
        duration: {
            type: Number,
            default: 300
        },
        offset: {
            ...usePageStickyProps.offset,
            default: ()=>[
                    18,
                    18
                ]
        }
    },
    emits: [
        "click"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const { $layout, getStickyContent } = usePageSticky();
        const rootRef = (0, _vue.ref)(null);
        let heightWatcher;
        const scrollHeight = (0, _vue.computed)(()=>$layout.height.value - ($layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height));
        function isVisible() {
            return props.reverse === true ? scrollHeight.value - $layout.scroll.value.position > props.scrollOffset : $layout.scroll.value.position > props.scrollOffset;
        }
        const showing = (0, _vue.ref)(isVisible());
        function updateVisibility() {
            const newVal = isVisible();
            if (showing.value !== newVal) showing.value = newVal;
        }
        function updateReverse() {
            if (props.reverse === true) {
                if (heightWatcher === void 0) heightWatcher = (0, _vue.watch)(scrollHeight, updateVisibility);
            } else cleanup();
        }
        (0, _vue.watch)($layout.scroll, updateVisibility);
        (0, _vue.watch)(()=>props.reverse, updateReverse);
        function cleanup() {
            if (heightWatcher !== void 0) {
                heightWatcher();
                heightWatcher = void 0;
            }
        }
        function onClick(e) {
            setVerticalScrollPosition(getScrollTarget($layout.isContainer.value === true ? rootRef.value : $layout.rootRef.value), props.reverse === true ? $layout.height.value : 0, props.duration);
            emit("click", e);
        }
        function getContent() {
            return showing.value === true ? (0, _vue.h)("div", {
                ref: rootRef,
                class: "q-page-scroller",
                onClick
            }, getStickyContent(slots)) : null;
        }
        updateReverse();
        (0, _vue.onBeforeUnmount)(cleanup);
        return ()=>(0, _vue.h)((0, _vue.Transition), {
                name: "q-transition--fade"
            }, getContent);
    }
});
//#endregion
//#region src/components/page-sticky/QPageSticky.js
var QPageSticky_default = createComponent({
    name: "QPageSticky",
    props: usePageStickyProps,
    setup (_, { slots }) {
        const { getStickyContent } = usePageSticky();
        return ()=>getStickyContent(slots);
    }
});
//#endregion
//#region src/components/pagination/QPagination.js
function getBool(val, otherwise) {
    return [
        true,
        false
    ].includes(val) ? val : otherwise;
}
var QPagination_default = createComponent({
    name: "QPagination",
    props: {
        ...useDarkProps,
        modelValue: {
            type: Number,
            required: true
        },
        min: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        max: {
            type: [
                Number,
                String
            ],
            required: true
        },
        maxPages: {
            type: [
                Number,
                String
            ],
            default: 0,
            validator: (v)=>(typeof v === "string" ? parseInt(v, 10) : v) >= 0
        },
        inputStyle: [
            Array,
            String,
            Object
        ],
        inputClass: [
            Array,
            String,
            Object
        ],
        size: String,
        disable: Boolean,
        input: Boolean,
        iconPrev: String,
        iconNext: String,
        iconFirst: String,
        iconLast: String,
        toFn: Function,
        boundaryLinks: {
            type: Boolean,
            default: null
        },
        boundaryNumbers: {
            type: Boolean,
            default: null
        },
        directionLinks: {
            type: Boolean,
            default: null
        },
        ellipses: {
            type: Boolean,
            default: null
        },
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: null
        },
        round: Boolean,
        rounded: Boolean,
        flat: Boolean,
        outline: Boolean,
        unelevated: Boolean,
        push: Boolean,
        glossy: Boolean,
        color: {
            type: String,
            default: "primary"
        },
        textColor: String,
        activeDesign: {
            type: String,
            default: "",
            values: (v)=>v === "" || btnDesignOptions.includes(v)
        },
        activeColor: String,
        activeTextColor: String,
        gutter: String,
        padding: {
            type: String,
            default: "3px 2px"
        }
    },
    emits: [
        "update:modelValue"
    ],
    setup (props, { emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const minProp = (0, _vue.computed)(()=>parseInt(props.min, 10));
        const maxProp = (0, _vue.computed)(()=>parseInt(props.max, 10));
        const maxPagesProp = (0, _vue.computed)(()=>parseInt(props.maxPages, 10));
        const inputPlaceholder = (0, _vue.computed)(()=>model.value + " / " + maxProp.value);
        const boundaryLinksProp = (0, _vue.computed)(()=>getBool(props.boundaryLinks, props.input));
        const boundaryNumbersProp = (0, _vue.computed)(()=>getBool(props.boundaryNumbers, !props.input));
        const directionLinksProp = (0, _vue.computed)(()=>getBool(props.directionLinks, props.input));
        const ellipsesProp = (0, _vue.computed)(()=>getBool(props.ellipses, !props.input));
        const newPage = (0, _vue.ref)(null);
        const model = (0, _vue.computed)({
            get: ()=>props.modelValue,
            set: (val)=>{
                val = parseInt(val, 10);
                if (props.disable || isNaN(val)) return;
                const value1 = between(val, minProp.value, maxProp.value);
                if (props.modelValue !== value1) emit("update:modelValue", value1);
            }
        });
        (0, _vue.watch)(()=>`${minProp.value}|${maxProp.value}`, ()=>{
            model.value = props.modelValue;
        });
        const classes = (0, _vue.computed)(()=>"q-pagination row no-wrap items-center" + (props.disable === true ? " disabled" : ""));
        const gutterProp = (0, _vue.computed)(()=>props.gutter in btnPadding ? `${btnPadding[props.gutter]}px` : props.gutter || null);
        const gutterStyle = (0, _vue.computed)(()=>gutterProp.value !== null ? `--q-pagination-gutter-parent:-${gutterProp.value};--q-pagination-gutter-child:${gutterProp.value}` : null);
        const icons = (0, _vue.computed)(()=>{
            const ico = [
                props.iconFirst || $q.iconSet.pagination.first,
                props.iconPrev || $q.iconSet.pagination.prev,
                props.iconNext || $q.iconSet.pagination.next,
                props.iconLast || $q.iconSet.pagination.last
            ];
            return $q.lang.rtl === true ? ico.reverse() : ico;
        });
        const attrs = (0, _vue.computed)(()=>({
                "aria-disabled": props.disable === true ? "true" : "false",
                role: "navigation"
            }));
        const btnDesignProp = (0, _vue.computed)(()=>getBtnDesign(props, "flat"));
        const btnProps = (0, _vue.computed)(()=>({
                [btnDesignProp.value]: true,
                round: props.round,
                rounded: props.rounded,
                padding: props.padding,
                color: props.color,
                textColor: props.textColor,
                size: props.size,
                ripple: props.ripple !== null ? props.ripple : true
            }));
        const btnActiveDesignProp = (0, _vue.computed)(()=>{
            const acc = {
                [btnDesignProp.value]: false
            };
            if (props.activeDesign !== "") acc[props.activeDesign] = true;
            return acc;
        });
        const activeBtnProps = (0, _vue.computed)(()=>({
                ...btnActiveDesignProp.value,
                color: props.activeColor || props.color,
                textColor: props.activeTextColor || props.textColor
            }));
        const btnConfig = (0, _vue.computed)(()=>{
            let maxPages = Math.max(maxPagesProp.value, 1 + (ellipsesProp.value ? 2 : 0) + (boundaryNumbersProp.value ? 2 : 0));
            const acc = {
                pgFrom: minProp.value,
                pgTo: maxProp.value,
                ellipsesStart: false,
                ellipsesEnd: false,
                boundaryStart: false,
                boundaryEnd: false,
                marginalStyle: {
                    minWidth: `${Math.max(2, String(maxProp.value).length)}em`
                }
            };
            if (maxPagesProp.value && maxPages < maxProp.value - minProp.value + 1) {
                maxPages = 1 + Math.floor(maxPages / 2) * 2;
                acc.pgFrom = Math.max(minProp.value, Math.min(maxProp.value - maxPages + 1, props.modelValue - Math.floor(maxPages / 2)));
                acc.pgTo = Math.min(maxProp.value, acc.pgFrom + maxPages - 1);
                if (boundaryNumbersProp.value) {
                    acc.boundaryStart = true;
                    acc.pgFrom++;
                }
                if (ellipsesProp.value && acc.pgFrom > minProp.value + (boundaryNumbersProp.value ? 1 : 0)) {
                    acc.ellipsesStart = true;
                    acc.pgFrom++;
                }
                if (boundaryNumbersProp.value) {
                    acc.boundaryEnd = true;
                    acc.pgTo--;
                }
                if (ellipsesProp.value && acc.pgTo < maxProp.value - (boundaryNumbersProp.value ? 1 : 0)) {
                    acc.ellipsesEnd = true;
                    acc.pgTo--;
                }
            }
            return acc;
        });
        function set(value1) {
            model.value = value1;
        }
        function setByOffset(offset) {
            model.value = model.value + offset;
        }
        function updateModel() {
            model.value = newPage.value;
            newPage.value = null;
            if ($q.platform.is.mobile === true) document.activeElement.blur();
        }
        function onInputValue(val) {
            newPage.value = val;
        }
        function onKeyup(e) {
            if (isKeyCode(e, 13) === true) updateModel();
        }
        function getBtn(cfg, page, active) {
            const data = {
                "aria-label": page,
                "aria-current": "false",
                ...btnProps.value,
                ...cfg
            };
            if (active === true) Object.assign(data, {
                "aria-current": "true",
                ...activeBtnProps.value
            });
            if (page !== void 0) {
                if (props.toFn !== void 0) data.to = props.toFn(page);
                else data.onClick = ()=>{
                    set(page);
                };
            }
            return (0, _vue.h)(QBtn_default, data);
        }
        Object.assign(proxy, {
            set,
            setByOffset
        });
        return ()=>{
            const contentStart = [];
            const contentEnd = [];
            let contentMiddle;
            if (boundaryLinksProp.value === true) {
                contentStart.push(getBtn({
                    key: "bls",
                    disable: props.disable || props.modelValue <= minProp.value,
                    icon: icons.value[0],
                    "aria-label": $q.lang.pagination.first
                }, minProp.value));
                contentEnd.unshift(getBtn({
                    key: "ble",
                    disable: props.disable || props.modelValue >= maxProp.value,
                    icon: icons.value[3],
                    "aria-label": $q.lang.pagination.last
                }, maxProp.value));
            }
            if (directionLinksProp.value === true) {
                contentStart.push(getBtn({
                    key: "bdp",
                    disable: props.disable || props.modelValue <= minProp.value,
                    icon: icons.value[1],
                    "aria-label": $q.lang.pagination.prev
                }, props.modelValue - 1));
                contentEnd.unshift(getBtn({
                    key: "bdn",
                    disable: props.disable || props.modelValue >= maxProp.value,
                    icon: icons.value[2],
                    "aria-label": $q.lang.pagination.next
                }, props.modelValue + 1));
            }
            if (props.input !== true) {
                contentMiddle = [];
                const { pgFrom, pgTo, marginalStyle: style } = btnConfig.value;
                if (btnConfig.value.boundaryStart === true) {
                    const active = minProp.value === props.modelValue;
                    contentStart.push(getBtn({
                        key: "bns",
                        style,
                        disable: props.disable,
                        label: minProp.value
                    }, minProp.value, active));
                }
                if (btnConfig.value.boundaryEnd === true) {
                    const active = maxProp.value === props.modelValue;
                    contentEnd.unshift(getBtn({
                        key: "bne",
                        style,
                        disable: props.disable,
                        label: maxProp.value
                    }, maxProp.value, active));
                }
                if (btnConfig.value.ellipsesStart === true) contentStart.push(getBtn({
                    key: "bes",
                    style,
                    disable: props.disable,
                    label: "\u2026",
                    ripple: false
                }, pgFrom - 1));
                if (btnConfig.value.ellipsesEnd === true) contentEnd.unshift(getBtn({
                    key: "bee",
                    style,
                    disable: props.disable,
                    label: "\u2026",
                    ripple: false
                }, pgTo + 1));
                for(let i = pgFrom; i <= pgTo; i++)contentMiddle.push(getBtn({
                    key: `bpg${i}`,
                    style,
                    disable: props.disable,
                    label: i
                }, i, i === props.modelValue));
            }
            return (0, _vue.h)("div", {
                class: classes.value,
                ...attrs.value
            }, [
                (0, _vue.h)("div", {
                    class: "q-pagination__content row no-wrap items-center",
                    style: gutterStyle.value
                }, [
                    ...contentStart,
                    props.input === true ? (0, _vue.h)(QInput_default, {
                        class: "inline",
                        style: {
                            width: `${inputPlaceholder.value.length / 1.5}em`
                        },
                        type: "number",
                        dense: true,
                        value: newPage.value,
                        disable: props.disable,
                        dark: isDark.value,
                        borderless: true,
                        inputClass: props.inputClass,
                        inputStyle: props.inputStyle,
                        placeholder: inputPlaceholder.value,
                        min: minProp.value,
                        max: maxProp.value,
                        "onUpdate:modelValue": onInputValue,
                        onKeyup,
                        onBlur: updateModel
                    }) : (0, _vue.h)("div", {
                        class: "q-pagination__middle row justify-center"
                    }, contentMiddle),
                    ...contentEnd
                ])
            ]);
        };
    }
});
//#endregion
//#region src/utils/frame-debounce/frame-debounce.js
function frameDebounce(fn) {
    let wait = false, frame, callArgs;
    function debounced() {
        callArgs = arguments;
        if (wait === true) return;
        wait = true;
        frame = window.requestAnimationFrame(()=>{
            fn.apply(this, callArgs);
            callArgs = void 0;
            wait = false;
        });
    }
    debounced.cancel = ()=>{
        window.cancelAnimationFrame(frame);
        wait = false;
    };
    return debounced;
}
//#endregion
//#region src/components/parallax/QParallax.js
const { passive: passive$1 } = listenOpts;
var QParallax_default = createComponent({
    name: "QParallax",
    props: {
        src: String,
        height: {
            type: Number,
            default: 500
        },
        speed: {
            type: Number,
            default: 1,
            validator: (v)=>v >= 0 && v <= 1
        },
        scrollTarget: scrollTargetProp,
        onScroll: Function
    },
    setup (props, { slots, emit }) {
        const percentScrolled = (0, _vue.ref)(0);
        const rootRef = (0, _vue.ref)(null);
        const mediaParentRef = (0, _vue.ref)(null);
        const mediaRef = (0, _vue.ref)(null);
        let isWorking, mediaEl, mediaHeight, resizeHandler, observer, localScrollTarget;
        (0, _vue.watch)(()=>props.height, ()=>{
            if (isWorking === true) updatePos();
        });
        (0, _vue.watch)(()=>props.scrollTarget, ()=>{
            if (isWorking === true) {
                stop();
                start();
            }
        });
        let update = (percentage)=>{
            percentScrolled.value = percentage;
            if (props.onScroll !== void 0) emit("scroll", percentage);
        };
        function updatePos() {
            let containerTop, containerHeight, containerBottom;
            if (localScrollTarget === window) {
                containerTop = 0;
                containerBottom = containerHeight = window.innerHeight;
            } else {
                containerTop = offset(localScrollTarget).top;
                containerHeight = height(localScrollTarget);
                containerBottom = containerTop + containerHeight;
            }
            const top = offset(rootRef.value).top;
            const bottom = top + props.height;
            if (observer !== void 0 || bottom > containerTop && top < containerBottom) {
                const percent = (containerBottom - top) / (props.height + containerHeight);
                setPos((mediaHeight - props.height) * percent * props.speed);
                update(percent);
            }
        }
        let setPos = (newOffset)=>{
            mediaEl.style.transform = `translate3d(-50%,${Math.round(newOffset)}px,0)`;
        };
        function onResize() {
            mediaHeight = mediaEl.naturalHeight || mediaEl.videoHeight || height(mediaEl);
            if (isWorking === true) updatePos();
        }
        function start() {
            isWorking = true;
            localScrollTarget = getScrollTarget(rootRef.value, props.scrollTarget);
            localScrollTarget.addEventListener("scroll", updatePos, passive$1);
            window.addEventListener("resize", resizeHandler, passive$1);
            updatePos();
        }
        function stop() {
            if (isWorking === true) {
                isWorking = false;
                localScrollTarget.removeEventListener("scroll", updatePos, passive$1);
                window.removeEventListener("resize", resizeHandler, passive$1);
                localScrollTarget = void 0;
                setPos.cancel();
                update.cancel();
                resizeHandler.cancel();
            }
        }
        (0, _vue.onMounted)(()=>{
            setPos = frameDebounce(setPos);
            update = frameDebounce(update);
            resizeHandler = frameDebounce(onResize);
            mediaEl = slots.media !== void 0 ? mediaParentRef.value.children[0] : mediaRef.value;
            mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = onResize;
            onResize();
            mediaEl.style.display = "initial";
            if (window.IntersectionObserver !== void 0) {
                observer = new IntersectionObserver((entries)=>{
                    (entries[0].isIntersecting === true ? start : stop)();
                });
                observer.observe(rootRef.value);
            } else start();
        });
        (0, _vue.onBeforeUnmount)(()=>{
            stop();
            observer?.disconnect();
            mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = null;
        });
        return ()=>(0, _vue.h)("div", {
                ref: rootRef,
                class: "q-parallax",
                style: {
                    height: `${props.height}px`
                }
            }, [
                (0, _vue.h)("div", {
                    ref: mediaParentRef,
                    class: "q-parallax__media absolute-full"
                }, slots.media !== void 0 ? slots.media() : [
                    (0, _vue.h)("img", {
                        ref: mediaRef,
                        src: props.src
                    })
                ]),
                (0, _vue.h)("div", {
                    class: "q-parallax__content absolute-full column flex-center"
                }, slots.content !== void 0 ? slots.content({
                    percentScrolled: percentScrolled.value
                }) : hSlot(slots.default))
            ]);
    }
});
//#endregion
//#region src/utils/clone/clone.js
function cloneDeep(data, hash = /* @__PURE__ */ new WeakMap()) {
    if (Object(data) !== data) return data;
    if (hash.has(data)) return hash.get(data);
    const result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? /* @__PURE__ */ new Set() : data instanceof Map ? /* @__PURE__ */ new Map() : typeof data.constructor !== "function" ? Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === "function" ? data : new data.constructor();
    if (typeof data.constructor === "function" && typeof data.valueOf === "function") {
        const val = data.valueOf();
        if (Object(val) !== val) {
            const localResult = new data.constructor(val);
            hash.set(data, localResult);
            return localResult;
        }
    }
    hash.set(data, result);
    if (data instanceof Set) data.forEach((val)=>{
        result.add(cloneDeep(val, hash));
    });
    else if (data instanceof Map) data.forEach((val, key)=>{
        result.set(key, cloneDeep(val, hash));
    });
    return Object.assign(result, ...Object.keys(data).map((key)=>({
            [key]: cloneDeep(data[key], hash)
        })));
}
//#endregion
//#region src/components/popup-edit/QPopupEdit.js
var QPopupEdit_default = createComponent({
    name: "QPopupEdit",
    props: {
        modelValue: {
            required: true
        },
        title: String,
        buttons: Boolean,
        labelSet: String,
        labelCancel: String,
        color: {
            type: String,
            default: "primary"
        },
        validate: {
            type: Function,
            default: ()=>true
        },
        autoSave: Boolean,
        cover: {
            type: Boolean,
            default: true
        },
        disable: Boolean
    },
    emits: [
        "update:modelValue",
        "save",
        "cancel",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const menuRef = (0, _vue.ref)(null);
        const initialValue = (0, _vue.ref)("");
        const currentModel = (0, _vue.ref)("");
        let validated = false;
        const scope = (0, _vue.computed)(()=>injectProp({
                initialValue: initialValue.value,
                validate: props.validate,
                set,
                cancel,
                updatePosition
            }, "value", ()=>currentModel.value, (val)=>{
                currentModel.value = val;
            }));
        function set() {
            if (props.validate(currentModel.value) === false) return;
            if (hasModelChanged() === true) {
                emit("save", currentModel.value, initialValue.value);
                emit("update:modelValue", currentModel.value);
            }
            closeMenu();
        }
        function cancel() {
            if (hasModelChanged() === true) emit("cancel", currentModel.value, initialValue.value);
            closeMenu();
        }
        function updatePosition() {
            (0, _vue.nextTick)(()=>{
                menuRef.value.updatePosition();
            });
        }
        function hasModelChanged() {
            return isDeepEqual(currentModel.value, initialValue.value) === false;
        }
        function closeMenu() {
            validated = true;
            menuRef.value.hide();
        }
        function onBeforeShow() {
            validated = false;
            initialValue.value = cloneDeep(props.modelValue);
            currentModel.value = cloneDeep(props.modelValue);
            emit("beforeShow");
        }
        function onShow() {
            emit("show");
        }
        function onBeforeHide() {
            if (validated === false && hasModelChanged() === true) {
                if (props.autoSave === true && props.validate(currentModel.value) === true) {
                    emit("save", currentModel.value, initialValue.value);
                    emit("update:modelValue", currentModel.value);
                } else emit("cancel", currentModel.value, initialValue.value);
            }
            emit("beforeHide");
        }
        function onHide() {
            emit("hide");
        }
        function getContent() {
            const child = slots.default !== void 0 ? [].concat(slots.default(scope.value)) : [];
            if (props.title) child.unshift((0, _vue.h)("div", {
                class: "q-dialog__title q-mt-sm q-mb-sm"
            }, props.title));
            if (props.buttons === true) child.push((0, _vue.h)("div", {
                class: "q-popup-edit__buttons row justify-center no-wrap"
            }, [
                (0, _vue.h)(QBtn_default, {
                    flat: true,
                    color: props.color,
                    label: props.labelCancel || $q.lang.label.cancel,
                    onClick: cancel
                }),
                (0, _vue.h)(QBtn_default, {
                    flat: true,
                    color: props.color,
                    label: props.labelSet || $q.lang.label.set,
                    onClick: set
                })
            ]));
            return child;
        }
        Object.assign(proxy, {
            set,
            cancel,
            show (e) {
                menuRef.value?.show(e);
            },
            hide (e) {
                menuRef.value?.hide(e);
            },
            updatePosition
        });
        return ()=>{
            if (props.disable === true) return;
            return (0, _vue.h)(QMenu_default, {
                ref: menuRef,
                class: "q-popup-edit",
                cover: props.cover,
                onBeforeShow,
                onShow,
                onBeforeHide,
                onHide,
                onEscapeKey: cancel
            }, getContent);
        };
    }
});
//#endregion
//#region src/components/popup-proxy/QPopupProxy.js
var QPopupProxy_default = createComponent({
    name: "QPopupProxy",
    props: {
        ...useAnchorProps,
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 450
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup (props, { slots, emit, attrs }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const showing = (0, _vue.ref)(false);
        const popupRef = (0, _vue.ref)(null);
        const breakpoint = (0, _vue.computed)(()=>parseInt(props.breakpoint, 10));
        const { canShow } = useAnchor({
            showing
        });
        function getType() {
            return $q.screen.width < breakpoint.value || $q.screen.height < breakpoint.value ? "dialog" : "menu";
        }
        const type = (0, _vue.ref)(getType());
        const popupProps = (0, _vue.computed)(()=>type.value === "menu" ? {
                maxHeight: "99vh"
            } : {});
        (0, _vue.watch)(()=>getType(), (val)=>{
            if (showing.value !== true) type.value = val;
        });
        function onShow(evt) {
            showing.value = true;
            emit("show", evt);
        }
        function onHide(evt) {
            showing.value = false;
            type.value = getType();
            emit("hide", evt);
        }
        Object.assign(proxy, {
            show (evt) {
                if (canShow(evt) === true) popupRef.value.show(evt);
            },
            hide (evt) {
                popupRef.value.hide(evt);
            },
            toggle (evt) {
                popupRef.value.toggle(evt);
            }
        });
        injectProp(proxy, "currentComponent", ()=>({
                type: type.value,
                ref: popupRef.value
            }));
        return ()=>{
            const data = {
                ref: popupRef,
                ...popupProps.value,
                ...attrs,
                onShow,
                onHide
            };
            let component;
            if (type.value === "dialog") component = QDialog_default;
            else {
                component = QMenu_default;
                Object.assign(data, {
                    target: props.target,
                    contextMenu: props.contextMenu,
                    noParentEvent: true,
                    separateClosePopup: true
                });
            }
            return (0, _vue.h)(component, data, slots.default);
        };
    }
});
//#endregion
//#region src/components/linear-progress/QLinearProgress.js
const defaultSizes = {
    xs: 2,
    sm: 4,
    md: 6,
    lg: 10,
    xl: 14
};
function width(val, reverse, $q) {
    return {
        transform: reverse === true ? `translateX(${$q.lang.rtl === true ? "-" : ""}100%) scale3d(${-val},1,1)` : `scale3d(${val},1,1)`
    };
}
var QLinearProgress_default = createComponent({
    name: "QLinearProgress",
    props: {
        ...useDarkProps,
        ...useSizeProps,
        value: {
            type: Number,
            default: 0
        },
        buffer: Number,
        color: String,
        trackColor: String,
        reverse: Boolean,
        stripe: Boolean,
        indeterminate: Boolean,
        query: Boolean,
        rounded: Boolean,
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 2100
        },
        instantFeedback: Boolean
    },
    setup (props, { slots }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, proxy.$q);
        const sizeStyle = useSize(props, defaultSizes);
        const motion = (0, _vue.computed)(()=>props.indeterminate === true || props.query === true);
        const widthReverse = (0, _vue.computed)(()=>props.reverse !== props.query);
        const style = (0, _vue.computed)(()=>({
                ...sizeStyle.value !== null ? sizeStyle.value : {},
                "--q-linear-progress-speed": `${props.animationSpeed}ms`
            }));
        const classes = (0, _vue.computed)(()=>"q-linear-progress" + (props.color !== void 0 ? ` text-${props.color}` : "") + (props.reverse === true || props.query === true ? " q-linear-progress--reverse" : "") + (props.rounded === true ? " rounded-borders" : ""));
        const trackStyle = (0, _vue.computed)(()=>width(props.buffer !== void 0 ? props.buffer : 1, widthReverse.value, proxy.$q));
        const transitionSuffix = (0, _vue.computed)(()=>`with${props.instantFeedback === true ? "out" : ""}-transition`);
        const trackClass = (0, _vue.computed)(()=>`q-linear-progress__track absolute-full q-linear-progress__track--${transitionSuffix.value} q-linear-progress__track--${isDark.value === true ? "dark" : "light"}` + (props.trackColor !== void 0 ? ` bg-${props.trackColor}` : ""));
        const modelStyle = (0, _vue.computed)(()=>width(motion.value === true ? 1 : props.value, widthReverse.value, proxy.$q));
        const modelClass = (0, _vue.computed)(()=>`q-linear-progress__model absolute-full q-linear-progress__model--${transitionSuffix.value} q-linear-progress__model--${motion.value === true ? "in" : ""}determinate`);
        const stripeStyle = (0, _vue.computed)(()=>({
                width: `${props.value * 100}%`
            }));
        const stripeClass = (0, _vue.computed)(()=>`q-linear-progress__stripe absolute-${props.reverse === true ? "right" : "left"} q-linear-progress__stripe--${transitionSuffix.value}`);
        return ()=>{
            const child = [
                (0, _vue.h)("div", {
                    class: trackClass.value,
                    style: trackStyle.value
                }),
                (0, _vue.h)("div", {
                    class: modelClass.value,
                    style: modelStyle.value
                })
            ];
            if (props.stripe === true && motion.value === false) child.push((0, _vue.h)("div", {
                class: stripeClass.value,
                style: stripeStyle.value
            }));
            return (0, _vue.h)("div", {
                class: classes.value,
                style: style.value,
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 1,
                "aria-valuenow": props.indeterminate === true ? void 0 : props.value
            }, hMergeSlot(slots.default, child));
        };
    }
});
//#endregion
//#region src/components/pull-to-refresh/QPullToRefresh.js
const PULLER_HEIGHT = 40, OFFSET_TOP = 20;
var QPullToRefresh_default = createComponent({
    name: "QPullToRefresh",
    props: {
        color: String,
        bgColor: String,
        icon: String,
        noMouse: Boolean,
        disable: Boolean,
        scrollTarget: scrollTargetProp
    },
    emits: [
        "refresh"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const state = (0, _vue.ref)("pull");
        const pullRatio = (0, _vue.ref)(0);
        const pulling = (0, _vue.ref)(false);
        const pullPosition = (0, _vue.ref)(-PULLER_HEIGHT);
        const animating = (0, _vue.ref)(false);
        const positionCSS = (0, _vue.ref)({});
        const style = (0, _vue.computed)(()=>({
                opacity: pullRatio.value,
                transform: `translateY(${pullPosition.value}px) rotate(${pullRatio.value * 360}deg)`
            }));
        const classes = (0, _vue.computed)(()=>"q-pull-to-refresh__puller row flex-center" + (animating.value === true ? " q-pull-to-refresh__puller--animating" : "") + (props.bgColor !== void 0 ? ` bg-${props.bgColor}` : ""));
        function pull(event) {
            if (event.isFinal === true) {
                if (pulling.value === true) {
                    pulling.value = false;
                    if (state.value === "pulled") {
                        state.value = "refreshing";
                        animateTo({
                            pos: OFFSET_TOP
                        });
                        trigger();
                    } else if (state.value === "pull") animateTo({
                        pos: -PULLER_HEIGHT,
                        ratio: 0
                    });
                }
                return;
            }
            if (animating.value === true || state.value === "refreshing") return false;
            if (event.isFirst === true) {
                if (getVerticalScrollPosition(localScrollTarget) !== 0 || event.direction !== "down") {
                    if (pulling.value === true) {
                        pulling.value = false;
                        state.value = "pull";
                        animateTo({
                            pos: -PULLER_HEIGHT,
                            ratio: 0
                        });
                    }
                    return false;
                }
                pulling.value = true;
                const { top, left } = proxy.$el.getBoundingClientRect();
                positionCSS.value = {
                    top: top + "px",
                    left: left + "px",
                    width: window.getComputedStyle(proxy.$el).getPropertyValue("width")
                };
            }
            prevent(event.evt);
            const distance = Math.min(140, Math.max(0, event.distance.y));
            pullPosition.value = distance - PULLER_HEIGHT;
            pullRatio.value = between(distance / (OFFSET_TOP + PULLER_HEIGHT), 0, 1);
            const newState = pullPosition.value > OFFSET_TOP ? "pulled" : "pull";
            if (state.value !== newState) state.value = newState;
        }
        const directives = (0, _vue.computed)(()=>{
            const modifiers = {
                down: true
            };
            if (props.noMouse !== true) modifiers.mouse = true;
            return [
                [
                    TouchPan_default,
                    pull,
                    void 0,
                    modifiers
                ]
            ];
        });
        const contentClass = (0, _vue.computed)(()=>`q-pull-to-refresh__content${pulling.value === true ? " no-pointer-events" : ""}`);
        function trigger() {
            emit("refresh", ()=>{
                animateTo({
                    pos: -PULLER_HEIGHT,
                    ratio: 0
                }, ()=>{
                    state.value = "pull";
                });
            });
        }
        let localScrollTarget, timer = null;
        function animateTo({ pos, ratio }, done) {
            animating.value = true;
            pullPosition.value = pos;
            if (ratio !== void 0) pullRatio.value = ratio;
            if (timer !== null) clearTimeout(timer);
            timer = setTimeout(()=>{
                timer = null;
                animating.value = false;
                done?.();
            }, 300);
        }
        function updateScrollTarget() {
            localScrollTarget = getScrollTarget(proxy.$el, props.scrollTarget);
        }
        (0, _vue.watch)(()=>props.scrollTarget, updateScrollTarget);
        (0, _vue.onMounted)(updateScrollTarget);
        (0, _vue.onBeforeUnmount)(()=>{
            if (timer !== null) clearTimeout(timer);
        });
        Object.assign(proxy, {
            trigger,
            updateScrollTarget
        });
        return ()=>{
            return hDir("div", {
                class: "q-pull-to-refresh"
            }, [
                (0, _vue.h)("div", {
                    class: contentClass.value
                }, hSlot(slots.default)),
                (0, _vue.h)("div", {
                    class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
                    style: positionCSS.value
                }, [
                    (0, _vue.h)("div", {
                        class: classes.value,
                        style: style.value
                    }, [
                        state.value !== "refreshing" ? (0, _vue.h)(QIcon_default, {
                            name: props.icon || $q.iconSet.pullToRefresh.icon,
                            color: props.color,
                            size: "32px"
                        }) : (0, _vue.h)(QSpinner_default, {
                            size: "24px",
                            color: props.color
                        })
                    ])
                ])
            ], "main", props.disable === false, ()=>directives.value);
        };
    }
});
//#endregion
//#region src/components/range/QRange.js
const dragType = {
    MIN: 0,
    RANGE: 1,
    MAX: 2
};
var QRange_default = createComponent({
    name: "QRange",
    props: {
        ...useSliderProps,
        modelValue: {
            type: Object,
            default: ()=>({
                    min: null,
                    max: null
                }),
            validator: (v)=>"min" in v && "max" in v
        },
        dragRange: Boolean,
        dragOnlyRange: Boolean,
        leftLabelColor: String,
        leftLabelTextColor: String,
        rightLabelColor: String,
        rightLabelTextColor: String,
        leftLabelValue: [
            String,
            Number
        ],
        rightLabelValue: [
            String,
            Number
        ],
        leftThumbColor: String,
        rightThumbColor: String
    },
    emits: useSliderEmits,
    setup (props, { emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const { state, methods } = useSlider({
            updateValue,
            updatePosition,
            getDragging,
            formAttrs: (0, _vue.computed)(()=>({
                    type: "hidden",
                    name: props.name,
                    value: `${props.modelValue.min}|${props.modelValue.max}`
                }))
        });
        const rootRef = (0, _vue.ref)(null);
        const curMinRatio = (0, _vue.ref)(0);
        const curMaxRatio = (0, _vue.ref)(0);
        const model = (0, _vue.ref)({
            min: 0,
            max: 0
        });
        function normalizeModel() {
            model.value.min = props.modelValue.min === null ? state.innerMin.value : between(props.modelValue.min, state.innerMin.value, state.innerMax.value);
            model.value.max = props.modelValue.max === null ? state.innerMax.value : between(props.modelValue.max, state.innerMin.value, state.innerMax.value);
        }
        (0, _vue.watch)(()=>`${props.modelValue.min}|${props.modelValue.max}|${state.innerMin.value}|${state.innerMax.value}`, normalizeModel);
        normalizeModel();
        const modelMinRatio = (0, _vue.computed)(()=>methods.convertModelToRatio(model.value.min));
        const modelMaxRatio = (0, _vue.computed)(()=>methods.convertModelToRatio(model.value.max));
        const ratioMin = (0, _vue.computed)(()=>state.active.value === true ? curMinRatio.value : modelMinRatio.value);
        const ratioMax = (0, _vue.computed)(()=>state.active.value === true ? curMaxRatio.value : modelMaxRatio.value);
        const selectionBarStyle = (0, _vue.computed)(()=>{
            const acc = {
                [state.positionProp.value]: `${100 * ratioMin.value}%`,
                [state.sizeProp.value]: `${100 * (ratioMax.value - ratioMin.value)}%`
            };
            if (props.selectionImg !== void 0) acc.backgroundImage = `url(${props.selectionImg}) !important`;
            return acc;
        });
        const trackContainerEvents = (0, _vue.computed)(()=>{
            if (state.editable.value !== true) return {};
            if ($q.platform.is.mobile === true) return {
                onClick: methods.onMobileClick
            };
            const evt = {
                onMousedown: methods.onActivate
            };
            if (props.dragRange === true || props.dragOnlyRange === true) Object.assign(evt, {
                onFocus: ()=>{
                    state.focus.value = "both";
                },
                onBlur: methods.onBlur,
                onKeydown,
                onKeyup: methods.onKeyup
            });
            return evt;
        });
        function getEvents(side) {
            return $q.platform.is.mobile !== true && state.editable.value === true && props.dragOnlyRange !== true ? {
                onFocus: ()=>{
                    state.focus.value = side;
                },
                onBlur: methods.onBlur,
                onKeydown,
                onKeyup: methods.onKeyup
            } : {};
        }
        const thumbTabindex = (0, _vue.computed)(()=>props.dragOnlyRange !== true ? state.tabindex.value : null);
        const trackContainerTabindex = (0, _vue.computed)(()=>$q.platform.is.mobile !== true && (props.dragRange || props.dragOnlyRange === true) ? state.tabindex.value : null);
        const minThumbRef = (0, _vue.ref)(null);
        const minEvents = (0, _vue.computed)(()=>getEvents("min"));
        const getMinThumb = methods.getThumbRenderFn({
            focusValue: "min",
            getNodeData: ()=>({
                    ref: minThumbRef,
                    key: "tmin",
                    ...minEvents.value,
                    tabindex: thumbTabindex.value
                }),
            ratio: ratioMin,
            label: (0, _vue.computed)(()=>props.leftLabelValue !== void 0 ? props.leftLabelValue : model.value.min),
            thumbColor: (0, _vue.computed)(()=>props.leftThumbColor || props.thumbColor || props.color),
            labelColor: (0, _vue.computed)(()=>props.leftLabelColor || props.labelColor),
            labelTextColor: (0, _vue.computed)(()=>props.leftLabelTextColor || props.labelTextColor)
        });
        const maxEvents = (0, _vue.computed)(()=>getEvents("max"));
        const getMaxThumb = methods.getThumbRenderFn({
            focusValue: "max",
            getNodeData: ()=>({
                    ...maxEvents.value,
                    key: "tmax",
                    tabindex: thumbTabindex.value
                }),
            ratio: ratioMax,
            label: (0, _vue.computed)(()=>props.rightLabelValue !== void 0 ? props.rightLabelValue : model.value.max),
            thumbColor: (0, _vue.computed)(()=>props.rightThumbColor || props.thumbColor || props.color),
            labelColor: (0, _vue.computed)(()=>props.rightLabelColor || props.labelColor),
            labelTextColor: (0, _vue.computed)(()=>props.rightLabelTextColor || props.labelTextColor)
        });
        function updateValue(change) {
            if (model.value.min !== props.modelValue.min || model.value.max !== props.modelValue.max) emit("update:modelValue", {
                ...model.value
            });
            if (change === true) emit("change", {
                ...model.value
            });
        }
        function getDragging(event) {
            const { left, top, width, height } = rootRef.value.getBoundingClientRect(), sensitivity = props.dragOnlyRange === true ? 0 : props.vertical === true ? minThumbRef.value.offsetHeight / (2 * height) : minThumbRef.value.offsetWidth / (2 * width);
            const dragging = {
                left,
                top,
                width,
                height,
                valueMin: model.value.min,
                valueMax: model.value.max,
                ratioMin: modelMinRatio.value,
                ratioMax: modelMaxRatio.value
            };
            const ratio = methods.getDraggingRatio(event, dragging);
            if (props.dragOnlyRange !== true && ratio < dragging.ratioMin + sensitivity) dragging.type = dragType.MIN;
            else if (props.dragOnlyRange === true || ratio < dragging.ratioMax - sensitivity) {
                if (props.dragRange === true || props.dragOnlyRange === true) {
                    dragging.type = dragType.RANGE;
                    Object.assign(dragging, {
                        offsetRatio: ratio,
                        offsetModel: methods.convertRatioToModel(ratio),
                        rangeValue: dragging.valueMax - dragging.valueMin,
                        rangeRatio: dragging.ratioMax - dragging.ratioMin
                    });
                } else dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType.MAX : dragType.MIN;
            } else dragging.type = dragType.MAX;
            return dragging;
        }
        function updatePosition(event, dragging = state.dragging.value) {
            let pos;
            const ratio = methods.getDraggingRatio(event, dragging);
            const localModel = methods.convertRatioToModel(ratio);
            switch(dragging.type){
                case dragType.MIN:
                    if (ratio <= dragging.ratioMax) {
                        pos = {
                            minR: ratio,
                            maxR: dragging.ratioMax,
                            min: localModel,
                            max: dragging.valueMax
                        };
                        state.focus.value = "min";
                    } else {
                        pos = {
                            minR: dragging.ratioMax,
                            maxR: ratio,
                            min: dragging.valueMax,
                            max: localModel
                        };
                        state.focus.value = "max";
                    }
                    break;
                case dragType.MAX:
                    if (ratio >= dragging.ratioMin) {
                        pos = {
                            minR: dragging.ratioMin,
                            maxR: ratio,
                            min: dragging.valueMin,
                            max: localModel
                        };
                        state.focus.value = "max";
                    } else {
                        pos = {
                            minR: ratio,
                            maxR: dragging.ratioMin,
                            min: localModel,
                            max: dragging.valueMin
                        };
                        state.focus.value = "min";
                    }
                    break;
                case dragType.RANGE:
                    const ratioDelta = ratio - dragging.offsetRatio, minR = between(dragging.ratioMin + ratioDelta, state.innerMinRatio.value, state.innerMaxRatio.value - dragging.rangeRatio), modelDelta = localModel - dragging.offsetModel, min = between(dragging.valueMin + modelDelta, state.innerMin.value, state.innerMax.value - dragging.rangeValue);
                    pos = {
                        minR,
                        maxR: minR + dragging.rangeRatio,
                        min: state.roundValueFn.value(min),
                        max: state.roundValueFn.value(min + dragging.rangeValue)
                    };
                    state.focus.value = "both";
                    break;
            }
            model.value = model.value.min === null || model.value.max === null ? {
                min: pos.min || props.min,
                max: pos.max || props.max
            } : {
                min: pos.min,
                max: pos.max
            };
            if (props.snap !== true || props.step === 0) {
                curMinRatio.value = pos.minR;
                curMaxRatio.value = pos.maxR;
            } else {
                curMinRatio.value = methods.convertModelToRatio(model.value.min);
                curMaxRatio.value = methods.convertModelToRatio(model.value.max);
            }
        }
        function onKeydown(evt) {
            if (keyCodes$2.includes(evt.keyCode) === false) return;
            stopAndPrevent(evt);
            const stepVal = ([
                34,
                33
            ].includes(evt.keyCode) ? 10 : 1) * state.keyStep.value, offset = ([
                34,
                37,
                40
            ].includes(evt.keyCode) ? -1 : 1) * (state.isReversed.value === true ? -1 : 1) * (props.vertical === true ? -1 : 1) * stepVal;
            if (state.focus.value === "both") {
                const interval = model.value.max - model.value.min;
                const min = between(state.roundValueFn.value(model.value.min + offset), state.innerMin.value, state.innerMax.value - interval);
                model.value = {
                    min,
                    max: state.roundValueFn.value(min + interval)
                };
            } else if (state.focus.value === false) return;
            else {
                const which = state.focus.value;
                model.value = {
                    ...model.value,
                    [which]: between(state.roundValueFn.value(model.value[which] + offset), which === "min" ? state.innerMin.value : model.value.min, which === "max" ? state.innerMax.value : model.value.max)
                };
            }
            updateValue();
        }
        return ()=>{
            const content = methods.getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, (node)=>{
                node.push(getMinThumb(), getMaxThumb());
            });
            return (0, _vue.h)("div", {
                ref: rootRef,
                class: "q-range " + state.classes.value + (props.modelValue.min === null || props.modelValue.max === null ? " q-slider--no-value" : ""),
                ...state.attributes.value,
                "aria-valuenow": props.modelValue.min + "|" + props.modelValue.max
            }, content);
        };
    }
});
//#endregion
//#region src/components/rating/QRating.js
var QRating_default = createComponent({
    name: "QRating",
    props: {
        ...useSizeProps,
        ...useFormProps,
        modelValue: {
            type: Number,
            required: true
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 5
        },
        icon: [
            String,
            Array
        ],
        iconHalf: [
            String,
            Array
        ],
        iconSelected: [
            String,
            Array
        ],
        iconAriaLabel: [
            String,
            Array
        ],
        color: [
            String,
            Array
        ],
        colorHalf: [
            String,
            Array
        ],
        colorSelected: [
            String,
            Array
        ],
        noReset: Boolean,
        noDimming: Boolean,
        readonly: Boolean,
        disable: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const sizeStyle = useSize(props);
        const injectFormInput = useFormInject(useFormAttrs(props));
        const mouseModel = (0, _vue.ref)(0);
        let iconRefs = {};
        const editable = (0, _vue.computed)(()=>props.readonly !== true && props.disable !== true);
        const classes = (0, _vue.computed)(()=>`q-rating row inline items-center q-rating--${editable.value === true ? "" : "non-"}editable` + (props.noDimming === true ? " q-rating--no-dimming" : "") + (props.disable === true ? " disabled" : "") + (props.color !== void 0 && Array.isArray(props.color) === false ? ` text-${props.color}` : ""));
        const iconData = (0, _vue.computed)(()=>{
            const iconLen = Array.isArray(props.icon) === true ? props.icon.length : 0, selIconLen = Array.isArray(props.iconSelected) === true ? props.iconSelected.length : 0, halfIconLen = Array.isArray(props.iconHalf) === true ? props.iconHalf.length : 0, colorLen = Array.isArray(props.color) === true ? props.color.length : 0, selColorLen = Array.isArray(props.colorSelected) === true ? props.colorSelected.length : 0, halfColorLen = Array.isArray(props.colorHalf) === true ? props.colorHalf.length : 0;
            return {
                iconLen,
                icon: iconLen > 0 ? props.icon[iconLen - 1] : props.icon,
                selIconLen,
                selIcon: selIconLen > 0 ? props.iconSelected[selIconLen - 1] : props.iconSelected,
                halfIconLen,
                halfIcon: halfIconLen > 0 ? props.iconHalf[selIconLen - 1] : props.iconHalf,
                colorLen,
                color: colorLen > 0 ? props.color[colorLen - 1] : props.color,
                selColorLen,
                selColor: selColorLen > 0 ? props.colorSelected[selColorLen - 1] : props.colorSelected,
                halfColorLen,
                halfColor: halfColorLen > 0 ? props.colorHalf[halfColorLen - 1] : props.colorHalf
            };
        });
        const iconLabel = (0, _vue.computed)(()=>{
            if (typeof props.iconAriaLabel === "string") {
                const label = props.iconAriaLabel.length !== 0 ? `${props.iconAriaLabel} ` : "";
                return (i)=>`${label}${i}`;
            }
            if (Array.isArray(props.iconAriaLabel) === true) {
                const iMax = props.iconAriaLabel.length;
                if (iMax > 0) return (i)=>props.iconAriaLabel[Math.min(i, iMax) - 1];
            }
            return (i, label)=>`${label} ${i}`;
        });
        const stars = (0, _vue.computed)(()=>{
            const acc = [], icons = iconData.value, ceil = Math.ceil(props.modelValue), tabindex = editable.value === true ? 0 : null;
            const halfIndex = props.iconHalf === void 0 || ceil === props.modelValue ? -1 : ceil;
            for(let i = 1; i <= props.max; i++){
                const active = mouseModel.value === 0 && props.modelValue >= i || mouseModel.value > 0 && mouseModel.value >= i, half = halfIndex === i && mouseModel.value < i, exSelected = mouseModel.value > 0 && (half === true ? ceil : props.modelValue) >= i && mouseModel.value < i, color = half === true ? i <= icons.halfColorLen ? props.colorHalf[i - 1] : icons.halfColor : icons.selColor !== void 0 && active === true ? i <= icons.selColorLen ? props.colorSelected[i - 1] : icons.selColor : i <= icons.colorLen ? props.color[i - 1] : icons.color, name = (half === true ? i <= icons.halfIconLen ? props.iconHalf[i - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i <= icons.selIconLen ? props.iconSelected[i - 1] : icons.selIcon : i <= icons.iconLen ? props.icon[i - 1] : icons.icon) || $q.iconSet.rating.icon;
                acc.push({
                    name: (half === true ? i <= icons.halfIconLen ? props.iconHalf[i - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i <= icons.selIconLen ? props.iconSelected[i - 1] : icons.selIcon : i <= icons.iconLen ? props.icon[i - 1] : icons.icon) || $q.iconSet.rating.icon,
                    attrs: {
                        tabindex,
                        role: "radio",
                        "aria-checked": props.modelValue === i ? "true" : "false",
                        "aria-label": iconLabel.value(i, name)
                    },
                    iconClass: "q-rating__icon" + (active === true || half === true ? " q-rating__icon--active" : "") + (exSelected === true ? " q-rating__icon--exselected" : "") + (mouseModel.value === i ? " q-rating__icon--hovered" : "") + (color !== void 0 ? ` text-${color}` : "")
                });
            }
            return acc;
        });
        const attributes = (0, _vue.computed)(()=>{
            const attrs = {
                role: "radiogroup"
            };
            if (props.disable === true) attrs["aria-disabled"] = "true";
            if (props.readonly === true) attrs["aria-readonly"] = "true";
            return attrs;
        });
        function set(value1) {
            if (editable.value === true) {
                const model = between(parseInt(value1, 10), 1, parseInt(props.max, 10)), newVal = props.noReset !== true && props.modelValue === model ? 0 : model;
                if (newVal !== props.modelValue) emit("update:modelValue", newVal);
                mouseModel.value = 0;
            }
        }
        function setHoverValue(value1) {
            if (editable.value === true) mouseModel.value = value1;
        }
        function onKeyup(e, i) {
            switch(e.keyCode){
                case 13:
                case 32:
                    set(i);
                    return stopAndPrevent(e);
                case 37:
                case 40:
                    if (iconRefs[`rt${i - 1}`]) iconRefs[`rt${i - 1}`].focus();
                    return stopAndPrevent(e);
                case 39:
                case 38:
                    if (iconRefs[`rt${i + 1}`]) iconRefs[`rt${i + 1}`].focus();
                    return stopAndPrevent(e);
            }
        }
        function resetMouseModel() {
            mouseModel.value = 0;
        }
        (0, _vue.onBeforeUpdate)(()=>{
            iconRefs = {};
        });
        return ()=>{
            const child = [];
            stars.value.forEach(({ iconClass, name, attrs }, index)=>{
                const i = index + 1;
                child.push((0, _vue.h)("div", {
                    key: i,
                    ref: (el)=>{
                        iconRefs[`rt${i}`] = el;
                    },
                    class: "q-rating__icon-container flex flex-center",
                    ...attrs,
                    onClick () {
                        set(i);
                    },
                    onMouseover () {
                        setHoverValue(i);
                    },
                    onMouseout: resetMouseModel,
                    onFocus () {
                        setHoverValue(i);
                    },
                    onBlur: resetMouseModel,
                    onKeyup (e) {
                        onKeyup(e, i);
                    }
                }, hMergeSlot(slots[`tip-${i}`], [
                    (0, _vue.h)(QIcon_default, {
                        class: iconClass,
                        name
                    })
                ])));
            });
            if (props.name !== void 0 && props.disable !== true) injectFormInput(child, "push");
            return (0, _vue.h)("div", {
                class: classes.value,
                style: sizeStyle.value,
                ...attributes.value
            }, child);
        };
    }
});
//#endregion
//#region src/components/responsive/QResponsive.js
var QResponsive_default = createComponent({
    name: "QResponsive",
    props: useRatioProps,
    setup (props, { slots }) {
        const ratioStyle = useRatio(props);
        return ()=>(0, _vue.h)("div", {
                class: "q-responsive"
            }, [
                (0, _vue.h)("div", {
                    class: "q-responsive__filler overflow-hidden"
                }, [
                    (0, _vue.h)("div", {
                        style: ratioStyle.value
                    })
                ]),
                (0, _vue.h)("div", {
                    class: "q-responsive__content absolute-full fit"
                }, hSlot(slots.default))
            ]);
    }
});
//#endregion
//#region src/components/scroll-area/ScrollAreaControls.js
/**
* We are using a sub-component to avoid unnecessary re-renders
* of the QScrollArea content when the scrollbars are interacted with.
*/ var ScrollAreaControls_default = createComponent({
    props: [
        "store",
        "barStyle",
        "verticalBarStyle",
        "horizontalBarStyle"
    ],
    setup (props) {
        return ()=>[
                (0, _vue.h)("div", {
                    class: props.store.scroll.vertical.barClass.value,
                    style: [
                        props.barStyle,
                        props.verticalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: props.store.onVerticalMousedown
                }),
                (0, _vue.h)("div", {
                    class: props.store.scroll.horizontal.barClass.value,
                    style: [
                        props.barStyle,
                        props.horizontalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: props.store.onHorizontalMousedown
                }),
                (0, _vue.withDirectives)((0, _vue.h)("div", {
                    ref: props.store.scroll.vertical.ref,
                    class: props.store.scroll.vertical.thumbClass.value,
                    style: props.store.scroll.vertical.style.value,
                    "aria-hidden": "true"
                }), props.store.thumbVertDir),
                (0, _vue.withDirectives)((0, _vue.h)("div", {
                    ref: props.store.scroll.horizontal.ref,
                    class: props.store.scroll.horizontal.thumbClass.value,
                    style: props.store.scroll.horizontal.style.value,
                    "aria-hidden": "true"
                }), props.store.thumbHorizDir)
            ];
    }
});
//#endregion
//#region src/components/scroll-area/QScrollArea.js
const axisList = [
    "vertical",
    "horizontal"
];
const dirProps = {
    vertical: {
        offset: "offsetY",
        scroll: "scrollTop",
        dir: "down",
        dist: "y"
    },
    horizontal: {
        offset: "offsetX",
        scroll: "scrollLeft",
        dir: "right",
        dist: "x"
    }
};
const panOpts = {
    prevent: true,
    mouse: true,
    mouseAllDir: true
};
const getMinThumbSize = (size)=>size >= 250 ? 50 : Math.ceil(size / 5);
var QScrollArea_default = createComponent({
    name: "QScrollArea",
    props: {
        ...useDarkProps,
        thumbStyle: Object,
        verticalThumbStyle: Object,
        horizontalThumbStyle: Object,
        barStyle: [
            Array,
            String,
            Object
        ],
        verticalBarStyle: [
            Array,
            String,
            Object
        ],
        horizontalBarStyle: [
            Array,
            String,
            Object
        ],
        verticalOffset: {
            type: Array,
            default: [
                0,
                0
            ]
        },
        horizontalOffset: {
            type: Array,
            default: [
                0,
                0
            ]
        },
        contentStyle: [
            Array,
            String,
            Object
        ],
        contentActiveStyle: [
            Array,
            String,
            Object
        ],
        delay: {
            type: [
                String,
                Number
            ],
            default: 1e3
        },
        visible: {
            type: Boolean,
            default: null
        },
        tabindex: [
            String,
            Number
        ],
        onScroll: Function
    },
    setup (props, { slots, emit }) {
        const tempShowing = (0, _vue.ref)(false);
        const panning = (0, _vue.ref)(false);
        const hover = (0, _vue.ref)(false);
        const container = {
            vertical: (0, _vue.ref)(0),
            horizontal: (0, _vue.ref)(0)
        };
        const scroll = {
            vertical: {
                ref: (0, _vue.ref)(null),
                position: (0, _vue.ref)(0),
                size: (0, _vue.ref)(0)
            },
            horizontal: {
                ref: (0, _vue.ref)(null),
                position: (0, _vue.ref)(0),
                size: (0, _vue.ref)(0)
            }
        };
        const { proxy } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, proxy.$q);
        let timer = null, panRefPos;
        const targetRef = (0, _vue.ref)(null);
        const classes = (0, _vue.computed)(()=>"q-scrollarea" + (isDark.value === true ? " q-scrollarea--dark" : ""));
        Object.assign(container, {
            verticalInner: (0, _vue.computed)(()=>container.vertical.value - props.verticalOffset[0] - props.verticalOffset[1]),
            horizontalInner: (0, _vue.computed)(()=>container.horizontal.value - props.horizontalOffset[0] - props.horizontalOffset[1])
        });
        scroll.vertical.percentage = (0, _vue.computed)(()=>{
            const diff = scroll.vertical.size.value - container.vertical.value;
            if (diff <= 0) return 0;
            const p = between(scroll.vertical.position.value / diff, 0, 1);
            return Math.round(p * 1e4) / 1e4;
        });
        scroll.vertical.thumbHidden = (0, _vue.computed)(()=>(props.visible === null ? hover.value : props.visible) !== true && tempShowing.value === false && panning.value === false || scroll.vertical.size.value <= container.vertical.value + 1);
        scroll.vertical.thumbStart = (0, _vue.computed)(()=>props.verticalOffset[0] + scroll.vertical.percentage.value * (container.verticalInner.value - scroll.vertical.thumbSize.value));
        scroll.vertical.thumbSize = (0, _vue.computed)(()=>Math.round(between(container.verticalInner.value * container.verticalInner.value / scroll.vertical.size.value, getMinThumbSize(container.verticalInner.value), container.verticalInner.value)));
        scroll.vertical.style = (0, _vue.computed)(()=>({
                ...props.thumbStyle,
                ...props.verticalThumbStyle,
                top: `${scroll.vertical.thumbStart.value}px`,
                height: `${scroll.vertical.thumbSize.value}px`,
                right: `${props.horizontalOffset[1]}px`
            }));
        scroll.vertical.thumbClass = (0, _vue.computed)(()=>"q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
        scroll.vertical.barClass = (0, _vue.computed)(()=>"q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
        scroll.horizontal.percentage = (0, _vue.computed)(()=>{
            const diff = scroll.horizontal.size.value - container.horizontal.value;
            if (diff <= 0) return 0;
            const p = between(Math.abs(scroll.horizontal.position.value) / diff, 0, 1);
            return Math.round(p * 1e4) / 1e4;
        });
        scroll.horizontal.thumbHidden = (0, _vue.computed)(()=>(props.visible === null ? hover.value : props.visible) !== true && tempShowing.value === false && panning.value === false || scroll.horizontal.size.value <= container.horizontal.value + 1);
        scroll.horizontal.thumbStart = (0, _vue.computed)(()=>props.horizontalOffset[0] + scroll.horizontal.percentage.value * (container.horizontalInner.value - scroll.horizontal.thumbSize.value));
        scroll.horizontal.thumbSize = (0, _vue.computed)(()=>Math.round(between(container.horizontalInner.value * container.horizontalInner.value / scroll.horizontal.size.value, getMinThumbSize(container.horizontalInner.value), container.horizontalInner.value)));
        scroll.horizontal.style = (0, _vue.computed)(()=>({
                ...props.thumbStyle,
                ...props.horizontalThumbStyle,
                [proxy.$q.lang.rtl === true ? "right" : "left"]: `${scroll.horizontal.thumbStart.value}px`,
                width: `${scroll.horizontal.thumbSize.value}px`,
                bottom: `${props.verticalOffset[1]}px`
            }));
        scroll.horizontal.thumbClass = (0, _vue.computed)(()=>"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
        scroll.horizontal.barClass = (0, _vue.computed)(()=>"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
        const mainStyle = (0, _vue.computed)(()=>scroll.vertical.thumbHidden.value === true && scroll.horizontal.thumbHidden.value === true ? props.contentStyle : props.contentActiveStyle);
        function getScroll() {
            const info = {};
            axisList.forEach((axis)=>{
                const data = scroll[axis];
                Object.assign(info, {
                    [axis + "Position"]: data.position.value,
                    [axis + "Percentage"]: data.percentage.value,
                    [axis + "Size"]: data.size.value,
                    [axis + "ContainerSize"]: container[axis].value,
                    [axis + "ContainerInnerSize"]: container[axis + "Inner"].value
                });
            });
            return info;
        }
        const emitScroll = debounce(()=>{
            const info = getScroll();
            info.ref = proxy;
            emit("scroll", info);
        }, 0);
        function localSetScrollPosition(axis, offset, duration) {
            if (axisList.includes(axis) === false) {
                console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
                return;
            }
            (axis === "vertical" ? setVerticalScrollPosition : setHorizontalScrollPosition)(targetRef.value, offset, duration);
        }
        function updateContainer({ height, width }) {
            let change = false;
            if (container.vertical.value !== height) {
                container.vertical.value = height;
                change = true;
            }
            if (container.horizontal.value !== width) {
                container.horizontal.value = width;
                change = true;
            }
            if (change === true) startTimer();
        }
        function updateScroll({ position }) {
            let change = false;
            if (scroll.vertical.position.value !== position.top) {
                scroll.vertical.position.value = position.top;
                change = true;
            }
            if (scroll.horizontal.position.value !== position.left) {
                scroll.horizontal.position.value = position.left;
                change = true;
            }
            if (change === true) startTimer();
        }
        function updateScrollSize({ height, width }) {
            if (scroll.horizontal.size.value !== width) {
                scroll.horizontal.size.value = width;
                startTimer();
            }
            if (scroll.vertical.size.value !== height) {
                scroll.vertical.size.value = height;
                startTimer();
            }
        }
        function onPanThumb(e, axis) {
            const data = scroll[axis];
            if (e.isFirst === true) {
                if (data.thumbHidden.value === true) return;
                panRefPos = data.position.value;
                panning.value = true;
            } else if (panning.value !== true) return;
            if (e.isFinal === true) panning.value = false;
            const dProp = dirProps[axis];
            const multiplier = (data.size.value - container[axis].value) / (container[axis + "Inner"].value - data.thumbSize.value);
            const distance = e.distance[dProp.dist];
            setScroll(panRefPos + (e.direction === dProp.dir ? 1 : -1) * distance * multiplier, axis);
        }
        function onMousedown(evt, axis) {
            const data = scroll[axis];
            if (data.thumbHidden.value !== true) {
                const startOffset = axis === "vertical" ? props.verticalOffset[0] : props.horizontalOffset[0];
                const offset = evt[dirProps[axis].offset] - startOffset;
                const thumbStart = data.thumbStart.value - startOffset;
                if (offset < thumbStart || offset > thumbStart + data.thumbSize.value) setScroll(between((offset - data.thumbSize.value / 2) / (container[axis + "Inner"].value - data.thumbSize.value), 0, 1) * Math.max(0, data.size.value - container[axis].value), axis);
                if (data.ref.value !== null) data.ref.value.dispatchEvent(new MouseEvent(evt.type, evt));
            }
        }
        function startTimer() {
            tempShowing.value = true;
            if (timer !== null) clearTimeout(timer);
            timer = setTimeout(()=>{
                timer = null;
                tempShowing.value = false;
            }, props.delay);
            if (props.onScroll !== void 0) emitScroll();
        }
        function setScroll(offset, axis) {
            targetRef.value[dirProps[axis].scroll] = offset;
        }
        let mouseEventTimer = null;
        function onMouseenter() {
            if (mouseEventTimer !== null) clearTimeout(mouseEventTimer);
            mouseEventTimer = setTimeout(()=>{
                mouseEventTimer = null;
                hover.value = true;
            }, proxy.$q.platform.is.ios ? 50 : 0);
        }
        function onMouseleave() {
            if (mouseEventTimer !== null) {
                clearTimeout(mouseEventTimer);
                mouseEventTimer = null;
            }
            hover.value = false;
        }
        let scrollPosition = null;
        (0, _vue.watch)(()=>proxy.$q.lang.rtl, (rtl)=>{
            if (targetRef.value !== null) setHorizontalScrollPosition(targetRef.value, Math.abs(scroll.horizontal.position.value) * (rtl === true ? -1 : 1));
        });
        (0, _vue.onDeactivated)(()=>{
            scrollPosition = {
                top: scroll.vertical.position.value,
                left: scroll.horizontal.position.value
            };
        });
        (0, _vue.onActivated)(()=>{
            if (scrollPosition === null) return;
            const scrollTarget = targetRef.value;
            if (scrollTarget !== null) {
                setHorizontalScrollPosition(scrollTarget, scrollPosition.left);
                setVerticalScrollPosition(scrollTarget, scrollPosition.top);
            }
        });
        (0, _vue.onBeforeUnmount)(emitScroll.cancel);
        Object.assign(proxy, {
            getScrollTarget: ()=>targetRef.value,
            getScroll,
            getScrollPosition: ()=>({
                    top: scroll.vertical.position.value,
                    left: scroll.horizontal.position.value
                }),
            getScrollPercentage: ()=>({
                    top: scroll.vertical.percentage.value,
                    left: scroll.horizontal.percentage.value
                }),
            setScrollPosition: localSetScrollPosition,
            setScrollPercentage (axis, percentage, duration) {
                localSetScrollPosition(axis, percentage * (scroll[axis].size.value - container[axis].value) * (axis === "horizontal" && proxy.$q.lang.rtl === true ? -1 : 1), duration);
            }
        });
        const store = {
            scroll,
            thumbVertDir: [
                [
                    TouchPan_default,
                    (e)=>{
                        onPanThumb(e, "vertical");
                    },
                    void 0,
                    {
                        vertical: true,
                        ...panOpts
                    }
                ]
            ],
            thumbHorizDir: [
                [
                    TouchPan_default,
                    (e)=>{
                        onPanThumb(e, "horizontal");
                    },
                    void 0,
                    {
                        horizontal: true,
                        ...panOpts
                    }
                ]
            ],
            onVerticalMousedown (evt) {
                onMousedown(evt, "vertical");
            },
            onHorizontalMousedown (evt) {
                onMousedown(evt, "horizontal");
            }
        };
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                onMouseenter,
                onMouseleave
            }, [
                (0, _vue.h)("div", {
                    ref: targetRef,
                    class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
                    tabindex: props.tabindex !== void 0 ? props.tabindex : void 0
                }, [
                    (0, _vue.h)("div", {
                        class: "q-scrollarea__content absolute",
                        style: mainStyle.value
                    }, hMergeSlot(slots.default, [
                        (0, _vue.h)(QResizeObserver_default, {
                            debounce: 0,
                            onResize: updateScrollSize
                        })
                    ])),
                    (0, _vue.h)(QScrollObserver_default, {
                        axis: "both",
                        onScroll: updateScroll
                    })
                ]),
                (0, _vue.h)(QResizeObserver_default, {
                    debounce: 0,
                    onResize: updateContainer
                }),
                (0, _vue.h)(ScrollAreaControls_default, {
                    store,
                    barStyle: props.barStyle,
                    verticalBarStyle: props.verticalBarStyle,
                    horizontalBarStyle: props.horizontalBarStyle
                })
            ]);
    }
});
//#endregion
//#region src/components/virtual-scroll/use-virtual-scroll.js
const aggBucketSize = 1e3;
const scrollToEdges = [
    "start",
    "center",
    "end",
    "start-force",
    "center-force",
    "end-force"
];
const filterProto = Array.prototype.filter;
const setOverflowAnchor = __QUASAR_SSR__ || window.getComputedStyle(document.body).overflowAnchor === void 0 ? noop : function setOverflowAnchor(contentEl, index) {
    if (contentEl === null) return;
    if (contentEl._qOverflowAnimationFrame !== void 0) cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
    contentEl._qOverflowAnimationFrame = requestAnimationFrame(()=>{
        if (contentEl === null) return;
        contentEl._qOverflowAnimationFrame = void 0;
        const children = contentEl.children || [];
        filterProto.call(children, (el)=>el.dataset && el.dataset.qVsAnchor !== void 0).forEach((el)=>{
            delete el.dataset.qVsAnchor;
        });
        const el = children[index];
        if (el?.dataset) el.dataset.qVsAnchor = "";
    });
};
function sumFn(acc, item) {
    return acc + item;
}
function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
    const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent, propElSize = horizontal === true ? "offsetWidth" : "offsetHeight", details = {
        scrollStart: 0,
        scrollViewSize: -stickyStart - stickyEnd,
        scrollMaxSize: 0,
        offsetStart: -stickyStart,
        offsetEnd: -stickyEnd
    };
    if (horizontal === true) {
        if (parent === window) {
            details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
            details.scrollViewSize += document.documentElement.clientWidth;
        } else {
            details.scrollStart = parentCalc.scrollLeft;
            details.scrollViewSize += parentCalc.clientWidth;
        }
        details.scrollMaxSize = parentCalc.scrollWidth;
        if (rtl === true) details.scrollStart = (rtlHasScrollBug === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    } else {
        if (parent === window) {
            details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
            details.scrollViewSize += document.documentElement.clientHeight;
        } else {
            details.scrollStart = parentCalc.scrollTop;
            details.scrollViewSize += parentCalc.clientHeight;
        }
        details.scrollMaxSize = parentCalc.scrollHeight;
    }
    if (beforeRef !== null) {
        for(let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling)if (el.classList.contains("q-virtual-scroll--skip") === false) details.offsetStart += el[propElSize];
    }
    if (afterRef !== null) {
        for(let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling)if (el.classList.contains("q-virtual-scroll--skip") === false) details.offsetEnd += el[propElSize];
    }
    if (child !== parent) {
        const parentRect = parentCalc.getBoundingClientRect(), childRect = child.getBoundingClientRect();
        if (horizontal === true) {
            details.offsetStart += childRect.left - parentRect.left;
            details.offsetEnd -= childRect.width;
        } else {
            details.offsetStart += childRect.top - parentRect.top;
            details.offsetEnd -= childRect.height;
        }
        if (parent !== window) details.offsetStart += details.scrollStart;
        details.offsetEnd += details.scrollMaxSize - details.offsetStart;
    }
    return details;
}
function setScroll(parent, scroll, horizontal, rtl) {
    if (scroll === "end") scroll = (parent === window ? document.body : parent)[horizontal === true ? "scrollWidth" : "scrollHeight"];
    if (parent === window) {
        if (horizontal === true) {
            if (rtl === true) scroll = (rtlHasScrollBug === true ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
            window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
        } else window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    } else if (horizontal === true) {
        if (rtl === true) scroll = (rtlHasScrollBug === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
        parent.scrollLeft = scroll;
    } else parent.scrollTop = scroll;
}
function sumSize(sizeAgg, size, from, to) {
    if (from >= to) return 0;
    const lastTo = size.length, fromAgg = Math.floor(from / aggBucketSize), toAgg = Math.floor((to - 1) / aggBucketSize) + 1;
    let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);
    if (from % aggBucketSize !== 0) total -= size.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
    if (to % aggBucketSize !== 0 && to !== lastTo) total -= size.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
    return total;
}
const commonVirtScrollProps = {
    virtualScrollSliceSize: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    virtualScrollSliceRatioBefore: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollSliceRatioAfter: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollItemSize: {
        type: [
            Number,
            String
        ],
        default: 24
    },
    virtualScrollStickySizeStart: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    virtualScrollStickySizeEnd: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    tableColspan: [
        Number,
        String
    ]
};
const commonVirtScrollPropsList = Object.keys(commonVirtScrollProps);
const useVirtualScrollProps = {
    virtualScrollHorizontal: Boolean,
    onVirtualScroll: Function,
    ...commonVirtScrollProps
};
function useVirtualScroll({ virtualScrollLength, getVirtualScrollTarget, getVirtualScrollEl, virtualScrollItemSizeComputed }) {
    const { props, emit, proxy } = (0, _vue.getCurrentInstance)();
    const { $q } = proxy;
    let prevScrollStart, prevToIndex, localScrollViewSize, virtualScrollSizesAgg = [], virtualScrollSizes;
    const virtualScrollPaddingBefore = (0, _vue.ref)(0);
    const virtualScrollPaddingAfter = (0, _vue.ref)(0);
    const virtualScrollSliceSizeComputed = (0, _vue.ref)({});
    const beforeRef = (0, _vue.ref)(null);
    const afterRef = (0, _vue.ref)(null);
    const contentRef = (0, _vue.ref)(null);
    const virtualScrollSliceRange = (0, _vue.ref)({
        from: 0,
        to: 0
    });
    const colspanAttr = (0, _vue.computed)(()=>props.tableColspan !== void 0 ? props.tableColspan : 100);
    if (virtualScrollItemSizeComputed === void 0) virtualScrollItemSizeComputed = (0, _vue.computed)(()=>props.virtualScrollItemSize);
    const needsReset = (0, _vue.computed)(()=>virtualScrollItemSizeComputed.value + ";" + props.virtualScrollHorizontal);
    (0, _vue.watch)((0, _vue.computed)(()=>needsReset.value + ";" + props.virtualScrollSliceRatioBefore + ";" + props.virtualScrollSliceRatioAfter), ()=>{
        setVirtualScrollSize();
    });
    (0, _vue.watch)(needsReset, reset);
    function reset() {
        localResetVirtualScroll(prevToIndex, true);
    }
    function refresh(toIndex) {
        localResetVirtualScroll(toIndex === void 0 ? prevToIndex : toIndex);
    }
    function scrollTo(toIndex, edge) {
        const scrollEl = getVirtualScrollTarget();
        if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) return;
        const scrollDetails = getScrollDetails(scrollEl, getVirtualScrollEl(), beforeRef.value, afterRef.value, props.virtualScrollHorizontal, $q.lang.rtl, props.virtualScrollStickySizeStart, props.virtualScrollStickySizeEnd);
        if (localScrollViewSize !== scrollDetails.scrollViewSize) setVirtualScrollSize(scrollDetails.scrollViewSize);
        setVirtualScrollSliceRange(scrollEl, scrollDetails, Math.min(virtualScrollLength.value - 1, Math.max(0, parseInt(toIndex, 10) || 0)), 0, scrollToEdges.indexOf(edge) !== -1 ? edge : prevToIndex !== -1 && toIndex > prevToIndex ? "end" : "start");
    }
    function localOnVirtualScrollEvt() {
        const scrollEl = getVirtualScrollTarget();
        if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) return;
        const scrollDetails = getScrollDetails(scrollEl, getVirtualScrollEl(), beforeRef.value, afterRef.value, props.virtualScrollHorizontal, $q.lang.rtl, props.virtualScrollStickySizeStart, props.virtualScrollStickySizeEnd), listLastIndex = virtualScrollLength.value - 1, listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - virtualScrollPaddingAfter.value;
        if (prevScrollStart === scrollDetails.scrollStart) return;
        if (scrollDetails.scrollMaxSize <= 0) {
            setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
            return;
        }
        if (localScrollViewSize !== scrollDetails.scrollViewSize) setVirtualScrollSize(scrollDetails.scrollViewSize);
        updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
        const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
        if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
            setVirtualScrollSliceRange(scrollEl, scrollDetails, listLastIndex, scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - virtualScrollSizesAgg.reduce(sumFn, 0));
            return;
        }
        let toIndex = 0, listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart, offset = listOffset;
        if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= virtualScrollPaddingBefore.value) {
            listOffset -= virtualScrollPaddingBefore.value;
            toIndex = virtualScrollSliceRange.value.from;
            offset = listOffset;
        } else for(let j = 0; listOffset >= virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++){
            listOffset -= virtualScrollSizesAgg[j];
            toIndex += aggBucketSize;
        }
        while(listOffset > 0 && toIndex < listLastIndex){
            listOffset -= virtualScrollSizes[toIndex];
            if (listOffset > -scrollDetails.scrollViewSize) {
                toIndex++;
                offset = listOffset;
            } else offset = virtualScrollSizes[toIndex] + listOffset;
        }
        setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset);
    }
    function setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset, align) {
        const alignForce = typeof align === "string" && align.indexOf("-force") !== -1;
        const alignEnd = alignForce === true ? align.replace("-force", "") : align;
        const alignRange = alignEnd !== void 0 ? alignEnd : "start";
        let from = Math.max(0, toIndex - virtualScrollSliceSizeComputed.value[alignRange]), to = from + virtualScrollSliceSizeComputed.value.total;
        if (to > virtualScrollLength.value) {
            to = virtualScrollLength.value;
            from = Math.max(0, to - virtualScrollSliceSizeComputed.value.total);
        }
        prevScrollStart = scrollDetails.scrollStart;
        const rangeChanged = from !== virtualScrollSliceRange.value.from || to !== virtualScrollSliceRange.value.to;
        if (rangeChanged === false && alignEnd === void 0) {
            emitScroll(toIndex);
            return;
        }
        const { activeElement } = document;
        const contentEl = contentRef.value;
        if (rangeChanged === true && contentEl !== null && contentEl !== activeElement && contentEl.contains(activeElement) === true) {
            contentEl.addEventListener("focusout", onBlurRefocusFn);
            setTimeout(()=>{
                contentEl?.removeEventListener("focusout", onBlurRefocusFn);
            });
        }
        setOverflowAnchor(contentEl, toIndex - from);
        const sizeBefore = alignEnd !== void 0 ? virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;
        if (rangeChanged === true) {
            const tempTo = to >= virtualScrollSliceRange.value.from && from <= virtualScrollSliceRange.value.to ? virtualScrollSliceRange.value.to : to;
            virtualScrollSliceRange.value = {
                from,
                to: tempTo
            };
            virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, from);
            virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
            requestAnimationFrame(()=>{
                if (virtualScrollSliceRange.value.to !== to && prevScrollStart === scrollDetails.scrollStart) {
                    virtualScrollSliceRange.value = {
                        from: virtualScrollSliceRange.value.from,
                        to
                    };
                    virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
                }
            });
        }
        requestAnimationFrame(()=>{
            if (prevScrollStart !== scrollDetails.scrollStart) return;
            if (rangeChanged === true) updateVirtualScrollSizes(from);
            const sizeAfter = virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0), posStart = sizeAfter + scrollDetails.offsetStart + virtualScrollPaddingBefore.value, posEnd = posStart + virtualScrollSizes[toIndex];
            let scrollPosition = posStart + offset;
            if (alignEnd !== void 0) {
                const sizeDiff = sizeAfter - sizeBefore;
                const scrollStart = scrollDetails.scrollStart + sizeDiff;
                scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === "end" ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === "start" ? 0 : Math.round((scrollDetails.scrollViewSize - virtualScrollSizes[toIndex]) / 2));
            }
            prevScrollStart = scrollPosition;
            setScroll(scrollEl, scrollPosition, props.virtualScrollHorizontal, $q.lang.rtl);
            emitScroll(toIndex);
        });
    }
    function updateVirtualScrollSizes(from) {
        const contentEl = contentRef.value;
        if (contentEl) {
            const children = filterProto.call(contentEl.children, (el)=>el.classList && el.classList.contains("q-virtual-scroll--skip") === false), childrenLength = children.length, sizeFn = props.virtualScrollHorizontal === true ? (el)=>el.getBoundingClientRect().width : (el)=>el.offsetHeight;
            let index = from, size, diff;
            for(let i = 0; i < childrenLength;){
                size = sizeFn(children[i]);
                i++;
                while(i < childrenLength && children[i].classList.contains("q-virtual-scroll--with-prev") === true){
                    size += sizeFn(children[i]);
                    i++;
                }
                diff = size - virtualScrollSizes[index];
                if (diff !== 0) {
                    virtualScrollSizes[index] += diff;
                    virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff;
                }
                index++;
            }
        }
    }
    function onBlurRefocusFn() {
        contentRef.value?.focus();
    }
    function localResetVirtualScroll(toIndex, fullReset) {
        const defaultSize = Number(virtualScrollItemSizeComputed.value);
        if (fullReset === true || Array.isArray(virtualScrollSizes) === false) virtualScrollSizes = [];
        const oldVirtualScrollSizesLength = virtualScrollSizes.length;
        virtualScrollSizes.length = virtualScrollLength.value;
        for(let i = virtualScrollLength.value - 1; i >= oldVirtualScrollSizesLength; i--)virtualScrollSizes[i] = defaultSize;
        const jMax = Math.floor((virtualScrollLength.value - 1) / aggBucketSize);
        virtualScrollSizesAgg = [];
        for(let j = 0; j <= jMax; j++){
            let size = 0;
            const iMax = Math.min((j + 1) * aggBucketSize, virtualScrollLength.value);
            for(let i = j * aggBucketSize; i < iMax; i++)size += virtualScrollSizes[i];
            virtualScrollSizesAgg.push(size);
        }
        prevToIndex = -1;
        prevScrollStart = void 0;
        virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, virtualScrollSliceRange.value.from);
        virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, virtualScrollSliceRange.value.to, virtualScrollLength.value);
        if (toIndex >= 0) {
            updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
            (0, _vue.nextTick)(()=>{
                scrollTo(toIndex);
            });
        } else onVirtualScrollEvt();
    }
    function setVirtualScrollSize(scrollViewSize) {
        if (scrollViewSize === void 0 && typeof window !== "undefined") {
            const scrollEl = getVirtualScrollTarget();
            if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) scrollViewSize = getScrollDetails(scrollEl, getVirtualScrollEl(), beforeRef.value, afterRef.value, props.virtualScrollHorizontal, $q.lang.rtl, props.virtualScrollStickySizeStart, props.virtualScrollStickySizeEnd).scrollViewSize;
        }
        localScrollViewSize = scrollViewSize;
        const virtualScrollSliceRatioBefore = parseFloat(props.virtualScrollSliceRatioBefore) || 0;
        const virtualScrollSliceRatioAfter = parseFloat(props.virtualScrollSliceRatioAfter) || 0;
        const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
        const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / virtualScrollItemSizeComputed.value);
        const baseSize = Math.max(1, view, Math.ceil((props.virtualScrollSliceSize > 0 ? props.virtualScrollSliceSize : 10) / multiplier));
        virtualScrollSliceSizeComputed.value = {
            total: Math.ceil(baseSize * multiplier),
            start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
            center: Math.ceil(baseSize * (.5 + virtualScrollSliceRatioBefore)),
            end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
            view
        };
    }
    function padVirtualScroll(tag, content) {
        const paddingSize = props.virtualScrollHorizontal === true ? "width" : "height";
        const style = {
            ["--q-virtual-scroll-item-" + paddingSize]: virtualScrollItemSizeComputed.value + "px"
        };
        return [
            tag === "tbody" ? (0, _vue.h)(tag, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: beforeRef
            }, [
                (0, _vue.h)("tr", [
                    (0, _vue.h)("td", {
                        style: {
                            [paddingSize]: `${virtualScrollPaddingBefore.value}px`,
                            ...style
                        },
                        colspan: colspanAttr.value
                    })
                ])
            ]) : (0, _vue.h)(tag, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: beforeRef,
                style: {
                    [paddingSize]: `${virtualScrollPaddingBefore.value}px`,
                    ...style
                }
            }),
            (0, _vue.h)(tag, {
                class: "q-virtual-scroll__content",
                key: "content",
                ref: contentRef,
                tabindex: -1
            }, content.flat()),
            tag === "tbody" ? (0, _vue.h)(tag, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: afterRef
            }, [
                (0, _vue.h)("tr", [
                    (0, _vue.h)("td", {
                        style: {
                            [paddingSize]: `${virtualScrollPaddingAfter.value}px`,
                            ...style
                        },
                        colspan: colspanAttr.value
                    })
                ])
            ]) : (0, _vue.h)(tag, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: afterRef,
                style: {
                    [paddingSize]: `${virtualScrollPaddingAfter.value}px`,
                    ...style
                }
            })
        ];
    }
    function emitScroll(index) {
        if (prevToIndex !== index) {
            if (props.onVirtualScroll !== void 0) emit("virtualScroll", {
                index,
                from: virtualScrollSliceRange.value.from,
                to: virtualScrollSliceRange.value.to - 1,
                direction: index < prevToIndex ? "decrease" : "increase",
                ref: proxy
            });
            prevToIndex = index;
        }
    }
    setVirtualScrollSize();
    const onVirtualScrollEvt = debounce(localOnVirtualScrollEvt, $q.platform.is.ios === true ? 120 : 35);
    (0, _vue.onBeforeMount)(()=>{
        setVirtualScrollSize();
    });
    let shouldActivate = false;
    (0, _vue.onDeactivated)(()=>{
        shouldActivate = true;
    });
    (0, _vue.onActivated)(()=>{
        if (shouldActivate !== true) return;
        const scrollEl = getVirtualScrollTarget();
        if (prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) setScroll(scrollEl, prevScrollStart, props.virtualScrollHorizontal, $q.lang.rtl);
        else scrollTo(prevToIndex);
    });
    if (!__QUASAR_SSR__) (0, _vue.onBeforeUnmount)(()=>{
        onVirtualScrollEvt.cancel();
    });
    Object.assign(proxy, {
        scrollTo,
        reset,
        refresh
    });
    return {
        virtualScrollSliceRange,
        virtualScrollSliceSizeComputed,
        setVirtualScrollSize,
        onVirtualScrollEvt,
        localResetVirtualScroll,
        padVirtualScroll,
        scrollTo,
        reset,
        refresh
    };
}
//#endregion
//#region src/components/select/QSelect.js
const validateNewValueMode = (v)=>[
        "add",
        "add-unique",
        "toggle"
    ].includes(v);
const reEscapeList = ".*+?^${}()|[]\\";
const fieldPropsList = Object.keys(useFieldProps);
function getPropValueFn(userPropName, defaultPropName) {
    if (typeof userPropName === "function") return userPropName;
    const propName = userPropName !== void 0 ? userPropName : defaultPropName;
    return (opt)=>opt !== null && typeof opt === "object" && propName in opt ? opt[propName] : opt;
}
var QSelect_default = createComponent({
    name: "QSelect",
    inheritAttrs: false,
    props: {
        ...useVirtualScrollProps,
        ...useFormProps,
        ...useFieldProps,
        modelValue: {
            required: true
        },
        multiple: Boolean,
        displayValue: [
            String,
            Number
        ],
        displayValueHtml: Boolean,
        dropdownIcon: String,
        options: {
            type: Array,
            default: ()=>[]
        },
        optionValue: [
            Function,
            String
        ],
        optionLabel: [
            Function,
            String
        ],
        optionDisable: [
            Function,
            String
        ],
        hideSelected: Boolean,
        hideDropdownIcon: Boolean,
        fillInput: Boolean,
        maxValues: [
            Number,
            String
        ],
        optionsDense: Boolean,
        optionsDark: {
            type: Boolean,
            default: null
        },
        optionsSelectedClass: String,
        optionsHtml: Boolean,
        optionsCover: Boolean,
        menuShrink: Boolean,
        menuAnchor: String,
        menuSelf: String,
        menuOffset: Array,
        popupContentClass: String,
        popupContentStyle: [
            String,
            Array,
            Object
        ],
        popupNoRouteDismiss: Boolean,
        useInput: Boolean,
        useChips: Boolean,
        newValueMode: {
            type: String,
            validator: validateNewValueMode
        },
        mapOptions: Boolean,
        emitValue: Boolean,
        disableTabSelection: Boolean,
        inputDebounce: {
            type: [
                Number,
                String
            ],
            default: 500
        },
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        autocomplete: String,
        transitionShow: {},
        transitionHide: {},
        transitionDuration: {},
        behavior: {
            type: String,
            validator: (v)=>[
                    "default",
                    "menu",
                    "dialog"
                ].includes(v),
            default: "default"
        },
        virtualScrollItemSize: useVirtualScrollProps.virtualScrollItemSize.type,
        onNewValue: Function,
        onFilter: Function
    },
    emits: [
        ...useFieldEmits,
        "add",
        "remove",
        "inputValue",
        "keyup",
        "keypress",
        "keydown",
        "popupShow",
        "popupHide",
        "filterAbort"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const menu = (0, _vue.ref)(false);
        const dialog = (0, _vue.ref)(false);
        const optionIndex = (0, _vue.ref)(-1);
        const inputValue = (0, _vue.ref)("");
        const dialogFieldFocused = (0, _vue.ref)(false);
        const innerLoadingIndicator = (0, _vue.ref)(false);
        let filterTimer = null, inputValueTimer = null, innerValueCache, hasDialog, userInputValue, filterId = null, defaultInputValue, transitionShowComputed, searchBuffer, searchBufferExp;
        const inputRef = (0, _vue.ref)(null);
        const targetRef = (0, _vue.ref)(null);
        const menuRef = (0, _vue.ref)(null);
        const dialogRef = (0, _vue.ref)(null);
        const menuContentRef = (0, _vue.ref)(null);
        const nameProp = useFormInputNameAttr(props);
        const onComposition = useKeyComposition(onInput);
        const virtualScrollLength = (0, _vue.computed)(()=>Array.isArray(props.options) ? props.options.length : 0);
        const { virtualScrollSliceRange, virtualScrollSliceSizeComputed, localResetVirtualScroll, padVirtualScroll, onVirtualScrollEvt, scrollTo, setVirtualScrollSize } = useVirtualScroll({
            virtualScrollLength,
            getVirtualScrollTarget,
            getVirtualScrollEl,
            virtualScrollItemSizeComputed: (0, _vue.computed)(()=>props.virtualScrollItemSize === void 0 ? props.optionsDense === true ? 24 : 48 : props.virtualScrollItemSize)
        });
        const state = useFieldState();
        const innerValue = (0, _vue.computed)(()=>{
            const mapNull = props.mapOptions === true && props.multiple !== true, val = props.modelValue !== void 0 && (props.modelValue !== null || mapNull === true) ? props.multiple === true && Array.isArray(props.modelValue) ? props.modelValue : [
                props.modelValue
            ] : [];
            if (props.mapOptions === true && Array.isArray(props.options) === true) {
                const cache = props.mapOptions === true && innerValueCache !== void 0 ? innerValueCache : [];
                const values = val.map((v)=>getOption(v, cache));
                return props.modelValue === null && mapNull === true ? values.filter((v)=>v !== null) : values;
            }
            return val;
        });
        const innerFieldProps = (0, _vue.computed)(()=>{
            const acc = {};
            fieldPropsList.forEach((key)=>{
                const val = props[key];
                if (val !== void 0) acc[key] = val;
            });
            return acc;
        });
        const isOptionsDark = (0, _vue.computed)(()=>props.optionsDark === null ? state.isDark.value : props.optionsDark);
        const hasValue = (0, _vue.computed)(()=>fieldValueIsFilled(innerValue.value));
        const computedInputClass = (0, _vue.computed)(()=>{
            let cls = "q-field__input q-placeholder col";
            if (props.hideSelected === true || innerValue.value.length === 0) return [
                cls,
                props.inputClass
            ];
            cls += " q-field__input--padding";
            return props.inputClass === void 0 ? cls : [
                cls,
                props.inputClass
            ];
        });
        const menuContentClass = (0, _vue.computed)(()=>(props.virtualScrollHorizontal === true ? "q-virtual-scroll--horizontal" : "") + (props.popupContentClass ? " " + props.popupContentClass : ""));
        const noOptions = (0, _vue.computed)(()=>virtualScrollLength.value === 0);
        const selectedString = (0, _vue.computed)(()=>innerValue.value.map((opt)=>getOptionLabel.value(opt)).join(", "));
        const ariaCurrentValue = (0, _vue.computed)(()=>props.displayValue !== void 0 ? props.displayValue : selectedString.value);
        const needsHtmlFn = (0, _vue.computed)(()=>props.optionsHtml === true ? ()=>true : (opt)=>opt?.html === true);
        const valueAsHtml = (0, _vue.computed)(()=>props.displayValueHtml === true || props.displayValue === void 0 && (props.optionsHtml === true || innerValue.value.some(needsHtmlFn.value)));
        const tabindex = (0, _vue.computed)(()=>state.focused.value === true ? props.tabindex : -1);
        const comboboxAttrs = (0, _vue.computed)(()=>{
            const attrs = {
                tabindex: props.tabindex,
                role: "combobox",
                "aria-label": props.label,
                "aria-readonly": props.readonly === true ? "true" : "false",
                "aria-autocomplete": props.useInput === true ? "list" : "none",
                "aria-expanded": menu.value === true ? "true" : "false",
                "aria-controls": `${state.targetUid.value}_lb`
            };
            if (optionIndex.value >= 0) attrs["aria-activedescendant"] = `${state.targetUid.value}_${optionIndex.value}`;
            return attrs;
        });
        const listboxAttrs = (0, _vue.computed)(()=>({
                id: `${state.targetUid.value}_lb`,
                role: "listbox",
                "aria-multiselectable": props.multiple === true ? "true" : "false"
            }));
        const selectedScope = (0, _vue.computed)(()=>innerValue.value.map((opt, i)=>({
                    index: i,
                    opt,
                    html: needsHtmlFn.value(opt),
                    selected: true,
                    removeAtIndex: removeAtIndexAndFocus,
                    toggleOption,
                    tabindex: tabindex.value
                })));
        const optionScope = (0, _vue.computed)(()=>{
            if (virtualScrollLength.value === 0) return [];
            const { from, to } = virtualScrollSliceRange.value;
            return props.options.slice(from, to).map((opt, i)=>{
                const disable = isOptionDisabled.value(opt) === true;
                const active = isOptionSelected(opt) === true;
                const index = from + i;
                const itemProps = {
                    clickable: true,
                    active,
                    activeClass: computedOptionsSelectedClass.value,
                    manualFocus: true,
                    focused: false,
                    disable,
                    tabindex: -1,
                    dense: props.optionsDense,
                    dark: isOptionsDark.value,
                    role: "option",
                    "aria-selected": active === true ? "true" : "false",
                    id: `${state.targetUid.value}_${index}`,
                    onClick: ()=>{
                        toggleOption(opt);
                    }
                };
                if (disable !== true) {
                    if (optionIndex.value === index) itemProps.focused = true;
                    if ($q.platform.is.desktop === true) itemProps.onMousemove = ()=>{
                        if (menu.value === true) setOptionIndex(index);
                    };
                }
                return {
                    index,
                    opt,
                    html: needsHtmlFn.value(opt),
                    label: getOptionLabel.value(opt),
                    selected: itemProps.active,
                    focused: itemProps.focused,
                    toggleOption,
                    setOptionIndex,
                    itemProps
                };
            });
        });
        const dropdownArrowIcon = (0, _vue.computed)(()=>props.dropdownIcon !== void 0 ? props.dropdownIcon : $q.iconSet.arrow.dropdown);
        const squaredMenu = (0, _vue.computed)(()=>props.optionsCover === false && props.outlined !== true && props.standout !== true && props.borderless !== true && props.rounded !== true);
        const computedOptionsSelectedClass = (0, _vue.computed)(()=>props.optionsSelectedClass !== void 0 ? props.optionsSelectedClass : props.color !== void 0 ? `text-${props.color}` : "");
        const getOptionValue = (0, _vue.computed)(()=>getPropValueFn(props.optionValue, "value"));
        const getOptionLabel = (0, _vue.computed)(()=>getPropValueFn(props.optionLabel, "label"));
        const isOptionDisabled = (0, _vue.computed)(()=>getPropValueFn(props.optionDisable, "disable"));
        const innerOptionsValue = (0, _vue.computed)(()=>innerValue.value.map(getOptionValue.value));
        const inputControlEvents = (0, _vue.computed)(()=>{
            const evt = {
                onInput,
                onChange: onComposition,
                onKeydown: onTargetKeydown,
                onKeyup: onTargetAutocomplete,
                onKeypress: onTargetKeypress,
                onFocus: selectInputText,
                onClick (e) {
                    if (hasDialog === true) stop(e);
                }
            };
            evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
            return evt;
        });
        (0, _vue.watch)(innerValue, (val)=>{
            innerValueCache = val;
            if (props.useInput === true && props.fillInput === true && props.multiple !== true && state.innerLoading.value !== true && (dialog.value !== true && menu.value !== true || hasValue.value !== true)) {
                if (userInputValue !== true) resetInputValue();
                if (dialog.value === true || menu.value === true) filter("");
            }
        }, {
            immediate: true
        });
        (0, _vue.watch)(()=>props.fillInput, resetInputValue);
        (0, _vue.watch)(menu, updateMenu);
        (0, _vue.watch)(virtualScrollLength, rerenderMenu);
        function getEmittingOptionValue(opt) {
            return props.emitValue === true ? getOptionValue.value(opt) : opt;
        }
        function removeAtIndex(index) {
            if (index !== -1 && index < innerValue.value.length) {
                if (props.multiple === true) {
                    const model = props.modelValue.slice();
                    emit("remove", {
                        index,
                        value: model.splice(index, 1)[0]
                    });
                    emit("update:modelValue", model);
                } else emit("update:modelValue", null);
            }
        }
        function removeAtIndexAndFocus(index) {
            removeAtIndex(index);
            state.focus();
        }
        function add(opt, unique) {
            const val = getEmittingOptionValue(opt);
            if (props.multiple !== true) {
                if (props.fillInput === true) updateInputValue(getOptionLabel.value(opt), true, true);
                emit("update:modelValue", val);
                return;
            }
            if (innerValue.value.length === 0) {
                emit("add", {
                    index: 0,
                    value: val
                });
                emit("update:modelValue", props.multiple === true ? [
                    val
                ] : val);
                return;
            }
            if (unique === true && isOptionSelected(opt) === true) return;
            if (props.maxValues !== void 0 && props.modelValue.length >= props.maxValues) return;
            const model = props.modelValue.slice();
            emit("add", {
                index: model.length,
                value: val
            });
            model.push(val);
            emit("update:modelValue", model);
        }
        function toggleOption(opt, keepOpen) {
            if (state.editable.value !== true || opt === void 0 || isOptionDisabled.value(opt) === true) return;
            const optValue = getOptionValue.value(opt);
            if (props.multiple !== true) {
                if (keepOpen !== true) {
                    updateInputValue(props.fillInput === true ? getOptionLabel.value(opt) : "", true, true);
                    hidePopup();
                }
                targetRef.value?.focus();
                if (innerValue.value.length === 0 || isDeepEqual(getOptionValue.value(innerValue.value[0]), optValue) !== true) emit("update:modelValue", props.emitValue === true ? optValue : opt);
                return;
            }
            if (hasDialog !== true || dialogFieldFocused.value === true) state.focus();
            selectInputText();
            if (innerValue.value.length === 0) {
                const val = props.emitValue === true ? optValue : opt;
                emit("add", {
                    index: 0,
                    value: val
                });
                emit("update:modelValue", props.multiple === true ? [
                    val
                ] : val);
                return;
            }
            const model = props.modelValue.slice(), index = innerOptionsValue.value.findIndex((v)=>isDeepEqual(v, optValue));
            if (index !== -1) emit("remove", {
                index,
                value: model.splice(index, 1)[0]
            });
            else {
                if (props.maxValues !== void 0 && model.length >= props.maxValues) return;
                const val = props.emitValue === true ? optValue : opt;
                emit("add", {
                    index: model.length,
                    value: val
                });
                model.push(val);
            }
            emit("update:modelValue", model);
        }
        function setOptionIndex(index) {
            if ($q.platform.is.desktop !== true) return;
            const val = index !== -1 && index < virtualScrollLength.value ? index : -1;
            if (optionIndex.value !== val) optionIndex.value = val;
        }
        function moveOptionSelection(localOffset = 1, skipInputValue) {
            if (menu.value === true) {
                let index = optionIndex.value;
                do index = normalizeToInterval(index + localOffset, -1, virtualScrollLength.value - 1);
                while (index !== -1 && index !== optionIndex.value && isOptionDisabled.value(props.options[index]) === true);
                if (optionIndex.value !== index) {
                    setOptionIndex(index);
                    scrollTo(index);
                    if (skipInputValue !== true && props.useInput === true && props.fillInput === true) setInputValue(index >= 0 ? getOptionLabel.value(props.options[index]) : defaultInputValue, true);
                }
            }
        }
        function getOption(value1, valueCache) {
            const fn = (opt)=>isDeepEqual(getOptionValue.value(opt), value1);
            return props.options.find(fn) || valueCache.find(fn) || value1;
        }
        function isOptionSelected(opt) {
            const val = getOptionValue.value(opt);
            return innerOptionsValue.value.find((v)=>isDeepEqual(v, val)) !== void 0;
        }
        function selectInputText(e) {
            if (props.useInput === true && targetRef.value !== null && (e === void 0 || targetRef.value === e.target && e.target.value === selectedString.value)) targetRef.value.select();
        }
        function onTargetKeyup(e) {
            if (isKeyCode(e, 27) === true && menu.value === true) {
                stop(e);
                hidePopup();
                resetInputValue();
            }
            emit("keyup", e);
        }
        function onTargetAutocomplete(e) {
            const { value: value1 } = e.target;
            if (e.keyCode !== void 0) {
                onTargetKeyup(e);
                return;
            }
            e.target.value = "";
            if (filterTimer !== null) {
                clearTimeout(filterTimer);
                filterTimer = null;
            }
            if (inputValueTimer !== null) {
                clearTimeout(inputValueTimer);
                inputValueTimer = null;
            }
            resetInputValue();
            if (typeof value1 === "string" && value1.length !== 0) {
                const needle = value1.toLocaleLowerCase();
                const findFn = (extractFn)=>{
                    const option = props.options.find((opt)=>String(extractFn.value(opt)).toLocaleLowerCase() === needle);
                    if (option === void 0) return false;
                    if (innerValue.value.indexOf(option) === -1) toggleOption(option);
                    else hidePopup();
                    return true;
                };
                const fillFn = (afterFilter)=>{
                    if (findFn(getOptionValue) !== true && afterFilter !== true && findFn(getOptionLabel) !== true) filter(value1, true, ()=>fillFn(true));
                };
                fillFn();
            } else state.clearValue(e);
        }
        function onTargetKeypress(e) {
            emit("keypress", e);
        }
        function onTargetKeydown(e) {
            emit("keydown", e);
            if (shouldIgnoreKey(e) === true) return;
            const newValueModeValid = inputValue.value.length !== 0 && (props.newValueMode !== void 0 || props.onNewValue !== void 0);
            const tabShouldSelect = e.shiftKey !== true && props.disableTabSelection !== true && props.multiple !== true && (optionIndex.value !== -1 || newValueModeValid === true);
            if (e.keyCode === 27) {
                prevent(e);
                return;
            }
            if (e.keyCode === 9 && tabShouldSelect === false) {
                closeMenu();
                return;
            }
            if (e.target === void 0 || e.target.id !== state.targetUid.value || state.editable.value !== true) return;
            if (e.keyCode === 40 && state.innerLoading.value !== true && menu.value === false) {
                stopAndPrevent(e);
                showPopup();
                return;
            }
            if (e.keyCode === 8 && (props.useChips === true || props.clearable === true) && props.hideSelected !== true && inputValue.value.length === 0) {
                if (props.multiple === true && Array.isArray(props.modelValue) === true) removeAtIndex(props.modelValue.length - 1);
                else if (props.multiple !== true && props.modelValue !== null) emit("update:modelValue", null);
                return;
            }
            if ((e.keyCode === 35 || e.keyCode === 36) && (typeof inputValue.value !== "string" || inputValue.value.length === 0)) {
                stopAndPrevent(e);
                optionIndex.value = -1;
                moveOptionSelection(e.keyCode === 36 ? 1 : -1, props.multiple);
            }
            if ((e.keyCode === 33 || e.keyCode === 34) && virtualScrollSliceSizeComputed.value !== void 0) {
                stopAndPrevent(e);
                optionIndex.value = Math.max(-1, Math.min(virtualScrollLength.value, optionIndex.value + (e.keyCode === 33 ? -1 : 1) * virtualScrollSliceSizeComputed.value.view));
                moveOptionSelection(e.keyCode === 33 ? 1 : -1, props.multiple);
            }
            if (e.keyCode === 38 || e.keyCode === 40) {
                stopAndPrevent(e);
                moveOptionSelection(e.keyCode === 38 ? -1 : 1, props.multiple);
            }
            const optionsLength = virtualScrollLength.value;
            if (searchBuffer === void 0 || searchBufferExp < Date.now()) searchBuffer = "";
            if (optionsLength > 0 && props.useInput !== true && e.key !== void 0 && e.key.length === 1 && e.altKey === false && e.ctrlKey === false && e.metaKey === false && (e.keyCode !== 32 || searchBuffer.length !== 0)) {
                if (menu.value !== true) showPopup(e);
                const char = e.key.toLocaleLowerCase(), keyRepeat = searchBuffer.length === 1 && searchBuffer[0] === char;
                searchBufferExp = Date.now() + 1500;
                if (keyRepeat === false) {
                    stopAndPrevent(e);
                    searchBuffer += char;
                }
                const searchRe = new RegExp("^" + searchBuffer.split("").map((l)=>reEscapeList.indexOf(l) !== -1 ? "\\" + l : l).join(".*"), "i");
                let index = optionIndex.value;
                if (keyRepeat === true || index < 0 || searchRe.test(getOptionLabel.value(props.options[index])) !== true) do index = normalizeToInterval(index + 1, -1, optionsLength - 1);
                while (index !== optionIndex.value && (isOptionDisabled.value(props.options[index]) === true || searchRe.test(getOptionLabel.value(props.options[index])) !== true));
                if (optionIndex.value !== index) (0, _vue.nextTick)(()=>{
                    setOptionIndex(index);
                    scrollTo(index);
                    if (index >= 0 && props.useInput === true && props.fillInput === true) setInputValue(getOptionLabel.value(props.options[index]), true);
                });
                return;
            }
            if (e.keyCode !== 13 && (e.keyCode !== 32 || props.useInput === true || searchBuffer !== "") && (e.keyCode !== 9 || tabShouldSelect === false)) return;
            if (e.keyCode !== 9) stopAndPrevent(e);
            if (optionIndex.value !== -1 && optionIndex.value < optionsLength) {
                toggleOption(props.options[optionIndex.value]);
                return;
            }
            if (newValueModeValid === true) {
                const done = (val, mode)=>{
                    if (mode) {
                        if (validateNewValueMode(mode) !== true) return;
                    } else mode = props.newValueMode;
                    updateInputValue("", props.multiple !== true, true);
                    if (val === void 0 || val === null) return;
                    (mode === "toggle" ? toggleOption : add)(val, mode === "add-unique");
                    if (props.multiple !== true) {
                        targetRef.value?.focus();
                        hidePopup();
                    }
                };
                if (props.onNewValue !== void 0) emit("newValue", inputValue.value, done);
                else done(inputValue.value);
                if (props.multiple !== true) return;
            }
            if (menu.value === true) closeMenu();
            else if (state.innerLoading.value !== true) showPopup();
        }
        function getVirtualScrollEl() {
            return hasDialog === true ? menuContentRef.value : menuRef.value !== null && menuRef.value.contentEl !== null ? menuRef.value.contentEl : void 0;
        }
        function getVirtualScrollTarget() {
            return getVirtualScrollEl();
        }
        function getSelection() {
            if (props.hideSelected === true) return [];
            if (slots["selected-item"] !== void 0) return selectedScope.value.map((scope)=>slots["selected-item"](scope)).slice();
            if (slots.selected !== void 0) return [].concat(slots.selected());
            if (props.useChips === true) return selectedScope.value.map((scope, i)=>(0, _vue.h)(QChip_default, {
                    key: "option-" + i,
                    removable: state.editable.value === true && isOptionDisabled.value(scope.opt) !== true,
                    dense: true,
                    textColor: props.color,
                    tabindex: tabindex.value,
                    onRemove () {
                        scope.removeAtIndex(i);
                    }
                }, ()=>(0, _vue.h)("span", {
                        class: "ellipsis",
                        [scope.html === true ? "innerHTML" : "textContent"]: getOptionLabel.value(scope.opt)
                    })));
            return [
                (0, _vue.h)("span", {
                    class: "ellipsis",
                    [valueAsHtml.value === true ? "innerHTML" : "textContent"]: ariaCurrentValue.value
                })
            ];
        }
        function getAllOptions() {
            if (noOptions.value === true) return slots["no-option"] !== void 0 ? slots["no-option"]({
                inputValue: inputValue.value
            }) : void 0;
            const fn = slots.option !== void 0 ? slots.option : (scope)=>(0, _vue.h)(QItem_default, {
                    key: scope.index,
                    ...scope.itemProps
                }, ()=>(0, _vue.h)(QItemSection_default, ()=>(0, _vue.h)(QItemLabel_default, ()=>(0, _vue.h)("span", {
                                [scope.html === true ? "innerHTML" : "textContent"]: scope.label
                            }))));
            let options = padVirtualScroll("div", optionScope.value.map(fn));
            if (slots["before-options"] !== void 0) options = slots["before-options"]().concat(options);
            return hMergeSlot(slots["after-options"], options);
        }
        function getInput(fromDialog, isTarget) {
            const attrs = isTarget === true ? {
                ...comboboxAttrs.value,
                ...state.splitAttrs.attributes.value
            } : void 0;
            const data = {
                ref: isTarget === true ? targetRef : void 0,
                key: "i_t",
                class: computedInputClass.value,
                style: props.inputStyle,
                value: inputValue.value !== void 0 ? inputValue.value : "",
                type: "search",
                ...attrs,
                id: isTarget === true ? state.targetUid.value : void 0,
                maxlength: props.maxlength,
                autocomplete: props.autocomplete,
                "data-autofocus": fromDialog === true || props.autofocus === true || void 0,
                disabled: props.disable === true,
                readonly: props.readonly === true,
                ...inputControlEvents.value
            };
            if (fromDialog !== true && hasDialog === true) {
                if (Array.isArray(data.class) === true) data.class = [
                    ...data.class,
                    "no-pointer-events"
                ];
                else data.class += " no-pointer-events";
            }
            return (0, _vue.h)("input", data);
        }
        function onInput(e) {
            if (filterTimer !== null) {
                clearTimeout(filterTimer);
                filterTimer = null;
            }
            if (inputValueTimer !== null) {
                clearTimeout(inputValueTimer);
                inputValueTimer = null;
            }
            if (e && e.target && e.target.qComposing === true) return;
            setInputValue(e.target.value || "");
            userInputValue = true;
            defaultInputValue = inputValue.value;
            if (state.focused.value !== true && (hasDialog !== true || dialogFieldFocused.value === true)) state.focus();
            if (props.onFilter !== void 0) filterTimer = setTimeout(()=>{
                filterTimer = null;
                filter(inputValue.value);
            }, props.inputDebounce);
        }
        function setInputValue(val, emitImmediately) {
            if (inputValue.value !== val) {
                inputValue.value = val;
                if (emitImmediately === true || props.inputDebounce === 0 || props.inputDebounce === "0") emit("inputValue", val);
                else inputValueTimer = setTimeout(()=>{
                    inputValueTimer = null;
                    emit("inputValue", val);
                }, props.inputDebounce);
            }
        }
        function updateInputValue(val, noFiltering, internal) {
            userInputValue = internal !== true;
            if (props.useInput === true) {
                setInputValue(val, true);
                if (noFiltering === true || internal !== true) defaultInputValue = val;
                if (noFiltering !== true) filter(val);
            }
        }
        function filter(val, keepClosed, afterUpdateFn) {
            if (props.onFilter === void 0 || keepClosed !== true && state.focused.value !== true) return;
            if (state.innerLoading.value === true) emit("filterAbort");
            else {
                state.innerLoading.value = true;
                innerLoadingIndicator.value = true;
            }
            if (val !== "" && props.multiple !== true && innerValue.value.length !== 0 && userInputValue !== true && val === getOptionLabel.value(innerValue.value[0])) val = "";
            const localFilterId = setTimeout(()=>{
                if (menu.value === true) menu.value = false;
            }, 10);
            if (filterId !== null) clearTimeout(filterId);
            filterId = localFilterId;
            emit("filter", val, (fn, afterFn)=>{
                if ((keepClosed === true || state.focused.value === true) && filterId === localFilterId) {
                    clearTimeout(filterId);
                    if (typeof fn === "function") fn();
                    innerLoadingIndicator.value = false;
                    (0, _vue.nextTick)(()=>{
                        state.innerLoading.value = false;
                        if (state.editable.value === true) {
                            if (keepClosed === true) {
                                if (menu.value === true) hidePopup();
                            } else if (menu.value === true) updateMenu(true);
                            else menu.value = true;
                        }
                        if (typeof afterFn === "function") (0, _vue.nextTick)(()=>{
                            afterFn(proxy);
                        });
                        if (typeof afterUpdateFn === "function") (0, _vue.nextTick)(()=>{
                            afterUpdateFn(proxy);
                        });
                    });
                }
            }, ()=>{
                if (state.focused.value === true && filterId === localFilterId) {
                    clearTimeout(filterId);
                    state.innerLoading.value = false;
                    innerLoadingIndicator.value = false;
                }
                if (menu.value === true) menu.value = false;
            });
        }
        function getMenu() {
            return (0, _vue.h)(QMenu_default, {
                ref: menuRef,
                class: menuContentClass.value,
                style: props.popupContentStyle,
                modelValue: menu.value,
                fit: props.menuShrink !== true,
                cover: props.optionsCover === true && noOptions.value !== true && props.useInput !== true,
                anchor: props.menuAnchor,
                self: props.menuSelf,
                offset: props.menuOffset,
                dark: isOptionsDark.value,
                noParentEvent: true,
                noRefocus: true,
                noFocus: true,
                noRouteDismiss: props.popupNoRouteDismiss,
                square: squaredMenu.value,
                transitionShow: props.transitionShow,
                transitionHide: props.transitionHide,
                transitionDuration: props.transitionDuration,
                separateClosePopup: true,
                ...listboxAttrs.value,
                onScrollPassive: onVirtualScrollEvt,
                onBeforeShow: onControlPopupShow,
                onBeforeHide: onMenuBeforeHide,
                onShow: onMenuShow
            }, getAllOptions);
        }
        function onMenuBeforeHide(e) {
            onControlPopupHide(e);
            closeMenu();
        }
        function onMenuShow() {
            setVirtualScrollSize();
        }
        function onDialogFieldFocus(e) {
            stop(e);
            targetRef.value?.focus();
            dialogFieldFocused.value = true;
            window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
        }
        function onDialogFieldBlur(e) {
            stop(e);
            (0, _vue.nextTick)(()=>{
                dialogFieldFocused.value = false;
            });
        }
        function getDialog() {
            const content = [
                (0, _vue.h)(QField_default, {
                    class: `col-auto ${state.fieldClass.value}`,
                    ...innerFieldProps.value,
                    for: state.targetUid.value,
                    dark: isOptionsDark.value,
                    square: true,
                    loading: innerLoadingIndicator.value,
                    itemAligned: false,
                    filled: true,
                    stackLabel: inputValue.value.length !== 0,
                    ...state.splitAttrs.listeners.value,
                    onFocus: onDialogFieldFocus,
                    onBlur: onDialogFieldBlur
                }, {
                    ...slots,
                    rawControl: ()=>state.getControl(true),
                    before: void 0,
                    after: void 0
                })
            ];
            if (menu.value === true) content.push((0, _vue.h)("div", {
                ref: menuContentRef,
                class: menuContentClass.value + " scroll",
                style: props.popupContentStyle,
                ...listboxAttrs.value,
                onClick: prevent,
                onScrollPassive: onVirtualScrollEvt
            }, getAllOptions()));
            return (0, _vue.h)(QDialog_default, {
                ref: dialogRef,
                modelValue: dialog.value,
                position: props.useInput === true ? "top" : void 0,
                transitionShow: transitionShowComputed,
                transitionHide: props.transitionHide,
                transitionDuration: props.transitionDuration,
                noRouteDismiss: props.popupNoRouteDismiss,
                onBeforeShow: onControlPopupShow,
                onBeforeHide: onDialogBeforeHide,
                onHide: onDialogHide,
                onShow: onDialogShow
            }, ()=>(0, _vue.h)("div", {
                    class: "q-select__dialog" + (isOptionsDark.value === true ? " q-select__dialog--dark q-dark" : "") + (dialogFieldFocused.value === true ? " q-select__dialog--focused" : "")
                }, content));
        }
        function onDialogBeforeHide(e) {
            onControlPopupHide(e);
            if (dialogRef.value !== null) dialogRef.value.__updateRefocusTarget(state.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child"));
            state.focused.value = false;
        }
        function onDialogHide(e) {
            hidePopup();
            if (state.focused.value === false) emit("blur", e);
            resetInputValue();
        }
        function onDialogShow() {
            const el = document.activeElement;
            if ((el === null || el.id !== state.targetUid.value) && targetRef.value !== null && targetRef.value !== el) targetRef.value.focus();
            setVirtualScrollSize();
        }
        function closeMenu() {
            if (dialog.value === true) return;
            optionIndex.value = -1;
            if (menu.value === true) menu.value = false;
            if (state.focused.value === false) {
                if (filterId !== null) {
                    clearTimeout(filterId);
                    filterId = null;
                }
                if (state.innerLoading.value === true) {
                    emit("filterAbort");
                    state.innerLoading.value = false;
                    innerLoadingIndicator.value = false;
                }
            }
        }
        function showPopup(e) {
            if (state.editable.value !== true) return;
            if (hasDialog === true) {
                state.onControlFocusin(e);
                dialog.value = true;
                (0, _vue.nextTick)(()=>{
                    state.focus();
                });
            } else state.focus();
            if (props.onFilter !== void 0) filter(inputValue.value);
            else if (noOptions.value !== true || slots["no-option"] !== void 0) menu.value = true;
        }
        function hidePopup() {
            dialog.value = false;
            closeMenu();
        }
        function resetInputValue() {
            if (props.useInput === true) updateInputValue(props.multiple !== true && props.fillInput === true && innerValue.value.length !== 0 ? getOptionLabel.value(innerValue.value[0]) || "" : "", true, true);
        }
        function updateMenu(show) {
            let localOptionIndex = -1;
            if (show === true) {
                if (innerValue.value.length !== 0) {
                    const val = getOptionValue.value(innerValue.value[0]);
                    localOptionIndex = props.options.findIndex((v)=>isDeepEqual(getOptionValue.value(v), val));
                }
                localResetVirtualScroll(localOptionIndex);
            }
            setOptionIndex(localOptionIndex);
        }
        function rerenderMenu(newLength, oldLength) {
            if (menu.value === true && state.innerLoading.value === false) {
                localResetVirtualScroll(-1, true);
                (0, _vue.nextTick)(()=>{
                    if (menu.value === true && state.innerLoading.value === false) {
                        if (newLength > oldLength) localResetVirtualScroll();
                        else updateMenu(true);
                    }
                });
            }
        }
        function updateMenuPosition() {
            if (dialog.value === false && menuRef.value !== null) menuRef.value.updatePosition();
        }
        function onControlPopupShow(e) {
            if (e !== void 0) stop(e);
            emit("popupShow", e);
            state.hasPopupOpen = true;
            state.onControlFocusin(e);
        }
        function onControlPopupHide(e) {
            if (e !== void 0) stop(e);
            emit("popupHide", e);
            state.hasPopupOpen = false;
            state.onControlFocusout(e);
        }
        function updatePreState() {
            hasDialog = $q.platform.is.mobile !== true && props.behavior !== "dialog" ? false : props.behavior !== "menu" && (props.useInput === true ? slots["no-option"] !== void 0 || props.onFilter !== void 0 || noOptions.value === false : true);
            transitionShowComputed = $q.platform.is.ios === true && hasDialog === true && props.useInput === true ? "fade" : props.transitionShow;
        }
        (0, _vue.onBeforeUpdate)(updatePreState);
        (0, _vue.onUpdated)(updateMenuPosition);
        updatePreState();
        (0, _vue.onBeforeUnmount)(()=>{
            if (filterTimer !== null) clearTimeout(filterTimer);
            if (inputValueTimer !== null) clearTimeout(inputValueTimer);
        });
        Object.assign(proxy, {
            showPopup,
            hidePopup,
            removeAtIndex,
            add,
            toggleOption,
            getOptionIndex: ()=>optionIndex.value,
            setOptionIndex,
            moveOptionSelection,
            filter,
            updateMenuPosition,
            updateInputValue,
            isOptionSelected,
            getEmittingOptionValue,
            isOptionDisabled: (...args)=>isOptionDisabled.value.apply(null, args) === true,
            getOptionValue: (...args)=>getOptionValue.value.apply(null, args),
            getOptionLabel: (...args)=>getOptionLabel.value.apply(null, args)
        });
        Object.assign(state, {
            innerValue,
            fieldClass: (0, _vue.computed)(()=>`q-select q-field--auto-height q-select--with${props.useInput !== true ? "out" : ""}-input q-select--with${props.useChips !== true ? "out" : ""}-chips q-select--${props.multiple === true ? "multiple" : "single"}`),
            inputRef,
            targetRef,
            hasValue,
            showPopup,
            floatingLabel: (0, _vue.computed)(()=>props.hideSelected !== true && hasValue.value === true || typeof inputValue.value === "number" || inputValue.value.length !== 0 || fieldValueIsFilled(props.displayValue)),
            getControlChild: ()=>{
                if (state.editable.value !== false && (dialog.value === true || noOptions.value !== true || slots["no-option"] !== void 0)) return hasDialog === true ? getDialog() : getMenu();
                else if (state.hasPopupOpen === true) state.hasPopupOpen = false;
            },
            controlEvents: {
                onFocusin (e) {
                    state.onControlFocusin(e);
                },
                onFocusout (e) {
                    state.onControlFocusout(e, ()=>{
                        resetInputValue();
                        closeMenu();
                    });
                },
                onClick (e) {
                    prevent(e);
                    if (hasDialog !== true && menu.value === true) {
                        closeMenu();
                        targetRef.value?.focus();
                        return;
                    }
                    showPopup(e);
                }
            },
            getControl: (fromDialog)=>{
                const child = getSelection();
                const isTarget = fromDialog === true || dialog.value !== true || hasDialog !== true;
                if (props.useInput === true) child.push(getInput(fromDialog, isTarget));
                else if (state.editable.value === true) {
                    const attrs = isTarget === true ? comboboxAttrs.value : void 0;
                    child.push((0, _vue.h)("input", {
                        ref: isTarget === true ? targetRef : void 0,
                        key: "d_t",
                        class: "q-select__focus-target",
                        id: isTarget === true ? state.targetUid.value : void 0,
                        value: ariaCurrentValue.value,
                        readonly: true,
                        "data-autofocus": fromDialog === true || props.autofocus === true || void 0,
                        ...attrs,
                        onKeydown: onTargetKeydown,
                        onKeyup: onTargetKeyup,
                        onKeypress: onTargetKeypress
                    }));
                    if (isTarget === true && typeof props.autocomplete === "string" && props.autocomplete.length !== 0) child.push((0, _vue.h)("input", {
                        class: "q-select__autocomplete-input",
                        autocomplete: props.autocomplete,
                        tabindex: -1,
                        onKeyup: onTargetAutocomplete
                    }));
                }
                if (nameProp.value !== void 0 && props.disable !== true && innerOptionsValue.value.length !== 0) {
                    const opts = innerOptionsValue.value.map((value1)=>(0, _vue.h)("option", {
                            value: value1,
                            selected: true
                        }));
                    child.push((0, _vue.h)("select", {
                        class: "hidden",
                        name: nameProp.value,
                        multiple: props.multiple
                    }, opts));
                }
                return (0, _vue.h)("div", {
                    class: "q-field__native row items-center",
                    ...props.useInput === true || isTarget !== true ? void 0 : state.splitAttrs.attributes.value,
                    ...state.splitAttrs.listeners.value
                }, child);
            },
            getInnerAppend: ()=>props.loading !== true && innerLoadingIndicator.value !== true && props.hideDropdownIcon !== true ? [
                    (0, _vue.h)(QIcon_default, {
                        class: "q-select__dropdown-icon" + (menu.value === true ? " rotate-180" : ""),
                        name: dropdownArrowIcon.value
                    })
                ] : null
        });
        return useField(state);
    }
});
//#endregion
//#region src/components/skeleton/QSkeleton.js
const skeletonTypes = [
    "text",
    "rect",
    "circle",
    "QBtn",
    "QBadge",
    "QChip",
    "QToolbar",
    "QCheckbox",
    "QRadio",
    "QToggle",
    "QSlider",
    "QRange",
    "QInput",
    "QAvatar"
];
const skeletonAnimations = [
    "wave",
    "pulse",
    "pulse-x",
    "pulse-y",
    "fade",
    "blink",
    "none"
];
var QSkeleton_default = createComponent({
    name: "QSkeleton",
    props: {
        ...useDarkProps,
        tag: {
            type: String,
            default: "div"
        },
        type: {
            type: String,
            validator: (v)=>skeletonTypes.includes(v),
            default: "rect"
        },
        animation: {
            type: String,
            validator: (v)=>skeletonAnimations.includes(v),
            default: "wave"
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 1500
        },
        square: Boolean,
        bordered: Boolean,
        size: String,
        width: String,
        height: String
    },
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const style = (0, _vue.computed)(()=>{
            const size = props.size !== void 0 ? [
                props.size,
                props.size
            ] : [
                props.width,
                props.height
            ];
            return {
                "--q-skeleton-speed": `${props.animationSpeed}ms`,
                width: size[0],
                height: size[1]
            };
        });
        const classes = (0, _vue.computed)(()=>`q-skeleton q-skeleton--${isDark.value === true ? "dark" : "light"} q-skeleton--type-${props.type}` + (props.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${props.animation}` : "") + (props.square === true ? " q-skeleton--square" : "") + (props.bordered === true ? " q-skeleton--bordered" : ""));
        return ()=>(0, _vue.h)(props.tag, {
                class: classes.value,
                style: style.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/slide-item/QSlideItem.js
const slotsDef = [
    [
        "left",
        "center",
        "start",
        "width"
    ],
    [
        "right",
        "center",
        "end",
        "width"
    ],
    [
        "top",
        "start",
        "center",
        "height"
    ],
    [
        "bottom",
        "end",
        "center",
        "height"
    ]
];
var QSlideItem_default = createComponent({
    name: "QSlideItem",
    props: {
        ...useDarkProps,
        leftColor: String,
        rightColor: String,
        topColor: String,
        bottomColor: String,
        onSlide: Function
    },
    emits: [
        "action",
        "top",
        "right",
        "bottom",
        "left"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const { getCache } = useRenderCache();
        const contentRef = (0, _vue.ref)(null);
        let timer = null, pan = {}, dirRefs = {}, dirContentRefs = {};
        const langDir = (0, _vue.computed)(()=>$q.lang.rtl === true ? {
                left: "right",
                right: "left"
            } : {
                left: "left",
                right: "right"
            });
        const classes = (0, _vue.computed)(()=>"q-slide-item q-item-type overflow-hidden" + (isDark.value === true ? " q-slide-item--dark q-dark" : ""));
        function reset() {
            contentRef.value.style.transform = "translate(0,0)";
        }
        function emitSlide(side, ratio, isReset) {
            if (props.onSlide !== void 0) emit("slide", {
                side,
                ratio,
                isReset
            });
        }
        function onPan(evt) {
            const node = contentRef.value;
            if (evt.isFirst) {
                pan = {
                    dir: null,
                    size: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    },
                    scale: 0
                };
                node.classList.add("no-transition");
                slotsDef.forEach((slotName)=>{
                    if (slots[slotName[0]] !== void 0) {
                        const localNode = dirContentRefs[slotName[0]];
                        localNode.style.transform = "scale(1)";
                        pan.size[slotName[0]] = localNode.getBoundingClientRect()[slotName[3]];
                    }
                });
                pan.axis = evt.direction === "up" || evt.direction === "down" ? "Y" : "X";
            } else if (evt.isFinal) {
                node.classList.remove("no-transition");
                if (pan.scale === 1) {
                    node.style.transform = `translate${pan.axis}(${pan.dir * 100}%)`;
                    if (timer !== null) clearTimeout(timer);
                    timer = setTimeout(()=>{
                        timer = null;
                        emit(pan.showing, {
                            reset
                        });
                        emit("action", {
                            side: pan.showing,
                            reset
                        });
                    }, 230);
                } else {
                    node.style.transform = "translate(0,0)";
                    emitSlide(pan.showing, 0, true);
                }
                return;
            } else evt.direction = pan.axis === "X" ? evt.offset.x < 0 ? "left" : "right" : evt.offset.y < 0 ? "up" : "down";
            if (slots.left === void 0 && evt.direction === langDir.value.right || slots.right === void 0 && evt.direction === langDir.value.left || slots.top === void 0 && evt.direction === "down" || slots.bottom === void 0 && evt.direction === "up") {
                node.style.transform = "translate(0,0)";
                return;
            }
            let showing, dir, dist;
            if (pan.axis === "X") {
                dir = evt.direction === "left" ? -1 : 1;
                showing = dir === 1 ? langDir.value.left : langDir.value.right;
                dist = evt.distance.x;
            } else {
                dir = evt.direction === "up" ? -2 : 2;
                showing = dir === 2 ? "top" : "bottom";
                dist = evt.distance.y;
            }
            if (pan.dir !== null && Math.abs(dir) !== Math.abs(pan.dir)) return;
            if (pan.dir !== dir) {
                [
                    "left",
                    "right",
                    "top",
                    "bottom"
                ].forEach((d)=>{
                    if (dirRefs[d]) dirRefs[d].style.visibility = showing === d ? "visible" : "hidden";
                });
                pan.showing = showing;
                pan.dir = dir;
            }
            pan.scale = Math.max(0, Math.min(1, (dist - 40) / pan.size[showing]));
            node.style.transform = `translate${pan.axis}(${dist * dir / Math.abs(dir)}px)`;
            dirContentRefs[showing].style.transform = `scale(${pan.scale})`;
            emitSlide(showing, pan.scale, false);
        }
        (0, _vue.onBeforeUpdate)(()=>{
            dirRefs = {};
            dirContentRefs = {};
        });
        (0, _vue.onBeforeUnmount)(()=>{
            if (timer !== null) clearTimeout(timer);
        });
        Object.assign(proxy, {
            reset
        });
        return ()=>{
            const content = [], slotsList = {
                left: slots[langDir.value.right] !== void 0,
                right: slots[langDir.value.left] !== void 0,
                up: slots.bottom !== void 0,
                down: slots.top !== void 0
            }, dirs = Object.keys(slotsList).filter((key)=>slotsList[key] === true);
            slotsDef.forEach((slotName)=>{
                const dir = slotName[0];
                if (slots[dir] !== void 0) content.push((0, _vue.h)("div", {
                    key: dir,
                    ref: (el)=>{
                        dirRefs[dir] = el;
                    },
                    class: `q-slide-item__${dir} absolute-full row no-wrap items-${slotName[1]} justify-${slotName[2]}` + (props[dir + "Color"] !== void 0 ? ` bg-${props[dir + "Color"]}` : "")
                }, [
                    (0, _vue.h)("div", {
                        ref: (el)=>{
                            dirContentRefs[dir] = el;
                        }
                    }, slots[dir]())
                ]));
            });
            const node = (0, _vue.h)("div", {
                key: `${dirs.length === 0 ? "only-" : ""} content`,
                ref: contentRef,
                class: "q-slide-item__content"
            }, hSlot(slots.default));
            if (dirs.length === 0) content.push(node);
            else content.push((0, _vue.withDirectives)(node, getCache("dir#" + dirs.join(""), ()=>{
                const modifiers = {
                    prevent: true,
                    stop: true,
                    mouse: true
                };
                dirs.forEach((dir)=>{
                    modifiers[dir] = true;
                });
                return [
                    [
                        TouchPan_default,
                        onPan,
                        void 0,
                        modifiers
                    ]
                ];
            })));
            return (0, _vue.h)("div", {
                class: classes.value
            }, content);
        };
    }
});
//#endregion
//#region src/components/space/QSpace.js
var QSpace_default = createComponent({
    name: "QSpace",
    setup () {
        const space = (0, _vue.h)("div", {
            class: "q-space"
        });
        return ()=>space;
    }
});
//#endregion
//#region src/components/spinner/QSpinnerAudio.js
const innerHTML$21 = '<g transform="matrix(1 0 0 -1 0 80)"><rect width="10" height="20" rx="3"><animate attributeName="height" begin="0s" dur="4.3s" values="20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="15" width="10" height="80" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="80;55;33;5;75;23;73;33;12;14;60;80" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" width="10" height="50" rx="3"><animate attributeName="height" begin="0s" dur="1.4s" values="50;34;78;23;56;23;34;76;80;54;21;50" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="45" width="10" height="30" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="30;45;13;80;56;72;45;76;34;23;67;30" calcMode="linear" repeatCount="indefinite"></animate></rect></g>';
var QSpinnerAudio_default = createComponent({
    name: "QSpinnerAudio",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                fill: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 55 80",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$21
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerBall.js
const innerHTML$20 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle cx="5" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="27" cy="5" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5" values="5;50;50;5" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27" values="27;49;5;27" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="49" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s" values="49;5;27;49" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
var QSpinnerBall_default = createComponent({
    name: "QSpinnerBall",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                stroke: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 57 57",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$20
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerBars.js
const innerHTML$19 = '<rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect>';
var QSpinnerBars_default = createComponent({
    name: "QSpinnerBars",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                fill: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 135 140",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$19
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerBox.js
const innerHTML$18 = '<rect x="25" y="25" width="50" height="50" fill="none" stroke-width="4" stroke="currentColor"><animateTransform id="spinnerBox" attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" dur="0.5s" begin="rectBox.end"></animateTransform></rect><rect x="27" y="27" width="46" height="50" fill="currentColor"><animate id="rectBox" attributeName="height" begin="0s;spinnerBox.end" dur="1.3s" from="50" to="0" fill="freeze"></animate></rect>';
var QSpinnerBox_default = createComponent({
    name: "QSpinnerBox",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$18
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerClock.js
const innerHTML$17 = '<circle cx="50" cy="50" r="48" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="currentColor"></circle><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="85" y2="50.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2s" repeatCount="indefinite"></animateTransform></line><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="49.5" y2="74"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="15s" repeatCount="indefinite"></animateTransform></line>';
var QSpinnerClock_default = createComponent({
    name: "QSpinnerClock",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$17
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerComment.js
const innerHTML$16 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><path d="M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z" fill="currentColor"></path><circle cx="30" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;1;1" keyTimes="0;0.2;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="50" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.2;0.4;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="70" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.4;0.6;1" dur="1s" repeatCount="indefinite"></animate></circle>';
var QSpinnerComment_default = createComponent({
    name: "QSpinnerComment",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                innerHTML: innerHTML$16
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerCube.js
const innerHTML$15 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><g transform="translate(25 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.1s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(25 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.7"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.3s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.2s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g>';
var QSpinnerCube_default = createComponent({
    name: "QSpinnerCube",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                innerHTML: innerHTML$15
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerDots.js
const innerHTML$14 = '<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity=".3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from=".5" to=".5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
var QSpinnerDots_default = createComponent({
    name: "QSpinnerDots",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                fill: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 120 30",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$14
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerFacebook.js
const innerHTML$13 = '<g transform="translate(20 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(50 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.1s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(80 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.2s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g>';
var QSpinnerFacebook_default = createComponent({
    name: "QSpinnerFacebook",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid",
                innerHTML: innerHTML$13
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerGears.js
const innerHTML$12 = '<g transform="translate(-20,-20)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="90 50 50" to="0 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g><g transform="translate(20,20) rotate(15 50 50)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="90 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
var QSpinnerGears_default = createComponent({
    name: "QSpinnerGears",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$12
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerGrid.js
const innerHTML$11 = '<circle cx="12.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="0s" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="52.5" r="12.5" fill-opacity=".5"><animate attributeName="fill-opacity" begin="100ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="300ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="600ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="800ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="400ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="700ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="500ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="200ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
var QSpinnerGrid_default = createComponent({
    name: "QSpinnerGrid",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                fill: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 105 105",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$11
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerHearts.js
const innerHTML$10 = '<path d="M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0.7s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"></path>';
var QSpinnerHearts_default = createComponent({
    name: "QSpinnerHearts",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                fill: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 140 64",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$10
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerHourglass.js
const innerHTML$9 = '<g><path fill="none" stroke="currentColor" stroke-width="5" stroke-miterlimit="10" d="M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"></path><clipPath id="uil-hourglass-clip1"><rect x="15" y="20" width="70" height="25"><animate attributeName="height" from="25" to="0" dur="1s" repeatCount="indefinite" values="25;0;0" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="20" to="45" dur="1s" repeatCount="indefinite" values="20;45;45" keyTimes="0;0.5;1"></animate></rect></clipPath><clipPath id="uil-hourglass-clip2"><rect x="15" y="55" width="70" height="25"><animate attributeName="height" from="0" to="25" dur="1s" repeatCount="indefinite" values="0;25;25" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="80" to="55" dur="1s" repeatCount="indefinite" values="80;55;55" keyTimes="0;0.5;1"></animate></rect></clipPath><path d="M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z" clip-path="url(#uil-hourglass-clip1)" fill="currentColor"></path><path d="M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z" clip-path="url(#uil-hourglass-clip2)" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" repeatCount="indefinite" dur="1s" values="0 50 50;0 50 50;180 50 50" keyTimes="0;0.7;1"></animateTransform></g>';
var QSpinnerHourglass_default = createComponent({
    name: "QSpinnerHourglass",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$9
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerInfinity.js
const innerHTML$8 = '<path d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z" fill="none" stroke="currentColor" stroke-width="8" stroke-dasharray="10.691205342610678 10.691205342610678" stroke-dashoffset="0"><animate attributeName="stroke-dashoffset" from="0" to="21.382410685221355" begin="0" dur="2s" repeatCount="indefinite" fill="freeze"></animate></path>';
var QSpinnerInfinity_default = createComponent({
    name: "QSpinnerInfinity",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                innerHTML: innerHTML$8
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerIos.js
const innerHTML$7 = '<g stroke-width="4" stroke-linecap="round"><line y1="17" y2="29" transform="translate(32,32) rotate(180)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(210)"><animate attributeName="stroke-opacity" dur="750ms" values="0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(240)"><animate attributeName="stroke-opacity" dur="750ms" values=".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(270)"><animate attributeName="stroke-opacity" dur="750ms" values=".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(300)"><animate attributeName="stroke-opacity" dur="750ms" values=".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(330)"><animate attributeName="stroke-opacity" dur="750ms" values=".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(0)"><animate attributeName="stroke-opacity" dur="750ms" values=".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(30)"><animate attributeName="stroke-opacity" dur="750ms" values=".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(60)"><animate attributeName="stroke-opacity" dur="750ms" values=".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(90)"><animate attributeName="stroke-opacity" dur="750ms" values=".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(120)"><animate attributeName="stroke-opacity" dur="750ms" values=".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(150)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line></g>';
var QSpinnerIos_default = createComponent({
    name: "QSpinnerIos",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                stroke: "currentColor",
                fill: "currentColor",
                viewBox: "0 0 64 64",
                innerHTML: innerHTML$7
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerOrbit.js
const innerHTML$6 = '<circle cx="50" cy="50" r="44" fill="none" stroke-width="4" stroke-opacity=".5" stroke="currentColor"></circle><circle cx="8" cy="54" r="6" fill="currentColor" stroke-width="3" stroke="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 48" to="360 50 52" dur="2s" repeatCount="indefinite"></animateTransform></circle>';
var QSpinnerOrbit_default = createComponent({
    name: "QSpinnerOrbit",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$6
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerOval.js
const innerHTML$5 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
var QSpinnerOval_default = createComponent({
    name: "QSpinnerOval",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                stroke: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$5
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerPie.js
const innerHTML$4 = '<path d="M0 50A50 50 0 0 1 50 0L50 50L0 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="0.8s" repeatCount="indefinite"></animateTransform></path><path d="M50 0A50 50 0 0 1 100 50L50 50L50 0" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1.6s" repeatCount="indefinite"></animateTransform></path><path d="M100 50A50 50 0 0 1 50 100L50 50L100 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2.4s" repeatCount="indefinite"></animateTransform></path><path d="M50 100A50 50 0 0 1 0 50L50 50L50 100" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="3.2s" repeatCount="indefinite"></animateTransform></path>';
var QSpinnerPie_default = createComponent({
    name: "QSpinnerPie",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$4
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerPuff.js
const innerHTML$3 = '<g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle></g>';
var QSpinnerPuff_default = createComponent({
    name: "QSpinnerPuff",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                stroke: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 44 44",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$3
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerRadio.js
const innerHTML$2 = '<g transform="scale(0.55)"><circle cx="30" cy="150" r="30" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></circle><path d="M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.1" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path><path d="M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.2" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path></g>';
var QSpinnerRadio_default = createComponent({
    name: "QSpinnerRadio",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$2
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerRings.js
const innerHTML$1 = '<g fill="none" fill-rule="evenodd" transform="translate(1 1)" stroke-width="2"><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="1.5s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="1.5s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="1.5s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="3s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="3s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="3s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="8"><animate attributeName="r" begin="0s" dur="1.5s" values="6;1;2;3;4;5;6" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
var QSpinnerRings_default = createComponent({
    name: "QSpinnerRings",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                stroke: "currentColor",
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 45 45",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML: innerHTML$1
            });
    }
});
//#endregion
//#region src/components/spinner/QSpinnerTail.js
const innerHTML = '<defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"><stop stop-color="currentColor" stop-opacity="0" offset="0%"></stop><stop stop-color="currentColor" stop-opacity=".631" offset="63.146%"></stop><stop stop-color="currentColor" offset="100%"></stop></linearGradient></defs><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><path d="M36 18c0-9.94-8.06-18-18-18" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></path><circle fill="currentColor" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></circle></g>';
var QSpinnerTail_default = createComponent({
    name: "QSpinnerTail",
    props: useSpinnerProps,
    setup (props) {
        const { cSize, classes } = useSpinner(props);
        return ()=>(0, _vue.h)("svg", {
                class: classes.value,
                width: cSize.value,
                height: cSize.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg",
                innerHTML
            });
    }
});
//#endregion
//#region src/components/splitter/QSplitter.js
var QSplitter_default = createComponent({
    name: "QSplitter",
    props: {
        ...useDarkProps,
        modelValue: {
            type: Number,
            required: true
        },
        reverse: Boolean,
        unit: {
            type: String,
            default: "%",
            validator: (v)=>[
                    "%",
                    "px"
                ].includes(v)
        },
        limits: {
            type: Array,
            validator: (v)=>{
                if (v.length !== 2) return false;
                if (typeof v[0] !== "number" || typeof v[1] !== "number") return false;
                return v[0] >= 0 && v[0] <= v[1];
            }
        },
        emitImmediately: Boolean,
        horizontal: Boolean,
        disable: Boolean,
        beforeClass: [
            Array,
            String,
            Object
        ],
        afterClass: [
            Array,
            String,
            Object
        ],
        separatorClass: [
            Array,
            String,
            Object
        ],
        separatorStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        "update:modelValue"
    ],
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, $q);
        const rootRef = (0, _vue.ref)(null);
        const sideRefs = {
            before: (0, _vue.ref)(null),
            after: (0, _vue.ref)(null)
        };
        const classes = (0, _vue.computed)(()=>`q-splitter no-wrap ${props.horizontal === true ? "q-splitter--horizontal column" : "q-splitter--vertical row"} q-splitter--${props.disable === true ? "disabled" : "workable"}` + (isDark.value === true ? " q-splitter--dark" : ""));
        const propName = (0, _vue.computed)(()=>props.horizontal === true ? "height" : "width");
        const side = (0, _vue.computed)(()=>props.reverse !== true ? "before" : "after");
        const computedLimits = (0, _vue.computed)(()=>props.limits !== void 0 ? props.limits : props.unit === "%" ? [
                10,
                90
            ] : [
                50,
                Infinity
            ]);
        function getCSSValue(value1) {
            return (props.unit === "%" ? value1 : Math.round(value1)) + props.unit;
        }
        const styles = (0, _vue.computed)(()=>({
                [side.value]: {
                    [propName.value]: getCSSValue(props.modelValue)
                }
            }));
        let __dir, __maxValue, __value, __multiplier, __normalized;
        function pan(evt) {
            if (evt.isFirst === true) {
                const size = rootRef.value.getBoundingClientRect()[propName.value];
                __dir = props.horizontal === true ? "up" : "left";
                __maxValue = props.unit === "%" ? 100 : size;
                __value = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], props.modelValue));
                __multiplier = (props.reverse !== true ? 1 : -1) * (props.horizontal === true ? 1 : $q.lang.rtl === true ? -1 : 1) * (props.unit === "%" ? size === 0 ? 0 : 100 / size : 1);
                rootRef.value.classList.add("q-splitter--active");
                return;
            }
            if (evt.isFinal === true) {
                if (__normalized !== props.modelValue) emit("update:modelValue", __normalized);
                rootRef.value.classList.remove("q-splitter--active");
                return;
            }
            const val = __value + __multiplier * (evt.direction === __dir ? -1 : 1) * evt.distance[props.horizontal === true ? "y" : "x"];
            __normalized = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], val));
            sideRefs[side.value].value.style[propName.value] = getCSSValue(__normalized);
            if (props.emitImmediately === true && props.modelValue !== __normalized) emit("update:modelValue", __normalized);
        }
        const sepDirective = (0, _vue.computed)(()=>[
                [
                    TouchPan_default,
                    pan,
                    void 0,
                    {
                        [props.horizontal === true ? "vertical" : "horizontal"]: true,
                        prevent: true,
                        stop: true,
                        mouse: true,
                        mouseAllDir: true
                    }
                ]
            ]);
        function normalize(val, limits) {
            if (val < limits[0]) emit("update:modelValue", limits[0]);
            else if (val > limits[1]) emit("update:modelValue", limits[1]);
        }
        (0, _vue.watch)(()=>props.modelValue, (v)=>{
            normalize(v, computedLimits.value);
        });
        (0, _vue.watch)(()=>props.limits, ()=>{
            (0, _vue.nextTick)(()=>{
                normalize(props.modelValue, computedLimits.value);
            });
        });
        return ()=>{
            const child = [
                (0, _vue.h)("div", {
                    ref: sideRefs.before,
                    class: [
                        "q-splitter__panel q-splitter__before" + (props.reverse === true ? " col" : ""),
                        props.beforeClass
                    ],
                    style: styles.value.before
                }, hSlot(slots.before)),
                (0, _vue.h)("div", {
                    class: [
                        "q-splitter__separator",
                        props.separatorClass
                    ],
                    style: props.separatorStyle,
                    "aria-disabled": props.disable === true ? "true" : void 0
                }, [
                    hDir("div", {
                        class: "q-splitter__separator-area absolute-full"
                    }, hSlot(slots.separator), "sep", props.disable !== true, ()=>sepDirective.value)
                ]),
                (0, _vue.h)("div", {
                    ref: sideRefs.after,
                    class: [
                        "q-splitter__panel q-splitter__after" + (props.reverse === true ? "" : " col"),
                        props.afterClass
                    ],
                    style: styles.value.after
                }, hSlot(slots.after))
            ];
            return (0, _vue.h)("div", {
                class: classes.value,
                ref: rootRef
            }, hMergeSlot(slots.default, child));
        };
    }
});
//#endregion
//#region src/components/stepper/StepHeader.js
var StepHeader_default = createComponent({
    name: "StepHeader",
    props: {
        stepper: {},
        step: {},
        goToPanel: Function
    },
    setup (props, { attrs }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const blurRef = (0, _vue.ref)(null);
        const isActive = (0, _vue.computed)(()=>props.stepper.modelValue === props.step.name);
        const isDisable = (0, _vue.computed)(()=>{
            const opt = props.step.disable;
            return opt === true || opt === "";
        });
        const isError = (0, _vue.computed)(()=>{
            const opt = props.step.error;
            return opt === true || opt === "";
        });
        const isDone = (0, _vue.computed)(()=>{
            const opt = props.step.done;
            return isDisable.value === false && (opt === true || opt === "");
        });
        const headerNav = (0, _vue.computed)(()=>{
            const opt = props.step.headerNav, nav = opt === true || opt === "" || opt === void 0;
            return isDisable.value === false && props.stepper.headerNav && nav;
        });
        const hasPrefix = (0, _vue.computed)(()=>props.step.prefix && (isActive.value === false || props.stepper.activeIcon === "none") && (isError.value === false || props.stepper.errorIcon === "none") && (isDone.value === false || props.stepper.doneIcon === "none"));
        const icon = (0, _vue.computed)(()=>{
            const defaultIcon = props.step.icon || props.stepper.inactiveIcon;
            if (isActive.value === true) {
                const localIcon = props.step.activeIcon || props.stepper.activeIcon;
                return localIcon === "none" ? defaultIcon : localIcon || $q.iconSet.stepper.active;
            }
            if (isError.value === true) {
                const localIcon = props.step.errorIcon || props.stepper.errorIcon;
                return localIcon === "none" ? defaultIcon : localIcon || $q.iconSet.stepper.error;
            }
            if (isDisable.value === false && isDone.value === true) {
                const localIcon = props.step.doneIcon || props.stepper.doneIcon;
                return localIcon === "none" ? defaultIcon : localIcon || $q.iconSet.stepper.done;
            }
            return defaultIcon;
        });
        const color = (0, _vue.computed)(()=>{
            const errorColor = isError.value === true ? props.step.errorColor || props.stepper.errorColor : void 0;
            if (isActive.value === true) {
                const localColor = props.step.activeColor || props.stepper.activeColor || props.step.color;
                return localColor !== void 0 ? localColor : errorColor;
            }
            if (errorColor !== void 0) return errorColor;
            if (isDisable.value === false && isDone.value === true) return props.step.doneColor || props.stepper.doneColor || props.step.color || props.stepper.inactiveColor;
            return props.step.color || props.stepper.inactiveColor;
        });
        const classes = (0, _vue.computed)(()=>"q-stepper__tab col-grow flex items-center no-wrap relative-position" + (color.value !== void 0 ? ` text-${color.value}` : "") + (isError.value === true ? " q-stepper__tab--error q-stepper__tab--error-with-" + (hasPrefix.value === true ? "prefix" : "icon") : "") + (isActive.value === true ? " q-stepper__tab--active" : "") + (isDone.value === true ? " q-stepper__tab--done" : "") + (headerNav.value === true ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (isDisable.value === true ? " q-stepper__tab--disabled" : ""));
        const ripple = (0, _vue.computed)(()=>props.stepper.headerNav !== true ? false : headerNav.value);
        function onActivate() {
            blurRef.value?.focus();
            if (isActive.value === false) props.goToPanel(props.step.name);
        }
        function onKeyup(e) {
            if (e.keyCode === 13 && isActive.value === false) props.goToPanel(props.step.name);
        }
        return ()=>{
            const data = {
                class: classes.value
            };
            if (headerNav.value === true) {
                data.onClick = onActivate;
                data.onKeyup = onKeyup;
                Object.assign(data, isDisable.value === true ? {
                    tabindex: -1,
                    "aria-disabled": "true"
                } : {
                    tabindex: attrs.tabindex || 0
                });
            }
            const child = [
                (0, _vue.h)("div", {
                    class: "q-focus-helper",
                    tabindex: -1,
                    ref: blurRef
                }),
                (0, _vue.h)("div", {
                    class: "q-stepper__dot row flex-center q-stepper__line relative-position"
                }, [
                    (0, _vue.h)("span", {
                        class: "row flex-center"
                    }, [
                        hasPrefix.value === true ? props.step.prefix : (0, _vue.h)(QIcon_default, {
                            name: icon.value
                        })
                    ])
                ])
            ];
            if (props.step.title !== void 0 && props.step.title !== null) {
                const content = [
                    (0, _vue.h)("div", {
                        class: "q-stepper__title"
                    }, props.step.title)
                ];
                if (props.step.caption !== void 0 && props.step.caption !== null) content.push((0, _vue.h)("div", {
                    class: "q-stepper__caption"
                }, props.step.caption));
                child.push((0, _vue.h)("div", {
                    class: "q-stepper__label q-stepper__line relative-position"
                }, content));
            }
            return (0, _vue.withDirectives)((0, _vue.h)("div", data, child), [
                [
                    Ripple_default,
                    ripple.value
                ]
            ]);
        };
    }
});
//#endregion
//#region src/components/stepper/QStep.js
function getStepWrapper(slots) {
    return (0, _vue.h)("div", {
        class: "q-stepper__step-content"
    }, [
        (0, _vue.h)("div", {
            class: "q-stepper__step-inner"
        }, hSlot(slots.default))
    ]);
}
const PanelWrapper = {
    setup (_, { slots }) {
        return ()=>getStepWrapper(slots);
    }
};
var QStep_default = createComponent({
    name: "QStep",
    props: {
        ...usePanelChildProps,
        icon: String,
        color: String,
        title: {
            type: String,
            required: true
        },
        caption: String,
        prefix: [
            String,
            Number
        ],
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String,
        headerNav: {
            type: Boolean,
            default: true
        },
        done: Boolean,
        error: Boolean,
        onScroll: [
            Function,
            Array
        ]
    },
    setup (props, { slots, emit }) {
        const { proxy: { $q } } = (0, _vue.getCurrentInstance)();
        const $stepper = (0, _vue.inject)(stepperKey, emptyRenderFn);
        if ($stepper === emptyRenderFn) {
            console.error("QStep needs to be a child of QStepper");
            return emptyRenderFn;
        }
        const { getCache } = useRenderCache();
        const rootRef = (0, _vue.ref)(null);
        const isActive = (0, _vue.computed)(()=>$stepper.value.modelValue === props.name);
        const scrollEvent = (0, _vue.computed)(()=>$q.platform.is.ios !== true && $q.platform.is.chrome === true || isActive.value !== true || $stepper.value.vertical !== true ? {} : {
                onScroll (e) {
                    const { target } = e;
                    if (target.scrollTop > 0) target.scrollTop = 0;
                    if (props.onScroll !== void 0) emit("scroll", e);
                }
            });
        const contentKey = (0, _vue.computed)(()=>typeof props.name === "string" || typeof props.name === "number" ? props.name : String(props.name));
        function getStepContent() {
            const vertical = $stepper.value.vertical;
            if (vertical === true && $stepper.value.keepAlive === true) return (0, _vue.h)((0, _vue.KeepAlive), $stepper.value.keepAliveProps.value, isActive.value === true ? [
                (0, _vue.h)($stepper.value.needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, ()=>({
                        ...PanelWrapper,
                        name: contentKey.value
                    })) : PanelWrapper, {
                    key: contentKey.value
                }, slots.default)
            ] : void 0);
            return vertical !== true || isActive.value === true ? getStepWrapper(slots) : void 0;
        }
        return ()=>(0, _vue.h)("div", {
                ref: rootRef,
                class: "q-stepper__step",
                role: "tabpanel",
                ...scrollEvent.value
            }, $stepper.value.vertical === true ? [
                (0, _vue.h)(StepHeader_default, {
                    stepper: $stepper.value,
                    step: props,
                    goToPanel: $stepper.value.goToPanel
                }),
                $stepper.value.animated === true ? (0, _vue.h)(QSlideTransition_default, getStepContent) : getStepContent()
            ] : [
                getStepContent()
            ]);
    }
});
//#endregion
//#region src/components/stepper/QStepper.js
const camelRE = /(-\w)/g;
function camelizeProps(props) {
    const acc = {};
    for(const key in props){
        const newKey = key.replace(camelRE, (m)=>m[1].toUpperCase());
        acc[newKey] = props[key];
    }
    return acc;
}
var QStepper_default = createComponent({
    name: "QStepper",
    props: {
        ...useDarkProps,
        ...usePanelProps,
        flat: Boolean,
        bordered: Boolean,
        alternativeLabels: Boolean,
        headerNav: Boolean,
        contracted: Boolean,
        headerClass: String,
        inactiveColor: String,
        inactiveIcon: String,
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String
    },
    emits: usePanelEmits,
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        const { updatePanelsList, isValidPanelName, updatePanelIndex, getPanelContent, getPanels, panelDirectives, goToPanel, keepAliveProps, needsUniqueKeepAliveWrapper } = usePanel();
        (0, _vue.provide)(stepperKey, (0, _vue.computed)(()=>({
                goToPanel,
                keepAliveProps,
                needsUniqueKeepAliveWrapper,
                ...props
            })));
        const classes = (0, _vue.computed)(()=>`q-stepper q-stepper--${props.vertical === true ? "vertical" : "horizontal"}` + (props.flat === true ? " q-stepper--flat" : "") + (props.bordered === true ? " q-stepper--bordered" : "") + (isDark.value === true ? " q-stepper--dark q-dark" : ""));
        const headerClasses = (0, _vue.computed)(()=>`q-stepper__header row items-stretch justify-between q-stepper__header--${props.alternativeLabels === true ? "alternative" : "standard"}-labels` + (props.flat === false || props.bordered === true ? " q-stepper__header--border" : "") + (props.contracted === true ? " q-stepper__header--contracted" : "") + (props.headerClass !== void 0 ? ` ${props.headerClass}` : ""));
        function getContent() {
            const top = hSlot(slots.message, []);
            if (props.vertical === true) {
                if (isValidPanelName(props.modelValue)) updatePanelIndex();
                const content = (0, _vue.h)("div", {
                    class: "q-stepper__content"
                }, hSlot(slots.default));
                return top === void 0 ? [
                    content
                ] : top.concat(content);
            }
            return [
                (0, _vue.h)("div", {
                    class: headerClasses.value
                }, getPanels().map((panel)=>{
                    const step = camelizeProps(panel.props);
                    return (0, _vue.h)(StepHeader_default, {
                        key: step.name,
                        stepper: props,
                        step,
                        goToPanel
                    });
                })),
                top,
                hDir("div", {
                    class: "q-stepper__content q-panel-parent"
                }, getPanelContent(), "cont", props.swipeable, ()=>panelDirectives.value)
            ];
        }
        return ()=>{
            updatePanelsList(slots);
            return (0, _vue.h)("div", {
                class: classes.value
            }, hMergeSlot(slots.navigation, getContent()));
        };
    }
});
//#endregion
//#region src/components/stepper/QStepperNavigation.js
var QStepperNavigation_default = createComponent({
    name: "QStepperNavigation",
    setup (_, { slots }) {
        return ()=>(0, _vue.h)("div", {
                class: "q-stepper__nav"
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/table/QTh.js
var QTh_default = createComponent({
    name: "QTh",
    props: {
        props: Object,
        autoWidth: Boolean
    },
    emits: [
        "click"
    ],
    setup (props, { slots, emit }) {
        const vm = (0, _vue.getCurrentInstance)();
        const { proxy: { $q } } = vm;
        const onClick = (evt)=>{
            emit("click", evt);
        };
        return ()=>{
            if (props.props === void 0) return (0, _vue.h)("th", {
                class: props.autoWidth === true ? "q-table--col-auto-width" : "",
                onClick
            }, hSlot(slots.default));
            let col, child;
            const name = vm.vnode.key;
            if (name) {
                col = props.props.colsMap[name];
                if (col === void 0) return;
            } else col = props.props.col;
            if (col.sortable === true) {
                const action = col.align === "right" ? "unshift" : "push";
                child = hUniqueSlot(slots.default, []);
                child[action]((0, _vue.h)(QIcon_default, {
                    class: col.__iconClass,
                    name: $q.iconSet.table.arrowUp
                }));
            } else child = hSlot(slots.default);
            return (0, _vue.h)("th", {
                class: col.__thClass + (props.autoWidth === true ? " q-table--col-auto-width" : ""),
                style: col.headerStyle,
                onClick: (evt)=>{
                    if (col.sortable === true) props.props.sort(col);
                    onClick(evt);
                }
            }, child);
        };
    }
});
//#endregion
//#region src/components/table/get-table-middle.js
function getTableMiddle(props, content) {
    return (0, _vue.h)("div", props, [
        (0, _vue.h)("table", {
            class: "q-table"
        }, content)
    ]);
}
//#endregion
//#region src/components/virtual-scroll/QVirtualScroll.js
const comps = {
    list: QList_default,
    table: QMarkupTable_default
};
const typeOptions = [
    "list",
    "table",
    "__qtable"
];
var QVirtualScroll_default = createComponent({
    name: "QVirtualScroll",
    props: {
        ...useVirtualScrollProps,
        type: {
            type: String,
            default: "list",
            validator: (v)=>typeOptions.includes(v)
        },
        items: {
            type: Array,
            default: ()=>[]
        },
        itemsFn: Function,
        itemsSize: Number,
        scrollTarget: scrollTargetProp
    },
    setup (props, { slots, attrs }) {
        let localScrollTarget;
        const rootRef = (0, _vue.ref)(null);
        const virtualScrollLength = (0, _vue.computed)(()=>props.itemsSize >= 0 && props.itemsFn !== void 0 ? parseInt(props.itemsSize, 10) : Array.isArray(props.items) ? props.items.length : 0);
        const { virtualScrollSliceRange, localResetVirtualScroll, padVirtualScroll, onVirtualScrollEvt } = useVirtualScroll({
            virtualScrollLength,
            getVirtualScrollTarget,
            getVirtualScrollEl
        });
        const virtualScrollScope = (0, _vue.computed)(()=>{
            if (virtualScrollLength.value === 0) return [];
            const mapFn = (item, i)=>({
                    index: virtualScrollSliceRange.value.from + i,
                    item
                });
            return props.itemsFn === void 0 ? props.items.slice(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to).map(mapFn) : props.itemsFn(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to - virtualScrollSliceRange.value.from).map(mapFn);
        });
        const classes = (0, _vue.computed)(()=>"q-virtual-scroll q-virtual-scroll" + (props.virtualScrollHorizontal === true ? "--horizontal" : "--vertical") + (props.scrollTarget !== void 0 ? "" : " scroll"));
        const attributes = (0, _vue.computed)(()=>props.scrollTarget !== void 0 ? {} : {
                tabindex: 0
            });
        (0, _vue.watch)(virtualScrollLength, ()=>{
            localResetVirtualScroll();
        });
        (0, _vue.watch)(()=>props.scrollTarget, ()=>{
            unconfigureScrollTarget();
            configureScrollTarget();
        });
        function getVirtualScrollEl() {
            return rootRef.value.$el || rootRef.value;
        }
        function getVirtualScrollTarget() {
            return localScrollTarget;
        }
        function configureScrollTarget() {
            localScrollTarget = getScrollTarget(getVirtualScrollEl(), props.scrollTarget);
            localScrollTarget.addEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
        }
        function unconfigureScrollTarget() {
            if (localScrollTarget !== void 0) {
                localScrollTarget.removeEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
                localScrollTarget = void 0;
            }
        }
        function __getVirtualChildren() {
            let child = padVirtualScroll(props.type === "list" ? "div" : "tbody", virtualScrollScope.value.map(slots.default));
            if (slots.before !== void 0) child = slots.before().concat(child);
            return hMergeSlot(slots.after, child);
        }
        (0, _vue.onBeforeMount)(()=>{
            localResetVirtualScroll();
        });
        (0, _vue.onMounted)(()=>{
            configureScrollTarget();
        });
        (0, _vue.onActivated)(()=>{
            configureScrollTarget();
        });
        (0, _vue.onDeactivated)(()=>{
            unconfigureScrollTarget();
        });
        (0, _vue.onBeforeUnmount)(()=>{
            unconfigureScrollTarget();
        });
        return ()=>{
            if (slots.default === void 0) {
                console.error("QVirtualScroll: default scoped slot is required for rendering");
                return;
            }
            return props.type === "__qtable" ? getTableMiddle({
                ref: rootRef,
                class: "q-table__middle " + classes.value
            }, __getVirtualChildren()) : (0, _vue.h)(comps[props.type], {
                ...attrs,
                ref: rootRef,
                class: [
                    attrs.class,
                    classes.value
                ],
                ...attributes.value
            }, __getVirtualChildren);
        };
    }
});
//#endregion
//#region src/utils/private.sort/sort.js
function sortDate(a, b) {
    return new Date(a) - new Date(b);
}
//#endregion
//#region src/components/table/table-sort.js
const useTableSortProps = {
    sortMethod: Function,
    binaryStateSort: Boolean,
    columnSortOrder: {
        type: String,
        validator: (v)=>v === "ad" || v === "da",
        default: "ad"
    }
};
function useTableSort(props, computedPagination, colList, setPagination) {
    const columnToSort = (0, _vue.computed)(()=>{
        const { sortBy } = computedPagination.value;
        return sortBy ? colList.value.find((def)=>def.name === sortBy) || null : null;
    });
    const computedSortMethod = (0, _vue.computed)(()=>props.sortMethod !== void 0 ? props.sortMethod : (data, sortBy, descending)=>{
            const col = colList.value.find((def)=>def.name === sortBy);
            if (col === void 0 || col.field === void 0) return data;
            const dir = descending === true ? -1 : 1, val = typeof col.field === "function" ? (v)=>col.field(v) : (v)=>v[col.field];
            return data.sort((a, b)=>{
                let A = val(a), B = val(b);
                if (col.rawSort !== void 0) return col.rawSort(A, B, a, b) * dir;
                if (A === null || A === void 0) return -1 * dir;
                if (B === null || B === void 0) return Number(dir);
                if (col.sort !== void 0) return col.sort(A, B, a, b) * dir;
                if (isNumber(A) === true && isNumber(B) === true) return (A - B) * dir;
                if (isDate(A) === true && isDate(B) === true) return sortDate(A, B) * dir;
                if (typeof A === "boolean" && typeof B === "boolean") return (A - B) * dir;
                [A, B] = [
                    A,
                    B
                ].map((s)=>String(s).toLocaleString().toLowerCase());
                return A < B ? -1 * dir : A === B ? 0 : dir;
            });
        });
    function sort(col) {
        let sortOrder = props.columnSortOrder;
        if (isObject(col) === true) {
            if (col.sortOrder) sortOrder = col.sortOrder;
            col = col.name;
        } else {
            const def = colList.value.find((item)=>item.name === col);
            if (def?.sortOrder) sortOrder = def.sortOrder;
        }
        let { sortBy, descending } = computedPagination.value;
        if (sortBy !== col) {
            sortBy = col;
            descending = sortOrder === "da";
        } else if (props.binaryStateSort === true) descending = !descending;
        else if (descending === true) {
            if (sortOrder === "ad") sortBy = null;
            else descending = false;
        } else if (sortOrder === "ad") descending = true;
        else sortBy = null;
        setPagination({
            sortBy,
            descending,
            page: 1
        });
    }
    return {
        columnToSort,
        computedSortMethod,
        sort
    };
}
//#endregion
//#region src/components/table/table-filter.js
const useTableFilterProps = {
    filter: [
        String,
        Object
    ],
    filterMethod: Function
};
function useTableFilter(props, setPagination) {
    const computedFilterMethod = (0, _vue.computed)(()=>props.filterMethod !== void 0 ? props.filterMethod : (rows, terms, cols, cellValue)=>{
            const lowerTerms = terms ? terms.toLowerCase() : "";
            return rows.filter((row)=>cols.some((col)=>{
                    const val = String(cellValue(col, row));
                    return (val === "undefined" || val === "null" ? "" : val.toLowerCase()).indexOf(lowerTerms) !== -1;
                }));
        });
    (0, _vue.watch)(()=>props.filter, ()=>{
        (0, _vue.nextTick)(()=>{
            setPagination({
                page: 1
            }, true);
        });
    }, {
        deep: true
    });
    return {
        computedFilterMethod
    };
}
//#endregion
//#region src/components/table/table-pagination.js
function samePagination(oldPag, newPag) {
    for(const prop in newPag)if (newPag[prop] !== oldPag[prop]) return false;
    return true;
}
function fixPagination(p) {
    if (p.page < 1) p.page = 1;
    if (p.rowsPerPage !== void 0 && p.rowsPerPage < 1) p.rowsPerPage = 0;
    return p;
}
const useTablePaginationProps = {
    pagination: Object,
    rowsPerPageOptions: {
        type: Array,
        default: ()=>[
                5,
                7,
                10,
                15,
                20,
                25,
                50,
                0
            ]
    },
    "onUpdate:pagination": [
        Function,
        Array
    ]
};
function useTablePaginationState(vm, getCellValue) {
    const { props, emit } = vm;
    const innerPagination = (0, _vue.ref)(Object.assign({
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: props.rowsPerPageOptions.length !== 0 ? props.rowsPerPageOptions[0] : 5
    }, props.pagination));
    const computedPagination = (0, _vue.computed)(()=>{
        return fixPagination(props["onUpdate:pagination"] !== void 0 ? {
            ...innerPagination.value,
            ...props.pagination
        } : innerPagination.value);
    });
    const isServerSide = (0, _vue.computed)(()=>computedPagination.value.rowsNumber !== void 0);
    function sendServerRequest(pagination) {
        requestServerInteraction({
            pagination,
            filter: props.filter
        });
    }
    function requestServerInteraction(prop = {}) {
        (0, _vue.nextTick)(()=>{
            emit("request", {
                pagination: prop.pagination || computedPagination.value,
                filter: prop.filter || props.filter,
                getCellValue
            });
        });
    }
    function setPagination(val, forceServerRequest) {
        const newPagination = fixPagination({
            ...computedPagination.value,
            ...val
        });
        if (samePagination(computedPagination.value, newPagination) === true) {
            if (isServerSide.value === true && forceServerRequest === true) sendServerRequest(newPagination);
            return;
        }
        if (isServerSide.value === true) {
            sendServerRequest(newPagination);
            return;
        }
        if (props.pagination !== void 0 && props["onUpdate:pagination"] !== void 0) emit("update:pagination", newPagination);
        else innerPagination.value = newPagination;
    }
    return {
        innerPagination,
        computedPagination,
        isServerSide,
        requestServerInteraction,
        setPagination
    };
}
function useTablePagination(vm, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber) {
    const { props, emit, proxy: { $q } } = vm;
    const computedRowsNumber = (0, _vue.computed)(()=>isServerSide.value === true ? computedPagination.value.rowsNumber || 0 : filteredSortedRowsNumber.value);
    const firstRowIndex = (0, _vue.computed)(()=>{
        const { page, rowsPerPage } = computedPagination.value;
        return (page - 1) * rowsPerPage;
    });
    const lastRowIndex = (0, _vue.computed)(()=>{
        const { page, rowsPerPage } = computedPagination.value;
        return page * rowsPerPage;
    });
    const isFirstPage = (0, _vue.computed)(()=>computedPagination.value.page === 1);
    const pagesNumber = (0, _vue.computed)(()=>computedPagination.value.rowsPerPage === 0 ? 1 : Math.max(1, Math.ceil(computedRowsNumber.value / computedPagination.value.rowsPerPage)));
    const isLastPage = (0, _vue.computed)(()=>lastRowIndex.value === 0 ? true : computedPagination.value.page >= pagesNumber.value);
    const computedRowsPerPageOptions = (0, _vue.computed)(()=>{
        return (props.rowsPerPageOptions.includes(innerPagination.value.rowsPerPage) ? props.rowsPerPageOptions : [
            innerPagination.value.rowsPerPage
        ].concat(props.rowsPerPageOptions)).map((count)=>({
                label: count === 0 ? $q.lang.table.allRows : String(count),
                value: count
            }));
    });
    (0, _vue.watch)(pagesNumber, (newLastPage, oldLastPage)=>{
        if (newLastPage === oldLastPage) return;
        const currentPage = computedPagination.value.page;
        if (newLastPage && !currentPage) setPagination({
            page: 1
        });
        else if (newLastPage < currentPage) setPagination({
            page: newLastPage
        });
    });
    function firstPage() {
        setPagination({
            page: 1
        });
    }
    function prevPage() {
        const { page } = computedPagination.value;
        if (page > 1) setPagination({
            page: page - 1
        });
    }
    function nextPage() {
        const { page, rowsPerPage } = computedPagination.value;
        if (lastRowIndex.value > 0 && page * rowsPerPage < computedRowsNumber.value) setPagination({
            page: page + 1
        });
    }
    function lastPage() {
        setPagination({
            page: pagesNumber.value
        });
    }
    if (props["onUpdate:pagination"] !== void 0) emit("update:pagination", {
        ...computedPagination.value
    });
    return {
        firstRowIndex,
        lastRowIndex,
        isFirstPage,
        isLastPage,
        pagesNumber,
        computedRowsPerPageOptions,
        computedRowsNumber,
        firstPage,
        prevPage,
        nextPage,
        lastPage
    };
}
//#endregion
//#region src/components/table/table-row-selection.js
const useTableRowSelectionProps = {
    selection: {
        type: String,
        default: "none",
        validator: (v)=>[
                "single",
                "multiple",
                "none"
            ].includes(v)
    },
    selected: {
        type: Array,
        default: ()=>[]
    }
};
const useTableRowSelectionEmits = [
    "update:selected",
    "selection"
];
function useTableRowSelection(props, emit, computedRows, getRowKey) {
    const selectedKeys = (0, _vue.computed)(()=>{
        const keys = {};
        props.selected.map(getRowKey.value).forEach((key)=>{
            keys[key] = true;
        });
        return keys;
    });
    const hasSelectionMode = (0, _vue.computed)(()=>props.selection !== "none");
    const singleSelection = (0, _vue.computed)(()=>props.selection === "single");
    const multipleSelection = (0, _vue.computed)(()=>props.selection === "multiple");
    const allRowsSelected = (0, _vue.computed)(()=>computedRows.value.length !== 0 && computedRows.value.every((row)=>selectedKeys.value[getRowKey.value(row)] === true));
    const someRowsSelected = (0, _vue.computed)(()=>allRowsSelected.value !== true && computedRows.value.some((row)=>selectedKeys.value[getRowKey.value(row)] === true));
    const rowsSelectedNumber = (0, _vue.computed)(()=>props.selected.length);
    function isRowSelected(key) {
        return selectedKeys.value[key] === true;
    }
    function clearSelection() {
        emit("update:selected", []);
    }
    function updateSelection(keys, rows, added, evt) {
        emit("selection", {
            rows,
            added,
            keys,
            evt
        });
        emit("update:selected", singleSelection.value === true ? added === true ? rows : [] : added === true ? props.selected.concat(rows) : props.selected.filter((row)=>keys.includes(getRowKey.value(row)) === false));
    }
    return {
        hasSelectionMode,
        singleSelection,
        multipleSelection,
        allRowsSelected,
        someRowsSelected,
        rowsSelectedNumber,
        isRowSelected,
        clearSelection,
        updateSelection
    };
}
//#endregion
//#region src/components/table/table-row-expand.js
function getVal(val) {
    return Array.isArray(val) ? val.slice() : [];
}
const useTableRowExpandProps = {
    expanded: Array
};
const useTableRowExpandEmits = [
    "update:expanded"
];
function useTableRowExpand(props, emit) {
    const innerExpanded = (0, _vue.ref)(getVal(props.expanded));
    (0, _vue.watch)(()=>props.expanded, (val)=>{
        innerExpanded.value = getVal(val);
    });
    function isRowExpanded(key) {
        return innerExpanded.value.includes(key);
    }
    function setExpanded(val) {
        if (props.expanded !== void 0) emit("update:expanded", val);
        else innerExpanded.value = val;
    }
    function updateExpanded(key, add) {
        const target = innerExpanded.value.slice();
        const index = target.indexOf(key);
        if (add === true) {
            if (index === -1) {
                target.push(key);
                setExpanded(target);
            }
        } else if (index !== -1) {
            target.splice(index, 1);
            setExpanded(target);
        }
    }
    return {
        isRowExpanded,
        setExpanded,
        updateExpanded
    };
}
//#endregion
//#region src/components/table/table-column-selection.js
const useTableColumnSelectionProps = {
    visibleColumns: Array
};
function useTableColumnSelection(props, computedPagination, hasSelectionMode) {
    const colList = (0, _vue.computed)(()=>{
        if (props.columns !== void 0) return props.columns;
        const row = props.rows[0];
        return row !== void 0 ? Object.keys(row).map((name)=>({
                name,
                label: name.toUpperCase(),
                field: name,
                align: isNumber(row[name]) ? "right" : "left",
                sortable: true
            })) : [];
    });
    const computedCols = (0, _vue.computed)(()=>{
        const { sortBy, descending } = computedPagination.value;
        return (props.visibleColumns !== void 0 ? colList.value.filter((col)=>col.required === true || props.visibleColumns.includes(col.name) === true) : colList.value).map((col)=>{
            const align = col.align || "right";
            const alignClass = `text-${align}`;
            return {
                ...col,
                align,
                __iconClass: `q-table__sort-icon q-table__sort-icon--${align}`,
                __thClass: alignClass + (col.headerClasses !== void 0 ? " " + col.headerClasses : "") + (col.sortable === true ? " sortable" : "") + (col.name === sortBy ? ` sorted ${descending === true ? "sort-desc" : ""}` : ""),
                __tdStyle: col.style !== void 0 ? typeof col.style !== "function" ? ()=>col.style : col.style : ()=>null,
                __tdClass: col.classes !== void 0 ? typeof col.classes !== "function" ? ()=>alignClass + " " + col.classes : (row)=>alignClass + " " + col.classes(row) : ()=>alignClass
            };
        });
    });
    return {
        colList,
        computedCols,
        computedColsMap: (0, _vue.computed)(()=>{
            const names = {};
            computedCols.value.forEach((col)=>{
                names[col.name] = col;
            });
            return names;
        }),
        computedColspan: (0, _vue.computed)(()=>props.tableColspan !== void 0 ? props.tableColspan : computedCols.value.length + (hasSelectionMode.value === true ? 1 : 0))
    };
}
//#endregion
//#region src/components/table/QTable.js
const bottomClass = "q-table__bottom row items-center";
const virtScrollPassthroughProps = {};
commonVirtScrollPropsList.forEach((p)=>{
    virtScrollPassthroughProps[p] = {};
});
var QTable_default = createComponent({
    name: "QTable",
    props: {
        rows: {
            type: Array,
            required: true
        },
        rowKey: {
            type: [
                String,
                Function
            ],
            default: "id"
        },
        columns: Array,
        loading: Boolean,
        iconFirstPage: String,
        iconPrevPage: String,
        iconNextPage: String,
        iconLastPage: String,
        title: String,
        hideHeader: Boolean,
        grid: Boolean,
        gridHeader: Boolean,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: (v)=>[
                    "horizontal",
                    "vertical",
                    "cell",
                    "none"
                ].includes(v)
        },
        wrapCells: Boolean,
        virtualScroll: Boolean,
        virtualScrollTarget: {},
        ...virtScrollPassthroughProps,
        noDataLabel: String,
        noResultsLabel: String,
        loadingLabel: String,
        selectedRowsLabel: Function,
        rowsPerPageLabel: String,
        paginationLabel: Function,
        color: {
            type: String,
            default: "grey-8"
        },
        titleClass: [
            String,
            Array,
            Object
        ],
        tableStyle: [
            String,
            Array,
            Object
        ],
        tableClass: [
            String,
            Array,
            Object
        ],
        tableHeaderStyle: [
            String,
            Array,
            Object
        ],
        tableHeaderClass: [
            String,
            Array,
            Object
        ],
        tableRowStyleFn: Function,
        tableRowClassFn: Function,
        cardContainerClass: [
            String,
            Array,
            Object
        ],
        cardContainerStyle: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ],
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyleFn: Function,
        cardClassFn: Function,
        hideBottom: Boolean,
        hideSelectedBanner: Boolean,
        hideNoData: Boolean,
        hidePagination: Boolean,
        onRowClick: Function,
        onRowDblclick: Function,
        onRowContextmenu: Function,
        ...useDarkProps,
        ...useFullscreenProps,
        ...useTableColumnSelectionProps,
        ...useTableFilterProps,
        ...useTablePaginationProps,
        ...useTableRowExpandProps,
        ...useTableRowSelectionProps,
        ...useTableSortProps
    },
    emits: [
        "request",
        "virtualScroll",
        ...useFullscreenEmits,
        ...useTableRowExpandEmits,
        ...useTableRowSelectionEmits
    ],
    setup (props, { slots, emit }) {
        const vm = (0, _vue.getCurrentInstance)();
        const { proxy: { $q } } = vm;
        const isDark = useDark(props, $q);
        const { inFullscreen, toggleFullscreen } = useFullscreen();
        const getRowKey = (0, _vue.computed)(()=>typeof props.rowKey === "function" ? props.rowKey : (row)=>row[props.rowKey]);
        const rootRef = (0, _vue.ref)(null);
        const virtScrollRef = (0, _vue.ref)(null);
        const hasVirtScroll = (0, _vue.computed)(()=>props.grid !== true && props.virtualScroll === true);
        const cardDefaultClass = (0, _vue.computed)(()=>" q-table__card" + (isDark.value === true ? " q-table__card--dark q-dark" : "") + (props.square === true ? " q-table--square" : "") + (props.flat === true ? " q-table--flat" : "") + (props.bordered === true ? " q-table--bordered" : ""));
        const containerClass = (0, _vue.computed)(()=>`q-table__container q-table--${props.separator}-separator column no-wrap` + (props.grid === true ? " q-table--grid" : cardDefaultClass.value) + (isDark.value === true ? " q-table--dark" : "") + (props.dense === true ? " q-table--dense" : "") + (props.wrapCells === false ? " q-table--no-wrap" : "") + (inFullscreen.value === true ? " fullscreen scroll" : ""));
        const rootContainerClass = (0, _vue.computed)(()=>containerClass.value + (props.loading === true ? " q-table--loading" : ""));
        (0, _vue.watch)(()=>props.tableStyle + props.tableClass + props.tableHeaderStyle + props.tableHeaderClass + containerClass.value, ()=>{
            if (hasVirtScroll.value === true) virtScrollRef.value?.reset();
        });
        const { innerPagination, computedPagination, isServerSide, requestServerInteraction, setPagination } = useTablePaginationState(vm, getCellValue);
        const { computedFilterMethod } = useTableFilter(props, setPagination);
        const { isRowExpanded, setExpanded, updateExpanded } = useTableRowExpand(props, emit);
        const filteredSortedRows = (0, _vue.computed)(()=>{
            let rows = props.rows;
            if (isServerSide.value === true || rows.length === 0) return rows;
            const { sortBy, descending } = computedPagination.value;
            if (props.filter) rows = computedFilterMethod.value(rows, props.filter, computedCols.value, getCellValue);
            if (columnToSort.value !== null) rows = computedSortMethod.value(props.rows === rows ? rows.slice() : rows, sortBy, descending);
            return rows;
        });
        const filteredSortedRowsNumber = (0, _vue.computed)(()=>filteredSortedRows.value.length);
        const computedRows = (0, _vue.computed)(()=>{
            let rows = filteredSortedRows.value;
            if (isServerSide.value === true) return rows;
            const { rowsPerPage } = computedPagination.value;
            if (rowsPerPage !== 0) {
                if (firstRowIndex.value === 0 && props.rows !== rows) {
                    if (rows.length > lastRowIndex.value) rows = rows.slice(0, lastRowIndex.value);
                } else rows = rows.slice(firstRowIndex.value, lastRowIndex.value);
            }
            return rows;
        });
        const { hasSelectionMode, singleSelection, multipleSelection, allRowsSelected, someRowsSelected, rowsSelectedNumber, isRowSelected, clearSelection, updateSelection } = useTableRowSelection(props, emit, computedRows, getRowKey);
        const { colList, computedCols, computedColsMap, computedColspan } = useTableColumnSelection(props, computedPagination, hasSelectionMode);
        const { columnToSort, computedSortMethod, sort } = useTableSort(props, computedPagination, colList, setPagination);
        const { firstRowIndex, lastRowIndex, isFirstPage, isLastPage, pagesNumber, computedRowsPerPageOptions, computedRowsNumber, firstPage, prevPage, nextPage, lastPage } = useTablePagination(vm, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber);
        const nothingToDisplay = (0, _vue.computed)(()=>computedRows.value.length === 0);
        const virtProps = (0, _vue.computed)(()=>{
            const acc = {};
            commonVirtScrollPropsList.forEach((p)=>{
                acc[p] = props[p];
            });
            if (acc.virtualScrollItemSize === void 0) acc.virtualScrollItemSize = props.dense === true ? 28 : 48;
            return acc;
        });
        function resetVirtualScroll() {
            if (hasVirtScroll.value === true) virtScrollRef.value.reset();
        }
        function getBody() {
            if (props.grid === true) return getGridBody();
            const header = props.hideHeader !== true ? getTHead : null;
            if (hasVirtScroll.value === true) {
                const topRow = slots["top-row"];
                const bottomRow = slots["bottom-row"];
                const virtSlots = {
                    default: (slotProps)=>getTBodyTR(slotProps.item, slots.body, slotProps.index)
                };
                if (topRow !== void 0) {
                    const topContent = (0, _vue.h)("tbody", topRow({
                        cols: computedCols.value
                    }));
                    virtSlots.before = header === null ? ()=>topContent : ()=>[
                            header()
                        ].concat(topContent);
                } else if (header !== null) virtSlots.before = header;
                if (bottomRow !== void 0) virtSlots.after = ()=>(0, _vue.h)("tbody", bottomRow({
                        cols: computedCols.value
                    }));
                return (0, _vue.h)(QVirtualScroll_default, {
                    ref: virtScrollRef,
                    class: props.tableClass,
                    style: props.tableStyle,
                    ...virtProps.value,
                    scrollTarget: props.virtualScrollTarget,
                    items: computedRows.value,
                    type: "__qtable",
                    tableColspan: computedColspan.value,
                    onVirtualScroll: onVScroll
                }, virtSlots);
            }
            const child = [
                getTBody()
            ];
            if (header !== null) child.unshift(header());
            return getTableMiddle({
                class: [
                    "q-table__middle scroll",
                    props.tableClass
                ],
                style: props.tableStyle
            }, child);
        }
        function scrollTo(toIndex, edge) {
            if (virtScrollRef.value !== null) {
                virtScrollRef.value.scrollTo(toIndex, edge);
                return;
            }
            toIndex = parseInt(toIndex, 10);
            const rowEl = rootRef.value.querySelector(`tbody tr:nth-of-type(${toIndex + 1})`);
            if (rowEl !== null) {
                const scrollTarget = rootRef.value.querySelector(".q-table__middle.scroll");
                const offsetTop = rowEl.offsetTop - props.virtualScrollStickySizeStart;
                const direction = offsetTop < scrollTarget.scrollTop ? "decrease" : "increase";
                scrollTarget.scrollTop = offsetTop;
                emit("virtualScroll", {
                    index: toIndex,
                    from: 0,
                    to: innerPagination.value.rowsPerPage - 1,
                    direction
                });
            }
        }
        function onVScroll(info) {
            emit("virtualScroll", info);
        }
        function getProgress() {
            return [
                (0, _vue.h)(QLinearProgress_default, {
                    class: "q-table__linear-progress",
                    color: props.color,
                    dark: isDark.value,
                    indeterminate: true,
                    trackColor: "transparent"
                })
            ];
        }
        function getTBodyTR(row, bodySlot, pageIndex) {
            const key = getRowKey.value(row), selected = isRowSelected(key);
            if (bodySlot !== void 0) {
                const cfg = {
                    key,
                    row,
                    pageIndex,
                    __trClass: selected ? "selected" : ""
                };
                if (props.tableRowStyleFn !== void 0) cfg.__trStyle = props.tableRowStyleFn(row);
                if (props.tableRowClassFn !== void 0) {
                    const cls = props.tableRowClassFn(row);
                    if (cls) cfg.__trClass = `${cls} ${cfg.__trClass}`;
                }
                return bodySlot(getBodyScope(cfg));
            }
            const bodyCell = slots["body-cell"], child = computedCols.value.map((col)=>{
                const bodyCellCol = slots[`body-cell-${col.name}`], slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;
                return slot !== void 0 ? slot(getBodyCellScope({
                    key,
                    row,
                    pageIndex,
                    col
                })) : (0, _vue.h)("td", {
                    class: col.__tdClass(row),
                    style: col.__tdStyle(row)
                }, getCellValue(col, row));
            });
            if (hasSelectionMode.value === true) {
                const slot = slots["body-selection"];
                const content = slot !== void 0 ? slot(getBodySelectionScope({
                    key,
                    row,
                    pageIndex
                })) : [
                    (0, _vue.h)(QCheckbox_default, {
                        modelValue: selected,
                        color: props.color,
                        dark: isDark.value,
                        dense: props.dense,
                        "onUpdate:modelValue": (adding, evt)=>{
                            updateSelection([
                                key
                            ], [
                                row
                            ], adding, evt);
                        }
                    })
                ];
                child.unshift((0, _vue.h)("td", {
                    class: "q-table--col-auto-width"
                }, content));
            }
            const data = {
                key,
                class: {
                    selected
                }
            };
            if (props.onRowClick !== void 0) {
                data.class["cursor-pointer"] = true;
                data.onClick = (evt)=>{
                    emit("rowClick", evt, row, pageIndex);
                };
            }
            if (props.onRowDblclick !== void 0) {
                data.class["cursor-pointer"] = true;
                data.onDblclick = (evt)=>{
                    emit("rowDblclick", evt, row, pageIndex);
                };
            }
            if (props.onRowContextmenu !== void 0) {
                data.class["cursor-pointer"] = true;
                data.onContextmenu = (evt)=>{
                    emit("rowContextmenu", evt, row, pageIndex);
                };
            }
            if (props.tableRowStyleFn !== void 0) data.style = props.tableRowStyleFn(row);
            if (props.tableRowClassFn !== void 0) {
                const cls = props.tableRowClassFn(row);
                if (cls) data.class[cls] = true;
            }
            return (0, _vue.h)("tr", data, child);
        }
        function getTBody() {
            const body = slots.body, topRow = slots["top-row"], bottomRow = slots["bottom-row"];
            let child = computedRows.value.map((row, pageIndex)=>getTBodyTR(row, body, pageIndex));
            if (topRow !== void 0) child = topRow({
                cols: computedCols.value
            }).concat(child);
            if (bottomRow !== void 0) child = child.concat(bottomRow({
                cols: computedCols.value
            }));
            return (0, _vue.h)("tbody", child);
        }
        function getBodyScope(data) {
            injectBodyCommonScope(data);
            data.cols = data.cols.map((col)=>injectProp({
                    ...col
                }, "value", ()=>getCellValue(col, data.row)));
            return data;
        }
        function getBodyCellScope(data) {
            injectBodyCommonScope(data);
            injectProp(data, "value", ()=>getCellValue(data.col, data.row));
            return data;
        }
        function getBodySelectionScope(data) {
            injectBodyCommonScope(data);
            return data;
        }
        function injectBodyCommonScope(data) {
            Object.assign(data, {
                cols: computedCols.value,
                colsMap: computedColsMap.value,
                sort,
                rowIndex: firstRowIndex.value + data.pageIndex,
                color: props.color,
                dark: isDark.value,
                dense: props.dense
            });
            if (hasSelectionMode.value === true) injectProp(data, "selected", ()=>isRowSelected(data.key), (adding, evt)=>{
                updateSelection([
                    data.key
                ], [
                    data.row
                ], adding, evt);
            });
            injectProp(data, "expand", ()=>isRowExpanded(data.key), (adding)=>{
                updateExpanded(data.key, adding);
            });
        }
        function getCellValue(col, row) {
            const val = typeof col.field === "function" ? col.field(row) : row[col.field];
            return col.format !== void 0 ? col.format(val, row) : val;
        }
        const marginalsScope = (0, _vue.computed)(()=>({
                pagination: computedPagination.value,
                pagesNumber: pagesNumber.value,
                isFirstPage: isFirstPage.value,
                isLastPage: isLastPage.value,
                firstPage,
                prevPage,
                nextPage,
                lastPage,
                inFullscreen: inFullscreen.value,
                toggleFullscreen
            }));
        function getTopDiv() {
            const top = slots.top, topLeft = slots["top-left"], topRight = slots["top-right"], topSelection = slots["top-selection"], hasSelection = hasSelectionMode.value === true && topSelection !== void 0 && rowsSelectedNumber.value > 0, topClass = "q-table__top relative-position row items-center";
            if (top !== void 0) return (0, _vue.h)("div", {
                class: topClass
            }, [
                top(marginalsScope.value)
            ]);
            let child;
            if (hasSelection === true) child = topSelection(marginalsScope.value).slice();
            else {
                child = [];
                if (topLeft !== void 0) child.push((0, _vue.h)("div", {
                    class: "q-table__control"
                }, [
                    topLeft(marginalsScope.value)
                ]));
                else if (props.title) child.push((0, _vue.h)("div", {
                    class: "q-table__control"
                }, [
                    (0, _vue.h)("div", {
                        class: [
                            "q-table__title",
                            props.titleClass
                        ]
                    }, props.title)
                ]));
            }
            if (topRight !== void 0) {
                child.push((0, _vue.h)("div", {
                    class: "q-table__separator col"
                }));
                child.push((0, _vue.h)("div", {
                    class: "q-table__control"
                }, [
                    topRight(marginalsScope.value)
                ]));
            }
            if (child.length === 0) return;
            return (0, _vue.h)("div", {
                class: topClass
            }, child);
        }
        const headerSelectedValue = (0, _vue.computed)(()=>someRowsSelected.value === true ? null : allRowsSelected.value);
        function getTHead() {
            const child = getTHeadTR();
            if (props.loading === true && slots.loading === void 0) child.push((0, _vue.h)("tr", {
                class: "q-table__progress"
            }, [
                (0, _vue.h)("th", {
                    class: "relative-position",
                    colspan: computedColspan.value
                }, getProgress())
            ]));
            return (0, _vue.h)("thead", child);
        }
        function getTHeadTR() {
            const header = slots.header, headerCell = slots["header-cell"];
            if (header !== void 0) return header(getHeaderScope({
                header: true
            })).slice();
            const child = computedCols.value.map((col)=>{
                const headerCellCol = slots[`header-cell-${col.name}`], slot = headerCellCol !== void 0 ? headerCellCol : headerCell, slotProps = getHeaderScope({
                    col
                });
                return slot !== void 0 ? slot(slotProps) : (0, _vue.h)(QTh_default, {
                    key: col.name,
                    props: slotProps
                }, ()=>col.label);
            });
            if (singleSelection.value === true && props.grid !== true) child.unshift((0, _vue.h)("th", {
                class: "q-table--col-auto-width"
            }, " "));
            else if (multipleSelection.value === true) {
                const slot = slots["header-selection"];
                const content = slot !== void 0 ? slot(getHeaderScope({})) : [
                    (0, _vue.h)(QCheckbox_default, {
                        color: props.color,
                        modelValue: headerSelectedValue.value,
                        dark: isDark.value,
                        dense: props.dense,
                        "onUpdate:modelValue": onMultipleSelectionSet
                    })
                ];
                child.unshift((0, _vue.h)("th", {
                    class: "q-table--col-auto-width"
                }, content));
            }
            return [
                (0, _vue.h)("tr", {
                    class: props.tableHeaderClass,
                    style: props.tableHeaderStyle
                }, child)
            ];
        }
        function getHeaderScope(data) {
            Object.assign(data, {
                cols: computedCols.value,
                sort,
                colsMap: computedColsMap.value,
                color: props.color,
                dark: isDark.value,
                dense: props.dense
            });
            if (multipleSelection.value === true) injectProp(data, "selected", ()=>headerSelectedValue.value, onMultipleSelectionSet);
            return data;
        }
        function onMultipleSelectionSet(val) {
            if (someRowsSelected.value === true) val = false;
            updateSelection(computedRows.value.map(getRowKey.value), computedRows.value, val);
        }
        const navIcon = (0, _vue.computed)(()=>{
            const ico = [
                props.iconFirstPage || $q.iconSet.table.firstPage,
                props.iconPrevPage || $q.iconSet.table.prevPage,
                props.iconNextPage || $q.iconSet.table.nextPage,
                props.iconLastPage || $q.iconSet.table.lastPage
            ];
            return $q.lang.rtl === true ? ico.reverse() : ico;
        });
        function getBottomDiv() {
            if (props.hideBottom === true) return;
            if (nothingToDisplay.value === true) {
                if (props.hideNoData === true) return;
                const message = props.loading === true ? props.loadingLabel || $q.lang.table.loading : props.filter ? props.noResultsLabel || $q.lang.table.noResults : props.noDataLabel || $q.lang.table.noData;
                const noData = slots["no-data"];
                const children = noData !== void 0 ? [
                    noData({
                        message,
                        icon: $q.iconSet.table.warning,
                        filter: props.filter
                    })
                ] : [
                    (0, _vue.h)(QIcon_default, {
                        class: "q-table__bottom-nodata-icon",
                        name: $q.iconSet.table.warning
                    }),
                    message
                ];
                return (0, _vue.h)("div", {
                    class: bottomClass + " q-table__bottom--nodata"
                }, children);
            }
            const bottom = slots.bottom;
            if (bottom !== void 0) return (0, _vue.h)("div", {
                class: bottomClass
            }, [
                bottom(marginalsScope.value)
            ]);
            const child = props.hideSelectedBanner !== true && hasSelectionMode.value === true && rowsSelectedNumber.value > 0 ? [
                (0, _vue.h)("div", {
                    class: "q-table__control"
                }, [
                    (0, _vue.h)("div", [
                        (props.selectedRowsLabel || $q.lang.table.selectedRecords)(rowsSelectedNumber.value)
                    ])
                ])
            ] : [];
            if (props.hidePagination !== true) return (0, _vue.h)("div", {
                class: bottomClass + " justify-end"
            }, getPaginationDiv(child));
            if (child.length !== 0) return (0, _vue.h)("div", {
                class: bottomClass
            }, child);
        }
        function onPagSelection(pag) {
            setPagination({
                page: 1,
                rowsPerPage: pag.value
            });
        }
        function getPaginationDiv(child) {
            let control;
            const { rowsPerPage } = computedPagination.value, paginationLabel = props.paginationLabel || $q.lang.table.pagination, paginationSlot = slots.pagination, hasOpts = props.rowsPerPageOptions.length > 1;
            child.push((0, _vue.h)("div", {
                class: "q-table__separator col"
            }));
            if (hasOpts === true) child.push((0, _vue.h)("div", {
                class: "q-table__control"
            }, [
                (0, _vue.h)("span", {
                    class: "q-table__bottom-item"
                }, [
                    props.rowsPerPageLabel || $q.lang.table.recordsPerPage
                ]),
                (0, _vue.h)(QSelect_default, {
                    class: "q-table__select inline q-table__bottom-item",
                    color: props.color,
                    modelValue: rowsPerPage,
                    options: computedRowsPerPageOptions.value,
                    displayValue: rowsPerPage === 0 ? $q.lang.table.allRows : rowsPerPage,
                    dark: isDark.value,
                    borderless: true,
                    dense: true,
                    optionsDense: true,
                    optionsCover: true,
                    "onUpdate:modelValue": onPagSelection
                })
            ]));
            if (paginationSlot !== void 0) control = paginationSlot(marginalsScope.value);
            else {
                control = [
                    (0, _vue.h)("span", rowsPerPage !== 0 ? {
                        class: "q-table__bottom-item"
                    } : {}, [
                        rowsPerPage ? paginationLabel(firstRowIndex.value + 1, Math.min(lastRowIndex.value, computedRowsNumber.value), computedRowsNumber.value) : paginationLabel(1, filteredSortedRowsNumber.value, computedRowsNumber.value)
                    ])
                ];
                if (rowsPerPage !== 0 && pagesNumber.value > 1) {
                    const btnProps = {
                        color: props.color,
                        round: true,
                        dense: true,
                        flat: true
                    };
                    if (props.dense === true) btnProps.size = "sm";
                    if (pagesNumber.value > 2) control.push((0, _vue.h)(QBtn_default, {
                        key: "pgFirst",
                        ...btnProps,
                        icon: navIcon.value[0],
                        disable: isFirstPage.value,
                        "aria-label": $q.lang.pagination.first,
                        onClick: firstPage
                    }));
                    control.push((0, _vue.h)(QBtn_default, {
                        key: "pgPrev",
                        ...btnProps,
                        icon: navIcon.value[1],
                        disable: isFirstPage.value,
                        "aria-label": $q.lang.pagination.prev,
                        onClick: prevPage
                    }), (0, _vue.h)(QBtn_default, {
                        key: "pgNext",
                        ...btnProps,
                        icon: navIcon.value[2],
                        disable: isLastPage.value,
                        "aria-label": $q.lang.pagination.next,
                        onClick: nextPage
                    }));
                    if (pagesNumber.value > 2) control.push((0, _vue.h)(QBtn_default, {
                        key: "pgLast",
                        ...btnProps,
                        icon: navIcon.value[3],
                        disable: isLastPage.value,
                        "aria-label": $q.lang.pagination.last,
                        onClick: lastPage
                    }));
                }
            }
            child.push((0, _vue.h)("div", {
                class: "q-table__control"
            }, control));
            return child;
        }
        function getGridHeader() {
            return (0, _vue.h)("div", {
                class: "q-table__middle"
            }, props.gridHeader === true ? [
                (0, _vue.h)("table", {
                    class: "q-table"
                }, [
                    getTHead((0, _vue.h))
                ])
            ] : props.loading === true && slots.loading === void 0 ? getProgress((0, _vue.h)) : void 0);
        }
        function getGridBody() {
            const item = slots.item !== void 0 ? slots.item : (scope)=>{
                const child = scope.cols.map((col)=>(0, _vue.h)("div", {
                        class: "q-table__grid-item-row"
                    }, [
                        (0, _vue.h)("div", {
                            class: "q-table__grid-item-title"
                        }, [
                            col.label
                        ]),
                        (0, _vue.h)("div", {
                            class: "q-table__grid-item-value"
                        }, [
                            col.value
                        ])
                    ]));
                if (hasSelectionMode.value === true) {
                    const slot = slots["body-selection"];
                    const content = slot !== void 0 ? slot(scope) : [
                        (0, _vue.h)(QCheckbox_default, {
                            modelValue: scope.selected,
                            color: props.color,
                            dark: isDark.value,
                            dense: props.dense,
                            "onUpdate:modelValue": (adding, evt)=>{
                                updateSelection([
                                    scope.key
                                ], [
                                    scope.row
                                ], adding, evt);
                            }
                        })
                    ];
                    child.unshift((0, _vue.h)("div", {
                        class: "q-table__grid-item-row"
                    }, content), (0, _vue.h)(QSeparator_default, {
                        dark: isDark.value
                    }));
                }
                const data = {
                    class: [
                        "q-table__grid-item-card" + cardDefaultClass.value,
                        props.cardClass
                    ],
                    style: props.cardStyle
                };
                if (props.cardStyleFn !== void 0) data.style = [
                    data.style,
                    props.cardStyleFn(scope.row)
                ];
                if (props.cardClassFn !== void 0) {
                    const cls = props.cardClassFn(scope.row);
                    if (cls) data.class[0] += ` ${cls}`;
                }
                if (props.onRowClick !== void 0 || props.onRowDblclick !== void 0 || props.onRowContextmenu !== void 0) {
                    data.class[0] += " cursor-pointer";
                    if (props.onRowClick !== void 0) data.onClick = (evt)=>{
                        emit("RowClick", evt, scope.row, scope.pageIndex);
                    };
                    if (props.onRowDblclick !== void 0) data.onDblclick = (evt)=>{
                        emit("RowDblclick", evt, scope.row, scope.pageIndex);
                    };
                    if (props.onRowContextmenu !== void 0) data.onContextmenu = (evt)=>{
                        emit("rowContextmenu", evt, scope.row, scope.pageIndex);
                    };
                }
                return (0, _vue.h)("div", {
                    class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (scope.selected === true ? " q-table__grid-item--selected" : "")
                }, [
                    (0, _vue.h)("div", data, child)
                ]);
            };
            return (0, _vue.h)("div", {
                class: [
                    "q-table__grid-content row",
                    props.cardContainerClass
                ],
                style: props.cardContainerStyle
            }, computedRows.value.map((row, pageIndex)=>item(getBodyScope({
                    key: getRowKey.value(row),
                    row,
                    pageIndex
                }))));
        }
        Object.assign(vm.proxy, {
            requestServerInteraction,
            setPagination,
            firstPage,
            prevPage,
            nextPage,
            lastPage,
            isRowSelected,
            clearSelection,
            isRowExpanded,
            setExpanded,
            sort,
            resetVirtualScroll,
            scrollTo,
            getCellValue
        });
        injectMultipleProps(vm.proxy, {
            filteredSortedRows: ()=>filteredSortedRows.value,
            computedRows: ()=>computedRows.value,
            computedRowsNumber: ()=>computedRowsNumber.value
        });
        return ()=>{
            const child = [
                getTopDiv()
            ];
            const data = {
                ref: rootRef,
                class: rootContainerClass.value
            };
            if (props.grid === true) child.push(getGridHeader());
            else Object.assign(data, {
                class: [
                    data.class,
                    props.cardClass
                ],
                style: props.cardStyle
            });
            child.push(getBody(), getBottomDiv());
            if (props.loading === true && slots.loading !== void 0) child.push(slots.loading());
            return (0, _vue.h)("div", data, child);
        };
    }
});
//#endregion
//#region src/components/table/QTr.js
var QTr_default = createComponent({
    name: "QTr",
    props: {
        props: Object,
        noHover: Boolean
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>"q-tr" + (props.props === void 0 || props.props.header === true ? "" : " " + props.props.__trClass) + (props.noHover === true ? " q-tr--no-hover" : ""));
        return ()=>(0, _vue.h)("tr", {
                style: props.props?.__trStyle,
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/table/QTd.js
var QTd_default = createComponent({
    name: "QTd",
    props: {
        props: Object,
        autoWidth: Boolean,
        noHover: Boolean
    },
    setup (props, { slots }) {
        const vm = (0, _vue.getCurrentInstance)();
        const classes = (0, _vue.computed)(()=>"q-td" + (props.autoWidth === true ? " q-table--col-auto-width" : "") + (props.noHover === true ? " q-td--no-hover" : "") + " ");
        return ()=>{
            if (props.props === void 0) return (0, _vue.h)("td", {
                class: classes.value
            }, hSlot(slots.default));
            const name = vm.vnode.key;
            const col = (props.props.colsMap !== void 0 ? props.props.colsMap[name] : null) || props.props.col;
            if (col === void 0) return;
            const { row } = props.props;
            return (0, _vue.h)("td", {
                class: classes.value + col.__tdClass(row),
                style: col.__tdStyle(row)
            }, hSlot(slots.default));
        };
    }
});
//#endregion
//#region src/components/tabs/QRouteTab.js
var QRouteTab_default = createComponent({
    name: "QRouteTab",
    props: {
        ...useRouterLinkProps,
        ...useTabProps
    },
    emits: useTabEmits,
    setup (props, { slots, emit }) {
        const routeData = useRouterLink({
            useDisableForRouterLinkProps: false
        });
        const { renderTab, $tabs } = useTab(props, slots, emit, {
            exact: (0, _vue.computed)(()=>props.exact),
            ...routeData
        });
        (0, _vue.watch)(()=>`${props.name} | ${props.exact} | ${(routeData.resolvedLink.value || {}).href}`, $tabs.verifyRouteModel);
        return ()=>renderTab(routeData.linkTag.value, routeData.linkAttrs.value);
    }
});
//#endregion
//#region src/components/time/QTime.js
function getViewByModel(model, withSeconds) {
    if (model.hour !== null) {
        if (model.minute === null) return "minute";
        else if (withSeconds === true && model.second === null) return "second";
    }
    return "hour";
}
function getCurrentTime() {
    const d = /* @__PURE__ */ new Date();
    return {
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds(),
        millisecond: d.getMilliseconds()
    };
}
var QTime_default = createComponent({
    name: "QTime",
    props: {
        ...useDarkProps,
        ...useFormProps,
        ...useDatetimeProps,
        modelValue: {
            required: true,
            validator: (val)=>typeof val === "string" || val === null
        },
        mask: {
            ...useDatetimeProps.mask,
            default: null
        },
        format24h: {
            type: Boolean,
            default: null
        },
        defaultDate: {
            type: String,
            validator: (v)=>/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v)
        },
        options: Function,
        hourOptions: Array,
        minuteOptions: Array,
        secondOptions: Array,
        withSeconds: Boolean,
        nowBtn: Boolean
    },
    emits: useDatetimeEmits,
    setup (props, { slots, emit }) {
        const vm = (0, _vue.getCurrentInstance)();
        const { $q } = vm.proxy;
        const isDark = useDark(props, $q);
        const { tabindex, headerClass, getLocale, getCurrentDate } = useDatetime(props, $q);
        const injectFormInput = useFormInject(useFormAttrs(props));
        let draggingClockRect, dragCache;
        const clockRef = (0, _vue.ref)(null);
        const mask = (0, _vue.computed)(()=>getMask());
        const locale = (0, _vue.computed)(()=>getLocale());
        const defaultDateModel = (0, _vue.computed)(()=>getDefaultDateModel());
        const model = __splitDate(props.modelValue, mask.value, locale.value, props.calendar, defaultDateModel.value);
        const view = (0, _vue.ref)(getViewByModel(model));
        const innerModel = (0, _vue.ref)(model);
        const isAM = (0, _vue.ref)(model.hour === null || model.hour < 12);
        const classes = (0, _vue.computed)(()=>`q-time q-time--${props.landscape === true ? "landscape" : "portrait"}` + (isDark.value === true ? " q-time--dark q-dark" : "") + (props.disable === true ? " disabled" : props.readonly === true ? " q-time--readonly" : "") + (props.bordered === true ? " q-time--bordered" : "") + (props.square === true ? " q-time--square no-border-radius" : "") + (props.flat === true ? " q-time--flat no-shadow" : ""));
        const stringModel = (0, _vue.computed)(()=>{
            const time = innerModel.value;
            return {
                hour: time.hour === null ? "--" : computedFormat24h.value === true ? pad(time.hour) : String(isAM.value === true ? time.hour === 0 ? 12 : time.hour : time.hour > 12 ? time.hour - 12 : time.hour),
                minute: time.minute === null ? "--" : pad(time.minute),
                second: time.second === null ? "--" : pad(time.second)
            };
        });
        const computedFormat24h = (0, _vue.computed)(()=>props.format24h !== null ? props.format24h : $q.lang.date.format24h);
        const pointerStyle = (0, _vue.computed)(()=>{
            const forHour = view.value === "hour", divider = forHour === true ? 12 : 60, amount = innerModel.value[view.value];
            let transform = `rotate(${Math.round(amount * (360 / divider)) - 180}deg) translateX(-50%)`;
            if (forHour === true && computedFormat24h.value === true && innerModel.value.hour >= 12) transform += " scale(.7)";
            return {
                transform
            };
        });
        const minLink = (0, _vue.computed)(()=>innerModel.value.hour !== null);
        const secLink = (0, _vue.computed)(()=>minLink.value === true && innerModel.value.minute !== null);
        const hourInSelection = (0, _vue.computed)(()=>props.hourOptions !== void 0 ? (val)=>props.hourOptions.includes(val) : props.options !== void 0 ? (val)=>props.options(val, null, null) : null);
        const minuteInSelection = (0, _vue.computed)(()=>props.minuteOptions !== void 0 ? (val)=>props.minuteOptions.includes(val) : props.options !== void 0 ? (val)=>props.options(innerModel.value.hour, val, null) : null);
        const secondInSelection = (0, _vue.computed)(()=>props.secondOptions !== void 0 ? (val)=>props.secondOptions.includes(val) : props.options !== void 0 ? (val)=>props.options(innerModel.value.hour, innerModel.value.minute, val) : null);
        const validHours = (0, _vue.computed)(()=>{
            if (hourInSelection.value === null) return null;
            const am = getValidValues(0, 11, hourInSelection.value);
            const pm = getValidValues(12, 11, hourInSelection.value);
            return {
                am,
                pm,
                values: am.values.concat(pm.values)
            };
        });
        const validMinutes = (0, _vue.computed)(()=>minuteInSelection.value !== null ? getValidValues(0, 59, minuteInSelection.value) : null);
        const validSeconds = (0, _vue.computed)(()=>secondInSelection.value !== null ? getValidValues(0, 59, secondInSelection.value) : null);
        const viewValidOptions = (0, _vue.computed)(()=>{
            switch(view.value){
                case "hour":
                    return validHours.value;
                case "minute":
                    return validMinutes.value;
                case "second":
                    return validSeconds.value;
            }
        });
        const positions = (0, _vue.computed)(()=>{
            let start, end, offset = 0, step = 1;
            const values = viewValidOptions.value !== null ? viewValidOptions.value.values : void 0;
            if (view.value === "hour") {
                if (computedFormat24h.value === true) {
                    start = 0;
                    end = 23;
                } else {
                    start = 0;
                    end = 11;
                    if (isAM.value === false) offset = 12;
                }
            } else {
                start = 0;
                end = 55;
                step = 5;
            }
            const pos = [];
            for(let val = start, index = start; val <= end; val += step, index++){
                const actualVal = val + offset, disable = values?.includes(actualVal) === false, label = view.value === "hour" && val === 0 ? computedFormat24h.value === true ? "00" : "12" : val;
                pos.push({
                    val: actualVal,
                    index,
                    disable,
                    label
                });
            }
            return pos;
        });
        const clockDirectives = (0, _vue.computed)(()=>[
                [
                    TouchPan_default,
                    onPan,
                    void 0,
                    {
                        stop: true,
                        prevent: true,
                        mouse: true
                    }
                ]
            ]);
        (0, _vue.watch)(()=>props.modelValue, (v)=>{
            const val = __splitDate(v, mask.value, locale.value, props.calendar, defaultDateModel.value);
            if (val.dateHash !== innerModel.value.dateHash || val.timeHash !== innerModel.value.timeHash) {
                innerModel.value = val;
                if (val.hour === null) view.value = "hour";
                else isAM.value = val.hour < 12;
            }
        });
        (0, _vue.watch)([
            mask,
            locale
        ], ()=>{
            (0, _vue.nextTick)(()=>{
                updateValue();
            });
        });
        function setNow() {
            const date = {
                ...getCurrentDate(),
                ...getCurrentTime()
            };
            updateValue(date);
            Object.assign(innerModel.value, date);
            view.value = "hour";
        }
        function getValidValues(start, count, testFn) {
            const values = Array.apply(null, {
                length: count + 1
            }).map((_, index)=>{
                const i = index + start;
                return {
                    index: i,
                    val: testFn(i) === true
                };
            }).filter((v)=>v.val === true).map((v)=>v.index);
            return {
                min: values[0],
                max: values[values.length - 1],
                values,
                threshold: count + 1
            };
        }
        function getWheelDist(a, b, threshold) {
            const diff = Math.abs(a - b);
            return Math.min(diff, threshold - diff);
        }
        function getNormalizedClockValue(val, { min, max, values, threshold }) {
            if (val === min) return min;
            if (val < min || val > max) return getWheelDist(val, min, threshold) <= getWheelDist(val, max, threshold) ? min : max;
            const index = values.findIndex((v)=>val <= v), before = values[index - 1], after = values[index];
            return val - before <= after - val ? before : after;
        }
        function getMask() {
            return props.calendar !== "persian" && props.mask !== null ? props.mask : `HH:mm${props.withSeconds === true ? ":ss" : ""}`;
        }
        function getDefaultDateModel() {
            if (typeof props.defaultDate !== "string") {
                const date = getCurrentDate(true);
                date.dateHash = getDayHash(date);
                return date;
            }
            return __splitDate(props.defaultDate, "YYYY/MM/DD", void 0, props.calendar);
        }
        function shouldAbortInteraction() {
            return vmIsDestroyed(vm) === true || viewValidOptions.value !== null && (viewValidOptions.value.values.length === 0 || view.value === "hour" && computedFormat24h.value !== true && validHours.value[isAM.value === true ? "am" : "pm"].values.length === 0);
        }
        function getClockRect() {
            const { top, left, width } = clockRef.value.getBoundingClientRect(), dist = width / 2;
            return {
                top: top + dist,
                left: left + dist,
                dist: dist * .7
            };
        }
        function onPan(event) {
            if (shouldAbortInteraction() === true) return;
            if (event.isFirst === true) {
                draggingClockRect = getClockRect();
                dragCache = updateClock(event.evt, draggingClockRect);
                return;
            }
            dragCache = updateClock(event.evt, draggingClockRect, dragCache);
            if (event.isFinal === true) {
                draggingClockRect = false;
                dragCache = null;
                goToNextView();
            }
        }
        function goToNextView() {
            if (view.value === "hour") view.value = "minute";
            else if (props.withSeconds && view.value === "minute") view.value = "second";
        }
        function updateClock(evt, clockRect, cacheVal) {
            const pos = position(evt), height = Math.abs(pos.top - clockRect.top), distance = Math.sqrt(Math.abs(pos.top - clockRect.top) ** 2 + Math.abs(pos.left - clockRect.left) ** 2);
            let val, angle = Math.asin(height / distance) * (180 / Math.PI);
            if (pos.top < clockRect.top) angle = clockRect.left < pos.left ? 90 - angle : 270 + angle;
            else angle = clockRect.left < pos.left ? angle + 90 : 270 - angle;
            if (view.value === "hour") {
                val = angle / 30;
                if (validHours.value !== null) {
                    const am = computedFormat24h.value !== true ? isAM.value === true : validHours.value.am.values.length !== 0 && validHours.value.pm.values.length !== 0 ? distance >= clockRect.dist : validHours.value.am.values.length !== 0;
                    val = getNormalizedClockValue(val + (am === true ? 0 : 12), validHours.value[am === true ? "am" : "pm"]);
                } else {
                    val = Math.round(val);
                    if (computedFormat24h.value === true) {
                        if (distance < clockRect.dist) {
                            if (val < 12) val += 12;
                        } else if (val === 12) val = 0;
                    } else if (isAM.value === true && val === 12) val = 0;
                    else if (isAM.value === false && val !== 12) val += 12;
                }
                if (computedFormat24h.value === true) isAM.value = val < 12;
            } else {
                val = Math.round(angle / 6) % 60;
                if (view.value === "minute" && validMinutes.value !== null) val = getNormalizedClockValue(val, validMinutes.value);
                else if (view.value === "second" && validSeconds.value !== null) val = getNormalizedClockValue(val, validSeconds.value);
            }
            if (cacheVal !== val) setModel[view.value](val);
            return val;
        }
        const setView = {
            hour () {
                view.value = "hour";
            },
            minute () {
                view.value = "minute";
            },
            second () {
                view.value = "second";
            }
        };
        function setAmOnKey(e) {
            if (e.keyCode === 13) setAm();
        }
        function setPmOnKey(e) {
            if (e.keyCode === 13) setPm();
        }
        function onClick(evt) {
            if (shouldAbortInteraction() !== true) {
                if ($q.platform.is.desktop !== true) updateClock(evt, getClockRect());
                goToNextView();
            }
        }
        function onMousedown(evt) {
            if (shouldAbortInteraction() !== true) updateClock(evt, getClockRect());
        }
        function onKeyupHour(e) {
            if (e.keyCode === 13) view.value = "hour";
            else if ([
                37,
                39
            ].includes(e.keyCode)) {
                const payload = e.keyCode === 37 ? -1 : 1;
                if (validHours.value !== null) {
                    const values = computedFormat24h.value === true ? validHours.value.values : validHours.value[isAM.value === true ? "am" : "pm"].values;
                    if (values.length === 0) return;
                    if (innerModel.value.hour === null) setHour(values[0]);
                    else setHour(values[(values.length + values.indexOf(innerModel.value.hour) + payload) % values.length]);
                } else {
                    const wrap = computedFormat24h.value === true ? 24 : 12;
                    setHour((computedFormat24h.value !== true && isAM.value === false ? 12 : 0) + (24 + (innerModel.value.hour === null ? -payload : innerModel.value.hour) + payload) % wrap);
                }
            }
        }
        function onKeyupMinute(e) {
            if (e.keyCode === 13) view.value = "minute";
            else if ([
                37,
                39
            ].includes(e.keyCode)) {
                const payload = e.keyCode === 37 ? -1 : 1;
                if (validMinutes.value !== null) {
                    const values = validMinutes.value.values;
                    if (values.length === 0) return;
                    if (innerModel.value.minute === null) setMinute(values[0]);
                    else setMinute(values[(values.length + values.indexOf(innerModel.value.minute) + payload) % values.length]);
                } else setMinute((60 + (innerModel.value.minute === null ? -payload : innerModel.value.minute) + payload) % 60);
            }
        }
        function onKeyupSecond(e) {
            if (e.keyCode === 13) view.value = "second";
            else if ([
                37,
                39
            ].includes(e.keyCode)) {
                const payload = e.keyCode === 37 ? -1 : 1;
                if (validSeconds.value !== null) {
                    const values = validSeconds.value.values;
                    if (values.length === 0) return;
                    if (innerModel.value.seconds === null) setSecond(values[0]);
                    else setSecond(values[(values.length + values.indexOf(innerModel.value.second) + payload) % values.length]);
                } else setSecond((60 + (innerModel.value.second === null ? -payload : innerModel.value.second) + payload) % 60);
            }
        }
        function setHour(hour) {
            if (innerModel.value.hour !== hour) {
                innerModel.value.hour = hour;
                verifyAndUpdate();
            }
        }
        function setMinute(minute) {
            if (innerModel.value.minute !== minute) {
                innerModel.value.minute = minute;
                verifyAndUpdate();
            }
        }
        function setSecond(second) {
            if (innerModel.value.second !== second) {
                innerModel.value.second = second;
                verifyAndUpdate();
            }
        }
        const setModel = {
            hour: setHour,
            minute: setMinute,
            second: setSecond
        };
        function setAm() {
            if (isAM.value === false) {
                isAM.value = true;
                if (innerModel.value.hour !== null) {
                    innerModel.value.hour -= 12;
                    verifyAndUpdate();
                }
            }
        }
        function setPm() {
            if (isAM.value === true) {
                isAM.value = false;
                if (innerModel.value.hour !== null) {
                    innerModel.value.hour += 12;
                    verifyAndUpdate();
                }
            }
        }
        function goToViewWhenHasModel(newView) {
            const val = props.modelValue;
            if (view.value !== newView && val !== void 0 && val !== null && val !== "" && typeof val !== "string") view.value = newView;
        }
        function verifyAndUpdate() {
            if (hourInSelection.value !== null && hourInSelection.value(innerModel.value.hour) !== true) {
                innerModel.value = __splitDate();
                goToViewWhenHasModel("hour");
                return;
            }
            if (minuteInSelection.value !== null && minuteInSelection.value(innerModel.value.minute) !== true) {
                innerModel.value.minute = null;
                innerModel.value.second = null;
                goToViewWhenHasModel("minute");
                return;
            }
            if (props.withSeconds === true && secondInSelection.value !== null && secondInSelection.value(innerModel.value.second) !== true) {
                innerModel.value.second = null;
                goToViewWhenHasModel("second");
                return;
            }
            if (innerModel.value.hour === null || innerModel.value.minute === null || props.withSeconds === true && innerModel.value.second === null) return;
            updateValue();
        }
        function updateValue(obj) {
            const date = Object.assign({
                ...innerModel.value
            }, obj);
            const val = props.calendar === "persian" ? pad(date.hour) + ":" + pad(date.minute) + (props.withSeconds === true ? ":" + pad(date.second) : "") : formatDate(new Date(date.year, date.month === null ? null : date.month - 1, date.day, date.hour, date.minute, date.second, date.millisecond), mask.value, locale.value, date.year, date.timezoneOffset);
            date.changed = val !== props.modelValue;
            emit("update:modelValue", val, date);
        }
        function getHeader() {
            const label = [
                (0, _vue.h)("div", {
                    class: "q-time__link " + (view.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: tabindex.value,
                    onClick: setView.hour,
                    onKeyup: onKeyupHour
                }, stringModel.value.hour),
                (0, _vue.h)("div", ":"),
                (0, _vue.h)("div", minLink.value === true ? {
                    class: "q-time__link " + (view.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: tabindex.value,
                    onKeyup: onKeyupMinute,
                    onClick: setView.minute
                } : {
                    class: "q-time__link"
                }, stringModel.value.minute)
            ];
            if (props.withSeconds === true) label.push((0, _vue.h)("div", ":"), (0, _vue.h)("div", secLink.value === true ? {
                class: "q-time__link " + (view.value === "second" ? "q-time__link--active" : "cursor-pointer"),
                tabindex: tabindex.value,
                onKeyup: onKeyupSecond,
                onClick: setView.second
            } : {
                class: "q-time__link"
            }, stringModel.value.second));
            const child = [
                (0, _vue.h)("div", {
                    class: "q-time__header-label row items-center no-wrap",
                    dir: "ltr"
                }, label)
            ];
            if (computedFormat24h.value === false) child.push((0, _vue.h)("div", {
                class: "q-time__header-ampm column items-between no-wrap"
            }, [
                (0, _vue.h)("div", {
                    class: "q-time__link " + (isAM.value === true ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: tabindex.value,
                    onClick: setAm,
                    onKeyup: setAmOnKey
                }, "AM"),
                (0, _vue.h)("div", {
                    class: "q-time__link " + (isAM.value !== true ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: tabindex.value,
                    onClick: setPm,
                    onKeyup: setPmOnKey
                }, "PM")
            ]));
            return (0, _vue.h)("div", {
                class: "q-time__header flex flex-center no-wrap " + headerClass.value
            }, child);
        }
        function getClock() {
            const current = innerModel.value[view.value];
            return (0, _vue.h)("div", {
                class: "q-time__content col relative-position"
            }, [
                (0, _vue.h)((0, _vue.Transition), {
                    name: "q-transition--scale"
                }, ()=>(0, _vue.h)("div", {
                        key: "clock" + view.value,
                        class: "q-time__container-parent absolute-full"
                    }, [
                        (0, _vue.h)("div", {
                            ref: clockRef,
                            class: "q-time__container-child fit overflow-hidden"
                        }, [
                            (0, _vue.withDirectives)((0, _vue.h)("div", {
                                class: "q-time__clock cursor-pointer non-selectable",
                                onClick,
                                onMousedown
                            }, [
                                (0, _vue.h)("div", {
                                    class: "q-time__clock-circle fit"
                                }, [
                                    (0, _vue.h)("div", {
                                        class: "q-time__clock-pointer" + (innerModel.value[view.value] === null ? " hidden" : props.color !== void 0 ? ` text-${props.color}` : ""),
                                        style: pointerStyle.value
                                    }),
                                    positions.value.map((pos)=>(0, _vue.h)("div", {
                                            class: `q-time__clock-position row flex-center q-time__clock-pos-${pos.index}` + (pos.val === current ? " q-time__clock-position--active " + headerClass.value : pos.disable === true ? " q-time__clock-position--disable" : "")
                                        }, [
                                            (0, _vue.h)("span", pos.label)
                                        ]))
                                ])
                            ]), clockDirectives.value)
                        ])
                    ])),
                props.nowBtn === true ? (0, _vue.h)(QBtn_default, {
                    class: "q-time__now-button absolute",
                    icon: $q.iconSet.datetime.now,
                    unelevated: true,
                    size: "sm",
                    round: true,
                    color: props.color,
                    textColor: props.textColor,
                    tabindex: tabindex.value,
                    onClick: setNow
                }) : null
            ]);
        }
        vm.proxy.setNow = setNow;
        return ()=>{
            const child = [
                getClock()
            ];
            const def = hSlot(slots.default);
            if (def !== void 0) child.push((0, _vue.h)("div", {
                class: "q-time__actions"
            }, def));
            if (props.name !== void 0 && props.disable !== true) injectFormInput(child, "push");
            return (0, _vue.h)("div", {
                class: classes.value,
                tabindex: -1
            }, [
                getHeader(),
                (0, _vue.h)("div", {
                    class: "q-time__main col overflow-auto"
                }, child)
            ]);
        };
    }
});
//#endregion
//#region src/components/timeline/QTimeline.js
var QTimeline_default = createComponent({
    name: "QTimeline",
    props: {
        ...useDarkProps,
        color: {
            type: String,
            default: "primary"
        },
        side: {
            type: String,
            default: "right",
            validator: (v)=>[
                    "left",
                    "right"
                ].includes(v)
        },
        layout: {
            type: String,
            default: "dense",
            validator: (v)=>[
                    "dense",
                    "comfortable",
                    "loose"
                ].includes(v)
        }
    },
    setup (props, { slots }) {
        const isDark = useDark(props, (0, _vue.getCurrentInstance)().proxy.$q);
        (0, _vue.provide)(timelineKey, props);
        const classes = (0, _vue.computed)(()=>`q-timeline q-timeline--${props.layout} q-timeline--${props.layout}--${props.side}` + (isDark.value === true ? " q-timeline--dark" : ""));
        return ()=>(0, _vue.h)("ul", {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/timeline/QTimelineEntry.js
var QTimelineEntry_default = createComponent({
    name: "QTimelineEntry",
    props: {
        heading: Boolean,
        tag: {
            type: String,
            default: "h3"
        },
        side: {
            type: String,
            default: "right",
            validator: (v)=>[
                    "left",
                    "right"
                ].includes(v)
        },
        icon: String,
        avatar: String,
        color: String,
        title: String,
        subtitle: String,
        body: String
    },
    setup (props, { slots }) {
        const $timeline = (0, _vue.inject)(timelineKey, emptyRenderFn);
        if ($timeline === emptyRenderFn) {
            console.error("QTimelineEntry needs to be child of QTimeline");
            return emptyRenderFn;
        }
        const classes = (0, _vue.computed)(()=>`q-timeline__entry q-timeline__entry--${props.side}` + (props.icon !== void 0 || props.avatar !== void 0 ? " q-timeline__entry--icon" : ""));
        const dotClass = (0, _vue.computed)(()=>`q-timeline__dot text-${props.color || $timeline.color}`);
        const reverse = (0, _vue.computed)(()=>$timeline.layout === "comfortable" && $timeline.side === "left");
        return ()=>{
            const child = hUniqueSlot(slots.default, []);
            if (props.body !== void 0) child.unshift(props.body);
            if (props.heading === true) {
                const content = [
                    (0, _vue.h)("div"),
                    (0, _vue.h)("div"),
                    (0, _vue.h)(props.tag, {
                        class: "q-timeline__heading-title"
                    }, child)
                ];
                return (0, _vue.h)("div", {
                    class: "q-timeline__heading"
                }, reverse.value === true ? content.reverse() : content);
            }
            let dot;
            if (props.icon !== void 0) dot = [
                (0, _vue.h)(QIcon_default, {
                    class: "row items-center justify-center",
                    name: props.icon
                })
            ];
            else if (props.avatar !== void 0) dot = [
                (0, _vue.h)("img", {
                    class: "q-timeline__dot-img",
                    src: props.avatar
                })
            ];
            const content = [
                (0, _vue.h)("div", {
                    class: "q-timeline__subtitle"
                }, [
                    (0, _vue.h)("span", {}, hSlot(slots.subtitle, [
                        props.subtitle
                    ]))
                ]),
                (0, _vue.h)("div", {
                    class: dotClass.value
                }, dot),
                (0, _vue.h)("div", {
                    class: "q-timeline__content"
                }, [
                    (0, _vue.h)("h6", {
                        class: "q-timeline__title"
                    }, hSlot(slots.title, [
                        props.title
                    ]))
                ].concat(child))
            ];
            return (0, _vue.h)("li", {
                class: classes.value
            }, reverse.value === true ? content.reverse() : content);
        };
    }
});
//#endregion
//#region src/components/toolbar/QToolbar.js
var QToolbar_default = createComponent({
    name: "QToolbar",
    props: {
        inset: Boolean
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>"q-toolbar row no-wrap items-center" + (props.inset === true ? " q-toolbar--inset" : ""));
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                role: "toolbar"
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/toolbar/QToolbarTitle.js
var QToolbarTitle_default = createComponent({
    name: "QToolbarTitle",
    props: {
        shrink: Boolean
    },
    setup (props, { slots }) {
        const classes = (0, _vue.computed)(()=>"q-toolbar__title ellipsis" + (props.shrink === true ? " col-shrink" : ""));
        return ()=>(0, _vue.h)("div", {
                class: classes.value
            }, hSlot(slots.default));
    }
});
//#endregion
//#region src/components/tree/QTree.js
const tickStrategyOptions = [
    "none",
    "strict",
    "leaf",
    "leaf-filtered"
];
var QTree_default = createComponent({
    name: "QTree",
    props: {
        ...useDarkProps,
        nodes: {
            type: Array,
            required: true
        },
        nodeKey: {
            type: String,
            required: true
        },
        labelKey: {
            type: String,
            default: "label"
        },
        childrenKey: {
            type: String,
            default: "children"
        },
        dense: Boolean,
        color: String,
        controlColor: String,
        textColor: String,
        selectedColor: String,
        icon: String,
        tickStrategy: {
            type: String,
            default: "none",
            validator: (v)=>tickStrategyOptions.includes(v)
        },
        ticked: Array,
        expanded: Array,
        selected: {},
        noSelectionUnset: Boolean,
        defaultExpandAll: Boolean,
        accordion: Boolean,
        filter: String,
        filterMethod: Function,
        duration: {},
        noConnectors: Boolean,
        noTransition: Boolean,
        noNodesLabel: String,
        noResultsLabel: String
    },
    emits: [
        "update:expanded",
        "update:ticked",
        "update:selected",
        "lazyLoad",
        "afterShow",
        "afterHide"
    ],
    setup (props, { slots, emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const lazy = (0, _vue.ref)({});
        const innerTicked = (0, _vue.ref)(props.ticked || []);
        const innerExpanded = (0, _vue.ref)(props.expanded || []);
        let blurTargets = {};
        (0, _vue.onBeforeUpdate)(()=>{
            blurTargets = {};
        });
        const classes = (0, _vue.computed)(()=>`q-tree q-tree--${props.dense === true ? "dense" : "standard"}` + (props.noConnectors === true ? " q-tree--no-connectors" : "") + (isDark.value === true ? " q-tree--dark" : "") + (props.color !== void 0 ? ` text-${props.color}` : ""));
        const hasSelection = (0, _vue.computed)(()=>props.selected !== void 0);
        const computedIcon = (0, _vue.computed)(()=>props.icon || $q.iconSet.tree.icon);
        const computedControlColor = (0, _vue.computed)(()=>props.controlColor || props.color);
        const textColorClass = (0, _vue.computed)(()=>props.textColor !== void 0 ? ` text-${props.textColor}` : "");
        const selectedColorClass = (0, _vue.computed)(()=>{
            const color = props.selectedColor || props.color;
            return color ? ` text-${color}` : "";
        });
        const computedFilterMethod = (0, _vue.computed)(()=>props.filterMethod !== void 0 ? props.filterMethod : (node, filter)=>{
                const filt = filter.toLowerCase();
                return node[props.labelKey] && node[props.labelKey].toLowerCase().indexOf(filt) !== -1;
            });
        const meta = (0, _vue.computed)(()=>{
            const acc = {};
            const travel = (node, parent)=>{
                const tickStrategy = node.tickStrategy || (parent ? parent.tickStrategy : props.tickStrategy);
                const key = node[props.nodeKey], isParent = node[props.childrenKey] && Array.isArray(node[props.childrenKey]) && node[props.childrenKey].length !== 0, selectable = node.disabled !== true && hasSelection.value === true && node.selectable !== false, expandable = node.disabled !== true && node.expandable !== false, hasTicking = tickStrategy !== "none", strictTicking = tickStrategy === "strict", leafFilteredTicking = tickStrategy === "leaf-filtered", leafTicking = tickStrategy === "leaf" || tickStrategy === "leaf-filtered";
                let tickable = node.disabled !== true && node.tickable !== false;
                if (leafTicking === true && tickable === true && parent && parent.tickable !== true) tickable = false;
                let localLazy = node.lazy;
                if (localLazy === true && lazy.value[key] !== void 0 && Array.isArray(node[props.childrenKey]) === true) localLazy = lazy.value[key];
                const m = {
                    key,
                    parent,
                    isParent,
                    lazy: localLazy,
                    disabled: node.disabled,
                    link: node.disabled !== true && (selectable === true || expandable === true && (isParent === true || localLazy === true)),
                    children: [],
                    matchesFilter: props.filter ? computedFilterMethod.value(node, props.filter) : true,
                    selected: key === props.selected && selectable === true,
                    selectable,
                    expanded: isParent === true ? innerExpanded.value.includes(key) : false,
                    expandable,
                    noTick: node.noTick === true || strictTicking !== true && localLazy && localLazy !== "loaded",
                    tickable,
                    tickStrategy,
                    hasTicking,
                    strictTicking,
                    leafFilteredTicking,
                    leafTicking,
                    ticked: strictTicking === true ? innerTicked.value.includes(key) : isParent === true ? false : innerTicked.value.includes(key)
                };
                acc[key] = m;
                if (isParent === true) {
                    m.children = node[props.childrenKey].map((n)=>travel(n, m));
                    if (props.filter) {
                        if (m.matchesFilter !== true) m.matchesFilter = m.children.some((n)=>n.matchesFilter);
                        else if (m.noTick !== true && m.disabled !== true && m.tickable === true && leafFilteredTicking === true && m.children.every((n)=>n.matchesFilter !== true || n.noTick === true || n.tickable !== true) === true) m.tickable = false;
                    }
                    if (m.matchesFilter === true) {
                        if (m.noTick !== true && strictTicking !== true && m.children.every((n)=>n.noTick) === true) m.noTick = true;
                        if (leafTicking) {
                            m.ticked = false;
                            m.indeterminate = m.children.some((entry)=>entry.indeterminate === true);
                            m.tickable = m.tickable === true && m.children.some((entry)=>entry.tickable);
                            if (m.indeterminate !== true) {
                                const sel = m.children.reduce((localAcc, entry)=>entry.ticked === true ? localAcc + 1 : localAcc, 0);
                                if (sel === m.children.length) m.ticked = true;
                                else if (sel > 0) m.indeterminate = true;
                            }
                            if (m.indeterminate === true) m.indeterminateNextState = m.children.every((entry)=>entry.tickable !== true || entry.ticked !== true);
                        }
                    }
                }
                return m;
            };
            props.nodes.forEach((node)=>travel(node, null));
            return acc;
        });
        (0, _vue.watch)(()=>props.ticked, (val)=>{
            innerTicked.value = val;
        });
        (0, _vue.watch)(()=>props.expanded, (val)=>{
            innerExpanded.value = val;
        });
        function getNodeByKey(key) {
            const reduce = [].reduce;
            const find = (result, node)=>{
                if (result || !node) return result;
                if (Array.isArray(node) === true) return reduce.call(Object(node), find, result);
                if (node[props.nodeKey] === key) return node;
                if (node[props.childrenKey]) return find(null, node[props.childrenKey]);
            };
            return find(null, props.nodes);
        }
        function getTickedNodes() {
            return innerTicked.value.map((key)=>getNodeByKey(key));
        }
        function getExpandedNodes() {
            return innerExpanded.value.map((key)=>getNodeByKey(key));
        }
        function isExpanded(key) {
            return key && meta.value[key] ? meta.value[key].expanded : false;
        }
        function collapseAll() {
            if (props.expanded !== void 0) emit("update:expanded", []);
            else innerExpanded.value = [];
        }
        function expandAll() {
            const expanded = [];
            const travel = (node)=>{
                if (node[props.childrenKey] && node[props.childrenKey].length !== 0) {
                    if (node.expandable !== false && node.disabled !== true) {
                        expanded.push(node[props.nodeKey]);
                        node[props.childrenKey].forEach(travel);
                    }
                }
            };
            props.nodes.forEach(travel);
            if (props.expanded !== void 0) emit("update:expanded", expanded);
            else innerExpanded.value = expanded;
        }
        function setExpanded(key, state, node = getNodeByKey(key), m = meta.value[key]) {
            if (m.lazy && m.lazy !== "loaded") {
                if (m.lazy === "loading") return;
                lazy.value[key] = "loading";
                if (Array.isArray(node[props.childrenKey]) !== true) node[props.childrenKey] = [];
                emit("lazyLoad", {
                    node,
                    key,
                    done: (children)=>{
                        lazy.value[key] = "loaded";
                        node[props.childrenKey] = Array.isArray(children) === true ? children : [];
                        (0, _vue.nextTick)(()=>{
                            if (meta.value[key]?.isParent === true) localSetExpanded(key, true);
                        });
                    },
                    fail: ()=>{
                        delete lazy.value[key];
                        if (node[props.childrenKey].length === 0) delete node[props.childrenKey];
                    }
                });
            } else if (m.isParent === true && m.expandable === true) localSetExpanded(key, state);
        }
        function localSetExpanded(key, state) {
            let target = innerExpanded.value;
            const shouldEmit = props.expanded !== void 0;
            if (shouldEmit === true) target = target.slice();
            if (state) {
                if (props.accordion) {
                    if (meta.value[key]) {
                        const collapse = [];
                        if (meta.value[key].parent) meta.value[key].parent.children.forEach((m)=>{
                            if (m.key !== key && m.expandable === true) collapse.push(m.key);
                        });
                        else props.nodes.forEach((node)=>{
                            const k = node[props.nodeKey];
                            if (k !== key) collapse.push(k);
                        });
                        if (collapse.length !== 0) target = target.filter((k)=>collapse.includes(k) === false);
                    }
                }
                target = target.concat([
                    key
                ]).filter((entryKey, index, self1)=>self1.indexOf(entryKey) === index);
            } else target = target.filter((k)=>k !== key);
            if (shouldEmit === true) emit("update:expanded", target);
            else innerExpanded.value = target;
        }
        function isTicked(key) {
            return key && meta.value[key] ? meta.value[key].ticked : false;
        }
        function setTicked(keys, state) {
            let target = innerTicked.value;
            const shouldEmit = props.ticked !== void 0;
            if (shouldEmit === true) target = target.slice();
            if (state) target = target.concat(keys).filter((key, index, self1)=>self1.indexOf(key) === index);
            else target = target.filter((k)=>keys.includes(k) === false);
            if (shouldEmit === true) emit("update:ticked", target);
        }
        function getSlotScope(node, localMeta, key) {
            const scope = {
                tree: proxy,
                node,
                key,
                color: props.color,
                dark: isDark.value
            };
            injectProp(scope, "expanded", ()=>localMeta.expanded, (val)=>{
                if (val !== localMeta.expanded) setExpanded(key, val);
            });
            injectProp(scope, "ticked", ()=>localMeta.ticked, (val)=>{
                if (val !== localMeta.ticked) setTicked([
                    key
                ], val);
            });
            return scope;
        }
        function getChildren(nodes) {
            return (props.filter ? nodes.filter((n)=>meta.value[n[props.nodeKey]].matchesFilter) : nodes).map((child)=>getNode(child));
        }
        function getNodeMedia(node) {
            if (node.icon !== void 0) return (0, _vue.h)(QIcon_default, {
                class: "q-tree__icon q-mr-sm",
                name: node.icon,
                color: node.iconColor
            });
            const src = node.img || node.avatar;
            if (src) return (0, _vue.h)("img", {
                class: `q-tree__${node.img ? "img" : "avatar"} q-mr-sm`,
                src
            });
        }
        function onShow() {
            emit("afterShow");
        }
        function onHide() {
            emit("afterHide");
        }
        function getNode(node) {
            const key = node[props.nodeKey], m = meta.value[key], header = node.header ? slots[`header-${node.header}`] || slots["default-header"] : slots["default-header"];
            const children = m.isParent === true ? getChildren(node[props.childrenKey]) : [];
            const isParent = children.length !== 0 || m.lazy && m.lazy !== "loaded";
            let body = node.body ? slots[`body-${node.body}`] || slots["default-body"] : slots["default-body"];
            const slotScope = header !== void 0 || body !== void 0 ? getSlotScope(node, m, key) : null;
            if (body !== void 0) body = (0, _vue.h)("div", {
                class: "q-tree__node-body relative-position"
            }, [
                (0, _vue.h)("div", {
                    class: textColorClass.value
                }, [
                    body(slotScope)
                ])
            ]);
            return (0, _vue.h)("div", {
                key,
                class: `q-tree__node relative-position q-tree__node--${isParent === true ? "parent" : "child"}`
            }, [
                (0, _vue.h)("div", {
                    class: "q-tree__node-header relative-position row no-wrap items-center" + (m.link === true ? " q-tree__node--link q-hoverable q-focusable" : "") + (m.selected === true ? " q-tree__node--selected" : "") + (m.disabled === true ? " q-tree__node--disabled" : ""),
                    tabindex: m.link === true ? 0 : -1,
                    ariaExpanded: children.length > 0 ? m.expanded : null,
                    role: "treeitem",
                    onClick: (e)=>{
                        onClick(node, m, e);
                    },
                    onKeypress (e) {
                        if (shouldIgnoreKey(e) !== true) {
                            if (e.keyCode === 13) onClick(node, m, e, true);
                            else if (e.keyCode === 32) onExpandClick(node, m, e, true);
                        }
                    }
                }, [
                    (0, _vue.h)("div", {
                        class: "q-focus-helper",
                        tabindex: -1,
                        ref: (el)=>{
                            blurTargets[m.key] = el;
                        }
                    }),
                    m.lazy === "loading" ? (0, _vue.h)(QSpinner_default, {
                        class: "q-tree__spinner",
                        color: computedControlColor.value
                    }) : isParent === true ? (0, _vue.h)(QIcon_default, {
                        class: "q-tree__arrow" + (m.expanded === true ? " q-tree__arrow--rotate" : ""),
                        name: computedIcon.value,
                        onClick (e) {
                            onExpandClick(node, m, e);
                        }
                    }) : null,
                    m.hasTicking === true && m.noTick !== true ? (0, _vue.h)(QCheckbox_default, {
                        class: "q-tree__tickbox",
                        modelValue: m.indeterminate === true ? null : m.ticked,
                        color: computedControlColor.value,
                        dark: isDark.value,
                        dense: true,
                        keepColor: true,
                        disable: m.tickable !== true,
                        onKeydown: stopAndPrevent,
                        "onUpdate:modelValue": (v)=>{
                            onTickedClick(m, v);
                        }
                    }) : null,
                    (0, _vue.h)("div", {
                        class: "q-tree__node-header-content col row no-wrap items-center" + (m.selected === true ? selectedColorClass.value : textColorClass.value)
                    }, [
                        header ? header(slotScope) : [
                            getNodeMedia(node),
                            (0, _vue.h)("div", node[props.labelKey])
                        ]
                    ])
                ]),
                isParent === true ? props.noTransition === true ? m.expanded === true ? (0, _vue.h)("div", {
                    class: "q-tree__node-collapsible" + textColorClass.value,
                    key: `${key}__q`
                }, [
                    body,
                    (0, _vue.h)("div", {
                        class: "q-tree__children" + (m.disabled === true ? " q-tree__node--disabled" : ""),
                        role: "group"
                    }, children)
                ]) : null : (0, _vue.h)(QSlideTransition_default, {
                    duration: props.duration,
                    onShow,
                    onHide
                }, ()=>(0, _vue.withDirectives)((0, _vue.h)("div", {
                        class: "q-tree__node-collapsible" + textColorClass.value,
                        key: `${key}__q`
                    }, [
                        body,
                        (0, _vue.h)("div", {
                            class: "q-tree__children" + (m.disabled === true ? " q-tree__node--disabled" : ""),
                            role: "group"
                        }, children)
                    ]), [
                        [
                            (0, _vue.vShow),
                            m.expanded
                        ]
                    ])) : body
            ]);
        }
        function blur(key) {
            blurTargets[key]?.focus();
        }
        function onClick(node, localMeta, e, keyboard) {
            if (keyboard !== true && localMeta.selectable !== false) blur(localMeta.key);
            if (hasSelection.value && localMeta.selectable) {
                if (props.noSelectionUnset === false) emit("update:selected", localMeta.key !== props.selected ? localMeta.key : null);
                else if (localMeta.key !== props.selected) emit("update:selected", localMeta.key === void 0 ? null : localMeta.key);
            } else onExpandClick(node, localMeta, e, keyboard);
            if (typeof node.handler === "function") node.handler(node);
        }
        function onExpandClick(node, localMeta, e, keyboard) {
            if (e !== void 0) stopAndPrevent(e);
            if (keyboard !== true && localMeta.selectable !== false) blur(localMeta.key);
            setExpanded(localMeta.key, !localMeta.expanded, node, localMeta);
        }
        function onTickedClick(localMeta, state) {
            if (localMeta.indeterminate === true) state = localMeta.indeterminateNextState;
            if (localMeta.strictTicking) setTicked([
                localMeta.key
            ], state);
            else if (localMeta.leafTicking) {
                const keys = [];
                const travel = (nodeMeta)=>{
                    if (nodeMeta.isParent) {
                        if (state !== true && nodeMeta.noTick !== true && nodeMeta.tickable === true) keys.push(nodeMeta.key);
                        if (nodeMeta.leafTicking === true) nodeMeta.children.forEach(travel);
                    } else if (nodeMeta.noTick !== true && nodeMeta.tickable === true && (nodeMeta.leafFilteredTicking !== true || nodeMeta.matchesFilter === true)) keys.push(nodeMeta.key);
                };
                travel(localMeta);
                setTicked(keys, state);
            }
        }
        if (props.defaultExpandAll === true) expandAll();
        Object.assign(proxy, {
            getNodeByKey,
            getTickedNodes,
            getExpandedNodes,
            isExpanded,
            collapseAll,
            expandAll,
            setExpanded,
            isTicked,
            setTicked
        });
        return ()=>{
            const children = getChildren(props.nodes);
            return (0, _vue.h)("div", {
                class: classes.value,
                role: "tree"
            }, children.length === 0 ? props.filter ? props.noResultsLabel || $q.lang.tree.noResults : props.noNodesLabel || $q.lang.tree.noNodes : children);
        };
    }
});
//#endregion
//#region src/components/uploader/uploader-core.js
function getProgressLabel(p) {
    return (p * 100).toFixed(2) + "%";
}
const coreProps = {
    ...useDarkProps,
    ...useFileProps,
    label: String,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    noThumbnails: Boolean,
    thumbnailFit: {
        type: String,
        default: "cover"
    },
    autoUpload: Boolean,
    hideUploadBtn: Boolean,
    disable: Boolean,
    readonly: Boolean
};
const coreEmits = [
    ...useFileEmits,
    "start",
    "finish",
    "added",
    "removed"
];
function getRenderer(getPlugin, expose) {
    const vm = (0, _vue.getCurrentInstance)();
    const { props, slots, emit, proxy } = vm;
    const { $q } = proxy;
    const isDark = useDark(props, $q);
    function updateFileStatus(file, status, uploadedSize) {
        file.__status = status;
        if (status === "idle") {
            file.__uploaded = 0;
            file.__progress = 0;
            file.__sizeLabel = humanStorageSize(file.size);
            file.__progressLabel = "0.00%";
            return;
        }
        if (status === "failed") {
            proxy.$forceUpdate();
            return;
        }
        file.__uploaded = status === "uploaded" ? file.size : uploadedSize;
        file.__progress = status === "uploaded" ? 1 : Math.min(.9999, file.__uploaded / file.size);
        file.__progressLabel = getProgressLabel(file.__progress);
        proxy.$forceUpdate();
    }
    const editable = (0, _vue.computed)(()=>props.disable !== true && props.readonly !== true);
    const dnd = (0, _vue.ref)(false);
    const rootRef = (0, _vue.ref)(null);
    const inputRef = (0, _vue.ref)(null);
    const state = {
        files: (0, _vue.ref)([]),
        queuedFiles: (0, _vue.ref)([]),
        uploadedFiles: (0, _vue.ref)([]),
        uploadedSize: (0, _vue.ref)(0),
        updateFileStatus,
        isAlive: ()=>vmIsDestroyed(vm) === false
    };
    const { pickFiles, addFiles, onDragover, onDragleave, processFiles, getDndNode, maxFilesNumber, maxTotalSizeNumber } = useFile({
        editable,
        dnd,
        getFileInput,
        addFilesToQueue
    });
    Object.assign(state, getPlugin({
        props,
        slots,
        emit,
        helpers: state,
        exposeApi: (obj)=>{
            Object.assign(state, obj);
        }
    }));
    if (state.isBusy === void 0) state.isBusy = (0, _vue.ref)(false);
    const uploadSize = (0, _vue.ref)(0);
    const uploadProgress = (0, _vue.computed)(()=>uploadSize.value === 0 ? 0 : state.uploadedSize.value / uploadSize.value);
    const uploadProgressLabel = (0, _vue.computed)(()=>getProgressLabel(uploadProgress.value));
    const uploadSizeLabel = (0, _vue.computed)(()=>humanStorageSize(uploadSize.value));
    const canAddFiles = (0, _vue.computed)(()=>editable.value === true && state.isUploading.value !== true && (props.multiple === true || state.queuedFiles.value.length === 0) && (props.maxFiles === void 0 || state.files.value.length < maxFilesNumber.value) && (props.maxTotalSize === void 0 || uploadSize.value < maxTotalSizeNumber.value));
    const canUpload = (0, _vue.computed)(()=>editable.value === true && state.isBusy.value !== true && state.isUploading.value !== true && state.queuedFiles.value.length !== 0);
    (0, _vue.provide)(uploaderKey, renderInput);
    const classes = (0, _vue.computed)(()=>"q-uploader column no-wrap" + (isDark.value === true ? " q-uploader--dark q-dark" : "") + (props.bordered === true ? " q-uploader--bordered" : "") + (props.square === true ? " q-uploader--square no-border-radius" : "") + (props.flat === true ? " q-uploader--flat no-shadow" : "") + (props.disable === true ? " disabled q-uploader--disable" : "") + (dnd.value === true ? " q-uploader--dnd" : ""));
    const colorClass = (0, _vue.computed)(()=>"q-uploader__header" + (props.color !== void 0 ? ` bg-${props.color}` : "") + (props.textColor !== void 0 ? ` text-${props.textColor}` : ""));
    (0, _vue.watch)(state.isUploading, (newVal, oldVal)=>{
        if (oldVal === false && newVal === true) emit("start");
        else if (oldVal === true && newVal === false) emit("finish");
    });
    function reset() {
        if (props.disable === false) {
            state.abort();
            state.uploadedSize.value = 0;
            uploadSize.value = 0;
            revokeImgURLs();
            state.files.value = [];
            state.queuedFiles.value = [];
            state.uploadedFiles.value = [];
        }
    }
    function removeUploadedFiles() {
        if (props.disable === false) batchRemoveFiles([
            "uploaded"
        ], ()=>{
            state.uploadedFiles.value = [];
        });
    }
    function removeQueuedFiles() {
        batchRemoveFiles([
            "idle",
            "failed"
        ], ({ size })=>{
            uploadSize.value -= size;
            state.queuedFiles.value = [];
        });
    }
    function batchRemoveFiles(statusList, cb) {
        if (props.disable === true) return;
        const removed = {
            files: [],
            size: 0
        };
        const localFiles = state.files.value.filter((f)=>{
            if (statusList.indexOf(f.__status) === -1) return true;
            removed.size += f.size;
            removed.files.push(f);
            if (f.__img !== void 0) window.URL.revokeObjectURL(f.__img.src);
            return false;
        });
        if (removed.files.length !== 0) {
            state.files.value = localFiles;
            cb(removed);
            emit("removed", removed.files);
        }
    }
    function removeFile(file) {
        if (props.disable) return;
        if (file.__status === "uploaded") state.uploadedFiles.value = state.uploadedFiles.value.filter((f)=>f.__key !== file.__key);
        else if (file.__status === "uploading") file.__abort();
        else uploadSize.value -= file.size;
        state.files.value = state.files.value.filter((f)=>{
            if (f.__key !== file.__key) return true;
            if (f.__img !== void 0) window.URL.revokeObjectURL(f.__img.src);
            return false;
        });
        state.queuedFiles.value = state.queuedFiles.value.filter((f)=>f.__key !== file.__key);
        emit("removed", [
            file
        ]);
    }
    function revokeImgURLs() {
        state.files.value.forEach((f)=>{
            if (f.__img !== void 0) window.URL.revokeObjectURL(f.__img.src);
        });
    }
    function getFileInput() {
        return inputRef.value || rootRef.value.getElementsByClassName("q-uploader__input")[0];
    }
    function addFilesToQueue(e, fileList) {
        const localFiles = processFiles(e, fileList, state.files.value, true);
        const fileInput = getFileInput();
        if (fileInput !== void 0 && fileInput !== null) fileInput.value = "";
        if (localFiles === void 0) return;
        localFiles.forEach((file)=>{
            state.updateFileStatus(file, "idle");
            uploadSize.value += file.size;
            if (props.noThumbnails !== true && file.type.toUpperCase().startsWith("IMAGE")) {
                const img = new Image();
                img.src = window.URL.createObjectURL(file);
                file.__img = img;
            }
        });
        state.files.value = state.files.value.concat(localFiles);
        state.queuedFiles.value = state.queuedFiles.value.concat(localFiles);
        emit("added", localFiles);
        if (props.autoUpload === true) state.upload();
    }
    function upload() {
        if (canUpload.value === true) state.upload();
    }
    function getBtn(show, icon, fn) {
        if (show === true) {
            const data = {
                type: "a",
                key: icon,
                icon: $q.iconSet.uploader[icon],
                flat: true,
                dense: true
            };
            let child = void 0;
            if (icon === "add") {
                data.onClick = pickFiles;
                child = renderInput;
            } else data.onClick = fn;
            return (0, _vue.h)(QBtn_default, data, child);
        }
    }
    function renderInput() {
        return (0, _vue.h)("input", {
            ref: inputRef,
            class: "q-uploader__input overflow-hidden absolute-full",
            tabindex: -1,
            type: "file",
            title: "",
            accept: props.accept,
            multiple: props.multiple === true ? "multiple" : void 0,
            capture: props.capture,
            onMousedown: stop,
            onClick: pickFiles,
            onChange: addFilesToQueue
        });
    }
    function getHeader() {
        if (slots.header !== void 0) return slots.header(publicApi);
        return [
            (0, _vue.h)("div", {
                class: "q-uploader__header-content column"
            }, [
                (0, _vue.h)("div", {
                    class: "flex flex-center no-wrap q-gutter-xs"
                }, [
                    getBtn(state.queuedFiles.value.length !== 0, "removeQueue", removeQueuedFiles),
                    getBtn(state.uploadedFiles.value.length !== 0, "removeUploaded", removeUploadedFiles),
                    state.isUploading.value === true ? (0, _vue.h)(QSpinner_default, {
                        class: "q-uploader__spinner"
                    }) : null,
                    (0, _vue.h)("div", {
                        class: "col column justify-center"
                    }, [
                        props.label !== void 0 ? (0, _vue.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            props.label
                        ]) : null,
                        (0, _vue.h)("div", {
                            class: "q-uploader__subtitle"
                        }, [
                            uploadSizeLabel.value + " / " + uploadProgressLabel.value
                        ])
                    ]),
                    getBtn(canAddFiles.value, "add"),
                    getBtn(props.hideUploadBtn === false && canUpload.value === true, "upload", state.upload),
                    getBtn(state.isUploading.value, "clear", state.abort)
                ])
            ])
        ];
    }
    function getList() {
        if (slots.list !== void 0) return slots.list(publicApi);
        return state.files.value.map((file)=>(0, _vue.h)("div", {
                key: file.__key,
                class: "q-uploader__file relative-position" + (props.noThumbnails !== true && file.__img !== void 0 ? " q-uploader__file--img" : "") + (file.__status === "failed" ? " q-uploader__file--failed" : file.__status === "uploaded" ? " q-uploader__file--uploaded" : ""),
                style: props.noThumbnails !== true && file.__img !== void 0 ? {
                    backgroundImage: 'url("' + file.__img.src + '")',
                    backgroundSize: props.thumbnailFit
                } : null
            }, [
                (0, _vue.h)("div", {
                    class: "q-uploader__file-header row flex-center no-wrap"
                }, [
                    file.__status === "failed" ? (0, _vue.h)(QIcon_default, {
                        class: "q-uploader__file-status",
                        name: $q.iconSet.type.negative,
                        color: "negative"
                    }) : null,
                    (0, _vue.h)("div", {
                        class: "q-uploader__file-header-content col"
                    }, [
                        (0, _vue.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            file.name
                        ]),
                        (0, _vue.h)("div", {
                            class: "q-uploader__subtitle row items-center no-wrap"
                        }, [
                            file.__sizeLabel + " / " + file.__progressLabel
                        ])
                    ]),
                    file.__status === "uploading" ? (0, _vue.h)(QCircularProgress_default, {
                        value: file.__progress,
                        min: 0,
                        max: 1,
                        indeterminate: file.__progress === 0
                    }) : (0, _vue.h)(QBtn_default, {
                        round: true,
                        dense: true,
                        flat: true,
                        icon: $q.iconSet.uploader[file.__status === "uploaded" ? "done" : "clear"],
                        onClick: ()=>{
                            removeFile(file);
                        }
                    })
                ])
            ]));
    }
    (0, _vue.onBeforeUnmount)(()=>{
        if (state.isUploading.value === true) state.abort();
        if (state.files.value.length !== 0) revokeImgURLs();
    });
    const publicApi = {};
    for(const key in state)if ((0, _vue.isRef)(state[key]) === true) injectProp(publicApi, key, ()=>state[key].value);
    else publicApi[key] = state[key];
    Object.assign(publicApi, {
        upload,
        reset,
        removeUploadedFiles,
        removeQueuedFiles,
        removeFile,
        pickFiles,
        addFiles
    });
    injectMultipleProps(publicApi, {
        canAddFiles: ()=>canAddFiles.value,
        canUpload: ()=>canUpload.value,
        uploadSizeLabel: ()=>uploadSizeLabel.value,
        uploadProgressLabel: ()=>uploadProgressLabel.value
    });
    expose({
        ...state,
        upload,
        reset,
        removeUploadedFiles,
        removeQueuedFiles,
        removeFile,
        pickFiles,
        addFiles,
        canAddFiles,
        canUpload,
        uploadSizeLabel,
        uploadProgressLabel
    });
    return ()=>{
        const children = [
            (0, _vue.h)("div", {
                class: colorClass.value
            }, getHeader()),
            (0, _vue.h)("div", {
                class: "q-uploader__list scroll"
            }, getList()),
            getDndNode("uploader")
        ];
        if (state.isBusy.value === true) children.push((0, _vue.h)("div", {
            class: "q-uploader__overlay absolute-full flex flex-center"
        }, [
            (0, _vue.h)(QSpinner_default)
        ]));
        const data = {
            ref: rootRef,
            class: classes.value
        };
        if (canAddFiles.value === true) Object.assign(data, {
            onDragover,
            onDragleave
        });
        return (0, _vue.h)("div", data, children);
    };
}
//#endregion
//#region src/utils/private.get-emits-object/get-emits-object.js
const trueFn = ()=>true;
function getEmitsObject(emitsArray) {
    const emitsObject = {};
    emitsArray.forEach((val)=>{
        emitsObject[val] = trueFn;
    });
    return emitsObject;
}
//#endregion
//#region src/utils/create-uploader-component/create-uploader-component.js
const coreEmitsObject = getEmitsObject(coreEmits);
var create_uploader_component_default = ({ name, props, emits, injectPlugin })=>createComponent({
        name,
        props: {
            ...coreProps,
            ...props
        },
        emits: isObject(emits) === true ? {
            ...coreEmitsObject,
            ...emits
        } : [
            ...coreEmits,
            ...emits
        ],
        setup (_, { expose }) {
            return getRenderer(injectPlugin, expose);
        }
    });
//#endregion
//#region src/components/uploader/xhr-uploader-plugin.js
function getFn(prop) {
    return typeof prop === "function" ? prop : ()=>prop;
}
const name = "QUploader";
const componentProps = {
    url: [
        Function,
        String
    ],
    method: {
        type: [
            Function,
            String
        ],
        default: "POST"
    },
    fieldName: {
        type: [
            Function,
            String
        ],
        default: ()=>(file)=>file.name
    },
    headers: [
        Function,
        Array
    ],
    formFields: [
        Function,
        Array
    ],
    withCredentials: [
        Function,
        Boolean
    ],
    sendRaw: [
        Function,
        Boolean
    ],
    batch: [
        Function,
        Boolean
    ],
    factory: Function
};
const emits$1 = [
    "factoryFailed",
    "uploaded",
    "failed",
    "uploading"
];
function injectPlugin({ props, emit, helpers }) {
    const xhrs = (0, _vue.ref)([]);
    const promises = (0, _vue.ref)([]);
    const workingThreads = (0, _vue.ref)(0);
    const xhrProps = (0, _vue.computed)(()=>({
            url: getFn(props.url),
            method: getFn(props.method),
            headers: getFn(props.headers),
            formFields: getFn(props.formFields),
            fieldName: getFn(props.fieldName),
            withCredentials: getFn(props.withCredentials),
            sendRaw: getFn(props.sendRaw),
            batch: getFn(props.batch)
        }));
    const isUploading = (0, _vue.computed)(()=>workingThreads.value > 0);
    const isBusy = (0, _vue.computed)(()=>promises.value.length !== 0);
    let abortPromises;
    function abort() {
        xhrs.value.forEach((x)=>{
            x.abort();
        });
        if (promises.value.length !== 0) abortPromises = true;
    }
    function upload() {
        const queue = helpers.queuedFiles.value.slice(0);
        helpers.queuedFiles.value = [];
        if (xhrProps.value.batch(queue)) runFactory(queue);
        else queue.forEach((file)=>{
            runFactory([
                file
            ]);
        });
    }
    function runFactory(files) {
        workingThreads.value++;
        if (typeof props.factory !== "function") {
            performUpload(files, {});
            return;
        }
        const res = props.factory(files);
        if (!res) {
            emit("factoryFailed", /* @__PURE__ */ new Error("QUploader: factory() does not return properly"), files);
            workingThreads.value--;
        } else if (typeof res.catch === "function" && typeof res.then === "function") {
            promises.value.push(res);
            const failed = (err)=>{
                if (helpers.isAlive() === true) {
                    promises.value = promises.value.filter((p)=>p !== res);
                    if (promises.value.length === 0) abortPromises = false;
                    helpers.queuedFiles.value = helpers.queuedFiles.value.concat(files);
                    files.forEach((f)=>{
                        helpers.updateFileStatus(f, "failed");
                    });
                    emit("factoryFailed", err, files);
                    workingThreads.value--;
                }
            };
            res.then((factory)=>{
                if (abortPromises === true) failed(/* @__PURE__ */ new Error("Aborted"));
                else if (helpers.isAlive() === true) {
                    promises.value = promises.value.filter((p)=>p !== res);
                    performUpload(files, factory);
                }
            }).catch(failed);
        } else performUpload(files, res || {});
    }
    function performUpload(files, factory) {
        const form = new FormData(), xhr = new XMLHttpRequest();
        const getProp = (propName, arg)=>factory[propName] !== void 0 ? getFn(factory[propName])(arg) : xhrProps.value[propName](arg);
        const url = getProp("url", files);
        if (!url) {
            console.error("q-uploader: invalid or no URL specified");
            workingThreads.value--;
            return;
        }
        const fields = getProp("formFields", files);
        if (fields !== void 0) fields.forEach((field)=>{
            form.append(field.name, field.value);
        });
        let uploadIndex = 0, uploadIndexSize = 0, localUploadedSize = 0, maxUploadSize = 0, aborted;
        xhr.upload.addEventListener("progress", (e)=>{
            if (aborted === true) return;
            const loaded = Math.min(maxUploadSize, e.loaded);
            helpers.uploadedSize.value += loaded - localUploadedSize;
            localUploadedSize = loaded;
            let size = localUploadedSize - uploadIndexSize;
            for(let i = uploadIndex; size > 0 && i < files.length; i++){
                const file = files[i];
                if (size > file.size) {
                    size -= file.size;
                    uploadIndex++;
                    uploadIndexSize += file.size;
                    helpers.updateFileStatus(file, "uploading", file.size);
                } else {
                    helpers.updateFileStatus(file, "uploading", size);
                    return;
                }
            }
        }, false);
        xhr.onreadystatechange = ()=>{
            if (xhr.readyState < 4) return;
            if (xhr.status && xhr.status < 400) {
                helpers.uploadedFiles.value = helpers.uploadedFiles.value.concat(files);
                files.forEach((f)=>{
                    helpers.updateFileStatus(f, "uploaded");
                });
                emit("uploaded", {
                    files,
                    xhr
                });
            } else {
                aborted = true;
                helpers.uploadedSize.value -= localUploadedSize;
                helpers.queuedFiles.value = helpers.queuedFiles.value.concat(files);
                files.forEach((f)=>{
                    helpers.updateFileStatus(f, "failed");
                });
                emit("failed", {
                    files,
                    xhr
                });
            }
            workingThreads.value--;
            xhrs.value = xhrs.value.filter((x)=>x !== xhr);
        };
        xhr.open(getProp("method", files), url);
        if (getProp("withCredentials", files) === true) xhr.withCredentials = true;
        const headers = getProp("headers", files);
        if (headers !== void 0) headers.forEach((head)=>{
            xhr.setRequestHeader(head.name, head.value);
        });
        const sendRaw = getProp("sendRaw", files);
        files.forEach((file)=>{
            helpers.updateFileStatus(file, "uploading", 0);
            if (sendRaw !== true) form.append(getProp("fieldName", file), file, file.name);
            file.xhr = xhr;
            file.__abort = ()=>{
                xhr.abort();
            };
            maxUploadSize += file.size;
        });
        emit("uploading", {
            files,
            xhr
        });
        xhrs.value.push(xhr);
        if (sendRaw === true) xhr.send(new Blob(files));
        else xhr.send(form);
    }
    return {
        isUploading,
        isBusy,
        abort,
        upload
    };
}
//#endregion
//#region src/components/uploader/QUploader.js
var QUploader_default = create_uploader_component_default({
    name,
    props: componentProps,
    emits: emits$1,
    injectPlugin
});
//#endregion
//#region src/components/uploader/QUploaderAddTrigger.js
var QUploaderAddTrigger_default = createComponent({
    name: "QUploaderAddTrigger",
    setup () {
        const $trigger = (0, _vue.inject)(uploaderKey, emptyRenderFn);
        if ($trigger === emptyRenderFn) console.error("QUploaderAddTrigger needs to be child of QUploader");
        return $trigger;
    }
});
//#endregion
//#region src/components/video/QVideo.js
var QVideo_default = createComponent({
    name: "QVideo",
    props: {
        ...useRatioProps,
        src: {
            type: String,
            required: true
        },
        title: String,
        fetchpriority: {
            type: String,
            default: "auto"
        },
        loading: {
            type: String,
            default: "eager"
        },
        referrerpolicy: {
            type: String,
            default: "strict-origin-when-cross-origin"
        }
    },
    setup (props) {
        const ratioStyle = useRatio(props);
        const classes = (0, _vue.computed)(()=>"q-video" + (props.ratio !== void 0 ? " q-video--responsive" : ""));
        return ()=>(0, _vue.h)("div", {
                class: classes.value,
                style: ratioStyle.value
            }, [
                (0, _vue.h)("iframe", {
                    src: props.src,
                    title: props.title,
                    fetchpriority: props.fetchpriority,
                    loading: props.loading,
                    referrerpolicy: props.referrerpolicy,
                    frameborder: "0",
                    allowfullscreen: true
                })
            ]);
    }
});
//#endregion
//#region src/directives/close-popup/ClosePopup.js
function getDepth(value1) {
    if (value1 === false) return 0;
    if (value1 === true || value1 === void 0) return 1;
    const depth = parseInt(value1, 10);
    return isNaN(depth) ? 0 : depth;
}
var ClosePopup_default = createDirective({
    name: "close-popup",
    beforeMount (el, { value: value1 }) {
        const ctx = {
            depth: getDepth(value1),
            handler (evt) {
                if (ctx.depth !== 0) setTimeout(()=>{
                    const proxy = getPortalProxy(el);
                    if (proxy !== void 0) closePortals(proxy, evt, ctx.depth);
                });
            },
            handlerKey (evt) {
                if (isKeyCode(evt, 13) === true) ctx.handler(evt);
            }
        };
        el.__qclosepopup = ctx;
        el.addEventListener("click", ctx.handler);
        el.addEventListener("keyup", ctx.handlerKey);
    },
    updated (el, { value: value1, oldValue }) {
        if (value1 !== oldValue) el.__qclosepopup.depth = getDepth(value1);
    },
    beforeUnmount (el) {
        const ctx = el.__qclosepopup;
        el.removeEventListener("click", ctx.handler);
        el.removeEventListener("keyup", ctx.handlerKey);
        delete el.__qclosepopup;
    }
});
//#endregion
//#region src/utils/morph/morph.js
let id = 0;
let offsetBase = void 0;
function getAbsolutePosition(el, resize) {
    if (offsetBase === void 0) {
        offsetBase = document.createElement("div");
        offsetBase.style.cssText = "position: absolute; left: 0; top: 0";
        document.body.appendChild(offsetBase);
    }
    const boundingRect = el.getBoundingClientRect();
    const baseRect = offsetBase.getBoundingClientRect();
    const { marginLeft, marginRight, marginTop, marginBottom } = window.getComputedStyle(el);
    const marginH = parseInt(marginLeft, 10) + parseInt(marginRight, 10);
    const marginV = parseInt(marginTop, 10) + parseInt(marginBottom, 10);
    return {
        left: boundingRect.left - baseRect.left,
        top: boundingRect.top - baseRect.top,
        width: boundingRect.right - boundingRect.left,
        height: boundingRect.bottom - boundingRect.top,
        widthM: boundingRect.right - boundingRect.left + (resize === true ? 0 : marginH),
        heightM: boundingRect.bottom - boundingRect.top + (resize === true ? 0 : marginV),
        marginH: resize === true ? marginH : 0,
        marginV: resize === true ? marginV : 0
    };
}
function getAbsoluteSize(el) {
    return {
        width: el.scrollWidth,
        height: el.scrollHeight
    };
}
const styleEdges = [
    "Top",
    "Right",
    "Bottom",
    "Left"
];
const styleBorderRadiuses = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
];
const reStyleSkipKey = /-block|-inline|block-|inline-/;
const reStyleSkipRule = /(-block|-inline|block-|inline-).*:/;
function getComputedStyle$1(el, props) {
    const style = window.getComputedStyle(el);
    const fixed = {};
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (style[prop] === "") {
            if (prop === "cssText") {
                const styleLen = style.length;
                let val = "";
                for(let styleIndex = 0; styleIndex < styleLen; styleIndex++)if (reStyleSkipKey.test(style[styleIndex]) !== true) val += style[styleIndex] + ": " + style[style[styleIndex]] + "; ";
                fixed[prop] = val;
            } else if ([
                "borderWidth",
                "borderStyle",
                "borderColor"
            ].indexOf(prop) !== -1) {
                const suffix = prop.replace("border", "");
                let val = "";
                for(let j = 0; j < styleEdges.length; j++){
                    const subProp = "border" + styleEdges[j] + suffix;
                    val += style[subProp] + " ";
                }
                fixed[prop] = val;
            } else if (prop === "borderRadius") {
                let val1 = "";
                let val2 = "";
                for(let j = 0; j < styleBorderRadiuses.length; j++){
                    const val = style[styleBorderRadiuses[j]].split(" ");
                    val1 += val[0] + " ";
                    val2 += (val[1] === void 0 ? val[0] : val[1]) + " ";
                }
                fixed[prop] = val1 + "/ " + val2;
            } else fixed[prop] = style[prop];
        } else if (prop === "cssText") fixed[prop] = style[prop].split(";").filter((val)=>reStyleSkipRule.test(val) !== true).join(";");
        else fixed[prop] = style[prop];
    }
    return fixed;
}
const zIndexPositions = [
    "absolute",
    "fixed",
    "relative",
    "sticky"
];
function getMaxZIndex(elStart) {
    let el = elStart;
    let maxIndex = 0;
    while(el !== null && el !== document){
        const { position, zIndex } = window.getComputedStyle(el);
        const zIndexNum = Number(zIndex);
        if (zIndexNum > maxIndex && (el === elStart || zIndexPositions.includes(position) === true)) maxIndex = zIndexNum;
        el = el.parentNode;
    }
    return maxIndex;
}
function normalizeElements(opts) {
    return {
        from: opts.from,
        to: opts.to !== void 0 ? opts.to : opts.from
    };
}
function normalizeOptions(options) {
    if (typeof options === "number") options = {
        duration: options
    };
    else if (typeof options === "function") options = {
        onEnd: options
    };
    return {
        ...options,
        waitFor: options.waitFor === void 0 ? 0 : options.waitFor,
        duration: isNaN(options.duration) === true ? 300 : parseInt(options.duration, 10),
        easing: typeof options.easing === "string" && options.easing.length !== 0 ? options.easing : "ease-in-out",
        delay: isNaN(options.delay) === true ? 0 : parseInt(options.delay, 10),
        fill: typeof options.fill === "string" && options.fill.length !== 0 ? options.fill : "none",
        resize: options.resize === true,
        useCSS: options.useCSS === true || options.usecss === true,
        hideFromClone: options.hideFromClone === true || options.hidefromclone === true,
        keepToClone: options.keepToClone === true || options.keeptoclone === true,
        tween: options.tween === true,
        tweenFromOpacity: isNaN(options.tweenFromOpacity) === true ? .6 : parseFloat(options.tweenFromOpacity),
        tweenToOpacity: isNaN(options.tweenToOpacity) === true ? .5 : parseFloat(options.tweenToOpacity)
    };
}
function getElement(element) {
    const type = typeof element;
    return type === "function" ? element() : type === "string" ? document.querySelector(element) : element;
}
function isValidElement(element) {
    return element && element.ownerDocument === document && element.parentNode !== null;
}
function morph(_options) {
    let cancel = ()=>false;
    let cancelStatus = false;
    let endElementTo = true;
    const elements = normalizeElements(_options);
    const options = normalizeOptions(_options);
    const elFrom = getElement(elements.from);
    if (isValidElement(elFrom) !== true) return cancel;
    if (typeof elFrom.qMorphCancel === "function") elFrom.qMorphCancel();
    let animationFromClone = void 0;
    let animationFromTween = void 0;
    let animationToClone = void 0;
    let animationTo = void 0;
    const elFromParent = elFrom.parentNode;
    const elFromNext = elFrom.nextElementSibling;
    const elFromPosition = getAbsolutePosition(elFrom, options.resize);
    const { width: elFromParentWidthBefore, height: elFromParentHeightBefore } = getAbsoluteSize(elFromParent);
    const { borderWidth: elFromBorderWidth, borderStyle: elFromBorderStyle, borderColor: elFromBorderColor, borderRadius: elFromBorderRadius, backgroundColor: elFromBackground, transform: elFromTransform, position: elFromPositioningType, cssText: elFromCssText } = getComputedStyle$1(elFrom, [
        "borderWidth",
        "borderStyle",
        "borderColor",
        "borderRadius",
        "backgroundColor",
        "transform",
        "position",
        "cssText"
    ]);
    const elFromClassSaved = elFrom.classList.toString();
    const elFromStyleSaved = elFrom.style.cssText;
    const elFromClone = elFrom.cloneNode(true);
    const elFromTween = options.tween === true ? elFrom.cloneNode(true) : void 0;
    if (elFromTween !== void 0) elFromTween.className = elFromTween.classList.toString().split(" ").filter((c)=>/^bg-/.test(c) === false).join(" ");
    if (options.hideFromClone === true) elFromClone.classList.add("q-morph--internal");
    elFromClone.setAttribute("aria-hidden", "true");
    elFromClone.style.transition = "none";
    elFromClone.style.animation = "none";
    elFromClone.style.pointerEvents = "none";
    elFromParent.insertBefore(elFromClone, elFromNext);
    elFrom.qMorphCancel = ()=>{
        cancelStatus = true;
        elFromClone.remove();
        elFromTween?.remove();
        if (options.hideFromClone === true) elFromClone.classList.remove("q-morph--internal");
        elFrom.qMorphCancel = void 0;
    };
    const calculateFinalState = ()=>{
        const elTo = getElement(elements.to);
        if (cancelStatus === true || isValidElement(elTo) !== true) {
            if (typeof elFrom.qMorphCancel === "function") elFrom.qMorphCancel();
            return;
        }
        if (elFrom !== elTo && typeof elTo.qMorphCancel === "function") elTo.qMorphCancel();
        if (options.keepToClone !== true) elTo.classList.add("q-morph--internal");
        elFromClone.classList.add("q-morph--internal");
        const { width: elFromParentWidthAfter, height: elFromParentHeightAfter } = getAbsoluteSize(elFromParent);
        const { width: elToParentWidthBefore, height: elToParentHeightBefore } = getAbsoluteSize(elTo.parentNode);
        if (options.hideFromClone !== true) elFromClone.classList.remove("q-morph--internal");
        elTo.qMorphCancel = ()=>{
            cancelStatus = true;
            elFromClone.remove();
            elFromTween?.remove();
            if (options.hideFromClone === true) elFromClone.classList.remove("q-morph--internal");
            if (options.keepToClone !== true) elTo.classList.remove("q-morph--internal");
            elFrom.qMorphCancel = void 0;
            elTo.qMorphCancel = void 0;
        };
        const animate = ()=>{
            if (cancelStatus === true) {
                if (typeof elTo.qMorphCancel === "function") elTo.qMorphCancel();
                return;
            }
            if (options.hideFromClone !== true) {
                elFromClone.classList.add("q-morph--internal");
                elFromClone.innerHTML = "";
                elFromClone.style.left = 0;
                elFromClone.style.right = "unset";
                elFromClone.style.top = 0;
                elFromClone.style.bottom = "unset";
                elFromClone.style.transform = "none";
            }
            if (options.keepToClone !== true) elTo.classList.remove("q-morph--internal");
            const elToParent = elTo.parentNode;
            const { width: elToParentWidthAfter, height: elToParentHeightAfter } = getAbsoluteSize(elToParent);
            const elToClone = elTo.cloneNode(options.keepToClone);
            elToClone.setAttribute("aria-hidden", "true");
            if (options.keepToClone !== true) {
                elToClone.style.left = 0;
                elToClone.style.right = "unset";
                elToClone.style.top = 0;
                elToClone.style.bottom = "unset";
                elToClone.style.transform = "none";
                elToClone.style.pointerEvents = "none";
            }
            elToClone.classList.add("q-morph--internal");
            const elToNext = elTo === elFrom && elFromParent === elToParent ? elFromClone : elTo.nextElementSibling;
            elToParent.insertBefore(elToClone, elToNext);
            const { borderWidth: elToBorderWidth, borderStyle: elToBorderStyle, borderColor: elToBorderColor, borderRadius: elToBorderRadius, backgroundColor: elToBackground, transform: elToTransform, position: elToPositioningType, cssText: elToCssText } = getComputedStyle$1(elTo, [
                "borderWidth",
                "borderStyle",
                "borderColor",
                "borderRadius",
                "backgroundColor",
                "transform",
                "position",
                "cssText"
            ]);
            const elToClassSaved = elTo.classList.toString();
            const elToStyleSaved = elTo.style.cssText;
            elTo.style.cssText = elToCssText;
            elTo.style.transform = "none";
            elTo.style.animation = "none";
            elTo.style.transition = "none";
            elTo.className = elToClassSaved.split(" ").filter((c)=>/^bg-/.test(c) === false).join(" ");
            const elToPosition = getAbsolutePosition(elTo, options.resize);
            const deltaX = elFromPosition.left - elToPosition.left;
            const deltaY = elFromPosition.top - elToPosition.top;
            const scaleX = elFromPosition.width / (elToPosition.width > 0 ? elToPosition.width : 10);
            const scaleY = elFromPosition.height / (elToPosition.height > 0 ? elToPosition.height : 100);
            const elFromParentWidthDiff = elFromParentWidthBefore - elFromParentWidthAfter;
            const elFromParentHeightDiff = elFromParentHeightBefore - elFromParentHeightAfter;
            const elToParentWidthDiff = elToParentWidthAfter - elToParentWidthBefore;
            const elToParentHeightDiff = elToParentHeightAfter - elToParentHeightBefore;
            const elFromCloneWidth = Math.max(elFromPosition.widthM, elFromParentWidthDiff);
            const elFromCloneHeight = Math.max(elFromPosition.heightM, elFromParentHeightDiff);
            const elToCloneWidth = Math.max(elToPosition.widthM, elToParentWidthDiff);
            const elToCloneHeight = Math.max(elToPosition.heightM, elToParentHeightDiff);
            const elSharedSize = elFrom === elTo && [
                "absolute",
                "fixed"
            ].includes(elToPositioningType) === false && [
                "absolute",
                "fixed"
            ].includes(elFromPositioningType) === false;
            let elToNeedsFixedPosition = elToPositioningType === "fixed";
            let parent = elToParent;
            while(elToNeedsFixedPosition !== true && parent !== document){
                elToNeedsFixedPosition = window.getComputedStyle(parent).position === "fixed";
                parent = parent.parentNode;
            }
            if (options.hideFromClone !== true) {
                elFromClone.style.display = "block";
                elFromClone.style.flex = "0 0 auto";
                elFromClone.style.opacity = 0;
                elFromClone.style.minWidth = "unset";
                elFromClone.style.maxWidth = "unset";
                elFromClone.style.minHeight = "unset";
                elFromClone.style.maxHeight = "unset";
                elFromClone.classList.remove("q-morph--internal");
            }
            if (options.keepToClone !== true) {
                elToClone.style.display = "block";
                elToClone.style.flex = "0 0 auto";
                elToClone.style.opacity = 0;
                elToClone.style.minWidth = "unset";
                elToClone.style.maxWidth = "unset";
                elToClone.style.minHeight = "unset";
                elToClone.style.maxHeight = "unset";
            }
            elToClone.classList.remove("q-morph--internal");
            if (typeof options.classes === "string") elTo.className += " " + options.classes;
            if (typeof options.style === "string") elTo.style.cssText += " " + options.style;
            else if (isObject(options.style) === true) for(const prop in options.style)elTo.style[prop] = options.style[prop];
            const elFromZIndex = getMaxZIndex(elFromClone);
            const elToZIndex = getMaxZIndex(elTo);
            const documentScroll = elToNeedsFixedPosition === true ? document.documentElement : {
                scrollLeft: 0,
                scrollTop: 0
            };
            elTo.style.position = elToNeedsFixedPosition === true ? "fixed" : "absolute";
            elTo.style.left = `${elToPosition.left - documentScroll.scrollLeft}px`;
            elTo.style.right = "unset";
            elTo.style.top = `${elToPosition.top - documentScroll.scrollTop}px`;
            elTo.style.margin = 0;
            if (options.resize === true) {
                elTo.style.minWidth = "unset";
                elTo.style.maxWidth = "unset";
                elTo.style.minHeight = "unset";
                elTo.style.maxHeight = "unset";
                elTo.style.overflow = "hidden";
                elTo.style.overflowX = "hidden";
                elTo.style.overflowY = "hidden";
            }
            document.body.appendChild(elTo);
            if (elFromTween !== void 0) {
                elFromTween.style.cssText = elFromCssText;
                elFromTween.style.transform = "none";
                elFromTween.style.animation = "none";
                elFromTween.style.transition = "none";
                elFromTween.style.position = elTo.style.position;
                elFromTween.style.left = `${elFromPosition.left - documentScroll.scrollLeft}px`;
                elFromTween.style.right = "unset";
                elFromTween.style.top = `${elFromPosition.top - documentScroll.scrollTop}px`;
                elFromTween.style.margin = 0;
                elFromTween.style.pointerEvents = "none";
                if (options.resize === true) {
                    elFromTween.style.minWidth = "unset";
                    elFromTween.style.maxWidth = "unset";
                    elFromTween.style.minHeight = "unset";
                    elFromTween.style.maxHeight = "unset";
                    elFromTween.style.overflow = "hidden";
                    elFromTween.style.overflowX = "hidden";
                    elFromTween.style.overflowY = "hidden";
                }
                document.body.appendChild(elFromTween);
            }
            const commonCleanup = (aborted)=>{
                if (elFrom === elTo && endElementTo !== true) {
                    elTo.style.cssText = elFromStyleSaved;
                    elTo.className = elFromClassSaved;
                } else {
                    elTo.style.cssText = elToStyleSaved;
                    elTo.className = elToClassSaved;
                }
                if (elToClone.parentNode === elToParent) elToParent.insertBefore(elTo, elToClone);
                elFromClone.remove();
                elToClone.remove();
                elFromTween?.remove();
                cancel = ()=>false;
                elFrom.qMorphCancel = void 0;
                elTo.qMorphCancel = void 0;
                if (typeof options.onEnd === "function") options.onEnd(endElementTo === true ? "to" : "from", aborted === true);
            };
            if (options.useCSS !== true && typeof elTo.animate === "function") {
                const resizeFrom = options.resize === true ? {
                    transform: `translate(${deltaX}px, ${deltaY}px)`,
                    width: `${elFromCloneWidth}px`,
                    height: `${elFromCloneHeight}px`
                } : {
                    transform: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`
                };
                const resizeTo = options.resize === true ? {
                    width: `${elToCloneWidth}px`,
                    height: `${elToCloneHeight}px`
                } : {};
                const resizeFromTween = options.resize === true ? {
                    width: `${elFromCloneWidth}px`,
                    height: `${elFromCloneHeight}px`
                } : {};
                const resizeToTween = options.resize === true ? {
                    transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px)`,
                    width: `${elToCloneWidth}px`,
                    height: `${elToCloneHeight}px`
                } : {
                    transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY})`
                };
                const tweenFrom = elFromTween !== void 0 ? {
                    opacity: options.tweenToOpacity
                } : {
                    backgroundColor: elFromBackground
                };
                const tweenTo = elFromTween !== void 0 ? {
                    opacity: 1
                } : {
                    backgroundColor: elToBackground
                };
                animationTo = elTo.animate([
                    {
                        margin: 0,
                        borderWidth: elFromBorderWidth,
                        borderStyle: elFromBorderStyle,
                        borderColor: elFromBorderColor,
                        borderRadius: elFromBorderRadius,
                        zIndex: elFromZIndex,
                        transformOrigin: "0 0",
                        ...resizeFrom,
                        ...tweenFrom
                    },
                    {
                        margin: 0,
                        borderWidth: elToBorderWidth,
                        borderStyle: elToBorderStyle,
                        borderColor: elToBorderColor,
                        borderRadius: elToBorderRadius,
                        zIndex: elToZIndex,
                        transformOrigin: "0 0",
                        transform: elToTransform,
                        ...resizeTo,
                        ...tweenTo
                    }
                ], {
                    duration: options.duration,
                    easing: options.easing,
                    fill: options.fill,
                    delay: options.delay
                });
                animationFromTween = elFromTween === void 0 ? void 0 : elFromTween.animate([
                    {
                        opacity: options.tweenFromOpacity,
                        margin: 0,
                        borderWidth: elFromBorderWidth,
                        borderStyle: elFromBorderStyle,
                        borderColor: elFromBorderColor,
                        borderRadius: elFromBorderRadius,
                        zIndex: elFromZIndex,
                        transformOrigin: "0 0",
                        transform: elFromTransform,
                        ...resizeFromTween
                    },
                    {
                        opacity: 0,
                        margin: 0,
                        borderWidth: elToBorderWidth,
                        borderStyle: elToBorderStyle,
                        borderColor: elToBorderColor,
                        borderRadius: elToBorderRadius,
                        zIndex: elToZIndex,
                        transformOrigin: "0 0",
                        ...resizeToTween
                    }
                ], {
                    duration: options.duration,
                    easing: options.easing,
                    fill: options.fill,
                    delay: options.delay
                });
                animationFromClone = options.hideFromClone === true || elSharedSize === true ? void 0 : elFromClone.animate([
                    {
                        margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
                        width: `${elFromCloneWidth + elFromPosition.marginH}px`,
                        height: `${elFromCloneHeight + elFromPosition.marginV}px`
                    },
                    {
                        margin: 0,
                        width: 0,
                        height: 0
                    }
                ], {
                    duration: options.duration,
                    easing: options.easing,
                    fill: options.fill,
                    delay: options.delay
                });
                animationToClone = options.keepToClone === true ? void 0 : elToClone.animate([
                    elSharedSize === true ? {
                        margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
                        width: `${elFromCloneWidth + elFromPosition.marginH}px`,
                        height: `${elFromCloneHeight + elFromPosition.marginV}px`
                    } : {
                        margin: 0,
                        width: 0,
                        height: 0
                    },
                    {
                        margin: `${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px`,
                        width: `${elToCloneWidth + elToPosition.marginH}px`,
                        height: `${elToCloneHeight + elToPosition.marginV}px`
                    }
                ], {
                    duration: options.duration,
                    easing: options.easing,
                    fill: options.fill,
                    delay: options.delay
                });
                const cleanup = (abort)=>{
                    animationFromClone?.cancel();
                    animationFromTween?.cancel();
                    animationToClone?.cancel();
                    animationTo.cancel();
                    animationTo.removeEventListener("finish", cleanup);
                    animationTo.removeEventListener("cancel", cleanup);
                    commonCleanup(abort);
                    animationFromClone = void 0;
                    animationFromTween = void 0;
                    animationToClone = void 0;
                    animationTo = void 0;
                };
                elFrom.qMorphCancel = ()=>{
                    elFrom.qMorphCancel = void 0;
                    cancelStatus = true;
                    cleanup();
                };
                elTo.qMorphCancel = ()=>{
                    elTo.qMorphCancel = void 0;
                    cancelStatus = true;
                    cleanup();
                };
                animationTo.addEventListener("finish", cleanup);
                animationTo.addEventListener("cancel", cleanup);
                cancel = (abort)=>{
                    if (cancelStatus === true || animationTo === void 0) return false;
                    if (abort === true) {
                        cleanup(true);
                        return true;
                    }
                    endElementTo = endElementTo !== true;
                    animationFromClone?.reverse();
                    animationFromTween?.reverse();
                    animationToClone?.reverse();
                    animationTo.reverse();
                    return true;
                };
            } else {
                const qAnimId = `q-morph-anim-${++id}`;
                const style = document.createElement("style");
                const resizeFrom = options.resize === true ? `
            transform: translate(${deltaX}px, ${deltaY}px);
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : `transform: translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY});`;
                const resizeTo = options.resize === true ? `
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : "";
                const resizeFromTween = options.resize === true ? `
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : "";
                const resizeToTween = options.resize === true ? `
            transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px);
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : `transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY});`;
                const tweenFrom = elFromTween !== void 0 ? `opacity: ${options.tweenToOpacity};` : `background-color: ${elFromBackground};`;
                const tweenTo = elFromTween !== void 0 ? "opacity: 1;" : `background-color: ${elToBackground};`;
                const keyframesFromTween = elFromTween === void 0 ? "" : `
            @keyframes ${qAnimId}-from-tween {
              0% {
                opacity: ${options.tweenFromOpacity};
                margin: 0;
                border-width: ${elFromBorderWidth};
                border-style: ${elFromBorderStyle};
                border-color: ${elFromBorderColor};
                border-radius: ${elFromBorderRadius};
                z-index: ${elFromZIndex};
                transform-origin: 0 0;
                transform: ${elFromTransform};
                ${resizeFromTween}
              }

              100% {
                opacity: 0;
                margin: 0;
                border-width: ${elToBorderWidth};
                border-style: ${elToBorderStyle};
                border-color: ${elToBorderColor};
                border-radius: ${elToBorderRadius};
                z-index: ${elToZIndex};
                transform-origin: 0 0;
                ${resizeToTween}
              }
            }
          `;
                const keyframesFrom = options.hideFromClone === true || elSharedSize === true ? "" : `
            @keyframes ${qAnimId}-from {
              0% {
                margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
                width: ${elFromCloneWidth + elFromPosition.marginH}px;
                height: ${elFromCloneHeight + elFromPosition.marginV}px;
              }

              100% {
                margin: 0;
                width: 0;
                height: 0;
              }
            }
          `;
                const keyframeToStart = elSharedSize === true ? `
            margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
            width: ${elFromCloneWidth + elFromPosition.marginH}px;
            height: ${elFromCloneHeight + elFromPosition.marginV}px;
          ` : `
            margin: 0;
            width: 0;
            height: 0;
          `;
                style.innerHTML = `
          @keyframes ${qAnimId} {
            0% {
              margin: 0;
              border-width: ${elFromBorderWidth};
              border-style: ${elFromBorderStyle};
              border-color: ${elFromBorderColor};
              border-radius: ${elFromBorderRadius};
              background-color: ${elFromBackground};
              z-index: ${elFromZIndex};
              transform-origin: 0 0;
              ${resizeFrom}
              ${tweenFrom}
            }

            100% {
              margin: 0;
              border-width: ${elToBorderWidth};
              border-style: ${elToBorderStyle};
              border-color: ${elToBorderColor};
              border-radius: ${elToBorderRadius};
              background-color: ${elToBackground};
              z-index: ${elToZIndex};
              transform-origin: 0 0;
              transform: ${elToTransform};
              ${resizeTo}
              ${tweenTo}
            }
          }

          ${keyframesFrom}

          ${keyframesFromTween}

          ${options.keepToClone === true ? "" : `
            @keyframes ${qAnimId}-to {
              0% {
                ${keyframeToStart}
              }

              100% {
                margin: ${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px;
                width: ${elToCloneWidth + elToPosition.marginH}px;
                height: ${elToCloneHeight + elToPosition.marginV}px;
              }
            }
          `}
        `;
                document.head.appendChild(style);
                let animationDirection = "normal";
                elFromClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from`;
                if (elFromTween !== void 0) elFromTween.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from-tween`;
                elToClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-to`;
                elTo.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}`;
                const cleanup = (evt)=>{
                    if (evt === Object(evt) && evt.animationName !== qAnimId) return;
                    elTo.removeEventListener("animationend", cleanup);
                    elTo.removeEventListener("animationcancel", cleanup);
                    commonCleanup();
                    style.remove();
                };
                elFrom.qMorphCancel = ()=>{
                    elFrom.qMorphCancel = void 0;
                    cancelStatus = true;
                    cleanup();
                };
                elTo.qMorphCancel = ()=>{
                    elTo.qMorphCancel = void 0;
                    cancelStatus = true;
                    cleanup();
                };
                elTo.addEventListener("animationend", cleanup);
                elTo.addEventListener("animationcancel", cleanup);
                cancel = (abort)=>{
                    if (cancelStatus === true || !elTo || !elFromClone || !elToClone) return false;
                    if (abort === true) {
                        cleanup();
                        return true;
                    }
                    endElementTo = endElementTo !== true;
                    animationDirection = animationDirection === "normal" ? "reverse" : "normal";
                    elFromClone.style.animationDirection = animationDirection;
                    elFromTween.style.animationDirection = animationDirection;
                    elToClone.style.animationDirection = animationDirection;
                    elTo.style.animationDirection = animationDirection;
                    return true;
                };
            }
        };
        if (options.waitFor > 0 || options.waitFor === "transitionend" || options.waitFor === Object(options.waitFor) && typeof options.waitFor.then === "function") (options.waitFor > 0 ? new Promise((resolve)=>setTimeout(resolve, options.waitFor)) : options.waitFor === "transitionend" ? new Promise((resolve)=>{
            const endFn = ()=>{
                if (timer !== null) {
                    clearTimeout(timer);
                    timer = null;
                }
                if (elTo) {
                    elTo.removeEventListener("transitionend", endFn);
                    elTo.removeEventListener("transitioncancel", endFn);
                }
                resolve();
            };
            let timer = setTimeout(endFn, 400);
            elTo.addEventListener("transitionend", endFn);
            elTo.addEventListener("transitioncancel", endFn);
        }) : options.waitFor).then(animate).catch(()=>{
            if (typeof elTo.qMorphCancel === "function") elTo.qMorphCancel();
        });
        else animate();
    };
    if (typeof _options.onToggle === "function") _options.onToggle();
    requestAnimationFrame(calculateFinalState);
    return (abort)=>cancel(abort);
}
//#endregion
//#region src/directives/morph/Morph.js
const morphGroups = {};
const props$1 = [
    "duration",
    "delay",
    "easing",
    "fill",
    "classes",
    "style",
    "duration",
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween",
    "tweenFromOpacity",
    "tweenToOpacity",
    "waitFor",
    "onEnd"
];
const mods = [
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween"
];
function changeClass(ctx, action) {
    if (ctx.clsAction !== action) {
        ctx.clsAction = action;
        ctx.el.classList[action]("q-morph--invisible");
    }
}
function trigger(group) {
    if (group.animating === true || group.queue.length < 2) return;
    const [from, to] = group.queue;
    group.animating = true;
    from.animating = true;
    to.animating = true;
    changeClass(from, "remove");
    changeClass(to, "remove");
    const cancelFn = morph({
        from: from.el,
        to: to.el,
        onToggle () {
            changeClass(from, "add");
            changeClass(to, "remove");
        },
        ...to.opts,
        onEnd (dir, aborted) {
            to.opts.onEnd?.(dir, aborted);
            if (aborted === true) return;
            from.animating = false;
            to.animating = false;
            group.animating = false;
            group.cancel = void 0;
            group.queue.shift();
            trigger(group);
        }
    });
    group.cancel = ()=>{
        cancelFn(true);
        group.cancel = void 0;
    };
}
function updateModifiers(mod, ctx) {
    const opts = ctx.opts;
    mods.forEach((name)=>{
        opts[name] = mod[name] === true;
    });
}
function insertArgs(arg, ctx) {
    const opts = typeof arg === "string" && arg.length !== 0 ? arg.split(":") : [];
    ctx.name = opts[0];
    ctx.group = opts[1];
    Object.assign(ctx.opts, {
        duration: isNaN(opts[2]) === true ? 300 : parseFloat(opts[2]),
        waitFor: opts[3]
    });
}
function updateArgs(arg, ctx) {
    if (arg.group !== void 0) ctx.group = arg.group;
    if (arg.name !== void 0) ctx.name = arg.name;
    const opts = ctx.opts;
    props$1.forEach((name)=>{
        if (arg[name] !== void 0) opts[name] = arg[name];
    });
}
function updateModel(name, ctx) {
    if (ctx.name === name) {
        const group = morphGroups[ctx.group];
        if (group === void 0) {
            morphGroups[ctx.group] = {
                name: ctx.group,
                model: name,
                queue: [
                    ctx
                ],
                animating: false
            };
            changeClass(ctx, "remove");
        } else if (group.model !== name) {
            group.model = name;
            group.queue.push(ctx);
            if (group.animating === false && group.queue.length === 2) trigger(group);
        }
        return;
    }
    if (ctx.animating === false) changeClass(ctx, "add");
}
function updateValue(ctx, value1) {
    let model;
    if (Object(value1) === value1) {
        model = String(value1.model);
        updateArgs(value1, ctx);
        updateModifiers(value1, ctx);
    } else model = String(value1);
    if (model !== ctx.model) {
        ctx.model = model;
        updateModel(model, ctx);
    } else if (ctx.animating === false && ctx.clsAction !== void 0) ctx.el.classList[ctx.clsAction]("q-morph--invisible");
}
var Morph_default = createDirective({
    name: "morph",
    mounted (el, binding) {
        const ctx = {
            el,
            animating: false,
            opts: {}
        };
        updateModifiers(binding.modifiers, ctx);
        insertArgs(binding.arg, ctx);
        updateValue(ctx, binding.value);
        el.__qmorph = ctx;
    },
    updated (el, binding) {
        updateValue(el.__qmorph, binding.value);
    },
    beforeUnmount (el) {
        const ctx = el.__qmorph;
        const group = morphGroups[ctx.group];
        if (group !== void 0) {
            if (group.queue.indexOf(ctx) !== -1) {
                group.queue = group.queue.filter((item)=>item !== ctx);
                if (group.queue.length === 0) {
                    group.cancel?.();
                    delete morphGroups[ctx.group];
                }
            }
        }
        if (ctx.clsAction === "add") el.classList.remove("q-morph--invisible");
        delete el.__qmorph;
    }
});
//#endregion
//#region src/directives/mutation/Mutation.js
const defaultCfg = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
    attributeOldValue: true,
    characterDataOldValue: true
};
function update$2(el, ctx, value1) {
    ctx.handler = value1;
    ctx.observer?.disconnect();
    ctx.observer = new MutationObserver((list)=>{
        if (typeof ctx.handler === "function") {
            if (ctx.handler(list) === false || ctx.once === true) destroy(el);
        }
    });
    ctx.observer.observe(el, ctx.opts);
}
function destroy(el) {
    const ctx = el.__qmutation;
    if (ctx !== void 0) {
        ctx.observer?.disconnect();
        delete el.__qmutation;
    }
}
var Mutation_default = createDirective({
    name: "mutation",
    mounted (el, { modifiers: { once, ...mod }, value: value1 }) {
        const ctx = {
            once,
            opts: Object.keys(mod).length === 0 ? defaultCfg : mod
        };
        update$2(el, ctx, value1);
        el.__qmutation = ctx;
    },
    updated (el, { oldValue, value: value1 }) {
        const ctx = el.__qmutation;
        if (ctx !== void 0 && oldValue !== value1) update$2(el, ctx, value1);
    },
    beforeUnmount: destroy
});
//#endregion
//#region src/directives/scroll-fire/ScrollFire.js
const { passive } = listenOpts;
function update$1(ctx, { value: value1, oldValue }) {
    if (typeof value1 !== "function") {
        ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive);
        return;
    }
    ctx.handler = value1;
    if (typeof oldValue !== "function") {
        ctx.scrollTarget.addEventListener("scroll", ctx.scroll, passive);
        ctx.scroll();
    }
}
var ScrollFire_default = createDirective({
    name: "scroll-fire",
    mounted (el, binding) {
        const ctx = {
            scrollTarget: getScrollTarget(el),
            scroll: debounce(()=>{
                let containerBottom, elBottom;
                if (ctx.scrollTarget === window) {
                    elBottom = el.getBoundingClientRect().bottom;
                    containerBottom = window.innerHeight;
                } else {
                    elBottom = offset(el).top + height(el);
                    containerBottom = offset(ctx.scrollTarget).top + height(ctx.scrollTarget);
                }
                if (elBottom > 0 && elBottom < containerBottom) {
                    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive);
                    ctx.handler(el);
                }
            }, 25)
        };
        update$1(ctx, binding);
        el.__qscrollfire = ctx;
    },
    updated (el, binding) {
        if (binding.value !== binding.oldValue) update$1(el.__qscrollfire, binding);
    },
    beforeUnmount (el) {
        const ctx = el.__qscrollfire;
        ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive);
        ctx.scroll.cancel();
        delete el.__qscrollfire;
    }
});
//#endregion
//#region src/directives/scroll/Scroll.js
function update(ctx, { value: value1, oldValue }) {
    if (typeof value1 !== "function") {
        ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts.passive);
        return;
    }
    ctx.handler = value1;
    if (typeof oldValue !== "function") ctx.scrollTarget.addEventListener("scroll", ctx.scroll, listenOpts.passive);
}
var Scroll_default = createDirective({
    name: "scroll",
    mounted (el, binding) {
        const ctx = {
            scrollTarget: getScrollTarget(el),
            scroll () {
                ctx.handler(getVerticalScrollPosition(ctx.scrollTarget), getHorizontalScrollPosition(ctx.scrollTarget));
            }
        };
        update(ctx, binding);
        el.__qscroll = ctx;
    },
    updated (el, binding) {
        if (el.__qscroll !== void 0 && binding.oldValue !== binding.value) update(el.__qscroll, binding);
    },
    beforeUnmount (el) {
        const ctx = el.__qscroll;
        ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts.passive);
        delete el.__qscroll;
    }
});
//#endregion
//#region src/directives/touch-hold/TouchHold.js
var TouchHold_default = createDirective({
    name: "touch-hold",
    beforeMount (el, binding) {
        const { modifiers } = binding;
        if (modifiers.mouse !== true && client.has.touch !== true) return;
        const ctx = {
            handler: binding.value,
            noop,
            mouseStart (evt) {
                if (typeof ctx.handler === "function" && leftClick(evt) === true) {
                    addEvt(ctx, "temp", [
                        [
                            document,
                            "mousemove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            document,
                            "click",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt, true);
                }
            },
            touchStart (evt) {
                if (evt.target !== void 0 && typeof ctx.handler === "function") {
                    const target = evt.target;
                    addEvt(ctx, "temp", [
                        [
                            target,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            target,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            target,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt);
                }
            },
            start (evt, mouseEvent) {
                ctx.origin = position(evt);
                const startTime = Date.now();
                if (client.is.mobile === true) {
                    document.body.classList.add("non-selectable");
                    clearSelection();
                    ctx.styleCleanup = (withDelay)=>{
                        ctx.styleCleanup = void 0;
                        const remove = ()=>{
                            document.body.classList.remove("non-selectable");
                        };
                        if (withDelay === true) {
                            clearSelection();
                            setTimeout(remove, 10);
                        } else remove();
                    };
                }
                ctx.triggered = false;
                ctx.sensitivity = mouseEvent === true ? ctx.mouseSensitivity : ctx.touchSensitivity;
                ctx.timer = setTimeout(()=>{
                    ctx.timer = void 0;
                    clearSelection();
                    ctx.triggered = true;
                    ctx.handler({
                        evt,
                        touch: mouseEvent !== true,
                        mouse: mouseEvent === true,
                        position: ctx.origin,
                        duration: Date.now() - startTime
                    });
                }, ctx.duration);
            },
            move (evt) {
                const { top, left } = position(evt);
                if (ctx.timer !== void 0 && (Math.abs(left - ctx.origin.left) >= ctx.sensitivity || Math.abs(top - ctx.origin.top) >= ctx.sensitivity)) {
                    clearTimeout(ctx.timer);
                    ctx.timer = void 0;
                }
            },
            end (evt) {
                cleanEvt(ctx, "temp");
                ctx.styleCleanup?.(ctx.triggered);
                if (ctx.triggered === true) {
                    if (evt !== void 0) stopAndPrevent(evt);
                } else if (ctx.timer !== void 0) {
                    clearTimeout(ctx.timer);
                    ctx.timer = void 0;
                }
            }
        };
        const data = [
            600,
            5,
            7
        ];
        if (typeof binding.arg === "string" && binding.arg.length !== 0) binding.arg.split(":").forEach((val, index)=>{
            const v = parseInt(val, 10);
            if (v) data[index] = v;
        });
        [ctx.duration, ctx.touchSensitivity, ctx.mouseSensitivity] = data;
        el.__qtouchhold = ctx;
        if (modifiers.mouse === true) addEvt(ctx, "main", [
            [
                el,
                "mousedown",
                "mouseStart",
                `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : ""}`
            ]
        ]);
        if (client.has.touch === true) addEvt(ctx, "main", [
            [
                el,
                "touchstart",
                "touchStart",
                `passive${modifiers.capture === true ? "Capture" : ""}`
            ],
            [
                el,
                "touchend",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (el, binding) {
        const ctx = el.__qtouchhold;
        if (ctx !== void 0 && binding.oldValue !== binding.value) {
            if (typeof binding.value !== "function") ctx.end();
            ctx.handler = binding.value;
        }
    },
    beforeUnmount (el) {
        const ctx = el.__qtouchhold;
        if (ctx !== void 0) {
            cleanEvt(ctx, "main");
            cleanEvt(ctx, "temp");
            if (ctx.timer !== void 0) clearTimeout(ctx.timer);
            ctx.styleCleanup?.();
            delete el.__qtouchhold;
        }
    }
});
//#endregion
//#region src/directives/touch-repeat/TouchRepeat.js
const keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [
        8,
        46
    ]
}, keyRegex = new RegExp(`^([\\d+]+|${Object.keys(keyCodes).join("|")})$`, "i");
function shouldEnd(evt, origin) {
    const { top, left } = position(evt);
    return Math.abs(left - origin.left) >= 7 || Math.abs(top - origin.top) >= 7;
}
var TouchRepeat_default = createDirective({
    name: "touch-repeat",
    beforeMount (el, { modifiers, value: value1, arg }) {
        const keyboard = Object.keys(modifiers).reduce((acc, key)=>{
            if (keyRegex.test(key) === true) {
                const keyCode = isNaN(parseInt(key, 10)) ? keyCodes[key.toLowerCase()] : parseInt(key, 10);
                if (keyCode >= 0) acc.push(keyCode);
            }
            return acc;
        }, []);
        if (modifiers.mouse !== true && client.has.touch !== true && keyboard.length === 0) return;
        const durations = typeof arg === "string" && arg.length !== 0 ? arg.split(":").map((val)=>parseInt(val, 10)) : [
            0,
            600,
            300
        ];
        const durationsLast = durations.length - 1;
        const ctx = {
            keyboard,
            handler: value1,
            noop,
            mouseStart (evt) {
                if (ctx.event === void 0 && typeof ctx.handler === "function" && leftClick(evt) === true) {
                    addEvt(ctx, "temp", [
                        [
                            document,
                            "mousemove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            document,
                            "click",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt, true);
                }
            },
            keyboardStart (evt) {
                if (typeof ctx.handler === "function" && isKeyCode(evt, keyboard) === true) {
                    if (durations[0] === 0 || ctx.event !== void 0) {
                        stopAndPrevent(evt);
                        el.focus();
                        if (ctx.event !== void 0) return;
                    }
                    addEvt(ctx, "temp", [
                        [
                            document,
                            "keyup",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            document,
                            "click",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt, false, true);
                }
            },
            touchStart (evt) {
                if (evt.target !== void 0 && typeof ctx.handler === "function") {
                    const target = evt.target;
                    addEvt(ctx, "temp", [
                        [
                            target,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            target,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            target,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]);
                    ctx.start(evt);
                }
            },
            start (evt, mouseEvent, keyboardEvent) {
                if (keyboardEvent !== true) ctx.origin = position(evt);
                function styleCleanup(withDelay) {
                    ctx.styleCleanup = void 0;
                    document.documentElement.style.cursor = "";
                    const remove = ()=>{
                        document.body.classList.remove("non-selectable");
                    };
                    if (withDelay === true) {
                        clearSelection();
                        setTimeout(remove, 10);
                    } else remove();
                }
                if (client.is.mobile === true) {
                    document.body.classList.add("non-selectable");
                    clearSelection();
                    ctx.styleCleanup = styleCleanup;
                }
                ctx.event = {
                    touch: mouseEvent !== true && keyboardEvent !== true,
                    mouse: mouseEvent === true,
                    keyboard: keyboardEvent === true,
                    startTime: Date.now(),
                    repeatCount: 0
                };
                const fn = ()=>{
                    ctx.timer = void 0;
                    if (ctx.event === void 0) return;
                    if (ctx.event.repeatCount === 0) {
                        ctx.event.evt = evt;
                        if (keyboardEvent === true) ctx.event.keyCode = evt.keyCode;
                        else ctx.event.position = position(evt);
                        if (client.is.mobile !== true) {
                            document.documentElement.style.cursor = "pointer";
                            document.body.classList.add("non-selectable");
                            clearSelection();
                            ctx.styleCleanup = styleCleanup;
                        }
                    }
                    ctx.event.duration = Date.now() - ctx.event.startTime;
                    ctx.event.repeatCount += 1;
                    ctx.handler(ctx.event);
                    const index = durationsLast < ctx.event.repeatCount ? durationsLast : ctx.event.repeatCount;
                    ctx.timer = setTimeout(fn, durations[index]);
                };
                if (durations[0] === 0) fn();
                else ctx.timer = setTimeout(fn, durations[0]);
            },
            move (evt) {
                if (ctx.event !== void 0 && ctx.timer !== void 0 && shouldEnd(evt, ctx.origin) === true) {
                    clearTimeout(ctx.timer);
                    ctx.timer = void 0;
                }
            },
            end (evt) {
                if (ctx.event === void 0) return;
                ctx.styleCleanup?.(true);
                if (evt !== void 0 && ctx.event.repeatCount > 0) stopAndPrevent(evt);
                cleanEvt(ctx, "temp");
                if (ctx.timer !== void 0) {
                    clearTimeout(ctx.timer);
                    ctx.timer = void 0;
                }
                ctx.event = void 0;
            }
        };
        el.__qtouchrepeat = ctx;
        if (modifiers.mouse === true) addEvt(ctx, "main", [
            [
                el,
                "mousedown",
                "mouseStart",
                `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : ""}`
            ]
        ]);
        if (client.has.touch === true) addEvt(ctx, "main", [
            [
                el,
                "touchstart",
                "touchStart",
                `passive${modifiers.capture === true ? "Capture" : ""}`
            ],
            [
                el,
                "touchend",
                "noop",
                "passiveCapture"
            ]
        ]);
        if (keyboard.length !== 0) addEvt(ctx, "main", [
            [
                el,
                "keydown",
                "keyboardStart",
                `notPassive${modifiers.keyCapture === true || modifiers.keycapture === true ? "Capture" : ""}`
            ]
        ]);
    },
    updated (el, { oldValue, value: value1 }) {
        const ctx = el.__qtouchrepeat;
        if (ctx !== void 0 && oldValue !== value1) {
            if (typeof value1 !== "function") ctx.end();
            ctx.handler = value1;
        }
    },
    beforeUnmount (el) {
        const ctx = el.__qtouchrepeat;
        if (ctx !== void 0) {
            if (ctx.timer !== void 0) clearTimeout(ctx.timer);
            cleanEvt(ctx, "main");
            cleanEvt(ctx, "temp");
            ctx.styleCleanup?.();
            delete el.__qtouchrepeat;
        }
    }
});
//#endregion
//#region src/utils/css-var/get-css-var.js
function getCssVar(propName, element = document.body) {
    if (typeof propName !== "string") throw new TypeError("Expected a string as propName");
    if (!(element instanceof Element)) throw new TypeError("Expected a DOM element");
    return getComputedStyle(element).getPropertyValue(`--q-${propName}`).trim() || null;
}
//#endregion
//#region src/plugins/addressbar/AddressbarColor.js
let metaValue;
function getProp() {
    return client.is.winphone ? "msapplication-navbutton-color" : "theme-color";
}
function getMetaTag(v) {
    const els = document.getElementsByTagName("META");
    for(const i in els)if (els[i].name === v) return els[i];
}
function setColor(hexColor) {
    if (metaValue === void 0) metaValue = getProp();
    let metaTag = getMetaTag(metaValue);
    const newTag = metaTag === void 0;
    if (newTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", metaValue);
    }
    metaTag.setAttribute("content", hexColor);
    if (newTag) document.head.appendChild(metaTag);
}
var AddressbarColor_default = {
    set: client.is.mobile === true && (client.is.nativeMobile === true || client.is.winphone === true || client.is.safari === true || client.is.webkit === true || client.is.vivaldi === true) ? (hexColor)=>{
        const val = hexColor || getCssVar("primary");
        if (client.is.nativeMobile === true && window.StatusBar) window.StatusBar.backgroundColorByHexString(val);
        else setColor(val);
    } : noop,
    install ({ $q }) {
        $q.addressbarColor = this;
        if ($q.config.addressbarColor) this.set($q.config.addressbarColor);
    }
};
//#endregion
//#region src/plugins/app-fullscreen/AppFullscreen.js
const prefixes = {};
function assignFn(fn) {
    Object.assign(Plugin, {
        request: fn,
        exit: fn,
        toggle: fn
    });
}
function getFullscreenElement() {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function updateEl() {
    const newEl = Plugin.activeEl = Plugin.isActive === false ? null : getFullscreenElement();
    changeGlobalNodesTarget(newEl === null || newEl === document.documentElement ? document.body : newEl);
}
function togglePluginState() {
    Plugin.isActive = Plugin.isActive === false;
    updateEl();
}
function promisify(target, fn) {
    try {
        const res = target[fn]();
        return res === void 0 ? Promise.resolve() : res;
    } catch (err) {
        return Promise.reject(err);
    }
}
const Plugin = createReactivePlugin({
    isActive: false,
    activeEl: null
}, {
    isCapable: false,
    install ({ $q }) {
        $q.fullscreen = this;
    }
});
prefixes.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
].find((request)=>document.documentElement[request] !== void 0);
Plugin.isCapable = prefixes.request !== void 0;
if (Plugin.isCapable === false) assignFn(()=>Promise.reject("Not capable"));
else {
    Object.assign(Plugin, {
        request (target) {
            const el = target || document.documentElement;
            const { activeEl } = Plugin;
            if (el === activeEl) return Promise.resolve();
            return (activeEl !== null && el.contains(activeEl) === true ? Plugin.exit() : Promise.resolve()).finally(()=>promisify(el, prefixes.request));
        },
        exit () {
            return Plugin.isActive === true ? promisify(document, prefixes.exit) : Promise.resolve();
        },
        toggle (target) {
            return Plugin.isActive === true ? Plugin.exit() : Plugin.request(target);
        }
    });
    prefixes.exit = [
        "exitFullscreen",
        "msExitFullscreen",
        "mozCancelFullScreen",
        "webkitExitFullscreen"
    ].find((exit)=>document[exit]);
    Plugin.isActive = Boolean(getFullscreenElement());
    if (Plugin.isActive === true) updateEl();
    [
        "onfullscreenchange",
        "onmsfullscreenchange",
        "onwebkitfullscreenchange"
    ].forEach((evt)=>{
        document[evt] = togglePluginState;
    });
}
//#endregion
//#region src/plugins/app-visibility/AppVisibility.js
const Plugin$1 = createReactivePlugin({
    appVisible: true
}, {
    install ({ $q }) {
        injectProp($q, "appVisible", ()=>this.appVisible);
    }
});
{
    let prop, evt;
    if (typeof document.hidden !== "undefined") {
        prop = "hidden";
        evt = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        prop = "msHidden";
        evt = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        prop = "webkitHidden";
        evt = "webkitvisibilitychange";
    }
    if (evt && typeof document[prop] !== "undefined") {
        const update = ()=>{
            Plugin$1.appVisible = !document[prop];
        };
        document.addEventListener(evt, update, false);
    }
}//#endregion
//#region src/plugins/bottom-sheet/component/BottomSheetComponent.js
var BottomSheetComponent_default = createComponent({
    name: "BottomSheetComponent",
    props: {
        ...useDarkProps,
        title: String,
        message: String,
        actions: Array,
        grid: Boolean,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    },
    emits: [
        "ok",
        "hide"
    ],
    setup (props, { emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const isDark = useDark(props, proxy.$q);
        const dialogRef = (0, _vue.ref)(null);
        function show() {
            dialogRef.value.show();
        }
        function hide() {
            dialogRef.value.hide();
        }
        function onOk(action) {
            emit("ok", action);
            hide();
        }
        function onHide() {
            emit("hide");
        }
        function getGrid() {
            return props.actions.map((action)=>{
                const img = action.avatar || action.img;
                return action.label === void 0 ? (0, _vue.h)(QSeparator_default, {
                    class: "col-all",
                    dark: isDark.value
                }) : (0, _vue.h)("div", {
                    class: [
                        "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
                        action.class
                    ],
                    style: action.style,
                    tabindex: 0,
                    role: "listitem",
                    onClick () {
                        onOk(action);
                    },
                    onKeyup (e) {
                        if (e.keyCode === 13) onOk(action);
                    }
                }, [
                    (0, _vue.h)("div", {
                        class: "q-focus-helper"
                    }),
                    action.icon ? (0, _vue.h)(QIcon_default, {
                        name: action.icon,
                        color: action.color
                    }) : img ? (0, _vue.h)("img", {
                        class: action.avatar ? "q-bottom-sheet__avatar" : "",
                        src: img
                    }) : (0, _vue.h)("div", {
                        class: "q-bottom-sheet__empty-icon"
                    }),
                    (0, _vue.h)("div", action.label)
                ]);
            });
        }
        function getList() {
            return props.actions.map((action)=>{
                const img = action.avatar || action.img;
                return action.label === void 0 ? (0, _vue.h)(QSeparator_default, {
                    spaced: true,
                    dark: isDark.value
                }) : (0, _vue.h)(QItem_default, {
                    class: [
                        "q-bottom-sheet__item",
                        action.classes
                    ],
                    style: action.style,
                    tabindex: 0,
                    clickable: true,
                    dark: isDark.value,
                    onClick () {
                        onOk(action);
                    }
                }, ()=>[
                        (0, _vue.h)(QItemSection_default, {
                            avatar: true
                        }, ()=>action.icon ? (0, _vue.h)(QIcon_default, {
                                name: action.icon,
                                color: action.color
                            }) : img ? (0, _vue.h)("img", {
                                class: action.avatar ? "q-bottom-sheet__avatar" : "",
                                src: img
                            }) : null),
                        (0, _vue.h)(QItemSection_default, ()=>action.label)
                    ]);
            });
        }
        function getCardContent() {
            const child = [];
            if (props.title) child.push((0, _vue.h)(QCardSection_default, {
                class: "q-dialog__title"
            }, ()=>props.title));
            if (props.message) child.push((0, _vue.h)(QCardSection_default, {
                class: "q-dialog__message"
            }, ()=>props.message));
            child.push(props.grid === true ? (0, _vue.h)("div", {
                class: "row items-stretch justify-start",
                role: "list"
            }, getGrid()) : (0, _vue.h)("div", {
                role: "list"
            }, getList()));
            return child;
        }
        function getContent() {
            return [
                (0, _vue.h)(QCard_default, {
                    class: [
                        `q-bottom-sheet q-bottom-sheet--${props.grid === true ? "grid" : "list"}` + (isDark.value === true ? " q-bottom-sheet--dark q-dark" : ""),
                        props.cardClass
                    ],
                    style: props.cardStyle
                }, getCardContent)
            ];
        }
        Object.assign(proxy, {
            show,
            hide
        });
        return ()=>(0, _vue.h)(QDialog_default, {
                ref: dialogRef,
                position: "bottom",
                onHide
            }, getContent);
    }
});
//#endregion
//#region src/utils/private.dialog/create-dialog.js
function merge(target, source) {
    for(const key in source)if (key !== "spinner" && Object(source[key]) === source[key]) {
        target[key] = Object(target[key]) !== target[key] ? {} : {
            ...target[key]
        };
        merge(target[key], source[key]);
    } else target[key] = source[key];
}
function createDialog(DefaultComponent, supportsCustomComponent, parentApp) {
    return (pluginProps)=>{
        let DialogComponent, props;
        const isCustom = supportsCustomComponent === true && pluginProps.component !== void 0;
        if (isCustom === true) {
            const { component, componentProps } = pluginProps;
            DialogComponent = typeof component === "string" ? parentApp.component(component) : component;
            props = componentProps || {};
        } else {
            const { class: klass, style, ...otherProps } = pluginProps;
            DialogComponent = DefaultComponent;
            props = otherProps;
            if (klass !== void 0) otherProps.cardClass = klass;
            if (style !== void 0) otherProps.cardStyle = style;
        }
        let vm, emittedOK = false;
        const dialogRef = (0, _vue.ref)(null);
        const el = createGlobalNode(false, "dialog");
        const applyState = (cmd)=>{
            if (dialogRef.value?.[cmd] !== void 0) {
                dialogRef.value[cmd]();
                return;
            }
            const target = vm.$.subTree;
            if (target?.component) {
                if (target.component.proxy && target.component.proxy[cmd]) {
                    target.component.proxy[cmd]();
                    return;
                }
                if (target.component.subTree && target.component.subTree.component && target.component.subTree.component.proxy && target.component.subTree.component.proxy[cmd]) {
                    target.component.subTree.component.proxy[cmd]();
                    return;
                }
            }
            console.error("[Quasar] Incorrectly defined Dialog component");
        };
        const okFns = [], cancelFns = [], API = {
            onOk (fn) {
                okFns.push(fn);
                return API;
            },
            onCancel (fn) {
                cancelFns.push(fn);
                return API;
            },
            onDismiss (fn) {
                okFns.push(fn);
                cancelFns.push(fn);
                return API;
            },
            hide () {
                applyState("hide");
                return API;
            },
            update (componentProps) {
                if (vm !== null) {
                    if (isCustom === true) Object.assign(props, componentProps);
                    else {
                        const { class: klass, style, ...cfg } = componentProps;
                        if (klass !== void 0) cfg.cardClass = klass;
                        if (style !== void 0) cfg.cardStyle = style;
                        merge(props, cfg);
                    }
                    vm.$forceUpdate();
                }
                return API;
            }
        };
        const onOk = (data)=>{
            emittedOK = true;
            okFns.forEach((fn)=>{
                fn(data);
            });
        };
        const onHide = ()=>{
            app.unmount(el);
            removeGlobalNode(el);
            app = null;
            vm = null;
            if (emittedOK !== true) cancelFns.forEach((fn)=>{
                fn();
            });
        };
        let app = createChildApp({
            name: "QGlobalDialog",
            setup: ()=>()=>(0, _vue.h)(DialogComponent, {
                        ...props,
                        ref: dialogRef,
                        onOk,
                        onHide,
                        onVnodeMounted (...args) {
                            if (typeof props.onVnodeMounted === "function") props.onVnodeMounted(...args);
                            (0, _vue.nextTick)(()=>applyState("show"));
                        }
                    })
        }, parentApp);
        vm = app.mount(el);
        return API;
    };
}
//#endregion
//#region src/plugins/bottom-sheet/BottomSheet.js
var BottomSheet_default = {
    install ({ $q, parentApp }) {
        $q.bottomSheet = this.create = createDialog(BottomSheetComponent_default, false, parentApp);
    }
};
//#endregion
//#region src/plugins/cookies/Cookies.js
function encode$1(string) {
    return encodeURIComponent(string);
}
function decode$1(string) {
    return decodeURIComponent(string);
}
function stringifyCookieValue(value1) {
    return encode$1(value1 === Object(value1) ? JSON.stringify(value1) : String(value1));
}
function read(string) {
    if (string === "") return string;
    if (string.indexOf('"') === 0) string = string.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
    string = decode$1(string.replace(/\+/g, " "));
    try {
        const parsed = JSON.parse(string);
        if (parsed === Object(parsed) || Array.isArray(parsed) === true) string = parsed;
    } catch  {}
    return string;
}
function getString(msOffset) {
    const time = /* @__PURE__ */ new Date();
    time.setMilliseconds(time.getMilliseconds() + msOffset);
    return time.toUTCString();
}
function parseExpireString(str) {
    let timestamp = 0;
    const days = str.match(/(\d+)d/);
    const hours = str.match(/(\d+)h/);
    const minutes = str.match(/(\d+)m/);
    const seconds = str.match(/(\d+)s/);
    if (days) timestamp += days[1] * 864e5;
    if (hours) timestamp += hours[1] * 36e5;
    if (minutes) timestamp += minutes[1] * 6e4;
    if (seconds) timestamp += seconds[1] * 1e3;
    return timestamp === 0 ? str : getString(timestamp);
}
function set(key, val, opts = {}, ssr) {
    let expire, expireValue;
    if (opts.expires !== void 0) {
        if (Object.prototype.toString.call(opts.expires) === "[object Date]") expire = opts.expires.toUTCString();
        else if (typeof opts.expires === "string") expire = parseExpireString(opts.expires);
        else {
            expireValue = parseFloat(opts.expires);
            expire = isNaN(expireValue) === false ? getString(expireValue * 864e5) : opts.expires;
        }
    }
    const keyValue = `${encode$1(key)}=${stringifyCookieValue(val)}`;
    const cookie = [
        keyValue,
        expire !== void 0 ? "; Expires=" + expire : "",
        opts.path ? "; Path=" + opts.path : "",
        opts.domain ? "; Domain=" + opts.domain : "",
        opts.sameSite ? "; SameSite=" + opts.sameSite : "",
        opts.httpOnly ? "; HttpOnly" : "",
        opts.secure ? "; Secure" : "",
        opts.other ? "; " + opts.other : ""
    ].join("");
    if (ssr) {
        if (ssr.req.qCookies) ssr.req.qCookies.push(cookie);
        else ssr.req.qCookies = [
            cookie
        ];
        ssr.res.setHeader("Set-Cookie", ssr.req.qCookies);
        let all = ssr.req.headers.cookie || "";
        if (expire !== void 0 && expireValue < 0) {
            const localVal = get(key, ssr);
            if (localVal !== void 0) all = all.replace(`${key}=${localVal}; `, "").replace(`; ${key}=${localVal}`, "").replace(`${key}=${localVal}`, "");
        } else all = all ? `${keyValue}; ${all}` : cookie;
        ssr.req.headers.cookie = all;
    } else document.cookie = cookie;
}
function get(key, ssr) {
    const cookieSource = ssr ? ssr.req.headers : document, cookies = cookieSource.cookie ? cookieSource.cookie.split("; ") : [], l = cookies.length;
    let result = key ? null : {}, i = 0, parts, name, cookie;
    for(; i < l; i++){
        parts = cookies[i].split("=");
        name = decode$1(parts.shift());
        cookie = parts.join("=");
        if (!key) result[name] = cookie;
        else if (key === name) {
            result = read(cookie);
            break;
        }
    }
    return result;
}
function remove(key, options, ssr) {
    set(key, "", {
        expires: -1,
        ...options
    }, ssr);
}
function has(key, ssr) {
    return get(key, ssr) !== null;
}
function getObject(ssr) {
    return {
        get: (key)=>get(key, ssr),
        set: (key, val, opts)=>set(key, val, opts, ssr),
        has: (key)=>has(key, ssr),
        remove: (key, options)=>remove(key, options, ssr),
        getAll: ()=>get(null, ssr)
    };
}
const Plugin$2 = {
    install ({ $q, ssrContext }) {
        $q.cookies = this;
    }
};
if (__QUASAR_SSR__) Plugin$2.parseSSR = (ssrContext)=>{
    if (ssrContext !== void 0) return getObject(ssrContext);
};
Object.assign(Plugin$2, getObject());
//#endregion
//#region src/plugins/dialog/component/DialogPluginComponent.js
var DialogPluginComponent_default = createComponent({
    name: "DialogPluginComponent",
    props: {
        ...useDarkProps,
        title: String,
        message: String,
        prompt: Object,
        options: Object,
        progress: [
            Boolean,
            Object
        ],
        html: Boolean,
        ok: {
            type: [
                String,
                Object,
                Boolean
            ],
            default: true
        },
        cancel: [
            String,
            Object,
            Boolean
        ],
        focus: {
            type: String,
            default: "ok",
            validator: (v)=>[
                    "ok",
                    "cancel",
                    "none"
                ].includes(v)
        },
        stackButtons: Boolean,
        color: String,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    },
    emits: [
        "ok",
        "hide"
    ],
    setup (props, { emit }) {
        const { proxy } = (0, _vue.getCurrentInstance)();
        const { $q } = proxy;
        const isDark = useDark(props, $q);
        const dialogRef = (0, _vue.ref)(null);
        const model = (0, _vue.ref)(props.prompt !== void 0 ? props.prompt.model : props.options !== void 0 ? props.options.model : void 0);
        const classes = (0, _vue.computed)(()=>"q-dialog-plugin" + (isDark.value === true ? " q-dialog-plugin--dark q-dark" : "") + (props.progress !== false ? " q-dialog-plugin--progress" : ""));
        const vmColor = (0, _vue.computed)(()=>props.color || (isDark.value === true ? "amber" : "primary"));
        const spinner = (0, _vue.computed)(()=>props.progress === false ? null : isObject(props.progress) === true ? {
                component: props.progress.spinner || QSpinner_default,
                props: {
                    color: props.progress.color || vmColor.value
                }
            } : {
                component: QSpinner_default,
                props: {
                    color: vmColor.value
                }
            });
        const hasForm = (0, _vue.computed)(()=>props.prompt !== void 0 || props.options !== void 0);
        const formProps = (0, _vue.computed)(()=>{
            if (hasForm.value !== true) return {};
            const { model, isValid, items, ...acc } = props.prompt !== void 0 ? props.prompt : props.options;
            return acc;
        });
        const okLabel = (0, _vue.computed)(()=>isObject(props.ok) === true ? $q.lang.label.ok : props.ok === true ? $q.lang.label.ok : props.ok);
        const cancelLabel = (0, _vue.computed)(()=>isObject(props.cancel) === true ? $q.lang.label.cancel : props.cancel === true ? $q.lang.label.cancel : props.cancel);
        const okDisabled = (0, _vue.computed)(()=>{
            if (props.prompt !== void 0) return props.prompt.isValid !== void 0 && props.prompt.isValid(model.value) !== true;
            if (props.options !== void 0) return props.options.isValid !== void 0 && props.options.isValid(model.value) !== true;
            return false;
        });
        const okProps = (0, _vue.computed)(()=>({
                color: vmColor.value,
                label: okLabel.value,
                ripple: false,
                disable: okDisabled.value,
                ...isObject(props.ok) === true ? props.ok : {
                    flat: true
                },
                "data-autofocus": props.focus === "ok" && hasForm.value !== true || void 0,
                onClick: onOk
            }));
        const cancelProps = (0, _vue.computed)(()=>({
                color: vmColor.value,
                label: cancelLabel.value,
                ripple: false,
                ...isObject(props.cancel) === true ? props.cancel : {
                    flat: true
                },
                "data-autofocus": props.focus === "cancel" && hasForm.value !== true || void 0,
                onClick: onCancel
            }));
        (0, _vue.watch)(()=>props.prompt && props.prompt.model, onUpdateModel);
        (0, _vue.watch)(()=>props.options && props.options.model, onUpdateModel);
        function show() {
            dialogRef.value.show();
        }
        function hide() {
            dialogRef.value.hide();
        }
        function onOk() {
            emit("ok", (0, _vue.toRaw)(model.value));
            hide();
        }
        function onCancel() {
            hide();
        }
        function onDialogHide() {
            emit("hide");
        }
        function onUpdateModel(val) {
            model.value = val;
        }
        function onInputKeyup(evt) {
            if (okDisabled.value !== true && props.prompt.type !== "textarea" && isKeyCode(evt, 13) === true) onOk();
        }
        function getSection(sectionClass, text) {
            return props.html === true ? (0, _vue.h)(QCardSection_default, {
                class: sectionClass,
                innerHTML: text
            }) : (0, _vue.h)(QCardSection_default, {
                class: sectionClass
            }, ()=>text);
        }
        function getPrompt() {
            return [
                (0, _vue.h)(QInput_default, {
                    color: vmColor.value,
                    dense: true,
                    autofocus: true,
                    dark: isDark.value,
                    ...formProps.value,
                    modelValue: model.value,
                    "onUpdate:modelValue": onUpdateModel,
                    onKeyup: onInputKeyup
                })
            ];
        }
        function getOptions() {
            return [
                (0, _vue.h)(QOptionGroup_default, {
                    color: vmColor.value,
                    options: props.options.items,
                    dark: isDark.value,
                    ...formProps.value,
                    modelValue: model.value,
                    "onUpdate:modelValue": onUpdateModel
                })
            ];
        }
        function getButtons() {
            const child = [];
            if (props.cancel) child.push((0, _vue.h)(QBtn_default, cancelProps.value));
            if (props.ok) child.push((0, _vue.h)(QBtn_default, okProps.value));
            return (0, _vue.h)(QCardActions_default, {
                class: props.stackButtons === true ? "items-end" : "",
                vertical: props.stackButtons,
                align: "right"
            }, ()=>child);
        }
        function getCardContent() {
            const child = [];
            if (props.title) child.push(getSection("q-dialog__title", props.title));
            if (props.progress !== false) child.push((0, _vue.h)(QCardSection_default, {
                class: "q-dialog__progress"
            }, ()=>(0, _vue.h)(spinner.value.component, spinner.value.props)));
            if (props.message) child.push(getSection("q-dialog__message", props.message));
            if (props.prompt !== void 0) child.push((0, _vue.h)(QCardSection_default, {
                class: "scroll q-dialog-plugin__form"
            }, getPrompt));
            else if (props.options !== void 0) child.push((0, _vue.h)(QSeparator_default, {
                dark: isDark.value
            }), (0, _vue.h)(QCardSection_default, {
                class: "scroll q-dialog-plugin__form"
            }, getOptions), (0, _vue.h)(QSeparator_default, {
                dark: isDark.value
            }));
            if (props.ok || props.cancel) child.push(getButtons());
            return child;
        }
        function getContent() {
            return [
                (0, _vue.h)(QCard_default, {
                    class: [
                        classes.value,
                        props.cardClass
                    ],
                    style: props.cardStyle,
                    dark: isDark.value
                }, getCardContent)
            ];
        }
        Object.assign(proxy, {
            show,
            hide
        });
        return ()=>(0, _vue.h)(QDialog_default, {
                ref: dialogRef,
                onHide: onDialogHide
            }, getContent);
    }
});
//#endregion
//#region src/plugins/dialog/Dialog.js
var Dialog_default = {
    install ({ $q, parentApp }) {
        $q.dialog = this.create = createDialog(DialogPluginComponent_default, true, parentApp);
    }
};
//#endregion
//#region src/plugins/loading/Loading.js
let app, vm, uid$2 = 0, timeout = null, props = {}, activeGroups = {};
const originalDefaults = {
    group: "__default_quasar_group__",
    delay: 0,
    message: false,
    html: false,
    spinnerSize: 80,
    spinnerColor: "",
    messageColor: "",
    backgroundColor: "",
    boxClass: "",
    spinner: QSpinner_default,
    customClass: ""
};
const defaults$1 = {
    ...originalDefaults
};
function registerProps(opts) {
    if (opts?.group !== void 0 && activeGroups[opts.group] !== void 0) return Object.assign(activeGroups[opts.group], opts);
    const newProps = isObject(opts) === true && opts.ignoreDefaults === true ? {
        ...originalDefaults,
        ...opts
    } : {
        ...defaults$1,
        ...opts
    };
    activeGroups[newProps.group] = newProps;
    return newProps;
}
const Plugin$6 = createReactivePlugin({
    isActive: false
}, {
    show (opts) {
        props = registerProps(opts);
        const { group } = props;
        Plugin$6.isActive = true;
        if (app !== void 0) {
            props.uid = uid$2;
            vm.$forceUpdate();
        } else {
            props.uid = ++uid$2;
            if (timeout !== null) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                timeout = null;
                const el = createGlobalNode("q-loading");
                app = createChildApp({
                    name: "QLoading",
                    setup () {
                        (0, _vue.onMounted)(()=>{
                            preventScroll(true);
                        });
                        function onAfterLeave() {
                            if (Plugin$6.isActive !== true && app !== void 0) {
                                preventScroll(false);
                                app.unmount(el);
                                removeGlobalNode(el);
                                app = void 0;
                                vm = void 0;
                            }
                        }
                        function getContent() {
                            if (Plugin$6.isActive !== true) return null;
                            const content = [
                                (0, _vue.h)(props.spinner, {
                                    class: "q-loading__spinner",
                                    color: props.spinnerColor,
                                    size: props.spinnerSize
                                })
                            ];
                            if (props.message) content.push((0, _vue.h)("div", {
                                class: "q-loading__message" + (props.messageColor ? ` text-${props.messageColor}` : ""),
                                [props.html === true ? "innerHTML" : "textContent"]: props.message
                            }));
                            return (0, _vue.h)("div", {
                                class: "q-loading fullscreen flex flex-center z-max " + props.customClass.trim(),
                                key: props.uid
                            }, [
                                (0, _vue.h)("div", {
                                    class: "q-loading__backdrop" + (props.backgroundColor ? ` bg-${props.backgroundColor}` : "")
                                }),
                                (0, _vue.h)("div", {
                                    class: "q-loading__box column items-center " + props.boxClass
                                }, content)
                            ]);
                        }
                        return ()=>(0, _vue.h)((0, _vue.Transition), {
                                name: "q-transition--fade",
                                appear: true,
                                onAfterLeave
                            }, getContent);
                    }
                }, Plugin$6.__parentApp);
                vm = app.mount(el);
            }, props.delay);
        }
        return (paramProps)=>{
            if (paramProps === void 0 || Object(paramProps) !== paramProps) {
                Plugin$6.hide(group);
                return;
            }
            Plugin$6.show({
                ...paramProps,
                group
            });
        };
    },
    hide (group) {
        if (Plugin$6.isActive === true) {
            if (group === void 0) activeGroups = {};
            else if (activeGroups[group] === void 0) return;
            else {
                delete activeGroups[group];
                const keys = Object.keys(activeGroups);
                if (keys.length !== 0) {
                    const lastGroup = keys[keys.length - 1];
                    Plugin$6.show({
                        group: lastGroup
                    });
                    return;
                }
            }
            if (timeout !== null) {
                clearTimeout(timeout);
                timeout = null;
            }
            Plugin$6.isActive = false;
        }
    },
    setDefaults (opts) {
        if (isObject(opts) === true) Object.assign(defaults$1, opts);
    },
    install ({ $q, parentApp }) {
        $q.loading = this;
        Plugin$6.__parentApp = parentApp;
        if ($q.config.loading !== void 0) this.setDefaults($q.config.loading);
    }
});
//#endregion
//#region src/plugins/loading-bar/LoadingBar.js
const barRef = (0, _vue.ref)(null);
const Plugin$7 = createReactivePlugin({
    isActive: false
}, {
    start: noop,
    stop: noop,
    increment: noop,
    setDefaults: noop,
    install ({ $q, parentApp }) {
        $q.loadingBar = this;
        if (this.__installed === true) {
            if ($q.config.loadingBar !== void 0) this.setDefaults($q.config.loadingBar);
            return;
        }
        const props = (0, _vue.ref)($q.config.loadingBar !== void 0 ? {
            ...$q.config.loadingBar
        } : {});
        function onStart() {
            Plugin$7.isActive = true;
        }
        function onStop() {
            Plugin$7.isActive = false;
        }
        const el = createGlobalNode("q-loading-bar");
        createChildApp({
            name: "LoadingBar",
            devtools: {
                hide: true
            },
            setup: ()=>()=>(0, _vue.h)(QAjaxBar_default, {
                        ...props.value,
                        onStart,
                        onStop,
                        ref: barRef
                    })
        }, parentApp).mount(el);
        Object.assign(this, {
            start (speed) {
                barRef.value.start(speed);
            },
            stop () {
                barRef.value.stop();
            },
            increment () {
                barRef.value.increment.apply(null, arguments);
            },
            setDefaults (opts) {
                if (isObject(opts) === true) Object.assign(props.value, opts);
            }
        });
    }
});
//#endregion
//#region src/plugins/meta/Meta.js
let updateId = null, currentClientMeta;
const clientList = [];
function normalize(meta) {
    if (meta.title) {
        meta.title = meta.titleTemplate ? meta.titleTemplate(meta.title) : meta.title;
        delete meta.titleTemplate;
    }
    [
        [
            "meta",
            "content"
        ],
        [
            "link",
            "href"
        ]
    ].forEach((type)=>{
        const metaType = meta[type[0]], metaProp = type[1];
        for(const name in metaType){
            const metaLink = metaType[name];
            if (metaLink.template) {
                if (Object.keys(metaLink).length === 1) delete metaType[name];
                else {
                    metaLink[metaProp] = metaLink.template(metaLink[metaProp] || "");
                    delete metaLink.template;
                }
            }
        }
    });
}
function changed(old, def) {
    if (Object.keys(old).length !== Object.keys(def).length) return true;
    for(const key in old)if (old[key] !== def[key]) return true;
}
function bodyFilter(name) {
    return [
        "class",
        "style"
    ].includes(name) === false;
}
function htmlFilter(name) {
    return [
        "lang",
        "dir"
    ].includes(name) === false;
}
function diff(meta, other) {
    const add = {}, remove = {};
    if (meta === void 0) return {
        add: other,
        remove
    };
    if (meta.title !== other.title) add.title = other.title;
    [
        "meta",
        "link",
        "script",
        "htmlAttr",
        "bodyAttr"
    ].forEach((type)=>{
        const old = meta[type], cur = other[type];
        remove[type] = [];
        if (old === void 0 || old === null) {
            add[type] = cur;
            return;
        }
        add[type] = {};
        for(const key in old)if (cur.hasOwnProperty(key) === false) remove[type].push(key);
        for(const key in cur)if (old.hasOwnProperty(key) === false) add[type][key] = cur[key];
        else if (changed(old[key], cur[key]) === true) {
            remove[type].push(key);
            add[type][key] = cur[key];
        }
    });
    return {
        add,
        remove
    };
}
function apply({ add, remove }) {
    if (add.title) document.title = add.title;
    if (Object.keys(remove).length !== 0) {
        [
            "meta",
            "link",
            "script"
        ].forEach((type)=>{
            remove[type].forEach((name)=>{
                document.head.querySelector(`${type}[data-qmeta="${name}"]`).remove();
            });
        });
        remove.htmlAttr.filter(htmlFilter).forEach((name)=>{
            document.documentElement.removeAttribute(name);
        });
        remove.bodyAttr.filter(bodyFilter).forEach((name)=>{
            document.body.removeAttribute(name);
        });
    }
    [
        "meta",
        "link",
        "script"
    ].forEach((type)=>{
        const metaType = add[type];
        for(const name in metaType){
            const tag = document.createElement(type);
            for(const att in metaType[name])if (att !== "innerHTML") tag.setAttribute(att, metaType[name][att]);
            tag.setAttribute("data-qmeta", name);
            if (type === "script") tag.innerHTML = metaType[name].innerHTML || "";
            document.head.appendChild(tag);
        }
    });
    Object.keys(add.htmlAttr).filter(htmlFilter).forEach((name)=>{
        document.documentElement.setAttribute(name, add.htmlAttr[name] || "");
    });
    Object.keys(add.bodyAttr).filter(bodyFilter).forEach((name)=>{
        document.body.setAttribute(name, add.bodyAttr[name] || "");
    });
}
function updateClientMeta() {
    updateId = null;
    const data = {
        title: "",
        titleTemplate: null,
        meta: {},
        link: {},
        script: {},
        htmlAttr: {},
        bodyAttr: {}
    };
    for(let i = 0; i < clientList.length; i++){
        const { active, val } = clientList[i];
        if (active === true) extend(true, data, val);
    }
    normalize(data);
    apply(diff(currentClientMeta, data));
    currentClientMeta = data;
}
function planClientUpdate() {
    if (updateId !== null) clearTimeout(updateId);
    updateId = setTimeout(updateClientMeta, 50);
}
var Meta_default = {
    install (opts) {
        if (this.__installed !== true && isRuntimeSsrPreHydration.value === true) {
            currentClientMeta = window.__Q_META__;
            document.getElementById("qmeta-init").remove();
        }
    }
};
//#endregion
//#region src/plugins/notify/Notify.js
let uid$1 = 0;
const defaults = {};
const groups = {};
const notificationsList = {};
const positionClass = {};
const emptyRE = /^\s*$/;
const notifRefs = [];
const invalidTimeoutValues = [
    void 0,
    null,
    true,
    false,
    ""
];
const positionList = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "top",
    "bottom",
    "left",
    "right",
    "center"
];
const badgePositions = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
];
const notifTypes = {
    positive: {
        icon: ($q)=>$q.iconSet.type.positive,
        color: "positive"
    },
    negative: {
        icon: ($q)=>$q.iconSet.type.negative,
        color: "negative"
    },
    warning: {
        icon: ($q)=>$q.iconSet.type.warning,
        color: "warning",
        textColor: "dark"
    },
    info: {
        icon: ($q)=>$q.iconSet.type.info,
        color: "info"
    },
    ongoing: {
        group: false,
        timeout: 0,
        spinner: true,
        color: "grey-8"
    }
};
function addNotification(config, $q, originalApi) {
    if (!config) return logError("parameter required");
    let Api;
    const notif = {
        textColor: "white"
    };
    if (config.ignoreDefaults !== true) Object.assign(notif, defaults);
    if (isObject(config) === false) {
        if (notif.type) Object.assign(notif, notifTypes[notif.type]);
        config = {
            message: config
        };
    }
    Object.assign(notif, notifTypes[config.type || notif.type], config);
    if (typeof notif.icon === "function") notif.icon = notif.icon($q);
    if (!notif.spinner) notif.spinner = false;
    else {
        if (notif.spinner === true) notif.spinner = QSpinner_default;
        notif.spinner = (0, _vue.markRaw)(notif.spinner);
    }
    notif.meta = {
        hasMedia: Boolean(notif.spinner !== false || notif.icon || notif.avatar),
        hasText: hasContent(notif.message) || hasContent(notif.caption)
    };
    if (notif.position) {
        if (positionList.includes(notif.position) === false) return logError("wrong position", config);
    } else notif.position = "bottom";
    if (invalidTimeoutValues.includes(notif.timeout) === true) notif.timeout = 5e3;
    else {
        const t = Number(notif.timeout);
        if (isNaN(t) || t < 0) return logError("wrong timeout", config);
        notif.timeout = Number.isFinite(t) ? t : 0;
    }
    if (notif.timeout === 0) notif.progress = false;
    else if (notif.progress === true) {
        notif.meta.progressClass = "q-notification__progress" + (notif.progressClass ? ` ${notif.progressClass}` : "");
        notif.meta.progressStyle = {
            animationDuration: `${notif.timeout + 1e3}ms`
        };
    }
    const actions = (Array.isArray(config.actions) === true ? config.actions : []).concat(config.ignoreDefaults !== true && Array.isArray(defaults.actions) === true ? defaults.actions : []).concat(Array.isArray(notifTypes[config.type]?.actions) === true ? notifTypes[config.type].actions : []);
    const { closeBtn } = notif;
    if (closeBtn) actions.push({
        label: typeof closeBtn === "string" ? closeBtn : $q.lang.label.close
    });
    notif.actions = actions.map(({ handler, noDismiss, ...item })=>({
            flat: true,
            ...item,
            onClick: typeof handler === "function" ? ()=>{
                handler();
                if (noDismiss !== true) dismiss();
            } : ()=>{
                dismiss();
            }
        }));
    if (notif.multiLine === void 0) notif.multiLine = notif.actions.length > 1;
    Object.assign(notif.meta, {
        class: `q-notification row items-stretch q-notification--${notif.multiLine === true ? "multi-line" : "standard"}` + (notif.color !== void 0 ? ` bg-${notif.color}` : "") + (notif.textColor !== void 0 ? ` text-${notif.textColor}` : "") + (notif.classes !== void 0 ? ` ${notif.classes}` : ""),
        wrapperClass: "q-notification__wrapper col relative-position border-radius-inherit " + (notif.multiLine === true ? "column no-wrap justify-center" : "row items-center"),
        contentClass: "q-notification__content row items-center" + (notif.multiLine === true ? "" : " col"),
        leftClass: notif.meta.hasText === true ? "additional" : "single",
        attrs: {
            role: "alert",
            ...notif.attrs
        }
    });
    if (notif.group === false) {
        notif.group = void 0;
        notif.meta.group = void 0;
    } else {
        if (notif.group === void 0 || notif.group === true) notif.group = [
            notif.message,
            notif.caption,
            notif.multiline
        ].concat(notif.actions.map((props)=>`${props.label}*${props.icon}`)).join("|");
        notif.meta.group = notif.group + "|" + notif.position;
    }
    if (notif.actions.length === 0) notif.actions = void 0;
    else notif.meta.actionsClass = "q-notification__actions row items-center " + (notif.multiLine === true ? "justify-end" : "col-auto") + (notif.meta.hasMedia === true ? " q-notification__actions--with-media" : "");
    if (originalApi !== void 0) {
        if (originalApi.notif.meta.timer) {
            clearTimeout(originalApi.notif.meta.timer);
            originalApi.notif.meta.timer = void 0;
        }
        notif.meta.uid = originalApi.notif.meta.uid;
        const index = notificationsList[notif.position].value.indexOf(originalApi.notif);
        notificationsList[notif.position].value[index] = notif;
    } else {
        const original = groups[notif.meta.group];
        if (original === void 0) {
            notif.meta.uid = uid$1++;
            notif.meta.badge = 1;
            if ([
                "left",
                "right",
                "center"
            ].indexOf(notif.position) !== -1) notificationsList[notif.position].value.splice(Math.floor(notificationsList[notif.position].value.length / 2), 0, notif);
            else {
                const action = notif.position.indexOf("top") !== -1 ? "unshift" : "push";
                notificationsList[notif.position].value[action](notif);
            }
            if (notif.group !== void 0) groups[notif.meta.group] = notif;
        } else {
            if (original.meta.timer) {
                clearTimeout(original.meta.timer);
                original.meta.timer = void 0;
            }
            if (notif.badgePosition !== void 0) {
                if (badgePositions.includes(notif.badgePosition) === false) return logError("wrong badgePosition", config);
            } else notif.badgePosition = `top-${notif.position.indexOf("left") !== -1 ? "right" : "left"}`;
            notif.meta.uid = original.meta.uid;
            notif.meta.badge = original.meta.badge + 1;
            notif.meta.badgeClass = `q-notification__badge q-notification__badge--${notif.badgePosition}` + (notif.badgeColor !== void 0 ? ` bg-${notif.badgeColor}` : "") + (notif.badgeTextColor !== void 0 ? ` text-${notif.badgeTextColor}` : "") + (notif.badgeClass ? ` ${notif.badgeClass}` : "");
            const index = notificationsList[notif.position].value.indexOf(original);
            notificationsList[notif.position].value[index] = groups[notif.meta.group] = notif;
        }
    }
    const dismiss = ()=>{
        removeNotification(notif);
        Api = void 0;
    };
    if (notif.timeout > 0) notif.meta.timer = setTimeout(()=>{
        notif.meta.timer = void 0;
        dismiss();
    }, notif.timeout + 1e3);
    if (notif.group !== void 0) return (props)=>{
        if (props !== void 0) logError("trying to update a grouped one which is forbidden", config);
        else dismiss();
    };
    Api = {
        dismiss,
        config,
        notif
    };
    if (originalApi !== void 0) {
        Object.assign(originalApi, Api);
        return;
    }
    return (props)=>{
        if (Api !== void 0) {
            if (props === void 0) Api.dismiss();
            else addNotification(Object.assign({}, Api.config, props, {
                group: false,
                position: notif.position
            }), $q, Api);
        }
    };
}
function removeNotification(notif) {
    if (notif.meta.timer) {
        clearTimeout(notif.meta.timer);
        notif.meta.timer = void 0;
    }
    const index = notificationsList[notif.position].value.indexOf(notif);
    if (index !== -1) {
        if (notif.group !== void 0) delete groups[notif.meta.group];
        const el = notifRefs[String(notif.meta.uid)];
        if (el) {
            const { width, height } = getComputedStyle(el);
            el.style.left = `${el.offsetLeft}px`;
            el.style.width = width;
            el.style.height = height;
        }
        notificationsList[notif.position].value.splice(index, 1);
        if (typeof notif.onDismiss === "function") notif.onDismiss();
    }
}
function hasContent(str) {
    return str !== void 0 && str !== null && emptyRE.test(str) !== true;
}
function logError(error, config) {
    console.error(`Notify: ${error}`, config);
    return false;
}
function getComponent() {
    return createComponent({
        name: "QNotifications",
        devtools: {
            hide: true
        },
        setup () {
            return ()=>(0, _vue.h)("div", {
                    class: "q-notifications"
                }, positionList.map((pos)=>(0, _vue.h)((0, _vue.TransitionGroup), {
                        key: pos,
                        class: positionClass[pos],
                        tag: "div",
                        name: `q-notification--${pos}`
                    }, ()=>notificationsList[pos].value.map((notif)=>{
                            const meta = notif.meta;
                            const mainChild = [];
                            if (meta.hasMedia === true) {
                                if (notif.spinner !== false) mainChild.push((0, _vue.h)(notif.spinner, {
                                    class: "q-notification__spinner q-notification__spinner--" + meta.leftClass,
                                    color: notif.spinnerColor,
                                    size: notif.spinnerSize
                                }));
                                else if (notif.icon) mainChild.push((0, _vue.h)(QIcon_default, {
                                    class: "q-notification__icon q-notification__icon--" + meta.leftClass,
                                    name: notif.icon,
                                    color: notif.iconColor,
                                    size: notif.iconSize,
                                    role: "img"
                                }));
                                else if (notif.avatar) mainChild.push((0, _vue.h)(QAvatar_default, {
                                    class: "q-notification__avatar q-notification__avatar--" + meta.leftClass
                                }, ()=>(0, _vue.h)("img", {
                                        src: notif.avatar,
                                        "aria-hidden": "true"
                                    })));
                            }
                            if (meta.hasText === true) {
                                let msgChild;
                                const msgData = {
                                    class: "q-notification__message col"
                                };
                                if (notif.html === true) msgData.innerHTML = notif.caption ? `<div>${notif.message}</div><div class="q-notification__caption">${notif.caption}</div>` : notif.message;
                                else {
                                    const msgNode = [
                                        notif.message
                                    ];
                                    msgChild = notif.caption ? [
                                        (0, _vue.h)("div", msgNode),
                                        (0, _vue.h)("div", {
                                            class: "q-notification__caption"
                                        }, [
                                            notif.caption
                                        ])
                                    ] : msgNode;
                                }
                                mainChild.push((0, _vue.h)("div", msgData, msgChild));
                            }
                            const child = [
                                (0, _vue.h)("div", {
                                    class: meta.contentClass
                                }, mainChild)
                            ];
                            if (notif.progress === true) child.push((0, _vue.h)("div", {
                                key: `${meta.uid}|p|${meta.badge}`,
                                class: meta.progressClass,
                                style: meta.progressStyle
                            }));
                            if (notif.actions !== void 0) child.push((0, _vue.h)("div", {
                                class: meta.actionsClass
                            }, notif.actions.map((props)=>(0, _vue.h)(QBtn_default, props))));
                            if (meta.badge > 1) child.push((0, _vue.h)("div", {
                                key: `${meta.uid}|${meta.badge}`,
                                class: notif.meta.badgeClass,
                                style: notif.badgeStyle
                            }, [
                                meta.badge
                            ]));
                            return (0, _vue.h)("div", {
                                ref: (el)=>{
                                    notifRefs[String(meta.uid)] = el;
                                },
                                key: meta.uid,
                                class: meta.class,
                                ...meta.attrs
                            }, [
                                (0, _vue.h)("div", {
                                    class: meta.wrapperClass
                                }, child)
                            ]);
                        }))));
        }
    });
}
var Notify_default = {
    setDefaults (opts) {
        if (isObject(opts) === true) Object.assign(defaults, opts);
    },
    registerType (typeName, typeOpts) {
        if (isObject(typeOpts) === true) notifTypes[typeName] = typeOpts;
    },
    install ({ $q, parentApp }) {
        $q.notify = this.create = (opts)=>addNotification(opts, $q);
        $q.notify.setDefaults = this.setDefaults;
        $q.notify.registerType = this.registerType;
        if ($q.config.notify !== void 0) this.setDefaults($q.config.notify);
        if (this.__installed !== true) {
            positionList.forEach((pos)=>{
                notificationsList[pos] = (0, _vue.ref)([]);
                const vert = [
                    "left",
                    "center",
                    "right"
                ].includes(pos) === true ? "center" : pos.indexOf("top") !== -1 ? "top" : "bottom", align = pos.indexOf("left") !== -1 ? "start" : pos.indexOf("right") !== -1 ? "end" : "center";
                positionClass[pos] = `q-notifications__list q-notifications__list--${vert} fixed column no-wrap ${[
                    "left",
                    "right"
                ].includes(pos) ? `items-${pos === "left" ? "start" : "end"} justify-center` : pos === "center" ? "flex-center" : `items-${align}`}`;
            });
            const el = createGlobalNode("q-notify");
            createChildApp(getComponent(), parentApp).mount(el);
        }
    }
};
//#endregion
//#region src/plugins/storage/engine/web-storage.js
function encode(value1) {
    if (isDate(value1) === true) return "__q_date|" + value1.getTime();
    if (isRegexp(value1) === true) return "__q_expr|" + value1.source;
    if (typeof value1 === "number") return "__q_numb|" + value1;
    if (typeof value1 === "boolean") return "__q_bool|" + (value1 ? "1" : "0");
    if (typeof value1 === "string") return "__q_strn|" + value1;
    if (typeof value1 === "function") return "__q_strn|" + value1.toString();
    if (value1 === Object(value1)) return "__q_objt|" + JSON.stringify(value1);
    return value1;
}
function decode(value1) {
    if (value1.length < 9) return value1;
    const type = value1.substring(0, 8);
    const source = value1.substring(9);
    switch(type){
        case "__q_date":
            const number = Number(source);
            return new Date(Number.isNaN(number) === true ? source : number);
        case "__q_expr":
            return new RegExp(source);
        case "__q_numb":
            return Number(source);
        case "__q_bool":
            return Boolean(source === "1");
        case "__q_strn":
            return String(source);
        case "__q_objt":
            return JSON.parse(source);
        default:
            return value1;
    }
}
function getEmptyStorage() {
    const getVal = ()=>null;
    return {
        has: ()=>false,
        hasItem: ()=>false,
        getLength: ()=>0,
        getItem: getVal,
        getIndex: getVal,
        getKey: getVal,
        getAll: ()=>{},
        getAllKeys: ()=>[],
        set: noop,
        setItem: noop,
        remove: noop,
        removeItem: noop,
        clear: noop,
        isEmpty: ()=>true
    };
}
function getStorage(type) {
    const webStorage = window[type + "Storage"], get = (key)=>{
        const item = webStorage.getItem(key);
        return item ? decode(item) : null;
    };
    const hasItem = (key)=>webStorage.getItem(key) !== null;
    const setItem = (key, value1)=>{
        webStorage.setItem(key, encode(value1));
    };
    const removeItem = (key)=>{
        webStorage.removeItem(key);
    };
    return {
        has: hasItem,
        hasItem,
        getLength: ()=>webStorage.length,
        getItem: get,
        getIndex: (index)=>index < webStorage.length ? get(webStorage.key(index)) : null,
        getKey: (index)=>index < webStorage.length ? webStorage.key(index) : null,
        getAll: ()=>{
            let key;
            const result = {}, len = webStorage.length;
            for(let i = 0; i < len; i++){
                key = webStorage.key(i);
                result[key] = get(key);
            }
            return result;
        },
        getAllKeys: ()=>{
            const result = [], len = webStorage.length;
            for(let i = 0; i < len; i++)result.push(webStorage.key(i));
            return result;
        },
        set: setItem,
        setItem,
        remove: removeItem,
        removeItem,
        clear: ()=>{
            webStorage.clear();
        },
        isEmpty: ()=>webStorage.length === 0
    };
}
//#endregion
//#region src/plugins/storage/LocalStorage.js
const storage$1 = client.has.webStorage === false ? getEmptyStorage() : getStorage("local");
const Plugin$8 = {
    install ({ $q }) {
        $q.localStorage = storage$1;
    }
};
Object.assign(Plugin$8, storage$1);
//#endregion
//#region src/plugins/storage/SessionStorage.js
const storage = client.has.webStorage === false ? getEmptyStorage() : getStorage("session");
const Plugin$9 = {
    install ({ $q }) {
        $q.sessionStorage = storage;
    }
};
Object.assign(Plugin$9, storage);
//#endregion
//#region src/composables/use-dialog-plugin-component/use-dialog-plugin-component.js
function useDialogPluginComponent() {
    const { emit, proxy } = (0, _vue.getCurrentInstance)();
    const dialogRef = (0, _vue.ref)(null);
    function show() {
        dialogRef.value.show();
    }
    function hide() {
        dialogRef.value.hide();
    }
    function onDialogOK(payload) {
        emit("ok", payload);
        hide();
    }
    function onDialogHide() {
        emit("hide");
    }
    Object.assign(proxy, {
        show,
        hide
    });
    return {
        dialogRef,
        onDialogHide,
        onDialogOK,
        onDialogCancel: hide
    };
}
const emits = [
    "ok",
    "hide"
];
useDialogPluginComponent.emits = emits;
useDialogPluginComponent.emitsObject = getEmitsObject(emits);
//#endregion
//#region src/composables/use-meta/use-meta.js
function useMeta(metaOptions) {
    {
        const meta = {
            active: true
        };
        if (typeof metaOptions === "function") {
            const content = (0, _vue.computed)(metaOptions);
            meta.val = content.value;
            (0, _vue.watch)(content, (val)=>{
                meta.val = val;
                if (meta.active === true) planClientUpdate();
            });
        } else meta.val = metaOptions;
        clientList.push(meta);
        planClientUpdate();
        (0, _vue.onActivated)(()=>{
            meta.active = true;
            planClientUpdate();
        });
        (0, _vue.onDeactivated)(()=>{
            meta.active = false;
            planClientUpdate();
        });
        (0, _vue.onUnmounted)(()=>{
            clientList.splice(clientList.indexOf(meta), 1);
            planClientUpdate();
        });
    }
}
//#endregion
//#region src/composables/use-quasar/use-quasar.js
/**
* Returns the $q instance.
* Equivalent to `this.$q` inside templates.
*/ function useQuasar() {
    return (0, _vue.inject)("_q_");
}
//#endregion
//#region src/composables/use-interval/use-interval.js
function useInterval() {
    let timer = null;
    const vm = (0, _vue.getCurrentInstance)();
    function removeInterval() {
        if (timer !== null) {
            clearInterval(timer);
            timer = null;
        }
    }
    (0, _vue.onDeactivated)(removeInterval);
    (0, _vue.onBeforeUnmount)(removeInterval);
    return {
        removeInterval,
        registerInterval (fn, delay) {
            removeInterval();
            if (vmIsDestroyed(vm) === false) timer = setInterval(fn, delay);
        }
    };
}
//#endregion
//#region src/utils/copy-to-clipboard/copy-to-clipboard.js
function fallback(text) {
    const area = document.createElement("textarea");
    area.value = text;
    area.contentEditable = "true";
    area.style.position = "fixed";
    const fn = ()=>{};
    addFocusout(fn);
    document.body.appendChild(area);
    area.focus();
    area.select();
    const res = document.execCommand("copy");
    area.remove();
    removeFocusout(fn);
    return res;
}
function copyToClipboard(text) {
    return navigator.clipboard !== void 0 ? navigator.clipboard.writeText(text) : new Promise((resolve, reject)=>{
        const res = fallback(text);
        if (res) resolve(true);
        else reject(res);
    });
}
//#endregion
//#region src/utils/create-meta-mixin/create-meta-mixin.js
var create_meta_mixin_default = (metaOptions)=>{
    const mixin = {
        activated () {
            this.__qMeta.active = true;
            planClientUpdate();
        },
        deactivated () {
            this.__qMeta.active = false;
            planClientUpdate();
        },
        unmounted () {
            clientList.splice(clientList.indexOf(this.__qMeta), 1);
            planClientUpdate();
            this.__qMeta = void 0;
        }
    };
    if (typeof metaOptions === "function") Object.assign(mixin, {
        computed: {
            __qMetaOptions () {
                return metaOptions.call(this) || {};
            }
        },
        watch: {
            __qMetaOptions (val) {
                this.__qMeta.val = val;
                if (this.__qMeta.active === true) planClientUpdate();
            }
        },
        created () {
            this.__qMeta = {
                active: true,
                val: this.__qMetaOptions
            };
            clientList.push(this.__qMeta);
            planClientUpdate();
        }
    });
    else mixin.created = function created() {
        this.__qMeta = {
            active: true,
            val: metaOptions
        };
        clientList.push(this.__qMeta);
        planClientUpdate();
    };
    return mixin;
};
//#endregion
//#region src/utils/EventBus/EventBus.js
/**
* Forked from tiny-emitter
* Copyright (c) 2017 Scott Corgan
*/ var EventBus = class {
    constructor(){
        this.__stack = {};
    }
    on(name, callback, ctx) {
        (this.__stack[name] || (this.__stack[name] = [])).push({
            fn: callback,
            ctx
        });
        return this;
    }
    once(name, callback, ctx) {
        const listener = (...args)=>{
            this.off(name, listener);
            callback.apply(ctx, args);
        };
        listener.__callback = callback;
        return this.on(name, listener, ctx);
    }
    emit(name) {
        const list = this.__stack[name];
        if (list !== void 0) {
            const params = [].slice.call(arguments, 1);
            list.forEach((entry)=>{
                entry.fn.apply(entry.ctx, params);
            });
        }
        return this;
    }
    off(name, callback) {
        const list = this.__stack[name];
        if (list === void 0) return this;
        if (callback === void 0) {
            delete this.__stack[name];
            return this;
        }
        const liveEvents = list.filter((entry)=>entry.fn !== callback && entry.fn.__callback !== callback);
        if (liveEvents.length !== 0) this.__stack[name] = liveEvents;
        else delete this.__stack[name];
        return this;
    }
};
//#endregion
//#region src/utils/export-file/export-file.js
function clean(link) {
    setTimeout(()=>{
        window.URL.revokeObjectURL(link.href);
    }, 1e4);
    link.remove();
}
/**
* Forces browser to download file with specified content
*
* @param {*} fileName - String
* @param {*} rawData - String | ArrayBuffer | ArrayBufferView | Blob
* @param {*} opts - String (mimeType) or Object
*                   Object form: { mimeType?: String, byteOrderMark?: String | Uint8Array, encoding?: String }
* @returns Boolean | Error
*
* mimeType       - Examples: 'application/octect-stream' (default), 'text/plain', 'application/json',
*                  'text/plain;charset=UTF-8', 'video/mp4', 'image/png', 'application/pdf'
*                  https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
*
* byteOrderMark  - (BOM) Example: '\uFEFF'
*                  https://en.wikipedia.org/wiki/Byte_order_mark
*
* encoding       - Performs a TextEncoder.encode() over the rawData;
*                  Example: 'windows-1252' (ANSI, a subset of ISO-8859-1)
*                  https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder
*/ function exportFile(fileName, rawData, opts = {}) {
    const { mimeType, byteOrderMark, encoding } = typeof opts === "string" ? {
        mimeType: opts
    } : opts;
    const data = encoding !== void 0 ? new TextEncoder(encoding).encode([
        rawData
    ]) : rawData;
    const blob = new Blob(byteOrderMark !== void 0 ? [
        byteOrderMark,
        data
    ] : [
        data
    ], {
        type: mimeType || "application/octet-stream"
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", fileName);
    if (typeof link.download === "undefined") link.setAttribute("target", "_blank");
    link.classList.add("hidden");
    link.style.position = "fixed";
    document.body.appendChild(link);
    try {
        link.click();
        clean(link);
        return true;
    } catch (err) {
        clean(link);
        return err;
    }
}
//#endregion
//#region src/utils/open-url/open-url.js
function parseFeatures(winFeatures) {
    const cfg = Object.assign({
        noopener: true
    }, winFeatures);
    const feat = [];
    for(const key in cfg){
        const value1 = cfg[key];
        if (value1 === true) feat.push(key);
        else if (isNumber(value1) || typeof value1 === "string" && value1 !== "") feat.push(key + "=" + value1);
    }
    return feat.join(",");
}
function openWindow(url, reject, windowFeatures) {
    let open = window.open;
    if (Platform.is.cordova === true) {
        if (cordova?.InAppBrowser?.open !== void 0) open = cordova.InAppBrowser.open;
        else if (navigator?.app !== void 0) return navigator.app.loadUrl(url, {
            openExternal: true
        });
    }
    const cfg = Object.assign({
        noopener: true
    }, windowFeatures);
    const hasNoopener = cfg.noopener === true || cfg.noreferrer === true;
    const win = open(url, "_blank", parseFeatures(windowFeatures));
    if (win) {
        if (Platform.is.desktop) win.focus();
        return win;
    } else if (hasNoopener === false) reject?.();
}
var open_url_default = (url, reject, windowFeatures)=>{
    if (Platform.is.ios === true && window.SafariViewController !== void 0) {
        window.SafariViewController.isAvailable((available)=>{
            if (available) window.SafariViewController.show({
                url
            }, noop, reject);
            else openWindow(url, reject, windowFeatures);
        });
        return;
    }
    return openWindow(url, reject, windowFeatures);
};
//#endregion
//#region src/utils/run-sequential-promises/run-sequential-promises.js
function parsePromises(sequentialPromises) {
    const isList = Array.isArray(sequentialPromises);
    if (isList === true) {
        const totalJobs = sequentialPromises.length;
        return {
            isList,
            totalJobs,
            resultAggregator: Array(totalJobs).fill(null)
        };
    }
    const resultKeys = Object.keys(sequentialPromises);
    const resultAggregator = {};
    resultKeys.forEach((keyName)=>{
        resultAggregator[keyName] = null;
    });
    return {
        isList,
        totalJobs: resultKeys.length,
        resultAggregator,
        resultKeys
    };
}
/**
* Run a list of Promises sequentially, optionally on multiple threads.
*
* @param {*} sequentialPromises - Array of Functions or Object with Functions as values
*                          Array of Function form: [ (resultAggregator: Array) => Promise<any>, ... ]
*                          Object form: { [key: string]: (resultAggregator: object) => Promise<any>, ... }
* @param {*} opts - Optional options Object
*                   Object form: { threadsNumber?: number, abortOnFail?: boolean }
*                   Default: { threadsNumber: 1, abortOnFail: true }
*                   When configuring threadsNumber AND using http requests, be
*                       aware of the maximum threads that the hosting browser
*                       supports (usually 5); any number of threads above that
*                       won't add any real benefits
* @returns Promise<Array<Object> | Object>
*    With opts.abortOnFail set to true (which is default):
*        When sequentialPromises param is Array:
*          The Promise resolves with an Array of Objects of the following form:
*             [ { key: number, status: 'fulfilled', value: any }, ... ]
*          The Promise rejects with an Object of the following form:
*             { key: number, status: 'rejected', reason: Error, resultAggregator: array }
*        When sequentialPromises param is Object:
*          The Promise resolves with an Object of the following form:
*             { [key: string]: { key: string, status: 'fulfilled', value: any }, ... }
*          The Promise rejects with an Object of the following form:
*             { key: string, status: 'rejected', reason: Error, resultAggregator: object }
*    With opts.abortOnFail set to false:
*       The Promise is never rejected (no catch() needed)
*       The Promise resolves with:
*          An Array of Objects (when sequentialPromises param is also an Array) of the following form:
*             [ { key: number, status: 'fulfilled', value: any } | { status: 'rejected', reason: Error }, ... ]
*          An Object (when sequentialPromises param is also an Object) of the following form:
*             { [key: string]: { key: string, status: 'fulfilled', value: any } | { key: string, status: 'rejected', reason: Error }, ... }
*/ function runSequentialPromises(sequentialPromises, { threadsNumber = 1, abortOnFail = true } = {}) {
    let jobIndex = -1, hasAborted = false;
    const { isList, totalJobs, resultAggregator, resultKeys } = parsePromises(sequentialPromises);
    const getPromiseThread = ()=>new Promise((resolve, reject)=>{
            function runNextPromise() {
                const currentJobIndex = ++jobIndex;
                if (hasAborted === true || currentJobIndex >= totalJobs) {
                    resolve();
                    return;
                }
                const key = isList === true ? currentJobIndex : resultKeys[currentJobIndex];
                sequentialPromises[key](resultAggregator).then((value1)=>{
                    if (hasAborted === true) {
                        resolve();
                        return;
                    }
                    resultAggregator[key] = {
                        key,
                        status: "fulfilled",
                        value: value1
                    };
                    setTimeout(runNextPromise);
                }).catch((reason)=>{
                    if (hasAborted === true) {
                        resolve();
                        return;
                    }
                    const result = {
                        key,
                        status: "rejected",
                        reason
                    };
                    resultAggregator[key] = result;
                    if (abortOnFail === true) {
                        hasAborted = true;
                        reject({
                            ...result,
                            resultAggregator
                        });
                        return;
                    }
                    setTimeout(runNextPromise);
                });
            }
            runNextPromise();
        });
    const threads = Array(Math.min(totalJobs, threadsNumber)).fill(null).map(getPromiseThread);
    return Promise.all(threads).then(()=>resultAggregator);
}
//#endregion
//#region src/index.dev.js
const Quasar = {
    version: "2.19.3",
    install: install_quasar_default,
    lang: Plugin$5,
    iconSet: Plugin$4
};

},{"vue":"fypEC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"jVJP6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    isoName: "pt-BR",
    nativeName: "Portugu\xeas (BR)",
    label: {
        clear: "Limpar",
        ok: "OK",
        cancel: "Cancelar",
        close: "Fechar",
        set: "Escolher",
        select: "Selecionar",
        reset: "Redefinir",
        remove: "Remover",
        update: "Atualizar",
        create: "Criar",
        search: "Buscar",
        filter: "Filtrar",
        refresh: "Recarregar",
        expand: (label)=>label ? `Expandir "${label}"` : "Expandir",
        collapse: (label)=>label ? `Recolher "${label}"` : "Colapso"
    },
    date: {
        days: "Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),
        daysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),
        months: "Janeiro_Fevereiro_Mar\xe7o_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
        firstDayOfWeek: 0,
        format24h: true,
        pluralDay: "dias",
        prevMonth: "M\xeas passado",
        nextMonth: "M\xeas que vem",
        prevYear: "Ano passado",
        nextYear: "Ano que vem",
        today: "Hoje",
        prevRangeYears: (range)=>`Anterior ${range}  Anos`,
        nextRangeYears: (range)=>`Pr\xf3ximo ${range} Anos`
    },
    table: {
        noData: "Sem dados dispon\xedveis",
        noResults: "Nenhum dado correspondente encontrado",
        loading: "Carregando...",
        selectedRecords: (rows)=>rows > 0 ? rows + " registro" + (rows === 1 ? " selecionado" : "s selecionados") + "." : "Nenhum registro selecionado.",
        recordsPerPage: "Registros por p\xe1gina:",
        allRows: "Todos",
        pagination: (start, end, total)=>start + "-" + end + " de " + total,
        columns: "Colunas"
    },
    pagination: {
        first: "Primeira p\xe1gina",
        prev: "P\xe1gina anterior",
        next: "Pr\xf3xima p\xe1gina",
        last: "\xdaltima p\xe1gina"
    },
    editor: {
        url: "URL",
        bold: "Negrito",
        italic: "It\xe1lico",
        strikethrough: "Riscado",
        underline: "Sublinhado",
        unorderedList: "Lista n\xe3o-ordenada",
        orderedList: "Lista ordenada",
        subscript: "Subscrito",
        superscript: "Sobrescrito",
        hyperlink: "Hyperlink",
        toggleFullscreen: "Tela cheia",
        quote: "Cita\xe7\xe3o",
        left: "Alinhado \xe0 esquerda",
        center: "Alinhado ao centro",
        right: "Alinhado \xe0 direita",
        justify: "Justificado",
        print: "Imprimir",
        outdent: "Diminuir indenta\xe7\xe3o",
        indent: "Aumentar indenta\xe7\xe3o",
        removeFormat: "Remover formata\xe7\xe3o",
        formatting: "Formata\xe7\xe3o",
        fontSize: "Tamanho de fonte",
        align: "Alinhar",
        hr: "Inserir divis\xf3ria horizontal",
        undo: "Desfazer",
        redo: "Refazer",
        heading1: "Cabe\xe7alho 1",
        heading2: "Cabe\xe7alho 2",
        heading3: "Cabe\xe7alho 3",
        heading4: "Cabe\xe7alho 4",
        heading5: "Cabe\xe7alho 5",
        heading6: "Cabe\xe7alho 6",
        paragraph: "Par\xe1grafo",
        code: "C\xf3digo",
        size1: "Muito pequeno",
        size2: "Pequeno",
        size3: "Normal",
        size4: "M\xe9dio",
        size5: "Grande",
        size6: "Enorme",
        size7: "M\xe1ximo",
        defaultFont: "Fonte padr\xe3o",
        viewSource: "Exibir fonte"
    },
    tree: {
        noNodes: "Sem n\xf3s dispon\xedveis",
        noResults: "Nenhum n\xf3 correspondente encontrado"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"75Ynz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoAnimatePlugin", ()=>autoAnimatePlugin);
parcelHelpers.export(exports, "useAutoAnimate", ()=>useAutoAnimate);
parcelHelpers.export(exports, "vAutoAnimate", ()=>vAutoAnimate);
var _autoAnimatePluginJs = require("./autoAnimatePlugin.js");
var _autoAnimatePluginJsDefault = parcelHelpers.interopDefault(_autoAnimatePluginJs);
var _vue = require("vue");
const vAutoAnimate = (0, _autoAnimatePluginJs.vAutoAnimate);
const autoAnimatePlugin = {
    install (app) {
        app.directive("auto-animate", vAutoAnimate);
    }
};
/**
 * AutoAnimate hook for adding dead-simple transitions and animations to Vue.
 * @param options - Auto animate options or a plugin
 * @returns A template ref. Use the `ref` attribute of your parent element
 * to store the element in this template ref.
 */ function useAutoAnimate(options) {
    const element = (0, _vue.ref)();
    let controller;
    function setEnabled(enabled) {
        if (controller) enabled ? controller.enable() : controller.disable();
    }
    (0, _vue.onMounted)(()=>{
        (0, _vue.watchEffect)(()=>{
            if (element.value instanceof HTMLElement) controller = (0, _autoAnimatePluginJsDefault.default)(element.value, options || {});
        });
    });
    return [
        element,
        setEnabled
    ];
}

},{"./autoAnimatePlugin.js":"2htr3","vue":"fypEC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2htr3":[function(require,module,exports) {
/**
 * A set of all the parents currently being observe. This is the only non weak
 * registry.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>autoAnimate);
parcelHelpers.export(exports, "getTransitionSizes", ()=>getTransitionSizes);
parcelHelpers.export(exports, "vAutoAnimate", ()=>vAutoAnimate);
const parents = new Set();
/**
 * Element coordinates that is constantly kept up to date.
 */ const coords = new WeakMap();
/**
 * Siblings of elements that have been removed from the dom.
 */ const siblings = new WeakMap();
/**
 * Animations that are currently running.
 */ const animations = new WeakMap();
/**
 * A map of existing intersection observers used to track element movements.
 */ const intersections = new WeakMap();
/**
 * Intervals for automatically checking the position of elements occasionally.
 */ const intervals = new WeakMap();
/**
 * The configuration options for each group of elements.
 */ const options = new WeakMap();
/**
 * Debounce counters by id, used to debounce calls to update positions.
 */ const debounces = new WeakMap();
/**
 * All parents that are currently enabled are tracked here.
 */ const enabled = new WeakSet();
/**
 * The document used to calculate transitions.
 */ let root;
/**
 * The root’s XY scroll positions.
 */ let scrollX = 0;
let scrollY = 0;
/**
 * Used to sign an element as the target.
 */ const TGT = "__aa_tgt";
/**
 * Used to sign an element as being part of a removal.
 */ const DEL = "__aa_del";
/**
 * Used to sign an element as being "new". When an element is removed from the
 * dom, but may cycle back in we can sign it with new to ensure the next time
 * it is recognized we consider it new.
 */ const NEW = "__aa_new";
/**
 * Callback for handling all mutations.
 * @param mutations - A mutation list
 */ const handleMutations = (mutations)=>{
    const elements = getElements(mutations);
    // If elements is "false" that means this mutation that should be ignored.
    if (elements) elements.forEach((el)=>animate(el));
};
/**
 *
 * @param entries - Elements that have been resized.
 */ const handleResizes = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.target === root) updateAllPos();
        if (coords.has(entry.target)) updatePos(entry.target);
    });
};
/**
 * Observe this elements position.
 * @param el - The element to observe the position of.
 */ function observePosition(el) {
    const oldObserver = intersections.get(el);
    oldObserver === null || oldObserver === void 0 || oldObserver.disconnect();
    let rect = coords.get(el);
    let invocations = 0;
    const buffer = 5;
    if (!rect) {
        rect = getCoords(el);
        coords.set(el, rect);
    }
    const { offsetWidth, offsetHeight } = root;
    const rootMargins = [
        rect.top - buffer,
        offsetWidth - (rect.left + buffer + rect.width),
        offsetHeight - (rect.top + buffer + rect.height),
        rect.left - buffer
    ];
    const rootMargin = rootMargins.map((px)=>`${-1 * Math.floor(px)}px`).join(" ");
    const observer = new IntersectionObserver(()=>{
        ++invocations > 1 && updatePos(el);
    }, {
        root,
        threshold: 1,
        rootMargin
    });
    observer.observe(el);
    intersections.set(el, observer);
}
/**
 * Update the exact position of a given element.
 * @param el - An element to update the position of.
 */ function updatePos(el) {
    clearTimeout(debounces.get(el));
    const optionsOrPlugin = getOptions(el);
    const delay = isPlugin(optionsOrPlugin) ? 500 : optionsOrPlugin.duration;
    debounces.set(el, setTimeout(async ()=>{
        const currentAnimation = animations.get(el);
        try {
            await (currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.finished);
            coords.set(el, getCoords(el));
            observePosition(el);
        } catch  {
        // ignore errors as the `.finished` promise is rejected when animations were cancelled
        }
    }, delay));
}
/**
 * Updates all positions that are currently being tracked.
 */ function updateAllPos() {
    clearTimeout(debounces.get(root));
    debounces.set(root, setTimeout(()=>{
        parents.forEach((parent)=>forEach(parent, (el)=>lowPriority(()=>updatePos(el))));
    }, 100));
}
/**
 * Its possible for a quick scroll or other fast events to get past the
 * intersection observer, so occasionally we need want "cold-poll" for the
 * latests and greatest position. We try to do this in the most non-disruptive
 * fashion possible. First we only do this ever couple seconds, staggard by a
 * random offset.
 * @param el - Element
 */ function poll(el) {
    setTimeout(()=>{
        intervals.set(el, setInterval(()=>lowPriority(updatePos.bind(null, el)), 2000));
    }, Math.round(2000 * Math.random()));
}
/**
 * Perform some operation that is non critical at some point.
 * @param callback
 */ function lowPriority(callback) {
    if (typeof requestIdleCallback === "function") requestIdleCallback(()=>callback());
    else requestAnimationFrame(()=>callback());
}
/**
 * The mutation observer responsible for watching each root element.
 */ let mutations;
/**
 * A resize observer, responsible for recalculating elements on resize.
 */ let resize;
/**
 * Ensure the browser is supported.
 */ const supportedBrowser = typeof window !== "undefined" && "ResizeObserver" in window;
/**
 * If this is in a browser, initialize our Web APIs
 */ if (supportedBrowser) {
    root = document.documentElement;
    mutations = new MutationObserver(handleMutations);
    resize = new ResizeObserver(handleResizes);
    window.addEventListener("scroll", ()=>{
        scrollY = window.scrollY;
        scrollX = window.scrollX;
    });
    resize.observe(root);
}
/**
 * Retrieves all the elements that may have been affected by the last mutation
 * including ones that have been removed and are no longer in the DOM.
 * @param mutations - A mutation list.
 * @returns
 */ function getElements(mutations) {
    const observedNodes = mutations.reduce((nodes, mutation)=>{
        return [
            ...nodes,
            ...Array.from(mutation.addedNodes),
            ...Array.from(mutation.removedNodes)
        ];
    }, []);
    // Short circuit if _only_ comment nodes are observed
    const onlyCommentNodesObserved = observedNodes.every((node)=>node.nodeName === "#comment");
    if (onlyCommentNodesObserved) return false;
    return mutations.reduce((elements, mutation)=>{
        // Short circuit if we find a purposefully deleted node.
        if (elements === false) return false;
        if (mutation.target instanceof Element) {
            target(mutation.target);
            if (!elements.has(mutation.target)) {
                elements.add(mutation.target);
                for(let i = 0; i < mutation.target.children.length; i++){
                    const child = mutation.target.children.item(i);
                    if (!child) continue;
                    if (DEL in child) return false;
                    target(mutation.target, child);
                    elements.add(child);
                }
            }
            if (mutation.removedNodes.length) for(let i = 0; i < mutation.removedNodes.length; i++){
                const child = mutation.removedNodes[i];
                if (DEL in child) return false;
                if (child instanceof Element) {
                    elements.add(child);
                    target(mutation.target, child);
                    siblings.set(child, [
                        mutation.previousSibling,
                        mutation.nextSibling
                    ]);
                }
            }
        }
        return elements;
    }, new Set());
}
/**
 * Assign the target to an element.
 * @param el - The root element
 * @param child
 */ function target(el, child) {
    if (!child && !(TGT in el)) Object.defineProperty(el, TGT, {
        value: el
    });
    else if (child && !(TGT in child)) Object.defineProperty(child, TGT, {
        value: el
    });
}
/**
 * Determines what kind of change took place on the given element and then
 * performs the proper animation based on that.
 * @param el - The specific element to animate.
 */ function animate(el) {
    var _a;
    const isMounted = el.isConnected;
    const preExisting = coords.has(el);
    if (isMounted && siblings.has(el)) siblings.delete(el);
    if (animations.has(el)) (_a = animations.get(el)) === null || _a === void 0 || _a.cancel();
    if (NEW in el) add(el);
    else if (preExisting && isMounted) remain(el);
    else if (preExisting && !isMounted) remove(el);
    else add(el);
}
/**
 * Removes all non-digits from a string and casts to a number.
 * @param str - A string containing a pixel value.
 * @returns
 */ function raw(str) {
    return Number(str.replace(/[^0-9.\-]/g, ""));
}
/**
 * Get the scroll offset of elements
 * @param el - Element
 * @returns
 */ function getScrollOffset(el) {
    let p = el.parentElement;
    while(p){
        if (p.scrollLeft || p.scrollTop) return {
            x: p.scrollLeft,
            y: p.scrollTop
        };
        p = p.parentElement;
    }
    return {
        x: 0,
        y: 0
    };
}
/**
 * Get the coordinates of elements adjusted for scroll position.
 * @param el - Element
 * @returns
 */ function getCoords(el) {
    const rect = el.getBoundingClientRect();
    const { x, y } = getScrollOffset(el);
    return {
        top: rect.top + y,
        left: rect.left + x,
        width: rect.width,
        height: rect.height
    };
}
/**
 * Returns the width/height that the element should be transitioned between.
 * This takes into account box-sizing.
 * @param el - Element being animated
 * @param oldCoords - Old set of Coordinates coordinates
 * @param newCoords - New set of Coordinates coordinates
 * @returns
 */ function getTransitionSizes(el, oldCoords, newCoords) {
    let widthFrom = oldCoords.width;
    let heightFrom = oldCoords.height;
    let widthTo = newCoords.width;
    let heightTo = newCoords.height;
    const styles = getComputedStyle(el);
    const sizing = styles.getPropertyValue("box-sizing");
    if (sizing === "content-box") {
        const paddingY = raw(styles.paddingTop) + raw(styles.paddingBottom) + raw(styles.borderTopWidth) + raw(styles.borderBottomWidth);
        const paddingX = raw(styles.paddingLeft) + raw(styles.paddingRight) + raw(styles.borderRightWidth) + raw(styles.borderLeftWidth);
        widthFrom -= paddingX;
        widthTo -= paddingX;
        heightFrom -= paddingY;
        heightTo -= paddingY;
    }
    return [
        widthFrom,
        widthTo,
        heightFrom,
        heightTo
    ].map(Math.round);
}
/**
 * Retrieves animation options for the current element.
 * @param el - Element to retrieve options for.
 * @returns
 */ function getOptions(el) {
    return TGT in el && options.has(el[TGT]) ? options.get(el[TGT]) : {
        duration: 250,
        easing: "ease-in-out"
    };
}
/**
 * Returns the target of a given animation (generally the parent).
 * @param el - An element to check for a target
 * @returns
 */ function getTarget(el) {
    if (TGT in el) return el[TGT];
    return undefined;
}
/**
 * Checks if animations are enabled or disabled for a given element.
 * @param el - Any element
 * @returns
 */ function isEnabled(el) {
    const target = getTarget(el);
    return target ? enabled.has(target) : false;
}
/**
 * Iterate over the children of a given parent.
 * @param parent - A parent element
 * @param callback - A callback
 */ function forEach(parent, ...callbacks) {
    callbacks.forEach((callback)=>callback(parent, options.has(parent)));
    for(let i = 0; i < parent.children.length; i++){
        const child = parent.children.item(i);
        if (child) callbacks.forEach((callback)=>callback(child, options.has(child)));
    }
}
/**
 * Always return tuple to provide consistent interface
 */ function getPluginTuple(pluginReturn) {
    if (Array.isArray(pluginReturn)) return pluginReturn;
    return [
        pluginReturn
    ];
}
/**
 * Determine if config is plugin
 */ function isPlugin(config) {
    return typeof config === "function";
}
/**
 * The element in question is remaining in the DOM.
 * @param el - Element to flip
 * @returns
 */ function remain(el) {
    const oldCoords = coords.get(el);
    const newCoords = getCoords(el);
    if (!isEnabled(el)) return coords.set(el, newCoords);
    let animation;
    if (!oldCoords) return;
    const pluginOrOptions = getOptions(el);
    if (typeof pluginOrOptions !== "function") {
        const deltaX = oldCoords.left - newCoords.left;
        const deltaY = oldCoords.top - newCoords.top;
        const [widthFrom, widthTo, heightFrom, heightTo] = getTransitionSizes(el, oldCoords, newCoords);
        const start = {
            transform: `translate(${deltaX}px, ${deltaY}px)`
        };
        const end = {
            transform: `translate(0, 0)`
        };
        if (widthFrom !== widthTo) {
            start.width = `${widthFrom}px`;
            end.width = `${widthTo}px`;
        }
        if (heightFrom !== heightTo) {
            start.height = `${heightFrom}px`;
            end.height = `${heightTo}px`;
        }
        animation = el.animate([
            start,
            end
        ], {
            duration: pluginOrOptions.duration,
            easing: pluginOrOptions.easing
        });
    } else {
        const [keyframes] = getPluginTuple(pluginOrOptions(el, "remain", oldCoords, newCoords));
        animation = new Animation(keyframes);
        animation.play();
    }
    animations.set(el, animation);
    coords.set(el, newCoords);
    animation.addEventListener("finish", updatePos.bind(null, el));
}
/**
 * Adds the element with a transition.
 * @param el - Animates the element being added.
 */ function add(el) {
    if (NEW in el) delete el[NEW];
    const newCoords = getCoords(el);
    coords.set(el, newCoords);
    const pluginOrOptions = getOptions(el);
    if (!isEnabled(el)) return;
    let animation;
    if (typeof pluginOrOptions !== "function") animation = el.animate([
        {
            transform: "scale(.98)",
            opacity: 0
        },
        {
            transform: "scale(0.98)",
            opacity: 0,
            offset: 0.5
        },
        {
            transform: "scale(1)",
            opacity: 1
        }
    ], {
        duration: pluginOrOptions.duration * 1.5,
        easing: "ease-in"
    });
    else {
        const [keyframes] = getPluginTuple(pluginOrOptions(el, "add", newCoords));
        animation = new Animation(keyframes);
        animation.play();
    }
    animations.set(el, animation);
    animation.addEventListener("finish", updatePos.bind(null, el));
}
/**
 * Clean up after removing an element from the dom.
 * @param el - Element being removed
 * @param styles - Optional styles that should be removed from the element.
 */ function cleanUp(el, styles) {
    var _a;
    el.remove();
    coords.delete(el);
    siblings.delete(el);
    animations.delete(el);
    (_a = intersections.get(el)) === null || _a === void 0 || _a.disconnect();
    setTimeout(()=>{
        if (DEL in el) delete el[DEL];
        Object.defineProperty(el, NEW, {
            value: true,
            configurable: true
        });
        if (styles && el instanceof HTMLElement) for(const style in styles)el.style[style] = "";
    }, 0);
}
/**
 * Animates the removal of an element.
 * @param el - Element to remove
 */ function remove(el) {
    var _a;
    if (!siblings.has(el) || !coords.has(el)) return;
    const [prev, next] = siblings.get(el);
    Object.defineProperty(el, DEL, {
        value: true,
        configurable: true
    });
    const finalX = window.scrollX;
    const finalY = window.scrollY;
    if (next && next.parentNode && next.parentNode instanceof Element) next.parentNode.insertBefore(el, next);
    else if (prev && prev.parentNode) prev.parentNode.appendChild(el);
    else (_a = getTarget(el)) === null || _a === void 0 || _a.appendChild(el);
    if (!isEnabled(el)) return cleanUp(el);
    const [top, left, width, height] = deletePosition(el);
    const optionsOrPlugin = getOptions(el);
    const oldCoords = coords.get(el);
    if (finalX !== scrollX || finalY !== scrollY) adjustScroll(el, finalX, finalY, optionsOrPlugin);
    let animation;
    let styleReset = {
        position: "absolute",
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        margin: "0",
        pointerEvents: "none",
        transformOrigin: "center",
        zIndex: "100"
    };
    if (!isPlugin(optionsOrPlugin)) {
        Object.assign(el.style, styleReset);
        animation = el.animate([
            {
                transform: "scale(1)",
                opacity: 1
            },
            {
                transform: "scale(.98)",
                opacity: 0
            }
        ], {
            duration: optionsOrPlugin.duration,
            easing: "ease-out"
        });
    } else {
        const [keyframes, options] = getPluginTuple(optionsOrPlugin(el, "remove", oldCoords));
        if ((options === null || options === void 0 ? void 0 : options.styleReset) !== false) {
            styleReset = (options === null || options === void 0 ? void 0 : options.styleReset) || styleReset;
            Object.assign(el.style, styleReset);
        }
        animation = new Animation(keyframes);
        animation.play();
    }
    animations.set(el, animation);
    animation.addEventListener("finish", cleanUp.bind(null, el, styleReset));
}
/**
 * If the element being removed is at the very bottom of the page, and the
 * the page was scrolled into a space being "made available" by the element
 * that was removed, the page scroll will have jumped up some amount. We need
 * to offset the jump by the amount that the page was "automatically" scrolled
 * up. We can do this by comparing the scroll position before and after the
 * element was removed, and then offsetting by that amount.
 *
 * @param el - The element being deleted
 * @param finalX - The final X scroll position
 * @param finalY - The final Y scroll position
 * @param optionsOrPlugin - The options or plugin
 * @returns
 */ function adjustScroll(el, finalX, finalY, optionsOrPlugin) {
    const scrollDeltaX = scrollX - finalX;
    const scrollDeltaY = scrollY - finalY;
    const scrollBefore = document.documentElement.style.scrollBehavior;
    const scrollBehavior = getComputedStyle(root).scrollBehavior;
    if (scrollBehavior === "smooth") document.documentElement.style.scrollBehavior = "auto";
    window.scrollTo(window.scrollX + scrollDeltaX, window.scrollY + scrollDeltaY);
    if (!el.parentElement) return;
    const parent = el.parentElement;
    let lastHeight = parent.clientHeight;
    let lastWidth = parent.clientWidth;
    const startScroll = performance.now();
    // Here we use a manual scroll animation to keep the element using the same
    // easing and timing as the parent’s scroll animation.
    function smoothScroll() {
        requestAnimationFrame(()=>{
            if (!isPlugin(optionsOrPlugin)) {
                const deltaY = lastHeight - parent.clientHeight;
                const deltaX = lastWidth - parent.clientWidth;
                if (startScroll + optionsOrPlugin.duration > performance.now()) {
                    window.scrollTo({
                        left: window.scrollX - deltaX,
                        top: window.scrollY - deltaY
                    });
                    lastHeight = parent.clientHeight;
                    lastWidth = parent.clientWidth;
                    smoothScroll();
                } else document.documentElement.style.scrollBehavior = scrollBefore;
            }
        });
    }
    smoothScroll();
}
/**
 * Determines the position of the element being removed.
 * @param el - The element being deleted
 * @returns
 */ function deletePosition(el) {
    const oldCoords = coords.get(el);
    const [width, , height] = getTransitionSizes(el, oldCoords, getCoords(el));
    let offsetParent = el.parentElement;
    while(offsetParent && (getComputedStyle(offsetParent).position === "static" || offsetParent instanceof HTMLBodyElement))offsetParent = offsetParent.parentElement;
    if (!offsetParent) offsetParent = document.body;
    const parentStyles = getComputedStyle(offsetParent);
    const parentCoords = coords.get(offsetParent) || getCoords(offsetParent);
    const top = Math.round(oldCoords.top - parentCoords.top) - raw(parentStyles.borderTopWidth);
    const left = Math.round(oldCoords.left - parentCoords.left) - raw(parentStyles.borderLeftWidth);
    return [
        top,
        left,
        width,
        height
    ];
}
/**
 * A function that automatically adds animation effects to itself and its
 * immediate children. Specifically it adds effects for adding, moving, and
 * removing DOM elements.
 * @param el - A parent element to add animations to.
 * @param options - An optional object of options.
 */ function autoAnimate(el, config = {}) {
    if (mutations && resize) {
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        const isDisabledDueToReduceMotion = mediaQuery.matches && !isPlugin(config) && !config.disrespectUserMotionPreference;
        if (!isDisabledDueToReduceMotion) {
            enabled.add(el);
            if (getComputedStyle(el).position === "static") Object.assign(el.style, {
                position: "relative"
            });
            forEach(el, updatePos, poll, (element)=>resize === null || resize === void 0 ? void 0 : resize.observe(element));
            if (isPlugin(config)) options.set(el, config);
            else options.set(el, {
                duration: 250,
                easing: "ease-in-out",
                ...config
            });
            mutations.observe(el, {
                childList: true
            });
            parents.add(el);
        }
    }
    return Object.freeze({
        parent: el,
        enable: ()=>{
            enabled.add(el);
        },
        disable: ()=>{
            enabled.delete(el);
        },
        isEnabled: ()=>enabled.has(el)
    });
}
/**
 * The vue directive.
 */ const vAutoAnimate = {
    mounted: (el, binding)=>{
        autoAnimate(el, binding.value || {});
    },
    // ignore ssr see #96:
    getSSRProps: ()=>({})
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2cQfL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>(0, _sdkJs.init));
parcelHelpers.export(exports, "browserTracingIntegration", ()=>(0, _browserTracingIntegrationJs.browserTracingIntegration));
parcelHelpers.export(exports, "attachErrorHandler", ()=>(0, _errorhandlerJs.attachErrorHandler));
parcelHelpers.export(exports, "createTracingMixins", ()=>(0, _tracingJs.createTracingMixins));
parcelHelpers.export(exports, "vueIntegration", ()=>(0, _integrationJs.vueIntegration));
parcelHelpers.export(exports, "createSentryPiniaPlugin", ()=>(0, _piniaJs.createSentryPiniaPlugin));
var _browser = require("@sentry/browser");
parcelHelpers.exportAll(_browser, exports);
var _sdkJs = require("./sdk.js");
var _browserTracingIntegrationJs = require("./browserTracingIntegration.js");
var _errorhandlerJs = require("./errorhandler.js");
var _tracingJs = require("./tracing.js");
var _integrationJs = require("./integration.js");
var _piniaJs = require("./pinia.js");

},{"@sentry/browser":false,"./sdk.js":false,"./browserTracingIntegration.js":false,"./errorhandler.js":"2zGg3","./tracing.js":false,"./integration.js":false,"./pinia.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2zGg3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachErrorHandler", ()=>attachErrorHandler);
var _core = require("@sentry/core");
var _componentsJs = require("./vendor/components.js");
const attachErrorHandler = (app, options)=>{
    const { errorHandler: originalErrorHandler } = app.config;
    app.config.errorHandler = (error, vm, lifecycleHook)=>{
        const componentName = (0, _componentsJs.formatComponentName)(vm, false);
        const trace = vm ? (0, _componentsJs.generateComponentTrace)(vm) : "";
        const metadata = {
            componentName,
            lifecycleHook,
            trace
        };
        // TODO(v11): guard via sendDefaultPii?
        if (options?.attachProps !== false && vm) {
            // Vue2 - $options.propsData
            // Vue3 - $props
            if (vm.$options?.propsData) metadata.propsData = vm.$options.propsData;
            else if (vm.$props) metadata.propsData = vm.$props;
        }
        // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
        setTimeout(()=>{
            (0, _core.captureException)(error, {
                captureContext: {
                    contexts: {
                        vue: metadata
                    }
                },
                mechanism: {
                    handled: !!originalErrorHandler,
                    type: "auto.function.vue.error_handler"
                }
            });
        });
        // Check if the current `app.config.errorHandler` is explicitly set by the user before calling it.
        if (typeof originalErrorHandler === "function" && app.config.errorHandler) originalErrorHandler.call(app, error, vm, lifecycleHook);
        else throw error;
    };
};

},{"@sentry/core":"aqk54","./vendor/components.js":"esvIw","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"aqk54":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", ()=>(0, _errorsJs.registerSpanErrorInstrumentation));
parcelHelpers.export(exports, "getCapturedScopesOnSpan", ()=>(0, _utilsJs.getCapturedScopesOnSpan));
parcelHelpers.export(exports, "setCapturedScopesOnSpan", ()=>(0, _utilsJs.setCapturedScopesOnSpan));
parcelHelpers.export(exports, "TRACING_DEFAULTS", ()=>(0, _idleSpanJs.TRACING_DEFAULTS));
parcelHelpers.export(exports, "startIdleSpan", ()=>(0, _idleSpanJs.startIdleSpan));
parcelHelpers.export(exports, "SentrySpan", ()=>(0, _sentrySpanJs.SentrySpan));
parcelHelpers.export(exports, "SentryNonRecordingSpan", ()=>(0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan));
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", ()=>(0, _spanstatusJs.SPAN_STATUS_ERROR));
parcelHelpers.export(exports, "SPAN_STATUS_OK", ()=>(0, _spanstatusJs.SPAN_STATUS_OK));
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", ()=>(0, _spanstatusJs.SPAN_STATUS_UNSET));
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", ()=>(0, _spanstatusJs.getSpanStatusFromHttpCode));
parcelHelpers.export(exports, "setHttpStatus", ()=>(0, _spanstatusJs.setHttpStatus));
parcelHelpers.export(exports, "continueTrace", ()=>(0, _traceJs.continueTrace));
parcelHelpers.export(exports, "startInactiveSpan", ()=>(0, _traceJs.startInactiveSpan));
parcelHelpers.export(exports, "startNewTrace", ()=>(0, _traceJs.startNewTrace));
parcelHelpers.export(exports, "startSpan", ()=>(0, _traceJs.startSpan));
parcelHelpers.export(exports, "startSpanManual", ()=>(0, _traceJs.startSpanManual));
parcelHelpers.export(exports, "suppressTracing", ()=>(0, _traceJs.suppressTracing));
parcelHelpers.export(exports, "withActiveSpan", ()=>(0, _traceJs.withActiveSpan));
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", ()=>(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient));
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", ()=>(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope));
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", ()=>(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan));
parcelHelpers.export(exports, "spanToBaggageHeader", ()=>(0, _dynamicSamplingContextJs.spanToBaggageHeader));
parcelHelpers.export(exports, "setMeasurement", ()=>(0, _measurementJs.setMeasurement));
parcelHelpers.export(exports, "timedEventsToMeasurements", ()=>(0, _measurementJs.timedEventsToMeasurements));
parcelHelpers.export(exports, "sampleSpan", ()=>(0, _samplingJs.sampleSpan));
parcelHelpers.export(exports, "logSpanEnd", ()=>(0, _logSpansJs.logSpanEnd));
parcelHelpers.export(exports, "logSpanStart", ()=>(0, _logSpansJs.logSpanStart));
parcelHelpers.export(exports, "captureSpan", ()=>(0, _captureSpanJs.captureSpan));
parcelHelpers.export(exports, "safeSetSpanJSONAttributes", ()=>(0, _captureSpanJs.safeSetSpanJSONAttributes));
parcelHelpers.export(exports, "GEN_AI_CONVERSATION_ID_ATTRIBUTE", ()=>(0, _semanticAttributesJs.GEN_AI_CONVERSATION_ID_ATTRIBUTE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_HIT));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_CACHE_KEY));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_RELEASE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_EMAIL", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_EMAIL));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_ID", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_ID));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_USERNAME", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_USERNAME));
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", ()=>(0, _semanticAttributesJs.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE));
parcelHelpers.export(exports, "createEventEnvelope", ()=>(0, _envelopeJs.createEventEnvelope));
parcelHelpers.export(exports, "createSessionEnvelope", ()=>(0, _envelopeJs.createSessionEnvelope));
parcelHelpers.export(exports, "createSpanEnvelope", ()=>(0, _envelopeJs.createSpanEnvelope));
parcelHelpers.export(exports, "addEventProcessor", ()=>(0, _exportsJs.addEventProcessor));
parcelHelpers.export(exports, "captureCheckIn", ()=>(0, _exportsJs.captureCheckIn));
parcelHelpers.export(exports, "captureEvent", ()=>(0, _exportsJs.captureEvent));
parcelHelpers.export(exports, "captureException", ()=>(0, _exportsJs.captureException));
parcelHelpers.export(exports, "captureMessage", ()=>(0, _exportsJs.captureMessage));
parcelHelpers.export(exports, "captureSession", ()=>(0, _exportsJs.captureSession));
parcelHelpers.export(exports, "close", ()=>(0, _exportsJs.close));
parcelHelpers.export(exports, "endSession", ()=>(0, _exportsJs.endSession));
parcelHelpers.export(exports, "flush", ()=>(0, _exportsJs.flush));
parcelHelpers.export(exports, "isEnabled", ()=>(0, _exportsJs.isEnabled));
parcelHelpers.export(exports, "isInitialized", ()=>(0, _exportsJs.isInitialized));
parcelHelpers.export(exports, "lastEventId", ()=>(0, _exportsJs.lastEventId));
parcelHelpers.export(exports, "setContext", ()=>(0, _exportsJs.setContext));
parcelHelpers.export(exports, "setConversationId", ()=>(0, _exportsJs.setConversationId));
parcelHelpers.export(exports, "setExtra", ()=>(0, _exportsJs.setExtra));
parcelHelpers.export(exports, "setExtras", ()=>(0, _exportsJs.setExtras));
parcelHelpers.export(exports, "setTag", ()=>(0, _exportsJs.setTag));
parcelHelpers.export(exports, "setTags", ()=>(0, _exportsJs.setTags));
parcelHelpers.export(exports, "setUser", ()=>(0, _exportsJs.setUser));
parcelHelpers.export(exports, "startSession", ()=>(0, _exportsJs.startSession));
parcelHelpers.export(exports, "withMonitor", ()=>(0, _exportsJs.withMonitor));
parcelHelpers.export(exports, "getClient", ()=>(0, _currentScopesJs.getClient));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _currentScopesJs.getCurrentScope));
parcelHelpers.export(exports, "getExternalPropagationContext", ()=>(0, _currentScopesJs.getExternalPropagationContext));
parcelHelpers.export(exports, "getGlobalScope", ()=>(0, _currentScopesJs.getGlobalScope));
parcelHelpers.export(exports, "getIsolationScope", ()=>(0, _currentScopesJs.getIsolationScope));
parcelHelpers.export(exports, "getTraceContextFromScope", ()=>(0, _currentScopesJs.getTraceContextFromScope));
parcelHelpers.export(exports, "hasExternalPropagationContext", ()=>(0, _currentScopesJs.hasExternalPropagationContext));
parcelHelpers.export(exports, "registerExternalPropagationContext", ()=>(0, _currentScopesJs.registerExternalPropagationContext));
parcelHelpers.export(exports, "withIsolationScope", ()=>(0, _currentScopesJs.withIsolationScope));
parcelHelpers.export(exports, "withScope", ()=>(0, _currentScopesJs.withScope));
parcelHelpers.export(exports, "getDefaultCurrentScope", ()=>(0, _defaultScopesJs.getDefaultCurrentScope));
parcelHelpers.export(exports, "getDefaultIsolationScope", ()=>(0, _defaultScopesJs.getDefaultIsolationScope));
parcelHelpers.export(exports, "setAsyncContextStrategy", ()=>(0, _indexJs.setAsyncContextStrategy));
parcelHelpers.export(exports, "getGlobalSingleton", ()=>(0, _carrierJs.getGlobalSingleton));
parcelHelpers.export(exports, "getMainCarrier", ()=>(0, _carrierJs.getMainCarrier));
parcelHelpers.export(exports, "closeSession", ()=>(0, _sessionJs.closeSession));
parcelHelpers.export(exports, "makeSession", ()=>(0, _sessionJs.makeSession));
parcelHelpers.export(exports, "updateSession", ()=>(0, _sessionJs.updateSession));
parcelHelpers.export(exports, "Scope", ()=>(0, _scopeJs.Scope));
parcelHelpers.export(exports, "notifyEventProcessors", ()=>(0, _eventProcessorsJs.notifyEventProcessors));
parcelHelpers.export(exports, "SENTRY_API_VERSION", ()=>(0, _apiJs.SENTRY_API_VERSION));
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>(0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth));
parcelHelpers.export(exports, "getReportDialogEndpoint", ()=>(0, _apiJs.getReportDialogEndpoint));
parcelHelpers.export(exports, "Client", ()=>(0, _clientJs.Client));
parcelHelpers.export(exports, "ServerRuntimeClient", ()=>(0, _serverRuntimeClientJs.ServerRuntimeClient));
parcelHelpers.export(exports, "initAndBind", ()=>(0, _sdkJs.initAndBind));
parcelHelpers.export(exports, "setCurrentClient", ()=>(0, _sdkJs.setCurrentClient));
parcelHelpers.export(exports, "createTransport", ()=>(0, _baseJs.createTransport));
parcelHelpers.export(exports, "makeOfflineTransport", ()=>(0, _offlineJs.makeOfflineTransport));
parcelHelpers.export(exports, "MULTIPLEXED_TRANSPORT_EXTRA_KEY", ()=>(0, _multiplexedJs.MULTIPLEXED_TRANSPORT_EXTRA_KEY));
parcelHelpers.export(exports, "makeMultiplexedTransport", ()=>(0, _multiplexedJs.makeMultiplexedTransport));
parcelHelpers.export(exports, "addIntegration", ()=>(0, _integrationJs.addIntegration));
parcelHelpers.export(exports, "defineIntegration", ()=>(0, _integrationJs.defineIntegration));
parcelHelpers.export(exports, "getIntegrationsToSetup", ()=>(0, _integrationJs.getIntegrationsToSetup));
parcelHelpers.export(exports, "installedIntegrations", ()=>(0, _integrationJs.installedIntegrations));
parcelHelpers.export(exports, "_INTERNAL_clearAiProviderSkips", ()=>(0, _providerSkipJs._INTERNAL_clearAiProviderSkips));
parcelHelpers.export(exports, "_INTERNAL_shouldSkipAiProviderWrapping", ()=>(0, _providerSkipJs._INTERNAL_shouldSkipAiProviderWrapping));
parcelHelpers.export(exports, "_INTERNAL_skipAiProviderWrapping", ()=>(0, _providerSkipJs._INTERNAL_skipAiProviderWrapping));
parcelHelpers.export(exports, "envToBool", ()=>(0, _envToBoolJs.envToBool));
parcelHelpers.export(exports, "applyScopeDataToEvent", ()=>(0, _scopeDataJs.applyScopeDataToEvent));
parcelHelpers.export(exports, "getCombinedScopeData", ()=>(0, _scopeDataJs.getCombinedScopeData));
parcelHelpers.export(exports, "mergeScopeData", ()=>(0, _scopeDataJs.mergeScopeData));
parcelHelpers.export(exports, "prepareEvent", ()=>(0, _prepareEventJs.prepareEvent));
parcelHelpers.export(exports, "createCheckInEnvelope", ()=>(0, _checkinJs.createCheckInEnvelope));
parcelHelpers.export(exports, "hasSpansEnabled", ()=>(0, _hasSpansEnabledJs.hasSpansEnabled));
parcelHelpers.export(exports, "isStreamedBeforeSendSpanCallback", ()=>(0, _beforeSendSpanJs.isStreamedBeforeSendSpanCallback));
parcelHelpers.export(exports, "withStreamedSpan", ()=>(0, _beforeSendSpanJs.withStreamedSpan));
parcelHelpers.export(exports, "isSentryRequestUrl", ()=>(0, _isSentryRequestUrlJs.isSentryRequestUrl));
parcelHelpers.export(exports, "handleCallbackErrors", ()=>(0, _handleCallbackErrorsJs.handleCallbackErrors));
parcelHelpers.export(exports, "fmt", ()=>(0, _parameterizeJs.fmt));
parcelHelpers.export(exports, "parameterize", ()=>(0, _parameterizeJs.parameterize));
parcelHelpers.export(exports, "handleTunnelRequest", ()=>(0, _tunnelJs.handleTunnelRequest));
parcelHelpers.export(exports, "addAutoIpAddressToSession", ()=>(0, _ipAddressJs.addAutoIpAddressToSession));
parcelHelpers.export(exports, "addAutoIpAddressToUser", ()=>(0, _ipAddressJs.addAutoIpAddressToUser));
parcelHelpers.export(exports, "INTERNAL_getSegmentSpan", ()=>(0, _spanUtilsJs.INTERNAL_getSegmentSpan));
parcelHelpers.export(exports, "addChildSpanToSpan", ()=>(0, _spanUtilsJs.addChildSpanToSpan));
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", ()=>(0, _spanUtilsJs.convertSpanLinksForEnvelope));
parcelHelpers.export(exports, "getActiveSpan", ()=>(0, _spanUtilsJs.getActiveSpan));
parcelHelpers.export(exports, "getRootSpan", ()=>(0, _spanUtilsJs.getRootSpan));
parcelHelpers.export(exports, "getSpanDescendants", ()=>(0, _spanUtilsJs.getSpanDescendants));
parcelHelpers.export(exports, "getStatusMessage", ()=>(0, _spanUtilsJs.getStatusMessage));
parcelHelpers.export(exports, "spanIsSampled", ()=>(0, _spanUtilsJs.spanIsSampled));
parcelHelpers.export(exports, "spanTimeInputToSeconds", ()=>(0, _spanUtilsJs.spanTimeInputToSeconds));
parcelHelpers.export(exports, "spanToJSON", ()=>(0, _spanUtilsJs.spanToJSON));
parcelHelpers.export(exports, "spanToStreamedSpanJSON", ()=>(0, _spanUtilsJs.spanToStreamedSpanJSON));
parcelHelpers.export(exports, "spanToTraceContext", ()=>(0, _spanUtilsJs.spanToTraceContext));
parcelHelpers.export(exports, "spanToTraceHeader", ()=>(0, _spanUtilsJs.spanToTraceHeader));
parcelHelpers.export(exports, "updateSpanName", ()=>(0, _spanUtilsJs.updateSpanName));
parcelHelpers.export(exports, "_INTERNAL_setSpanForScope", ()=>(0, _spanOnScopeJs._setSpanForScope));
parcelHelpers.export(exports, "parseSampleRate", ()=>(0, _parseSampleRateJs.parseSampleRate));
parcelHelpers.export(exports, "applySdkMetadata", ()=>(0, _sdkMetadataJs.applySdkMetadata));
parcelHelpers.export(exports, "getTraceData", ()=>(0, _traceDataJs.getTraceData));
parcelHelpers.export(exports, "shouldPropagateTraceForUrl", ()=>(0, _tracePropagationTargetsJs.shouldPropagateTraceForUrl));
parcelHelpers.export(exports, "getTraceMetaTags", ()=>(0, _metaJs.getTraceMetaTags));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounceJs.debounce));
parcelHelpers.export(exports, "derefWeakRef", ()=>(0, _weakRefJs.derefWeakRef));
parcelHelpers.export(exports, "makeWeakRef", ()=>(0, _weakRefJs.makeWeakRef));
parcelHelpers.export(exports, "shouldIgnoreSpan", ()=>(0, _shouldIgnoreSpanJs.shouldIgnoreSpan));
parcelHelpers.export(exports, "extractQueryParamsFromUrl", ()=>(0, _requestJs.extractQueryParamsFromUrl));
parcelHelpers.export(exports, "headersToDict", ()=>(0, _requestJs.headersToDict));
parcelHelpers.export(exports, "httpHeadersToSpanAttributes", ()=>(0, _requestJs.httpHeadersToSpanAttributes));
parcelHelpers.export(exports, "httpRequestToRequestData", ()=>(0, _requestJs.httpRequestToRequestData));
parcelHelpers.export(exports, "winterCGHeadersToDict", ()=>(0, _requestJs.winterCGHeadersToDict));
parcelHelpers.export(exports, "winterCGRequestToRequestData", ()=>(0, _requestJs.winterCGRequestToRequestData));
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", ()=>(0, _constantsJs.DEFAULT_ENVIRONMENT));
parcelHelpers.export(exports, "DEV_ENVIRONMENT", ()=>(0, _constantsJs.DEV_ENVIRONMENT));
parcelHelpers.export(exports, "addBreadcrumb", ()=>(0, _breadcrumbsJs.addBreadcrumb));
parcelHelpers.export(exports, "functionToStringIntegration", ()=>(0, _functiontostringJs.functionToStringIntegration));
parcelHelpers.export(exports, "eventFiltersIntegration", ()=>(0, _eventFiltersJs.eventFiltersIntegration));
parcelHelpers.export(exports, "inboundFiltersIntegration", ()=>(0, _eventFiltersJs.inboundFiltersIntegration));
parcelHelpers.export(exports, "linkedErrorsIntegration", ()=>(0, _linkederrorsJs.linkedErrorsIntegration));
parcelHelpers.export(exports, "moduleMetadataIntegration", ()=>(0, _moduleMetadataJs.moduleMetadataIntegration));
parcelHelpers.export(exports, "requestDataIntegration", ()=>(0, _requestdataJs.requestDataIntegration));
parcelHelpers.export(exports, "captureConsoleIntegration", ()=>(0, _captureconsoleJs.captureConsoleIntegration));
parcelHelpers.export(exports, "expressErrorHandler", ()=>(0, _indexJs1.expressErrorHandler));
parcelHelpers.export(exports, "patchExpressModule", ()=>(0, _indexJs1.patchExpressModule));
parcelHelpers.export(exports, "setupExpressErrorHandler", ()=>(0, _indexJs1.setupExpressErrorHandler));
parcelHelpers.export(exports, "dedupeIntegration", ()=>(0, _dedupeJs.dedupeIntegration));
parcelHelpers.export(exports, "extraErrorDataIntegration", ()=>(0, _extraerrordataJs.extraErrorDataIntegration));
parcelHelpers.export(exports, "rewriteFramesIntegration", ()=>(0, _rewriteframesJs.rewriteFramesIntegration));
parcelHelpers.export(exports, "instrumentSupabaseClient", ()=>(0, _supabaseJs.instrumentSupabaseClient));
parcelHelpers.export(exports, "supabaseIntegration", ()=>(0, _supabaseJs.supabaseIntegration));
parcelHelpers.export(exports, "instrumentPostgresJsSql", ()=>(0, _postgresjsJs.instrumentPostgresJsSql));
parcelHelpers.export(exports, "zodErrorsIntegration", ()=>(0, _zoderrorsJs.zodErrorsIntegration));
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", ()=>(0, _thirdPartyErrorsFilterJs.thirdPartyErrorFilterIntegration));
parcelHelpers.export(exports, "consoleIntegration", ()=>(0, _consoleJs.consoleIntegration));
parcelHelpers.export(exports, "featureFlagsIntegration", ()=>(0, _featureFlagsIntegrationJs.featureFlagsIntegration));
parcelHelpers.export(exports, "growthbookIntegration", ()=>(0, _growthbookJs.growthbookIntegration));
parcelHelpers.export(exports, "conversationIdIntegration", ()=>(0, _conversationIdJs.conversationIdIntegration));
parcelHelpers.export(exports, "profiler", ()=>(0, _profilingJs.profiler));
parcelHelpers.export(exports, "_INTERNAL_getTracingHeadersForFetchRequest", ()=>(0, _fetchJs._INTERNAL_getTracingHeadersForFetchRequest));
parcelHelpers.export(exports, "instrumentFetchRequest", ()=>(0, _fetchJs.instrumentFetchRequest));
parcelHelpers.export(exports, "trpcMiddleware", ()=>(0, _trpcJs.trpcMiddleware));
parcelHelpers.export(exports, "wrapMcpServerWithSentry", ()=>(0, _indexJs2.wrapMcpServerWithSentry));
parcelHelpers.export(exports, "captureFeedback", ()=>(0, _feedbackJs.captureFeedback));
parcelHelpers.export(exports, "_INTERNAL_captureLog", ()=>(0, _internalJs._INTERNAL_captureLog));
parcelHelpers.export(exports, "_INTERNAL_captureSerializedLog", ()=>(0, _internalJs._INTERNAL_captureSerializedLog));
parcelHelpers.export(exports, "_INTERNAL_flushLogsBuffer", ()=>(0, _internalJs._INTERNAL_flushLogsBuffer));
parcelHelpers.export(exports, "consoleLoggingIntegration", ()=>(0, _consoleIntegrationJs.consoleLoggingIntegration));
parcelHelpers.export(exports, "_INTERNAL_captureMetric", ()=>(0, _internalJs1._INTERNAL_captureMetric));
parcelHelpers.export(exports, "_INTERNAL_captureSerializedMetric", ()=>(0, _internalJs1._INTERNAL_captureSerializedMetric));
parcelHelpers.export(exports, "_INTERNAL_flushMetricsBuffer", ()=>(0, _internalJs1._INTERNAL_flushMetricsBuffer));
parcelHelpers.export(exports, "createConsolaReporter", ()=>(0, _consolaJs.createConsolaReporter));
parcelHelpers.export(exports, "addVercelAiProcessors", ()=>(0, _indexJs3.addVercelAiProcessors));
parcelHelpers.export(exports, "_INTERNAL_cleanupToolCallSpanContext", ()=>(0, _utilsJs1._INTERNAL_cleanupToolCallSpanContext));
parcelHelpers.export(exports, "_INTERNAL_getSpanContextForToolCallId", ()=>(0, _utilsJs1._INTERNAL_getSpanContextForToolCallId));
parcelHelpers.export(exports, "_INTERNAL_toolCallSpanContextMap", ()=>(0, _constantsJs1.toolCallSpanContextMap));
parcelHelpers.export(exports, "instrumentOpenAiClient", ()=>(0, _indexJs4.instrumentOpenAiClient));
parcelHelpers.export(exports, "OPENAI_INTEGRATION_NAME", ()=>(0, _constantsJs2.OPENAI_INTEGRATION_NAME));
parcelHelpers.export(exports, "instrumentAnthropicAiClient", ()=>(0, _indexJs5.instrumentAnthropicAiClient));
parcelHelpers.export(exports, "ANTHROPIC_AI_INTEGRATION_NAME", ()=>(0, _constantsJs3.ANTHROPIC_AI_INTEGRATION_NAME));
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", ()=>(0, _indexJs6.instrumentGoogleGenAIClient));
parcelHelpers.export(exports, "GOOGLE_GENAI_INTEGRATION_NAME", ()=>(0, _constantsJs4.GOOGLE_GENAI_INTEGRATION_NAME));
parcelHelpers.export(exports, "createLangChainCallbackHandler", ()=>(0, _indexJs7.createLangChainCallbackHandler));
parcelHelpers.export(exports, "LANGCHAIN_INTEGRATION_NAME", ()=>(0, _constantsJs5.LANGCHAIN_INTEGRATION_NAME));
parcelHelpers.export(exports, "instrumentCreateReactAgent", ()=>(0, _indexJs8.instrumentCreateReactAgent));
parcelHelpers.export(exports, "instrumentLangGraph", ()=>(0, _indexJs8.instrumentLangGraph));
parcelHelpers.export(exports, "instrumentStateGraphCompile", ()=>(0, _indexJs8.instrumentStateGraphCompile));
parcelHelpers.export(exports, "LANGGRAPH_INTEGRATION_NAME", ()=>(0, _constantsJs6.LANGGRAPH_INTEGRATION_NAME));
parcelHelpers.export(exports, "SpanBuffer", ()=>(0, _spanBufferJs.SpanBuffer));
parcelHelpers.export(exports, "hasSpanStreamingEnabled", ()=>(0, _hasSpanStreamingEnabledJs.hasSpanStreamingEnabled));
parcelHelpers.export(exports, "spanStreamingIntegration", ()=>(0, _spanStreamingJs.spanStreamingIntegration));
parcelHelpers.export(exports, "_INTERNAL_FLAG_BUFFER_SIZE", ()=>(0, _featureFlagsJs._INTERNAL_FLAG_BUFFER_SIZE));
parcelHelpers.export(exports, "_INTERNAL_MAX_FLAGS_PER_SPAN", ()=>(0, _featureFlagsJs._INTERNAL_MAX_FLAGS_PER_SPAN));
parcelHelpers.export(exports, "_INTERNAL_addFeatureFlagToActiveSpan", ()=>(0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan));
parcelHelpers.export(exports, "_INTERNAL_copyFlagsFromScopeToEvent", ()=>(0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent));
parcelHelpers.export(exports, "_INTERNAL_insertFlagToScope", ()=>(0, _featureFlagsJs._INTERNAL_insertFlagToScope));
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", ()=>(0, _aggregateErrorsJs.applyAggregateErrorsToEvent));
parcelHelpers.export(exports, "getBreadcrumbLogLevelFromHttpStatusCode", ()=>(0, _breadcrumbLogLevelJs.getBreadcrumbLogLevelFromHttpStatusCode));
parcelHelpers.export(exports, "getComponentName", ()=>(0, _browserJs.getComponentName));
parcelHelpers.export(exports, "getLocationHref", ()=>(0, _browserJs.getLocationHref));
parcelHelpers.export(exports, "htmlTreeAsString", ()=>(0, _browserJs.htmlTreeAsString));
parcelHelpers.export(exports, "dsnFromString", ()=>(0, _dsnJs.dsnFromString));
parcelHelpers.export(exports, "dsnToString", ()=>(0, _dsnJs.dsnToString));
parcelHelpers.export(exports, "makeDsn", ()=>(0, _dsnJs.makeDsn));
parcelHelpers.export(exports, "SentryError", ()=>(0, _errorJs.SentryError));
parcelHelpers.export(exports, "GLOBAL_OBJ", ()=>(0, _worldwideJs.GLOBAL_OBJ));
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", ()=>(0, _consoleJs1.addConsoleInstrumentationHandler));
parcelHelpers.export(exports, "addFetchEndInstrumentationHandler", ()=>(0, _fetchJs1.addFetchEndInstrumentationHandler));
parcelHelpers.export(exports, "addFetchInstrumentationHandler", ()=>(0, _fetchJs1.addFetchInstrumentationHandler));
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", ()=>(0, _globalErrorJs.addGlobalErrorInstrumentationHandler));
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", ()=>(0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler));
parcelHelpers.export(exports, "addHandler", ()=>(0, _handlersJs.addHandler));
parcelHelpers.export(exports, "maybeInstrument", ()=>(0, _handlersJs.maybeInstrument));
parcelHelpers.export(exports, "resetInstrumentationHandlers", ()=>(0, _handlersJs.resetInstrumentationHandlers));
parcelHelpers.export(exports, "triggerHandlers", ()=>(0, _handlersJs.triggerHandlers));
parcelHelpers.export(exports, "isDOMError", ()=>(0, _isJs.isDOMError));
parcelHelpers.export(exports, "isDOMException", ()=>(0, _isJs.isDOMException));
parcelHelpers.export(exports, "isElement", ()=>(0, _isJs.isElement));
parcelHelpers.export(exports, "isError", ()=>(0, _isJs.isError));
parcelHelpers.export(exports, "isErrorEvent", ()=>(0, _isJs.isErrorEvent));
parcelHelpers.export(exports, "isEvent", ()=>(0, _isJs.isEvent));
parcelHelpers.export(exports, "isInstanceOf", ()=>(0, _isJs.isInstanceOf));
parcelHelpers.export(exports, "isParameterizedString", ()=>(0, _isJs.isParameterizedString));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _isJs.isPlainObject));
parcelHelpers.export(exports, "isPrimitive", ()=>(0, _isJs.isPrimitive));
parcelHelpers.export(exports, "isRegExp", ()=>(0, _isJs.isRegExp));
parcelHelpers.export(exports, "isString", ()=>(0, _isJs.isString));
parcelHelpers.export(exports, "isSyntheticEvent", ()=>(0, _isJs.isSyntheticEvent));
parcelHelpers.export(exports, "isThenable", ()=>(0, _isJs.isThenable));
parcelHelpers.export(exports, "isVueViewModel", ()=>(0, _isJs.isVueViewModel));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserJs.isBrowser));
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>(0, _debugLoggerJs.CONSOLE_LEVELS));
parcelHelpers.export(exports, "consoleSandbox", ()=>(0, _debugLoggerJs.consoleSandbox));
parcelHelpers.export(exports, "debug", ()=>(0, _debugLoggerJs.debug));
parcelHelpers.export(exports, "originalConsoleMethods", ()=>(0, _debugLoggerJs.originalConsoleMethods));
parcelHelpers.export(exports, "addContextToFrame", ()=>(0, _miscJs.addContextToFrame));
parcelHelpers.export(exports, "addExceptionMechanism", ()=>(0, _miscJs.addExceptionMechanism));
parcelHelpers.export(exports, "addExceptionTypeValue", ()=>(0, _miscJs.addExceptionTypeValue));
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>(0, _miscJs.checkOrSetAlreadyCaught));
parcelHelpers.export(exports, "getEventDescription", ()=>(0, _miscJs.getEventDescription));
parcelHelpers.export(exports, "isAlreadyCaptured", ()=>(0, _miscJs.isAlreadyCaptured));
parcelHelpers.export(exports, "parseSemver", ()=>(0, _miscJs.parseSemver));
parcelHelpers.export(exports, "uuid4", ()=>(0, _miscJs.uuid4));
parcelHelpers.export(exports, "isNodeEnv", ()=>(0, _nodeJs.isNodeEnv));
parcelHelpers.export(exports, "loadModule", ()=>(0, _nodeJs.loadModule));
parcelHelpers.export(exports, "normalize", ()=>(0, _normalizeJs.normalize));
parcelHelpers.export(exports, "normalizeToSize", ()=>(0, _normalizeJs.normalizeToSize));
parcelHelpers.export(exports, "normalizeUrlToBase", ()=>(0, _normalizeJs.normalizeUrlToBase));
parcelHelpers.export(exports, "setNormalizationDepthOverrideHint", ()=>(0, _normalizationHintsJs.setNormalizationDepthOverrideHint));
parcelHelpers.export(exports, "setSkipNormalizationHint", ()=>(0, _normalizationHintsJs.setSkipNormalizationHint));
parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>(0, _objectJs.addNonEnumerableProperty));
parcelHelpers.export(exports, "convertToPlainObject", ()=>(0, _objectJs.convertToPlainObject));
parcelHelpers.export(exports, "dropUndefinedKeys", ()=>(0, _objectJs.dropUndefinedKeys));
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>(0, _objectJs.extractExceptionKeysForMessage));
parcelHelpers.export(exports, "fill", ()=>(0, _objectJs.fill));
parcelHelpers.export(exports, "getOriginalFunction", ()=>(0, _objectJs.getOriginalFunction));
parcelHelpers.export(exports, "markFunctionWrapped", ()=>(0, _objectJs.markFunctionWrapped));
parcelHelpers.export(exports, "objectify", ()=>(0, _objectJs.objectify));
parcelHelpers.export(exports, "basename", ()=>(0, _pathJs.basename));
parcelHelpers.export(exports, "dirname", ()=>(0, _pathJs.dirname));
parcelHelpers.export(exports, "isAbsolute", ()=>(0, _pathJs.isAbsolute));
parcelHelpers.export(exports, "join", ()=>(0, _pathJs.join));
parcelHelpers.export(exports, "normalizePath", ()=>(0, _pathJs.normalizePath));
parcelHelpers.export(exports, "relative", ()=>(0, _pathJs.relative));
parcelHelpers.export(exports, "resolve", ()=>(0, _pathJs.resolve));
parcelHelpers.export(exports, "SENTRY_BUFFER_FULL_ERROR", ()=>(0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR));
parcelHelpers.export(exports, "makePromiseBuffer", ()=>(0, _promisebufferJs.makePromiseBuffer));
parcelHelpers.export(exports, "severityLevelFromString", ()=>(0, _severityJs.severityLevelFromString));
parcelHelpers.export(exports, "replaceExports", ()=>(0, _exportsJs1.replaceExports));
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", ()=>(0, _stacktraceJs.UNKNOWN_FUNCTION));
parcelHelpers.export(exports, "createStackParser", ()=>(0, _stacktraceJs.createStackParser));
parcelHelpers.export(exports, "getFramesFromEvent", ()=>(0, _stacktraceJs.getFramesFromEvent));
parcelHelpers.export(exports, "getFunctionName", ()=>(0, _stacktraceJs.getFunctionName));
parcelHelpers.export(exports, "stackParserFromStackParserOptions", ()=>(0, _stacktraceJs.stackParserFromStackParserOptions));
parcelHelpers.export(exports, "stripSentryFramesAndReverse", ()=>(0, _stacktraceJs.stripSentryFramesAndReverse));
parcelHelpers.export(exports, "filenameIsInApp", ()=>(0, _nodeStackTraceJs.filenameIsInApp));
parcelHelpers.export(exports, "node", ()=>(0, _nodeStackTraceJs.node));
parcelHelpers.export(exports, "nodeStackLineParser", ()=>(0, _nodeStackTraceJs.nodeStackLineParser));
parcelHelpers.export(exports, "isMatchingPattern", ()=>(0, _stringJs.isMatchingPattern));
parcelHelpers.export(exports, "safeJoin", ()=>(0, _stringJs.safeJoin));
parcelHelpers.export(exports, "snipLine", ()=>(0, _stringJs.snipLine));
parcelHelpers.export(exports, "stringMatchesSomePattern", ()=>(0, _stringJs.stringMatchesSomePattern));
parcelHelpers.export(exports, "truncate", ()=>(0, _stringJs.truncate));
parcelHelpers.export(exports, "isNativeFunction", ()=>(0, _supportsJs.isNativeFunction));
parcelHelpers.export(exports, "supportsDOMError", ()=>(0, _supportsJs.supportsDOMError));
parcelHelpers.export(exports, "supportsDOMException", ()=>(0, _supportsJs.supportsDOMException));
parcelHelpers.export(exports, "supportsErrorEvent", ()=>(0, _supportsJs.supportsErrorEvent));
parcelHelpers.export(exports, "supportsFetch", ()=>(0, _supportsJs.supportsFetch));
parcelHelpers.export(exports, "supportsHistory", ()=>(0, _supportsJs.supportsHistory));
parcelHelpers.export(exports, "supportsNativeFetch", ()=>(0, _supportsJs.supportsNativeFetch));
parcelHelpers.export(exports, "supportsReferrerPolicy", ()=>(0, _supportsJs.supportsReferrerPolicy));
parcelHelpers.export(exports, "supportsReportingObserver", ()=>(0, _supportsJs.supportsReportingObserver));
parcelHelpers.export(exports, "SyncPromise", ()=>(0, _syncpromiseJs.SyncPromise));
parcelHelpers.export(exports, "rejectedSyncPromise", ()=>(0, _syncpromiseJs.rejectedSyncPromise));
parcelHelpers.export(exports, "resolvedSyncPromise", ()=>(0, _syncpromiseJs.resolvedSyncPromise));
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>(0, _timeJs.browserPerformanceTimeOrigin));
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>(0, _timeJs.dateTimestampInSeconds));
parcelHelpers.export(exports, "timestampInSeconds", ()=>(0, _timeJs.timestampInSeconds));
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", ()=>(0, _tracingJs.TRACEPARENT_REGEXP));
parcelHelpers.export(exports, "extractTraceparentData", ()=>(0, _tracingJs.extractTraceparentData));
parcelHelpers.export(exports, "generateSentryTraceHeader", ()=>(0, _tracingJs.generateSentryTraceHeader));
parcelHelpers.export(exports, "generateTraceparentHeader", ()=>(0, _tracingJs.generateTraceparentHeader));
parcelHelpers.export(exports, "propagationContextFromHeaders", ()=>(0, _tracingJs.propagationContextFromHeaders));
parcelHelpers.export(exports, "shouldContinueTrace", ()=>(0, _tracingJs.shouldContinueTrace));
parcelHelpers.export(exports, "getSDKSource", ()=>(0, _envJs.getSDKSource));
parcelHelpers.export(exports, "isBrowserBundle", ()=>(0, _envJs.isBrowserBundle));
parcelHelpers.export(exports, "addItemToEnvelope", ()=>(0, _envelopeJs1.addItemToEnvelope));
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", ()=>(0, _envelopeJs1.createAttachmentEnvelopeItem));
parcelHelpers.export(exports, "createEnvelope", ()=>(0, _envelopeJs1.createEnvelope));
parcelHelpers.export(exports, "createEventEnvelopeHeaders", ()=>(0, _envelopeJs1.createEventEnvelopeHeaders));
parcelHelpers.export(exports, "createSpanEnvelopeItem", ()=>(0, _envelopeJs1.createSpanEnvelopeItem));
parcelHelpers.export(exports, "envelopeContainsItemType", ()=>(0, _envelopeJs1.envelopeContainsItemType));
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", ()=>(0, _envelopeJs1.envelopeItemTypeToDataCategory));
parcelHelpers.export(exports, "forEachEnvelopeItem", ()=>(0, _envelopeJs1.forEachEnvelopeItem));
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", ()=>(0, _envelopeJs1.getSdkMetadataForEnvelopeHeader));
parcelHelpers.export(exports, "parseEnvelope", ()=>(0, _envelopeJs1.parseEnvelope));
parcelHelpers.export(exports, "serializeEnvelope", ()=>(0, _envelopeJs1.serializeEnvelope));
parcelHelpers.export(exports, "createClientReportEnvelope", ()=>(0, _clientreportJs.createClientReportEnvelope));
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", ()=>(0, _ratelimitJs.DEFAULT_RETRY_AFTER));
parcelHelpers.export(exports, "disabledUntil", ()=>(0, _ratelimitJs.disabledUntil));
parcelHelpers.export(exports, "isRateLimited", ()=>(0, _ratelimitJs.isRateLimited));
parcelHelpers.export(exports, "parseRetryAfterHeader", ()=>(0, _ratelimitJs.parseRetryAfterHeader));
parcelHelpers.export(exports, "updateRateLimits", ()=>(0, _ratelimitJs.updateRateLimits));
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", ()=>(0, _baggageJs.MAX_BAGGAGE_STRING_LENGTH));
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", ()=>(0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX));
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", ()=>(0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX_REGEX));
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", ()=>(0, _baggageJs.baggageHeaderToDynamicSamplingContext));
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", ()=>(0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader));
parcelHelpers.export(exports, "objectToBaggageHeader", ()=>(0, _baggageJs.objectToBaggageHeader));
parcelHelpers.export(exports, "parseBaggageHeader", ()=>(0, _baggageJs.parseBaggageHeader));
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", ()=>(0, _urlJs.getHttpSpanDetailsFromUrlObject));
parcelHelpers.export(exports, "getSanitizedUrlString", ()=>(0, _urlJs.getSanitizedUrlString));
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", ()=>(0, _urlJs.getSanitizedUrlStringFromUrlObject));
parcelHelpers.export(exports, "isURLObjectRelative", ()=>(0, _urlJs.isURLObjectRelative));
parcelHelpers.export(exports, "parseStringToURLObject", ()=>(0, _urlJs.parseStringToURLObject));
parcelHelpers.export(exports, "parseUrl", ()=>(0, _urlJs.parseUrl));
parcelHelpers.export(exports, "stripDataUrlContent", ()=>(0, _urlJs.stripDataUrlContent));
parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>(0, _urlJs.stripUrlQueryAndFragment));
parcelHelpers.export(exports, "_INTERNAL_enhanceErrorWithSentryInfo", ()=>(0, _eventbuilderJs._enhanceErrorWithSentryInfo));
parcelHelpers.export(exports, "eventFromMessage", ()=>(0, _eventbuilderJs.eventFromMessage));
parcelHelpers.export(exports, "eventFromUnknownInput", ()=>(0, _eventbuilderJs.eventFromUnknownInput));
parcelHelpers.export(exports, "exceptionFromError", ()=>(0, _eventbuilderJs.exceptionFromError));
parcelHelpers.export(exports, "parseStackFrames", ()=>(0, _eventbuilderJs.parseStackFrames));
parcelHelpers.export(exports, "callFrameToStackFrame", ()=>(0, _anrJs.callFrameToStackFrame));
parcelHelpers.export(exports, "watchdogTimer", ()=>(0, _anrJs.watchdogTimer));
parcelHelpers.export(exports, "LRUMap", ()=>(0, _lruJs.LRUMap));
parcelHelpers.export(exports, "generateSpanId", ()=>(0, _propagationContextJs.generateSpanId));
parcelHelpers.export(exports, "generateTraceId", ()=>(0, _propagationContextJs.generateTraceId));
parcelHelpers.export(exports, "vercelWaitUntil", ()=>(0, _vercelWaitUntilJs.vercelWaitUntil));
parcelHelpers.export(exports, "flushIfServerless", ()=>(0, _flushIfServerlessJs.flushIfServerless));
parcelHelpers.export(exports, "SDK_VERSION", ()=>(0, _versionJs.SDK_VERSION));
parcelHelpers.export(exports, "getDebugImagesForResources", ()=>(0, _debugIdsJs.getDebugImagesForResources));
parcelHelpers.export(exports, "getFilenameToDebugIdMap", ()=>(0, _debugIdsJs.getFilenameToDebugIdMap));
parcelHelpers.export(exports, "getFilenameToMetadataMap", ()=>(0, _metadataJs.getFilenameToMetadataMap));
parcelHelpers.export(exports, "escapeStringForRegex", ()=>(0, _escapeStringForRegexJs.escapeStringForRegex));
parcelHelpers.export(exports, "_INTERNAL_safeDateNow", ()=>(0, _randomSafeContextJs.safeDateNow));
parcelHelpers.export(exports, "_INTERNAL_safeMathRandom", ()=>(0, _randomSafeContextJs.safeMathRandom));
parcelHelpers.export(exports, "_INTERNAL_withRandomSafeContext", ()=>(0, _randomSafeContextJs.withRandomSafeContext));
parcelHelpers.export(exports, "_INTERNAL_safeUnref", ()=>(0, _timerJs.safeUnref));
parcelHelpers.export(exports, "instrumentLangChainEmbeddings", ()=>(0, _embeddingsJs.instrumentLangChainEmbeddings));
parcelHelpers.export(exports, "logger", ()=>_publicApiJs);
parcelHelpers.export(exports, "metrics", ()=>_publicApiJs1);
var _errorsJs = require("./tracing/errors.js");
var _utilsJs = require("./tracing/utils.js");
var _idleSpanJs = require("./tracing/idleSpan.js");
var _sentrySpanJs = require("./tracing/sentrySpan.js");
var _sentryNonRecordingSpanJs = require("./tracing/sentryNonRecordingSpan.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _traceJs = require("./tracing/trace.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _measurementJs = require("./tracing/measurement.js");
var _samplingJs = require("./tracing/sampling.js");
var _logSpansJs = require("./tracing/logSpans.js");
var _captureSpanJs = require("./tracing/spans/captureSpan.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _currentScopesJs = require("./currentScopes.js");
var _defaultScopesJs = require("./defaultScopes.js");
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _sessionJs = require("./session.js");
var _scopeJs = require("./scope.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _apiJs = require("./api.js");
var _clientJs = require("./client.js");
var _serverRuntimeClientJs = require("./server-runtime-client.js");
var _sdkJs = require("./sdk.js");
var _baseJs = require("./transports/base.js");
var _offlineJs = require("./transports/offline.js");
var _multiplexedJs = require("./transports/multiplexed.js");
var _integrationJs = require("./integration.js");
var _providerSkipJs = require("./utils/ai/providerSkip.js");
var _envToBoolJs = require("./utils/envToBool.js");
var _scopeDataJs = require("./utils/scopeData.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _checkinJs = require("./checkin.js");
var _hasSpansEnabledJs = require("./utils/hasSpansEnabled.js");
var _beforeSendSpanJs = require("./tracing/spans/beforeSendSpan.js");
var _isSentryRequestUrlJs = require("./utils/isSentryRequestUrl.js");
var _handleCallbackErrorsJs = require("./utils/handleCallbackErrors.js");
var _parameterizeJs = require("./utils/parameterize.js");
var _tunnelJs = require("./utils/tunnel.js");
var _ipAddressJs = require("./utils/ipAddress.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _parseSampleRateJs = require("./utils/parseSampleRate.js");
var _sdkMetadataJs = require("./utils/sdkMetadata.js");
var _traceDataJs = require("./utils/traceData.js");
var _tracePropagationTargetsJs = require("./utils/tracePropagationTargets.js");
var _metaJs = require("./utils/meta.js");
var _debounceJs = require("./utils/debounce.js");
var _weakRefJs = require("./utils/weakRef.js");
var _shouldIgnoreSpanJs = require("./utils/should-ignore-span.js");
var _requestJs = require("./utils/request.js");
var _constantsJs = require("./constants.js");
var _breadcrumbsJs = require("./breadcrumbs.js");
var _functiontostringJs = require("./integrations/functiontostring.js");
var _eventFiltersJs = require("./integrations/eventFilters.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _moduleMetadataJs = require("./integrations/moduleMetadata.js");
var _requestdataJs = require("./integrations/requestdata.js");
var _captureconsoleJs = require("./integrations/captureconsole.js");
var _indexJs1 = require("./integrations/express/index.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _extraerrordataJs = require("./integrations/extraerrordata.js");
var _rewriteframesJs = require("./integrations/rewriteframes.js");
var _supabaseJs = require("./integrations/supabase.js");
var _postgresjsJs = require("./integrations/postgresjs.js");
var _zoderrorsJs = require("./integrations/zoderrors.js");
var _thirdPartyErrorsFilterJs = require("./integrations/third-party-errors-filter.js");
var _consoleJs = require("./integrations/console.js");
var _featureFlagsIntegrationJs = require("./integrations/featureFlags/featureFlagsIntegration.js");
var _growthbookJs = require("./integrations/featureFlags/growthbook.js");
var _conversationIdJs = require("./integrations/conversationId.js");
var _profilingJs = require("./profiling.js");
var _fetchJs = require("./fetch.js");
var _trpcJs = require("./trpc.js");
var _indexJs2 = require("./integrations/mcp-server/index.js");
var _feedbackJs = require("./feedback.js");
var _internalJs = require("./logs/internal.js");
var _publicApiJs = require("./logs/public-api.js");
var _consoleIntegrationJs = require("./logs/console-integration.js");
var _internalJs1 = require("./metrics/internal.js");
var _publicApiJs1 = require("./metrics/public-api.js");
var _consolaJs = require("./integrations/consola.js");
var _indexJs3 = require("./tracing/vercel-ai/index.js");
var _utilsJs1 = require("./tracing/vercel-ai/utils.js");
var _constantsJs1 = require("./tracing/vercel-ai/constants.js");
var _indexJs4 = require("./tracing/openai/index.js");
var _constantsJs2 = require("./tracing/openai/constants.js");
var _indexJs5 = require("./tracing/anthropic-ai/index.js");
var _constantsJs3 = require("./tracing/anthropic-ai/constants.js");
var _indexJs6 = require("./tracing/google-genai/index.js");
var _constantsJs4 = require("./tracing/google-genai/constants.js");
var _indexJs7 = require("./tracing/langchain/index.js");
var _constantsJs5 = require("./tracing/langchain/constants.js");
var _indexJs8 = require("./tracing/langgraph/index.js");
var _constantsJs6 = require("./tracing/langgraph/constants.js");
var _spanBufferJs = require("./tracing/spans/spanBuffer.js");
var _hasSpanStreamingEnabledJs = require("./tracing/spans/hasSpanStreamingEnabled.js");
var _spanStreamingJs = require("./integrations/spanStreaming.js");
var _featureFlagsJs = require("./utils/featureFlags.js");
var _aggregateErrorsJs = require("./utils/aggregate-errors.js");
var _breadcrumbLogLevelJs = require("./utils/breadcrumb-log-level.js");
var _browserJs = require("./utils/browser.js");
var _dsnJs = require("./utils/dsn.js");
var _errorJs = require("./utils/error.js");
var _worldwideJs = require("./utils/worldwide.js");
var _consoleJs1 = require("./instrument/console.js");
var _fetchJs1 = require("./instrument/fetch.js");
var _globalErrorJs = require("./instrument/globalError.js");
var _globalUnhandledRejectionJs = require("./instrument/globalUnhandledRejection.js");
var _handlersJs = require("./instrument/handlers.js");
var _isJs = require("./utils/is.js");
var _isBrowserJs = require("./utils/isBrowser.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _miscJs = require("./utils/misc.js");
var _nodeJs = require("./utils/node.js");
var _normalizeJs = require("./utils/normalize.js");
var _normalizationHintsJs = require("./utils/normalizationHints.js");
var _objectJs = require("./utils/object.js");
var _pathJs = require("./utils/path.js");
var _promisebufferJs = require("./utils/promisebuffer.js");
var _severityJs = require("./utils/severity.js");
var _exportsJs1 = require("./utils/exports.js");
var _stacktraceJs = require("./utils/stacktrace.js");
var _nodeStackTraceJs = require("./utils/node-stack-trace.js");
var _stringJs = require("./utils/string.js");
var _supportsJs = require("./utils/supports.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _timeJs = require("./utils/time.js");
var _tracingJs = require("./utils/tracing.js");
var _envJs = require("./utils/env.js");
var _envelopeJs1 = require("./utils/envelope.js");
var _clientreportJs = require("./utils/clientreport.js");
var _ratelimitJs = require("./utils/ratelimit.js");
var _baggageJs = require("./utils/baggage.js");
var _urlJs = require("./utils/url.js");
var _eventbuilderJs = require("./utils/eventbuilder.js");
var _anrJs = require("./utils/anr.js");
var _lruJs = require("./utils/lru.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _vercelWaitUntilJs = require("./utils/vercelWaitUntil.js");
var _flushIfServerlessJs = require("./utils/flushIfServerless.js");
var _versionJs = require("./utils/version.js");
var _debugIdsJs = require("./utils/debug-ids.js");
var _metadataJs = require("./metadata.js");
var _escapeStringForRegexJs = require("./vendor/escapeStringForRegex.js");
var _randomSafeContextJs = require("./utils/randomSafeContext.js");
var _timerJs = require("./utils/timer.js");
var _embeddingsJs = require("./tracing/langchain/embeddings.js");

},{"./tracing/errors.js":"gdtmI","./tracing/utils.js":false,"./tracing/idleSpan.js":"kOcu8","./tracing/sentrySpan.js":false,"./tracing/sentryNonRecordingSpan.js":"bVjrp","./tracing/spanstatus.js":"cq3xe","./tracing/trace.js":"jFgPq","./tracing/dynamicSamplingContext.js":"1usYY","./tracing/measurement.js":"8x3Vk","./tracing/sampling.js":false,"./tracing/logSpans.js":false,"./tracing/spans/captureSpan.js":"2SWd6","./semanticAttributes.js":"CCqFC","./envelope.js":false,"./exports.js":"9zd3A","./currentScopes.js":"5f8H7","./defaultScopes.js":false,"./asyncContext/index.js":false,"./carrier.js":false,"./session.js":false,"./scope.js":"dAMNc","./eventProcessors.js":false,"./api.js":"f5OYB","./client.js":"d2Ee4","./server-runtime-client.js":false,"./sdk.js":"2GuLR","./transports/base.js":"hLCdF","./transports/offline.js":"k4bjn","./transports/multiplexed.js":"fFmDB","./integration.js":"b7ak3","./utils/ai/providerSkip.js":false,"./utils/envToBool.js":false,"./utils/scopeData.js":false,"./utils/prepareEvent.js":"iluNN","./checkin.js":false,"./utils/hasSpansEnabled.js":"ddp8b","./tracing/spans/beforeSendSpan.js":"8cA2V","./utils/isSentryRequestUrl.js":"ayFtx","./utils/handleCallbackErrors.js":false,"./utils/parameterize.js":"boXso","./utils/tunnel.js":false,"./utils/ipAddress.js":"7MOFI","./utils/spanUtils.js":"2Bh30","./utils/spanOnScope.js":"l06IL","./utils/parseSampleRate.js":"d6zVq","./utils/sdkMetadata.js":"le1kr","./utils/traceData.js":"aiP8Q","./utils/tracePropagationTargets.js":false,"./utils/meta.js":false,"./utils/debounce.js":"Gv4xx","./utils/weakRef.js":false,"./utils/should-ignore-span.js":false,"./utils/request.js":false,"./constants.js":"chV8V","./breadcrumbs.js":"1mChz","./integrations/functiontostring.js":"7qRY6","./integrations/eventFilters.js":"7ofVr","./integrations/linkederrors.js":false,"./integrations/moduleMetadata.js":"k0cAK","./integrations/requestdata.js":false,"./integrations/captureconsole.js":"cFxlD","./integrations/express/index.js":false,"./integrations/dedupe.js":"egVbF","./integrations/extraerrordata.js":"fGPte","./integrations/rewriteframes.js":"eFzi3","./integrations/supabase.js":"kv21b","./integrations/postgresjs.js":false,"./integrations/zoderrors.js":"6xTDd","./integrations/third-party-errors-filter.js":"jmBPg","./integrations/console.js":false,"./integrations/featureFlags/featureFlagsIntegration.js":"8WDuG","./integrations/featureFlags/growthbook.js":"4NUMl","./integrations/conversationId.js":"48aVW","./profiling.js":false,"./fetch.js":"7kVE9","./trpc.js":false,"./integrations/mcp-server/index.js":false,"./feedback.js":"l9nNR","./logs/internal.js":"bO2sr","./logs/public-api.js":"ibTkj","./logs/console-integration.js":"d38y8","./metrics/internal.js":"htABD","./metrics/public-api.js":"imV6l","./integrations/consola.js":"9EcD4","./tracing/vercel-ai/index.js":false,"./tracing/vercel-ai/utils.js":false,"./tracing/vercel-ai/constants.js":false,"./tracing/openai/index.js":"4p1QQ","./tracing/openai/constants.js":false,"./tracing/anthropic-ai/index.js":"e0CxK","./tracing/anthropic-ai/constants.js":false,"./tracing/google-genai/index.js":"fGcNz","./tracing/google-genai/constants.js":false,"./tracing/langchain/index.js":"k2Iuh","./tracing/langchain/constants.js":false,"./tracing/langgraph/index.js":"gcVGc","./tracing/langgraph/constants.js":false,"./tracing/spans/spanBuffer.js":"899Ji","./tracing/spans/hasSpanStreamingEnabled.js":"58R9c","./integrations/spanStreaming.js":false,"./utils/featureFlags.js":"kDEWt","./utils/aggregate-errors.js":"1SaXE","./utils/breadcrumb-log-level.js":"bQvgk","./utils/browser.js":"1ewaB","./utils/dsn.js":"dadDm","./utils/error.js":false,"./utils/worldwide.js":"2qGVN","./instrument/console.js":"447RN","./instrument/fetch.js":"2tP5i","./instrument/globalError.js":"92QeV","./instrument/globalUnhandledRejection.js":"211Fg","./instrument/handlers.js":"laAoO","./utils/is.js":"jiTW9","./utils/isBrowser.js":"en9iQ","./utils/debug-logger.js":"6Sybg","./utils/misc.js":"21lxb","./utils/node.js":false,"./utils/normalize.js":"bplSM","./utils/normalizationHints.js":false,"./utils/object.js":"9SPt0","./utils/path.js":false,"./utils/promisebuffer.js":"a1A80","./utils/severity.js":"62Hx5","./utils/exports.js":false,"./utils/stacktrace.js":"1WmJO","./utils/node-stack-trace.js":false,"./utils/string.js":"ankyT","./utils/supports.js":"9hk0S","./utils/syncpromise.js":"h255F","./utils/time.js":"lCk2j","./utils/tracing.js":"fyjN8","./utils/env.js":"6Zp9k","./utils/envelope.js":"fQsVK","./utils/clientreport.js":false,"./utils/ratelimit.js":"cW23y","./utils/baggage.js":false,"./utils/url.js":"3T1sD","./utils/eventbuilder.js":"bHgOY","./utils/anr.js":false,"./utils/lru.js":false,"./utils/propagationContext.js":"K2Zo8","./utils/vercelWaitUntil.js":false,"./utils/flushIfServerless.js":false,"./utils/version.js":"bRSzn","./utils/debug-ids.js":"lWwdc","./metadata.js":false,"./vendor/escapeStringForRegex.js":false,"./utils/randomSafeContext.js":false,"./utils/timer.js":false,"./tracing/langchain/embeddings.js":"gDYV0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"gdtmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSpanErrorInstrumentation", ()=>registerSpanErrorInstrumentation);
var _debugBuildJs = require("../debug-build.js");
var _globalErrorJs = require("../instrument/globalError.js");
var _globalUnhandledRejectionJs = require("../instrument/globalUnhandledRejection.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _spanstatusJs = require("./spanstatus.js");
let errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function registerSpanErrorInstrumentation() {
    if (errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        const activeSpan = (0, _spanUtilsJs.getActiveSpan)();
        const rootSpan = activeSpan && (0, _spanUtilsJs.getRootSpan)(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = "sentry_tracingErrorCallback";
    errorsInstrumented = true;
    (0, _globalErrorJs.addGlobalErrorInstrumentationHandler)(errorCallback);
    (0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler)(errorCallback);
}

},{"../debug-build.js":"a2zY5","../instrument/globalError.js":"92QeV","../instrument/globalUnhandledRejection.js":"211Fg","../utils/debug-logger.js":"6Sybg","../utils/spanUtils.js":"2Bh30","./spanstatus.js":"cq3xe","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"a2zY5":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"92QeV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", ()=>addGlobalErrorInstrumentationHandler);
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
let _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = (0, _worldwideJs.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, _worldwideJs.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column,
            error,
            line,
            msg,
            url
        };
        (0, _handlersJs.triggerHandlers)("error", handlerData);
        if (_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

},{"../utils/worldwide.js":"2qGVN","./handlers.js":"laAoO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2qGVN":[function(require,module,exports) {
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_OBJ", ()=>GLOBAL_OBJ);
const GLOBAL_OBJ = globalThis;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"laAoO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHandler", ()=>addHandler);
parcelHelpers.export(exports, "maybeInstrument", ()=>maybeInstrument);
parcelHelpers.export(exports, "resetInstrumentationHandlers", ()=>resetInstrumentationHandlers);
parcelHelpers.export(exports, "triggerHandlers", ()=>triggerHandlers);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _stacktraceJs = require("../utils/stacktrace.js");
// We keep the handlers globally
const handlers = {};
const instrumented = {};
/** Add a handler function. Returns a function to remove the handler. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
    return ()=>{
        const typeHandlers = handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach((key)=>{
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    const typeHandlers = type && handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, _stacktraceJs.getFunctionName)(handler)}\nError:`, e);
    }
}

},{"../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/stacktrace.js":"1WmJO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6Sybg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>CONSOLE_LEVELS);
parcelHelpers.export(exports, "consoleSandbox", ()=>consoleSandbox);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "originalConsoleMethods", ()=>originalConsoleMethods);
var _carrierJs = require("../carrier.js");
var _debugBuildJs = require("../debug-build.js");
var _worldwideJs = require("./worldwide.js");
const CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** Prefix for logging strings */ const PREFIX = "Sentry Logger ";
/** This may be mutated by the console instrumentation. */ const originalConsoleMethods = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!("console" in (0, _worldwideJs.GLOBAL_OBJ))) return callback();
    const console = (0, _worldwideJs.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function enable() {
    _getLoggerSettings().enabled = true;
}
function disable() {
    _getLoggerSettings().enabled = false;
}
function isEnabled() {
    return _getLoggerSettings().enabled;
}
function log(...args) {
    _maybeLog("log", ...args);
}
function warn(...args) {
    _maybeLog("warn", ...args);
}
function error(...args) {
    _maybeLog("error", ...args);
}
function _maybeLog(level, ...args) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    if (isEnabled()) consoleSandbox(()=>{
        (0, _worldwideJs.GLOBAL_OBJ).console[level](`${PREFIX}[${level}]:`, ...args);
    });
}
function _getLoggerSettings() {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, _carrierJs.getGlobalSingleton)("loggerSettings", ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const debug = {
    /** Enable logging. */ enable,
    /** Disable logging. */ disable,
    /** Check if logging is enabled. */ isEnabled,
    /** Log a message. */ log,
    /** Log a warning. */ warn,
    /** Log an error. */ error
};

},{"../carrier.js":"kQ3LD","../debug-build.js":"a2zY5","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"kQ3LD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalSingleton", ()=>getGlobalSingleton);
parcelHelpers.export(exports, "getMainCarrier", ()=>getMainCarrier);
parcelHelpers.export(exports, "getSentryCarrier", ()=>getSentryCarrier);
var _versionJs = require("./utils/version.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    // This ensures a Sentry carrier exists
    getSentryCarrier((0, _worldwideJs.GLOBAL_OBJ));
    return 0, _worldwideJs.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, _versionJs.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator, obj = (0, _worldwideJs.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, _versionJs.SDK_VERSION] = __SENTRY__[0, _versionJs.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

},{"./utils/version.js":"bRSzn","./utils/worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bRSzn":[function(require,module,exports) {
// This is a magic string replaced by rollup
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", ()=>SDK_VERSION);
const SDK_VERSION = "10.51.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1WmJO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNKNOWN_FUNCTION", ()=>UNKNOWN_FUNCTION);
parcelHelpers.export(exports, "createStackParser", ()=>createStackParser);
parcelHelpers.export(exports, "getFramesFromEvent", ()=>getFramesFromEvent);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
parcelHelpers.export(exports, "getVueInternalName", ()=>getVueInternalName);
parcelHelpers.export(exports, "normalizeStackTracePath", ()=>normalizeStackTracePath);
parcelHelpers.export(exports, "stackParserFromStackParserOptions", ()=>stackParserFromStackParserOptions);
parcelHelpers.export(exports, "stripSentryFramesAndReverse", ()=>stripSentryFramesAndReverse);
const STACKTRACE_FRAME_LIMIT = 50;
const UNKNOWN_FUNCTION = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return createStackParser(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || getLastStackFrame(localStack).filename,
            function: frame.function || UNKNOWN_FUNCTION
        }));
}
function getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function getVueInternalName(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = "__v_isVNode" in value && value.__v_isVNode;
    return isVNode ? "[VueVNode]" : "[VueViewModel]";
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"211Fg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", ()=>addGlobalUnhandledRejectionInstrumentationHandler);
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
let _oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, _handlersJs.triggerHandlers)("unhandledrejection", handlerData);
        if (_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

},{"../utils/worldwide.js":"2qGVN","./handlers.js":"laAoO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2Bh30":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_getSegmentSpan", ()=>INTERNAL_getSegmentSpan);
parcelHelpers.export(exports, "TRACE_FLAG_NONE", ()=>TRACE_FLAG_NONE);
parcelHelpers.export(exports, "TRACE_FLAG_SAMPLED", ()=>TRACE_FLAG_SAMPLED);
parcelHelpers.export(exports, "addChildSpanToSpan", ()=>addChildSpanToSpan);
parcelHelpers.export(exports, "convertSpanLinksForEnvelope", ()=>convertSpanLinksForEnvelope);
parcelHelpers.export(exports, "getActiveSpan", ()=>getActiveSpan);
parcelHelpers.export(exports, "getRootSpan", ()=>getRootSpan);
parcelHelpers.export(exports, "getSimpleStatusMessage", ()=>getSimpleStatusMessage);
parcelHelpers.export(exports, "getSpanDescendants", ()=>getSpanDescendants);
parcelHelpers.export(exports, "getStatusMessage", ()=>getStatusMessage);
parcelHelpers.export(exports, "getStreamedSpanLinks", ()=>getStreamedSpanLinks);
parcelHelpers.export(exports, "removeChildSpanFromSpan", ()=>removeChildSpanFromSpan);
parcelHelpers.export(exports, "showSpanDropWarning", ()=>showSpanDropWarning);
parcelHelpers.export(exports, "spanIsSampled", ()=>spanIsSampled);
parcelHelpers.export(exports, "spanTimeInputToSeconds", ()=>spanTimeInputToSeconds);
parcelHelpers.export(exports, "spanToJSON", ()=>spanToJSON);
parcelHelpers.export(exports, "spanToStreamedSpanJSON", ()=>spanToStreamedSpanJSON);
parcelHelpers.export(exports, "spanToTraceContext", ()=>spanToTraceContext);
parcelHelpers.export(exports, "spanToTraceHeader", ()=>spanToTraceHeader);
parcelHelpers.export(exports, "spanToTraceparentHeader", ()=>spanToTraceparentHeader);
parcelHelpers.export(exports, "spanToTransactionTraceContext", ()=>spanToTransactionTraceContext);
parcelHelpers.export(exports, "streamedSpanJsonToSerializedSpan", ()=>streamedSpanJsonToSerializedSpan);
parcelHelpers.export(exports, "updateSpanName", ()=>updateSpanName);
var _indexJs = require("../asyncContext/index.js");
var _attributesJs = require("../attributes.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _utilsJs = require("../tracing/utils.js");
var _objectJs = require("./object.js");
var _propagationContextJs = require("./propagationContext.js");
var _timeJs = require("./time.js");
var _tracingJs = require("./tracing.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanOnScopeJs = require("./spanOnScope.js");
// These are aligned with OpenTelemetry trace flags
const TRACE_FLAG_NONE = 0x0;
const TRACE_FLAG_SAMPLED = 0x1;
let hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data, op, parent_span_id, status, origin, links } = spanToJSON(span);
    return {
        parent_span_id,
        span_id,
        trace_id,
        data,
        op,
        status,
        origin,
        links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function spanToTraceContext(span) {
    const { spanId, traceId: trace_id, isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
    const scope = (0, _utilsJs.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, _propagationContextJs.generateSpanId)() : spanId;
    return {
        parent_span_id,
        span_id,
        trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    const { traceId, spanId } = span.spanContext();
    const sampled = spanIsSampled(span);
    return (0, _tracingJs.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function spanToTraceparentHeader(span) {
    const { traceId, spanId } = span.spanContext();
    const sampled = spanIsSampled(span);
    return (0, _tracingJs.generateTraceparentHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId, traceId, traceFlags, ...restContext }, attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === TRACE_FLAG_SAMPLED,
            attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Converts the span links array to a flattened version with serialized attributes for V2 spans.
 *
 * If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId, traceId, traceFlags }, attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === TRACE_FLAG_SAMPLED,
            attributes
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === "number") return ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return ensureTimestampInSeconds(input.getTime());
    return (0, _timeJs.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function spanToJSON(span) {
    if (spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes, startTime, name, endTime, status, links } = span;
        return {
            span_id,
            trace_id,
            data: attributes,
            description: name,
            parent_span_id: getOtelParentSpanId(span),
            start_timestamp: spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: spanTimeInputToSeconds(endTime) || undefined,
            status: getStatusMessage(status),
            op: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: convertSpanLinksForEnvelope(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id,
        trace_id,
        start_timestamp: 0,
        data: {}
    };
}
/**
 * Convert a span to the intermediate {@link StreamedSpanJSON} representation.
 */ function spanToStreamedSpanJSON(span) {
    if (spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes, startTime, name, endTime, status, links } = span;
        return {
            name,
            span_id,
            trace_id,
            parent_span_id: getOtelParentSpanId(span),
            start_timestamp: spanTimeInputToSeconds(startTime),
            end_timestamp: spanTimeInputToSeconds(endTime),
            is_segment: span === INTERNAL_getSegmentSpan(span),
            status: getSimpleStatusMessage(status),
            attributes,
            links: getStreamedSpanLinks(links)
        };
    }
    // Finally, as a fallback, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id,
        trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === INTERNAL_getSegmentSpan(span)
    };
}
/**
 * In preparation for the next major of OpenTelemetry, we want to support
 * looking up the parent span id according to the new API
 * In OTel v1, the parent span id is accessed as `parentSpanId`
 * In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
 */ function getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : undefined;
}
/**
 * Converts a {@link StreamedSpanJSON} to a {@link SerializedSpan}.
 * This is the final serialized span format that is sent to Sentry.
 * The returned serilaized spans must not be consumed by users or SDK integrations.
 */ function streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: (0, _attributesJs.serializeAttributes)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, _attributesJs.serializeAttributes)(link.attributes)
            }))
    };
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags } = span.spanContext();
    return traceFlags === TRACE_FLAG_SAMPLED;
}
/** Get the status message to use for a JSON representation of a span. */ function getStatusMessage(status) {
    if (!status || status.code === (0, _spanstatusJs.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, _spanstatusJs.SPAN_STATUS_OK)) return "ok";
    return status.message || "internal_error";
}
/**
 * Convert the various statuses to the simple onces expected by Sentry for steamed spans ('ok' is default).
 */ function getSimpleStatusMessage(status) {
    return !status || status.code === (0, _spanstatusJs.SPAN_STATUS_OK) || status.code === (0, _spanstatusJs.SPAN_STATUS_UNSET) || status.message === "cancelled" ? "ok" : "error";
}
const CHILD_SPANS_FIELD = "_sentryChildSpans";
const ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function addChildSpanToSpan(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[ROOT_SPAN_FIELD] || span;
    (0, _objectJs.addNonEnumerableProperty)(childSpan, ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].add(childSpan);
    else (0, _objectJs.addNonEnumerableProperty)(span, CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function removeChildSpanFromSpan(span, childSpan) {
    if (span[CHILD_SPANS_FIELD]) span[CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function getSpanDescendants(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if (spanIsSampled(span)) {
            resultSet.add(span);
            const childSpans = span[CHILD_SPANS_FIELD] ? Array.from(span[CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ const getRootSpan = INTERNAL_getSegmentSpan;
/**
 * Returns the segment span of a given span.
 */ function INTERNAL_getSegmentSpan(span) {
    return span[ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, _spanOnScopeJs._getSpanForScope)((0, _currentScopesJs.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function showSpanDropWarning() {
    if (!hasShownSpanDropWarning) {
        (0, _debugLoggerJs.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

},{"../asyncContext/index.js":"gS3DN","../attributes.js":"gGkrY","../carrier.js":"kQ3LD","../currentScopes.js":"5f8H7","../semanticAttributes.js":"CCqFC","../tracing/spanstatus.js":"cq3xe","../tracing/utils.js":"a2SOi","./object.js":"9SPt0","./propagationContext.js":"K2Zo8","./time.js":"lCk2j","./tracing.js":"fyjN8","./debug-logger.js":"6Sybg","./spanOnScope.js":"l06IL","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"gS3DN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAsyncContextStrategy", ()=>getAsyncContextStrategy);
parcelHelpers.export(exports, "setAsyncContextStrategy", ()=>setAsyncContextStrategy);
var _carrierJs = require("../carrier.js");
var _stackStrategyJs = require("./stackStrategy.js");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, _carrierJs.getMainCarrier)();
    const sentry = (0, _carrierJs.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function getAsyncContextStrategy(carrier) {
    const sentry = (0, _carrierJs.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, _stackStrategyJs.getStackAsyncContextStrategy)();
}

},{"../carrier.js":"kQ3LD","./stackStrategy.js":"ciSGh","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"ciSGh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncContextStack", ()=>AsyncContextStack);
parcelHelpers.export(exports, "getStackAsyncContextStrategy", ()=>getStackAsyncContextStrategy);
var _defaultScopesJs = require("../defaultScopes.js");
var _scopeJs = require("../scope.js");
var _chainAndCopyPromiselikeJs = require("../utils/chain-and-copy-promiselike.js");
var _isJs = require("../utils/is.js");
var _carrierJs = require("../carrier.js");
/**
 * This is an object that holds a stack of scopes.
 */ class AsyncContextStack {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, _scopeJs.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, _scopeJs.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, _isJs.isThenable)(maybePromiseResult)) return (0, _chainAndCopyPromiselikeJs.chainAndCopyPromiseLike)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function getAsyncContextStack() {
    const registry = (0, _carrierJs.getMainCarrier)();
    const sentry = (0, _carrierJs.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new AsyncContextStack((0, _defaultScopesJs.getDefaultCurrentScope)(), (0, _defaultScopesJs.getDefaultIsolationScope)());
}
function withScope(callback) {
    return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
    const stack = getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function withIsolationScope(callback) {
    return getAsyncContextStack().withScope(()=>{
        return callback(getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function getStackAsyncContextStrategy() {
    return {
        withIsolationScope,
        withScope,
        withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return withIsolationScope(callback);
        },
        getCurrentScope: ()=>getAsyncContextStack().getScope(),
        getIsolationScope: ()=>getAsyncContextStack().getIsolationScope()
    };
}

},{"../defaultScopes.js":"c0TVE","../scope.js":"dAMNc","../utils/chain-and-copy-promiselike.js":"eQV7y","../utils/is.js":"jiTW9","../carrier.js":"kQ3LD","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"c0TVE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultCurrentScope", ()=>getDefaultCurrentScope);
parcelHelpers.export(exports, "getDefaultIsolationScope", ()=>getDefaultIsolationScope);
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
/** Get the default current scope. */ function getDefaultCurrentScope() {
    return (0, _carrierJs.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, _scopeJs.Scope)());
}
/** Get the default isolation scope. */ function getDefaultIsolationScope() {
    return (0, _carrierJs.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, _scopeJs.Scope)());
}

},{"./carrier.js":"kQ3LD","./scope.js":"dAMNc","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"dAMNc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", ()=>Scope);
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _mergeJs = require("./utils/merge.js");
var _miscJs = require("./utils/misc.js");
var _propagationContextJs = require("./utils/propagationContext.js");
var _randomSafeContextJs = require("./utils/randomSafeContext.js");
var _spanOnScopeJs = require("./utils/spanOnScope.js");
var _stringJs = require("./utils/string.js");
var _timeJs = require("./utils/time.js");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class Scope {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: (0, _randomSafeContextJs.safeMathRandom)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, _spanOnScopeJs._setSpanForScope)(newScope, (0, _spanOnScopeJs._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, _sessionJs.updateSession)(this._session, {
            user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof Scope ? scopeToMerge.getScopeData() : (0, _isJs.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags, attributes, extra, user, contexts, level, fingerprint = [], propagationContext, conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, _spanOnScopeJs._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: (0, _randomSafeContextJs.safeMathRandom)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, _timeJs.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, _stringJs.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, _spanOnScopeJs._getSpanForScope)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, _mergeJs.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, _miscJs.uuid4)();
        if (!this._client) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, _miscJs.uuid4)();
        if (!this._client) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, _miscJs.uuid4)();
        if (!this._client) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

},{"./debug-build.js":"a2zY5","./session.js":"yGpuM","./utils/debug-logger.js":"6Sybg","./utils/is.js":"jiTW9","./utils/merge.js":"4G0g1","./utils/misc.js":"21lxb","./utils/propagationContext.js":"K2Zo8","./utils/randomSafeContext.js":"fExsU","./utils/spanOnScope.js":"l06IL","./utils/string.js":"ankyT","./utils/time.js":"lCk2j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"yGpuM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeSession", ()=>closeSession);
parcelHelpers.export(exports, "makeSession", ()=>makeSession);
parcelHelpers.export(exports, "updateSession", ()=>updateSession);
var _miscJs = require("./utils/misc.js");
var _timeJs = require("./utils/time.js");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, _timeJs.timestampInSeconds)();
    const session = {
        sid: (0, _miscJs.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>sessionToJSON(session)
    };
    if (context) updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, _timeJs.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, _miscJs.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    let context = {};
    if (status) context = {
        status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

},{"./utils/misc.js":"21lxb","./utils/time.js":"lCk2j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"21lxb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addContextToFrame", ()=>addContextToFrame);
parcelHelpers.export(exports, "addExceptionMechanism", ()=>addExceptionMechanism);
parcelHelpers.export(exports, "addExceptionTypeValue", ()=>addExceptionTypeValue);
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>checkOrSetAlreadyCaught);
parcelHelpers.export(exports, "getEventDescription", ()=>getEventDescription);
parcelHelpers.export(exports, "isAlreadyCaptured", ()=>isAlreadyCaptured);
parcelHelpers.export(exports, "parseSemver", ()=>parseSemver);
parcelHelpers.export(exports, "uuid4", ()=>uuid4);
var _objectJs = require("./object.js");
var _randomSafeContextJs = require("./randomSafeContext.js");
var _stringJs = require("./string.js");
var _worldwideJs = require("./worldwide.js");
function getCrypto() {
    const gbl = (0, _worldwideJs.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
let emptyUuid;
function getRandomByte() {
    return (0, _randomSafeContextJs.safeMathRandom)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function uuid4(crypto = getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, _randomSafeContextJs.withRandomSafeContext)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    emptyUuid = "10000000100040008000100000000000";
    return emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    const { message, event_id: eventId } = event;
    if (message) return message;
    const firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    const firstException = getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function _parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    const match = input.match(SEMVER_REGEXP) || [];
    const major = _parseInt(match[1]);
    const minor = _parseInt(match[2]);
    const patch = _parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, _stringJs.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, _stringJs.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, _stringJs.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    if (isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _objectJs.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

},{"./object.js":"9SPt0","./randomSafeContext.js":"fExsU","./string.js":"ankyT","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9SPt0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>addNonEnumerableProperty);
parcelHelpers.export(exports, "convertToPlainObject", ()=>convertToPlainObject);
parcelHelpers.export(exports, "dropUndefinedKeys", ()=>dropUndefinedKeys);
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>extractExceptionKeysForMessage);
parcelHelpers.export(exports, "fill", ()=>fill);
parcelHelpers.export(exports, "getOriginalFunction", ()=>getOriginalFunction);
parcelHelpers.export(exports, "markFunctionWrapped", ()=>markFunctionWrapped);
parcelHelpers.export(exports, "objectify", ()=>objectify);
parcelHelpers.export(exports, "wrapMethod", ()=>wrapMethod);
var _debugBuildJs = require("../debug-build.js");
var _browserJs = require("./browser.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if (getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0, _isJs.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...getOwnProperties(value)
    };
    else if ((0, _isJs.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget),
            ...getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, _isJs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _isJs.isElement)(target) ? (0, _browserJs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch  {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    const keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push(_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if (isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = _dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _isJs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"../debug-build.js":"a2zY5","./browser.js":"1ewaB","./debug-logger.js":"6Sybg","./is.js":"jiTW9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1ewaB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComponentName", ()=>getComponentName);
parcelHelpers.export(exports, "getLocationHref", ()=>getLocationHref);
parcelHelpers.export(exports, "htmlTreeAsString", ()=>htmlTreeAsString);
var _isJs = require("./is.js");
var _worldwideJs = require("./worldwide.js");
const WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
const DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, _isJs.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

},{"./is.js":"jiTW9","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"jiTW9":[function(require,module,exports) {
// eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMError", ()=>isDOMError);
parcelHelpers.export(exports, "isDOMException", ()=>isDOMException);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isErrorEvent", ()=>isErrorEvent);
parcelHelpers.export(exports, "isEvent", ()=>isEvent);
parcelHelpers.export(exports, "isInstanceOf", ()=>isInstanceOf);
parcelHelpers.export(exports, "isParameterizedString", ()=>isParameterizedString);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isRequest", ()=>isRequest);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSyntheticEvent", ()=>isSyntheticEvent);
parcelHelpers.export(exports, "isThenable", ()=>isThenable);
parcelHelpers.export(exports, "isVueViewModel", ()=>isVueViewModel);
const objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function isRequest(request) {
    return typeof Request !== "undefined" && isInstanceOf(request, Request);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fExsU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeDateNow", ()=>safeDateNow);
parcelHelpers.export(exports, "safeMathRandom", ()=>safeMathRandom);
parcelHelpers.export(exports, "withRandomSafeContext", ()=>withRandomSafeContext);
var _worldwideJs = require("./worldwide.js");
// undefined = not yet resolved, null = no runner found, function = runner found
let RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function withRandomSafeContext(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if (RESOLVED_RUNNER !== undefined) return RESOLVED_RUNNER ? RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, _worldwideJs.GLOBAL_OBJ);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        RESOLVED_RUNNER = globalWithSymbol[sym];
        return RESOLVED_RUNNER(cb);
    }
    RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function safeMathRandom() {
    return withRandomSafeContext(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function safeDateNow() {
    return withRandomSafeContext(()=>Date.now());
}

},{"./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"ankyT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchingPattern", ()=>isMatchingPattern);
parcelHelpers.export(exports, "safeJoin", ()=>safeJoin);
parcelHelpers.export(exports, "snipLine", ()=>snipLine);
parcelHelpers.export(exports, "stringMatchesSomePattern", ()=>stringMatchesSomePattern);
parcelHelpers.export(exports, "truncate", ()=>truncate);
var _isJs = require("./is.js");
var _stacktraceJs = require("./stacktrace.js");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, _isJs.isVueViewModel)(value)) output.push((0, _stacktraceJs.getVueInternalName)(value));
            else output.push(String(value));
        } catch  {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!(0, _isJs.isString)(value)) return false;
    if ((0, _isJs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, _isJs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>isMatchingPattern(testString, pattern, requireExactStringMatch));
}

},{"./is.js":"jiTW9","./stacktrace.js":"1WmJO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"lCk2j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>browserPerformanceTimeOrigin);
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds);
parcelHelpers.export(exports, "timestampInSeconds", ()=>timestampInSeconds);
var _randomSafeContextJs = require("./randomSafeContext.js");
var _worldwideJs = require("./worldwide.js");
const ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function dateTimestampInSeconds() {
    return (0, _randomSafeContextJs.safeDateNow)() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    const { performance } = (0, _worldwideJs.GLOBAL_OBJ);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, _randomSafeContextJs.withRandomSafeContext)(()=>performance.now())) / ONE_SECOND_IN_MS;
    };
}
let _cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function timestampInSeconds() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = _cachedTimestampInSeconds ?? (_cachedTimestampInSeconds = createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function getBrowserTimeOrigin() {
    const { performance } = (0, _worldwideJs.GLOBAL_OBJ);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, _randomSafeContextJs.withRandomSafeContext)(()=>performance.now());
    const dateNow = (0, _randomSafeContextJs.safeDateNow)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function browserPerformanceTimeOrigin() {
    if (cachedTimeOrigin === null) cachedTimeOrigin = getBrowserTimeOrigin();
    return cachedTimeOrigin;
}

},{"./randomSafeContext.js":"fExsU","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"4G0g1":[function(require,module,exports) {
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
function merge(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = merge(output[key], mergeObj[key], levels - 1);
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"K2Zo8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSpanId", ()=>generateSpanId);
parcelHelpers.export(exports, "generateTraceId", ()=>generateTraceId);
var _miscJs = require("./misc.js");
/**
 * Generate a random, valid trace ID.
 */ function generateTraceId() {
    return (0, _miscJs.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function generateSpanId() {
    return (0, _miscJs.uuid4)().substring(16);
}

},{"./misc.js":"21lxb","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"l06IL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getSpanForScope", ()=>_getSpanForScope);
parcelHelpers.export(exports, "_setSpanForScope", ()=>_setSpanForScope);
var _objectJs = require("./object.js");
const SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _setSpanForScope(scope, span) {
    if (span) (0, _objectJs.addNonEnumerableProperty)(scope, SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function _getSpanForScope(scope) {
    return scope[SCOPE_SPAN_FIELD];
}

},{"./object.js":"9SPt0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"eQV7y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chainAndCopyPromiseLike", ()=>chainAndCopyPromiseLike);
const isActualPromise = (p)=>p instanceof Promise && !p[kChainedCopy];
const kChainedCopy = Symbol("chained PromiseLike");
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return isActualPromise(chained) && isActualPromise(original) ? chained : copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const copyProps = (original, chained)=>{
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [kChainedCopy]: true
    });
    return chained;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"gGkrY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attributeValueToTypedAttributeValue", ()=>attributeValueToTypedAttributeValue);
parcelHelpers.export(exports, "estimateTypedAttributesSizeInBytes", ()=>estimateTypedAttributesSizeInBytes);
parcelHelpers.export(exports, "isAttributeObject", ()=>isAttributeObject);
parcelHelpers.export(exports, "serializeAttributes", ()=>serializeAttributes);
var _isJs = require("./utils/is.js");
/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value, unit } = isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * Estimates the serialized byte size of {@link Attributes},
 * with a couple of heuristics for performance.
 */ function estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) // Assumption: Individual array items have the same type and roughly the same size
        // probably not always true but allows us to cut down on runtime
        weight += estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, _isJs.isPrimitive)(val)) weight += estimatePrimitiveSizeInBytes(val);
        else // default fallback for anything else (objects)
        weight += 100;
    }
    return weight;
}
function estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function getTypedAttributeValue(value) {
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value,
        type: primitiveType
    };
}

},{"./utils/is.js":"jiTW9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"5f8H7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClient", ()=>getClient);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "getExternalPropagationContext", ()=>getExternalPropagationContext);
parcelHelpers.export(exports, "getGlobalScope", ()=>getGlobalScope);
parcelHelpers.export(exports, "getIsolationScope", ()=>getIsolationScope);
parcelHelpers.export(exports, "getTraceContextFromScope", ()=>getTraceContextFromScope);
parcelHelpers.export(exports, "hasExternalPropagationContext", ()=>hasExternalPropagationContext);
parcelHelpers.export(exports, "registerExternalPropagationContext", ()=>registerExternalPropagationContext);
parcelHelpers.export(exports, "withIsolationScope", ()=>withIsolationScope);
parcelHelpers.export(exports, "withScope", ()=>withScope);
var _indexJs = require("./asyncContext/index.js");
var _carrierJs = require("./carrier.js");
var _scopeJs = require("./scope.js");
var _propagationContextJs = require("./utils/propagationContext.js");
let _externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function registerExternalPropagationContext(fn) {
    _externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function getExternalPropagationContext() {
    return _externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function hasExternalPropagationContext() {
    return _externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function getIsolationScope() {
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    return (0, _carrierJs.getGlobalSingleton)("globalScope", ()=>new (0, _scopeJs.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope(...rest) {
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function withIsolationScope(...rest) {
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function getClient() {
    return getCurrentScope().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function getTraceContextFromScope(scope) {
    const externalContext = getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId, parentSpanId, propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, _propagationContextJs.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

},{"./asyncContext/index.js":"gS3DN","./carrier.js":"kQ3LD","./scope.js":"dAMNc","./utils/propagationContext.js":"K2Zo8","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"CCqFC":[function(require,module,exports) {
/**
 * Use this attribute to represent the source of a span name.
 * Must be one of: custom, url, route, view, component, task
 * TODO(v11): rename this to sentry.span.source'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GEN_AI_CONVERSATION_ID_ATTRIBUTE", ()=>GEN_AI_CONVERSATION_ID_ATTRIBUTE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", ()=>SEMANTIC_ATTRIBUTE_CACHE_HIT);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", ()=>SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", ()=>SEMANTIC_ATTRIBUTE_CACHE_KEY);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", ()=>SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", ()=>SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", ()=>SEMANTIC_ATTRIBUTE_PROFILE_ID);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", ()=>SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT", ()=>SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", ()=>SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", ()=>SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", ()=>SEMANTIC_ATTRIBUTE_SENTRY_OP);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", ()=>SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_RELEASE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_RELEASE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SOURCE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", ()=>SEMANTIC_ATTRIBUTE_URL_FULL);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_EMAIL", ()=>SEMANTIC_ATTRIBUTE_USER_EMAIL);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_ID", ()=>SEMANTIC_ATTRIBUTE_USER_ID);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS", ()=>SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_USER_USERNAME", ()=>SEMANTIC_ATTRIBUTE_USER_USERNAME);
parcelHelpers.export(exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", ()=>SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE);
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
/** The reason why an idle span finished. */ const SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
/** The release version of the application */ const SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
/** The environment name (e.g., "production", "staging", "development") */ const SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
/** The segment name (e.g., "GET /users") */ const SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
/** The id of the segment that this span belongs to. */ const SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
/** The name of the Sentry SDK (e.g., "sentry.php", "sentry.javascript") */ const SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
/** The version of the Sentry SDK */ const SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
/** The user ID (gated by sendDefaultPii) */ const SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
/** The user email (gated by sendDefaultPii) */ const SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
/** The user IP address (gated by sendDefaultPii) */ const SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
/** The user username (gated by sendDefaultPii) */ const SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"cq3xe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPAN_STATUS_ERROR", ()=>SPAN_STATUS_ERROR);
parcelHelpers.export(exports, "SPAN_STATUS_OK", ()=>SPAN_STATUS_OK);
parcelHelpers.export(exports, "SPAN_STATUS_UNSET", ()=>SPAN_STATUS_UNSET);
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", ()=>getSpanStatusFromHttpCode);
parcelHelpers.export(exports, "setHttpStatus", ()=>setHttpStatus);
const SPAN_STATUS_UNSET = 0;
const SPAN_STATUS_OK = 1;
const SPAN_STATUS_ERROR = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"a2SOi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCapturedScopesOnSpan", ()=>getCapturedScopesOnSpan);
parcelHelpers.export(exports, "setCapturedScopesOnSpan", ()=>setCapturedScopesOnSpan);
var _objectJs = require("../utils/object.js");
var _weakRefJs = require("../utils/weakRef.js");
const SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, _objectJs.addNonEnumerableProperty)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, _weakRefJs.makeWeakRef)(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, _objectJs.addNonEnumerableProperty)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, _weakRefJs.derefWeakRef)(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}

},{"../utils/object.js":"9SPt0","../utils/weakRef.js":"fueTg","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fueTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "derefWeakRef", ()=>derefWeakRef);
parcelHelpers.export(exports, "makeWeakRef", ()=>makeWeakRef);
var _worldwideJs = require("./worldwide.js");
/**
 * Interface representing a weak reference to an object.
 * This matches the standard WeakRef interface but is defined here
 * because WeakRef is not available in ES2020 type definitions.
 */ /**
 * Creates a weak reference to an object if WeakRef is available,
 * otherwise returns the object directly.
 *
 * This is useful for breaking circular references while maintaining
 * compatibility with environments that don't support WeakRef (e.g., older browsers).
 *
 * @param value - The object to create a weak reference to
 * @returns A WeakRef wrapper if available, or the original object as fallback
 */ function makeWeakRef(value) {
    try {
        // @ts-expect-error - WeakRef may not be in the type definitions for older TS targets
        const WeakRefImpl = (0, _worldwideJs.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {
    // WeakRef not available or construction failed
    }
    return value;
}
/**
 * Resolves a potentially weak reference, returning the underlying object
 * or undefined if the reference has been garbage collected.
 *
 * @param ref - A MaybeWeakRef or undefined
 * @returns The referenced object, or undefined if GC'd or ref was undefined
 */ function derefWeakRef(ref) {
    if (!ref) return undefined;
    // Check if this is a WeakRef (has deref method)
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        // deref() failed - treat as GC'd
        return undefined;
    }
    // Direct reference fallback
    return ref;
}

},{"./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fyjN8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", ()=>TRACEPARENT_REGEXP);
parcelHelpers.export(exports, "extractTraceparentData", ()=>extractTraceparentData);
parcelHelpers.export(exports, "generateSentryTraceHeader", ()=>generateSentryTraceHeader);
parcelHelpers.export(exports, "generateTraceparentHeader", ()=>generateTraceparentHeader);
parcelHelpers.export(exports, "propagationContextFromHeaders", ()=>propagationContextFromHeaders);
parcelHelpers.export(exports, "shouldContinueTrace", ()=>shouldContinueTrace);
var _debugLoggerJs = require("./debug-logger.js");
var _baggageJs = require("./baggage.js");
var _dsnJs = require("./dsn.js");
var _parseSampleRateJs = require("./parseSampleRate.js");
var _propagationContextJs = require("./propagationContext.js");
var _randomSafeContextJs = require("./randomSafeContext.js");
// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    const traceparentData = extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, _propagationContextJs.generateTraceId)(),
        sampleRand: (0, _randomSafeContextJs.safeMathRandom)()
    };
    const sampleRand = getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId, parentSpanId, parentSampled } = traceparentData;
    return {
        traceId,
        parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader(traceId = (0, _propagationContextJs.generateTraceId)(), spanId = (0, _propagationContextJs.generateSpanId)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function generateTraceparentHeader(traceId = (0, _propagationContextJs.generateTraceId)(), spanId = (0, _propagationContextJs.generateSpanId)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, _parseSampleRateJs.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, _randomSafeContextJs.safeMathRandom)() * parsedSampleRate : parsedSampleRate + (0, _randomSafeContextJs.safeMathRandom)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, _randomSafeContextJs.safeMathRandom)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = (0, _dsnJs.extractOrgIdFromClient)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, _debugLoggerJs.debug).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, _debugLoggerJs.debug).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}

},{"./debug-logger.js":"6Sybg","./baggage.js":"klYqA","./dsn.js":"dadDm","./parseSampleRate.js":"d6zVq","./propagationContext.js":"K2Zo8","./randomSafeContext.js":"fExsU","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"klYqA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", ()=>MAX_BAGGAGE_STRING_LENGTH);
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", ()=>SENTRY_BAGGAGE_KEY_PREFIX);
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", ()=>SENTRY_BAGGAGE_KEY_PREFIX_REGEX);
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", ()=>baggageHeaderToDynamicSamplingContext);
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", ()=>dynamicSamplingContextToSentryBaggageHeader);
parcelHelpers.export(exports, "objectToBaggageHeader", ()=>objectToBaggageHeader);
parcelHelpers.export(exports, "parseBaggageHeader", ()=>parseBaggageHeader);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _isJs = require("./is.js");
const SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = parseBaggageHeader(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !(0, _isJs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

},{"../debug-build.js":"a2zY5","./debug-logger.js":"6Sybg","./is.js":"jiTW9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"dadDm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsnFromString", ()=>dsnFromString);
parcelHelpers.export(exports, "dsnToString", ()=>dsnToString);
parcelHelpers.export(exports, "extractOrgIdFromClient", ()=>extractOrgIdFromClient);
parcelHelpers.export(exports, "extractOrgIdFromDsnHost", ()=>extractOrgIdFromDsnHost);
parcelHelpers.export(exports, "makeDsn", ()=>makeDsn);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
/** Regular expression used to extract org ID from a DSN host. */ const ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn, withPassword = false) {
    const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    const match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, _debugLoggerJs.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host,
        pass,
        path,
        projectId,
        port,
        protocol: protocol,
        publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return true;
    const { port, projectId, protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, _debugLoggerJs.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, _debugLoggerJs.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!isValidProtocol(protocol)) {
        (0, _debugLoggerJs.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, _debugLoggerJs.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function extractOrgIdFromDsnHost(host) {
    const match = host.match(ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = extractOrgIdFromDsnHost(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    const components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) return undefined;
    return components;
}

},{"../debug-build.js":"a2zY5","./debug-logger.js":"6Sybg","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"d6zVq":[function(require,module,exports) {
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSampleRate", ()=>parseSampleRate);
function parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"kOcu8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACING_DEFAULTS", ()=>TRACING_DEFAULTS);
parcelHelpers.export(exports, "startIdleSpan", ()=>startIdleSpan);
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _shouldIgnoreSpanJs = require("../utils/should-ignore-span.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _timeJs = require("../utils/time.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _sentryNonRecordingSpanJs = require("./sentryNonRecordingSpan.js");
var _sentrySpanJs = require("./sentrySpan.js");
var _spanstatusJs = require("./spanstatus.js");
var _traceJs = require("./trace.js");
const TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function startIdleSpan(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout = TRACING_DEFAULTS.idleTimeout, finalTimeout = TRACING_DEFAULTS.finalTimeout, childSpanTimeout = TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd, trimIdleSpanEndTimestamp = true } = options;
    const client = (0, _currentScopesJs.getClient)();
    if (!client || !(0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        const span = new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        const dsc = {
            sample_rate: "0",
            sampled: "false",
            ...(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span)
        };
        (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
        return span;
    }
    const scope = (0, _currentScopesJs.getCurrentScope)();
    const previousActiveSpan = (0, _spanUtilsJs.getActiveSpan)();
    const span = _startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, _timeJs.timestampInSeconds)();
            const spanEndTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, _spanUtilsJs.getSpanDescendants)(span).filter((child)=>child !== span);
            const spanJson = (0, _spanUtilsJs.spanToJSON)(span);
            // If we have no spans, we just end, nothing else to do here
            // Likewise, if users explicitly ended the span, we simply end the span without timestamp adjustment
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = (0, _spanUtilsJs.spanToJSON)(current);
                if (!currentSpanJson.timestamp) return acc;
                // Ignored spans will get dropped later (in the client) but since we already adjust
                // the idle span end timestamp here, we can already take to-be-ignored spans out of
                // the calculation here.
                if (ignoreSpans && (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, undefined);
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = spanJson.start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, _timeJs.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, _timeJs.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, _spanOnScopeJs._setSpanForScope)(scope, previousActiveSpan);
        const spanJSON = (0, _spanUtilsJs.spanToJSON)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        // Set span status to 'ok' if it hasn't been explicitly set to an error status
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_OK)
        });
        (0, _debugLoggerJs.debug).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, _spanUtilsJs.getSpanDescendants)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, _spanUtilsJs.spanToJSON)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, _debugBuildJs.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, _debugLoggerJs.debug).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, _debugLoggerJs.debug).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, _spanUtilsJs.removeChildSpanFromSpan)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, _spanUtilsJs.spanToJSON)(startedSpan).timestamp || startedSpan instanceof (0, _sentrySpanJs.SentrySpan) && startedSpan.isStandaloneSpan()) return;
        const allSpans = (0, _spanUtilsJs.getSpanDescendants)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: "deadline_exceeded"
            });
            _finishReason = FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function _startIdleSpan(options) {
    const span = (0, _traceJs.startInactiveSpan)(options);
    (0, _spanOnScopeJs._setSpanForScope)((0, _currentScopesJs.getCurrentScope)(), span);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Started span is an idle span");
    return span;
}

},{"../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../semanticAttributes.js":"CCqFC","../utils/debug-logger.js":"6Sybg","../utils/hasSpansEnabled.js":"ddp8b","../utils/should-ignore-span.js":"kOBns","../utils/spanOnScope.js":"l06IL","../utils/spanUtils.js":"2Bh30","../utils/time.js":"lCk2j","./dynamicSamplingContext.js":"1usYY","./sentryNonRecordingSpan.js":"bVjrp","./sentrySpan.js":"8Lfvo","./spanstatus.js":"cq3xe","./trace.js":"jFgPq","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"ddp8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSpansEnabled", ()=>hasSpansEnabled);
var _currentScopesJs = require("../currentScopes.js");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, _currentScopesJs.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

},{"../currentScopes.js":"5f8H7","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"kOBns":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reparentChildSpans", ()=>reparentChildSpans);
parcelHelpers.export(exports, "shouldIgnoreSpan", ()=>shouldIgnoreSpan);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _stringJs = require("./string.js");
function logIgnoredSpan(droppedSpan) {
    (0, _debugLoggerJs.debug).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if (isStringOrRegExp(pattern)) {
            if (span.description && (0, _stringJs.isMatchingPattern)(span.description, pattern)) {
                (0, _debugBuildJs.DEBUG_BUILD) && logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, _stringJs.isMatchingPattern)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, _stringJs.isMatchingPattern)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches`, `opMatches`, or `attrsMatch`. So in contrary to how this looks,
        // not all of op, name, and attributes actually have to match. This is the most efficient way to check
        // for all combinations of name, op, and attribute patterns.
        if (nameMatches && opMatches && attrsMatch) {
            (0, _debugBuildJs.DEBUG_BUILD) && logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function _matchesAttributeValue(actual, pat) {
    // String values support pattern matching
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, _stringJs.isMatchingPattern)(actual, pat);
    // Arrays: element-wise strict equality
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    // Primitives: strict equality
    return actual === pat;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}

},{"../debug-build.js":"a2zY5","./debug-logger.js":"6Sybg","./string.js":"ankyT","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1usYY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freezeDscOnSpan", ()=>freezeDscOnSpan);
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", ()=>getDynamicSamplingContextFromClient);
parcelHelpers.export(exports, "getDynamicSamplingContextFromScope", ()=>getDynamicSamplingContextFromScope);
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", ()=>getDynamicSamplingContextFromSpan);
parcelHelpers.export(exports, "spanToBaggageHeader", ()=>spanToBaggageHeader);
var _constantsJs = require("../constants.js");
var _currentScopesJs = require("../currentScopes.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _dsnJs = require("../utils/dsn.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _objectJs = require("../utils/object.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _utilsJs = require("./utils.js");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, _objectJs.addNonEnumerableProperty)(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, _constantsJs.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key,
        trace_id,
        org_id: (0, _dsnJs.extractOrgIdFromClient)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    const client = (0, _currentScopesJs.getClient)();
    if (!client) return {};
    const rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    const rootSpanJson = (0, _spanUtilsJs.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    // TODO(v11): Only read `SEMANTIC_ATTRIBUTE_SENTRY_SOURCE` again, once we renamed it to `sentry.span.source`
    const source = rootSpanAttributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        dsc.sampled = String((0, _spanUtilsJs.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, _utilsJs.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function spanToBaggageHeader(span) {
    const dsc = getDynamicSamplingContextFromSpan(span);
    return (0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

},{"../constants.js":"chV8V","../currentScopes.js":"5f8H7","../semanticAttributes.js":"CCqFC","../utils/baggage.js":"klYqA","../utils/dsn.js":"dadDm","../utils/hasSpansEnabled.js":"ddp8b","../utils/object.js":"9SPt0","../utils/spanUtils.js":"2Bh30","./utils.js":"a2SOi","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"chV8V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", ()=>DEFAULT_ENVIRONMENT);
parcelHelpers.export(exports, "DEV_ENVIRONMENT", ()=>DEV_ENVIRONMENT);
const DEFAULT_ENVIRONMENT = "production";
const DEV_ENVIRONMENT = "development";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bVjrp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryNonRecordingSpan", ()=>SentryNonRecordingSpan);
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class SentryNonRecordingSpan {
    /**
   * Reason why this span was dropped, if applicable ('ignored' or 'sample_rate').
   * Used to propagate the correct client report outcome to descendant spans
   * when span streaming is enabled.
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, _propagationContextJs.generateTraceId)();
        this._spanId = spanContext.spanId || (0, _propagationContextJs.generateSpanId)();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, _spanUtilsJs.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}

},{"../utils/propagationContext.js":"K2Zo8","../utils/spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"8Lfvo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentrySpan", ()=>SentrySpan);
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _envelopeJs = require("../envelope.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _propagationContextJs = require("../utils/propagationContext.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _timeJs = require("../utils/time.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _logSpansJs = require("./logSpans.js");
var _measurementJs = require("./measurement.js");
var _hasSpanStreamingEnabledJs = require("./spans/hasSpanStreamingEnabled.js");
var _utilsJs = require("./utils.js");
/* eslint-disable max-lines */ const MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class SentrySpan {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, _propagationContextJs.generateTraceId)();
        this._spanId = spanContext.spanId || (0, _propagationContextJs.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, _timeJs.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "manual",
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId,
            traceId,
            traceFlags: sampled ? (0, _spanUtilsJs.TRACE_FLAG_SAMPLED) : (0, _spanUtilsJs.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
        (0, _logSpansJs.logSpanEnd)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, _spanUtilsJs.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, _measurementJs.timedEventsToMeasurements)(this._events),
            is_segment: this._isStandaloneSpan && (0, _spanUtilsJs.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, _spanUtilsJs.getRootSpan)(this).spanContext().spanId : undefined,
            links: (0, _spanUtilsJs.convertSpanLinksForEnvelope)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, _spanUtilsJs.getRootSpan)(this),
            status: (0, _spanUtilsJs.getSimpleStatusMessage)(this._status),
            attributes: this._attributes,
            links: (0, _spanUtilsJs.getStreamedSpanLinks)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Adding an event to span:", name);
        const time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, _timeJs.timestampInSeconds)();
        const attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name,
            time: (0, _spanUtilsJs.spanTimeInputToSeconds)(time),
            attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, _currentScopesJs.getClient)();
        if (client) {
            client.emit("spanEnd", this);
            // Guarding sending standalone v1 spans as v2 streamed spans for now.
            // Otherwise they'd be sent once as v1 spans and again as streamed spans.
            // We'll migrate CLS and LCP spans to streamed spans in a later PR and
            // INP spans in the next major of the SDK. At that point, we can fully remove
            // standalone v1 spans <3
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, _spanUtilsJs.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) sendSpanEnvelope((0, _envelopeJs.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && (0, _hasSpanStreamingEnabledJs.hasSpanStreamingEnabled)(client)) {
            // TODO (spans): Remove standalone span custom logic in favor of sending simple v2 web vital spans
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, _utilsJs.getCapturedScopesOnSpan)(this).scope || (0, _currentScopesJs.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!isFullFinishedSpan((0, _spanUtilsJs.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, _utilsJs.getCapturedScopesOnSpan)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, _spanUtilsJs.getSpanDescendants)(this).filter((span)=>span !== this && !isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, _spanUtilsJs.spanToJSON)(span)).filter(isFullFinishedSpan);
        const source = this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            delete span.data[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, _spanUtilsJs.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope,
                capturedSpanIsolationScope,
                dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source
                }
            }
        };
        const measurements = (0, _measurementJs.timedEventsToMeasurements)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function isStandaloneSpan(span) {
    return span instanceof SentrySpan && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function sendSpanEnvelope(envelope) {
    const client = (0, _currentScopesJs.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

},{"../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../envelope.js":"lC95z","../semanticAttributes.js":"CCqFC","../utils/debug-logger.js":"6Sybg","../utils/propagationContext.js":"K2Zo8","../utils/spanUtils.js":"2Bh30","../utils/time.js":"lCk2j","./dynamicSamplingContext.js":"1usYY","./logSpans.js":"dVfpy","./measurement.js":"8x3Vk","./spans/hasSpanStreamingEnabled.js":"58R9c","./utils.js":"a2SOi","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"lC95z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_enhanceEventWithSdkInfo", ()=>_enhanceEventWithSdkInfo);
parcelHelpers.export(exports, "createEventEnvelope", ()=>createEventEnvelope);
parcelHelpers.export(exports, "createSessionEnvelope", ()=>createSessionEnvelope);
parcelHelpers.export(exports, "createSpanEnvelope", ()=>createSpanEnvelope);
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _beforeSendSpanJs = require("./tracing/spans/beforeSendSpan.js");
var _dsnJs = require("./utils/dsn.js");
var _envelopeJs = require("./utils/envelope.js");
var _shouldIgnoreSpanJs = require("./utils/should-ignore-span.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function _enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, _dsnJs.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, _envelopeJs.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    _enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, _envelopeJs.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, _envelopeJs.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, _dsnJs.dsnToString)(dsn)
        }
    };
    const { beforeSendSpan, ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, _spanUtilsJs.spanToJSON)(span);
        return !(0, _shouldIgnoreSpanJs.shouldIgnoreSpan)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, _spanUtilsJs.spanToJSON)(span);
        const processedSpan = !(0, _beforeSendSpanJs.isStreamedBeforeSendSpanCallback)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, _spanUtilsJs.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, _spanUtilsJs.spanToJSON);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, _envelopeJs.createSpanEnvelopeItem)(spanJson));
    }
    return (0, _envelopeJs.createEnvelope)(headers, items);
}

},{"./tracing/dynamicSamplingContext.js":"1usYY","./tracing/spans/beforeSendSpan.js":"8cA2V","./utils/dsn.js":"dadDm","./utils/envelope.js":"fQsVK","./utils/should-ignore-span.js":"kOBns","./utils/spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"8cA2V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStreamedBeforeSendSpanCallback", ()=>isStreamedBeforeSendSpanCallback);
parcelHelpers.export(exports, "withStreamedSpan", ()=>withStreamedSpan);
var _objectJs = require("../../utils/object.js");
/**
 * A wrapper to use the new span format in your `beforeSendSpan` callback.
 *
 * When using `traceLifecycle: 'stream'`, wrap your callback with this function
 * to receive and return {@link StreamedSpanJSON} instead of the standard {@link SpanJSON}.
 *
 * @example
 *
 * Sentry.init({
 *   traceLifecycle: 'stream',
 *   beforeSendSpan: withStreamedSpan((span) => {
 *     // span is of type StreamedSpanJSON
 *     return span;
 *   }),
 * });
 *
 * @param callback - The callback function that receives and returns a {@link StreamedSpanJSON}.
 * @returns A callback that is compatible with the `beforeSendSpan` option when using `traceLifecycle: 'stream'`.
 */ function withStreamedSpan(callback) {
    (0, _objectJs.addNonEnumerableProperty)(callback, "_streamed", true);
    return callback;
}
/**
 * Typesafe check to identify if a `beforeSendSpan` callback expects the streamed span JSON format.
 *
 * @param callback - The `beforeSendSpan` callback to check.
 * @returns `true` if the callback was wrapped with {@link withStreamedSpan}.
 */ function isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}

},{"../../utils/object.js":"9SPt0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fQsVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addItemToEnvelope", ()=>addItemToEnvelope);
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", ()=>createAttachmentEnvelopeItem);
parcelHelpers.export(exports, "createEnvelope", ()=>createEnvelope);
parcelHelpers.export(exports, "createEventEnvelopeHeaders", ()=>createEventEnvelopeHeaders);
parcelHelpers.export(exports, "createSpanEnvelopeItem", ()=>createSpanEnvelopeItem);
parcelHelpers.export(exports, "envelopeContainsItemType", ()=>envelopeContainsItemType);
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", ()=>envelopeItemTypeToDataCategory);
parcelHelpers.export(exports, "forEachEnvelopeItem", ()=>forEachEnvelopeItem);
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", ()=>getSdkMetadataForEnvelopeHeader);
parcelHelpers.export(exports, "parseEnvelope", ()=>parseEnvelope);
parcelHelpers.export(exports, "serializeEnvelope", ()=>serializeEnvelope);
var _carrierJs = require("../carrier.js");
var _dsnJs = require("./dsn.js");
var _normalizeJs = require("./normalize.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function encodeUTF8(input) {
    const carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function decodeUTF8(input) {
    const carrier = (0, _carrierJs.getSentryCarrier)((0, _worldwideJs.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, _normalizeJs.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env) {
    let buffer = typeof env === "string" ? encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function _isOverriddenType(type) {
    return type in DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return _isOverriddenType(type) ? DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name, version } = metadataOrEvent.sdk;
    return {
        name,
        version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, _dsnJs.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

},{"../carrier.js":"kQ3LD","./dsn.js":"dadDm","./normalize.js":"bplSM","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bplSM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "normalizeToSize", ()=>normalizeToSize);
parcelHelpers.export(exports, "normalizeUrlToBase", ()=>normalizeUrlToBase);
var _isJs = require("./is.js");
var _normalizationHintsJs = require("./normalizationHints.js");
var _objectJs = require("./object.js");
var _stacktraceJs = require("./stacktrace.js");
var global = arguments[3];
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value, depth = Infinity, maxProperties = Infinity, memo = memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. Hints use internal symbols
    // (see normalizationHints.ts) so user-controlled JSON cannot spoof them.
    if ((0, _normalizationHintsJs.hasSkipNormalizationHint)(value)) return value;
    // Override remaining depth from this node (e.g. Redux / Pinia state). Set via setNormalizationDepthOverrideHint.
    const overrideDepth = (0, _normalizationHintsJs.getNormalizationDepthOverrideHint)(value);
    const remainingDepth = overrideDepth !== undefined ? overrideDepth : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, _objectJs.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== "undefined" && value === global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, _isJs.isVueViewModel)(value)) return (0, _stacktraceJs.getVueInternalName)(value);
        // React's SyntheticEvent thingy
        if ((0, _isJs.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, _stacktraceJs.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"./is.js":"jiTW9","./normalizationHints.js":"6q8iK","./object.js":"9SPt0","./stacktrace.js":"1WmJO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6q8iK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNormalizationDepthOverrideHint", ()=>getNormalizationDepthOverrideHint);
parcelHelpers.export(exports, "hasSkipNormalizationHint", ()=>hasSkipNormalizationHint);
parcelHelpers.export(exports, "setNormalizationDepthOverrideHint", ()=>setNormalizationDepthOverrideHint);
parcelHelpers.export(exports, "setSkipNormalizationHint", ()=>setSkipNormalizationHint);
var _objectJs = require("./object.js");
/**
 * Internal symbols for normalization behavior. JSON and other structured user payloads cannot
 * carry these keys, so they cannot spoof SDK-only normalization hints.
 * We use Symbol.for to ensure that the symbols are the same across different modules/files.
 */ const SENTRY_SKIP_NORMALIZATION = Symbol.for("sentry.skipNormalization");
const SENTRY_OVERRIDE_NORMALIZATION_DEPTH = Symbol.for("sentry.overrideNormalizationDepth");
/** Marks an object so `normalize` returns it unchanged (already-normalized SDK data). */ function setSkipNormalizationHint(obj) {
    (0, _objectJs.addNonEnumerableProperty)(obj, SENTRY_SKIP_NORMALIZATION, true);
}
/** Overrides remaining normalization depth from this object downward (e.g. Redux / Pinia state). */ function setNormalizationDepthOverrideHint(obj, depth) {
    (0, _objectJs.addNonEnumerableProperty)(obj, SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
/** @internal */ function hasSkipNormalizationHint(value) {
    return Boolean(value[SENTRY_SKIP_NORMALIZATION]);
}
/** @internal */ function getNormalizationDepthOverrideHint(value) {
    const v = value[SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : undefined;
}

},{"./object.js":"9SPt0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"dVfpy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logSpanEnd", ()=>logSpanEnd);
parcelHelpers.export(exports, "logSpanStart", ()=>logSpanStart);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Print a log message for a started span.
 */ function logSpanStart(span) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    const { description = "< unknown name >", op = "< unknown op >", parent_span_id: parentSpanId } = (0, _spanUtilsJs.spanToJSON)(span);
    const { spanId } = span.spanContext();
    const sampled = (0, _spanUtilsJs.spanIsSampled)(span);
    const rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op, description } = (0, _spanUtilsJs.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, _debugLoggerJs.debug).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function logSpanEnd(span) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return;
    const { description = "< unknown name >", op = "< unknown op >" } = (0, _spanUtilsJs.spanToJSON)(span);
    const { spanId } = span.spanContext();
    const rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, _debugLoggerJs.debug).log(msg);
}

},{"../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"8x3Vk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setMeasurement", ()=>setMeasurement);
parcelHelpers.export(exports, "timedEventsToMeasurements", ()=>timedEventsToMeasurements);
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function setMeasurement(name, value, unit, activeSpan = (0, _spanUtilsJs.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, _spanUtilsJs.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value,
            unit
        };
    });
    return measurements;
}

},{"../debug-build.js":"a2zY5","../semanticAttributes.js":"CCqFC","../utils/debug-logger.js":"6Sybg","../utils/spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"58R9c":[function(require,module,exports) {
/**
 * Determines if span streaming is enabled for the given client
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSpanStreamingEnabled", ()=>hasSpanStreamingEnabled);
function hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"jFgPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "continueTrace", ()=>continueTrace);
parcelHelpers.export(exports, "startInactiveSpan", ()=>startInactiveSpan);
parcelHelpers.export(exports, "startNewTrace", ()=>startNewTrace);
parcelHelpers.export(exports, "startSpan", ()=>startSpan);
parcelHelpers.export(exports, "startSpanManual", ()=>startSpanManual);
parcelHelpers.export(exports, "suppressTracing", ()=>suppressTracing);
parcelHelpers.export(exports, "withActiveSpan", ()=>withActiveSpan);
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _baggageJs = require("../utils/baggage.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _handleCallbackErrorsJs = require("../utils/handleCallbackErrors.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _shouldIgnoreSpanJs = require("../utils/should-ignore-span.js");
var _hasSpanStreamingEnabledJs = require("./spans/hasSpanStreamingEnabled.js");
var _parseSampleRateJs = require("../utils/parseSampleRate.js");
var _propagationContextJs = require("../utils/propagationContext.js");
var _randomSafeContextJs = require("../utils/randomSafeContext.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _tracingJs = require("../utils/tracing.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _logSpansJs = require("./logSpans.js");
var _samplingJs = require("./sampling.js");
var _sentryNonRecordingSpanJs = require("./sentryNonRecordingSpan.js");
var _sentrySpanJs = require("./sentrySpan.js");
var _spanstatusJs = require("./spanstatus.js");
var _utilsJs = require("./utils.js");
/* eslint-disable max-lines */ const SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startSpan(options, callback) {
    const acs = getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = parseSentrySpanArguments(options);
    const { forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, _currentScopesJs.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, _currentScopesJs.getCurrentScope)();
            const parentSpan = getParentSpan(scope, customParentSpan);
            const client = (0, _currentScopesJs.getClient)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)() : createChildOrRootSpan({
                parentSpan,
                spanArguments,
                forceTransaction,
                scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            // Ignored root spans still need to be set on scope so that `getActiveSpan()` returns them
            // and descendants are also non-recording. Ignored child spans don't need this because
            // the parent span is already on scope.
            if (!_isIgnoredSpan(activeSpan) || !parentSpan) (0, _spanOnScopeJs._setSpanForScope)(scope, activeSpan);
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status } = (0, _spanUtilsJs.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startSpanManual(options, callback) {
    const acs = getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = parseSentrySpanArguments(options);
    const { forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, _currentScopesJs.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, _currentScopesJs.getCurrentScope)();
            const parentSpan = getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)() : createChildOrRootSpan({
                parentSpan,
                spanArguments,
                forceTransaction,
                scope
            });
            if (missingRequiredParent) (0, _currentScopesJs.getClient)()?.recordDroppedEvent("no_parent_span", "span");
            // We don't set ignored child spans onto the scope because there likely is an active,
            // unignored span on the scope already.
            if (!_isIgnoredSpan(activeSpan) || !parentSpan) (0, _spanOnScopeJs._setSpanForScope)(scope, activeSpan);
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status } = (0, _spanUtilsJs.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function startInactiveSpan(options) {
    const acs = getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = parseSentrySpanArguments(options);
    const { forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, _currentScopesJs.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, _currentScopesJs.getCurrentScope)();
        const parentSpan = getParentSpan(scope, customParentSpan);
        const client = (0, _currentScopesJs.getClient)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        }
        return createChildOrRootSpan({
            parentSpan,
            spanArguments,
            forceTransaction,
            scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const continueTrace = (options, callback)=>{
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace, baggage } = options;
    const client = (0, _currentScopesJs.getClient)();
    const incomingDsc = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    if (client && !(0, _tracingJs.shouldContinueTrace)(client, incomingDsc?.org_id)) return startNewTrace(callback);
    return (0, _currentScopesJs.withScope)((scope)=>{
        const propagationContext = (0, _tracingJs.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, _spanOnScopeJs._setSpanForScope)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    const acs = getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, _currentScopesJs.withScope)((scope)=>{
        (0, _spanOnScopeJs._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function suppressTracing(callback) {
    const acs = getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, _currentScopesJs.withScope)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function startNewTrace(callback) {
    const acs = getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, _currentScopesJs.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, _propagationContextJs.generateTraceId)(),
            sampleRand: (0, _randomSafeContextJs.safeMathRandom)()
        });
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return withActiveSpan(null, callback);
    });
}
function createChildOrRootSpan({ parentSpan, spanArguments, forceTransaction, scope }) {
    if (!(0, _hasSpansEnabledJs.hasSpansEnabled)()) {
        const span = new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span)
            };
            (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    const client = (0, _currentScopesJs.getClient)();
    if (_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!_isTracingSuppressed(scope)) // if tracing is actively suppressed (Sentry.suppressTracing(...)),
        // we don't want to record a client outcome for the ignored span
        client?.recordDroppedEvent("ignored", "span");
        return new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = (0, _currentScopesJs.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = _startChildSpan(parentSpan, scope, spanArguments);
        (0, _spanUtilsJs.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, _spanUtilsJs.spanIsSampled)(parentSpan);
        span = _startRootSpan({
            traceId,
            parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId, dsc, parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = _startRootSpan({
            traceId,
            parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, _dynamicSamplingContextJs.freezeDscOnSpan)(span, dsc);
    }
    (0, _logSpansJs.logSpanStart)(span);
    (0, _utilsJs.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function getAcs() {
    const carrier = (0, _carrierJs.getMainCarrier)();
    return (0, _indexJs.getAsyncContextStrategy)(carrier);
}
function _startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, _currentScopesJs.getClient)();
    const options = client?.getOptions() || {};
    const { name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = _isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, _samplingJs.sampleSpan)(options, {
        name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, _parseSampleRateJs.parseSampleRate)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, _sentrySpanJs.SentrySpan)({
        ...spanArguments,
        attributes: {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, _hasSpanStreamingEnabledJs.hasSpanStreamingEnabled)(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function _startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId, traceId } = parentSpan.spanContext();
    const isTracingSuppressed = _isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, _spanUtilsJs.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, _sentrySpanJs.SentrySpan)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId,
        sampled
    }) : new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)({
        traceId
    });
    (0, _spanUtilsJs.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, _currentScopesJs.getClient)();
    if (!client) return childSpan;
    if ((0, _hasSpanStreamingEnabledJs.hasSpanStreamingEnabled)(client) && childSpan instanceof (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)) {
        if (parentSpan instanceof (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan) && parentSpan.dropReason) {
            // We land here if the parent span was a segment span that was ignored (`ignoreSpans`).
            // In this case, the child was also ignored (see `sampled` above) but we need to
            // record a client outcome for the child.
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            // Otherwise, the child is not sampled due to sampling of the parent span,
            // hence we record a sample_rate client outcome for the child.
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, _spanOnScopeJs._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, _currentScopesJs.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, _spanUtilsJs.getRootSpan)(span);
    return span;
}
function getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
/* Checks if `ignoreSpans` applies (extracted for bundle size)*/ function _shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, _hasSpanStreamingEnabledJs.hasSpanStreamingEnabled)(client) || !ignoreSpans?.length) return false;
    return (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function _isIgnoredSpan(span) {
    return span instanceof (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan) && span.dropReason === "ignored";
}
function _isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] === true;
}

},{"../asyncContext/index.js":"gS3DN","../carrier.js":"kQ3LD","../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../semanticAttributes.js":"CCqFC","../utils/baggage.js":"klYqA","../utils/debug-logger.js":"6Sybg","../utils/handleCallbackErrors.js":"2pTms","../utils/hasSpansEnabled.js":"ddp8b","../utils/should-ignore-span.js":"kOBns","./spans/hasSpanStreamingEnabled.js":"58R9c","../utils/parseSampleRate.js":"d6zVq","../utils/propagationContext.js":"K2Zo8","../utils/randomSafeContext.js":"fExsU","../utils/spanOnScope.js":"l06IL","../utils/spanUtils.js":"2Bh30","../utils/tracing.js":"fyjN8","./dynamicSamplingContext.js":"1usYY","./logSpans.js":"dVfpy","./sampling.js":"2ByQP","./sentryNonRecordingSpan.js":"bVjrp","./sentrySpan.js":"8Lfvo","./spanstatus.js":"cq3xe","./utils.js":"a2SOi","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2pTms":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleCallbackErrors", ()=>handleCallbackErrors);
var _chainAndCopyPromiselikeJs = require("./chain-and-copy-promiselike.js");
var _isJs = require("./is.js");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, _isJs.isThenable)(value)) return (0, _chainAndCopyPromiselikeJs.chainAndCopyPromiseLike)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}

},{"./chain-and-copy-promiselike.js":"eQV7y","./is.js":"jiTW9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2ByQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleSpan", ()=>sampleSpan);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _hasSpansEnabledJs = require("../utils/hasSpansEnabled.js");
var _parseSampleRateJs = require("../utils/parseSampleRate.js");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function sampleSpan(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, _hasSpansEnabledJs.hasSpansEnabled)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, _parseSampleRateJs.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

},{"../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/hasSpansEnabled.js":"ddp8b","../utils/parseSampleRate.js":"d6zVq","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2SWd6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyBeforeSendSpanCallback", ()=>applyBeforeSendSpanCallback);
parcelHelpers.export(exports, "captureSpan", ()=>captureSpan);
parcelHelpers.export(exports, "inferSpanDataFromOtelAttributes", ()=>inferSpanDataFromOtelAttributes);
parcelHelpers.export(exports, "safeSetSpanJSONAttributes", ()=>safeSetSpanJSONAttributes);
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _scopeDataJs = require("../../utils/scopeData.js");
var _spanUtilsJs = require("../../utils/spanUtils.js");
var _utilsJs = require("../utils.js");
var _beforeSendSpanJs = require("./beforeSendSpan.js");
/**
 * Captures a span and returns a JSON representation to be enqueued for sending.
 *
 * IMPORTANT: This function converts the span to JSON immediately to avoid writing
 * to an already-ended OTel span instance (which is blocked by the OTel Span class).
 *
 * @returns the final serialized span with a reference to its segment span. This reference
 * is needed later on to compute the DSC for the span envelope.
 */ function captureSpan(span, client) {
    // Convert to JSON FIRST - we cannot write to an already-ended span
    const spanJSON = (0, _spanUtilsJs.spanToStreamedSpanJSON)(span);
    const segmentSpan = (0, _spanUtilsJs.INTERNAL_getSegmentSpan)(span);
    const serializedSegmentSpan = (0, _spanUtilsJs.spanToStreamedSpanJSON)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, _utilsJs.getCapturedScopesOnSpan)(span);
    const finalScopeData = (0, _scopeDataJs.getCombinedScopeData)(spanIsolationScope, spanScope);
    applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    // Backfill span data from OTel semantic conventions when not explicitly set.
    // OTel-originated spans don't have sentry.op, description, etc. — the non-streamed path
    // infers these in the SentrySpanExporter, but streamed spans skip the exporter entirely.
    // Access `kind` via duck-typing — OTel span objects have this property but it's not on Sentry's Span type.
    // This must run before all hooks and beforeSendSpan so that user callbacks can see and override inferred values.
    const spanKind = span.kind;
    inferSpanDataFromOtelAttributes(spanJSON, spanKind);
    if (spanJSON.is_segment) // Allow hook subscribers to mutate the segment span JSON
    // This also invokes the `processSegmentSpan` hook of all integrations
    client.emit("processSegmentSpan", spanJSON);
    // This allows hook subscribers to mutate the span JSON
    // This also invokes the `processSpan` hook of all integrations
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, _beforeSendSpanJs.isStreamedBeforeSendSpanCallback)(beforeSendSpan) ? applyBeforeSendSpanCallback(spanJSON, beforeSendSpan) : spanJSON;
    // Backfill sentry.span.source from sentry.source. Only `sentry.span.source` is respected by Sentry.
    // TODO(v11): Remove this backfill once we renamed SEMANTIC_ATTRIBUTE_SENTRY_SOURCE to sentry.span.source
    const spanNameSource = processedSpan.attributes?.[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...(0, _spanUtilsJs.streamedSpanJsonToSerializedSpan)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release, environment, sendDefaultPii } = client.getOptions();
    // avoid overwriting any previously set attributes (from users or potentially our SDK instrumentation)
    safeSetSpanJSONAttributes(spanJSON, {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE)]: release,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT)]: environment,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME)]: serializedSegmentSpan.name,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID)]: serializedSegmentSpan.span_id,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME)]: sdk?.sdk?.name,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION)]: sdk?.sdk?.version,
        ...sendDefaultPii ? {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_ID)]: scopeData.user?.id,
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_EMAIL)]: scopeData.user?.email,
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS)]: scopeData.user?.ip_address,
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_USER_USERNAME)]: scopeData.user?.username
        } : {},
        ...scopeData.attributes
    });
}
/**
 * Apply a user-provided beforeSendSpan callback to a span JSON.
 */ function applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, _spanUtilsJs.showSpanDropWarning)();
        return span;
    }
    return modifedSpan;
}
/**
 * Safely set attributes on a span JSON.
 * If an attribute already exists, it will not be overwritten.
 */ function safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
// OTel SpanKind values (numeric to avoid importing from @opentelemetry/api)
const SPAN_KIND_SERVER = 1;
const SPAN_KIND_CLIENT = 2;
/**
 * Infer and backfill span data from OTel semantic conventions.
 * This mirrors what the `SentrySpanExporter` does for non-streamed spans via `getSpanData`/`inferSpanData`.
 * Streamed spans skip the exporter, so we do the inference here during capture.
 *
 * Backfills: `sentry.op`, `sentry.source`, and `name` (description).
 * Uses `safeSetSpanJSONAttributes` so explicitly set attributes are never overwritten.
 */ /** Exported only for tests. */ function inferSpanDataFromOtelAttributes(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes["http.request.method"] || attributes["http.method"];
    if (httpMethod) {
        inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes["db.system.name"] || attributes["db.system"];
    const opIsCache = typeof attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "string" && `${attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP]}`.startsWith("cache.");
    if (dbSystem && !opIsCache) {
        inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes["rpc.service"]) {
        safeSetSpanJSONAttributes(spanJSON, {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "rpc"
        });
        return;
    }
    if (attributes["messaging.system"]) {
        safeSetSpanJSONAttributes(spanJSON, {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "message"
        });
        return;
    }
    const faasTrigger = attributes["faas.trigger"];
    if (faasTrigger) safeSetSpanJSONAttributes(spanJSON, {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: `${faasTrigger}`
    });
}
function inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    // Infer op: http.client, http.server, or just http
    const opParts = [
        "http"
    ];
    if (spanKind === SPAN_KIND_CLIENT) opParts.push("client");
    else if (spanKind === SPAN_KIND_SERVER) opParts.push("server");
    if (attributes["sentry.http.prefetch"]) opParts.push("prefetch");
    safeSetSpanJSONAttributes(spanJSON, {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: opParts.join(".")
    });
    // If the user set a custom span name via updateSpanName(), apply it — OTel instrumentation
    // may have overwritten span.name after the user set it, so we restore from the attribute.
    const customName = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    // Only overwrite the span name when we have an explicit http.route — it's more specific than
    // what OTel instrumentation sets as the span name. For all other cases (url.full, http.target),
    // the OTel-set name is already good enough and we'd risk producing a worse name (e.g. full URL).
    const httpRoute = attributes["http.route"];
    if (typeof httpRoute === "string") {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        safeSetSpanJSONAttributes(spanJSON, {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "route"
        });
    } else // Fallback: set source to 'url' for HTTP spans without a route.
    // The spec requires sentry.span.source on segment spans, and the non-streamed exporter
    // always sets this — so we need to ensure it's present for streamed spans too.
    safeSetSpanJSONAttributes(spanJSON, {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
    });
}
function inferDbSpanData(spanJSON, attributes) {
    safeSetSpanJSONAttributes(spanJSON, {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "db"
    });
    // If the user set a custom span name via updateSpanName(), apply it.
    const customName = attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const statement = attributes["db.statement"];
    if (statement) {
        spanJSON.name = `${statement}`;
        safeSetSpanJSONAttributes(spanJSON, {
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "task"
        });
    }
}

},{"../../semanticAttributes.js":"CCqFC","../../utils/scopeData.js":"9UXFa","../../utils/spanUtils.js":"2Bh30","../utils.js":"a2SOi","./beforeSendSpan.js":"8cA2V","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9UXFa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyScopeDataToEvent", ()=>applyScopeDataToEvent);
parcelHelpers.export(exports, "getCombinedScopeData", ()=>getCombinedScopeData);
parcelHelpers.export(exports, "mergeAndOverwriteScopeData", ()=>mergeAndOverwriteScopeData);
parcelHelpers.export(exports, "mergeScopeData", ()=>mergeScopeData);
var _currentScopesJs = require("../currentScopes.js");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _mergeJs = require("./merge.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) applySpanToEvent(event, span);
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    const { extra, tags, attributes, user, contexts, level, sdkProcessingMetadata, breadcrumbs, fingerprint, eventProcessors, attachments, propagationContext, transactionName, span } = mergeData;
    mergeAndOverwriteScopeData(data, "extra", extra);
    mergeAndOverwriteScopeData(data, "tags", tags);
    mergeAndOverwriteScopeData(data, "attributes", attributes);
    mergeAndOverwriteScopeData(data, "user", user);
    mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, _mergeJs.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = (0, _mergeJs.merge)(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = (0, _currentScopesJs.getGlobalScope)().getScopeData();
    isolationScope && mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function applyDataToEvent(event, data) {
    const { extra, tags, user, contexts, level, transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, _spanUtilsJs.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, _spanUtilsJs.getRootSpan)(span);
    const transactionName = (0, _spanUtilsJs.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

},{"../currentScopes.js":"5f8H7","../tracing/dynamicSamplingContext.js":"1usYY","./merge.js":"4G0g1","./spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9zd3A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addEventProcessor", ()=>addEventProcessor);
parcelHelpers.export(exports, "captureCheckIn", ()=>captureCheckIn);
parcelHelpers.export(exports, "captureEvent", ()=>captureEvent);
parcelHelpers.export(exports, "captureException", ()=>captureException);
parcelHelpers.export(exports, "captureMessage", ()=>captureMessage);
parcelHelpers.export(exports, "captureSession", ()=>captureSession);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "endSession", ()=>endSession);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "isEnabled", ()=>isEnabled);
parcelHelpers.export(exports, "isInitialized", ()=>isInitialized);
parcelHelpers.export(exports, "lastEventId", ()=>lastEventId);
parcelHelpers.export(exports, "setContext", ()=>setContext);
parcelHelpers.export(exports, "setConversationId", ()=>setConversationId);
parcelHelpers.export(exports, "setExtra", ()=>setExtra);
parcelHelpers.export(exports, "setExtras", ()=>setExtras);
parcelHelpers.export(exports, "setTag", ()=>setTag);
parcelHelpers.export(exports, "setTags", ()=>setTags);
parcelHelpers.export(exports, "setUser", ()=>setUser);
parcelHelpers.export(exports, "startSession", ()=>startSession);
parcelHelpers.export(exports, "withMonitor", ()=>withMonitor);
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _sessionJs = require("./session.js");
var _traceJs = require("./tracing/trace.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _miscJs = require("./utils/misc.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _scopeDataJs = require("./utils/scopeData.js");
var _timeJs = require("./utils/time.js");
var _worldwideJs = require("./utils/worldwide.js");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(exception, hint) {
    return (0, _currentScopesJs.getCurrentScope)().captureException(exception, (0, _prepareEventJs.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const hint = typeof captureContext !== "string" ? {
        captureContext
    } : undefined;
    return (0, _currentScopesJs.getCurrentScope)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    return (0, _currentScopesJs.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function setContext(name, context) {
    (0, _currentScopesJs.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function setExtras(extras) {
    (0, _currentScopesJs.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function setExtra(key, extra) {
    (0, _currentScopesJs.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function setTags(tags) {
    (0, _currentScopesJs.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function setTag(key, value) {
    (0, _currentScopesJs.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function setUser(user) {
    (0, _currentScopesJs.getIsolationScope)().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function setConversationId(conversationId) {
    (0, _currentScopesJs.getIsolationScope)().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function lastEventId() {
    return (0, _currentScopesJs.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = (0, _currentScopesJs.getCurrentScope)();
    const client = (0, _currentScopesJs.getClient)();
    if (!client) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, _miscJs.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = captureCheckIn({
            monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = (0, _timeJs.timestampInSeconds)();
        function finishCheckIn(status) {
            captureCheckIn({
                monitorSlug,
                status,
                checkInId,
                duration: (0, _timeJs.timestampInSeconds)() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, _isJs.isThenable)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return (0, _currentScopesJs.withIsolationScope)(()=>upsertMonitorConfig?.isolateTrace ? (0, _traceJs.startNewTrace)(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function flush(timeout) {
    const client = (0, _currentScopesJs.getClient)();
    if (client) return client.flush(timeout);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function close(timeout) {
    const client = (0, _currentScopesJs.getClient)();
    if (client) return client.close(timeout);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!(0, _currentScopesJs.getClient)();
}
/** If the SDK is initialized & enabled. */ function isEnabled() {
    const client = (0, _currentScopesJs.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function addEventProcessor(callback) {
    (0, _currentScopesJs.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    const isolationScope = (0, _currentScopesJs.getIsolationScope)();
    const { user } = (0, _scopeDataJs.getCombinedScopeData)(isolationScope, (0, _currentScopesJs.getCurrentScope)());
    // Will fetch userAgent if called from browser sdk
    const { userAgent } = (0, _worldwideJs.GLOBAL_OBJ).navigator || {};
    const session = (0, _sessionJs.makeSession)({
        user,
        ...userAgent && {
            userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, _sessionJs.updateSession)(currentSession, {
        status: "exited"
    });
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    const isolationScope = (0, _currentScopesJs.getIsolationScope)();
    const currentScope = (0, _currentScopesJs.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, _sessionJs.closeSession)(session);
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    const isolationScope = (0, _currentScopesJs.getIsolationScope)();
    const client = (0, _currentScopesJs.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}

},{"./currentScopes.js":"5f8H7","./debug-build.js":"a2zY5","./session.js":"yGpuM","./tracing/trace.js":"jFgPq","./utils/debug-logger.js":"6Sybg","./utils/is.js":"jiTW9","./utils/misc.js":"21lxb","./utils/prepareEvent.js":"iluNN","./utils/scopeData.js":"9UXFa","./utils/time.js":"lCk2j","./utils/worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"iluNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyClientOptions", ()=>applyClientOptions);
parcelHelpers.export(exports, "applyDebugIds", ()=>applyDebugIds);
parcelHelpers.export(exports, "applyDebugMeta", ()=>applyDebugMeta);
parcelHelpers.export(exports, "parseEventHintOrCaptureContext", ()=>parseEventHintOrCaptureContext);
parcelHelpers.export(exports, "prepareEvent", ()=>prepareEvent);
var _constantsJs = require("../constants.js");
var _eventProcessorsJs = require("../eventProcessors.js");
var _scopeJs = require("../scope.js");
var _debugIdsJs = require("./debug-ids.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _scopeDataJs = require("./scopeData.js");
var _stringJs = require("./string.js");
var _syncpromiseJs = require("./syncpromise.js");
var _timeJs = require("./time.js");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, _miscJs.uuid4)(),
        timestamp: event.timestamp || (0, _timeJs.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, _miscJs.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, _scopeDataJs.getCombinedScopeData)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, _scopeDataJs.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, _syncpromiseJs.resolvedSyncPromise)(prepared) : (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    const { environment, release, dist, maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, _constantsJs.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, _stringJs.truncate)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = (0, _stringJs.truncate)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, _debugIdsJs.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, _normalizeJs.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, _normalizeJs.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, _normalizeJs.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, _normalizeJs.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, _normalizeJs.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, _normalizeJs.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, _normalizeJs.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, _scopeJs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if (hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return hint instanceof (0, _scopeJs.Scope) || typeof hint === "function";
}
const captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>captureContextKeys.includes(key));
}

},{"../constants.js":"chV8V","../eventProcessors.js":"9b39f","../scope.js":"dAMNc","./debug-ids.js":"lWwdc","./misc.js":"21lxb","./normalize.js":"bplSM","./scopeData.js":"9UXFa","./string.js":"ankyT","./syncpromise.js":"h255F","./time.js":"lCk2j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9b39f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifyEventProcessors", ()=>notifyEventProcessors);
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _isJs = require("./utils/is.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = _notifyEventProcessors(event, hint, processors, index);
        return (0, _isJs.isThenable)(result) ? result : (0, _syncpromiseJs.resolvedSyncPromise)(result);
    } catch (error) {
        return (0, _syncpromiseJs.rejectedSyncPromise)(error);
    }
}
function _notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, _debugBuildJs.DEBUG_BUILD) && result === null && (0, _debugLoggerJs.debug).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, _isJs.isThenable)(result)) return result.then((final)=>_notifyEventProcessors(final, hint, processors, index + 1));
    return _notifyEventProcessors(result, hint, processors, index + 1);
}

},{"./debug-build.js":"a2zY5","./utils/debug-logger.js":"6Sybg","./utils/is.js":"jiTW9","./utils/syncpromise.js":"h255F","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"h255F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncPromise", ()=>SyncPromise);
parcelHelpers.export(exports, "rejectedSyncPromise", ()=>rejectedSyncPromise);
parcelHelpers.export(exports, "resolvedSyncPromise", ()=>resolvedSyncPromise);
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const STATE_PENDING = 0;
const STATE_RESOLVED = 1;
const STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class SyncPromise {
    constructor(executor){
        this._state = STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === STATE_RESOLVED) handler[1](this._value);
            if (this._state === STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== STATE_PENDING) return;
            if ((0, _isJs.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult(STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult(STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

},{"./is.js":"jiTW9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"lWwdc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDebugImagesForResources", ()=>getDebugImagesForResources);
parcelHelpers.export(exports, "getFilenameToDebugIdMap", ()=>getFilenameToDebugIdMap);
var _stacktraceJs = require("./stacktrace.js");
var _worldwideJs = require("./worldwide.js");
let parsedStackResults;
let lastSentryKeysCount;
let lastNativeKeysCount;
let cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = (0, _worldwideJs.GLOBAL_OBJ)._sentryDebugIds;
    const nativeDebugIdMap = (0, _worldwideJs.GLOBAL_OBJ)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if (cachedFilenameDebugIds && sentryDebugIdKeys.length === lastSentryKeysCount && nativeDebugIdKeys.length === lastNativeKeysCount) return cachedFilenameDebugIds;
    lastSentryKeysCount = sentryDebugIdKeys.length;
    lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    cachedFilenameDebugIds = {};
    if (!parsedStackResults) parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = parsedStackResults?.[key];
            if (result && cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if (parsedStackResults) parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && cachedFilenameDebugIds && parsedStackResults) {
                        cachedFilenameDebugIds[filename] = debugId;
                        parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, _stacktraceJs.normalizeStackTracePath)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}

},{"./stacktrace.js":"1WmJO","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"f5OYB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENTRY_API_VERSION", ()=>SENTRY_API_VERSION);
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>getEnvelopeEndpointWithUrlEncodedAuth);
parcelHelpers.export(exports, "getReportDialogEndpoint", ()=>getReportDialogEndpoint);
var _dsnJs = require("./utils/dsn.js");
const SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn) {
    return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn = (0, _dsnJs.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, _dsnJs.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

},{"./utils/dsn.js":"dadDm","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"d2Ee4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _apiJs = require("./api.js");
var _constantsJs = require("./constants.js");
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _envelopeJs = require("./envelope.js");
var _integrationJs = require("./integration.js");
var _internalJs = require("./logs/internal.js");
var _internalJs1 = require("./metrics/internal.js");
var _sessionJs = require("./session.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _beforeSendSpanJs = require("./tracing/spans/beforeSendSpan.js");
var _baseJs = require("./transports/base.js");
var _clientreportJs = require("./utils/clientreport.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _dsnJs = require("./utils/dsn.js");
var _envelopeJs1 = require("./utils/envelope.js");
var _eventUtilsJs = require("./utils/eventUtils.js");
var _isJs = require("./utils/is.js");
var _mergeJs = require("./utils/merge.js");
var _miscJs = require("./utils/misc.js");
var _parseSampleRateJs = require("./utils/parseSampleRate.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _promisebufferJs = require("./utils/promisebuffer.js");
var _randomSafeContextJs = require("./utils/randomSafeContext.js");
var _shouldIgnoreSpanJs = require("./utils/should-ignore-span.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _syncpromiseJs = require("./utils/syncpromise.js");
var _timerJs = require("./utils/timer.js");
var _transactionEventJs = require("./utils/transactionEvent.js");
/* eslint-disable max-lines */ const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const INTERNAL_ERROR_SYMBOL = Symbol.for("SentryInternalError");
const DO_NOT_SEND_EVENT_SYMBOL = Symbol.for("SentryDoNotSendEventError");
// Default interval for flushing logs and metrics (5 seconds)
const DEFAULT_FLUSH_INTERVAL = 5000;
function _makeInternalError(message) {
    return {
        message,
        [INTERNAL_ERROR_SYMBOL]: true
    };
}
function _makeDoNotSendEventError(message) {
    return {
        message,
        [DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function _isInternalError(error) {
    return !!error && typeof error === "object" && INTERNAL_ERROR_SYMBOL in error;
}
function _isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = (0, _timerJs.safeUnref)(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class Client {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, _promisebufferJs.makePromiseBuffer)(options.transportOptions?.bufferSize ?? (0, _baseJs.DEFAULT_TRANSPORT_BUFFER_SIZE));
        if (options.dsn) this._dsn = (0, _dsnJs.makeDsn)(options.dsn);
        else (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", estimateLogSizeInBytes, (0, _internalJs._INTERNAL_flushLogsBuffer));
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", estimateMetricSizeInBytes, (0, _internalJs1._INTERNAL_flushMetricsBuffer));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, _miscJs.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, _miscJs.checkOrSetAlreadyCaught)(exception)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, _miscJs.uuid4)(),
            ...hint
        };
        const eventMessage = (0, _isJs.isParameterizedString)(message) ? message : String(message);
        const isMessage = (0, _isJs.isPrimitive)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, _miscJs.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, _miscJs.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, _sessionJs.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit("flush");
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        (0, _internalJs._INTERNAL_flushLogsBuffer)(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        // This hook takes care of only installing if not already installed
        (0, _integrationJs.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, _integrationJs.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, _envelopeJs.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, _envelopeJs1.addItemToEnvelope)(env, (0, _envelopeJs1.createAttachmentEnvelopeItem)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, _constantsJs.DEFAULT_ENVIRONMENT) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, _envelopeJs.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Error while sending envelope:", reason);
            return {};
        }
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {
    // No-op in base class - subclasses override to implement cleanup registration
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations } = this._options;
        this._integrations = (0, _integrationJs.setupIntegrations)(this, integrations);
        (0, _integrationJs.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, _sessionJs.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, _prepareEventJs.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, _currentScopesJs.getTraceContextFromScope)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, _currentScopesJs.getCurrentScope)(), isolationScope = (0, _currentScopesJs.getIsolationScope)()) {
        if ((0, _debugBuildJs.DEBUG_BUILD) && isErrorEvent(event)) (0, _debugLoggerJs.debug).log(`Captured error event \`${(0, _eventUtilsJs.getPossibleEventMessages)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, _debugBuildJs.DEBUG_BUILD) {
                if (_isDoNotSendEventError(reason)) (0, _debugLoggerJs.debug).log(reason.message);
                else if (_isInternalError(reason)) (0, _debugLoggerJs.debug).warn(reason.message);
                else (0, _debugLoggerJs.debug).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate } = options;
        const isTransaction = isTransactionEvent(event);
        const isError = isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, _parseSampleRateJs.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && (0, _randomSafeContextJs.safeMathRandom)() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, _syncpromiseJs.rejectedSyncPromise)(_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw _makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = processBeforeSend(this, options, prepared, hint);
            return _validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw _makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (_isDoNotSendEventError(reason) || _isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw _makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR)) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason,
                category,
                quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("Sending outcomes:", outcomes);
        const envelope = (0, _clientreportJs.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, _dsnJs.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, _isJs.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, _isJs.isPlainObject)(event) && event !== null) throw _makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw _makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, _isJs.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw _makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function processBeforeSend(client, options, event, hint) {
    const { beforeSend, beforeSendTransaction, ignoreSpans } = options;
    const beforeSendSpan = !(0, _beforeSendSpanJs.isStreamedBeforeSendSpanCallback)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if (isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if (isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, _transactionEventJs.convertTransactionEventToSpanJson)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, _spanUtilsJs.showSpanDropWarning)();
                else // update event with processed root span values
                processedEvent = (0, _mergeJs.merge)(event, (0, _transactionEventJs.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, _shouldIgnoreSpanJs.shouldIgnoreSpan)({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        (0, _shouldIgnoreSpanJs.reparentChildSpans)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, _spanUtilsJs.showSpanDropWarning)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function isErrorEvent(event) {
    return event.type === undefined;
}
function isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, _isJs.isPrimitive)(value)) weight += estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}

},{"./api.js":"f5OYB","./constants.js":"chV8V","./currentScopes.js":"5f8H7","./debug-build.js":"a2zY5","./envelope.js":"lC95z","./integration.js":"b7ak3","./logs/internal.js":"bO2sr","./metrics/internal.js":"htABD","./session.js":"yGpuM","./tracing/dynamicSamplingContext.js":"1usYY","./tracing/spans/beforeSendSpan.js":"8cA2V","./transports/base.js":"hLCdF","./utils/clientreport.js":"5Bnv5","./utils/debug-logger.js":"6Sybg","./utils/dsn.js":"dadDm","./utils/envelope.js":"fQsVK","./utils/eventUtils.js":"1n3it","./utils/is.js":"jiTW9","./utils/merge.js":"4G0g1","./utils/misc.js":"21lxb","./utils/parseSampleRate.js":"d6zVq","./utils/prepareEvent.js":"iluNN","./utils/promisebuffer.js":"a1A80","./utils/randomSafeContext.js":"fExsU","./utils/should-ignore-span.js":"kOBns","./utils/spanUtils.js":"2Bh30","./utils/syncpromise.js":"h255F","./utils/timer.js":"9j54j","./utils/transactionEvent.js":"gs7j2","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"b7ak3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addIntegration", ()=>addIntegration);
parcelHelpers.export(exports, "afterSetupIntegrations", ()=>afterSetupIntegrations);
parcelHelpers.export(exports, "defineIntegration", ()=>defineIntegration);
parcelHelpers.export(exports, "getIntegrationsToSetup", ()=>getIntegrationsToSetup);
parcelHelpers.export(exports, "installedIntegrations", ()=>installedIntegrations);
parcelHelpers.export(exports, "setupIntegration", ()=>setupIntegration);
parcelHelpers.export(exports, "setupIntegrations", ()=>setupIntegrations);
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
const installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") // The cast is needed because TS can't resolve overloads when the discriminant is a union type.
        // Both overloads have the same callback signature so this is safe.
        client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function addIntegration(integration) {
    const client = (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function defineIntegration(fn) {
    return fn;
}

},{"./currentScopes.js":"5f8H7","./debug-build.js":"a2zY5","./utils/debug-logger.js":"6Sybg","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bO2sr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_captureLog", ()=>_INTERNAL_captureLog);
parcelHelpers.export(exports, "_INTERNAL_captureSerializedLog", ()=>_INTERNAL_captureSerializedLog);
parcelHelpers.export(exports, "_INTERNAL_flushLogsBuffer", ()=>_INTERNAL_flushLogsBuffer);
parcelHelpers.export(exports, "_INTERNAL_getLogBuffer", ()=>_INTERNAL_getLogBuffer);
var _attributesJs = require("../attributes.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _isJs = require("../utils/is.js");
var _scopeDataJs = require("../utils/scopeData.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _timeJs = require("../utils/time.js");
var _timestampSequenceJs = require("../utils/timestampSequence.js");
var _traceInfoJs = require("../utils/trace-info.js");
var _constantsJs = require("./constants.js");
var _envelopeJs = require("./envelope.js");
const MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = _getBufferMap();
    const logBuffer = _INTERNAL_getLogBuffer(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= MAX_LOG_BUFFER_SIZE) {
        _INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureLog(beforeLog, currentScope = (0, _currentScopesJs.getCurrentScope)(), captureSerializedLog = _INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No client available to capture log.");
        return;
    }
    const { release, environment, enableLogs = false, beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, _traceInfoJs._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id, email, username }, attributes: scopeAttributes = {} } = (0, _scopeDataJs.getCombinedScopeData)((0, _currentScopesJs.getIsolationScope)(), currentScope);
    setLogAttribute(processedLogAttributes, "user.id", id, false);
    setLogAttribute(processedLogAttributes, "user.email", email, false);
    setLogAttribute(processedLogAttributes, "user.name", username, false);
    setLogAttribute(processedLogAttributes, "sentry.release", release);
    setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name, version } = client.getSdkMetadata()?.sdk ?? {};
    setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ((0, _isJs.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__, __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, _spanOnScopeJs._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, _debugLoggerJs.consoleSandbox)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level, message, attributes: logAttributes = {}, severityNumber } = log;
    const timestamp = (0, _timeJs.timestampInSeconds)();
    const sequenceAttr = (0, _timestampSequenceJs.getSequenceAttribute)(timestamp);
    const serializedLog = {
        timestamp,
        level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, _constantsJs.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: {
            ...(0, _attributesJs.serializeAttributes)(scopeAttributes),
            ...(0, _attributesJs.serializeAttributes)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? _INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, _envelopeJs.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    _getBufferMap().set(client, []);
    client.emit("flushLogs");
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function _INTERNAL_getLogBuffer(client) {
    return _getBufferMap().get(client);
}
function _getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, _carrierJs.getGlobalSingleton)("clientToLogBufferMap", ()=>new WeakMap());
}

},{"../attributes.js":"gGkrY","../carrier.js":"kQ3LD","../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/is.js":"jiTW9","../utils/scopeData.js":"9UXFa","../utils/spanOnScope.js":"l06IL","../utils/time.js":"lCk2j","../utils/timestampSequence.js":"1LDMO","../utils/trace-info.js":"g58Wg","./constants.js":"i2RGL","./envelope.js":"2qs5A","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1LDMO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSequenceAttribute", ()=>getSequenceAttribute);
const SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let _sequenceNumber = 0;
let _previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if (_previousTimestampMs !== undefined && nowMs !== _previousTimestampMs) _sequenceNumber = 0;
    const value = _sequenceNumber;
    _sequenceNumber++;
    _previousTimestampMs = nowMs;
    return {
        key: SEQUENCE_ATTR_KEY,
        value: {
            value,
            type: "integer"
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"g58Wg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_getTraceInfoFromScope", ()=>_getTraceInfoFromScope);
var _currentScopesJs = require("../currentScopes.js");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _spanUtilsJs = require("./spanUtils.js");
/** Extract trace information from scope */ function _getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, _currentScopesJs.withScope)(scope, ()=>{
        const span = (0, _spanUtilsJs.getActiveSpan)();
        const traceContext = span ? (0, _spanUtilsJs.spanToTraceContext)(span) : (0, _currentScopesJs.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span) : (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

},{"../currentScopes.js":"5f8H7","../tracing/dynamicSamplingContext.js":"1usYY","./spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"i2RGL":[function(require,module,exports) {
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", ()=>SEVERITY_TEXT_TO_SEVERITY_NUMBER);
const SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2qs5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogContainerEnvelopeItem", ()=>createLogContainerEnvelopeItem);
parcelHelpers.export(exports, "createLogEnvelope", ()=>createLogEnvelope);
var _dsnJs = require("../utils/dsn.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function createLogContainerEnvelopeItem(items) {
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function createLogEnvelope(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _dsnJs.dsnToString)(dsn);
    return (0, _envelopeJs.createEnvelope)(headers, [
        createLogContainerEnvelopeItem(logs)
    ]);
}

},{"../utils/dsn.js":"dadDm","../utils/envelope.js":"fQsVK","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"htABD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_captureMetric", ()=>_INTERNAL_captureMetric);
parcelHelpers.export(exports, "_INTERNAL_captureSerializedMetric", ()=>_INTERNAL_captureSerializedMetric);
parcelHelpers.export(exports, "_INTERNAL_flushMetricsBuffer", ()=>_INTERNAL_flushMetricsBuffer);
parcelHelpers.export(exports, "_INTERNAL_getMetricBuffer", ()=>_INTERNAL_getMetricBuffer);
var _attributesJs = require("../attributes.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _scopeDataJs = require("../utils/scopeData.js");
var _spanOnScopeJs = require("../utils/spanOnScope.js");
var _timeJs = require("../utils/time.js");
var _timestampSequenceJs = require("../utils/timestampSequence.js");
var _traceInfoJs = require("../utils/trace-info.js");
var _envelopeJs = require("./envelope.js");
const MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = _getBufferMap();
    const metricBuffer = _INTERNAL_getMetricBuffer(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= MAX_METRIC_BUFFER_SIZE) {
        _INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function _enrichMetricAttributes(beforeMetric, client, user) {
    const { release, environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    // Add Sentry metadata
    setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    // Add SDK metadata
    const { name, version } = client.getSdkMetadata()?.sdk ?? {};
    setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    // Add replay metadata
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function _buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = (0, _traceInfoJs._getTraceInfoFromScope)(client, currentScope);
    const span = (0, _spanOnScopeJs._getSpanForScope)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = (0, _timeJs.timestampInSeconds)();
    const sequenceAttr = (0, _timestampSequenceJs.getSequenceAttribute)(timestamp);
    return {
        timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, _attributesJs.serializeAttributes)(scopeAttributes),
            ...(0, _attributesJs.serializeAttributes)(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, _currentScopesJs.getCurrentScope)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? _INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? (0, _currentScopesJs.getClient)();
    if (!client) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No client available to capture metric.");
        return;
    }
    const { _experiments, enableMetrics, beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    // Enrich metric with contextual attributes
    const { user, attributes: scopeAttributes } = (0, _scopeDataJs.getCombinedScopeData)((0, _currentScopesJs.getIsolationScope)(), currentScope);
    const enrichedMetric = _enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = _buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function _INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? _INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, _envelopeJs.createMetricEnvelope)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    _getBufferMap().set(client, []);
    client.emit("flushMetrics");
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function _INTERNAL_getMetricBuffer(client) {
    return _getBufferMap().get(client);
}
function _getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, _carrierJs.getGlobalSingleton)("clientToMetricBufferMap", ()=>new WeakMap());
}

},{"../attributes.js":"gGkrY","../carrier.js":"kQ3LD","../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/scopeData.js":"9UXFa","../utils/spanOnScope.js":"l06IL","../utils/time.js":"lCk2j","../utils/timestampSequence.js":"1LDMO","../utils/trace-info.js":"g58Wg","./envelope.js":"2kv50","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2kv50":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMetricContainerEnvelopeItem", ()=>createMetricContainerEnvelopeItem);
parcelHelpers.export(exports, "createMetricEnvelope", ()=>createMetricEnvelope);
var _dsnJs = require("../utils/dsn.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function createMetricContainerEnvelopeItem(items) {
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function createMetricEnvelope(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _dsnJs.dsnToString)(dsn);
    return (0, _envelopeJs.createEnvelope)(headers, [
        createMetricContainerEnvelopeItem(metrics)
    ]);
}

},{"../utils/dsn.js":"dadDm","../utils/envelope.js":"fQsVK","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"hLCdF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TRANSPORT_BUFFER_SIZE", ()=>DEFAULT_TRANSPORT_BUFFER_SIZE);
parcelHelpers.export(exports, "createTransport", ()=>createTransport);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _envelopeJs = require("../utils/envelope.js");
var _promisebufferJs = require("../utils/promisebuffer.js");
var _ratelimitJs = require("../utils/ratelimit.js");
const DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function createTransport(options, makeRequest, buffer = (0, _promisebufferJs.makePromiseBuffer)(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, _envelopeJs.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, _envelopeJs.envelopeItemTypeToDataCategory)(type);
            if ((0, _ratelimitJs.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, _envelopeJs.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ((0, _envelopeJs.envelopeContainsItemType)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, _envelopeJs.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, _envelopeJs.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, _envelopeJs.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ((0, _debugBuildJs.DEBUG_BUILD) && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, _debugLoggerJs.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, _ratelimitJs.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, _promisebufferJs.SENTRY_BUFFER_FULL_ERROR)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send,
        flush
    };
}

},{"../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/envelope.js":"fQsVK","../utils/promisebuffer.js":"a1A80","../utils/ratelimit.js":"cW23y","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"a1A80":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENTRY_BUFFER_FULL_ERROR", ()=>SENTRY_BUFFER_FULL_ERROR);
parcelHelpers.export(exports, "makePromiseBuffer", ()=>makePromiseBuffer);
var _syncpromiseJs = require("./syncpromise.js");
var _timerJs = require("./timer.js");
const SENTRY_BUFFER_FULL_ERROR = Symbol.for("SentryBufferFullError");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function makePromiseBuffer(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, _syncpromiseJs.rejectedSyncPromise)(SENTRY_BUFFER_FULL_ERROR);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, _syncpromiseJs.resolvedSyncPromise)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, _timerJs.safeUnref)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add,
        drain
    };
}

},{"./syncpromise.js":"h255F","./timer.js":"9j54j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9j54j":[function(require,module,exports) {
/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeUnref", ()=>safeUnref);
function safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"cW23y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", ()=>DEFAULT_RETRY_AFTER);
parcelHelpers.export(exports, "disabledUntil", ()=>disabledUntil);
parcelHelpers.export(exports, "isRateLimited", ()=>isRateLimited);
parcelHelpers.export(exports, "parseRetryAfterHeader", ()=>parseRetryAfterHeader);
parcelHelpers.export(exports, "updateRateLimits", ()=>updateRateLimits);
var _randomSafeContextJs = require("./randomSafeContext.js");
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header, now = (0, _randomSafeContextJs.safeDateNow)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory, now = (0, _randomSafeContextJs.safeDateNow)()) {
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, { statusCode, headers }, now = (0, _randomSafeContextJs.safeDateNow)()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

},{"./randomSafeContext.js":"fExsU","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"5Bnv5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createClientReportEnvelope", ()=>createClientReportEnvelope);
var _envelopeJs = require("./envelope.js");
var _timeJs = require("./time.js");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, _timeJs.dateTimestampInSeconds)(),
            discarded_events
        }
    ];
    return (0, _envelopeJs.createEnvelope)(dsn ? {
        dsn
    } : {}, [
        clientReportItem
    ]);
}

},{"./envelope.js":"fQsVK","./time.js":"lCk2j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1n3it":[function(require,module,exports) {
/**
 * Get a list of possible event messages from a Sentry event.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPossibleEventMessages", ()=>getPossibleEventMessages);
function getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"gs7j2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertSpanJsonToTransactionEvent", ()=>convertSpanJsonToTransactionEvent);
parcelHelpers.export(exports, "convertTransactionEventToSpanJson", ()=>convertTransactionEventToSpanJson);
var _semanticAttributesJs = require("../semanticAttributes.js");
/**
 * Converts a transaction event to a span JSON object.
 */ function convertTransactionEventToSpanJson(event) {
    const { trace_id, parent_span_id, span_id, status, origin, data, op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op,
        parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin,
        profile_id: data?.[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

},{"../semanticAttributes.js":"CCqFC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2GuLR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAndBind", ()=>initAndBind);
parcelHelpers.export(exports, "setCurrentClient", ()=>setCurrentClient);
var _currentScopesJs = require("./currentScopes.js");
var _debugBuildJs = require("./debug-build.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _debugLoggerJs.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, _debugLoggerJs.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, _currentScopesJs.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    setCurrentClient(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function setCurrentClient(client) {
    (0, _currentScopesJs.getCurrentScope)().setClient(client);
}

},{"./currentScopes.js":"5f8H7","./debug-build.js":"a2zY5","./utils/debug-logger.js":"6Sybg","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"k4bjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIN_DELAY", ()=>MIN_DELAY);
parcelHelpers.export(exports, "START_DELAY", ()=>START_DELAY);
parcelHelpers.export(exports, "makeOfflineTransport", ()=>makeOfflineTransport);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _envelopeJs = require("../utils/envelope.js");
var _ratelimitJs = require("../utils/ratelimit.js");
var _timerJs = require("../utils/timer.js");
const MIN_DELAY = 100; // 100 ms
const START_DELAY = 5000; // 5 seconds
const MAX_DELAY = 3.6e6; // 1 hour
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function makeOfflineTransport(createTransport) {
    function log(...args) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, _envelopeJs.envelopeContainsItemType)(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            flushTimer = (0, _timerJs.safeUnref)(setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    // We should to update the sent_at timestamp to the current time.
                    found[0].sent_at = new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
        }
        async function send(envelope, isRetry = false) {
            // We queue all replay envelopes to avoid multiple replay envelopes being sent at the same time. If one fails, we
            // need to retry them in order.
            if (!isRetry && (0, _envelopeJs.envelopeContainsItemType)(envelope, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope);
                flushIn(MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope);
                let delay = MIN_DELAY;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers?.["retry-after"]) delay = (0, _ratelimitJs.parseRetryAfterHeader)(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 60000; // 60 seconds
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope, e, retryDelay)) {
                    // If this envelope was a retry, we want to add it to the front of the queue so it's retried again first.
                    if (isRetry) await store.unshift(envelope);
                    else await store.push(envelope);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send,
            flush: (timeout)=>{
                // If there's no timeout, we should attempt to flush the offline queue.
                if (timeout === undefined) {
                    retryDelay = START_DELAY;
                    flushIn(MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}

},{"../debug-build.js":"a2zY5","../utils/debug-logger.js":"6Sybg","../utils/envelope.js":"fQsVK","../utils/ratelimit.js":"cW23y","../utils/timer.js":"9j54j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fFmDB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MULTIPLEXED_TRANSPORT_EXTRA_KEY", ()=>MULTIPLEXED_TRANSPORT_EXTRA_KEY);
parcelHelpers.export(exports, "eventFromEnvelope", ()=>eventFromEnvelope);
parcelHelpers.export(exports, "makeMultiplexedTransport", ()=>makeMultiplexedTransport);
var _apiJs = require("../api.js");
var _dsnJs = require("../utils/dsn.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Key used in event.extra to provide routing information for the multiplexed transport.
 * Should contain an array of `{ dsn: string, release?: string }` objects.
 */ const MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function eventFromEnvelope(env, types) {
    let event;
    (0, _envelopeJs.forEachEnvelopeItem)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function overrideDsn(envelope, dsn) {
    return (0, _envelopeJs.createEnvelope)(dsn ? {
        ...envelope[0],
        dsn
    } : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 *
 * If no matcher is provided, the transport will look for routing information in
 * `event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY]`, which should contain
 * an array of `{ dsn: string, release?: string }` objects.
 */ function makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        // Use provided matcher or default to simple multiplexed transport behavior
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = (0, _dsnJs.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn, options.tunnel);
                transport = release ? makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url
                }) : createTransport({
                    ...options,
                    url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope,
                getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            // Don't override the DSN in the header for the fallback transport. '' is falsy
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send(overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send,
            flush
        };
    };
}

},{"../api.js":"f5OYB","../utils/dsn.js":"dadDm","../utils/envelope.js":"fQsVK","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"ayFtx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSentryRequestUrl", ()=>isSentryRequestUrl);
var _urlJs = require("./url.js");
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    const urlParts = (0, _urlJs.parseStringToURLObject)(url);
    if (!urlParts || (0, _urlJs.isURLObjectRelative)(urlParts)) return false;
    if (!dsn) return false;
    return hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}

},{"./url.js":"3T1sD","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"3T1sD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHttpSpanDetailsFromUrlObject", ()=>getHttpSpanDetailsFromUrlObject);
parcelHelpers.export(exports, "getSanitizedUrlString", ()=>getSanitizedUrlString);
parcelHelpers.export(exports, "getSanitizedUrlStringFromUrlObject", ()=>getSanitizedUrlStringFromUrlObject);
parcelHelpers.export(exports, "isURLObjectRelative", ()=>isURLObjectRelative);
parcelHelpers.export(exports, "parseStringToURLObject", ()=>parseStringToURLObject);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
parcelHelpers.export(exports, "stripDataUrlContent", ()=>stripDataUrlContent);
parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>stripUrlQueryAndFragment);
var _semanticAttributesJs = require("../semanticAttributes.js");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const DEFAULT_BASE_URL = "thismessage:/";
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function isURLObjectRelative(url) {
    return "isRelative" in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ("canParse" in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlStringFromUrlObject(url) {
    if (isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!isURLObjectRelative(urlObject)) {
            attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    const { protocol, host, path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}

},{"../semanticAttributes.js":"CCqFC","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"boXso":[function(require,module,exports) {
/**
 * Tagged template function which returns parameterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 *
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fmt", ()=>fmt);
parcelHelpers.export(exports, "parameterize", ()=>parameterize);
function parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\x00").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
/**
 * Tagged template function which returns parameterized representation of the message.
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ const fmt = parameterize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"7MOFI":[function(require,module,exports) {
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAutoIpAddressToSession", ()=>addAutoIpAddressToSession);
parcelHelpers.export(exports, "addAutoIpAddressToUser", ()=>addAutoIpAddressToUser);
function addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
/**
 * @internal
 */ function addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === undefined) session.ipAddress = "{{auto}}";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"le1kr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applySdkMetadata", ()=>applySdkMetadata);
var _versionJs = require("./version.js");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, _versionJs.SDK_VERSION)
            }));
        sdk.version = (0, _versionJs.SDK_VERSION);
    }
}

},{"./version.js":"bRSzn","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"aiP8Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTraceData", ()=>getTraceData);
var _indexJs = require("../asyncContext/index.js");
var _carrierJs = require("../carrier.js");
var _currentScopesJs = require("../currentScopes.js");
var _exportsJs = require("../exports.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanUtilsJs = require("./spanUtils.js");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _baggageJs = require("./baggage.js");
var _tracingJs = require("./tracing.js");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * When an external propagation context is registered (e.g. via the OTLP integration) and there is no active
 * Sentry span, this function returns an empty object to defer outgoing request propagation to the external
 * propagator (e.g. an OpenTelemetry propagator).
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function getTraceData(options = {}) {
    const client = options.client || (0, _currentScopesJs.getClient)();
    if (!(0, _exportsJs.isEnabled)() || !client) return {};
    const carrier = (0, _carrierJs.getMainCarrier)();
    const acs = (0, _indexJs.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || (0, _currentScopesJs.getCurrentScope)();
    const span = options.span || (0, _spanUtilsJs.getActiveSpan)();
    // When no active span and external propagation context is registered (e.g. OTLP integration),
    // return empty to let the OTel propagator handle outgoing request propagation.
    if (!span && (0, _currentScopesJs.hasExternalPropagationContext)()) return {};
    const sentryTrace = span ? (0, _spanUtilsJs.spanToTraceHeader)(span) : scopeToTraceHeader(scope);
    const dsc = span ? (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span) : (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromScope)(client, scope);
    const baggage = (0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    const isValidSentryTraceHeader = (0, _tracingJs.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, _debugLoggerJs.debug).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? (0, _spanUtilsJs.spanToTraceparentHeader)(span) : scopeToTraceparentHeader(scope);
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function scopeToTraceHeader(scope) {
    const { traceId, sampled, propagationSpanId } = scope.getPropagationContext();
    return (0, _tracingJs.generateSentryTraceHeader)(traceId, propagationSpanId, sampled);
}
function scopeToTraceparentHeader(scope) {
    const { traceId, sampled, propagationSpanId } = scope.getPropagationContext();
    return (0, _tracingJs.generateTraceparentHeader)(traceId, propagationSpanId, sampled);
}

},{"../asyncContext/index.js":"gS3DN","../carrier.js":"kQ3LD","../currentScopes.js":"5f8H7","../exports.js":"9zd3A","./debug-logger.js":"6Sybg","./spanUtils.js":"2Bh30","../tracing/dynamicSamplingContext.js":"1usYY","./baggage.js":"klYqA","./tracing.js":"fyjN8","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"Gv4xx":[function(require,module,exports) {
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
function debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1mChz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", ()=>addBreadcrumb);
var _currentScopesJs = require("./currentScopes.js");
var _debugLoggerJs = require("./utils/debug-logger.js");
var _timeJs = require("./utils/time.js");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function addBreadcrumb(breadcrumb, hint) {
    const client = (0, _currentScopesJs.getClient)();
    const isolationScope = (0, _currentScopesJs.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, _timeJs.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, _debugLoggerJs.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

},{"./currentScopes.js":"5f8H7","./utils/debug-logger.js":"6Sybg","./utils/time.js":"lCk2j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"7qRY6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "functionToStringIntegration", ()=>functionToStringIntegration);
var _currentScopesJs = require("../currentScopes.js");
var _integrationJs = require("../integration.js");
var _objectJs = require("../utils/object.js");
let originalFunctionToString;
const INTEGRATION_NAME = "FunctionToString";
const SETUP_CLIENTS = new WeakMap();
const _functionToStringIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, _objectJs.getOriginalFunction)(this);
                    const context = SETUP_CLIENTS.has((0, _currentScopesJs.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const functionToStringIntegration = (0, _integrationJs.defineIntegration)(_functionToStringIntegration);

},{"../currentScopes.js":"5f8H7","../integration.js":"b7ak3","../utils/object.js":"9SPt0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"7ofVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFiltersIntegration", ()=>eventFiltersIntegration);
parcelHelpers.export(exports, "inboundFiltersIntegration", ()=>inboundFiltersIntegration);
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _eventUtilsJs = require("../utils/eventUtils.js");
var _miscJs = require("../utils/misc.js");
var _stringJs = require("../utils/string.js");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const INTEGRATION_NAME = "EventFilters";
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const eventFiltersIntegration = (0, _integrationJs.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = _mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = _mergeOptions(options, clientOptions);
            }
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const inboundFiltersIntegration = (0, _integrationJs.defineIntegration)((options = {})=>{
    return {
        ...eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function _mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function _shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if (_isIgnoredError(event, options.ignoreErrors)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, _miscJs.getEventDescription)(event)}`);
            return true;
        }
        if (_isUselessError(event)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, _miscJs.getEventDescription)(event)}`);
            return true;
        }
        if (_isDeniedUrl(event, options.denyUrls)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, _miscJs.getEventDescription)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
            return true;
        }
        if (!_isAllowedUrl(event, options.allowUrls)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, _miscJs.getEventDescription)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") // Filter transactions
    {
        if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, _miscJs.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, _eventUtilsJs.getPossibleEventMessages)(event).some((message)=>(0, _stringJs.stringMatchesSomePattern)(message, ignoreErrors));
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, _stringJs.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = _getEventFilterUrl(event);
    return !url ? false : (0, _stringJs.stringMatchesSomePattern)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = _getEventFilterUrl(event);
    return !url ? true : (0, _stringJs.stringMatchesSomePattern)(url, allowUrls);
}
function _getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? _getLastValidUrl(frames) : null;
    } catch  {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error(`Cannot extract url for event ${(0, _miscJs.getEventDescription)(event)}`);
        return null;
    }
}
function _isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}

},{"../debug-build.js":"a2zY5","../integration.js":"b7ak3","../utils/debug-logger.js":"6Sybg","../utils/eventUtils.js":"1n3it","../utils/misc.js":"21lxb","../utils/string.js":"ankyT","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"k0cAK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moduleMetadataIntegration", ()=>moduleMetadataIntegration);
var _integrationJs = require("../integration.js");
var _metadataJs = require("../metadata.js");
var _envelopeJs = require("../utils/envelope.js");
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */ const moduleMetadataIntegration = (0, _integrationJs.defineIntegration)(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on("beforeEnvelope", (envelope)=>{
                (0, _envelopeJs.forEachEnvelopeItem)(envelope, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, _metadataJs.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                (0, _metadataJs.addMetadataToStackFrames)(stackParser, event);
            });
        }
    };
});

},{"../integration.js":"b7ak3","../metadata.js":"9Kk8M","../utils/envelope.js":"fQsVK","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9Kk8M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMetadataToStackFrames", ()=>addMetadataToStackFrames);
parcelHelpers.export(exports, "getFilenameToMetadataMap", ()=>getFilenameToMetadataMap);
parcelHelpers.export(exports, "getMetadataForUrl", ()=>getMetadataForUrl);
parcelHelpers.export(exports, "stripMetadataFromStackFrames", ()=>stripMetadataFromStackFrames);
var _worldwideJs = require("./utils/worldwide.js");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const parsedStacks = new Set();
/**
 * Builds a map of filenames to module metadata from the global _sentryModuleMetadata object.
 * This is useful for forwarding metadata from web workers to the main thread.
 *
 * @param parser - Stack parser to use for extracting filenames from stack traces
 * @returns A map of filename to metadata object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFilenameToMetadataMap(parser) {
    if (!(0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filenameMap = {};
    for (const stack of Object.keys((0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata)){
        const metadata = (0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function ensureMetadataStacksAreParsed(parser) {
    if (!(0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata)){
        const metadata = (0, _worldwideJs.GLOBAL_OBJ)._sentryModuleMetadata[stack];
        if (parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
    ensureMetadataStacksAreParsed(parser);
    return filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
/**
 * Strips metadata from stack frames.
 */ function stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}

},{"./utils/worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"cFxlD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureConsoleIntegration", ()=>captureConsoleIntegration);
var _currentScopesJs = require("../currentScopes.js");
var _exportsJs = require("../exports.js");
var _consoleJs = require("../instrument/console.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _miscJs = require("../utils/misc.js");
var _severityJs = require("../utils/severity.js");
var _stringJs = require("../utils/string.js");
var _worldwideJs = require("../utils/worldwide.js");
const INTEGRATION_NAME = "CaptureConsole";
const _captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, _debugLoggerJs.CONSOLE_LEVELS);
    const handled = options.handled ?? true;
    return {
        name: INTEGRATION_NAME,
        setup (client) {
            if (!("console" in (0, _worldwideJs.GLOBAL_OBJ))) return;
            (0, _consoleJs.addConsoleInstrumentationHandler)(({ args, level })=>{
                if ((0, _currentScopesJs.getClient)() !== client || !levels.includes(level)) return;
                consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const captureConsoleIntegration = (0, _integrationJs.defineIntegration)(_captureConsoleIntegration);
function consoleHandler(args, level, handled) {
    const severityLevel = (0, _severityJs.severityLevelFromString)(level);
    /*
    We create this error here already to attach a stack trace to captured messages,
    if users set `attachStackTrace` to `true` in Sentry.init.
    We do this here already because we want to minimize the number of Sentry SDK stack frames
    within the error. Technically, Client.captureMessage will also do it but this happens several
    stack frames deeper.
  */ const syntheticException = new Error();
    const captureContext = {
        level: (0, _severityJs.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, _currentScopesJs.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            (0, _miscJs.addExceptionMechanism)(event, {
                handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message = `Assertion failed: ${(0, _stringJs.safeJoin)(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message, severityLevel, {
                    captureContext,
                    syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            (0, _exportsJs.captureException)(error, captureContext);
            return;
        }
        const message = (0, _stringJs.safeJoin)(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext,
            syntheticException
        });
    });
}

},{"../currentScopes.js":"5f8H7","../exports.js":"9zd3A","../instrument/console.js":"447RN","../integration.js":"b7ak3","../utils/debug-logger.js":"6Sybg","../utils/misc.js":"21lxb","../utils/severity.js":"62Hx5","../utils/string.js":"ankyT","../utils/worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"447RN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", ()=>addConsoleInstrumentationHandler);
var _debugLoggerJs = require("../utils/debug-logger.js");
var _objectJs = require("../utils/object.js");
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentConsole);
    return removeHandler;
}
function instrumentConsole() {
    if (!("console" in (0, _worldwideJs.GLOBAL_OBJ))) return;
    (0, _debugLoggerJs.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, _worldwideJs.GLOBAL_OBJ).console)) return;
        (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, _debugLoggerJs.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                (0, _handlersJs.triggerHandlers)("console", {
                    args,
                    level
                });
                const log = (0, _debugLoggerJs.originalConsoleMethods)[level];
                log?.apply((0, _worldwideJs.GLOBAL_OBJ).console, args);
            };
        });
    });
}

},{"../utils/debug-logger.js":"6Sybg","../utils/object.js":"9SPt0","../utils/worldwide.js":"2qGVN","./handlers.js":"laAoO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"62Hx5":[function(require,module,exports) {
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "severityLevelFromString", ()=>severityLevelFromString);
function severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"egVbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_shouldDropEvent", ()=>_shouldDropEvent);
parcelHelpers.export(exports, "dedupeIntegration", ()=>dedupeIntegration);
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _stacktraceJs = require("../utils/stacktrace.js");
const INTEGRATION_NAME = "Dedupe";
const _dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const dedupeIntegration = (0, _integrationJs.defineIntegration)(_dedupeIntegration);
/** only exported for tests. */ function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = _getExceptionFromEvent(previousEvent);
    const currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, _stacktraceJs.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, _stacktraceJs.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}

},{"../debug-build.js":"a2zY5","../integration.js":"b7ak3","../utils/debug-logger.js":"6Sybg","../utils/stacktrace.js":"1WmJO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fGPte":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extraErrorDataIntegration", ()=>extraErrorDataIntegration);
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _isJs = require("../utils/is.js");
var _normalizeJs = require("../utils/normalize.js");
var _normalizationHintsJs = require("../utils/normalizationHints.js");
var _stringJs = require("../utils/string.js");
const INTEGRATION_NAME = "ExtraErrorData";
/**
 * Extract additional data for from original exceptions.
 */ const _extraErrorDataIntegration = (options = {})=>{
    const { depth = 3, captureErrorCause = true } = options;
    return {
        name: INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength } = client.getOptions();
            return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const extraErrorDataIntegration = (0, _integrationJs.defineIntegration)(_extraErrorDataIntegration);
function _enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, _isJs.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = _extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, _normalizeJs.normalize)(errorData, depth);
        if ((0, _isJs.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, _normalizationHintsJs.setSkipNormalizationHint)(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function _extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, _isJs.isError)(value) || typeof value === "string" ? maxValueLength ? (0, _stringJs.truncate)(`${value}`, maxValueLength) : `${value}` : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) {
            if ((0, _isJs.isError)(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: _extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, _isJs.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}

},{"../debug-build.js":"a2zY5","../integration.js":"b7ak3","../utils/debug-logger.js":"6Sybg","../utils/is.js":"jiTW9","../utils/normalize.js":"bplSM","../utils/normalizationHints.js":"6q8iK","../utils/string.js":"ankyT","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"eFzi3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateIteratee", ()=>generateIteratee);
parcelHelpers.export(exports, "rewriteFramesIntegration", ()=>rewriteFramesIntegration);
var _integrationJs = require("../integration.js");
var _pathJs = require("../utils/path.js");
var _worldwideJs = require("../utils/worldwide.js");
const INTEGRATION_NAME = "RewriteFrames";
/**
 * Rewrite event frames paths.
 */ const rewriteFramesIntegration = (0, _integrationJs.defineIntegration)((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in (0, _worldwideJs.GLOBAL_OBJ) && !!(0, _worldwideJs.GLOBAL_OBJ).window;
    const iteratee = options.iteratee || generateIteratee({
        isBrowser,
        root,
        prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function generateIteratee({ isBrowser, root, prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "") // remove Windows-style prefix
            .replace(/\\/g, "/") // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, _pathJs.relative)(root, filename) : (0, _pathJs.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}

},{"../integration.js":"b7ak3","../utils/path.js":"1xp48","../utils/worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1xp48":[function(require,module,exports) {
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basename", ()=>basename);
parcelHelpers.export(exports, "dirname", ()=>dirname);
parcelHelpers.export(exports, "isAbsolute", ()=>isAbsolute);
parcelHelpers.export(exports, "join", ()=>join);
parcelHelpers.export(exports, "normalizePath", ()=>normalizePath);
parcelHelpers.export(exports, "relative", ()=>relative);
parcelHelpers.export(exports, "resolve", ()=>resolve);
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).slice(1);
    to = resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = trim(from.split("/"));
    const toParts = trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
// path.normalize(path)
// posix version
/** JSDoc */ function normalizePath(path) {
    const isPathAbsolute = isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    // Normalize the path
    let normalizedPath = normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
// posix version
/** JSDoc */ function isAbsolute(path) {
    return path.charAt(0) === "/";
}
// posix version
/** JSDoc */ function join(...args) {
    return normalizePath(args.join("/"));
}
/** JSDoc */ function dirname(path) {
    const result = splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return ".";
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function basename(path, ext) {
    let f = splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"kv21b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DB_OPERATIONS_TO_INSTRUMENT", ()=>DB_OPERATIONS_TO_INSTRUMENT);
parcelHelpers.export(exports, "FILTER_MAPPINGS", ()=>FILTER_MAPPINGS);
parcelHelpers.export(exports, "extractOperation", ()=>extractOperation);
parcelHelpers.export(exports, "instrumentSupabaseClient", ()=>instrumentSupabaseClient);
parcelHelpers.export(exports, "supabaseIntegration", ()=>supabaseIntegration);
parcelHelpers.export(exports, "translateFiltersIntoMethods", ()=>translateFiltersIntoMethods);
var _breadcrumbsJs = require("../breadcrumbs.js");
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _exportsJs = require("../exports.js");
var _integrationJs = require("../integration.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _miscJs = require("../utils/misc.js");
var _isJs = require("../utils/is.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _traceJs = require("../tracing/trace.js");
// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js
const AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {
    // ignore errors here
    }
}
function isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
/**
 * Plain-object bodies are copied into `plainBody`; array inserts (and other non-plain shapes) stay only on `rawBody`.
 * Returns a payload suitable for span attributes / breadcrumbs when the client has `sendDefaultPii` enabled.
 */ function getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return undefined;
}
/** True when the PostgREST builder carries a mutation body (for `insert(...)`, etc. in span descriptions). */ function hasMutationBodyForDescription(rawBody, plainBody) {
    return getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== undefined;
}
/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */ function extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */ function translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    // Handle optional `configPart` of the filter
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return (0, _traceJs.startSpan)({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.db.supabase",
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: (0, _spanstatusJs.SPAN_STATUS_ERROR)
                        });
                        (0, _exportsJs.captureException)(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_OK)
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_ERROR)
                    });
                    span.end();
                    (0, _exportsJs.captureException)(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = instrumentAuthOperation(authOperation);
    }
    for (const operation of AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = instrumentAuthOperation(authOperation, true);
    }
    markAsInstrumented(supabaseClientInstance.auth);
}
function instrumentSupabaseClientConstructor(SupabaseClient) {
    if (isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
            return rv;
        }
    });
    markAsInstrumented(SupabaseClient.prototype.from);
}
function instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
    if (isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())// It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
            // so we need to use array instead of object to collect them.
            queryItems.push(translateFiltersIntoMethods(key, value));
            const body = Object.create(null);
            if ((0, _isJs.isPlainObject)(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const sendDefaultPii = Boolean((0, _currentScopesJs.getClient)()?.getOptions().sendDefaultPii);
            const bodyPayload = getMutationBodyPayloadForTelemetry(typedThis.body, body);
            // Adding operation to the beginning of the description if it's not a `select` operation
            // For example, it can be an `insert` or `update` operation but the query can be `select(...)`
            // For `select` operations, we don't need repeat it in the description
            const mutationPart = operation === "select" ? "" : `${operation}${hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = sendDefaultPii ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.db.supabase",
                [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "db"
            };
            if (queryItems.length && sendDefaultPii) attributes["db.query"] = queryItems;
            if (bodyPayload !== undefined && sendDefaultPii) attributes["db.body"] = bodyPayload;
            return (0, _traceJs.startSpan)({
                name: description,
                attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) (0, _spanstatusJs.setHttpStatus)(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && sendDefaultPii) supabaseContext.query = queryItems;
                        if (bodyPayload !== undefined && sendDefaultPii) supabaseContext.body = bodyPayload;
                        (0, _exportsJs.captureException)(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                (0, _miscJs.addExceptionMechanism)(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && sendDefaultPii) data.query = queryItems;
                    if (bodyPayload !== undefined && sendDefaultPii) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    (0, _breadcrumbsJs.addBreadcrumb)(breadcrumb);
                    return res;
                }, (err)=>{
                    // TODO: shouldn't we capture this error?
                    if (span) {
                        (0, _spanstatusJs.setHttpStatus)(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
    // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
    // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
    for (const operation of DB_OPERATIONS_TO_INSTRUMENT){
        if (isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
                return rv;
            }
        });
        markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const instrumentSupabaseClient = (supabaseClient)=>{
    if (!supabaseClient) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    instrumentSupabaseClientConstructor(SupabaseClientConstructor);
    instrumentSupabaseAuthClient(supabaseClient);
};
const INTEGRATION_NAME = "Supabase";
const _supabaseIntegration = (supabaseClient)=>{
    return {
        setupOnce () {
            instrumentSupabaseClient(supabaseClient);
        },
        name: INTEGRATION_NAME
    };
};
const supabaseIntegration = (0, _integrationJs.defineIntegration)((options)=>{
    return _supabaseIntegration(options.supabaseClient);
});

},{"../breadcrumbs.js":"1mChz","../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../exports.js":"9zd3A","../integration.js":"b7ak3","../semanticAttributes.js":"CCqFC","../utils/debug-logger.js":"6Sybg","../utils/misc.js":"21lxb","../utils/is.js":"jiTW9","../tracing/spanstatus.js":"cq3xe","../tracing/trace.js":"jFgPq","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6xTDd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyZodErrorsToEvent", ()=>applyZodErrorsToEvent);
parcelHelpers.export(exports, "flattenIssue", ()=>flattenIssue);
parcelHelpers.export(exports, "flattenIssuePath", ()=>flattenIssuePath);
parcelHelpers.export(exports, "formatIssueMessage", ()=>formatIssueMessage);
parcelHelpers.export(exports, "zodErrorsIntegration", ()=>zodErrorsIntegration);
var _integrationJs = require("../integration.js");
var _isJs = require("../utils/is.js");
var _stringJs = require("../utils/string.js");
const DEFAULT_LIMIT = 10;
const INTEGRATION_NAME = "ZodErrors";
/**
 * Simplified ZodIssue type definition
 */ function originalExceptionIsZodError(originalException) {
    return (0, _isJs.isError)(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
/**
 * Formats child objects or arrays to a string
 * that is preserved when sent to Sentry.
 *
 * Without this, we end up with something like this in Sentry:
 *
 * [
 *  [Object],
 *  [Object],
 *  [Object],
 *  [Object]
 * ]
 */ function flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : undefined,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : undefined,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : undefined
    };
}
/**
 * Takes ZodError issue path array and returns a flattened version as a string.
 * This makes it easier to display paths within a Sentry error message.
 *
 * Array indexes are normalized to reduce duplicate entries
 *
 * @param path ZodError issue path
 * @returns flattened path
 *
 * @example
 * flattenIssuePath([0, 'foo', 1, 'bar']) // -> '<array>.foo.<array>.bar'
 */ function flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */ function formatIssueMessage(zodError) {
    const errorKeyMap = new Set();
    for (const iss of zodError.issues){
        const issuePath = flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        // If there are no keys, then we're likely validating the root
        // variable rather than a key within an object. This attempts
        // to extract what type it was that failed to validate.
        // For example, z.string().parse(123) would return "string" here.
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== undefined && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${(0, _stringJs.truncate)(errorKeys.join(", "), 100)}`;
}
/**
 * Applies ZodError issues to an event extra and replaces the error message
 */ function applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map(flattenIssue);
        if (saveZodIssuesAsAttachment) {
            // Sometimes having the full error details can be helpful.
            // Attachments have much higher limits, so we can include the full list of issues.
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        // Hopefully we never throw errors here, but record it
        // with the event just in case.
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}\n${e.stack}` : "unknown"
                }
            }
        };
    }
}
const _zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? DEFAULT_LIMIT;
    return {
        name: INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
/**
 * Sentry integration to process Zod errors, making them easier to work with in Sentry.
 */ const zodErrorsIntegration = (0, _integrationJs.defineIntegration)(_zodErrorsIntegration);

},{"../integration.js":"b7ak3","../utils/is.js":"jiTW9","../utils/string.js":"ankyT","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"jmBPg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thirdPartyErrorFilterIntegration", ()=>thirdPartyErrorFilterIntegration);
var _integrationJs = require("../integration.js");
var _metadataJs = require("../metadata.js");
var _envelopeJs = require("../utils/envelope.js");
var _stacktraceJs = require("../utils/stacktrace.js");
/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */ const thirdPartyErrorFilterIntegration = (0, _integrationJs.defineIntegration)((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on("beforeEnvelope", (envelope)=>{
                (0, _envelopeJs.forEachEnvelopeItem)(envelope, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, _metadataJs.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                (0, _metadataJs.addMetadataToStackFrames)(stackParser, event);
            });
        },
        processEvent (event) {
            const frameKeys = getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
/**
 * Checks if a stack frame is a Sentry internal frame by strictly matching:
 * 1. The frame must be the last frame in the stack
 * 2. The filename must indicate the internal helpers file
 * 3. The context_line must contain the exact pattern "fn.apply(this, wrappedArguments)"
 * 4. The comment pattern "Attempt to invoke user-land function" must be present in pre_context
 *
 */ function isSentryInternalFrame(frame, frameIndex) {
    // Only match the last frame (index 0 in reversed stack)
    if (frameIndex !== 0 || !frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes(SENTRY_INTERNAL_FN_APPLY) // Must have context_line with the exact fn.apply pattern
    ) return false;
    // Check pre_context array for comment pattern
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes(SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames) {
    const frames = (0, _stacktraceJs.getFramesFromEvent)(event);
    if (!frames) return undefined;
    return frames.filter((frame, index)=>{
        // Exclude frames without a filename
        if (!frame.filename) return false;
        // Exclude frames without location info, since these are likely native code or built-ins.
        // JS frames have lineno/colno, WASM frames have instruction_addr instead.
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        // Optionally ignore Sentry internal frames
        return !ignoreSentryInternalFrames || !isSentryInternalFrame(frame, index);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith(BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice(BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
const BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";

},{"../integration.js":"b7ak3","../metadata.js":"9Kk8M","../utils/envelope.js":"fQsVK","../utils/stacktrace.js":"1WmJO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"8WDuG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureFlagsIntegration", ()=>featureFlagsIntegration);
var _integrationJs = require("../../integration.js");
var _featureFlagsJs = require("../../utils/featureFlags.js");
/**
 * Sentry integration for buffering feature flag evaluations manually with an API, and
 * capturing them on error events and spans.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const featureFlagsIntegration = (0, _integrationJs.defineIntegration)(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return (0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent)(event);
        },
        addFeatureFlag (name, value) {
            (0, _featureFlagsJs._INTERNAL_insertFlagToScope)(name, value);
            (0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan)(name, value);
        }
    };
});

},{"../../integration.js":"b7ak3","../../utils/featureFlags.js":"kDEWt","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"kDEWt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_FLAG_BUFFER_SIZE", ()=>_INTERNAL_FLAG_BUFFER_SIZE);
parcelHelpers.export(exports, "_INTERNAL_MAX_FLAGS_PER_SPAN", ()=>_INTERNAL_MAX_FLAGS_PER_SPAN);
parcelHelpers.export(exports, "_INTERNAL_addFeatureFlagToActiveSpan", ()=>_INTERNAL_addFeatureFlagToActiveSpan);
parcelHelpers.export(exports, "_INTERNAL_copyFlagsFromScopeToEvent", ()=>_INTERNAL_copyFlagsFromScopeToEvent);
parcelHelpers.export(exports, "_INTERNAL_insertFlagToScope", ()=>_INTERNAL_insertFlagToScope);
parcelHelpers.export(exports, "_INTERNAL_insertToFlagBuffer", ()=>_INTERNAL_insertToFlagBuffer);
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const _INTERNAL_FLAG_BUFFER_SIZE = 100;
/**
 * Max number of flag evaluations to record per span.
 */ const _INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
/**
 * Copies feature flags that are in current scope context to the event context
 */ function _INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) // No need to add the flags context to transaction events.
    // Spans already get the flag.evaluation attributes.
    return event;
    const scope = (0, _currentScopesJs.getCurrentScope)();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Inserts a flag into the current scope's context while maintaining ordered LRU properties.
 * Not thread-safe. After inserting:
 * - The flag buffer is sorted in order of recency, with the newest evaluation at the end.
 * - The names in the buffer are always unique.
 * - The length of the buffer never exceeds `maxSize`.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. Default value should always be used in production.
 */ function _INTERNAL_insertFlagToScope(name, value, maxSize = _INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = (0, _currentScopesJs.getCurrentScope)().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    _INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
/**
 * Exported for tests only. Currently only accepts boolean values (otherwise no-op).
 * Inserts a flag into a FeatureFlag array while maintaining the following properties:
 * - Flags are sorted in order of recency, with the newest evaluation at the end.
 * - The flag names are always unique.
 * - The length of the array never exceeds `maxSize`.
 *
 * @param flags      The buffer to insert the flag into.
 * @param name       Name of the feature flag to insert.
 * @param value      Value of the feature flag.
 * @param maxSize    Max number of flags the buffer should store. Default value should always be used in production.
 */ function _INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}
/**
 * Records a feature flag evaluation for the active span. This is a no-op for non-boolean values.
 * The flag and its value is stored in span attributes with the `flag.evaluation` prefix. Once the
 * unique flags for a span reaches maxFlagsPerSpan, subsequent flags are dropped.
 *
 * @param name             Name of the feature flag.
 * @param value            Value of the feature flag. Non-boolean values are ignored.
 * @param maxFlagsPerSpan  Max number of flags a buffer should store. Default value should always be used in production.
 */ function _INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = _INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = (0, _spanUtilsJs.getActiveSpan)();
    if (!span) return;
    const attributes = (0, _spanUtilsJs.spanToJSON)(span).data;
    // If the flag already exists, always update it
    if (`${SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    // Else, add the flag to the span if we have not reached the max number of flags
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith(SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}

},{"../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","./debug-logger.js":"6Sybg","./spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"4NUMl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "growthbookIntegration", ()=>growthbookIntegration);
var _integrationJs = require("../../integration.js");
var _featureFlagsJs = require("../../utils/featureFlags.js");
var _objectJs = require("../../utils/object.js");
/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * Only boolean results are captured at this time.
 *
 * @example
 * ```typescript
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser'; // or '@sentry/node'
 *
 * Sentry.init({
 *   dsn: 'your-dsn',
 *   integrations: [
 *     Sentry.growthbookIntegration({ growthbookClass: GrowthBook })
 *   ]
 * });
 * ```
 */ const growthbookIntegration = (0, _integrationJs.defineIntegration)(({ growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            // Type guard and wrap isOn
            if (typeof proto.isOn === "function") (0, _objectJs.fill)(proto, "isOn", _wrapAndCaptureBooleanResult);
            // Type guard and wrap getFeatureValue
            if (typeof proto.getFeatureValue === "function") (0, _objectJs.fill)(proto, "getFeatureValue", _wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return (0, _featureFlagsJs._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
function _wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            (0, _featureFlagsJs._INTERNAL_insertFlagToScope)(flagName, result);
            (0, _featureFlagsJs._INTERNAL_addFeatureFlagToActiveSpan)(flagName, result);
        }
        return result;
    };
}

},{"../../integration.js":"b7ak3","../../utils/featureFlags.js":"kDEWt","../../utils/object.js":"9SPt0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"48aVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conversationIdIntegration", ()=>conversationIdIntegration);
var _currentScopesJs = require("../currentScopes.js");
var _integrationJs = require("../integration.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
const INTEGRATION_NAME = "ConversationId";
const _conversationIdIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = (0, _currentScopesJs.getCurrentScope)().getScopeData();
                const isolationScopeData = (0, _currentScopesJs.getIsolationScope)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op, data: attributes, description: name } = (0, _spanUtilsJs.spanToJSON)(span);
                    // Only apply conversation ID to gen_ai spans.
                    // We also check for Vercel AI spans (ai.operationId attribute or ai.* span name)
                    // because the Vercel AI integration sets the gen_ai.* op in its own spanStart handler
                    // which fires after this, so the op is not yet available at this point.
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute((0, _semanticAttributesJs.GEN_AI_CONVERSATION_ID_ATTRIBUTE), conversationId);
                }
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const conversationIdIntegration = (0, _integrationJs.defineIntegration)(_conversationIdIntegration);

},{"../currentScopes.js":"5f8H7","../integration.js":"b7ak3","../semanticAttributes.js":"CCqFC","../utils/spanUtils.js":"2Bh30","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"7kVE9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_INTERNAL_getTracingHeadersForFetchRequest", ()=>_INTERNAL_getTracingHeadersForFetchRequest);
parcelHelpers.export(exports, "_callOnRequestSpanEnd", ()=>_callOnRequestSpanEnd);
parcelHelpers.export(exports, "instrumentFetchRequest", ()=>instrumentFetchRequest);
var _currentScopesJs = require("./currentScopes.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _isJs = require("./utils/is.js");
var _hasSpansEnabledJs = require("./utils/hasSpansEnabled.js");
var _baggageJs = require("./utils/baggage.js");
var _sentryNonRecordingSpanJs = require("./tracing/sentryNonRecordingSpan.js");
var _traceJs = require("./tracing/trace.js");
var _traceDataJs = require("./utils/traceData.js");
var _urlJs = require("./utils/url.js");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    const { method, url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, _hasSpansEnabledJs.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            // Only end the span and call hooks if we're actually recording
            if (shouldCreateSpanResult) {
                endSpan(span, handlerData);
                _callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions);
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    const { spanOrigin = "auto.http.browser", propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = (0, _currentScopesJs.getClient)();
    const hasParent = !!(0, _spanUtilsJs.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, _traceJs.startInactiveSpan)(getSpanStartOptions(url, method, spanOrigin)) : new (0, _sentryNonRecordingSpanJs.SentryNonRecordingSpan)();
    if (shouldCreateSpanResult && !hasParent) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        // Shallow clone the options object to avoid mutating the original user-provided object
        // Examples: users re-using same options object for multiple fetch calls, frozen objects
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = _INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, _hasSpansEnabledJs.hasSpansEnabled)() && hasParent ? span : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
/**
 * Calls the onRequestSpanEnd callback if it is defined.
 */ function _callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : undefined;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
/**
 * Builds merged fetch headers that include `sentry-trace` and `baggage` (and optionally `traceparent`)
 * for the given request and init, without mutating the original request or options.
 * Returns `undefined` when there is no `sentry-trace` value to attach.
 *
 * @internal Exported for cross-package instrumentation (for example Cloudflare Workers fetcher bindings)
 * and unit tests
 *
 * Baggage handling:
 * 1. No previous baggage header → include Sentry baggage
 * 2. Previous baggage has no Sentry entries → merge Sentry baggage in
 * 3. Previous baggage already has Sentry entries → leave as-is (may be user-defined)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function _INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = (0, _traceDataJs.getTraceData)({
        span,
        propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ((0, _isJs.isRequest)(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if (isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if (isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : undefined;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : undefined;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>baggageHeaderHasSentryBaggageValues(headerItem)) : baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, _spanstatusJs.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
        message: "internal_error"
    });
    span.end();
}
function baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith((0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX)));
}
function isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, _isJs.isInstanceOf)(headers, Headers);
}
/** `HeadersInit` array form: each entry is a [name, value] pair of strings. */ function isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function getSpanStartOptions(url, method, spanOrigin) {
    // Data URLs need special handling because parseStringToURLObject treats them as "relative"
    // (no "://"), causing getSanitizedUrlStringFromUrlObject to return just the pathname
    // without the "data:" prefix, making later stripDataUrlContent calls ineffective.
    // So for data URLs, we strip the content first and use that directly.
    if (url.startsWith("data:")) {
        const sanitizedUrl = (0, _urlJs.stripDataUrlContent)(url);
        return {
            name: `${method} ${sanitizedUrl}`,
            attributes: getFetchSpanAttributes(url, undefined, method, spanOrigin)
        };
    }
    const parsedUrl = (0, _urlJs.parseStringToURLObject)(url);
    const sanitizedUrl = parsedUrl ? (0, _urlJs.getSanitizedUrlStringFromUrlObject)(parsedUrl) : url;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: (0, _urlJs.stripDataUrlContent)(url),
        type: "fetch",
        "http.method": method,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client"
    };
    if (parsedUrl) {
        if (!(0, _urlJs.isURLObjectRelative)(parsedUrl)) {
            attributes["http.url"] = (0, _urlJs.stripDataUrlContent)(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}

},{"./currentScopes.js":"5f8H7","./semanticAttributes.js":"CCqFC","./utils/spanUtils.js":"2Bh30","./tracing/spanstatus.js":"cq3xe","./utils/is.js":"jiTW9","./utils/hasSpansEnabled.js":"ddp8b","./utils/baggage.js":"klYqA","./tracing/sentryNonRecordingSpan.js":"bVjrp","./tracing/trace.js":"jFgPq","./utils/traceData.js":"aiP8Q","./utils/url.js":"3T1sD","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"l9nNR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureFeedback", ()=>captureFeedback);
var _currentScopesJs = require("./currentScopes.js");
/**
 * Send user feedback to Sentry.
 */ function captureFeedback(params, hint = {}, scope = (0, _currentScopesJs.getCurrentScope)()) {
    const { message, name, email, url, source, associatedEventId, tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name,
                message,
                url,
                source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags
    };
    const client = scope?.getClient() || (0, _currentScopesJs.getClient)();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}

},{"./currentScopes.js":"5f8H7","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"ibTkj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fmt", ()=>(0, _parameterizeJs.fmt));
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "fatal", ()=>fatal);
parcelHelpers.export(exports, "info", ()=>info);
parcelHelpers.export(exports, "trace", ()=>trace);
parcelHelpers.export(exports, "warn", ()=>warn);
var _internalJs = require("./internal.js");
var _parameterizeJs = require("../utils/parameterize.js");
/**
 * Capture a log with the given level.
 *
 * @param level - The level of the log.
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., userId: 100.
 * @param scope - The scope to capture the log with.
 * @param severityNumber - The severity number of the log.
 */ function captureLog(level, message, attributes, scope, severityNumber) {
    (0, _internalJs._INTERNAL_captureLog)({
        level,
        message,
        attributes,
        severityNumber
    }, scope);
}
/**
 * Additional metadata to capture the log with.
 */ /**
 * @summary Capture a log with the `trace` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function trace(message, attributes, { scope } = {}) {
    captureLog("trace", message, attributes, scope);
}
/**
 * @summary Capture a log with the `debug` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function debug(message, attributes, { scope } = {}) {
    captureLog("debug", message, attributes, scope);
}
/**
 * @summary Capture a log with the `info` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function info(message, attributes, { scope } = {}) {
    captureLog("info", message, attributes, scope);
}
/**
 * @summary Capture a log with the `warn` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function warn(message, attributes, { scope } = {}) {
    captureLog("warn", message, attributes, scope);
}
/**
 * @summary Capture a log with the `error` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function error(message, attributes, { scope } = {}) {
    captureLog("error", message, attributes, scope);
}
/**
 * @summary Capture a log with the `fatal` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function fatal(message, attributes, { scope } = {}) {
    captureLog("fatal", message, attributes, scope);
}

},{"./internal.js":"bO2sr","../utils/parameterize.js":"boXso","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"d38y8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "consoleLoggingIntegration", ()=>consoleLoggingIntegration);
var _currentScopesJs = require("../currentScopes.js");
var _debugBuildJs = require("../debug-build.js");
var _consoleJs = require("../instrument/console.js");
var _integrationJs = require("../integration.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _debugLoggerJs = require("../utils/debug-logger.js");
var _internalJs = require("./internal.js");
var _utilsJs = require("./utils.js");
const INTEGRATION_NAME = "ConsoleLogs";
const DEFAULT_ATTRIBUTES = {
    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.log.console"
};
const _consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || (0, _debugLoggerJs.CONSOLE_LEVELS);
    return {
        name: INTEGRATION_NAME,
        setup (client) {
            const { enableLogs, normalizeDepth = 3, normalizeMaxBreadth = 1000 } = client.getOptions();
            if (!enableLogs) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = (0, _consoleJs.addConsoleInstrumentationHandler)(({ args, level })=>{
                if ((0, _currentScopesJs.getClient)() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${(0, _utilsJs.formatConsoleArgs)(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        (0, _internalJs._INTERNAL_captureLog)({
                            level: "error",
                            message: assertionMessage,
                            attributes: DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const shouldGenerateTemplate = args.length > 1 && typeof args[0] === "string" && !(0, _utilsJs.hasConsoleSubstitutions)(args[0]);
                const attributes = {
                    ...DEFAULT_ATTRIBUTES,
                    ...shouldGenerateTemplate ? (0, _utilsJs.createConsoleTemplateAttributes)(firstArg, followingArgs) : {}
                };
                (0, _internalJs._INTERNAL_captureLog)({
                    level: isLevelLog ? "info" : level,
                    message: (0, _utilsJs.formatConsoleArgs)(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : undefined,
                    attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
/**
 * Captures calls to the `console` API as logs in Sentry. Requires the `enableLogs` option to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   enableLogs: true,
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const consoleLoggingIntegration = (0, _integrationJs.defineIntegration)(_consoleLoggingIntegration);

},{"../currentScopes.js":"5f8H7","../debug-build.js":"a2zY5","../instrument/console.js":"447RN","../integration.js":"b7ak3","../semanticAttributes.js":"CCqFC","../utils/debug-logger.js":"6Sybg","./internal.js":"bO2sr","./utils.js":"3XuQV","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"3XuQV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConsoleTemplateAttributes", ()=>createConsoleTemplateAttributes);
parcelHelpers.export(exports, "formatConsoleArgs", ()=>formatConsoleArgs);
parcelHelpers.export(exports, "hasConsoleSubstitutions", ()=>hasConsoleSubstitutions);
parcelHelpers.export(exports, "safeJoinConsoleArgs", ()=>safeJoinConsoleArgs);
var _isJs = require("../utils/is.js");
var _normalizeJs = require("../utils/normalize.js");
var _worldwideJs = require("../utils/worldwide.js");
/**
 * Formats the given values into a string.
 *
 * @param values - The values to format.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The formatted string.
 */ function formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in (0, _worldwideJs.GLOBAL_OBJ) && typeof (0, _worldwideJs.GLOBAL_OBJ).util.format === "function" ? (0, _worldwideJs.GLOBAL_OBJ).util.format(...values) : safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
/**
 * Joins the given values into a string.
 *
 * @param values - The values to join.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The joined string.
 */ function safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>(0, _isJs.isPrimitive)(value) ? String(value) : JSON.stringify((0, _normalizeJs.normalize)(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
/**
 * Checks if a string contains console substitution patterns like %s, %d, %i, %f, %o, %O, %c.
 *
 * @param str - The string to check
 * @returns true if the string contains console substitution patterns
 */ function hasConsoleSubstitutions(str) {
    // Match console substitution patterns: %s, %d, %i, %f, %o, %O, %c
    return /%[sdifocO]/.test(str);
}
/**
 * Creates template attributes for multiple console arguments.
 *
 * @param args - The console arguments
 * @returns An object with template and parameter attributes
 */ function createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    // Create template with placeholders for each argument
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    // Add each argument as a parameter
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}

},{"../utils/is.js":"jiTW9","../utils/normalize.js":"bplSM","../utils/worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"imV6l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", ()=>count);
parcelHelpers.export(exports, "distribution", ()=>distribution);
parcelHelpers.export(exports, "gauge", ()=>gauge);
var _internalJs = require("./internal.js");
/**
 * Options for capturing a metric.
 */ /**
 * Capture a metric with the given type, name, and value.
 *
 * @param type - The type of the metric.
 * @param name - The name of the metric.
 * @param value - The value of the metric.
 * @param options - Options for capturing the metric.
 */ function captureMetric(type, name, value, options) {
    (0, _internalJs._INTERNAL_captureMetric)({
        type,
        name,
        value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
/**
 * @summary Increment a counter metric.
 *
 * @param name - The name of the counter metric.
 * @param value - The value to increment by (defaults to 1).
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.count('api.requests', 1, {
 *   attributes: {
 *     endpoint: '/api/users',
 *     method: 'GET',
 *     status: 200
 *   }
 * });
 * ```
 *
 * @example With custom value
 *
 * ```
 * Sentry.metrics.count('items.processed', 5, {
 *   attributes: {
 *     processor: 'batch-processor',
 *     queue: 'high-priority'
 *   }
 * });
 * ```
 */ function count(name, value = 1, options) {
    captureMetric("counter", name, value, options);
}
/**
 * @summary Set a gauge metric to a specific value.
 *
 * @param name - The name of the gauge metric.
 * @param value - The current value of the gauge.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.gauge('memory.usage', 1024, {
 *   unit: 'megabyte',
 *   attributes: {
 *     process: 'web-server',
 *     region: 'us-east-1'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.gauge('active.connections', 42, {
 *   attributes: {
 *     server: 'api-1',
 *     protocol: 'websocket'
 *   }
 * });
 * ```
 */ function gauge(name, value, options) {
    captureMetric("gauge", name, value, options);
}
/**
 * @summary Record a value in a distribution metric.
 *
 * @param name - The name of the distribution metric.
 * @param value - The value to record in the distribution.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.distribution('task.duration', 500, {
 *   unit: 'millisecond',
 *   attributes: {
 *     task: 'data-processing',
 *     priority: 'high'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.distribution('batch.size', 100, {
 *   attributes: {
 *     processor: 'batch-1',
 *     type: 'async'
 *   }
 * });
 * ```
 */ function distribution(name, value, options) {
    captureMetric("distribution", name, value, options);
}

},{"./internal.js":"htABD","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9EcD4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConsolaReporter", ()=>createConsolaReporter);
var _currentScopesJs = require("../currentScopes.js");
var _internalJs = require("../logs/internal.js");
var _utilsJs = require("../logs/utils.js");
var _isJs = require("../utils/is.js");
var _normalizeJs = require("../utils/normalize.js");
/**
 * Result of extracting structured attributes from console arguments.
 */ const DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
/**
 * Creates a new Sentry reporter for Consola that forwards logs to Sentry. Requires the `enableLogs` option to be enabled.
 *
 * **Note: This integration supports Consola v3.x only.** The reporter interface and log object structure
 * may differ in other versions of Consola.
 *
 * @param options - Configuration options for the reporter.
 * @returns A Consola reporter that can be added to consola instances.
 *
 * @example
 * ```ts
 * import * as Sentry from '@sentry/node';
 * import { consola } from 'consola';
 *
 * Sentry.init({
 *   enableLogs: true,
 * });
 *
 * const sentryReporter = Sentry.createConsolaReporter({
 *   // Optional: filter levels to capture
 *   levels: ['error', 'warn', 'info'],
 * });
 *
 * consola.addReporter(sentryReporter);
 *
 * // Now consola logs will be captured by Sentry
 * consola.info('This will be sent to Sentry');
 * consola.error('This error will also be sent to Sentry');
 * ```
 */ function createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            // We need to exclude certain known properties from being added as additional attributes
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { type, level, message: consolaMessage, args, tag, date: _date, ...rest } = logObj;
            // Get client - use provided client or current client
            const client = providedClient || (0, _currentScopesJs.getClient)();
            if (!client) return;
            // Determine the log severity level
            const logSeverityLevel = getLogSeverityLevel(type, level);
            // Early exit if this level should not be captured
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = client.getOptions();
            const attributes = {};
            // Build attributes
            for (const [key, value] of Object.entries(rest))attributes[key] = (0, _normalizeJs.normalize)(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            // Only add level if it's a valid number (not null/undefined)
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = processExtractedAttributes(defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            (0, _internalJs._INTERNAL_captureLog)({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && (0, _utilsJs.formatConsoleArgs)(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes
            });
        }
    };
}
// Mapping from consola log types to Sentry log severity levels
const CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
// Mapping from consola log levels (numbers) to Sentry log severity levels
const CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    1: "warn",
    2: "info",
    3: "info",
    4: "debug",
    5: "trace"
};
/**
 * Determines the log severity level from Consola type and level.
 *
 * @param type - The Consola log type (e.g., 'error', 'warn', 'info')
 * @param level - The Consola numeric log level (0-5) or null for some types like 'verbose'
 * @returns The corresponding Sentry log severity level
 */ function getLogSeverityLevel(type, level) {
    // Handle special case for verbose logs (level can be null with infinite level in Consola)
    if (type === "verbose") return "debug";
    // Handle silent logs - these should be at trace level
    if (type === "silent") return "trace";
    // First try to map by type (more specific)
    if (type) {
        const mappedLevel = CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    // Fallback to level mapping (handle null level)
    if (typeof level === "number") {
        const mappedLevel = CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    // Default fallback
    return "info";
}
/**
 * Extracts structured attributes from console arguments. If the first argument is a plain object, its properties are extracted as attributes.
 */ function defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    // Message looks like how consola logs the message to the console (all args stringified and joined)
    const message = (0, _utilsJs.formatConsoleArgs)(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ((0, _isJs.isPlainObject)(firstArg)) {
        // Remaining args start from index 2 i f we used second arg as message, otherwise from index 1
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !(0, _utilsJs.hasConsoleSubstitutions)(firstArg);
        return {
            message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : undefined,
            messageParameters: shouldAddTemplateAttr ? followingArgs : undefined
        };
    }
}
/**
 * Processes extracted attributes by normalizing them and preparing message parameter attributes if a template is present.
 */ function processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message, attributes, messageTemplate, messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = (0, _utilsJs.createConsoleTemplateAttributes)(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? (0, _normalizeJs.normalize)(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = (0, _normalizeJs.normalize)(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...(0, _normalizeJs.normalize)(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}

},{"../currentScopes.js":"5f8H7","../logs/internal.js":"bO2sr","../logs/utils.js":"3XuQV","../utils/is.js":"jiTW9","../utils/normalize.js":"bplSM","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"4p1QQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentOpenAiClient", ()=>instrumentOpenAiClient);
var _debugBuildJs = require("../../debug-build.js");
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _debugLoggerJs = require("../../utils/debug-logger.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _streamingJs = require("./streaming.js");
var _utilsJs1 = require("./utils.js");
/**
 * Extract available tools from request parameters
 */ function extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return undefined;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Failed to serialize OpenAI tools:", error);
        return undefined;
    }
}
/**
 * Extract request attributes from method arguments
 */ function extractRequestAttributes(args, operationName) {
    const attributes = {
        [(0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE)]: "openai",
        [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: operationName,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = extractAvailableTools(params);
        if (availableTools) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, (0, _utilsJs1.extractRequestParameters)(params));
    } else attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
// Extract and record AI request inputs, if present. This is intentionally separate from response attributes.
function addRequestAttributes(span, params, operationName, enableTruncation) {
    // Store embeddings input on a separate attribute and do not truncate it
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        // No input provided
        if (input == null) return;
        // Empty input string
        if (typeof input === "string" && input.length === 0) return;
        // Empty array input
        if (Array.isArray(input) && input.length === 0) return;
        // Store strings as-is, arrays/objects as JSON
        span.setAttribute((0, _genAiAttributesJs.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE), typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : undefined;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions, filteredMessages } = (0, _utilsJs.extractSystemInstructions)(src);
    if (systemInstructions) span.setAttribute((0, _genAiAttributesJs.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE), systemInstructions);
    span.setAttribute((0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ATTRIBUTE), enableTruncation ? (0, _utilsJs.getTruncatedJsonString)(filteredMessages) : (0, _utilsJs.getJsonString)(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute((0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE), filteredMessages.length);
    else span.setAttribute((0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE), 1);
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = extractRequestAttributes(args, operationName);
        const model = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult;
            const instrumentedPromise = (0, _traceJs.startSpanManual)(spanConfig, (span)=>{
                originalResult = originalMethod.apply(context, args);
                if (options.recordInputs && params) addRequestAttributes(span, params, operationName, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
                // Return async processing
                return (async ()=>{
                    try {
                        const result = await originalResult;
                        return (0, _streamingJs.instrumentStream)(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                            message: "internal_error"
                        });
                        (0, _exportsJs.captureException)(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return (0, _utilsJs.wrapPromiseWithMethods)(originalResult, instrumentedPromise, "auto.ai.openai");
        }
        // Non-streaming
        let originalResult;
        const instrumentedPromise = (0, _traceJs.startSpan)(spanConfig, (span)=>{
            // Call synchronously to capture the promise
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) addRequestAttributes(span, params, operationName, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
            return originalResult.then((result)=>{
                (0, _utilsJs1.addResponseAttributes)(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                (0, _exportsJs.captureException)(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return (0, _utilsJs.wrapPromiseWithMethods)(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
/**
 * Create a deep proxy for OpenAI client instrumentation
 */ function createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = (0, _utilsJs.buildMethodPath)(currentPath, String(prop));
            const instrumentedMethod = (0, _constantsJs.OPENAI_METHOD_REGISTRY)[methodPath];
            if (typeof value === "function" && instrumentedMethod) return instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") // Bind non-instrumented functions to preserve the original `this` context,
            // which is required for accessing private class fields (e.g. #baseURL) in OpenAI SDK v5.
            return value.bind(obj);
            if (value && typeof value === "object") return createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an OpenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 */ function instrumentOpenAiClient(client, options) {
    return createDeepProxy(client, "", (0, _utilsJs.resolveAIRecordingOptions)(options));
}

},{"../../debug-build.js":"a2zY5","../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../../utils/debug-logger.js":"6Sybg","../spanstatus.js":"cq3xe","../trace.js":"jFgPq","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","./constants.js":"d7exr","./streaming.js":"3bal3","./utils.js":"47J21","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6VSO0":[function(require,module,exports) {
/**
 * OpenAI Integration Telemetry Attributes
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 */ // =============================================================================
// OPENTELEMETRY SEMANTIC CONVENTIONS FOR GENAI
// =============================================================================
/**
 * The input messages sent to the model
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GEN_AI_AGENT_NAME_ATTRIBUTE", ()=>GEN_AI_AGENT_NAME_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_CONVERSATION_ID_ATTRIBUTE", ()=>GEN_AI_CONVERSATION_ID_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE", ()=>GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE", ()=>GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE", ()=>GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_INPUT_MESSAGES_ATTRIBUTE", ()=>GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE", ()=>GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE", ()=>GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_OPERATION_NAME_ATTRIBUTE", ()=>GEN_AI_OPERATION_NAME_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE", ()=>GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_PIPELINE_NAME_ATTRIBUTE", ()=>GEN_AI_PIPELINE_NAME_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_PROMPT_ATTRIBUTE", ()=>GEN_AI_PROMPT_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE", ()=>GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE", ()=>GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE", ()=>GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE", ()=>GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE", ()=>GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_MODEL_ATTRIBUTE", ()=>GEN_AI_REQUEST_MODEL_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE", ()=>GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_STREAM_ATTRIBUTE", ()=>GEN_AI_REQUEST_STREAM_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE", ()=>GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_TOP_K_ATTRIBUTE", ()=>GEN_AI_REQUEST_TOP_K_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_REQUEST_TOP_P_ATTRIBUTE", ()=>GEN_AI_REQUEST_TOP_P_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE", ()=>GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_ID_ATTRIBUTE", ()=>GEN_AI_RESPONSE_ID_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_MODEL_ATTRIBUTE", ()=>GEN_AI_RESPONSE_MODEL_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE", ()=>GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_STREAMING_ATTRIBUTE", ()=>GEN_AI_RESPONSE_STREAMING_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_TEXT_ATTRIBUTE", ()=>GEN_AI_RESPONSE_TEXT_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE", ()=>GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_SYSTEM_ATTRIBUTE", ()=>GEN_AI_SYSTEM_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE", ()=>GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_TOOL_CALL_ID_ATTRIBUTE", ()=>GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE", ()=>GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_TOOL_INPUT_ATTRIBUTE", ()=>GEN_AI_TOOL_INPUT_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_TOOL_NAME_ATTRIBUTE", ()=>GEN_AI_TOOL_NAME_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_TOOL_OUTPUT_ATTRIBUTE", ()=>GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_TOOL_TYPE_ATTRIBUTE", ()=>GEN_AI_TOOL_TYPE_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE", ()=>GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE", ()=>GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE", ()=>GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE", ()=>GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE", ()=>GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE", ()=>GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
parcelHelpers.export(exports, "GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE", ()=>GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE);
const GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
/**
 * The Generative AI system being used
 * For OpenAI, this should always be "openai"
 */ const GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
/**
 * The name of the model as requested
 * Examples: "gpt-4", "gpt-3.5-turbo"
 */ const GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
/**
 * Whether streaming was enabled for the request
 */ const GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
/**
 * The temperature setting for the model request
 */ const GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
/**
 * The maximum number of tokens requested
 */ const GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
/**
 * The frequency penalty setting for the model request
 */ const GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
/**
 * The presence penalty setting for the model request
 */ const GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
/**
 * The top_p (nucleus sampling) setting for the model request
 */ const GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
/**
 * The top_k setting for the model request
 */ const GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
/**
 * The encoding format for the model request
 */ const GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
/**
 * The dimensions for the model request
 */ const GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
/**
 * Array of reasons why the model stopped generating tokens
 */ const GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
/**
 * The name of the model that generated the response
 */ const GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
/**
 * The unique identifier for the response
 */ const GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
/**
 * The reason why the model stopped generating tokens
 */ const GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
/**
 * The number of tokens used in the prompt
 */ const GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
/**
 * The number of tokens used in the response
 */ const GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
/**
 * The total number of tokens used (input + output)
 */ const GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
/**
 * The operation name
 */ const GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
/**
 * Original length of messages array, used to indicate truncations had occured
 */ const GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
/**
 * The prompt messages
 * Only recorded when recordInputs is enabled
 */ const GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
/**
 * The model's response messages including text and tool calls
 * Only recorded when recordOutputs is enabled
 * Format: stringified array of message objects with role, parts, and finish_reason
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-output-messages
 */ const GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
/**
 * The system instructions extracted from system messages
 * Only recorded when recordInputs is enabled
 * According to OpenTelemetry spec: https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-system-instructions
 */ const GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
/**
 * The response text
 * Only recorded when recordOutputs is enabled
 */ const GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
/**
 * The available tools from incoming request
 * Only recorded when recordInputs is enabled
 */ const GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
/**
 * Whether the response is a streaming response
 */ const GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
/**
 * The tool calls from the response
 * Only recorded when recordOutputs is enabled
 */ const GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
/**
 * The agent name
 */ const GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
/**
 * The pipeline name
 */ const GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
/**
 * The conversation ID for linking messages across API calls
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
/**
 * The number of cache creation input tokens used
 */ const GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
/**
 * The number of cache read input tokens used
 */ const GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
/**
 * The number of cache write input tokens used
 */ const GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
/**
 * The number of cached input tokens that were used
 */ const GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
/**
 * The span operation name for invoking an agent
 */ const GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
/**
 * The embeddings input
 * Only recorded when recordInputs is enabled
 */ const GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
/**
 * The span operation for embeddings
 */ const GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
/**
 * The span operation name for executing a tool
 */ const GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
/**
 * The tool name for tool call spans
 */ const GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
/**
 * The tool call ID
 */ const GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
/**
 * The tool type (e.g., 'function')
 */ const GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
/**
 * The tool input/arguments
 */ const GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
/**
 * The tool output/result
 */ const GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
/**
 * The description of the tool being used
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-description
 */ const GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"19wr8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMethodPath", ()=>buildMethodPath);
parcelHelpers.export(exports, "endStreamSpan", ()=>endStreamSpan);
parcelHelpers.export(exports, "extractSystemInstructions", ()=>extractSystemInstructions);
parcelHelpers.export(exports, "getJsonString", ()=>getJsonString);
parcelHelpers.export(exports, "getTruncatedJsonString", ()=>getTruncatedJsonString);
parcelHelpers.export(exports, "resolveAIRecordingOptions", ()=>resolveAIRecordingOptions);
parcelHelpers.export(exports, "setTokenUsageAttributes", ()=>setTokenUsageAttributes);
parcelHelpers.export(exports, "shouldEnableTruncation", ()=>shouldEnableTruncation);
parcelHelpers.export(exports, "wrapPromiseWithMethods", ()=>wrapPromiseWithMethods);
var _exportsJs = require("../../exports.js");
var _currentScopesJs = require("../../currentScopes.js");
var _hasSpanStreamingEnabledJs = require("../spans/hasSpanStreamingEnabled.js");
var _isJs = require("../../utils/is.js");
var _genAiAttributesJs = require("./gen-ai-attributes.js");
var _messageTruncationJs = require("./messageTruncation.js");
/**
 * Shared utils for AI integrations (OpenAI, Anthropic, Verce.AI, etc.)
 */ /**
 * Resolves AI recording options by falling back to the client's `sendDefaultPii` setting.
 * Precedence: explicit option > sendDefaultPii > false
 */ function resolveAIRecordingOptions(options) {
    const sendDefaultPii = Boolean((0, _currentScopesJs.getClient)()?.getOptions().sendDefaultPii);
    return {
        ...options,
        recordInputs: options?.recordInputs ?? sendDefaultPii,
        recordOutputs: options?.recordOutputs ?? sendDefaultPii
    };
}
/**
 * Resolves whether truncation should be enabled.
 * If the user explicitly set `enableTruncation`, that value is used.
 * Otherwise, truncation is disabled when span streaming is active.
 */ function shouldEnableTruncation(enableTruncation) {
    const client = (0, _currentScopesJs.getClient)();
    return enableTruncation ?? !(client && (0, _hasSpanStreamingEnabledJs.hasSpanStreamingEnabled)(client));
}
/**
 * Build method path from current traversal
 */ function buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param cachedInputTokens - The number of cached input tokens
 * @param cachedOutputTokens - The number of cached output tokens
 */ function setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== undefined) span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE)]: promptTokens
    });
    if (completionTokens !== undefined) span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE)]: completionTokens
    });
    if (promptTokens !== undefined || completionTokens !== undefined || cachedInputTokens !== undefined || cachedOutputTokens !== undefined) {
        /**
     * Total input tokens in a request is the summation of `input_tokens`,
     * `cache_creation_input_tokens`, and `cache_read_input_tokens`.
     */ const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE)]: totalTokens
        });
    }
}
/**
 * Ends a streaming span by setting all accumulated response attributes and ending the span.
 * Shared across OpenAI, Anthropic, and Google GenAI streaming implementations.
 */ function endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [(0, _genAiAttributesJs.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE)]: true
    };
    if (state.responseId) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    // Use explicit total if provided (OpenAI, Google), otherwise compute from cache tokens (Anthropic)
    if (state.totalTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== undefined || state.completionTokens !== undefined || state.cacheCreationInputTokens !== undefined || state.cacheReadInputTokens !== undefined) attrs[0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
/**
 * Serialize a value to a JSON string without truncation.
 * Strings are returned as-is, arrays and objects are JSON-stringified.
 */ function getJsonString(value) {
    if (typeof value === "string") return value;
    return JSON.stringify(value);
}
/**
 * Get the truncated JSON string for a string or array of strings.
 *
 * @param value - The string or array of strings to truncate
 * @returns The truncated JSON string
 */ function getTruncatedJsonString(value) {
    if (typeof value === "string") // Some values are already JSON strings, so we don't need to duplicate the JSON parsing
    return (0, _messageTruncationJs.truncateGenAiStringInput)(value);
    if (Array.isArray(value)) {
        // truncateGenAiMessages returns an array of strings, so we need to stringify it
        const truncatedMessages = (0, _messageTruncationJs.truncateGenAiMessages)(value);
        return JSON.stringify(truncatedMessages);
    }
    // value is an object, so we need to stringify it
    return JSON.stringify(value);
}
/**
 * Extract system instructions from messages array.
 * Finds the first system message and formats it according to OpenTelemetry semantic conventions.
 *
 * @param messages - Array of messages to extract system instructions from
 * @returns systemInstructions (JSON string) and filteredMessages (without system message)
 */ function extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== undefined ? JSON.stringify(systemMessage.content) : undefined;
    if (!systemContent) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions,
        filteredMessages
    };
}
/**
 * Creates a wrapped version of .withResponse() that replaces the data field
 * with the instrumented result while preserving metadata (response, request_id).
 */ async function createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    // Attach catch handler to originalWithResponse immediately to prevent unhandled rejection
    // If instrumentedPromise rejects first, we still need this handled
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        (0, _exportsJs.captureException)(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    // Combine instrumented result with original metadata
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
/**
 * Wraps a promise-like object to preserve additional methods (like .withResponse())
 * that AI SDK clients (OpenAI, Anthropic) attach to their APIPromise return values.
 *
 * Standard Promise methods (.then, .catch, .finally) are routed to the instrumented
 * promise to preserve Sentry's span instrumentation, while custom SDK methods are
 * forwarded to the original promise to maintain the SDK's API surface.
 */ function wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    // If the original result is not thenable, return the instrumented promise
    if (!(0, _isJs.isThenable)(originalPromiseLike)) return instrumentedPromise;
    // Create a proxy that forwards Promise methods to instrumentedPromise
    // and preserves additional methods from the original result
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            // For standard Promise methods (.then, .catch, .finally, Symbol.toStringTag),
            // use instrumentedPromise to preserve Sentry instrumentation.
            // For custom methods (like .withResponse()), use the original target.
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            // Special handling for .withResponse() to preserve instrumentation
            // .withResponse() returns { data: T, response: Response, request_id: string }
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}

},{"../../exports.js":"9zd3A","../../currentScopes.js":"5f8H7","../spans/hasSpanStreamingEnabled.js":"58R9c","../../utils/is.js":"jiTW9","./gen-ai-attributes.js":"6VSO0","./messageTruncation.js":"sR4dr","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"sR4dr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT", ()=>DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
parcelHelpers.export(exports, "truncateGenAiMessages", ()=>truncateGenAiMessages);
parcelHelpers.export(exports, "truncateGenAiStringInput", ()=>truncateGenAiStringInput);
var _mediaStrippingJs = require("./mediaStripping.js");
/**
 * Default maximum size in bytes for GenAI messages.
 * Messages exceeding this limit will be truncated.
 */ const DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 20000;
/**
 * Message format used by OpenAI and Anthropic APIs.
 */ /**
 * Calculate the UTF-8 byte length of a string.
 */ const utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
/**
 * Calculate the UTF-8 byte length of a value's JSON representation.
 */ const jsonBytes = (value)=>{
    return utf8Bytes(JSON.stringify(value));
};
/**
 * Truncate a string to fit within maxBytes (inclusive) when encoded as UTF-8.
 * Uses binary search for efficiency with multi-byte characters.
 *
 * @param text - The string to truncate
 * @param maxBytes - Maximum byte length (inclusive, UTF-8 encoded)
 * @returns Truncated string whose UTF-8 byte length is at most maxBytes
 */ function truncateTextByBytes(text, maxBytes) {
    if (utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
/**
 * Extract text content from a message item.
 * Handles plain strings and objects with a text property.
 *
 * @returns The text content
 */ function getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
/**
 * Create a new item with updated text content while preserving the original structure.
 *
 * @param item - Original item (string or object)
 * @param text - New text content
 * @returns New item with updated text
 */ function withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text
    };
}
/**
 * Check if a message has the OpenAI/Anthropic content format.
 */ function isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
/**
 * Check if a message has the OpenAI/Anthropic content array format.
 */ function isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
/**
 * Check if a message has the Google GenAI parts format.
 */ function isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
/**
 * Truncate a message with `content: string` format (OpenAI/Anthropic).
 *
 * @param message - Message with content property
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function truncateContentMessage(message, maxBytes) {
    // Calculate overhead (message structure without content)
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
/**
 * Extracts the array items and their key from an array-based message.
 * Returns `null` key if neither `parts` nor `content` is a valid array.
 */ function getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
/**
 * Truncate a message with an array-based format.
 * Handles both `parts: [...]` (Google GenAI) and `content: [...]` (OpenAI/Anthropic multimodal).
 * Keeps as many complete items as possible, only truncating the first item if needed.
 *
 * @param message - Message with parts or content array
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function truncateArrayMessage(message, maxBytes) {
    const { key, items } = getArrayItems(message);
    if (key === null || items.length === 0) return [];
    // Calculate overhead by creating empty text items
    const emptyItems = items.map((item)=>withItemText(item, ""));
    const overhead = jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    // Include items until we run out of space
    const includedItems = [];
    for (const item of items){
        const text = getItemText(item);
        const textSize = utf8Bytes(text);
        if (textSize <= remainingBytes) {
            // Item fits: include it as-is
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            // First item doesn't fit: truncate it
            const truncated = truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push(withItemText(item, truncated));
            break;
        } else break;
    }
    /* c8 ignore start
   * for type safety only, algorithm guarantees SOME text included */ if (includedItems.length <= 0) return [];
    else /* c8 ignore stop */ return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
/**
 * Truncate a single message to fit within maxBytes.
 *
 * Supports three message formats:
 * - OpenAI/Anthropic: `{ ..., content: string }`
 * - Vercel AI/OpenAI multimodal: `{ ..., content: Array<{type, text?, ...}> }`
 * - Google GenAI: `{ ..., parts: Array<string | {text: string} | non-text> }`
 *
 * @param message - The message to truncate
 * @param maxBytes - Maximum byte limit for the message
 * @returns Array containing the truncated message, or empty array if truncation fails
 */ function truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    // Handle plain strings (e.g., embeddings input)
    if (typeof message === "string") {
        const truncated = truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if (isContentMessage(message)) return truncateContentMessage(message, maxBytes);
    if (isContentArrayMessage(message) || isPartsMessage(message)) return truncateArrayMessage(message, maxBytes);
    // Unknown message format: cannot truncate safely
    return [];
}
/**
 * Strip the inline media from message arrays.
 *
 * This returns a stripped message. We do NOT want to mutate the data in place,
 * because of course we still want the actual API/client to handle the media.
 */ function stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = undefined;
        if (!!message && typeof message === "object") {
            if (isContentArrayMessage(message)) newMessage = {
                ...message,
                content: stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && (0, _mediaStrippingJs.isContentMedia)(message.content)) newMessage = {
                ...message,
                content: (0, _mediaStrippingJs.stripInlineMediaFromSingleMessage)(message.content)
            };
            if (isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: stripInlineMediaFromMessages(message.parts)
            };
            if ((0, _mediaStrippingJs.isContentMedia)(newMessage)) newMessage = (0, _mediaStrippingJs.stripInlineMediaFromSingleMessage)(newMessage);
            else if ((0, _mediaStrippingJs.isContentMedia)(message)) newMessage = (0, _mediaStrippingJs.stripInlineMediaFromSingleMessage)(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
/**
 * Truncate an array of messages to fit within a byte limit.
 *
 * Strategy:
 * - Always keeps only the last (newest) message
 * - Strips inline media from the message
 * - Truncates the message content if it exceeds the byte limit
 *
 * @param messages - Array of messages to truncate
 * @param maxBytes - Maximum total byte limit for the message
 * @returns Array containing only the last message (possibly truncated)
 *
 * @example
 * ```ts
 * const messages = [msg1, msg2, msg3, msg4]; // newest is msg4
 * const truncated = truncateMessagesByBytes(messages, 10000);
 * // Returns [msg4] (truncated if needed)
 * ```
 */ function truncateMessagesByBytes(messages, maxBytes) {
    // Early return for empty or invalid input
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    // The result is always a single-element array that callers wrap with
    // JSON.stringify([message]), so subtract the 2-byte array wrapper ("["  and "]")
    // to ensure the final serialized value stays under the limit.
    const effectiveMaxBytes = maxBytes - 2;
    // Always keep only the last message
    const lastMessage = messages[messages.length - 1];
    // Strip inline media from the single message
    const stripped = stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    // Check if it fits
    const messageBytes = jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    // Truncate the single message if needed
    return truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
/**
 * Truncate GenAI messages using the default byte limit.
 *
 * Convenience wrapper around `truncateMessagesByBytes` with the default limit.
 *
 * @param messages - Array of messages to truncate
 * @returns Truncated array of messages
 */ function truncateGenAiMessages(messages) {
    return truncateMessagesByBytes(messages, DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
/**
 * Truncate GenAI string input using the default byte limit.
 *
 * @param input - The string to truncate
 * @returns Truncated string
 */ function truncateGenAiStringInput(input) {
    return truncateTextByBytes(input, DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}

},{"./mediaStripping.js":"adCrc","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"adCrc":[function(require,module,exports) {
/**
 * Inline media content source, with a potentially very large base64
 * blob or data: uri.
 */ /**
 * Check if a content part is an OpenAI/Anthropic media source
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isContentMedia", ()=>isContentMedia);
parcelHelpers.export(exports, "stripInlineMediaFromSingleMessage", ()=>stripInlineMediaFromSingleMessage);
function isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return isContentMediaSource(part) || hasInlineData(part) || hasImageUrl(part) || hasInputAudio(part) || hasFileData(part) || hasMediaTypeData(part) || hasVercelFileData(part) || hasVercelImageData(part) || hasBlobOrBase64Type(part) || hasB64Json(part) || hasImageGenerationResult(part) || hasDataUri(part);
}
function hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return hasNestedImageUrl(part);
}
function hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && isContentMedia(part.source);
}
function hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
/**
 * Check for Vercel AI SDK file format: { type: "file", mediaType: "...", data: "..." }
 * Only matches base64/binary data, not HTTP/HTTPS URLs (which should be preserved).
 */ function hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
/**
 * Check for Vercel AI SDK image format: { type: "image", image: "base64...", mimeType?: "..." }
 * Only matches base64/data URIs, not HTTP/HTTPS URLs (which should be preserved).
 * Note: mimeType is optional in Vercel AI SDK image parts.
 */ function hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function hasB64Json(part) {
    return "b64_json" in part;
}
function hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const REMOVED_STRING = "[Blob substitute]";
const MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
/**
 * Replace inline binary data in a single media content part with a placeholder.
 */ function stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if (isContentMedia(strip.source)) strip.source = stripInlineMediaFromSingleMessage(strip.source);
    if (hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: REMOVED_STRING
    };
    if (hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: REMOVED_STRING
    };
    if (hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: REMOVED_STRING
    };
    if (hasFileData(part)) strip.file = {
        ...part.file,
        file_data: REMOVED_STRING
    };
    for (const field of MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = REMOVED_STRING;
    return strip;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"d7exr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPENAI_INTEGRATION_NAME", ()=>OPENAI_INTEGRATION_NAME);
parcelHelpers.export(exports, "OPENAI_METHOD_REGISTRY", ()=>OPENAI_METHOD_REGISTRY);
parcelHelpers.export(exports, "RESPONSES_TOOL_CALL_EVENT_TYPES", ()=>RESPONSES_TOOL_CALL_EVENT_TYPES);
parcelHelpers.export(exports, "RESPONSE_EVENT_TYPES", ()=>RESPONSE_EVENT_TYPES);
const OPENAI_INTEGRATION_NAME = "OpenAI";
// https://platform.openai.com/docs/quickstart?api-mode=responses
// https://platform.openai.com/docs/quickstart?api-mode=chat
// https://platform.openai.com/docs/api-reference/conversations
const OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...RESPONSES_TOOL_CALL_EVENT_TYPES
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"3bal3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentStream", ()=>instrumentStream);
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _utilsJs1 = require("./utils.js");
/**
 * State object used to accumulate information from a stream of OpenAI events/chunks.
 */ /**
 * Processes tool calls from a chat completion chunk delta.
 * Follows the pattern: accumulate by index, then convert to array at the end.
 *
 * @param toolCalls - Array of tool calls from the delta.
 * @param state - The current streaming state to update.
 *
 *  @see https://platform.openai.com/docs/guides/function-calling#streaming
 */ function processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === undefined || !toolCall.function) continue;
        // Initialize tool call if this is the first chunk for this index
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            // Accumulate function arguments from subsequent chunks
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
/**
 * Processes a single OpenAI ChatCompletionChunk event, updating the streaming state.
 *
 * @param chunk - The ChatCompletionChunk event to process.
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 */ function processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        // For stream responses, the input tokens remain constant across all events in the stream.
        // Output tokens, however, are only finalized in the last event.
        // Since we can't guarantee that the last event will include usage data or even be a typed event,
        // we update the output token values on every event that includes them.
        // This ensures that output token usage is always set, even if the final event lacks it.
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            // Handle tool calls from delta
            if (choice.delta?.tool_calls) processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
/**
 * Processes a single OpenAI Responses API streaming event, updating the streaming state and span.
 *
 * @param streamEvent - The event to process (may be an error or unknown object).
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 * @param span - The span to update with error status if needed.
 */ function processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: "internal_error"
        });
        (0, _exportsJs.captureException)(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!(0, _constantsJs.RESPONSE_EVENT_TYPES).includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    // Handle output text delta
    if (recordOutputs) {
        // Handle tool call events for Responses API
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            // For stream responses, the input tokens remain constant across all events in the stream.
            // Output tokens, however, are only finalized in the last event.
            // Since we can't guarantee that the last event will include usage data or even be a typed event,
            // we update the output token values on every event that includes them.
            // This ensures that output token usage is always set, even if the final event lacks it.
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
/**
 * Instruments a stream of OpenAI events, updating the provided span with relevant attributes and
 * optionally recording output text. This function yields each event from the input stream as it is processed.
 *
 * @template T - The type of events in the stream.
 * @param stream - The async iterable stream of events to instrument.
 * @param span - The span to add attributes to and to finish at the end of the stream.
 * @param recordOutputs - Whether to record output text fragments in the span.
 * @returns An async generator yielding each event from the input stream.
 */ async function* instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: undefined,
        completionTokens: undefined,
        totalTokens: undefined,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ((0, _utilsJs1.isChatCompletionChunk)(event)) processChatCompletionChunk(event, state, recordOutputs);
            else if ((0, _utilsJs1.isResponsesApiStreamEvent)(event)) processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        (0, _utilsJs.endStreamSpan)(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}

},{"../../exports.js":"9zd3A","../spanstatus.js":"cq3xe","../ai/utils.js":"19wr8","./constants.js":"d7exr","./utils.js":"47J21","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"47J21":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addResponseAttributes", ()=>addResponseAttributes);
parcelHelpers.export(exports, "extractRequestParameters", ()=>extractRequestParameters);
parcelHelpers.export(exports, "isChatCompletionChunk", ()=>isChatCompletionChunk);
parcelHelpers.export(exports, "isResponsesApiStreamEvent", ()=>isResponsesApiStreamEvent);
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
/**
 * Check if streaming event is from the Responses API
 */ function isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
/**
 * Check if streaming event is a chat completion chunk
 */ function isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
/**
 * Add response attributes to a span using duck-typing.
 * Works for Chat Completions, Responses API, Embeddings, and Conversations API responses.
 */ function addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    // Response ID
    if (typeof response.id === "string") attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    // Response model
    if (typeof response.model === "string") attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    // Conversation ID (conversation objects use id as conversation link)
    if (response.object === "conversation" && typeof response.id === "string") attrs[0, _genAiAttributesJs.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    // Token usage — supports both naming conventions (chat: prompt_tokens/completion_tokens, responses: input_tokens/output_tokens)
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    // Finish reasons from choices (chat completions)
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            // Response text from choices
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            // Tool calls from choices
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    // Finish reason from status (responses API)
    if (typeof response.status === "string") // Only set if not already set from choices
    {
        if (!attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        // Response text from output_text (responses API)
        if (typeof response.output_text === "string" && !attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        // Tool calls from output array (responses API)
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
/**
 * Extract conversation ID from request parameters
 * Supports both Conversations API and previous_response_id chaining
 * @see https://platform.openai.com/docs/guides/conversation-state
 */ function extractConversationId(params) {
    // Conversations API: conversation parameter (e.g., "conv_...")
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    // Responses chaining: previous_response_id links to parent response
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return undefined;
}
/**
 * Extract request parameters including model settings and conversation context
 */ function extractRequestParameters(params) {
    const attributes = {
        [(0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE)]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    // Capture conversation ID for linking messages across API calls
    const conversationId = extractConversationId(params);
    if (conversationId) attributes[0, _genAiAttributesJs.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}

},{"../ai/gen-ai-attributes.js":"6VSO0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"e0CxK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentAnthropicAiClient", ()=>instrumentAnthropicAiClient);
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _streamingJs = require("./streaming.js");
var _utilsJs1 = require("./utils.js");
/**
 * Extract request attributes from method arguments
 */ function extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [(0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE)]: "anthropic",
        [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: operationName,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") // models.retrieve(model-id) and models.get(model-id)
    attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 */ function addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = (0, _utilsJs1.messagesFromParams)(params);
    (0, _utilsJs1.setMessagesAttribute)(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_PROMPT_ATTRIBUTE)]: JSON.stringify(params.prompt)
    });
}
/**
 * Add content attributes when recordOutputs is enabled
 */ function addContentAttributes(span, response) {
    // Messages.create
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [(0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE)]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [(0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE)]: JSON.stringify(toolCalls)
            });
        }
    }
    // Completions.create
    if ("completion" in response) span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE)]: response.completion
    });
    // Models.countTokens
    if ("input_tokens" in response) span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE)]: JSON.stringify(response.input_tokens)
    });
}
/**
 * Add basic metadata attributes from the response
 */ function addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE)]: response.id,
            [(0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE)]: response.model
        });
        if ("usage" in response && response.usage) (0, _utilsJs.setTokenUsageAttributes)(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
/**
 * Add response attributes to spans
 */ function addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    // capture error, do not add attributes if error (they shouldn't exist)
    if ("type" in response && response.type === "error") {
        (0, _utilsJs1.handleResponseError)(span, response);
        return;
    }
    // Private response attributes that are only recorded if recordOutputs is true.
    if (recordOutputs) addContentAttributes(span, response);
    // Add basic metadata attributes
    addMetadataAttributes(span, response);
}
/**
 * Handle common error catching and reporting for streaming requests
 */ function handleStreamingError(error, span, methodPath) {
    (0, _exportsJs.captureException)(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
/**
 * Handle streaming cases with common logic
 */ function handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    // messages.stream() always returns a sync MessageStream, even with stream: true param
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = (0, _traceJs.startSpanManual)(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) addPrivateRequestAttributes(span, params, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return (0, _streamingJs.instrumentAsyncIterableStream)(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return (0, _utilsJs.wrapPromiseWithMethods)(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return (0, _traceJs.startSpanManual)(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) addPrivateRequestAttributes(span, params, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return (0, _streamingJs.instrumentMessageStream)(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return handleStreamingError(error, span, methodPath);
        }
    });
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : undefined;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = (0, _traceJs.startSpan)({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) addPrivateRequestAttributes(span, params, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
                return originalResult.then((result)=>{
                    addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return (0, _utilsJs.wrapPromiseWithMethods)(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
/**
 * Create a deep proxy for Anthropic AI client instrumentation
 */ function createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = (0, _utilsJs.buildMethodPath)(currentPath, String(prop));
            const instrumentedMethod = (0, _constantsJs.ANTHROPIC_METHOD_REGISTRY)[methodPath];
            if (typeof value === "function" && instrumentedMethod) return instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") // Bind non-instrumented functions to preserve the original `this` context,
            return value.bind(obj);
            if (value && typeof value === "object") return createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an Anthropic AI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends object
 * @param client - The Anthropic AI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 */ function instrumentAnthropicAiClient(anthropicAiClient, options) {
    return createDeepProxy(anthropicAiClient, "", (0, _utilsJs.resolveAIRecordingOptions)(options));
}

},{"../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../spanstatus.js":"cq3xe","../trace.js":"jFgPq","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","./constants.js":"eF75w","./streaming.js":"4CX6c","./utils.js":"6Pkfq","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"eF75w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANTHROPIC_AI_INTEGRATION_NAME", ()=>ANTHROPIC_AI_INTEGRATION_NAME);
parcelHelpers.export(exports, "ANTHROPIC_METHOD_REGISTRY", ()=>ANTHROPIC_METHOD_REGISTRY);
const ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
// https://docs.anthropic.com/en/api/messages
// https://docs.anthropic.com/en/api/models-list
const ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"4CX6c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentAsyncIterableStream", ()=>instrumentAsyncIterableStream);
parcelHelpers.export(exports, "instrumentMessageStream", ()=>instrumentMessageStream);
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _utilsJs = require("../ai/utils.js");
var _utilsJs1 = require("./utils.js");
/**
 * State object used to accumulate information from a stream of Anthropic AI events.
 */ /**
 * Checks if an event is an error event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 * @returns Whether an error occurred
 */ function isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") // If the event is an error, set the span status and capture the error
    // These error events are not rejected by the API by default, but are sent as metadata of the response
    {
        if (event.type === "error") {
            span.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: (0, _utilsJs1.mapAnthropicErrorToStatusMessage)(event.error?.type)
            });
            (0, _exportsJs.captureException)(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
/**
 * Processes the message metadata of an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 */ function handleMessageMetadata(event, state) {
    // The token counts shown in the usage field of the message_delta event are cumulative.
    // @see https://docs.anthropic.com/en/docs/build-with-claude/streaming#event-types
    if (event.type === "message_delta" && event.usage) {
        if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
/**
 * Handle start of a content block (e.g., tool_use)
 */ function handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
/**
 * Handle deltas of a content block, including input_json_delta for tool_use
 */ function handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    // Accumulate tool_use input JSON deltas only when we have an index and an active tool block
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    // Accumulate streamed response text regardless of index
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
/**
 * Handle stop of a content block; finalize tool_use entries
 */ function handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete state.activeToolBlocks[event.index];
}
/**
 * Processes an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = isErrorEvent(event, span);
    if (isError) return;
    handleMessageMetadata(event, state);
    // Tool call events are sent via 3 separate events:
    // - content_block_start (start of the tool call)
    // - content_block_delta (delta aka input of the tool call)
    // - content_block_stop (end of the tool call)
    // We need to handle them all to capture the full tool call.
    handleContentBlockStart(event, state);
    handleContentBlockDelta(event, state, recordOutputs);
    handleContentBlockStop(event, state);
}
/**
 * Instruments an async iterable stream of Anthropic events, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each event from the input stream unchanged.
 */ async function* instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        (0, _utilsJs.endStreamSpan)(span, state, recordOutputs);
    }
}
/**
 * Instruments a MessageStream by registering event handlers and preserving the original stream API.
 */ function instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        processEvent(event, state, recordOutputs, span);
    });
    // The event fired when a message is done being streamed by the API. Corresponds to the message_stop SSE event.
    // @see https://github.com/anthropics/anthropic-sdk-typescript/blob/d3be31f5a4e6ebb4c0a2f65dbb8f381ae73a9166/helpers.md?plain=1#L42-L44
    stream.on("message", ()=>{
        (0, _utilsJs.endStreamSpan)(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        (0, _exportsJs.captureException)(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}

},{"../../exports.js":"9zd3A","../spanstatus.js":"cq3xe","../ai/utils.js":"19wr8","./utils.js":"6Pkfq","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6Pkfq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleResponseError", ()=>handleResponseError);
parcelHelpers.export(exports, "mapAnthropicErrorToStatusMessage", ()=>mapAnthropicErrorToStatusMessage);
parcelHelpers.export(exports, "messagesFromParams", ()=>messagesFromParams);
parcelHelpers.export(exports, "setMessagesAttribute", ()=>setMessagesAttribute);
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
/**
 * Set the messages and messages original length attributes.
 * Extracts system instructions before truncation.
 */ function setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions, filteredMessages } = (0, _utilsJs.extractSystemInstructions)(messages);
    if (systemInstructions) span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE)]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [(0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ATTRIBUTE)]: enableTruncation ? (0, _utilsJs.getTruncatedJsonString)(filteredMessages) : (0, _utilsJs.getJsonString)(filteredMessages),
        [(0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE)]: filteredLength
    });
}
const ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
/**
 * Map an Anthropic API error type to a SpanStatusType value.
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
/**
 * Capture error information from the response
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: mapAnthropicErrorToStatusMessage(response.error.type)
        });
        (0, _exportsJs.captureException)(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
/**
 * Include the system prompt in the messages list, if available
 */ function messagesFromParams(params) {
    const { system, messages, input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : undefined;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}

},{"../../exports.js":"9zd3A","../spanstatus.js":"cq3xe","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fGcNz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractModel", ()=>extractModel);
parcelHelpers.export(exports, "instrumentGoogleGenAIClient", ()=>instrumentGoogleGenAIClient);
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _handleCallbackErrorsJs = require("../../utils/handleCallbackErrors.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _streamingJs = require("./streaming.js");
var _utilsJs1 = require("./utils.js");
/* eslint-disable max-lines */ /**
 * Extract model from parameters or chat context object
 * For chat instances, the model is available on the chat object as 'model' (older versions) or 'modelVersion' (newer versions)
 */ function extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    // Try to get model from chat context object (chat instance has model property)
    if (context && typeof context === "object") {
        const contextObj = context;
        // Check for 'model' property (older versions, and streaming)
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        // Check for 'modelVersion' property (newer versions)
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
/**
 * Extract generation config parameters
 */ function extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
/**
 * Extract request attributes from method arguments
 * Builds the base attributes for span creation including system info, model, and config
 */ function extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [(0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE)]: (0, _constantsJs.GOOGLE_GENAI_SYSTEM_NAME),
        [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: operationName,
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = extractModel(params, context);
        // Extract generation config parameters
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, extractConfigAttributes(config));
            // Extract available tools from config
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = extractModel({}, context);
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 * Handles different parameter formats for different Google GenAI methods.
 */ function addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute((0, _genAiAttributesJs.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE), typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    // config.systemInstruction: ContentUnion
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...(0, _utilsJs1.contentUnionToMessages)(params.config.systemInstruction, "system"));
    // For chats.create: history contains the conversation history
    if ("history" in params) messages.push(...(0, _utilsJs1.contentUnionToMessages)(params.history, "user"));
    // For models.generateContent: ContentListUnion
    if ("contents" in params) messages.push(...(0, _utilsJs1.contentUnionToMessages)(params.contents, "user"));
    // For chat.sendMessage: message can be PartListUnion
    if ("message" in params) messages.push(...(0, _utilsJs1.contentUnionToMessages)(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions, filteredMessages } = (0, _utilsJs.extractSystemInstructions)(messages);
        if (systemInstructions) span.setAttribute((0, _genAiAttributesJs.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE), systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE)]: filteredLength,
            [(0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ATTRIBUTE)]: enableTruncation ? (0, _utilsJs.getTruncatedJsonString)(filteredMessages) : (0, _utilsJs.getJsonString)(filteredMessages)
        });
    }
}
/**
 * Add response attributes from the Google GenAI response
 * @see https://github.com/googleapis/js-genai/blob/v1.19.0/src/types.ts#L2313
 */ function addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), response.modelVersion);
    // Add usage metadata if present
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE)]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE)]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE)]: usage.totalTokenCount
        });
    }
    // Add response text if recordOutputs is enabled
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE)]: responseTexts.join("")
        });
    }
    // Add tool calls if recordOutputs is enabled
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [(0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE)]: JSON.stringify(functionCalls)
        });
    }
}
/**
 * Instrument any async or synchronous genai method with Sentry spans
 * Handles operations like models.generateContent and chat.sendMessage and chats.create
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            // Check if this is a streaming method
            if (instrumentedMethod.streaming) // Use startSpanManual for streaming methods to control span lifecycle
            return (0, _traceJs.startSpanManual)({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) addPrivateRequestAttributes(span, params, isEmbeddings, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return (0, _streamingJs.instrumentStream)(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                        message: "internal_error"
                    });
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            // Single span for both sync and async operations
            return (0, _traceJs.startSpan)({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) addPrivateRequestAttributes(span, params, isEmbeddings, (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation));
                return (0, _handleCallbackErrorsJs.handleCallbackErrors)(()=>target.apply(context, args), (error)=>{
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    // Only add response attributes for content-producing methods, not for embeddings
                    if (!isEmbeddings) addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
/**
 * Create a deep proxy for Google GenAI client instrumentation
 * Recursively instruments methods and handles special cases like chats.create
 */ function createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = (0, _utilsJs.buildMethodPath)(currentPath, String(prop));
            const instrumentedMethod = (0, _constantsJs.GOOGLE_GENAI_METHOD_REGISTRY)[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                // If an operation is specified, we need to instrument the method itself
                const wrappedMethod = instrumentedMethod.operation ? instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                // If a proxyResultPath is specified, we need to proxy the result of the method.
                // Note: This currently only properly handles synchronous methods. For async methods,
                // the Promise itself would be proxied instead of the resolved value. Currently we
                // don't have a case where this is needed, so I'll keep it simple for now.
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") // Bind non-instrumented functions to preserve the original `this` context
            return value.bind(t);
            if (value && typeof value === "object") return createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument a Google GenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends client object
 * @param client - The Google GenAI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 *
 * @example
 * ```typescript
 * import { GoogleGenAI } from '@google/genai';
 * import { instrumentGoogleGenAIClient } from '@sentry/core';
 *
 * const genAI = new GoogleGenAI({ apiKey: process.env.GOOGLE_GENAI_API_KEY });
 * const instrumentedClient = instrumentGoogleGenAIClient(genAI);
 *
 * // Now both chats.create and sendMessage will be instrumented
 * const chat = instrumentedClient.chats.create({ model: 'gemini-1.5-pro' });
 * const response = await chat.sendMessage({ message: 'Hello' });
 * ```
 */ function instrumentGoogleGenAIClient(client, options) {
    return createDeepProxy(client, "", (0, _utilsJs.resolveAIRecordingOptions)(options));
}

},{"../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../spanstatus.js":"cq3xe","../trace.js":"jFgPq","../../utils/handleCallbackErrors.js":"2pTms","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","./constants.js":"3RH7Y","./streaming.js":"7rJSK","./utils.js":"92LXE","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"3RH7Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GOOGLE_GENAI_INTEGRATION_NAME", ()=>GOOGLE_GENAI_INTEGRATION_NAME);
parcelHelpers.export(exports, "GOOGLE_GENAI_METHOD_REGISTRY", ()=>GOOGLE_GENAI_METHOD_REGISTRY);
parcelHelpers.export(exports, "GOOGLE_GENAI_SYSTEM_NAME", ()=>GOOGLE_GENAI_SYSTEM_NAME);
const GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
// https://ai.google.dev/api/rest/v1/models/generateContent
// https://ai.google.dev/api/rest/v1/chats/sendMessage
// https://googleapis.github.io/js-genai/release_docs/classes/models.Models.html#generatecontentstream
// https://googleapis.github.io/js-genai/release_docs/classes/chats.Chat.html#sendmessagestream
const GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
// Constants for internal use
const GOOGLE_GENAI_SYSTEM_NAME = "google_genai";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"7rJSK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentStream", ()=>instrumentStream);
var _exportsJs = require("../../exports.js");
var _spanstatusJs = require("../spanstatus.js");
var _utilsJs = require("../ai/utils.js");
/**
 * State object used to accumulate information from a stream of Google GenAI events.
 */ /**
 * Checks if a response chunk contains an error
 * @param chunk - The response chunk to check
 * @param span - The span to update if error is found
 * @returns Whether an error occurred
 */ function isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
            message: "internal_error"
        });
        (0, _exportsJs.captureException)(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
/**
 * Processes response metadata from a chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 */ function handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
/**
 * Processes candidate content from a response chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 */ function handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
/**
 * Processes a single chunk from the Google GenAI stream
 * @param chunk - The chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || isErrorChunk(chunk, span)) return;
    handleResponseMetadata(chunk, state);
    handleCandidateContent(chunk, state, recordOutputs);
}
/**
 * Instruments an async iterable stream of Google GenAI response chunks, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each chunk from the input stream unchanged.
 */ async function* instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        (0, _utilsJs.endStreamSpan)(span, state, recordOutputs);
    }
}

},{"../../exports.js":"9zd3A","../spanstatus.js":"cq3xe","../ai/utils.js":"19wr8","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"92LXE":[function(require,module,exports) {
// Copied from https://googleapis.github.io/js-genai/release_docs/index.html
/**
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentUnionToMessages", ()=>contentUnionToMessages);
function contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role,
            content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content)=>contentUnionToMessages(content, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role
        }
    ];
    return [
        {
            role,
            content
        }
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"k2Iuh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLangChainCallbackHandler", ()=>createLangChainCallbackHandler);
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
var _utilsJs1 = require("./utils.js");
/* eslint-disable max-lines */ /**
 * Creates a Sentry callback handler for LangChain
 * Returns a plain object that LangChain will call via duck-typing
 *
 * This is a stateful handler that tracks spans across multiple LangChain executions.
 */ function createLangChainCallbackHandler(options = {}) {
    const { recordInputs, recordOutputs } = (0, _utilsJs.resolveAIRecordingOptions)(options);
    const enableTruncation = (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation);
    // Internal state - single instance tracks all spans
    const spanMap = new Map();
    /**
   * Exit a span and clean up
   */ const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    /**
   * Handler for LLM Start
   * This handler will be called by LangChain's callback handler when an LLM event is detected.
   */ const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: undefined,
        lc_attributes: undefined,
        lc_aliases: undefined,
        lc_serializable_keys: undefined,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = (0, _utilsJs1.getInvocationParams)(tags);
            const attributes = (0, _utilsJs1.extractLLMRequestAttributes)(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            (0, _traceJs.startSpanManual)({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...(0, _utilsJs1.getAgentNameFromMetadata)(metadata),
                    ...attributes,
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = (0, _utilsJs1.getInvocationParams)(tags);
            const attributes = (0, _utilsJs1.extractChatModelRequestAttributes)(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = (0, _utilsJs1.extractToolDefinitions)(extraParams);
            if (toolDefsJson) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            (0, _traceJs.startSpanManual)({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...(0, _utilsJs1.getAgentNameFromMetadata)(metadata),
                    ...attributes,
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = (0, _utilsJs1.extractLlmResponseAttributes)(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            (0, _exportsJs.captureException)(error, {
                mechanism: {
                    handled: false,
                    type: `${(0, _constantsJs.LANGCHAIN_ORIGIN)}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            // Skip chain spans when inside an agent context (createReactAgent).
            // The agent already creates an invoke_agent span; internal chain steps
            // (ChannelWrite, Branch, prompt, etc.) are noise.
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            (0, _traceJs.startSpanManual)({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                // Add outputs if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            (0, _exportsJs.captureException)(error, {
                mechanism: {
                    handled: false,
                    type: `${(0, _constantsJs.LANGCHAIN_ORIGIN)}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            // Skip tool spans when inside an agent context (createReactAgent).
            // Tool spans are created by wrapToolsWithSpans with richer attributes.
            if (metadata?.__sentry_langgraph__) return;
            // runName is set to tool.name by LangChain's StructuredTool.call()
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...(0, _utilsJs1.getAgentNameFromMetadata)(metadata),
                [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: (0, _constantsJs.LANGCHAIN_ORIGIN),
                [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: "execute_tool",
                [(0, _genAiAttributesJs.GEN_AI_TOOL_NAME_ATTRIBUTE)]: toolName
            };
            if (recordInputs) attributes[0, _genAiAttributesJs.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            (0, _traceJs.startSpanManual)({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    // LangChain tools may return ToolMessage objects — extract the content
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [(0, _genAiAttributesJs.GEN_AI_TOOL_OUTPUT_ATTRIBUTE)]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            (0, _exportsJs.captureException)(error, {
                mechanism: {
                    handled: false,
                    type: `${(0, _constantsJs.LANGCHAIN_ORIGIN)}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}

},{"../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../spanstatus.js":"cq3xe","../trace.js":"jFgPq","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","./constants.js":"b2hG3","./utils.js":"7WZ0j","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"b2hG3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGCHAIN_INTEGRATION_NAME", ()=>LANGCHAIN_INTEGRATION_NAME);
parcelHelpers.export(exports, "LANGCHAIN_ORIGIN", ()=>LANGCHAIN_ORIGIN);
parcelHelpers.export(exports, "ROLE_MAP", ()=>ROLE_MAP);
const LANGCHAIN_INTEGRATION_NAME = "LangChain";
const LANGCHAIN_ORIGIN = "auto.ai.langchain";
const ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"7WZ0j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractChatModelRequestAttributes", ()=>extractChatModelRequestAttributes);
parcelHelpers.export(exports, "extractLLMRequestAttributes", ()=>extractLLMRequestAttributes);
parcelHelpers.export(exports, "extractLlmResponseAttributes", ()=>extractLlmResponseAttributes);
parcelHelpers.export(exports, "extractToolDefinitions", ()=>extractToolDefinitions);
parcelHelpers.export(exports, "getAgentNameFromMetadata", ()=>getAgentNameFromMetadata);
parcelHelpers.export(exports, "getInvocationParams", ()=>getInvocationParams);
parcelHelpers.export(exports, "normalizeLangChainMessages", ()=>normalizeLangChainMessages);
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _mediaStrippingJs = require("../ai/mediaStripping.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
/**
 * Assigns an attribute only when the value is neither `undefined` nor `null`.
 *
 * We keep this tiny helper because call sites are repetitive and easy to miswrite.
 * It also preserves falsy-but-valid values like `0` and `""`.
 */ const setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
/**
 * Like `setIfDefined`, but converts the value with `Number()` and skips only when the
 * result is `NaN`. This ensures numeric 0 makes it through (unlike truthy checks).
 */ const setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
/**
 * Converts a value to a string. Avoids double-quoted JSON strings where a plain
 * string is desired, but still handles objects/arrays safely.
 */ function asString(v) {
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
/**
 * Converts message content to a string, stripping inline media (base64 images, audio, etc.)
 * from multimodal content before stringification so downstream media stripping can't miss it.
 *
 * @example
 * // String content passes through unchanged:
 * normalizeContent("Hello") // => "Hello"
 *
 * // Multimodal array content — media is replaced with "[Blob substitute]" before JSON.stringify:
 * normalizeContent([
 *   { type: "text", text: "What color?" },
 *   { type: "image_url", image_url: { url: "data:image/png;base64,iVBOR..." } }
 * ])
 * // => '[{"type":"text","text":"What color?"},{"type":"image_url","image_url":{"url":"[Blob substitute]"}}]'
 *
 * // Without this, asString() would JSON.stringify the raw array and the base64 blob
 * // would end up in span attributes, since downstream stripping only works on objects.
 */ function normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && (0, _mediaStrippingJs.isContentMedia)(part) ? (0, _mediaStrippingJs.stripInlineMediaFromSingleMessage)(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return asString(v);
}
/**
 * Normalizes a single role token to our canonical set.
 *
 * @param role Incoming role value (free-form, any casing)
 * @returns Canonical role: 'user' | 'assistant' | 'system' | 'function' | 'tool' | <passthrough>
 */ function normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return (0, _constantsJs.ROLE_MAP)[normalized] ?? normalized;
}
/**
 * Infers a role from a LangChain message constructor name.
 *
 * Checks for substrings like "System", "Human", "AI", etc.
 */ function normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
/**
 * Returns invocation params from a LangChain `tags` object.
 *
 * LangChain often passes runtime parameters (model, temperature, etc.) via the
 * `tags.invocation_params` bag. If `tags` is an array (LangChain sometimes uses
 * string tags), we return `undefined`.
 *
 * @param tags LangChain tags (string[] or record)
 * @returns The `invocation_params` object, if present
 */ function getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return undefined;
    return tags.invocation_params;
}
/**
 * Normalizes a heterogeneous set of LangChain messages to `{ role, content }`.
 *
 * Why so many branches? LangChain messages can arrive in several shapes:
 *  - Message classes with `_getType()` (most reliable)
 *  - Classes with meaningful constructor names (e.g. `SystemMessage`)
 *  - Plain objects with `type`, or `{ role, content }`
 *  - Serialized format with `{ lc: 1, id: [...], kwargs: { content } }`
 * We preserve the prioritization to minimize behavioral drift.
 *
 * @param messages Mixed LangChain messages
 * @returns Array of normalized `{ role, content }`
 */ function normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        // 1) Prefer _getType() when present
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: normalizeMessageRole(messageType),
                content: normalizeContent(message.content)
            };
        }
        // 2) Serialized LangChain format (lc: 1) - check before constructor name
        // This is more reliable than constructor.name which can be lost during serialization
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: normalizeMessageRole(role),
                content: normalizeContent(message.kwargs?.content)
            };
        }
        // 3) Then objects with `type`
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: normalizeMessageRole(role),
                content: normalizeContent(message.content)
            };
        }
        // 4) Then objects with `{ role, content }` - check before constructor name
        // Plain objects have constructor.name="Object" which would incorrectly default to "user"
        if (message.role) return {
            role: normalizeMessageRole(String(message.role)),
            content: normalizeContent(message.content)
        };
        // 5) Then try constructor name (SystemMessage / HumanMessage / ...)
        // Only use this if we haven't matched a more specific case
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: normalizeMessageRole(normalizeRoleNameFromCtor(ctor)),
            content: normalizeContent(message.content)
        };
        // 6) Fallback: treat as user text
        return {
            role: "user",
            content: normalizeContent(message.content)
        };
    });
}
/**
 * Extracts request attributes common to both LLM and ChatModel invocations.
 *
 * Source precedence:
 * 1) `invocationParams` (highest)
 * 2) `langSmithMetadata`
 *
 * Numeric values are set even when 0 (e.g. `temperature: 0`), but skipped if `NaN`.
 */ function extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    // Get kwargs if available (from constructor type)
    const kwargs = "kwargs" in serialized ? serialized.kwargs : undefined;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE), temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE), maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_TOP_P_ATTRIBUTE), topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE), frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE), presencePenalty);
    // LangChain uses `stream`. We only set the attribute if the key actually exists
    // (some callbacks report `false` even on streamed requests, this stems from LangChain's callback handler).
    if (invocationParams && "stream" in invocationParams) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_REQUEST_STREAM_ATTRIBUTE), Boolean(invocationParams.stream));
    return attrs;
}
/**
 * Small helper to assemble boilerplate attributes shared by both request extractors.
 * Always uses 'chat' as the operation type for all LLM and chat model operations.
 */ function baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [(0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE)]: asString(system ?? "langchain"),
        [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: "chat",
        [(0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE)]: asString(modelName),
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: (0, _constantsJs.LANGCHAIN_ORIGIN),
        ...extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
/**
 * Extracts attributes for plain LLM invocations (string prompts).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain LLM operations are treated as chat operations.
 * - When `recordInputs` is true, string prompts are wrapped into `{role:"user"}`
 *   messages to align with the chat schema used elsewhere.
 */ function extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE), prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ATTRIBUTE), enableTruncation ? (0, _utilsJs.getTruncatedJsonString)(messages) : (0, _utilsJs.getJsonString)(messages));
    }
    return attrs;
}
/**
 * Extracts attributes for ChatModel invocations (array-of-arrays of messages).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain chat model operations are chat operations.
 * - We flatten LangChain's `LangChainMessage[][]` and normalize shapes into a
 *   consistent `{ role, content }` array when `recordInputs` is true.
 * - Provider system value falls back to `serialized.id?.[2]`.
 */ function extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions, filteredMessages } = (0, _utilsJs.extractSystemInstructions)(normalized);
        if (systemInstructions) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE), systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE), filteredLength);
        setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ATTRIBUTE), enableTruncation ? (0, _utilsJs.getTruncatedJsonString)(filteredMessages) : (0, _utilsJs.getJsonString)(filteredMessages));
    }
    return attrs;
}
/**
 * Extracts tool calls from generations and records them on the span attributes.
 * Prefers message.tool_calls (LangChain's normalized format). Falls back to
 * scanning message.content for Anthropic-style tool_use items in older versions
 * where tool_calls may not be populated.
 */ function addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            // Fallback for older LangChain versions: scan message.content for Anthropic-style tool_use
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), asString(toolCalls));
}
/**
 * Adds token usage attributes, supporting both OpenAI (`tokenUsage`) and Anthropic (`usage`) formats.
 * - Preserve zero values (0 tokens) by avoiding truthy checks.
 * - Compute a total for Anthropic when not explicitly provided.
 * - Include cache token metrics when present.
 */ function addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), tokenUsage.promptTokens);
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), tokenUsage.completionTokens);
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), anthropicUsage.input_tokens);
        setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), anthropicUsage.output_tokens);
        // Compute total when not provided by the provider.
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), total);
        // Extra Anthropic cache metrics (present only when caching is enabled)
        if (anthropicUsage.cache_creation_input_tokens !== undefined) setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE), anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== undefined) setNumberIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE), anthropicUsage.cache_read_input_tokens);
    }
}
/**
 * Extracts response-related attributes based on a `LangChainLLMResult`.
 *
 * - Records finish reasons when present on generations (e.g., OpenAI)
 * - When `recordOutputs` is true, captures textual response content and any
 *   tool calls.
 * - Also propagates model name (`model_name` or `model`), response `id`, and
 *   `stop_reason` (for providers that use it).
 */ function extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            // v1 uses generationInfo.finish_reason
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            // v0.3+ uses generation_info.finish_reason
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), asString(finishReasons));
        // Tool calls metadata (names, IDs) are not PII, so capture them regardless of recordOutputs
        addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), asString(texts));
        }
    }
    addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    // Extract from v1 generations structure if available
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    // Provider model identifier: `model_name` (OpenAI-style) or `model` (others)
    // v1 stores this in message.response_metadata.model_name
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), modelName);
    // Response ID: v1 stores this in message.id
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_ID_ATTRIBUTE), responseId);
    // Stop reason: v1 stores this in message.response_metadata.finish_reason
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) setIfDefined(attrs, (0, _genAiAttributesJs.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE), asString(stopReason));
    return attrs;
}
function getAgentNameFromMetadata(metadata) {
    const attrs = {};
    // lc_agent_name is injected by instrumentCompiledGraphInvoke (langgraph integration)
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[0, _genAiAttributesJs.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function extractToolDefinitions(extraParams) {
    const tools = (extraParams?.invocation_params)?.tools ?? (extraParams?.options)?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return undefined;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}

},{"../../semanticAttributes.js":"CCqFC","../ai/gen-ai-attributes.js":"6VSO0","../ai/mediaStripping.js":"adCrc","../ai/utils.js":"19wr8","./constants.js":"b2hG3","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"gcVGc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentCreateReactAgent", ()=>instrumentCreateReactAgent);
parcelHelpers.export(exports, "instrumentLangGraph", ()=>instrumentLangGraph);
parcelHelpers.export(exports, "instrumentStateGraphCompile", ()=>instrumentStateGraphCompile);
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _indexJs = require("../langchain/index.js");
var _utilsJs1 = require("../langchain/utils.js");
var _constantsJs = require("./constants.js");
var _utilsJs2 = require("./utils.js");
let _insideCreateReactAgent = false;
const SENTRY_PATCHED = "__sentry_patched__";
/**
 * Instruments StateGraph's compile method to create spans for agent creation and invocation
 *
 * Wraps the compile() method to:
 * - Create a `gen_ai.create_agent` span when compile() is called
 * - Automatically wrap the invoke() method on the returned compiled graph with a `gen_ai.invoke_agent` span
 *
 */ function instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = (0, _indexJs.createLangChainCallbackHandler)(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            // Skip when called from within createReactAgent to avoid duplicate instrumentation
            if (_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return (0, _traceJs.startSpan)({
                op: "gen_ai.create_agent",
                name: "create_agent",
                attributes: {
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: (0, _constantsJs.LANGGRAPH_ORIGIN),
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "gen_ai.create_agent",
                    [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: "create_agent"
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    // Extract graph name
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute((0, _genAiAttributesJs.GEN_AI_AGENT_NAME_ATTRIBUTE), compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    // Instrument agent invoke method on the compiled graph
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, undefined, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                        message: "internal_error"
                    });
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
/**
 * Instruments CompiledGraph's invoke method to create spans for agent invocation
 *
 * Creates a `gen_ai.invoke_agent` span when invoke() is called
 */ function instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return (0, _traceJs.startSpan)({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: (0, _constantsJs.LANGGRAPH_ORIGIN),
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: (0, _genAiAttributesJs.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE),
                    [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute((0, _genAiAttributesJs.GEN_AI_PIPELINE_NAME_ATTRIBUTE), graphName);
                        span.setAttribute((0, _genAiAttributesJs.GEN_AI_AGENT_NAME_ATTRIBUTE), graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute((0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE), modelName);
                    // Extract thread_id from the config (second argument)
                    // LangGraph uses config.configurable.thread_id for conversation/session linking
                    const config = args.length > 1 ? args[1] : undefined;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute((0, _genAiAttributesJs.GEN_AI_CONVERSATION_ID_ATTRIBUTE), threadId);
                    // Inject callback handler and agent name into invoke config
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = (0, _utilsJs2.mergeSentryCallback)(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    // Extract available tools from the graph instance
                    const tools = (0, _utilsJs2.extractToolsFromCompiledGraph)(graphInstance);
                    if (tools) span.setAttribute((0, _genAiAttributesJs.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE), JSON.stringify(tools));
                    // Parse input messages
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = (0, _utilsJs1.normalizeLangChainMessages)(inputMessages);
                        const { systemInstructions, filteredMessages } = (0, _utilsJs.extractSystemInstructions)(normalizedMessages);
                        if (systemInstructions) span.setAttribute((0, _genAiAttributesJs.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE), systemInstructions);
                        const enableTruncation = (0, _utilsJs.shouldEnableTruncation)(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [(0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ATTRIBUTE)]: enableTruncation ? (0, _utilsJs.getTruncatedJsonString)(filteredMessages) : (0, _utilsJs.getJsonString)(filteredMessages),
                            [(0, _genAiAttributesJs.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE)]: filteredLength
                        });
                    }
                    // Call original invoke
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) (0, _utilsJs2.setResponseAttributes)(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                        message: "internal_error"
                    });
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
/**
 * Instruments createReactAgent to create invoke_agent and execute_tool spans.
 */ function instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = (0, _utilsJs.resolveAIRecordingOptions)(options);
    const sentryHandler = (0, _indexJs.createLangChainCallbackHandler)(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = (0, _utilsJs2.extractLLMFromParams)(args);
            const agentName = (0, _utilsJs2.extractAgentNameFromParams)(args);
            // Wrap tools with execute_tool spans (direct access gives us name, type, description)
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) (0, _utilsJs2.wrapToolsWithSpans)(params.tools, resolvedOptions, agentName ?? undefined);
            // Suppress StateGraph.compile instrumentation inside createReactAgent
            _insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                _insideCreateReactAgent = false;
            }
            // Wrap invoke() on the returned compiled graph
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
/**
 * Directly instruments a StateGraph instance to add tracing spans
 *
 * This function can be used to manually instrument LangGraph StateGraph instances
 * in environments where automatic instrumentation is not available or desired.
 *
 * @param stateGraph - The StateGraph instance to instrument
 * @param options - Optional configuration for recording inputs/outputs
 *
 * @example
 * ```typescript
 * import { instrumentLangGraph } from '@sentry/cloudflare';
 * import { StateGraph } from '@langchain/langgraph';
 *
 * const graph = new StateGraph(MessagesAnnotation)
 *   .addNode('agent', mockLlm)
 *   .addEdge(START, 'agent')
 *   .addEdge('agent', END);
 *
 * instrumentLangGraph(graph, { recordInputs: true, recordOutputs: true });
 * const compiled = graph.compile({ name: 'my_agent' });
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = instrumentStateGraphCompile(stateGraph.compile, (0, _utilsJs.resolveAIRecordingOptions)(options));
    return stateGraph;
}

},{"../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../spanstatus.js":"cq3xe","../trace.js":"jFgPq","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","../langchain/index.js":"k2Iuh","../langchain/utils.js":"7WZ0j","./constants.js":"6WY7z","./utils.js":"8M02G","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6WY7z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGGRAPH_INTEGRATION_NAME", ()=>LANGGRAPH_INTEGRATION_NAME);
parcelHelpers.export(exports, "LANGGRAPH_ORIGIN", ()=>LANGGRAPH_ORIGIN);
const LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const LANGGRAPH_ORIGIN = "auto.ai.langgraph";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"8M02G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractAgentNameFromParams", ()=>extractAgentNameFromParams);
parcelHelpers.export(exports, "extractLLMFromParams", ()=>extractLLMFromParams);
parcelHelpers.export(exports, "extractModelMetadata", ()=>extractModelMetadata);
parcelHelpers.export(exports, "extractTokenUsageFromMessage", ()=>extractTokenUsageFromMessage);
parcelHelpers.export(exports, "extractToolCalls", ()=>extractToolCalls);
parcelHelpers.export(exports, "extractToolsFromCompiledGraph", ()=>extractToolsFromCompiledGraph);
parcelHelpers.export(exports, "mergeSentryCallback", ()=>mergeSentryCallback);
parcelHelpers.export(exports, "setResponseAttributes", ()=>setResponseAttributes);
parcelHelpers.export(exports, "wrapToolsWithSpans", ()=>wrapToolsWithSpans);
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _spanstatusJs = require("../spanstatus.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../langchain/utils.js");
var _constantsJs = require("./constants.js");
/**
 * Extract LLM model object from createReactAgent params
 */ function extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
/**
 * Extract agent name from createReactAgent params
 */ function extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
/**
 * Wraps an array of LangChain tools so each invocation creates a gen_ai.execute_tool span.
 *
 * Wraps each tool's invoke() method in place. A marker prevents double-wrapping.
 */ function wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : undefined;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: (0, _constantsJs.LANGGRAPH_ORIGIN),
                    [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: (0, _genAiAttributesJs.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE),
                    [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: "execute_tool",
                    [(0, _genAiAttributesJs.GEN_AI_TOOL_NAME_ATTRIBUTE)]: toolName,
                    [(0, _genAiAttributesJs.GEN_AI_TOOL_TYPE_ATTRIBUTE)]: "function"
                };
                // Read agent name from LangChain's propagated config metadata at call time,
                // so shared tools get the correct agent name for each invocation
                const callConfig = args[1];
                const callAgentName = (callConfig?.metadata)?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[0, _genAiAttributesJs.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[0, _genAiAttributesJs.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                // LangGraph ToolNode passes { name, args, id, type: "tool_call" }
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[0, _genAiAttributesJs.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[0, _genAiAttributesJs.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {
                        // skip if not serializable
                        }
                    }
                }
                return (0, _traceJs.startSpan)({
                    op: (0, _genAiAttributesJs.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE),
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            // ToolMessage objects wrap the result in .content
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute((0, _genAiAttributesJs.GEN_AI_TOOL_OUTPUT_ATTRIBUTE), typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {
                        // skip if not serializable
                        }
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: (0, _spanstatusJs.SPAN_STATUS_ERROR),
                            message: "internal_error"
                        });
                        (0, _exportsJs.captureException)(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
/**
 * Extract tool calls from messages
 */ function extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
/**
 * Extract token usage from a message's usage_metadata or response_metadata
 * Returns token counts without setting span attributes
 */ function extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    // Extract from usage_metadata (newer format)
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens,
            outputTokens,
            totalTokens
        };
    }
    // Fallback: Extract from response_metadata.tokenUsage
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens,
        outputTokens,
        totalTokens
    };
}
/**
 * Extract model and finish reason from a message's response_metadata
 */ function extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_MODEL_ATTRIBUTE), metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE), [
            metadata.finish_reason
        ]);
    }
}
/**
 * Extract tools from compiled graph structure
 *
 * Tools are stored in: compiledGraph.builder.nodes.tools.runnable.tools
 */ function extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    // Extract name, description, and schema from each tool's lc_kwargs
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
/**
 * Set response attributes on the span
 */ function setResponseAttributes(span, inputMessages, result) {
    // Extract messages from result
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    // Get new messages (delta between input and output)
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    // Extract and set tool calls from new messages BEFORE normalization
    // (normalization strips tool_calls, so we need to extract them first)
    const toolCalls = extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE), JSON.stringify(toolCalls));
    // Normalize the new messages
    const normalizedNewMessages = (0, _utilsJs.normalizeLangChainMessages)(newMessages);
    span.setAttribute((0, _genAiAttributesJs.GEN_AI_RESPONSE_TEXT_ATTRIBUTE), JSON.stringify(normalizedNewMessages));
    // Accumulate token usage across all messages
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    // Extract metadata from messages
    for (const message of newMessages){
        // Accumulate token usage
        const tokens = extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        // Extract model metadata (last message's metadata wins for model/finish_reason)
        extractModelMetadata(span, message);
    }
    // Set accumulated token usage on span
    if (totalInputTokens > 0) span.setAttribute((0, _genAiAttributesJs.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE), totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute((0, _genAiAttributesJs.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE), totalOutputTokens);
    if (totalTokens > 0) span.setAttribute((0, _genAiAttributesJs.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE), totalTokens);
}
/** Merge `sentryHandler` into a langchain `callbacks` value (`BaseCallbackHandler[]` or `BaseCallbackManager`). */ function mergeSentryCallback(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if (Array.isArray(existing)) {
        if (existing.includes(sentryHandler)) return existing;
        return [
            ...existing,
            sentryHandler
        ];
    }
    const manager = existing;
    if (typeof manager.addHandler === "function") {
        const alreadyAdded = Array.isArray(manager.handlers) && manager.handlers.includes(sentryHandler);
        if (!alreadyAdded) manager.addHandler(sentryHandler);
    }
    return existing;
}

},{"../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../spanstatus.js":"cq3xe","../trace.js":"jFgPq","../ai/gen-ai-attributes.js":"6VSO0","../langchain/utils.js":"7WZ0j","./constants.js":"6WY7z","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"899Ji":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpanBuffer", ()=>SpanBuffer);
var _debugBuildJs = require("../../debug-build.js");
var _debugLoggerJs = require("../../utils/debug-logger.js");
var _timerJs = require("../../utils/timer.js");
var _dynamicSamplingContextJs = require("../dynamicSamplingContext.js");
var _envelopeJs = require("./envelope.js");
var _estimateSizeJs = require("./estimateSize.js");
/**
 * We must not send more than 1000 spans in one envelope.
 * Otherwise the envelope is dropped by Relay.
 */ const MAX_SPANS_PER_ENVELOPE = 1000;
const MAX_TRACE_WEIGHT_IN_BYTES = 5000000;
/**
 * A buffer for serialized streamed span JSON objects that flushes them to Sentry in Span v2 envelopes.
 * Handles per-trace timeout-based flushing, size thresholds, and graceful shutdown.
 * Also handles computation of the Dynamic Sampling Context (DSC) for the trace, if it wasn't yet
 * frozen onto the segment span.
 *
 * For this, we need the reference to the segment span instance, from
 * which we compute the DSC. Doing this in the buffer ensures that we compute the DSC as late as possible,
 * allowing span name and data updates up to this point. Worth noting here that the segment span is likely
 * still active and modifyable when child spans are added to the buffer.
 */ class SpanBuffer {
    /* Bucket spans by their trace id, along with accumulated size and a per-trace flush timeout */ constructor(client, options){
        this._traceBuckets = new Map();
        this._client = client;
        const { maxSpanLimit, flushInterval, maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5000;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            // No need to drain the buffer here as `Client.close()` internally already calls `Client.flush()`
            // which already invokes the `flush` hook and thus drains the buffer.
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: new Set(),
                size: 0,
                timeout: (0, _timerJs.safeUnref)(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += (0, _estimateSizeJs.estimateSerializedSpanSizeInBytes)(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            // we should never get here, given we always add a span when we create a new bucket
            // and delete the bucket once we flush out the trace
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope = (0, _envelopeJs.createStreamedSpanEnvelope)(cleanedSpans, dsc, this._client);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope).then(null, (reason)=>{
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}

},{"../../debug-build.js":"a2zY5","../../utils/debug-logger.js":"6Sybg","../../utils/timer.js":"9j54j","../dynamicSamplingContext.js":"1usYY","./envelope.js":"by3b8","./estimateSize.js":"6fLT9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"by3b8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStreamedSpanEnvelope", ()=>createStreamedSpanEnvelope);
var _dsnJs = require("../../utils/dsn.js");
var _envelopeJs = require("../../utils/envelope.js");
var _isBrowserJs = require("../../utils/isBrowser.js");
/**
 * Creates a span v2 span streaming envelope
 */ function createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = (0, _envelopeJs.getSdkMetadataForEnvelopeHeader)(options._metadata);
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk
        },
        ...!!tunnel && dsn && {
            dsn: (0, _dsnJs.dsnToString)(dsn)
        }
    };
    const inferSetting = options.sendDefaultPii ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...(0, _isBrowserJs.isBrowser)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return (0, _envelopeJs.createEnvelope)(headers, [
        spanContainer
    ]);
}
function dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}

},{"../../utils/dsn.js":"dadDm","../../utils/envelope.js":"fQsVK","../../utils/isBrowser.js":"en9iQ","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"en9iQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
var _nodeJs = require("./node.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, _nodeJs.isNodeEnv)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    const process = (0, _worldwideJs.GLOBAL_OBJ).process;
    return process?.type === "renderer";
}

},{"./node.js":"fe9Wu","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"fe9Wu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeEnv", ()=>isNodeEnv);
parcelHelpers.export(exports, "loadModule", ()=>loadModule);
var _envJs = require("./env.js");
var process = require("98d04653f97218a1");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _envJs.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {
    // no-empty
    }
    return mod;
}

},{"98d04653f97218a1":"3bjyP","./env.js":"6Zp9k","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"3bjyP":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"6Zp9k":[function(require,module,exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDKSource", ()=>getSDKSource);
parcelHelpers.export(exports, "isBrowserBundle", ()=>isBrowserBundle);
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"6fLT9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "estimateSerializedSpanSizeInBytes", ()=>estimateSerializedSpanSizeInBytes);
var _attributesJs = require("../../attributes.js");
/**
 * Estimates the serialized byte size of a {@link SerializedStreamedSpan}.
 *
 * Uses 2 bytes per character as a UTF-16 approximation, and 8 bytes per number.
 * The estimate is intentionally conservative and may be slightly lower than the
 * actual byte size on the wire.
 * We compensate for this by setting the span buffers internal limit well below the limit
 * of how large an actual span v2 envelope may be.
 */ function estimateSerializedSpanSizeInBytes(span) {
    /*
   * Fixed-size fields are pre-computed as a constant for performance:
   * - two timestamps (8 bytes each = 16)
   * - is_segment boolean (5 bytes, assumed false for most spans)
   * - trace_id  – always 32 hex chars (64 bytes)
   * - span_id   – always 16 hex chars (32 bytes)
   * - parent_span_id – 16 hex chars, assumed present for most spans (32 bytes)
   * - status "ok" – most common value (8 bytes)
   * = 156 bytes total base
   */ let weight = 156;
    weight += span.name.length * 2;
    weight += (0, _attributesJs.estimateTypedAttributesSizeInBytes)(span.attributes);
    if (span.links && span.links.length > 0) {
        // Assumption: Links are roughly equal in number of attributes
        // probably not always true but allows us to cut down on runtime
        const firstLink = span.links[0];
        const attributes = firstLink?.attributes;
        // Fixed size 100 due to span_id, trace_id and sampled flag (see above)
        const linkWeight = 100 + (attributes ? (0, _attributesJs.estimateTypedAttributesSizeInBytes)(attributes) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}

},{"../../attributes.js":"gGkrY","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"1SaXE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", ()=>applyAggregateErrorsToEvent);
var _isJs = require("./is.js");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, _isJs.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, _isJs.isInstanceOf)(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, _isJs.isInstanceOf)(childError, Error)) {
            applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

},{"./is.js":"jiTW9","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bQvgk":[function(require,module,exports) {
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBreadcrumbLogLevelFromHttpStatusCode", ()=>getBreadcrumbLogLevelFromHttpStatusCode);
function getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"2tP5i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFetchEndInstrumentationHandler", ()=>addFetchEndInstrumentationHandler);
parcelHelpers.export(exports, "addFetchInstrumentationHandler", ()=>addFetchInstrumentationHandler);
parcelHelpers.export(exports, "parseFetchArgs", ()=>parseFetchArgs);
var _currentScopesJs = require("../currentScopes.js");
var _isJs = require("../utils/is.js");
var _objectJs = require("../utils/object.js");
var _supportsJs = require("../utils/supports.js");
var _timeJs = require("../utils/time.js");
var _worldwideJs = require("../utils/worldwide.js");
var _handlersJs = require("./handlers.js");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, ()=>instrumentFetch(undefined, skipNativeFetchCheck));
    return removeHandler;
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 * Returns a function to remove the handler.
 *
 * Only used internally
 * @hidden
 */ function addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, ()=>instrumentFetch(streamHandler));
    return removeHandler;
}
function instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, _supportsJs.supportsNativeFetch)()) return;
    (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method, url } = parseFetchArgs(args);
            const handlerData = {
                args,
                fetchData: {
                    method,
                    url
                },
                startTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
                // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, _handlersJs.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, _worldwideJs.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, _handlersJs.triggerHandlers)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
                    response
                });
                return response;
            }, (error)=>{
                (0, _handlersJs.triggerHandlers)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
                    error
                });
                if ((0, _isJs.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, _objectJs.addNonEnumerableProperty)(error, "framesToPop", 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = (0, _currentScopesJs.getClient)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === "always") // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    (0, _objectJs.addNonEnumerableProperty)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    resolveResponse(clonedResponseForResolving, ()=>{
        (0, _handlersJs.triggerHandlers)("fetch-body-resolved", {
            endTimestamp: (0, _timeJs.timestampInSeconds)() * 1000,
            response
        });
    });
}
function hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if (hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: getUrlFromResource(resource),
            method: hasProp(options, "method") ? String(options.method).toUpperCase() : (0, _isJs.isRequest)(resource) && hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, _isJs.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

},{"../currentScopes.js":"5f8H7","../utils/is.js":"jiTW9","../utils/object.js":"9SPt0","../utils/supports.js":"9hk0S","../utils/time.js":"lCk2j","../utils/worldwide.js":"2qGVN","./handlers.js":"laAoO","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"9hk0S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNativeFunction", ()=>isNativeFunction);
parcelHelpers.export(exports, "supportsDOMError", ()=>supportsDOMError);
parcelHelpers.export(exports, "supportsDOMException", ()=>supportsDOMException);
parcelHelpers.export(exports, "supportsErrorEvent", ()=>supportsErrorEvent);
parcelHelpers.export(exports, "supportsFetch", ()=>supportsFetch);
parcelHelpers.export(exports, "supportsHistory", ()=>supportsHistory);
parcelHelpers.export(exports, "supportsNativeFetch", ()=>supportsNativeFetch);
parcelHelpers.export(exports, "supportsReferrerPolicy", ()=>supportsReferrerPolicy);
parcelHelpers.export(exports, "supportsReportingObserver", ()=>supportsReportingObserver);
var _debugBuildJs = require("../debug-build.js");
var _debugLoggerJs = require("./debug-logger.js");
var _worldwideJs = require("./worldwide.js");
const WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    return "history" in WINDOW && !!WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const supportsFetch = _isFetchSupported;
function _isFetchSupported() {
    if (!("fetch" in WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFunction(WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _debugLoggerJs.debug).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return "ReportingObserver" in WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}

},{"../debug-build.js":"a2zY5","./debug-logger.js":"6Sybg","./worldwide.js":"2qGVN","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bHgOY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_enhanceErrorWithSentryInfo", ()=>_enhanceErrorWithSentryInfo);
parcelHelpers.export(exports, "eventFromMessage", ()=>eventFromMessage);
parcelHelpers.export(exports, "eventFromUnknownInput", ()=>eventFromUnknownInput);
parcelHelpers.export(exports, "exceptionFromError", ()=>exceptionFromError);
parcelHelpers.export(exports, "parseStackFrames", ()=>parseStackFrames);
var _isJs = require("./is.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
/**
 * Extracts stack frames from the error.stack string
 */ function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function hasSentryFetchUrlHost(error) {
    return (0, _isJs.isError)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function _enhanceErrorWithSentryInfo(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if (hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: _enhanceErrorWithSentryInfo(error)
    };
    const frames = parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = (0, _objectJs.extractExceptionKeysForMessage)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, _isJs.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function getException(client, mechanism, exception, hint) {
    if ((0, _isJs.isError)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, _isJs.isPlainObject)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: (0, _normalizeJs.normalizeToSize)(exception, normalizeDepth)
        };
        const errorFromProp = getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, _miscJs.addExceptionTypeValue)(event, undefined, undefined);
    (0, _miscJs.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames
                        }
                    }
                ]
            };
            (0, _miscJs.addExceptionMechanism)(event, {
                synthetic: true
            });
        }
    }
    if ((0, _isJs.isParameterizedString)(message)) {
        const { __sentry_template_string__, __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

},{"./is.js":"jiTW9","./misc.js":"21lxb","./normalize.js":"bplSM","./object.js":"9SPt0","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"gDYV0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentEmbeddingMethod", ()=>instrumentEmbeddingMethod);
parcelHelpers.export(exports, "instrumentLangChainEmbeddings", ()=>instrumentLangChainEmbeddings);
var _exportsJs = require("../../exports.js");
var _semanticAttributesJs = require("../../semanticAttributes.js");
var _traceJs = require("../trace.js");
var _genAiAttributesJs = require("../ai/gen-ai-attributes.js");
var _utilsJs = require("../ai/utils.js");
var _constantsJs = require("./constants.js");
/**
 * Infers the AI provider system name from the embedding class instance.
 */ function inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
/**
 * Extracts span attributes from a LangChain embedding class instance.
 */ function extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: (0, _constantsJs.LANGCHAIN_ORIGIN),
        [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: (0, _genAiAttributesJs.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE),
        [(0, _genAiAttributesJs.GEN_AI_OPERATION_NAME_ATTRIBUTE)]: "embeddings",
        [(0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE)]: embeddingsInstance.model ?? "unknown"
    };
    attributes[0, _genAiAttributesJs.GEN_AI_SYSTEM_ATTRIBUTE] = inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
/**
 * Wraps a LangChain embedding method (embedQuery or embedDocuments) to create Sentry spans.
 *
 * Used internally by the Node.js auto-instrumentation to patch embedding class prototypes.
 */ function instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs } = (0, _utilsJs.resolveAIRecordingOptions)(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = extractEmbeddingAttributes(thisArg);
            const modelName = attributes[0, _genAiAttributesJs.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[0, _genAiAttributesJs.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
            }
            return (0, _traceJs.startSpan)({
                name: `embeddings ${modelName}`,
                op: (0, _genAiAttributesJs.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE),
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(undefined, (error)=>{
                    (0, _exportsJs.captureException)(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
/**
 * Wraps a LangChain embeddings instance to create Sentry spans for `embedQuery` and `embedDocuments` calls.
 *
 * Use this in non-Node runtimes (Cloudflare, browser, etc.) where auto-instrumentation is not available.
 *
 * @example
 * ```javascript
 * import * as Sentry from '@sentry/cloudflare';
 * import { OpenAIEmbeddings } from '@langchain/openai';
 *
 * const embeddings = Sentry.instrumentLangChainEmbeddings(
 *   new OpenAIEmbeddings({ model: 'text-embedding-3-small' })
 * );
 *
 * await embeddings.embedQuery('Hello world');
 * await embeddings.embedDocuments(['doc1', 'doc2']);
 * ```
 */ function instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}

},{"../../exports.js":"9zd3A","../../semanticAttributes.js":"CCqFC","../trace.js":"jFgPq","../ai/gen-ai-attributes.js":"6VSO0","../ai/utils.js":"19wr8","./constants.js":"b2hG3","@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"esvIw":[function(require,module,exports) {
// Vendored from https://github.com/vuejs/vue/blob/612fb89547711cacb030a3893a0065b785802860/src/core/util/debug.js
// with types only changes.
// The MIT License (MIT)
// Copyright (c) 2013-present, Yuxi (Evan) You
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatComponentName", ()=>formatComponentName);
parcelHelpers.export(exports, "generateComponentTrace", ()=>generateComponentTrace);
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
const ROOT_COMPONENT_NAME = "<Root>";
const ANONYMOUS_COMPONENT_NAME = "<Anonymous>";
const repeat = (str, n)=>{
    return str.repeat(n);
};
const formatComponentName = (vm, includeFile)=>{
    if (!vm) return ANONYMOUS_COMPONENT_NAME;
    if (vm.$root === vm) return ROOT_COMPONENT_NAME;
    // https://github.com/getsentry/sentry-javascript/issues/5204 $options can be undefined
    if (!vm.$options) return ANONYMOUS_COMPONENT_NAME;
    const options = vm.$options;
    let name = options.name || options._componentTag || options.__name;
    const file = options.__file;
    if (!name && file) {
        const match = file.match(/([^/\\]+)\.vue$/);
        if (match) name = match[1];
    }
    return (name ? `<${classify(name)}>` : ANONYMOUS_COMPONENT_NAME) + (file && includeFile !== false ? ` at ${file}` : "");
};
const generateComponentTrace = (vm)=>{
    if (vm && (vm._isVue || vm.__isVue) && vm.$parent) {
        const tree = [];
        let currentRecursiveSequence = 0;
        while(vm){
            if (tree.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const last = tree[tree.length - 1];
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (last.constructor === vm.constructor) {
                    currentRecursiveSequence++;
                    vm = vm.$parent; // eslint-disable-line no-param-reassign
                    continue;
                } else if (currentRecursiveSequence > 0) {
                    tree[tree.length - 1] = [
                        last,
                        currentRecursiveSequence
                    ];
                    currentRecursiveSequence = 0;
                }
            }
            tree.push(vm);
            vm = vm.$parent; // eslint-disable-line no-param-reassign
        }
        const formattedTree = tree.map((vm, i)=>`${(i === 0 ? "---> " : repeat(" ", 5 + i * 2)) + (Array.isArray(vm) ? `${formatComponentName(vm[0])}... (${vm[1]} recursive calls)` : formatComponentName(vm))}`).join("\n");
        return `\n\nfound in\n\n${formattedTree}`;
    }
    return `\n\n(found in ${formatComponentName(vm)})`;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"b6aao"}],"bbXYh":[function(require,module,exports) {
module.exports = require("6d26fc464444eec0")(require("c91105201032448b").resolve("b5bbt")).then(()=>module.bundle.root("f1ceP"));

},{"6d26fc464444eec0":"4fR2o","c91105201032448b":"fr4hE"}],"4fR2o":[function(require,module,exports) {
"use strict";
var cacheLoader = require("783f416dfef27699");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"783f416dfef27699":"dPiie"}],"dPiie":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"jYDaW":[function(require,module,exports) {
module.exports = require("7f596de6bad5ab82")(require("d55ec4efa048cd6e").resolve("eVZew")).then(()=>module.bundle.root("kLC3P"));

},{"7f596de6bad5ab82":"4fR2o","d55ec4efa048cd6e":"fr4hE"}],"atGDB":[function(require,module,exports) {
module.exports = require("75741dcdef71ffcd")(require("9af644c88fadbcc4").resolve("cXwOr")).then(()=>module.bundle.root("a7KkB"));

},{"75741dcdef71ffcd":"4fR2o","9af644c88fadbcc4":"fr4hE"}],"cuo2U":[function(require,module,exports) {
module.exports = Promise.all([
    require("4f46c053a8fa21e5")(require("9e927cb71d53337f").resolve("j5lEo")),
    require("4f46c053a8fa21e5")(require("9e927cb71d53337f").resolve("1RNcA")),
    require("4f46c053a8fa21e5")(require("9e927cb71d53337f").resolve("l7T2x"))
]).then(()=>module.bundle.root("3JqsN"));

},{"4f46c053a8fa21e5":"4fR2o","9e927cb71d53337f":"fr4hE"}],"7lE8D":[function(require,module,exports) {
module.exports = Promise.all([
    require("eac7b4275fced269")(require("8a731df51509bb1f").resolve("j5lEo")),
    require("eac7b4275fced269")(require("8a731df51509bb1f").resolve("eIzfm"))
]).then(()=>module.bundle.root("um1AB"));

},{"eac7b4275fced269":"4fR2o","8a731df51509bb1f":"fr4hE"}],"bhStf":[function(require,module,exports) {
module.exports = Promise.all([
    require("6d113bebd9c76f73")(require("ed3e50ccbc846d4b").resolve("1RNcA")),
    require("6d113bebd9c76f73")(require("ed3e50ccbc846d4b").resolve("80HCa"))
]).then(()=>module.bundle.root("87KeD"));

},{"6d113bebd9c76f73":"4fR2o","ed3e50ccbc846d4b":"fr4hE"}]},["i4Eus","cXALw"], "cXALw", "parcelRequire9b8f")

//# sourceMappingURL=App.js.map
